import { useState, useMemo, useCallback, useRef, useEffect, Component } from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { getUserProfile } from "../api/graph";
import { getApiData, uploadPricingData, postZones } from "../api/mrcreporting";
import * as XLSX from "xlsx";
import '../index.css';

// getZone, getTiers, getTrucking,getDestScan,getFmc,

// //error boundary to catch and display rendering errors in the pricing jsx
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("App crash:", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div
          style={{
            padding: 20,
            background: "#1a0000",
            color: "#f85149",
            fontFamily: "monospace",
            fontSize: 12,
            minHeight: "100vh",
          }}
        >
          <div
            style={{
              fontSize: 16,
              fontWeight: 700,
              marginBottom: 12,
            }}
          >
            ⚠ Render Error — Pricing Agent v188
          </div>
          <div style={{ marginBottom: 8, color: "#ff9999" }}>
            {this.state.error.message}
          </div>
          <pre
            style={{
              fontSize: 10,
              color: "#ff6666",
              whiteSpace: "pre-wrap",
              wordBreak: "break-all",
            }}
          >
            {this.state.error.stack}
          </pre>
          <div
            style={{
              marginTop: 16,
              fontSize: 11,
              color: "#aaa",
            }}
          >
            Try: clear shared storage entries routing-pm-v1, routing-pr-v1,
            billing-pm-v1 and reload
          </div>
        </div>
      );
    }
    return this.props.children;
    console.log("Rendering children of ErrorBoundary");
  }
}
//Can be fetched from api for Parcel Right
var ZD_ZONES_M = {"800":"NT1","810":"NT1","812":"NT1","820":"NT3","822":"NT1","828":"NT1","829":"NT1","830":"NT1","832":"NT3","834":"NT3","835":"NT3","836":"NT3","837":"NT3","838":"NT3","839":"NT3","840":"NT3","841":"NT3","845":"NT2","846":"NT2","847":"NT2","850":"NT3","852":"NT3","853":"NT3","854":"NT3","860":"NT3","862":"NT3","870":"NT3","872":"NT3","873":"NT3","874":"NT3","875":"NT3","880":"NT1","885":"NT1","886":"NT1","2000":"NSW1","2007":"NSW1","2008":"NSW1","2009":"NSW1","2010":"NSW1","2011":"NSW1","2015":"NSW1","2016":"NSW1","2017":"NSW1","2018":"NSW1","2019":"NSW1","2020":"NSW1","2021":"NSW1","2022":"NSW1","2023":"NSW1","2024":"NSW1","2025":"NSW1","2026":"NSW1","2027":"NSW1","2028":"NSW1","2029":"NSW1","2030":"NSW1","2031":"NSW1","2032":"NSW1","2033":"NSW1","2034":"NSW1","2035":"NSW1","2036":"NSW1","2037":"NSW1","2038":"NSW1","2039":"NSW1","2040":"NSW1","2041":"NSW1","2042":"NSW1","2043":"NSW1","2044":"NSW1","2045":"NSW1","2046":"NSW1","2047":"NSW1","2048":"NSW1","2049":"NSW1","2050":"NSW1","2052":"NSW1","2060":"NSW1","2061":"NSW1","2062":"NSW1","2063":"NSW1","2064":"NSW1","2065":"NSW1","2066":"NSW1","2067":"NSW1","2068":"NSW1","2069":"NSW1","2070":"NSW1","2071":"NSW1","2072":"NSW1","2073":"NSW1","2074":"NSW1","2075":"NSW1","2076":"NSW1","2077":"NSW1","2079":"NSW1","2080":"NSW1","2081":"NSW1","2082":"NSW1","2084":"NSW1","2085":"NSW1","2086":"NSW1","2087":"NSW1","2088":"NSW1","2089":"NSW1","2090":"NSW1","2091":"NSW1","2092":"NSW1","2093":"NSW1","2094":"NSW1","2095":"NSW2","2096":"NSW1","2097":"NSW2","2099":"NSW1","2100":"NSW2","2101":"NSW2","2102":"NSW2","2103":"NSW2","2104":"NSW2","2105":"NSW2","2106":"NSW2","2107":"NSW1","2108":"NSW1","2109":"NSW1","2110":"NSW1","2111":"NSW1","2112":"NSW1","2113":"NSW1","2114":"NSW1","2115":"NSW1","2116":"NSW1","2117":"NSW1","2118":"NSW1","2119":"NSW1","2120":"NSW1","2121":"NSW1","2122":"NSW1","2123":"NSW1","2125":"NSW1","2126":"NSW1","2127":"NSW1","2128":"NSW1","2130":"NSW1","2131":"NSW1","2132":"NSW1","2133":"NSW1","2134":"NSW1","2135":"NSW1","2136":"NSW1","2137":"NSW1","2138":"NSW1","2139":"NSW1","2140":"NSW1","2141":"NSW1","2142":"NSW1","2143":"NSW1","2144":"NSW1","2145":"NSW1","2146":"NSW1","2147":"NSW1","2148":"NSW1","2150":"NSW1","2151":"NSW1","2152":"NSW1","2153":"NSW1","2154":"NSW1","2155":"NSW1","2156":"NSW1","2157":"NSW1","2158":"NSW1","2159":"NSW1","2160":"NSW1","2161":"NSW1","2162":"NSW1","2163":"NSW1","2164":"NSW1","2165":"NSW1","2166":"NSW1","2167":"NSW1","2168":"NSW1","2170":"NSW1","2171":"NSW1","2172":"NSW1","2173":"NSW1","2174":"NSW1","2175":"NSW1","2176":"NSW1","2177":"NSW1","2178":"NSW1","2179":"NSW1","2190":"NSW1","2191":"NSW1","2192":"NSW1","2193":"NSW1","2194":"NSW1","2195":"NSW1","2196":"NSW1","2197":"NSW1","2198":"NSW1","2199":"NSW1","2200":"NSW1","2203":"NSW1","2204":"NSW1","2205":"NSW1","2206":"NSW1","2207":"NSW1","2208":"NSW1","2209":"NSW1","2210":"NSW1","2211":"NSW1","2212":"NSW1","2213":"NSW1","2214":"NSW1","2216":"NSW1","2217":"NSW1","2218":"NSW1","2219":"NSW1","2220":"NSW1","2221":"NSW1","2222":"NSW1","2223":"NSW1","2224":"NSW1","2225":"NSW1","2226":"NSW1","2227":"NSW1","2228":"NSW1","2229":"NSW1","2230":"NSW1","2231":"NSW1","2232":"NSW1","2233":"NSW1","2234":"NSW1","2250":"NSW2","2251":"NSW2","2256":"NSW2","2257":"NSW2","2258":"NSW2","2259":"NSW3","2260":"NSW2","2261":"NSW2","2262":"NSW2","2263":"NSW2","2264":"NSW2","2265":"NSW3","2267":"NSW2","2278":"NSW2","2280":"NSW2","2281":"NSW2","2282":"NSW2","2283":"NSW2","2284":"NSW2","2285":"NSW2","2286":"NSW2","2287":"NSW2","2289":"NSW2","2290":"NSW2","2291":"NSW2","2292":"NSW2","2293":"NSW2","2294":"NSW2","2295":"NSW2","2296":"NSW2","2297":"NSW2","2298":"NSW2","2299":"NSW2","2300":"NSW2","2302":"NSW2","2303":"NSW2","2304":"NSW2","2305":"NSW2","2306":"NSW2","2307":"NSW2","2308":"NSW2","2311":"NSW3","2312":"NSW2","2314":"NSW2","2315":"NSW2","2316":"NSW2","2317":"NSW2","2318":"NSW2","2319":"NSW3","2320":"NSW2","2321":"NSW3","2322":"NSW2","2323":"NSW2","2324":"NSW3","2325":"NSW3","2326":"NSW2","2327":"NSW2","2328":"NSW3","2329":"NSW3","2330":"NSW3","2331":"NSW3","2333":"NSW3","2334":"NSW2","2335":"NSW3","2336":"NSW3","2337":"NSW3","2338":"NSW3","2339":"NSW3","2340":"NSW3","2341":"NSW3","2342":"NSW3","2343":"NSW3","2344":"NSW3","2345":"NSW3","2346":"NSW3","2347":"NSW3","2350":"NSW3","2351":"NSW3","2352":"NSW3","2353":"NSW3","2354":"NSW3","2355":"NSW3","2356":"NSW3","2357":"NSW3","2358":"NSW3","2359":"NSW3","2360":"NSW3","2361":"NSW3","2365":"NSW3","2369":"NSW3","2370":"NSW3","2371":"NSW3","2372":"NSW3","2379":"NSW3","2380":"NSW3","2381":"NSW3","2382":"NSW3","2386":"NSW3","2387":"NSW3","2388":"NSW3","2390":"NSW3","2395":"NSW3","2396":"NSW3","2397":"NSW3","2398":"NSW3","2399":"NSW3","2400":"NSW3","2401":"NSW3","2402":"NSW3","2403":"NSW3","2404":"NSW3","2405":"NSW3","2406":"NSW3","2408":"NSW3","2409":"NSW3","2410":"NSW3","2411":"NSW3","2415":"NSW3","2420":"NSW3","2421":"NSW3","2422":"NSW3","2423":"NSW3","2424":"NSW3","2425":"NSW3","2426":"NSW3","2427":"NSW2","2428":"NSW3","2429":"NSW3","2430":"NSW2","2431":"NSW3","2439":"NSW3","2440":"NSW3","2441":"NSW2","2443":"NSW2","2444":"NSW2","2445":"NSW2","2446":"NSW2","2447":"NSW3","2448":"NSW2","2449":"NSW3","2450":"NSW3","2452":"NSW2","2453":"NSW3","2454":"NSW3","2455":"NSW2","2456":"NSW2","2460":"NSW3","2462":"NSW3","2463":"NSW3","2464":"NSW3","2465":"NSW2","2466":"NSW3","2469":"NSW3","2470":"NSW3","2471":"NSW3","2472":"NSW3","2473":"NSW3","2474":"NSW3","2475":"NSW3","2476":"NSW3","2477":"NSW2","2478":"NSW2","2479":"NSW3","2480":"NSW3","2481":"NSW3","2482":"NSW3","2483":"NSW3","2484":"NSW3","2485":"QLD2","2486":"QLD3","2487":"NSW3","2488":"NSW3","2489":"QLD2","2490":"NSW2","2500":"NSW2","2502":"NSW2","2505":"NSW2","2506":"NSW2","2508":"NSW3","2515":"NSW2","2516":"NSW2","2517":"NSW2","2518":"NSW2","2519":"NSW2","2522":"NSW2","2525":"NSW2","2526":"NSW2","2527":"NSW2","2528":"NSW2","2529":"NSW2","2530":"NSW2","2533":"NSW2","2534":"NSW2","2535":"NSW3","2536":"NSW3","2537":"NSW3","2538":"NSW3","2539":"NSW3","2540":"NSW3","2541":"NSW2","2545":"NSW3","2546":"NSW3","2548":"NSW3","2549":"NSW3","2550":"NSW3","2551":"NSW3","2555":"NSW1","2556":"NSW1","2557":"NSW2","2558":"NSW1","2559":"NSW2","2560":"NSW2","2564":"NSW1","2565":"NSW1","2566":"NSW1","2567":"NSW2","2568":"NSW3","2569":"NSW3","2570":"NSW2","2571":"NSW2","2572":"NSW2","2573":"NSW2","2574":"NSW2","2575":"NSW2","2576":"NSW3","2577":"NSW3","2578":"NSW2","2579":"NSW3","2580":"NSW3","2581":"NSW3","2582":"NSW3","2583":"NSW3","2584":"NSW3","2585":"NSW3","2586":"NSW3","2587":"NSW3","2588":"NSW3","2590":"NSW3","2594":"NSW2","2600":"ACT1","2601":"ACT1","2602":"ACT1","2603":"ACT1","2604":"ACT1","2605":"ACT1","2606":"ACT1","2607":"ACT1","2609":"ACT1","2611":"ACT1","2612":"ACT1","2614":"ACT1","2615":"ACT1","2617":"ACT1","2618":"ACT1","2619":"ACT1","2620":"ACT2","2621":"NSW3","2622":"NSW3","2623":"NSW3","2624":"NSW3","2625":"NSW3","2626":"NSW3","2627":"NSW3","2628":"NSW3","2629":"NSW3","2630":"NSW3","2631":"NSW3","2632":"NSW3","2633":"NSW3","2640":"NSW3","2641":"NSW2","2642":"NSW3","2643":"NSW2","2644":"NSW3","2645":"NSW3","2646":"NSW3","2647":"NSW2","2648":"VIC3","2649":"NSW3","2650":"NSW3","2651":"NSW2","2652":"NSW3","2653":"NSW3","2655":"NSW3","2656":"NSW3","2658":"NSW3","2659":"NSW3","2660":"NSW3","2661":"NSW3","2663":"NSW3","2665":"NSW3","2666":"NSW3","2668":"NSW3","2669":"NSW3","2671":"NSW3","2672":"NSW3","2675":"NSW3","2678":"NSW3","2680":"NSW2","2681":"NSW2","2700":"NSW3","2701":"NSW3","2702":"NSW3","2703":"NSW3","2705":"NSW3","2706":"NSW3","2707":"NSW3","2710":"NSW3","2711":"NSW3","2712":"NSW3","2713":"NSW3","2714":"NSW3","2715":"VIC3","2716":"NSW3","2717":"VIC3","2720":"NSW3","2721":"NSW3","2722":"NSW3","2725":"NSW3","2726":"NSW3","2727":"NSW3","2729":"NSW3","2730":"NSW3","2731":"VIC3","2732":"VIC3","2733":"VIC3","2734":"VIC3","2735":"VIC3","2736":"VIC3","2737":"VIC3","2738":"VIC3","2739":"VIC3","2745":"NSW2","2747":"NSW2","2748":"NSW1","2749":"NSW2","2750":"NSW2","2752":"NSW1","2753":"NSW1","2754":"NSW1","2756":"NSW1","2759":"NSW1","2760":"NSW2","2761":"NSW1","2762":"NSW1","2763":"NSW1","2765":"NSW1","2766":"NSW1","2767":"NSW1","2768":"NSW1","2769":"NSW1","2770":"NSW1","2773":"NSW2","2774":"NSW2","2776":"NSW2","2777":"NSW1","2778":"NSW2","2779":"NSW2","2780":"NSW1","2782":"NSW3","2783":"NSW2","2784":"NSW2","2785":"NSW1","2786":"NSW3","2787":"NSW3","2790":"NSW3","2791":"NSW3","2792":"NSW3","2793":"NSW3","2794":"NSW3","2795":"NSW3","2797":"NSW3","2798":"NSW3","2799":"NSW3","2800":"NSW3","2803":"NSW3","2804":"NSW3","2805":"NSW3","2806":"NSW3","2807":"NSW3","2808":"NSW3","2809":"NSW3","2810":"NSW3","2817":"NSW3","2818":"NSW3","2820":"NSW3","2821":"NSW3","2822":"NSW3","2823":"NSW3","2824":"NSW3","2825":"NSW3","2826":"NSW3","2827":"NSW3","2828":"NSW3","2829":"NSW3","2830":"NSW3","2831":"NSW3","2832":"NSW3","2833":"NSW3","2834":"NSW3","2835":"NSW3","2836":"NSW3","2838":"NSW3","2839":"NSW3","2840":"NSW3","2842":"NSW3","2843":"NSW3","2844":"NSW3","2845":"NSW3","2846":"NSW3","2847":"NSW3","2848":"NSW3","2849":"NSW3","2850":"NSW3","2852":"NSW3","2864":"NSW3","2865":"NSW3","2866":"NSW3","2867":"NSW3","2868":"NSW3","2869":"NSW3","2870":"NSW3","2871":"NSW3","2873":"NSW3","2874":"NSW3","2875":"NSW3","2876":"NSW3","2877":"NSW3","2878":"NSW3","2879":"NSW3","2880":"NSW3","2900":"ACT1","2902":"ACT1","2903":"ACT1","2904":"ACT1","2905":"ACT1","2906":"ACT1","2911":"ACT1","2912":"ACT1","2913":"ACT1","2914":"ACT1","3000":"VIC1","3002":"VIC1","3003":"VIC1","3004":"VIC1","3006":"VIC1","3008":"VIC1","3010":"VIC2","3011":"VIC1","3012":"VIC1","3013":"VIC1","3015":"VIC1","3016":"VIC1","3018":"VIC1","3019":"VIC1","3020":"VIC1","3021":"VIC1","3022":"VIC1","3023":"VIC1","3024":"VIC1","3025":"VIC1","3026":"VIC1","3027":"VIC1","3028":"VIC1","3029":"VIC1","3030":"VIC1","3031":"VIC1","3032":"VIC1","3033":"VIC1","3034":"VIC1","3036":"VIC1","3037":"VIC1","3038":"VIC1","3039":"VIC1","3040":"VIC1","3041":"VIC1","3042":"VIC1","3043":"VIC1","3044":"VIC1","3045":"VIC1","3046":"VIC1","3047":"VIC1","3048":"VIC1","3049":"VIC1","3051":"VIC1","3052":"VIC1","3053":"VIC1","3054":"VIC1","3055":"VIC1","3056":"VIC1","3057":"VIC1","3058":"VIC1","3059":"VIC1","3060":"VIC1","3061":"VIC1","3062":"VIC1","3063":"VIC1","3064":"VIC1","3065":"VIC1","3066":"VIC1","3067":"VIC1","3068":"VIC1","3070":"VIC1","3071":"VIC1","3072":"VIC1","3073":"VIC1","3074":"VIC1","3075":"VIC1","3076":"VIC1","3078":"VIC1","3079":"VIC1","3081":"VIC1","3082":"VIC1","3083":"VIC2","3084":"VIC1","3085":"VIC1","3087":"VIC1","3088":"VIC1","3089":"VIC2","3090":"VIC2","3091":"VIC2","3093":"VIC1","3094":"VIC1","3095":"VIC2","3096":"VIC2","3097":"VIC2","3101":"VIC1","3102":"VIC1","3103":"VIC2","3104":"VIC2","3105":"VIC1","3106":"VIC1","3107":"VIC1","3108":"VIC1","3109":"VIC2","3111":"VIC1","3113":"VIC2","3114":"VIC1","3115":"VIC2","3116":"VIC2","3121":"VIC1","3122":"VIC1","3123":"VIC1","3124":"VIC2","3125":"VIC2","3126":"VIC1","3127":"VIC2","3128":"VIC2","3129":"VIC1","3130":"VIC2","3131":"VIC1","3132":"VIC2","3133":"VIC1","3134":"VIC1","3135":"VIC1","3136":"VIC1","3137":"VIC2","3138":"VIC1","3139":"VIC3","3140":"VIC2","3141":"VIC1","3142":"VIC1","3143":"VIC1","3144":"VIC1","3145":"VIC1","3146":"VIC2","3147":"VIC1","3148":"VIC2","3149":"VIC2","3150":"VIC1","3151":"VIC2","3152":"VIC2","3153":"VIC1","3154":"VIC2","3155":"VIC2","3156":"VIC2","3158":"VIC2","3159":"VIC2","3160":"VIC2","3161":"VIC1","3162":"VIC1","3163":"VIC1","3165":"VIC2","3166":"VIC1","3167":"VIC2","3168":"VIC1","3169":"VIC1","3170":"VIC2","3171":"VIC1","3172":"VIC2","3173":"VIC2","3174":"VIC2","3175":"VIC2","3177":"VIC2","3178":"VIC2","3179":"VIC2","3180":"VIC2","3181":"VIC1","3182":"VIC1","3183":"VIC1","3184":"VIC1","3185":"VIC1","3186":"VIC1","3187":"VIC2","3188":"VIC2","3189":"VIC2","3190":"VIC2","3191":"VIC2","3192":"VIC2","3193":"VIC2","3194":"VIC2","3195":"VIC2","3196":"VIC2","3197":"VIC2","3198":"VIC2","3199":"VIC2","3200":"VIC2","3201":"VIC2","3202":"VIC2","3204":"VIC2","3205":"VIC1","3206":"VIC1","3207":"VIC1","3211":"VIC3","3212":"VIC3","3213":"VIC3","3214":"VIC1","3215":"VIC1","3216":"VIC1","3217":"VIC2","3218":"VIC3","3219":"VIC1","3220":"VIC1","3221":"VIC3","3222":"VIC2","3223":"VIC2","3224":"VIC2","3225":"VIC3","3226":"VIC2","3227":"VIC2","3228":"VIC2","3230":"VIC3","3231":"VIC3","3232":"VIC3","3233":"VIC3","3234":"VIC3","3235":"VIC3","3236":"VIC3","3237":"VIC3","3238":"VIC3","3239":"VIC3","3240":"VIC3","3241":"VIC3","3242":"VIC3","3243":"VIC3","3249":"VIC3","3250":"VIC2","3251":"VIC3","3254":"VIC3","3260":"VIC3","3264":"VIC3","3265":"VIC3","3266":"VIC3","3267":"VIC3","3268":"VIC3","3269":"VIC3","3270":"VIC3","3271":"VIC3","3272":"VIC3","3273":"VIC3","3274":"VIC3","3275":"VIC3","3276":"VIC3","3277":"VIC3","3278":"VIC3","3279":"VIC3","3280":"VIC3","3281":"VIC3","3282":"VIC3","3283":"VIC3","3284":"VIC3","3285":"VIC3","3286":"VIC3","3287":"VIC3","3289":"VIC3","3292":"VIC3","3293":"VIC3","3294":"VIC3","3300":"VIC3","3301":"VIC3","3302":"VIC3","3303":"VIC3","3304":"VIC3","3305":"VIC3","3309":"VIC3","3310":"VIC3","3311":"VIC3","3312":"VIC3","3314":"VIC3","3315":"VIC3","3317":"VIC3","3318":"VIC3","3319":"VIC3","3321":"VIC3","3322":"VIC3","3323":"VIC3","3324":"VIC3","3325":"VIC3","3328":"VIC3","3329":"VIC3","3330":"VIC3","3331":"VIC3","3332":"VIC3","3333":"VIC3","3334":"VIC3","3335":"VIC1","3336":"VIC1","3337":"VIC2","3338":"VIC1","3340":"VIC3","3341":"VIC3","3342":"VIC3","3345":"VIC3","3350":"VIC2","3351":"VIC3","3352":"VIC3","3355":"VIC2","3356":"VIC2","3357":"VIC2","3358":"VIC2","3360":"VIC3","3361":"VIC3","3363":"VIC3","3364":"VIC3","3370":"VIC3","3371":"VIC3","3373":"VIC3","3374":"VIC3","3375":"VIC3","3377":"VIC3","3378":"VIC3","3379":"VIC3","3380":"VIC3","3381":"VIC3","3384":"VIC3","3385":"VIC3","3387":"VIC3","3388":"VIC3","3390":"VIC3","3391":"VIC3","3392":"VIC3","3393":"VIC3","3395":"VIC3","3396":"VIC3","3400":"VIC3","3401":"VIC3","3407":"VIC3","3409":"VIC3","3412":"VIC3","3413":"VIC3","3414":"VIC3","3415":"VIC3","3418":"VIC3","3419":"VIC3","3420":"VIC3","3423":"VIC3","3424":"VIC3","3427":"VIC1","3428":"VIC1","3429":"VIC2","3430":"VIC3","3431":"VIC3","3432":"VIC3","3433":"VIC3","3434":"VIC3","3435":"VIC3","3437":"VIC2","3438":"VIC2","3440":"VIC3","3441":"VIC3","3442":"VIC3","3444":"VIC3","3446":"VIC2","3447":"VIC2","3448":"VIC3","3450":"VIC3","3451":"VIC3","3453":"VIC3","3458":"VIC3","3460":"VIC3","3461":"VIC3","3462":"VIC3","3463":"VIC3","3464":"VIC3","3465":"VIC3","3467":"VIC3","3468":"VIC3","3469":"VIC3","3472":"VIC3","3475":"VIC3","3477":"VIC3","3478":"VIC3","3480":"VIC3","3482":"VIC3","3483":"VIC3","3485":"VIC3","3487":"VIC3","3488":"VIC3","3489":"VIC3","3490":"VIC3","3491":"VIC3","3494":"VIC3","3496":"VIC3","3498":"VIC3","3500":"VIC3","3501":"VIC3","3505":"VIC3","3506":"VIC3","3507":"VIC3","3509":"VIC3","3512":"VIC3","3515":"VIC3","3516":"VIC3","3517":"VIC3","3518":"VIC3","3520":"VIC3","3521":"VIC3","3522":"VIC3","3523":"VIC3","3525":"VIC3","3527":"VIC3","3529":"VIC3","3530":"VIC3","3531":"VIC3","3533":"VIC3","3537":"VIC3","3540":"VIC3","3542":"VIC3","3544":"VIC3","3546":"VIC3","3549":"VIC3","3550":"VIC2","3551":"VIC3","3555":"VIC2","3556":"VIC3","3557":"VIC3","3558":"VIC3","3559":"VIC3","3561":"VIC3","3562":"VIC3","3563":"VIC3","3564":"VIC3","3565":"VIC3","3566":"VIC3","3567":"VIC3","3568":"VIC3","3570":"VIC3","3571":"VIC3","3572":"VIC3","3573":"VIC3","3575":"VIC3","3576":"VIC3","3579":"VIC3","3580":"VIC3","3581":"VIC3","3583":"VIC3","3584":"VIC3","3585":"VIC3","3586":"VIC3","3588":"VIC3","3589":"VIC3","3590":"VIC3","3591":"VIC3","3594":"VIC3","3595":"VIC3","3596":"VIC3","3597":"VIC3","3599":"VIC3","3607":"VIC3","3608":"VIC3","3610":"VIC3","3612":"VIC3","3614":"VIC3","3616":"VIC3","3617":"VIC3","3618":"VIC3","3620":"VIC3","3621":"VIC3","3622":"VIC3","3623":"VIC3","3624":"VIC3","3629":"VIC3","3630":"VIC3","3631":"VIC3","3633":"VIC3","3634":"VIC3","3635":"VIC3","3636":"VIC3","3637":"VIC3","3638":"VIC3","3639":"VIC3","3640":"VIC3","3641":"VIC3","3644":"VIC3","3646":"VIC3","3647":"VIC3","3649":"VIC3","3658":"VIC3","3659":"VIC3","3660":"VIC3","3662":"VIC3","3663":"VIC3","3664":"VIC3","3665":"VIC3","3666":"VIC3","3669":"VIC3","3670":"VIC3","3672":"VIC3","3673":"VIC3","3675":"VIC3","3677":"VIC3","3678":"VIC3","3682":"VIC3","3683":"VIC3","3685":"VIC2","3687":"VIC2","3688":"VIC3","3690":"VIC2","3691":"VIC2","3695":"VIC3","3697":"VIC3","3698":"VIC3","3699":"VIC3","3700":"VIC3","3701":"VIC3","3704":"VIC3","3705":"VIC3","3707":"VIC3","3708":"VIC3","3709":"VIC3","3711":"VIC3","3712":"VIC3","3713":"VIC3","3714":"VIC3","3715":"VIC3","3717":"VIC3","3718":"VIC3","3719":"VIC3","3720":"VIC3","3722":"VIC3","3723":"VIC3","3725":"VIC3","3726":"VIC3","3727":"VIC3","3728":"VIC3","3730":"VIC3","3732":"VIC3","3733":"VIC3","3735":"VIC3","3737":"VIC3","3738":"VIC2","3739":"VIC2","3740":"VIC2","3741":"VIC3","3744":"VIC3","3746":"VIC3","3747":"VIC3","3749":"VIC2","3750":"VIC1","3751":"VIC2","3752":"VIC1","3753":"VIC2","3754":"VIC1","3755":"VIC3","3756":"VIC3","3757":"VIC3","3758":"VIC3","3759":"VIC2","3760":"VIC3","3761":"VIC3","3762":"VIC3","3763":"VIC3","3764":"VIC3","3765":"VIC2","3766":"VIC2","3767":"VIC2","3770":"VIC3","3775":"VIC3","3777":"VIC3","3778":"VIC3","3779":"VIC3","3781":"VIC3","3782":"VIC3","3783":"VIC3","3785":"VIC2","3786":"VIC2","3787":"VIC2","3788":"VIC2","3789":"VIC2","3791":"VIC2","3792":"VIC2","3793":"VIC2","3795":"VIC2","3796":"VIC2","3797":"VIC3","3799":"VIC3","3802":"VIC2","3803":"VIC2","3804":"VIC2","3805":"VIC1","3806":"VIC1","3807":"VIC3","3808":"VIC3","3809":"VIC3","3810":"VIC3","3812":"VIC3","3813":"VIC3","3814":"VIC3","3815":"VIC3","3816":"VIC3","3818":"VIC3","3820":"VIC3","3821":"VIC3","3822":"VIC3","3823":"VIC3","3824":"VIC3","3825":"VIC3","3831":"VIC3","3832":"VIC3","3833":"VIC3","3835":"VIC3","3840":"VIC3","3842":"VIC3","3844":"VIC3","3847":"VIC3","3850":"VIC3","3851":"VIC3","3852":"VIC3","3854":"VIC3","3856":"VIC3","3857":"VIC3","3858":"VIC3","3859":"VIC3","3860":"VIC3","3862":"VIC3","3864":"VIC3","3865":"VIC3","3869":"VIC3","3870":"VIC3","3871":"VIC3","3873":"VIC3","3874":"VIC3","3875":"VIC3","3878":"VIC3","3880":"VIC3","3882":"VIC3","3885":"VIC3","3886":"VIC3","3887":"VIC3","3888":"VIC3","3889":"VIC3","3890":"VIC3","3891":"VIC3","3892":"VIC3","3893":"VIC3","3895":"VIC3","3896":"VIC3","3898":"VIC3","3900":"VIC3","3902":"VIC3","3903":"VIC3","3904":"VIC3","3909":"VIC3","3910":"VIC2","3911":"VIC2","3912":"VIC2","3913":"VIC2","3915":"VIC2","3916":"VIC2","3918":"VIC2","3919":"VIC2","3920":"VIC3","3921":"VIC3","3922":"VIC3","3923":"VIC3","3925":"VIC3","3926":"VIC2","3927":"VIC2","3928":"VIC2","3929":"VIC2","3930":"VIC2","3931":"VIC2","3933":"VIC2","3934":"VIC2","3936":"VIC2","3937":"VIC2","3938":"VIC2","3939":"VIC2","3940":"VIC2","3941":"VIC2","3942":"VIC2","3943":"VIC2","3944":"VIC2","3945":"VIC3","3946":"VIC3","3950":"VIC3","3951":"VIC3","3953":"VIC3","3954":"VIC3","3956":"VIC3","3957":"VIC3","3958":"VIC3","3959":"VIC3","3960":"VIC3","3962":"VIC3","3964":"VIC3","3965":"VIC3","3966":"VIC3","3967":"VIC3","3971":"VIC3","3975":"VIC2","3976":"VIC1","3977":"VIC2","3978":"VIC2","3979":"VIC3","3980":"VIC3","3981":"VIC3","3984":"VIC3","3987":"VIC3","3988":"VIC3","3990":"VIC3","3991":"VIC3","3992":"VIC3","3995":"VIC3","3996":"VIC3","4000":"QLD1","4005":"QLD1","4006":"QLD1","4007":"QLD1","4008":"QLD1","4009":"QLD1","4010":"QLD1","4011":"QLD1","4012":"QLD1","4013":"QLD1","4014":"QLD1","4017":"QLD2","4018":"QLD1","4019":"QLD2","4020":"QLD2","4021":"QLD2","4022":"QLD2","4030":"QLD1","4031":"QLD1","4032":"QLD1","4034":"QLD1","4035":"QLD1","4036":"QLD2","4037":"QLD1","4051":"QLD1","4053":"QLD1","4054":"QLD1","4055":"QLD1","4059":"QLD1","4060":"QLD1","4061":"QLD1","4064":"QLD1","4065":"QLD1","4066":"QLD1","4067":"QLD1","4068":"QLD1","4069":"QLD1","4070":"QLD1","4073":"QLD1","4074":"QLD1","4075":"QLD1","4076":"QLD1","4077":"QLD1","4078":"QLD1","4101":"QLD1","4102":"QLD1","4103":"QLD1","4104":"QLD1","4105":"QLD1","4106":"QLD1","4107":"QLD1","4108":"QLD1","4109":"QLD1","4110":"QLD1","4111":"QLD1","4112":"QLD1","4113":"QLD1","4114":"QLD1","4115":"QLD1","4116":"QLD1","4117":"QLD1","4118":"QLD1","4119":"QLD1","4120":"QLD1","4121":"QLD1","4122":"QLD1","4123":"QLD1","4124":"QLD1","4125":"QLD1","4127":"QLD1","4128":"QLD1","4129":"QLD1","4130":"QLD1","4131":"QLD1","4132":"QLD1","4133":"QLD1","4151":"QLD1","4152":"QLD1","4153":"QLD1","4154":"QLD1","4155":"QLD1","4156":"QLD1","4157":"QLD1","4158":"QLD1","4159":"QLD1","4160":"QLD1","4161":"QLD1","4163":"QLD1","4164":"QLD1","4165":"QLD2","4169":"QLD1","4170":"QLD1","4171":"QLD1","4172":"QLD1","4173":"QLD1","4174":"QLD1","4178":"QLD1","4179":"QLD1","4183":"QLD3","4184":"QLD3","4205":"QLD1","4207":"QLD2","4208":"QLD1","4209":"QLD2","4210":"QLD2","4211":"QLD3","4212":"QLD2","4213":"QLD2","4214":"QLD2","4215":"QLD2","4216":"QLD3","4217":"QLD2","4218":"QLD2","4220":"QLD2","4221":"QLD2","4223":"QLD2","4224":"QLD2","4225":"QLD2","4226":"QLD2","4227":"QLD2","4228":"QLD3","4270":"QLD3","4272":"QLD2","4275":"QLD3","4280":"QLD2","4285":"QLD3","4287":"QLD3","4300":"QLD1","4301":"QLD1","4303":"QLD1","4304":"QLD1","4305":"QLD2","4306":"QLD3","4307":"QLD3","4309":"QLD3","4310":"QLD3","4311":"QLD3","4312":"QLD3","4313":"QLD3","4314":"QLD3","4340":"QLD3","4341":"QLD3","4342":"QLD3","4343":"QLD2","4344":"QLD3","4346":"QLD2","4347":"QLD3","4350":"QLD2","4352":"QLD3","4353":"QLD3","4354":"QLD3","4355":"QLD3","4356":"QLD3","4357":"QLD3","4358":"QLD3","4359":"QLD3","4360":"QLD2","4361":"QLD3","4362":"QLD3","4363":"QLD3","4364":"QLD3","4365":"QLD3","4370":"QLD2","4371":"QLD3","4372":"QLD3","4373":"QLD3","4374":"QLD2","4375":"QLD3","4376":"QLD2","4377":"QLD2","4378":"QLD2","4380":"QLD3","4381":"QLD2","4382":"QLD3","4383":"QLD3","4384":"QLD3","4385":"QLD3","4387":"QLD3","4388":"QLD3","4390":"QLD3","4400":"QLD2","4401":"QLD3","4402":"QLD3","4403":"QLD3","4404":"QLD3","4405":"QLD3","4406":"QLD3","4407":"QLD3","4408":"QLD3","4410":"QLD3","4411":"QLD3","4412":"QLD3","4413":"QLD3","4415":"QLD3","4416":"QLD3","4417":"QLD3","4418":"QLD3","4419":"QLD3","4420":"QLD3","4421":"QLD3","4422":"QLD3","4423":"QLD3","4424":"QLD3","4425":"QLD3","4426":"QLD3","4427":"QLD3","4428":"QLD3","4454":"QLD3","4455":"QLD3","4461":"QLD3","4462":"QLD3","4465":"QLD3","4467":"QLD3","4468":"QLD3","4470":"QLD3","4471":"QLD3","4472":"QLD3","4474":"QLD3","4475":"QLD3","4477":"QLD3","4478":"QLD3","4479":"QLD3","4480":"QLD3","4481":"QLD3","4482":"QLD3","4486":"QLD3","4487":"QLD3","4488":"QLD3","4489":"QLD3","4490":"QLD3","4491":"QLD3","4492":"QLD3","4493":"QLD3","4494":"QLD3","4496":"QLD3","4497":"QLD3","4498":"QLD3","4500":"QLD2","4501":"QLD2","4502":"QLD2","4503":"QLD1","4504":"QLD2","4505":"QLD2","4506":"QLD2","4507":"QLD1","4508":"QLD2","4509":"QLD2","4510":"QLD2","4511":"QLD2","4512":"QLD3","4513":"QLD3","4514":"QLD3","4515":"QLD3","4516":"QLD2","4517":"QLD3","4518":"QLD2","4519":"QLD3","4520":"QLD3","4521":"QLD3","4550":"QLD3","4551":"QLD2","4552":"QLD3","4553":"QLD2","4554":"QLD2","4555":"QLD2","4556":"QLD2","4557":"QLD2","4558":"QLD2","4559":"QLD2","4560":"QLD2","4561":"QLD2","4562":"QLD2","4563":"QLD2","4564":"QLD2","4565":"QLD2","4566":"QLD2","4567":"QLD2","4568":"QLD2","4569":"QLD3","4570":"QLD3","4571":"QLD3","4572":"QLD1","4573":"QLD2","4574":"QLD3","4575":"QLD2","4580":"QLD3","4581":"QLD3","4600":"QLD3","4601":"QLD3","4605":"QLD3","4606":"QLD3","4608":"QLD3","4610":"QLD3","4611":"QLD3","4612":"QLD3","4613":"QLD3","4614":"QLD3","4615":"QLD3","4620":"QLD3","4621":"QLD3","4625":"QLD3","4626":"QLD3","4627":"QLD3","4630":"QLD3","4650":"QLD3","4655":"QLD2","4659":"QLD3","4660":"QLD2","4662":"QLD2","4670":"QLD2","4671":"QLD3","4673":"QLD3","4674":"QLD3","4676":"QLD3","4677":"QLD3","4678":"QLD3","4680":"QLD3","4694":"QLD3","4695":"QLD3","4697":"QLD3","4699":"QLD2","4700":"QLD2","4701":"QLD2","4702":"QLD3","4703":"QLD2","4704":"QLD3","4705":"QLD3","4706":"QLD3","4707":"QLD3","4709":"QLD3","4710":"QLD2","4711":"QLD2","4712":"QLD3","4713":"QLD3","4714":"QLD3","4715":"QLD3","4716":"QLD3","4717":"QLD3","4718":"QLD3","4719":"QLD3","4720":"QLD3","4721":"QLD3","4722":"QLD3","4723":"QLD3","4724":"QLD3","4725":"QLD3","4726":"QLD3","4727":"QLD3","4728":"QLD3","4730":"QLD3","4731":"QLD3","4732":"QLD3","4733":"QLD3","4735":"QLD3","4736":"QLD3","4737":"QLD3","4738":"QLD3","4739":"QLD3","4740":"QLD2","4741":"QLD3","4742":"QLD3","4743":"QLD3","4744":"QLD3","4745":"QLD3","4746":"QLD3","4750":"QLD2","4751":"QLD2","4753":"QLD2","4754":"QLD3","4756":"QLD3","4757":"QLD3","4798":"QLD3","4799":"QLD3","4800":"QLD3","4802":"QLD3","4804":"QLD3","4805":"QLD2","4806":"QLD3","4807":"QLD3","4808":"QLD3","4809":"QLD3","4810":"QLD2","4811":"QLD2","4812":"QLD2","4814":"QLD2","4815":"QLD2","4816":"QLD2","4817":"QLD2","4818":"QLD2","4819":"QLD3","4820":"QLD2","4821":"QLD3","4822":"QLD3","4823":"QLD3","4824":"QLD3","4825":"QLD3","4828":"QLD3","4829":"QLD3","4830":"ROA3","4849":"QLD3","4850":"QLD3","4852":"QLD3","4854":"QLD3","4855":"QLD3","4856":"QLD3","4857":"QLD3","4858":"QLD3","4859":"QLD2","4860":"QLD3","4861":"QLD3","4865":"QLD3","4868":"QLD2","4869":"QLD3","4870":"QLD2","4871":"ROA3","4872":"QLD2","4873":"QLD3","4874":"ROA3","4875":"ROA3","4876":"ROA3","4877":"QLD2","4878":"QLD2","4879":"QLD2","4880":"QLD3","4881":"QLD3","4882":"QLD2","4883":"QLD3","4884":"QLD2","4885":"QLD3","4886":"QLD3","4887":"ROA3","4888":"QLD3","4890":"ROA3","4891":"ROA3","4892":"ROA3","4895":"ROA3","5000":"SA1","5005":"SA1","5006":"SA1","5007":"SA1","5008":"SA1","5009":"SA1","5010":"SA1","5011":"SA1","5012":"SA1","5013":"SA1","5014":"SA1","5015":"SA1","5016":"SA1","5017":"SA1","5018":"SA1","5019":"SA1","5020":"SA1","5021":"SA1","5022":"SA1","5023":"SA1","5024":"SA1","5025":"SA1","5031":"SA1","5032":"SA1","5033":"SA1","5034":"SA1","5035":"SA1","5037":"SA1","5038":"SA1","5039":"SA1","5040":"SA1","5041":"SA1","5042":"SA1","5043":"SA1","5044":"SA1","5045":"SA1","5046":"SA1","5047":"SA1","5048":"SA1","5049":"SA1","5050":"SA1","5051":"SA1","5052":"SA1","5061":"SA1","5062":"SA1","5063":"SA1","5064":"SA1","5065":"SA1","5066":"SA1","5067":"SA1","5068":"SA1","5069":"SA1","5070":"SA1","5072":"SA1","5073":"SA1","5074":"SA1","5075":"SA1","5076":"SA1","5081":"SA1","5082":"SA1","5083":"SA1","5084":"SA1","5085":"SA1","5086":"SA1","5087":"SA1","5088":"SA1","5089":"SA1","5090":"SA1","5091":"SA1","5092":"SA1","5093":"SA1","5094":"SA1","5095":"SA1","5096":"SA1","5097":"SA1","5098":"SA1","5106":"SA1","5107":"SA1","5108":"SA1","5109":"SA1","5110":"SA1","5111":"SA1","5112":"SA1","5113":"SA1","5114":"SA1","5115":"SA1","5116":"SA1","5117":"SA1","5118":"SA1","5120":"SA1","5121":"SA1","5125":"SA1","5126":"SA1","5127":"SA1","5131":"SA2","5132":"SA2","5133":"SA2","5134":"SA2","5136":"SA2","5137":"SA2","5138":"SA2","5139":"SA2","5140":"SA2","5141":"SA2","5142":"SA2","5144":"SA2","5150":"SA2","5151":"SA2","5152":"SA2","5153":"SA2","5154":"SA2","5155":"SA2","5156":"SA2","5157":"SA2","5158":"SA1","5159":"SA1","5160":"SA1","5161":"SA1","5162":"SA1","5163":"SA1","5164":"SA1","5165":"SA1","5166":"SA1","5167":"SA1","5168":"SA1","5169":"SA1","5170":"SA1","5171":"SA1","5172":"SA2","5173":"SA1","5174":"SA2","5201":"SA2","5202":"SA2","5203":"SA2","5204":"SA2","5210":"SA2","5211":"SA2","5212":"SA2","5213":"SA2","5214":"SA2","5220":"SA3","5221":"SA3","5222":"SA3","5223":"SA3","5231":"SA2","5232":"SA2","5233":"SA2","5234":"SA2","5235":"SA2","5236":"SA2","5237":"SA2","5238":"SA2","5240":"SA2","5241":"SA2","5242":"SA2","5243":"SA2","5244":"SA2","5245":"SA2","5250":"SA2","5251":"SA2","5252":"SA2","5253":"SA2","5254":"SA2","5255":"SA2","5256":"SA2","5259":"SA2","5260":"SA2","5261":"SA2","5262":"SA2","5263":"SA2","5264":"SA2","5265":"SA2","5266":"SA2","5267":"SA2","5268":"SA2","5269":"SA2","5270":"SA2","5271":"SA2","5272":"SA2","5273":"SA2","5275":"SA2","5276":"SA2","5277":"SA2","5278":"SA2","5279":"SA2","5280":"SA2","5290":"SA2","5291":"SA2","5301":"SA2","5302":"SA2","5303":"SA2","5304":"SA2","5306":"SA2","5307":"SA2","5308":"SA2","5309":"SA2","5310":"SA2","5311":"SA2","5320":"SA2","5321":"SA2","5322":"SA2","5330":"SA2","5331":"SA2","5332":"SA2","5333":"SA2","5340":"SA2","5341":"SA2","5342":"SA2","5343":"SA2","5344":"SA2","5345":"SA2","5346":"SA2","5350":"SA1","5351":"SA1","5352":"SA1","5353":"SA2","5354":"SA2","5355":"SA1","5356":"SA2","5357":"SA2","5360":"SA2","5371":"SA2","5372":"SA2","5373":"SA2","5374":"SA2","5381":"SA2","5400":"SA2","5401":"SA2","5410":"SA2","5411":"SA2","5412":"SA2","5413":"SA2","5414":"SA2","5415":"SA2","5416":"SA2","5417":"SA2","5418":"SA2","5419":"SA2","5420":"SA2","5421":"SA2","5422":"SA2","5431":"SA2","5432":"SA2","5433":"SA2","5434":"SA3","5440":"SA3","5451":"SA2","5452":"SA2","5453":"SA2","5454":"SA2","5455":"SA2","5460":"SA2","5461":"SA2","5462":"SA2","5464":"SA2","5470":"SA2","5471":"SA2","5472":"SA2","5473":"SA2","5480":"SA2","5481":"SA2","5482":"SA2","5483":"SA2","5485":"SA2","5490":"SA2","5491":"SA2","5493":"SA2","5495":"SA2","5501":"SA2","5502":"SA2","5510":"SA2","5520":"SA2","5521":"SA2","5522":"SA2","5523":"SA2","5540":"SA2","5550":"SA2","5552":"SA2","5554":"SA2","5555":"SA2","5556":"SA2","5558":"SA2","5560":"SA2","5570":"SA2","5571":"SA2","5572":"SA2","5573":"SA2","5575":"SA2","5576":"SA2","5577":"SA2","5580":"SA2","5581":"SA2","5582":"SA2","5583":"SA2","5600":"SA2","5601":"SA2","5602":"SA3","5603":"SA3","5604":"SA3","5605":"SA3","5606":"SA3","5607":"SA3","5608":"SA2","5609":"SA2","5630":"SA3","5631":"SA3","5632":"SA3","5633":"SA3","5640":"SA3","5641":"SA3","5642":"SA3","5650":"SA3","5651":"SA3","5652":"SA3","5653":"SA3","5654":"SA3","5655":"SA3","5660":"SA3","5661":"SA3","5670":"SA3","5671":"SA3","5680":"SA3","5690":"SA3","5700":"SA2","5701":"SA2","5710":"SA2","5717":"SA3","5719":"SA3","5720":"SA3","5722":"SA3","5723":"SA3","5724":"SA3","5725":"SA3","5730":"SA3","5731":"SA3","5732":"SA3","5733":"SA3","5734":"SA3","5800":"SA1","5810":"SA1","5839":"SA1","5950":"SA1","6000":"WA1","6003":"WA1","6004":"WA1","6005":"WA1","6006":"WA1","6007":"WA1","6008":"WA1","6009":"WA1","6010":"WA1","6011":"WA1","6012":"WA1","6014":"WA1","6015":"WA1","6016":"WA1","6017":"WA1","6018":"WA1","6019":"WA1","6020":"WA1","6021":"WA1","6022":"WA1","6023":"WA1","6024":"WA1","6025":"WA1","6026":"WA1","6027":"WA1","6028":"WA1","6029":"WA1","6030":"WA1","6031":"WA1","6033":"WA1","6034":"WA1","6035":"WA1","6036":"WA1","6037":"WA1","6038":"WA1","6050":"WA1","6051":"WA1","6052":"WA1","6053":"WA1","6054":"WA1","6055":"WA1","6056":"WA1","6057":"WA1","6058":"WA1","6059":"WA1","6060":"WA1","6061":"WA1","6062":"WA1","6063":"WA1","6064":"WA1","6065":"WA1","6066":"WA1","6068":"WA1","6069":"WA1","6070":"WA1","6071":"WA1","6072":"WA1","6073":"WA1","6076":"WA1","6077":"WA1","6081":"WA1","6090":"WA1","6100":"WA1","6101":"WA1","6102":"WA1","6103":"WA1","6104":"WA1","6105":"WA1","6106":"WA1","6107":"WA1","6108":"WA1","6109":"WA1","6110":"WA1","6111":"WA1","6112":"WA1","6122":"WA1","6147":"WA1","6148":"WA1","6149":"WA1","6150":"WA1","6151":"WA1","6152":"WA1","6153":"WA1","6154":"WA1","6155":"WA1","6156":"WA1","6157":"WA1","6158":"WA1","6159":"WA1","6160":"WA1","6162":"WA1","6163":"WA1","6164":"WA1","6165":"WA1","6166":"WA1","6167":"WA1","6168":"WA1","6169":"WA1","6170":"WA1","6171":"WA1","6172":"WA1","6173":"WA1","6174":"WA1","6175":"WA1","6176":"WA1","6180":"WA1","6181":"WA1","6182":"WA2","6207":"WA2","6208":"WA2","6209":"WA1","6210":"WA1","6211":"WA2","6213":"WA2","6214":"WA2","6215":"WA2","6218":"WA2","6219":"WA2","6220":"WA2","6221":"WA2","6223":"WA2","6224":"WA2","6225":"WA2","6226":"WA2","6227":"WA2","6228":"WA2","6229":"WA2","6230":"WA2","6232":"WA2","6233":"WA2","6236":"WA2","6237":"WA2","6239":"WA2","6240":"WA2","6243":"WA2","6244":"WA2","6251":"WA2","6252":"WA2","6253":"WA2","6254":"WA2","6255":"WA2","6256":"WA2","6258":"WA2","6260":"WA2","6262":"WA2","6271":"WA2","6275":"WA2","6280":"WA2","6281":"WA2","6282":"WA2","6284":"WA2","6285":"WA2","6286":"WA2","6288":"WA2","6290":"WA2","6302":"WA2","6304":"WA2","6306":"WA2","6308":"WA2","6309":"WA2","6311":"WA2","6312":"WA2","6313":"WA2","6315":"WA2","6316":"WA2","6317":"WA2","6318":"WA2","6320":"WA2","6321":"WA2","6322":"WA2","6323":"WA2","6324":"WA2","6326":"WA2","6327":"WA2","6328":"WA2","6330":"WA2","6333":"WA2","6335":"WA2","6336":"WA2","6337":"WA2","6338":"WA2","6341":"WA2","6343":"WA2","6346":"WA2","6348":"WA2","6350":"WA2","6351":"WA2","6352":"WA2","6353":"WA2","6355":"WA2","6356":"WA2","6357":"WA2","6358":"WA2","6359":"WA2","6361":"WA2","6363":"WA2","6365":"WA2","6367":"WA2","6368":"WA2","6369":"WA2","6370":"WA2","6372":"WA2","6373":"WA2","6375":"WA2","6383":"WA2","6384":"WA2","6385":"WA2","6386":"WA2","6390":"WA2","6391":"WA2","6392":"WA2","6393":"WA2","6394":"WA2","6395":"WA2","6396":"WA2","6397":"WA2","6398":"WA2","6401":"WA2","6403":"WA2","6405":"WA2","6407":"WA2","6409":"WA2","6410":"WA2","6411":"WA2","6412":"WA2","6413":"WA2","6414":"WA2","6415":"WA2","6418":"WA2","6419":"WA2","6420":"WA2","6421":"WA2","6422":"WA2","6423":"WA2","6424":"WA2","6425":"WA2","6426":"WA2","6427":"WA2","6428":"WA2","6429":"WA2","6430":"WA2","6431":"WA3","6432":"WA2","6434":"WA3","6436":"WA3","6437":"WA3","6438":"WA3","6440":"WA3","6442":"WA2","6443":"WA2","6445":"WA2","6446":"WA2","6447":"WA2","6448":"WA2","6450":"WA2","6452":"WA2","6460":"WA2","6461":"WA2","6462":"WA2","6463":"WA2","6465":"WA2","6466":"WA2","6467":"WA2","6468":"WA2","6470":"WA2","6472":"WA2","6473":"WA2","6475":"WA2","6476":"WA2","6477":"WA2","6479":"WA2","6480":"WA2","6484":"WA2","6485":"WA2","6487":"WA2","6488":"WA2","6489":"WA2","6490":"WA2","6501":"WA2","6502":"WA2","6503":"WA2","6504":"WA2","6505":"WA2","6506":"WA2","6507":"WA2","6509":"WA2","6510":"WA2","6511":"WA2","6512":"WA2","6513":"WA2","6514":"WA2","6515":"WA2","6516":"WA2","6517":"WA2","6518":"WA2","6519":"WA2","6521":"WA2","6522":"WA2","6525":"WA2","6528":"WA2","6530":"WA2","6532":"WA2","6535":"WA3","6536":"WA3","6537":"WA3","6556":"WA2","6558":"WA2","6560":"WA2","6562":"WA2","6564":"WA2","6566":"WA2","6567":"WA2","6568":"WA2","6569":"WA2","6571":"WA2","6572":"WA2","6574":"WA2","6575":"WA2","6603":"WA2","6605":"WA2","6606":"WA2","6608":"WA2","6609":"WA2","6612":"WA2","6613":"WA2","6614":"WA2","6616":"WA2","6620":"WA2","6623":"WA2","6625":"WA2","6627":"WA2","6628":"WA2","6630":"WA3","6631":"WA3","6632":"WA3","6635":"WA3","6638":"WA3","6639":"WA3","6640":"WA3","6642":"WA3","6646":"WA3","6701":"WA3","6705":"WA3","6707":"WA3","6710":"WA3","6711":"WA3","6712":"WA3","6713":"WA3","6714":"WA3","6716":"WA3","6718":"WA3","6720":"WA3","6721":"WA3","6722":"WA3","6725":"WA3","6726":"WA3","6728":"WA3","6733":"WA3","6740":"WA3","6743":"WA3","6751":"WA3","6753":"WA3","6754":"WA3","6758":"WA3","6760":"WA3","6762":"WA3","6765":"WA3","6770":"WA3","6809":"WA1","6827":"WA1","6830":"WA1","6900":"WA1","6907":"WA1","6945":"WA1","7000":"TAS1","7004":"TAS1","7005":"TAS1","7007":"TAS1","7008":"TAS1","7009":"TAS1","7010":"TAS1","7011":"TAS1","7012":"TAS3","7015":"TAS1","7016":"TAS1","7017":"TAS3","7018":"TAS1","7019":"TAS1","7020":"TAS3","7021":"TAS1","7022":"TAS3","7023":"TAS3","7024":"TAS3","7025":"TAS1","7026":"TAS3","7027":"TAS3","7030":"TAS3","7050":"TAS1","7052":"TAS1","7053":"TAS1","7054":"TAS3","7055":"TAS1","7109":"TAS3","7112":"TAS3","7113":"TAS3","7116":"TAS3","7117":"TAS3","7119":"TAS3","7120":"TAS3","7139":"TAS3","7140":"TAS3","7150":"TAS3","7151":"ROA3","7155":"TAS3","7162":"TAS3","7163":"TAS3","7170":"TAS1","7171":"TAS1","7172":"TAS3","7173":"TAS3","7174":"TAS3","7175":"TAS3","7176":"TAS3","7177":"TAS3","7178":"TAS3","7179":"TAS3","7180":"TAS3","7182":"TAS3","7183":"TAS3","7184":"TAS3","7185":"TAS3","7186":"TAS3","7187":"TAS3","7190":"TAS3","7209":"TAS3","7210":"TAS3","7211":"TAS3","7212":"TAS1","7213":"TAS3","7214":"TAS3","7215":"TAS3","7216":"TAS3","7248":"TAS1","7249":"TAS1","7250":"TAS1","7252":"TAS1","7253":"TAS1","7254":"TAS3","7255":"TAS2","7256":"TAS2","7257":"TAS2","7258":"TAS3","7259":"TAS3","7260":"TAS3","7261":"TAS3","7262":"TAS3","7263":"TAS3","7264":"TAS3","7265":"TAS3","7267":"TAS3","7268":"TAS3","7270":"TAS3","7275":"TAS3","7276":"TAS1","7277":"TAS1","7290":"TAS1","7291":"TAS1","7292":"TAS3","7300":"TAS3","7301":"TAS3","7302":"TAS3","7303":"TAS3","7304":"TAS3","7305":"TAS3","7306":"TAS3","7307":"TAS3","7310":"TAS2","7315":"TAS1","7316":"TAS3","7320":"TAS1","7321":"TAS3","7322":"TAS1","7325":"TAS3","7330":"TAS3","7331":"TAS3","7466":"TAS3","7467":"TAS3","7468":"TAS3","7469":"TAS3","7470":"TAS3","8511":"VIC2"};
var TIERS_M=[{id:"A",l:"Tier A",mn:250000,mx:999999999,pu:.1095,pr:.2,ins:.1,mg:.15,ot:.1},{id:"B",l:"Tier B",mn:150000,mx:250000,pu:.1095,pr:.2,ins:.1,mg:.19,ot:.1},{id:"C",l:"Tier C",mn:50000,mx:150000,pu:.1095,pr:.2,ins:.1,mg:.225,ot:.1},{id:"D",l:"Tier D",mn:20000,mx:50000,pu:.44,pr:.2,ins:.1,mg:.275,ot:.1},{id:"E",l:"Tier E",mn:0,mx:20000,pu:.46,pr:.2,ins:.1,mg:.325,ot:.1}];
//trucking
var TRK_M={"VIC":{MEL:0,SYD:.4,BNE:.7},"NSW":{MEL:.52,SYD:0,BNE:.3},"QLD":{MEL:1.14,SYD:.62,BNE:0},"SA":{MEL:.78,SYD:1.88,BNE:1.48},"WA":{MEL:2.76,SYD:4.23,BNE:4.9},"TAS":{MEL:0,SYD:.4,BNE:.7},"ACT":{MEL:.52,SYD:.11,BNE:.41},"NT":{MEL:1.14,SYD:.62,BNE:0}};
//FMC
var FMC_OLD={"VIC-Z1":[3.61,3.61,3.66,3.68,3.71,3.74,3.96,4.23,4.68,5.82],"VIC-Z2":[4.77,5.15,5.36,5.52,5.79,6.1,6.76,7.75,9.4,12.37],"VIC-Z3":[8.5,8.5,9.56,9.56,10.82,10.82,11.67,14.37,18.87,25.17],"NSW-Z1":[3.62,3.62,3.68,3.7,3.75,3.79,4.04,4.35,4.86,6.14],"NSW-Z2":[4.61,5.32,5.71,6.08,6.48,6.94,7.86,9.26,11.58,15.13],"NSW-Z3":[8.82,8.84,9.92,9.92,11.21,11.21,12.04,14.73,19.22,25.52],"QLD-Z1":[3.76,3.78,3.88,3.93,3.99,4.06,4.5,5.04,5.95,8.23],"QLD-Z2":[4.79,5.75,6.34,6.78,7.25,7.79,9.07,10.72,13.66,18.29],"QLD-Z3":[9.91,9.91,11.11,11.11,12.64,12.64,13.34,16.04,20.54,26.84],"SA-Z1":[3.67,3.67,3.73,3.79,3.86,3.92,4.04,4.22,4.53,4.96],"SA-Z2":[8.58,8.58,9.65,9.65,10.96,10.96,11.78,14.48,18.98,25.28],"SA-Z3":[9.83,9.83,11.41,11.41,13.08,13.08,13.72,16.42,20.92,27.22],"WA-Z1":[3.98,3.98,3.98,3.98,4.16,4.22,4.35,4.53,4.84,5.26],"WA-Z2":[10.35,10.35,11.58,11.58,13.33,13.33,13.95,16.65,21.15,27.45],"WA-Z3":[10.52,10.52,11.85,11.85,13.72,13.72,14.31,17.01,21.5,27.8],"TAS-Z1":[4.72,5.66,6.48,7.29,8.11,8.92,10.56,13.01,17.09,22.8],"TAS-Z2":[11.11,11.11,13.65,13.65,16.16,16.16,16.83,19.99,25.26,32.63],"TAS-Z3":[11.83,11.83,14.79,14.79,17.25,17.25,17.83,20.99,26.26,33.63],"ACT-Z1":[3.65,3.65,3.65,3.65,3.86,3.92,4.04,4.23,4.53,4.96],"ACT-Z2":[5.12,8.37,9.9,9.9,11.25,11.25,16.29,16.29,21.33,31.41],"NT-Z1":[13.78,13.78,14.8,14.8,18.43,18.43,19.91,24.56,32.29,43.13],"NT-Z2":[13.78,13.78,14.8,14.8,18.43,18.43,19.92,24.56,32.29,43.13],"NT-Z3":[13.78,13.78,14.8,14.8,18.43,18.43,19.91,24.56,32.29,43.13]};
var FMC_AX_M={"ACT-Z1":[3.264,3.264,3.264,3.264,3.264,3.264,3.9678,4.1514,4.4574,4.8858],"ACT-Z2":[5.12,8.37,9.9,9.9,11.25,11.25,16.29,16.29,21.33,31.41],"NSW-Z1":[3.264,3.264,3.264,3.264,3.264,3.264,3.9372,4.488,5.406,6.6912],"NSW-Z2":[3.79,4.47,4.71,5.16,5.09,5.54,5.54,6.37,7.61,9.67],"NSW-Z3":[8.82,8.84,9.92,9.92,11.21,11.21,12.04,14.73,19.22,25.52],"NT-Z1":[13.78,13.78,14.8,14.8,18.43,18.43,19.91,24.56,32.29,43.13],"NT-Z2":[13.78,13.78,14.8,14.8,18.43,18.43,19.92,24.56,32.29,43.13],"NT-Z3":[13.78,13.78,14.8,14.8,18.43,18.43,19.91,24.56,32.29,43.13],"QLD-Z1":[3.264,3.264,3.264,3.264,3.264,3.264,3.9372,4.1208,4.4268,4.8552],"QLD-Z2":[3.79,4.62,4.93,5.29,5.52,5.93,6.25,6.87,7.79,9.33],"QLD-Z3":[9.91,9.91,11.11,11.11,12.64,12.64,13.34,16.04,20.54,26.84],"SA-Z1":[3.264,3.264,3.264,3.264,3.264,3.264,4.0392,4.2228,4.5288,4.9572],"SA-Z2":[8.58,8.58,9.65,9.65,10.96,10.96,11.78,14.48,18.98,25.28],"SA-Z3":[9.83,9.83,11.41,11.41,13.08,13.08,13.72,16.42,20.92,27.22],"TAS-Z1":[5.253,5.457,6.3648,7.089,7.9356,8.7618,10.4958,12.9438,17.0238,22.7358],"TAS-Z2":[11.11,11.11,13.65,13.65,16.16,16.16,16.83,19.99,25.26,32.63],"TAS-Z3":[11.83,11.83,14.79,14.79,17.25,17.25,17.83,20.99,26.26,33.63],"VIC-Z1":[3.264,3.264,3.264,3.264,3.264,3.264,4.3758,4.4982,4.7022,4.9878],"VIC-Z2":[3.74,4.37,4.61,4.84,5.02,5.53,5.75,6.18,6.84,7.92],"VIC-Z3":[8.5,8.5,9.56,9.56,10.82,10.82,11.67,14.37,18.87,25.17],"WA-Z1":[3.264,3.264,3.264,3.264,3.264,3.264,3.9372,4.1208,4.4268,4.8552],"WA-Z2":[10.35,10.35,11.58,11.58,13.33,13.33,13.95,16.65,21.15,27.45],"WA-Z3":[10.52,10.52,11.85,11.85,13.72,13.72,14.31,17.01,21.5,27.8]};
//dest scan
var SSC_M={"VIC":{MEL:0,SYD:.2,BNE:.2,PER:.2},"NSW":{MEL:.2,SYD:0,BNE:.2,PER:.2},"QLD":{MEL:.2,SYD:.2,BNE:0,PER:.2},"SA":{MEL:0,SYD:0,BNE:0,PER:0},"WA":{MEL:.2,SYD:.2,BNE:.2,PER:0},"TAS":{MEL:0,SYD:0,BNE:0,PER:0},"ACT":{MEL:0,SYD:0,BNE:0,PER:0},"NT":{MEL:0,SYD:0,BNE:0,PER:0}};


// ─── DATA ───
//pr weights by zone and weight band (from spreadsheet, updated manually as needed)
var PRW=[0.5,1,2,3,4,5,7,10,15,22],PRWL=["0.5","1","2","3","4","5","7","10","15","22"];

//PM weights by zone and weight band (from spreadsheet, updated manually as needed)
var PMAW=[0.25,0.5,1,2,3,4,5,7,10,15,22],PMAWL=["0.25","0.5","1","2","3","4","5","7","10","15","22"];

//SF Evri
// SF (Evri) customer target rates per zone (fixed - from spreadsheet, never changes)
var SF_EVRI_TGT={"VIC-Z1":[2.45,2.75,2.86,3.01,3.30,4.59,4.70,0,0,0,0],"NSW-Z1":[2.41,2.78,2.87,3.00,3.26,4.20,4.16,0,0,0,0],"QLD-Z1":[3.14,3.13,3.38,3.70,3.79,4.67,4.67,0,0,0,0]};
var FXD={USD:.65,GBP:.5,HKD:5.1,EUR:.56};
var ORIS={LHR:"UK (LHR)",JFK:"US (JFK)",LAX:"US (LAX)",ORD:"US (ORD)",HKG:"Hong Kong",SZX:"Shenzhen",AMS:"Amsterdam"};
var AFC={LHR:{SYD:3.0,MEL:2.85,BNE:3.24,PER:3.07,c:"GBP"},JFK:{SYD:1.92,MEL:2.20,BNE:2.09,PER:2.35,c:"USD"},LAX:{SYD:1.76,MEL:2.30,BNE:2.23,PER:2.18,c:"USD"},ORD:{SYD:1.81,MEL:2.12,BNE:2.27,PER:1.88,c:"USD"},HKG:{SYD:34,MEL:34,BNE:34,PER:34,c:"HKD"},SZX:{SYD:34,MEL:34,BNE:34,PER:34,c:"HKD"},AMS:{SYD:3.13,MEL:8.44,BNE:3.38,PER:6.69,c:"EUR"}};
var AFC_NF={LHR:{SYD:2.79,MEL:2.65,BNE:2.91,PER:2.73,c:"GBP"},JFK:{SYD:1.87,MEL:2.03,BNE:1.87,PER:2.24,c:"USD"},LAX:{SYD:1.67,MEL:2.07,BNE:2.12,PER:2.06,c:"USD"},ORD:{SYD:1.71,MEL:1.97,BNE:2.27,PER:1.76,c:"USD"},HKG:{SYD:34,MEL:34,BNE:34,PER:34,c:"HKD"},SZX:{SYD:34,MEL:34,BNE:34,PER:34,c:"HKD"},AMS:{SYD:3.13,MEL:8.44,BNE:3.38,PER:6.69,c:"EUR"}};
var LDIM={LHR:{avg:1.38},JFK:{avg:1.69},LAX:{avg:1.37},ORD:{avg:1.65},HKG:{avg:1.08},SZX:{avg:1.08},AMS:{avg:2.28}};
var LKW={LHR:27700,JFK:10900,LAX:18000,ORD:36800,HKG:3400,SZX:200,AMS:1200};
var OP={LHR:{t:"b"},JFK:{t:"u",AKE:400,PMC:600,c:"USD",k:455},LAX:{t:"u",AKE:400,PMC:500,c:"USD",k:560},ORD:{t:"k",r:.37,c:"USD"},HKG:{t:"k",r:10.6,c:"HKD"},SZX:{t:"k",r:7.38,c:"HKD"},AMS:{t:"t",c:"EUR",ti:[[99,3.97],[149,2.11],[199,1.48],[249,1.17],[299,.99],[349,.86],[399,.77],[449,.71],[499,.65],[599,.61],[699,.57],[799,.54],[899,.51],[999,.49],[99999,.48]]}};
var L2F={JFK:1.13,LAX:1.13,ORD:1.13,LHR:1.13,AMS:1.13,HKG:1.13,SZX:1.13,OTH:1.13};
var DW={SYD:.41,MEL:.29,BNE:.2,PER:.1};
var STS=["NSW","VIC","QLD","WA","SA","TAS","ACT","NT"];
var DD={NSW:{pct:30.1,z1:60.3,z2:12.5,z3:27.2},VIC:{pct:24.6,z1:75.3,z2:5,z3:19.7},QLD:{pct:21.3,z1:39,z2:37.4,z3:23.7},WA:{pct:11.7,z1:80.6,z2:16.2,z3:3.2},SA:{pct:6.9,z1:74,z2:19,z3:7},TAS:{pct:2.5,z1:77,z2:0,z3:23},ACT:{pct:2.1,z1:100,z2:0,z3:0},NT:{pct:.8,z1:64,z2:0,z3:36}};
var PMW=[{l:"0-500g",mx:.5,p:67.7},{l:"501g-1kg",mx:1,p:16.2},{l:"1.01-2kg",mx:2,p:9.3},{l:"2.01-3kg",mx:3,p:3},{l:"3.01-4kg",mx:4,p:1.4},{l:"4.01-5kg",mx:5,p:.8},{l:"5.01-22kg",mx:22,p:1.6}];

var RETRIEVAL={AKE:{MEL:85,SYD:165,BNE:185,PER:92.8},PMC:{MEL:120,SYD:220,BNE:220,PER:185.6}};
var CTO_DOC=78,CTO_THK=0.29,DEPOT_PC=0.35,DAFF=0.37;
var UNIT_KG={AKE:750,PMC:1400};
var UNIT_VOL_KG={AKE:750,PMC:1860};
var CUST_FSC={JFK:0.27,LAX:0.27,ORD:0.27,LHR:0.19,AMS:0.23,HKG:5.50,SZX:5.50,OTH:0};
var DF_Z1=[2.65,2.83,2.92,3.15,3.31,3.84,3.94,4.57,5.36,6.7,10.04];
var DF_PORTS={MEL:true,SYD:false,BNE:false,ADL:false};
var DF_Z1_PCT={MEL:0.85,SYD:0.75,BNE:0.70,ADL:0.80};
var DF_FSC_BANDS=[[1.15,0],[1.20,.25],[1.25,.5],[1.30,.75],[1.35,1],[1.40,1.25],[1.45,1.5],[1.50,1.75],[1.55,3],[1.60,2.25],[1.65,2.5],[1.70,2.75],[1.75,3],[1.80,3.25],[1.85,3.5],[1.90,3.75],[1.95,4],[2.00,4.25],[2.05,4.5],[2.10,4.75],[2.15,5],[2.20,5.25],[2.25,5.5],[2.30,5.75],[2.35,6],[2.40,6.25],[2.45,6.5],[2.50,6.75],[2.55,7],[2.60,7.25],[2.65,7.5],[2.70,7.75],[2.75,8],[2.80,8.25],[2.85,8.5],[2.90,8.75],[2.95,9],[3.00,9.25],[3.05,9.5]];
function getDfFSC(price){for(var i=0;i<DF_FSC_BANDS.length;i++){if(price<=DF_FSC_BANDS[i][0])return DF_FSC_BANDS[i][1]/100}return 0.095}
var FSC_BANDS=[[1.85,5],[1.90,5.3],[1.95,5.5],[2.00,5.8],[2.05,6],[2.10,6.3],[2.15,6.5],[2.20,6.8],[2.25,7],[2.30,7.3],[2.35,7.5],[2.40,7.8],[2.45,8],[2.50,8.3],[2.55,8.5],[2.60,8.8],[2.65,9],[2.70,9.3],[2.75,9.5],[2.80,9.8],[2.85,10],[2.90,10.3],[2.95,10.5],[3.00,10.8],[3.05,11],[3.10,11.3],[3.15,11.5],[3.20,11.8],[3.25,12]];
function getFSC(price){for(var i=0;i<FSC_BANDS.length;i++){if(price<=FSC_BANDS[i][0])return FSC_BANDS[i][1]/100}return 0.12}

function toA(a,c,fx){return c==="AUD"?a:a/(fx[c]||1)}
function f(n,d){if(d===undefined)d=2;return(n==null||isNaN(n))?"--":n.toFixed(d)}
function fK(n){if(n==null||isNaN(n))return "--";if(Math.abs(n)>=1e6)return "$"+(n/1e6).toFixed(2)+"M";if(Math.abs(n)>=1e3)return "$"+(n/1e3).toFixed(1)+"K";return "$"+n.toFixed(0)}
function gOP(o,fx){var p=OP[o];if(!p||p.t==="b")return 0;if(p.t==="k")return toA(p.r,p.c,fx);if(p.t==="u")return toA(p.AKE/p.k,p.c,fx);if(p.t==="t"){for(var i=0;i<p.ti.length;i++){if(500<=p.ti[i][0])return toA(p.ti[i][1],p.c,fx)}}return 0}
function gFMC(d,wi,fmc){var t=0;STS.forEach(function(st){var v=d[st];if(!v)return;var sp=v.pct/100;[["z1",v.z1],["z2",v.z2],["z3",v.z3]].forEach(function(zd){var k=st+"-Z"+zd[0][1];var r=fmc[k];if(!r||!zd[1])return;t+=sp*(zd[1]/100)*(r[wi]||r[0])})});return t}
function pmI(mx){return{0.5:0,1:1,2:2,3:3,4:4,5:5,22:6}[mx]||0}

// DGF Flex Service rates (AUD, ex FSC) — Z2 merged into Z1 per DAI Post agreement Feb 2026
// Source: DAIPost_Updated_20022026-Proposed_FLEX.xlsx
// PMA weight breaks: 0.5,1,2,3,4,5,7,10,15,22,30 kg
var DGF_FLEX_RATES={
  Z1:[2.83,2.92,3.15,3.31,3.84,3.94,4.57,5.36,6.70,10.04,17.51],
  Z3:[4.81,4.88,5.03,5.10,5.47,6.18,7.57,9.73,13.43,18.97,28.69],
  Z4:[5.00,5.18,5.75,6.09,6.46,6.86,8.15,9.63,12.03,18.14,32.73]
};
// DGF Flex postcode→zone map (521 postcodes; ZONE1+ZONE2 both mapped to Z1)
// Coverage: NSW, VIC, QLD, SA — no WA or TAS
var DGF_FLEX_PC={"2000":"Z1","2007":"Z1","2008":"Z1","2009":"Z1","2010":"Z1","2011":"Z1","2015":"Z1","2016":"Z1","2017":"Z1","2018":"Z1","2019":"Z1","2020":"Z1","2021":"Z1","2022":"Z1","2023":"Z1","2024":"Z1","2025":"Z1","2026":"Z1","2027":"Z1","2028":"Z1","2029":"Z1","2030":"Z1","2031":"Z1","2032":"Z1","2033":"Z1","2034":"Z1","2035":"Z1","2036":"Z1","2037":"Z1","2038":"Z1","2039":"Z1","2040":"Z1","2041":"Z1","2042":"Z1","2043":"Z1","2044":"Z1","2045":"Z1","2046":"Z1","2047":"Z1","2048":"Z1","2049":"Z1","2050":"Z1","2060":"Z1","2061":"Z1","2062":"Z1","2063":"Z1","2064":"Z1","2065":"Z1","2066":"Z1","2067":"Z1","2068":"Z1","2069":"Z1","2070":"Z1","2071":"Z1","2072":"Z1","2073":"Z1","2074":"Z1","2075":"Z1","2076":"Z1","2077":"Z1","2085":"Z1","2086":"Z1","2087":"Z1","2088":"Z1","2089":"Z1","2090":"Z1","2092":"Z1","2093":"Z1","2094":"Z1","2095":"Z1","2096":"Z1","2097":"Z1","2099":"Z1","2100":"Z1","2101":"Z1","2102":"Z1","2103":"Z1","2104":"Z1","2105":"Z1","2106":"Z1","2110":"Z1","2111":"Z1","2112":"Z1","2113":"Z1","2114":"Z1","2115":"Z1","2116":"Z1","2117":"Z1","2118":"Z1","2119":"Z1","2120":"Z1","2121":"Z1","2122":"Z1","2125":"Z1","2126":"Z1","2127":"Z1","2128":"Z1","2130":"Z1","2131":"Z1","2132":"Z1","2133":"Z1","2134":"Z1","2135":"Z1","2136":"Z1","2137":"Z1","2138":"Z1","2140":"Z1","2141":"Z1","2142":"Z1","2143":"Z1","2144":"Z1","2145":"Z1","2146":"Z1","2147":"Z1","2148":"Z1","2150":"Z1","2151":"Z1","2152":"Z1","2153":"Z1","2154":"Z1","2155":"Z1","2156":"Z1","2158":"Z1","2160":"Z1","2161":"Z1","2162":"Z1","2163":"Z1","2164":"Z1","2165":"Z1","2166":"Z1","2168":"Z1","2170":"Z1","2172":"Z1","2173":"Z1","2176":"Z1","2177":"Z1","2190":"Z1","2191":"Z1","2192":"Z1","2193":"Z1","2194":"Z1","2195":"Z1","2196":"Z1","2197":"Z1","2198":"Z1","2199":"Z1","2200":"Z1","2203":"Z1","2204":"Z1","2205":"Z1","2206":"Z1","2207":"Z1","2208":"Z1","2209":"Z1","2210":"Z1","2211":"Z1","2212":"Z1","2213":"Z1","2214":"Z1","2216":"Z1","2217":"Z1","2218":"Z1","2219":"Z1","2220":"Z1","2221":"Z1","2222":"Z1","2223":"Z1","2224":"Z1","2225":"Z1","2226":"Z1","2227":"Z1","2228":"Z1","2229":"Z1","2230":"Z1","2231":"Z1","2232":"Z1","2526":"Z4","2557":"Z3","2560":"Z3","2566":"Z1","2567":"Z3","2570":"Z3","3000":"Z1","3002":"Z1","3004":"Z1","3006":"Z1","3011":"Z1","3012":"Z1","3016":"Z1","3018":"Z1","3020":"Z1","3021":"Z1","3022":"Z1","3023":"Z1","3024":"Z1","3031":"Z1","3033":"Z1","3036":"Z1","3037":"Z1","3040":"Z1","3043":"Z1","3044":"Z1","3046":"Z1","3047":"Z1","3048":"Z1","3051":"Z1","3052":"Z1","3055":"Z1","3063":"Z1","3066":"Z1","3068":"Z1","3075":"Z1","3076":"Z1","3081":"Z1","3082":"Z1","3084":"Z1","3088":"Z1","3089":"Z1","3090":"Z1","3093":"Z1","3094":"Z1","3095":"Z1","3103":"Z1","3104":"Z1","3108":"Z1","3113":"Z1","3114":"Z1","3124":"Z1","3125":"Z1","3126":"Z1","3128":"Z1","3129":"Z1","3133":"Z1","3134":"Z1","3137":"Z1","3138":"Z1","3140":"Z1","3141":"Z1","3142":"Z1","3144":"Z1","3148":"Z1","3150":"Z1","3152":"Z1","3153":"Z1","3154":"Z1","3155":"Z1","3156":"Z1","3161":"Z1","3162":"Z1","3163":"Z1","3168":"Z1","3171":"Z1","3172":"Z1","3174":"Z1","3175":"Z1","3178":"Z1","3179":"Z1","3181":"Z1","3182":"Z1","3183":"Z1","3185":"Z1","3186":"Z1","3190":"Z1","3191":"Z1","3192":"Z1","3194":"Z1","3196":"Z1","3198":"Z1","3200":"Z1","3204":"Z1","3205":"Z1","3206":"Z1","3207":"Z1","3211":"Z1","3212":"Z1","3335":"Z1","3337":"Z1","3338":"Z1","3341":"Z1","3427":"Z1","3430":"Z1","3431":"Z1","3432":"Z1","3434":"Z1","3437":"Z1","3440":"Z1","3441":"Z1","3751":"Z1","3752":"Z1","3755":"Z1","3756":"Z1","3757":"Z1","3759":"Z1","3761":"Z1","3763":"Z1","3765":"Z1","3766":"Z1","3767":"Z1","3770":"Z1","3775":"Z1","3785":"Z1","3787":"Z1","3788":"Z1","3789":"Z1","3791":"Z1","3792":"Z1","3795":"Z1","3802":"Z1","3803":"Z1","3805":"Z1","3808":"Z1","3809":"Z1","3810":"Z1","3812":"Z1","3813":"Z1","3910":"Z1","3911":"Z1","3913":"Z1","3915":"Z1","3930":"Z1","3975":"Z1","3977":"Z1","4000":"Z1","4005":"Z1","4006":"Z1","4007":"Z1","4008":"Z1","4009":"Z1","4010":"Z1","4011":"Z1","4012":"Z1","4013":"Z1","4014":"Z1","4017":"Z1","4018":"Z1","4019":"Z1","4020":"Z1","4021":"Z1","4022":"Z1","4025":"Z3","4029":"Z1","4030":"Z1","4031":"Z1","4032":"Z1","4034":"Z1","4035":"Z1","4036":"Z1","4037":"Z1","4051":"Z1","4053":"Z1","4054":"Z1","4055":"Z1","4059":"Z1","4060":"Z1","4061":"Z1","4064":"Z1","4065":"Z1","4066":"Z1","4067":"Z1","4068":"Z1","4069":"Z1","4070":"Z1","4072":"Z1","4073":"Z1","4074":"Z1","4075":"Z1","4076":"Z1","4077":"Z1","4078":"Z1","4101":"Z1","4102":"Z1","4103":"Z1","4104":"Z1","4105":"Z1","4106":"Z1","4107":"Z1","4108":"Z1","4109":"Z1","4110":"Z1","4111":"Z1","4112":"Z1","4113":"Z1","4114":"Z1","4115":"Z1","4116":"Z1","4117":"Z1","4118":"Z1","4119":"Z1","4120":"Z1","4121":"Z1","4122":"Z1","4123":"Z1","4124":"Z1","4125":"Z1","4127":"Z1","4128":"Z1","4129":"Z1","4130":"Z1","4131":"Z1","4132":"Z1","4133":"Z1","4151":"Z1","4152":"Z1","4153":"Z1","4154":"Z1","4155":"Z1","4156":"Z1","4157":"Z1","4158":"Z1","4159":"Z1","4160":"Z1","4161":"Z1","4163":"Z1","4164":"Z1","4165":"Z1","4169":"Z1","4170":"Z1","4171":"Z1","4172":"Z1","4173":"Z1","4174":"Z1","4178":"Z1","4179":"Z1","4183":"Z3","4184":"Z1","4205":"Z1","4207":"Z1","4208":"Z1","4209":"Z3","4210":"Z3","4270":"Z3","4280":"Z3","4300":"Z1","4301":"Z1","4303":"Z1","4304":"Z1","4305":"Z1","4306":"Z3","4307":"Z3","4346":"Z3","4500":"Z1","4501":"Z1","4502":"Z1","4503":"Z1","4504":"Z1","4505":"Z1","4506":"Z3","4508":"Z1","4509":"Z1","4510":"Z3","4511":"Z3","4512":"Z3","4516":"Z3","4517":"Z3","4520":"Z1","4521":"Z3","5007":"Z1","5008":"Z1","5009":"Z1","5010":"Z1","5011":"Z1","5012":"Z1","5013":"Z1","5014":"Z1","5016":"Z1","5017":"Z1","5018":"Z1","5019":"Z1","5023":"Z1","5024":"Z1","5025":"Z1","5032":"Z1","5033":"Z1","5037":"Z1","5038":"Z1","5040":"Z1","5041":"Z1","5044":"Z1","5047":"Z1","5048":"Z1","5049":"Z1","5050":"Z1","5051":"Z1","5061":"Z1","5062":"Z1","5063":"Z1","5064":"Z1","5065":"Z1","5066":"Z1","5067":"Z1","5068":"Z1","5069":"Z1","5070":"Z1","5072":"Z1","5074":"Z1","5076":"Z1","5081":"Z1","5082":"Z1","5083":"Z1","5084":"Z1","5085":"Z1","5086":"Z1","5087":"Z1","5088":"Z1","5090":"Z1","5091":"Z1","5092":"Z1","5093":"Z1","5094":"Z1","5095":"Z1","5096":"Z1","5097":"Z1","5098":"Z1","5106":"Z1","5108":"Z1","5109":"Z1","5112":"Z1","5113":"Z1","5114":"Z1","5115":"Z1","5116":"Z1"};

// FW_PC_INDUCTION: postcode → Aramex injection point (from old network routing file)
var FW_PC_INDUCTION={
  '1021':'BRI',
  '1022':'BRI',
  '1100':'BRI',
  '1215':'BRI',
  '1220':'BRI',
  '1225':'BRI',
  '1230':'BRI',
  '1231':'BRI',
  '1235':'BRI',
  '1239':'BRI',
  '1240':'BRI',
  '1291':'BRI',
  '1300':'BRI',
  '1335':'BRI',
  '1340':'BRI',
  '1350':'BRI',
  '1355':'BRI',
  '1360':'BRI',
  '1405':'BRI',
  '1435':'BRI',
  '1445':'BRI',
  '1450':'BRI',
  '1455':'BRI',
  '1460':'BRI',
  '1465':'BRI',
  '1466':'BRI',
  '1470':'BRI',
  '1475':'BRI',
  '1480':'BRI',
  '1481':'BRI',
  '1485':'BRI',
  '1490':'BRI',
  '1495':'BRI',
  '1499':'BRI',
  '1515':'BRI',
  '1560':'BRI',
  '1565':'BRI',
  '1570':'BRI',
  '1585':'BRI',
  '1590':'BRI',
  '1595':'BRI',
  '1602':'BRI',
  '1630':'BRI',
  '1635':'BRI',
  '1640':'BRI',
  '1655':'BRI',
  '1660':'BRI',
  '1670':'BRI',
  '1675':'BRI',
  '1680':'BRI',
  '1685':'BRI',
  '1700':'BRI',
  '1710':'BRI',
  '1715':'BRI',
  '1730':'BRI',
  '1750':'BRI',
  '1755':'BRI',
  '1765':'BRI',
  '1781':'BRI',
  '1790':'BRI',
  '1800':'BRI',
  '1805':'BRI',
  '1811':'BRI',
  '1825':'BRI',
  '1835':'BRI',
  '1851':'BRI',
  '1860':'BRI',
  '1871':'BRI',
  '1874':'BRI',
  '1875':'BRI',
  '1885':'BRI',
  '1890':'BRI',
  '1891':'BRI',
  '200':'CBR',
  '2000':'SYD',
  '2001':'SYD',
  '2002':'SYD',
  '2004':'SYD',
  '2006':'SYD',
  '2007':'SYD',
  '2008':'SYD',
  '2009':'SYD',
  '2010':'SYD',
  '2011':'SYD',
  '2012':'SYD',
  '2015':'SYD',
  '2016':'SYD',
  '2017':'SYD',
  '2018':'SYD',
  '2019':'SYD',
  '2020':'SYD',
  '2021':'SYD',
  '2022':'SYD',
  '2023':'SYD',
  '2024':'SYD',
  '2025':'SYD',
  '2026':'SYD',
  '2027':'SYD',
  '2028':'SYD',
  '2029':'SYD',
  '2030':'SYD',
  '2031':'SYD',
  '2032':'SYD',
  '2033':'SYD',
  '2034':'SYD',
  '2035':'SYD',
  '2036':'SYD',
  '2037':'SYD',
  '2038':'SYD',
  '2039':'SYD',
  '2040':'SYD',
  '2041':'SYD',
  '2042':'SYD',
  '2043':'SYD',
  '2044':'SYD',
  '2045':'SYD',
  '2046':'SYD',
  '2047':'SYD',
  '2048':'SYD',
  '2049':'SYD',
  '2050':'SYD',
  '2052':'SYD',
  '2055':'SYD',
  '2057':'SYD',
  '2059':'SYD',
  '2060':'SYD',
  '2061':'SYD',
  '2062':'SYD',
  '2063':'SYD',
  '2064':'SYD',
  '2065':'SYD',
  '2066':'SYD',
  '2067':'SYD',
  '2068':'SYD',
  '2069':'SYD',
  '2070':'SYD',
  '2071':'SYD',
  '2072':'SYD',
  '2073':'SYD',
  '2074':'SYD',
  '2075':'SYD',
  '2076':'SYD',
  '2077':'SYD',
  '2079':'SYD',
  '2080':'SYD',
  '2081':'MEL',
  '2082':'SYD',
  '2083':'MEL',
  '2084':'SYD',
  '2085':'SYD',
  '2086':'SYD',
  '2087':'SYD',
  '2088':'SYD',
  '2089':'SYD',
  '2090':'SYD',
  '2091':'SYD',
  '2092':'SYD',
  '2093':'SYD',
  '2094':'SYD',
  '2095':'SYD',
  '2096':'SYD',
  '2097':'SYD',
  '2099':'SYD',
  '2100':'SYD',
  '2101':'SYD',
  '2102':'SYD',
  '2103':'SYD',
  '2104':'SYD',
  '2105':'BRI',
  '2106':'SYD',
  '2107':'SYD',
  '2108':'SYD',
  '2109':'SYD',
  '2110':'SYD',
  '2111':'SYD',
  '2112':'SYD',
  '2113':'SYD',
  '2114':'SYD',
  '2115':'SYD',
  '2116':'SYD',
  '2117':'SYD',
  '2118':'SYD',
  '2119':'SYD',
  '2120':'SYD',
  '2121':'SYD',
  '2122':'SYD',
  '2123':'SYD',
  '2124':'SYD',
  '2125':'SYD',
  '2126':'SYD',
  '2127':'SYD',
  '2128':'SYD',
  '2129':'SYD',
  '2130':'SYD',
  '2131':'SYD',
  '2132':'SYD',
  '2133':'SYD',
  '2134':'SYD',
  '2135':'SYD',
  '2136':'SYD',
  '2137':'SYD',
  '2138':'SYD',
  '2139':'SYD',
  '2140':'SYD',
  '2141':'SYD',
  '2142':'SYD',
  '2143':'SYD',
  '2144':'SYD',
  '2145':'SYD',
  '2146':'SYD',
  '2147':'SYD',
  '2148':'SYD',
  '2150':'SYD',
  '2151':'SYD',
  '2152':'SYD',
  '2153':'SYD',
  '2154':'SYD',
  '2155':'SYD',
  '2156':'SYD',
  '2157':'SYD',
  '2158':'SYD',
  '2159':'SYD',
  '2160':'SYD',
  '2161':'SYD',
  '2162':'SYD',
  '2163':'SYD',
  '2164':'SYD',
  '2165':'SYD',
  '2166':'SYD',
  '2167':'SYD',
  '2168':'SYD',
  '2170':'SYD',
  '2171':'SYD',
  '2172':'SYD',
  '2173':'SYD',
  '2174':'SYD',
  '2175':'SYD',
  '2176':'SYD',
  '2177':'SYD',
  '2178':'SYD',
  '2179':'SYD',
  '2190':'SYD',
  '2191':'SYD',
  '2192':'SYD',
  '2193':'SYD',
  '2194':'SYD',
  '2195':'SYD',
  '2196':'SYD',
  '2197':'SYD',
  '2198':'SYD',
  '2199':'SYD',
  '2200':'SYD',
  '2203':'SYD',
  '2204':'SYD',
  '2205':'SYD',
  '2206':'SYD',
  '2207':'SYD',
  '2208':'SYD',
  '2209':'SYD',
  '2210':'SYD',
  '2211':'SYD',
  '2212':'SYD',
  '2213':'SYD',
  '2214':'SYD',
  '2216':'BRI',
  '2217':'SYD',
  '2218':'SYD',
  '2219':'SYD',
  '2220':'SYD',
  '2221':'SYD',
  '2222':'SYD',
  '2223':'SYD',
  '2224':'SYD',
  '2225':'SYD',
  '2226':'SYD',
  '2227':'SYD',
  '2228':'SYD',
  '2229':'SYD',
  '2230':'SYD',
  '2231':'SYD',
  '2232':'SYD',
  '2233':'SYD',
  '2234':'SYD',
  '2250':'SYD',
  '2251':'SYD',
  '2252':'SYD',
  '2256':'SYD',
  '2257':'SYD',
  '2258':'SYD',
  '2259':'SYD',
  '2260':'SYD',
  '2261':'SYD',
  '2262':'SYD',
  '2263':'SYD',
  '2264':'SYD',
  '2265':'CBR',
  '2267':'SYD',
  '2278':'SYD',
  '2280':'SYD',
  '2281':'SYD',
  '2282':'SYD',
  '2283':'SYD',
  '2284':'SYD',
  '2285':'SYD',
  '2286':'SYD',
  '2287':'SYD',
  '2289':'SYD',
  '2290':'SYD',
  '2291':'SYD',
  '2292':'SYD',
  '2293':'SYD',
  '2294':'SYD',
  '2295':'SYD',
  '2296':'SYD',
  '2297':'SYD',
  '2298':'SYD',
  '2299':'SYD',
  '2300':'SYD',
  '2302':'SYD',
  '2303':'SYD',
  '2304':'SYD',
  '2305':'SYD',
  '2306':'SYD',
  '2307':'SYD',
  '2308':'SYD',
  '2309':'SYD',
  '2310':'SYD',
  '2311':'BRI',
  '2312':'SYD',
  '2314':'SYD',
  '2315':'SYD',
  '2316':'SYD',
  '2317':'SYD',
  '2318':'SYD',
  '2319':'SYD',
  '2320':'SYD',
  '2321':'CBR',
  '2322':'SYD',
  '2323':'SYD',
  '2324':'CBR',
  '2325':'CBR',
  '2326':'SYD',
  '2327':'SYD',
  '2328':'CBR',
  '2329':'CBR',
  '2330':'CBR',
  '2331':'CBR',
  '2333':'CBR',
  '2334':'SYD',
  '2335':'CBR',
  '2336':'CBR',
  '2337':'CBR',
  '2338':'CBR',
  '2339':'CBR',
  '2340':'SYD',
  '2341':'CBR',
  '2342':'SYD',
  '2343':'SYD',
  '2344':'SYD',
  '2345':'SYD',
  '2346':'SYD',
  '2347':'SYD',
  '2348':'SYD',
  '2350':'SYD',
  '2351':'SYD',
  '2352':'SYD',
  '2353':'SYD',
  '2354':'SYD',
  '2355':'SYD',
  '2356':'SYD',
  '2357':'SYD',
  '2358':'SYD',
  '2359':'SYD',
  '2360':'SYD',
  '2361':'SYD',
  '2365':'SYD',
  '2369':'SYD',
  '2370':'SYD',
  '2371':'SYD',
  '2372':'SYD',
  '2379':'BRI',
  '2380':'SYD',
  '2381':'SYD',
  '2382':'SYD',
  '2386':'SYD',
  '2387':'SYD',
  '2388':'SYD',
  '2390':'SYD',
  '2395':'SYD',
  '2396':'SYD',
  '2397':'SYD',
  '2398':'SYD',
  '2399':'SYD',
  '2400':'SYD',
  '2401':'SYD',
  '2402':'SYD',
  '2403':'SYD',
  '2404':'CBR',
  '2405':'SYD',
  '2406':'SYD',
  '2408':'SYD',
  '2409':'SYD',
  '2410':'SYD',
  '2411':'SYD',
  '2415':'SYD',
  '2420':'SYD',
  '2421':'SYD',
  '2422':'SYD',
  '2423':'SYD',
  '2424':'SYD',
  '2425':'SYD',
  '2426':'SYD',
  '2427':'SYD',
  '2428':'SYD',
  '2429':'SYD',
  '2430':'SYD',
  '2431':'SYD',
  '2439':'SYD',
  '2440':'SYD',
  '2441':'SYD',
  '2442':'SYD',
  '2443':'SYD',
  '2444':'SYD',
  '2445':'SYD',
  '2446':'SYD',
  '2447':'SYD',
  '2448':'SYD',
  '2449':'SYD',
  '2450':'SYD',
  '2452':'SYD',
  '2453':'SYD',
  '2454':'SYD',
  '2455':'SYD',
  '2456':'SYD',
  '2460':'SYD',
  '2462':'SYD',
  '2463':'SYD',
  '2464':'BRI',
  '2465':'SYD',
  '2466':'SYD',
  '2469':'MEL',
  '2470':'MEL',
  '2471':'MEL',
  '2472':'MEL',
  '2473':'MEL',
  '2474':'MEL',
  '2475':'MEL',
  '2476':'MEL',
  '2477':'SYD',
  '2478':'SYD',
  '2479':'MEL',
  '2480':'MEL',
  '2481':'MEL',
  '2482':'MEL',
  '2483':'MEL',
  '2484':'SYD',
  '2485':'BRI',
  '2486':'SYD',
  '2487':'SYD',
  '2488':'SYD',
  '2489':'BRI',
  '2490':'BRI',
  '2500':'SYD',
  '2502':'SYD',
  '2505':'SYD',
  '2506':'SYD',
  '2508':'BRI',
  '2515':'SYD',
  '2516':'SYD',
  '2517':'SYD',
  '2518':'SYD',
  '2519':'SYD',
  '2520':'SYD',
  '2522':'SYD',
  '2525':'SYD',
  '2526':'SYD',
  '2527':'SYD',
  '2528':'SYD',
  '2529':'SYD',
  '2530':'SYD',
  '2533':'SYD',
  '2534':'SYD',
  '2535':'SYD',
  '2536':'SYD',
  '2537':'MEL',
  '2538':'SYD',
  '2539':'SYD',
  '2540':'SYD',
  '2541':'SYD',
  '2545':'SYD',
  '2546':'SYD',
  '2548':'SYD',
  '2549':'SYD',
  '2550':'MEL',
  '2551':'MEL',
  '2555':'SYD',
  '2556':'SYD',
  '2557':'SYD',
  '2558':'SYD',
  '2559':'SYD',
  '2560':'SYD',
  '2563':'MEL',
  '2564':'SYD',
  '2565':'SYD',
  '2566':'SYD',
  '2567':'SYD',
  '2568':'MEL',
  '2569':'MEL',
  '2570':'MEL',
  '2571':'SYD',
  '2572':'SYD',
  '2573':'SYD',
  '2574':'SYD',
  '2575':'SYD',
  '2576':'MEL',
  '2577':'MEL',
  '2578':'SYD',
  '2579':'MEL',
  '2580':'SYD',
  '2581':'SYD',
  '2582':'MEL',
  '2583':'SYD',
  '2584':'SYD',
  '2585':'SYD',
  '2586':'SYD',
  '2587':'SYD',
  '2588':'SYD',
  '2590':'SYD',
  '2594':'MEL',
  '2600':'CBR',
  '2601':'CBR',
  '2602':'CBR',
  '2603':'CBR',
  '2604':'CBR',
  '2605':'CBR',
  '2606':'CBR',
  '2607':'CBR',
  '2608':'CBR',
  '2609':'CBR',
  '2610':'CBR',
  '2611':'CBR',
  '2612':'CBR',
  '2614':'CBR',
  '2615':'MEL',
  '2616':'CBR',
  '2617':'CBR',
  '2618':'CBR',
  '2619':'CBR',
  '2620':'SYD',
  '2621':'SYD',
  '2622':'SYD',
  '2623':'SYD',
  '2624':'CBR',
  '2625':'CBR',
  '2626':'SYD',
  '2627':'SYD',
  '2628':'SYD',
  '2629':'SYD',
  '2630':'SYD',
  '2631':'SYD',
  '2632':'SYD',
  '2633':'SYD',
  '2640':'SYD',
  '2641':'MEL',
  '2642':'SYD',
  '2643':'MEL',
  '2644':'SYD',
  '2645':'SYD',
  '2646':'SYD',
  '2647':'MEL',
  '2648':'ADL',
  '2649':'SYD',
  '2650':'SYD',
  '2651':'MEL',
  '2652':'SYD',
  '2653':'SYD',
  '2655':'SYD',
  '2656':'SYD',
  '2658':'SYD',
  '2659':'SYD',
  '2660':'SYD',
  '2661':'SYD',
  '2663':'SYD',
  '2665':'SYD',
  '2666':'SYD',
  '2668':'SYD',
  '2669':'ADL',
  '2671':'SYD',
  '2672':'SYD',
  '2675':'SYD',
  '2678':'SYD',
  '2680':'MEL',
  '2681':'MEL',
  '2700':'SYD',
  '2701':'SYD',
  '2702':'SYD',
  '2703':'SYD',
  '2705':'SYD',
  '2706':'SYD',
  '2707':'SYD',
  '2708':'MEL',
  '2710':'ADL',
  '2711':'ADL',
  '2712':'ADL',
  '2713':'SYD',
  '2714':'SYD',
  '2715':'BRI',
  '2716':'ADL',
  '2717':'ADL',
  '2720':'SYD',
  '2721':'SYD',
  '2722':'SYD',
  '2725':'SYD',
  '2726':'SYD',
  '2727':'SYD',
  '2729':'SYD',
  '2730':'SYD',
  '2731':'SYD',
  '2732':'ADL',
  '2733':'ADL',
  '2734':'ADL',
  '2735':'SYD',
  '2736':'SYD',
  '2737':'SYD',
  '2738':'SYD',
  '2739':'ADL',
  '2745':'SYD',
  '2747':'SYD',
  '2748':'SYD',
  '2749':'SYD',
  '2750':'SYD',
  '2751':'SYD',
  '2752':'SYD',
  '2753':'SYD',
  '2754':'SYD',
  '2756':'SYD',
  '2757':'SYD',
  '2758':'SYD',
  '2759':'SYD',
  '2760':'SYD',
  '2761':'SYD',
  '2762':'SYD',
  '2763':'SYD',
  '2765':'SYD',
  '2766':'SYD',
  '2767':'SYD',
  '2768':'SYD',
  '2769':'SYD',
  '2770':'SYD',
  '2773':'SYD',
  '2774':'SYD',
  '2775':'SYD',
  '2776':'SYD',
  '2777':'SYD',
  '2778':'SYD',
  '2779':'SYD',
  '2780':'SYD',
  '2782':'SYD',
  '2783':'SYD',
  '2784':'SYD',
  '2785':'SYD',
  '2786':'SYD',
  '2787':'SYD',
  '2790':'SYD',
  '2791':'SYD',
  '2792':'SYD',
  '2793':'SYD',
  '2794':'SYD',
  '2795':'SYD',
  '2797':'SYD',
  '2798':'SYD',
  '2799':'SYD',
  '2800':'SYD',
  '2803':'SYD',
  '2804':'SYD',
  '2805':'SYD',
  '2806':'SYD',
  '2807':'SYD',
  '2808':'SYD',
  '2809':'SYD',
  '2810':'SYD',
  '2817':'SYD',
  '2818':'SYD',
  '2820':'SYD',
  '2821':'SYD',
  '2822':'SYD',
  '2823':'SYD',
  '2824':'SYD',
  '2825':'SYD',
  '2826':'SYD',
  '2827':'SYD',
  '2828':'SYD',
  '2829':'SYD',
  '2830':'SYD',
  '2831':'SYD',
  '2832':'SYD',
  '2833':'SYD',
  '2834':'SYD',
  '2835':'SYD',
  '2836':'SYD',
  '2838':'SYD',
  '2839':'SYD',
  '2840':'SYD',
  '2842':'SYD',
  '2843':'SYD',
  '2844':'SYD',
  '2845':'SYD',
  '2846':'SYD',
  '2847':'SYD',
  '2848':'SYD',
  '2849':'SYD',
  '2850':'SYD',
  '2852':'SYD',
  '2864':'SYD',
  '2865':'SYD',
  '2866':'SYD',
  '2867':'SYD',
  '2868':'SYD',
  '2869':'SYD',
  '2870':'SYD',
  '2871':'SYD',
  '2873':'SYD',
  '2874':'SYD',
  '2875':'SYD',
  '2876':'SYD',
  '2877':'SYD',
  '2878':'ADL',
  '2879':'ADL',
  '2880':'ADL',
  '2890':'ADL',
  '2891':'ADL',
  '2898':'ADL',
  '2899':'ADL',
  '2900':'CBR',
  '2901':'CBR',
  '2902':'CBR',
  '2903':'CBR',
  '2904':'CBR',
  '2905':'CBR',
  '2906':'CBR',
  '2911':'CBR',
  '2912':'CBR',
  '2913':'CBR',
  '2914':'CBR',
  '3000':'MEL',
  '3001':'MEL',
  '3002':'MEL',
  '3003':'MEL',
  '3004':'ADL',
  '3006':'MEL',
  '3008':'MEL',
  '3010':'MEL',
  '3011':'MEL',
  '3012':'MEL',
  '3013':'MEL',
  '3015':'MEL',
  '3016':'MEL',
  '3018':'MEL',
  '3019':'MEL',
  '3020':'MEL',
  '3021':'MEL',
  '3022':'MEL',
  '3023':'MEL',
  '3024':'MEL',
  '3025':'MEL',
  '3026':'MEL',
  '3027':'MEL',
  '3028':'MEL',
  '3029':'MEL',
  '3030':'MEL',
  '3031':'MEL',
  '3032':'MEL',
  '3033':'MEL',
  '3034':'MEL',
  '3036':'MEL',
  '3037':'MEL',
  '3038':'BRI',
  '3039':'MEL',
  '3040':'MEL',
  '3041':'MEL',
  '3042':'BRI',
  '3043':'MEL',
  '3044':'MEL',
  '3045':'MEL',
  '3046':'MEL',
  '3047':'MEL',
  '3048':'MEL',
  '3049':'MEL',
  '3050':'MEL',
  '3051':'MEL',
  '3052':'MEL',
  '3053':'MEL',
  '3054':'MEL',
  '3055':'MEL',
  '3056':'MEL',
  '3057':'BRI',
  '3058':'MEL',
  '3059':'MEL',
  '3060':'MEL',
  '3061':'MEL',
  '3062':'MEL',
  '3063':'BRI',
  '3064':'MEL',
  '3065':'MEL',
  '3066':'MEL',
  '3067':'MEL',
  '3068':'MEL',
  '3070':'MEL',
  '3071':'MEL',
  '3072':'BRI',
  '3073':'MEL',
  '3074':'MEL',
  '3075':'MEL',
  '3076':'MEL',
  '3078':'MEL',
  '3079':'MEL',
  '3081':'MEL',
  '3082':'MEL',
  '3083':'MEL',
  '3084':'MEL',
  '3085':'MEL',
  '3086':'MEL',
  '3087':'MEL',
  '3088':'MEL',
  '3089':'BRI',
  '3090':'BRI',
  '3091':'BRI',
  '3093':'MEL',
  '3094':'MEL',
  '3095':'MEL',
  '3096':'BRI',
  '3097':'BRI',
  '3099':'BRI',
  '3101':'MEL',
  '3102':'MEL',
  '3103':'BRI',
  '3104':'MEL',
  '3105':'MEL',
  '3106':'MEL',
  '3107':'MEL',
  '3108':'MEL',
  '3109':'MEL',
  '3111':'MEL',
  '3113':'BRI',
  '3114':'BRI',
  '3115':'BRI',
  '3116':'MEL',
  '3121':'MEL',
  '3122':'MEL',
  '3123':'MEL',
  '3124':'MEL',
  '3125':'MEL',
  '3126':'MEL',
  '3127':'MEL',
  '3128':'BRI',
  '3129':'MEL',
  '3130':'MEL',
  '3131':'MEL',
  '3132':'BRI',
  '3133':'MEL',
  '3134':'MEL',
  '3135':'MEL',
  '3136':'MEL',
  '3137':'MEL',
  '3138':'MEL',
  '3139':'BRI',
  '3140':'MEL',
  '3141':'MEL',
  '3142':'MEL',
  '3143':'MEL',
  '3144':'MEL',
  '3145':'BRI',
  '3146':'BRI',
  '3147':'MEL',
  '3148':'BRI',
  '3149':'BRI',
  '3150':'MEL',
  '3151':'MEL',
  '3152':'MEL',
  '3153':'MEL',
  '3154':'MEL',
  '3155':'MEL',
  '3156':'BRI',
  '3158':'BRI',
  '3159':'BRI',
  '3160':'BRI',
  '3161':'MEL',
  '3162':'BRI',
  '3163':'MEL',
  '3164':'MEL',
  '3165':'MEL',
  '3166':'MEL',
  '3167':'MEL',
  '3168':'MEL',
  '3169':'MEL',
  '3170':'BRI',
  '3171':'MEL',
  '3172':'MEL',
  '3173':'MEL',
  '3174':'MEL',
  '3175':'BRI',
  '3176':'MEL',
  '3177':'MEL',
  '3178':'MEL',
  '3179':'MEL',
  '3180':'MEL',
  '3181':'MEL',
  '3182':'MEL',
  '3183':'MEL',
  '3184':'MEL',
  '3185':'MEL',
  '3186':'BRI',
  '3187':'MEL',
  '3188':'MEL',
  '3189':'BRI',
  '3190':'MEL',
  '3191':'MEL',
  '3192':'MEL',
  '3193':'BRI',
  '3194':'MEL',
  '3195':'MEL',
  '3196':'MEL',
  '3197':'MEL',
  '3198':'MEL',
  '3199':'BRI',
  '3200':'BRI',
  '3201':'MEL',
  '3202':'MEL',
  '3204':'BRI',
  '3205':'MEL',
  '3206':'MEL',
  '3207':'MEL',
  '3211':'BRI',
  '3212':'BRI',
  '3213':'BRI',
  '3214':'MEL',
  '3215':'MEL',
  '3216':'MEL',
  '3217':'MEL',
  '3218':'BRI',
  '3219':'MEL',
  '3220':'MEL',
  '3221':'BRI',
  '3222':'MEL',
  '3223':'MEL',
  '3224':'MEL',
  '3225':'BRI',
  '3226':'MEL',
  '3227':'MEL',
  '3228':'MEL',
  '3230':'MEL',
  '3231':'BRI',
  '3232':'BRI',
  '3233':'BRI',
  '3234':'BRI',
  '3235':'BRI',
  '3236':'BRI',
  '3237':'BRI',
  '3238':'BRI',
  '3239':'BRI',
  '3240':'BRI',
  '3241':'BRI',
  '3242':'MEL',
  '3243':'BRI',
  '3249':'BRI',
  '3250':'MEL',
  '3251':'BRI',
  '3254':'BRI',
  '3260':'BRI',
  '3264':'BRI',
  '3265':'BRI',
  '3266':'BRI',
  '3267':'BRI',
  '3268':'BRI',
  '3269':'BRI',
  '3270':'BRI',
  '3271':'BRI',
  '3272':'BRI',
  '3273':'BRI',
  '3274':'BRI',
  '3275':'BRI',
  '3276':'BRI',
  '3277':'BRI',
  '3278':'BRI',
  '3279':'BRI',
  '3280':'BRI',
  '3281':'BRI',
  '3282':'BRI',
  '3283':'BRI',
  '3284':'BRI',
  '3285':'BRI',
  '3286':'BRI',
  '3287':'BRI',
  '3289':'BRI',
  '3292':'BRI',
  '3293':'BRI',
  '3294':'BRI',
  '3300':'BRI',
  '3301':'BRI',
  '3302':'BRI',
  '3303':'BRI',
  '3304':'BRI',
  '3305':'BRI',
  '3309':'BRI',
  '3310':'BRI',
  '3311':'BRI',
  '3312':'BRI',
  '3314':'BRI',
  '3315':'BRI',
  '3317':'MEL',
  '3318':'MEL',
  '3319':'MEL',
  '3321':'MEL',
  '3322':'MEL',
  '3323':'MEL',
  '3324':'MEL',
  '3325':'MEL',
  '3328':'MEL',
  '3329':'MEL',
  '3330':'MEL',
  '3331':'MEL',
  '3332':'MEL',
  '3333':'MEL',
  '3334':'MEL',
  '3335':'MEL',
  '3336':'MEL',
  '3337':'MEL',
  '3338':'MEL',
  '3340':'MEL',
  '3341':'MEL',
  '3342':'MEL',
  '3345':'MEL',
  '3350':'MEL',
  '3351':'MEL',
  '3352':'MEL',
  '3353':'MEL',
  '3354':'MEL',
  '3355':'MEL',
  '3356':'MEL',
  '3357':'MEL',
  '3358':'MEL',
  '3360':'MEL',
  '3361':'MEL',
  '3363':'BRI',
  '3364':'MEL',
  '3370':'BRI',
  '3371':'MEL',
  '3373':'MEL',
  '3374':'MEL',
  '3375':'BRI',
  '3377':'BRI',
  '3378':'BRI',
  '3379':'MEL',
  '3380':'MEL',
  '3381':'MEL',
  '3384':'BRI',
  '3385':'BRI',
  '3387':'BRI',
  '3388':'MEL',
  '3390':'MEL',
  '3391':'MEL',
  '3392':'BRI',
  '3393':'BRI',
  '3395':'BRI',
  '3396':'MEL',
  '3400':'BRI',
  '3401':'MEL',
  '3402':'BRI',
  '3407':'BRI',
  '3409':'BRI',
  '3412':'MEL',
  '3413':'MEL',
  '3414':'MEL',
  '3415':'BRI',
  '3418':'MEL',
  '3419':'MEL',
  '3420':'BRI',
  '3423':'MEL',
  '3424':'MEL',
  '3427':'MEL',
  '3428':'BRI',
  '3429':'BRI',
  '3430':'BRI',
  '3431':'MEL',
  '3432':'MEL',
  '3433':'MEL',
  '3434':'BRI',
  '3435':'BRI',
  '3437':'MEL',
  '3438':'MEL',
  '3440':'MEL',
  '3441':'MEL',
  '3442':'MEL',
  '3444':'BRI',
  '3446':'MEL',
  '3447':'MEL',
  '3448':'BRI',
  '3450':'BRI',
  '3451':'BRI',
  '3453':'BRI',
  '3458':'BRI',
  '3460':'MEL',
  '3461':'BRI',
  '3462':'BRI',
  '3463':'BRI',
  '3464':'BRI',
  '3465':'BRI',
  '3467':'BRI',
  '3468':'BRI',
  '3469':'BRI',
  '3472':'BRI',
  '3475':'BRI',
  '3477':'BRI',
  '3478':'MEL',
  '3480':'BRI',
  '3482':'BRI',
  '3483':'BRI',
  '3485':'BRI',
  '3487':'BRI',
  '3488':'BRI',
  '3489':'BRI',
  '3490':'BRI',
  '3491':'BRI',
  '3494':'BRI',
  '3496':'ADL',
  '3498':'ADL',
  '3500':'ADL',
  '3501':'ADL',
  '3502':'ADL',
  '3505':'ADL',
  '3506':'ADL',
  '3507':'ADL',
  '3509':'ADL',
  '3512':'ADL',
  '3515':'ADL',
  '3516':'ADL',
  '3517':'ADL',
  '3518':'ADL',
  '3520':'ADL',
  '3521':'ADL',
  '3522':'ADL',
  '3523':'ADL',
  '3525':'ADL',
  '3527':'ADL',
  '3529':'ADL',
  '3530':'ADL',
  '3531':'ADL',
  '3533':'ADL',
  '3537':'ADL',
  '3540':'ADL',
  '3542':'ADL',
  '3544':'ADL',
  '3546':'ADL',
  '3549':'ADL',
  '3550':'MEL',
  '3551':'MEL',
  '3552':'MEL',
  '3554':'MEL',
  '3555':'MEL',
  '3556':'BRI',
  '3557':'BRI',
  '3558':'BRI',
  '3559':'BRI',
  '3561':'MEL',
  '3562':'MEL',
  '3563':'MEL',
  '3564':'MEL',
  '3565':'MEL',
  '3566':'MEL',
  '3567':'BRI',
  '3568':'BRI',
  '3570':'BRI',
  '3571':'MEL',
  '3572':'MEL',
  '3573':'MEL',
  '3575':'BRI',
  '3576':'BRI',
  '3579':'BRI',
  '3580':'BRI',
  '3581':'BRI',
  '3583':'BRI',
  '3584':'BRI',
  '3585':'BRI',
  '3586':'BRI',
  '3588':'BRI',
  '3589':'BRI',
  '3590':'BRI',
  '3591':'BRI',
  '3594':'BRI',
  '3595':'BRI',
  '3596':'BRI',
  '3597':'BRI',
  '3599':'BRI',
  '3607':'MEL',
  '3608':'MEL',
  '3610':'MEL',
  '3612':'MEL',
  '3614':'MEL',
  '3616':'MEL',
  '3617':'MEL',
  '3618':'MEL',
  '3619':'MEL',
  '3620':'MEL',
  '3621':'MEL',
  '3622':'MEL',
  '3623':'MEL',
  '3624':'MEL',
  '3629':'MEL',
  '3630':'MEL',
  '3631':'MEL',
  '3632':'MEL',
  '3633':'MEL',
  '3634':'MEL',
  '3635':'MEL',
  '3636':'MEL',
  '3637':'MEL',
  '3638':'MEL',
  '3639':'MEL',
  '3640':'MEL',
  '3641':'MEL',
  '3643':'MEL',
  '3644':'MEL',
  '3646':'MEL',
  '3647':'MEL',
  '3649':'MEL',
  '3658':'MEL',
  '3659':'MEL',
  '3660':'MEL',
  '3661':'BRI',
  '3662':'MEL',
  '3663':'MEL',
  '3664':'MEL',
  '3665':'MEL',
  '3666':'MEL',
  '3669':'MEL',
  '3670':'MEL',
  '3671':'MEL',
  '3672':'MEL',
  '3673':'MEL',
  '3675':'MEL',
  '3676':'MEL',
  '3677':'MEL',
  '3678':'MEL',
  '3682':'MEL',
  '3683':'MEL',
  '3685':'MEL',
  '3687':'MEL',
  '3688':'BRI',
  '3689':'MEL',
  '3690':'MEL',
  '3691':'MEL',
  '3694':'MEL',
  '3695':'MEL',
  '3697':'MEL',
  '3698':'MEL',
  '3699':'MEL',
  '3700':'MEL',
  '3701':'BRI',
  '3704':'BRI',
  '3705':'BRI',
  '3707':'BRI',
  '3708':'BRI',
  '3709':'BRI',
  '3711':'MEL',
  '3712':'MEL',
  '3713':'MEL',
  '3714':'MEL',
  '3715':'MEL',
  '3717':'MEL',
  '3718':'MEL',
  '3719':'MEL',
  '3720':'MEL',
  '3722':'MEL',
  '3723':'MEL',
  '3724':'MEL',
  '3725':'MEL',
  '3726':'MEL',
  '3727':'MEL',
  '3728':'MEL',
  '3730':'MEL',
  '3732':'MEL',
  '3733':'MEL',
  '3735':'MEL',
  '3736':'MEL',
  '3737':'BRI',
  '3738':'MEL',
  '3739':'MEL',
  '3740':'MEL',
  '3741':'BRI',
  '3744':'MEL',
  '3746':'MEL',
  '3747':'MEL',
  '3749':'MEL',
  '3750':'MEL',
  '3751':'MEL',
  '3752':'MEL',
  '3753':'MEL',
  '3754':'BRI',
  '3755':'BRI',
  '3756':'MEL',
  '3757':'BRI',
  '3758':'BRI',
  '3759':'BRI',
  '3760':'BRI',
  '3761':'BRI',
  '3762':'MEL',
  '3763':'BRI',
  '3764':'BRI',
  '3765':'BRI',
  '3766':'BRI',
  '3767':'BRI',
  '3770':'BRI',
  '3775':'BRI',
  '3777':'BRI',
  '3778':'BRI',
  '3779':'BRI',
  '3781':'BRI',
  '3782':'BRI',
  '3783':'BRI',
  '3785':'BRI',
  '3786':'BRI',
  '3787':'BRI',
  '3788':'BRI',
  '3789':'BRI',
  '3791':'BRI',
  '3792':'BRI',
  '3793':'BRI',
  '3795':'BRI',
  '3796':'BRI',
  '3797':'BRI',
  '3799':'BRI',
  '3800':'MEL',
  '3802':'MEL',
  '3803':'MEL',
  '3804':'MEL',
  '3805':'MEL',
  '3806':'BRI',
  '3807':'BRI',
  '3808':'BRI',
  '3809':'BRI',
  '3810':'BRI',
  '3812':'BRI',
  '3813':'BRI',
  '3814':'BRI',
  '3815':'BRI',
  '3816':'BRI',
  '3818':'BRI',
  '3820':'BRI',
  '3821':'BRI',
  '3822':'BRI',
  '3823':'BRI',
  '3824':'BRI',
  '3825':'BRI',
  '3831':'BRI',
  '3832':'BRI',
  '3833':'BRI',
  '3835':'BRI',
  '3840':'BRI',
  '3841':'BRI',
  '3842':'BRI',
  '3844':'BRI',
  '3847':'BRI',
  '3850':'BRI',
  '3851':'BRI',
  '3852':'BRI',
  '3853':'BRI',
  '3854':'BRI',
  '3856':'BRI',
  '3857':'BRI',
  '3858':'BRI',
  '3859':'BRI',
  '3860':'BRI',
  '3862':'BRI',
  '3864':'BRI',
  '3865':'BRI',
  '3869':'BRI',
  '3870':'BRI',
  '3871':'BRI',
  '3873':'BRI',
  '3874':'BRI',
  '3875':'BRI',
  '3878':'BRI',
  '3880':'BRI',
  '3882':'BRI',
  '3885':'BRI',
  '3886':'BRI',
  '3887':'BRI',
  '3888':'BRI',
  '3889':'BRI',
  '3890':'BRI',
  '3891':'BRI',
  '3892':'BRI',
  '3893':'BRI',
  '3895':'BRI',
  '3896':'BRI',
  '3898':'BRI',
  '3900':'BRI',
  '3902':'BRI',
  '3903':'BRI',
  '3904':'BRI',
  '3909':'BRI',
  '3910':'MEL',
  '3911':'MEL',
  '3912':'MEL',
  '3913':'MEL',
  '3915':'MEL',
  '3916':'MEL',
  '3918':'MEL',
  '3919':'MEL',
  '3920':'MEL',
  '3921':'BRI',
  '3922':'BRI',
  '3923':'BRI',
  '3925':'BRI',
  '3926':'MEL',
  '3927':'MEL',
  '3928':'MEL',
  '3929':'MEL',
  '3930':'MEL',
  '3931':'MEL',
  '3933':'MEL',
  '3934':'MEL',
  '3936':'MEL',
  '3937':'MEL',
  '3938':'MEL',
  '3939':'MEL',
  '3940':'MEL',
  '3941':'MEL',
  '3942':'MEL',
  '3943':'MEL',
  '3944':'MEL',
  '3945':'BRI',
  '3946':'BRI',
  '3950':'BRI',
  '3951':'BRI',
  '3953':'BRI',
  '3954':'BRI',
  '3956':'BRI',
  '3957':'BRI',
  '3958':'BRI',
  '3959':'BRI',
  '3960':'BRI',
  '3962':'BRI',
  '3964':'BRI',
  '3965':'BRI',
  '3966':'BRI',
  '3967':'BRI',
  '3971':'BRI',
  '3975':'MEL',
  '3976':'MEL',
  '3977':'MEL',
  '3978':'BRI',
  '3979':'BRI',
  '3980':'BRI',
  '3981':'BRI',
  '3984':'BRI',
  '3987':'BRI',
  '3988':'BRI',
  '3990':'BRI',
  '3991':'BRI',
  '3992':'BRI',
  '3995':'BRI',
  '3996':'BRI',
  '4000':'BRI',
  '4001':'BRI',
  '4002':'BRI',
  '4003':'BRI',
  '4004':'BRI',
  '4005':'BRI',
  '4006':'BRI',
  '4007':'BRI',
  '4008':'BRI',
  '4009':'BRI',
  '4010':'BRI',
  '4011':'BRI',
  '4012':'BRI',
  '4013':'BRI',
  '4014':'BRI',
  '4017':'BRI',
  '4018':'BRI',
  '4019':'BRI',
  '4020':'BRI',
  '4021':'BRI',
  '4022':'BRI',
  '4025':'BRI',
  '4029':'BRI',
  '4030':'BRI',
  '4031':'BRI',
  '4032':'BRI',
  '4034':'BRI',
  '4035':'BRI',
  '4036':'BRI',
  '4037':'BRI',
  '4051':'BRI',
  '4053':'BRI',
  '4054':'BRI',
  '4055':'BRI',
  '4059':'BRI',
  '4060':'BRI',
  '4061':'BRI',
  '4064':'BRI',
  '4065':'BRI',
  '4066':'BRI',
  '4067':'BRI',
  '4068':'BRI',
  '4069':'BRI',
  '4070':'BRI',
  '4072':'BRI',
  '4073':'BRI',
  '4074':'BRI',
  '4075':'BRI',
  '4076':'BRI',
  '4077':'BRI',
  '4078':'BRI',
  '4101':'BRI',
  '4102':'BRI',
  '4103':'BRI',
  '4104':'BRI',
  '4105':'BRI',
  '4106':'BRI',
  '4107':'BRI',
  '4108':'BRI',
  '4109':'BRI',
  '4110':'BRI',
  '4111':'BRI',
  '4112':'BRI',
  '4113':'BRI',
  '4114':'BRI',
  '4115':'BRI',
  '4116':'BRI',
  '4117':'BRI',
  '4118':'BRI',
  '4119':'BRI',
  '4120':'BRI',
  '4121':'BRI',
  '4122':'BRI',
  '4123':'BRI',
  '4124':'BRI',
  '4125':'BRI',
  '4127':'BRI',
  '4128':'BRI',
  '4129':'BRI',
  '4130':'BRI',
  '4131':'BRI',
  '4132':'BRI',
  '4133':'BRI',
  '4151':'BRI',
  '4152':'BRI',
  '4153':'BRI',
  '4154':'BRI',
  '4155':'BRI',
  '4156':'BRI',
  '4157':'BRI',
  '4158':'BRI',
  '4159':'BRI',
  '4160':'BRI',
  '4161':'BRI',
  '4163':'BRI',
  '4164':'BRI',
  '4165':'BRI',
  '4169':'BRI',
  '4170':'BRI',
  '4171':'BRI',
  '4172':'BRI',
  '4173':'BRI',
  '4174':'BRI',
  '4178':'BRI',
  '4179':'BRI',
  '4183':'BRI',
  '4184':'BRI',
  '4205':'BRI',
  '4207':'BRI',
  '4208':'BRI',
  '4209':'BRI',
  '4210':'BRI',
  '4211':'BRI',
  '4212':'BRI',
  '4213':'BRI',
  '4214':'BRI',
  '4215':'BRI',
  '4216':'BRI',
  '4217':'BRI',
  '4218':'BRI',
  '4219':'BRI',
  '4220':'BRI',
  '4221':'BRI',
  '4222':'BRI',
  '4223':'BRI',
  '4224':'BRI',
  '4225':'BRI',
  '4226':'BRI',
  '4227':'BRI',
  '4228':'BRI',
  '4230':'BRI',
  '4270':'BRI',
  '4271':'BRI',
  '4272':'BRI',
  '4275':'BRI',
  '4280':'BRI',
  '4285':'BRI',
  '4287':'BRI',
  '4300':'BRI',
  '4301':'BRI',
  '4303':'BRI',
  '4304':'BRI',
  '4305':'BRI',
  '4306':'BRI',
  '4307':'BRI',
  '4309':'BRI',
  '4310':'BRI',
  '4311':'BRI',
  '4312':'BRI',
  '4313':'BRI',
  '4314':'BRI',
  '4340':'BRI',
  '4341':'BRI',
  '4342':'BRI',
  '4343':'BRI',
  '4344':'BRI',
  '4345':'BRI',
  '4346':'BRI',
  '4347':'BRI',
  '4350':'BRI',
  '4352':'BRI',
  '4353':'BRI',
  '4354':'BRI',
  '4355':'BRI',
  '4356':'BRI',
  '4357':'BRI',
  '4358':'BRI',
  '4359':'BRI',
  '4360':'BRI',
  '4361':'BRI',
  '4362':'BRI',
  '4363':'BRI',
  '4364':'BRI',
  '4365':'BRI',
  '4370':'BRI',
  '4371':'BRI',
  '4372':'BRI',
  '4373':'BRI',
  '4374':'BRI',
  '4375':'BRI',
  '4376':'BRI',
  '4377':'BRI',
  '4378':'BRI',
  '4380':'BRI',
  '4381':'BRI',
  '4382':'BRI',
  '4383':'BRI',
  '4384':'BRI',
  '4385':'BRI',
  '4387':'BRI',
  '4388':'BRI',
  '4390':'BRI',
  '4400':'BRI',
  '4401':'BRI',
  '4402':'BRI',
  '4403':'BRI',
  '4404':'BRI',
  '4405':'BRI',
  '4406':'BRI',
  '4407':'BRI',
  '4408':'BRI',
  '4410':'BRI',
  '4411':'BRI',
  '4412':'BRI',
  '4413':'BRI',
  '4415':'BRI',
  '4416':'BRI',
  '4417':'BRI',
  '4418':'BRI',
  '4419':'BRI',
  '4420':'BRI',
  '4421':'BRI',
  '4422':'BRI',
  '4423':'BRI',
  '4424':'BRI',
  '4425':'BRI',
  '4426':'BRI',
  '4427':'BRI',
  '4428':'BRI',
  '4454':'BRI',
  '4455':'BRI',
  '4461':'BRI',
  '4462':'BRI',
  '4465':'BRI',
  '4467':'BRI',
  '4468':'BRI',
  '4470':'BRI',
  '4471':'BRI',
  '4472':'BRI',
  '4474':'BRI',
  '4475':'BRI',
  '4477':'BRI',
  '4478':'BRI',
  '4479':'BRI',
  '4480':'BRI',
  '4481':'BRI',
  '4482':'BRI',
  '4486':'BRI',
  '4487':'BRI',
  '4488':'BRI',
  '4489':'BRI',
  '4490':'BRI',
  '4491':'BRI',
  '4492':'BRI',
  '4493':'BRI',
  '4494':'BRI',
  '4496':'BRI',
  '4497':'BRI',
  '4498':'BRI',
  '4500':'BRI',
  '4501':'BRI',
  '4502':'BRI',
  '4503':'BRI',
  '4504':'BRI',
  '4505':'BRI',
  '4506':'BRI',
  '4507':'BRI',
  '4508':'BRI',
  '4509':'BRI',
  '4510':'BRI',
  '4511':'BRI',
  '4512':'BRI',
  '4513':'BRI',
  '4514':'BRI',
  '4515':'BRI',
  '4516':'BRI',
  '4517':'BRI',
  '4518':'BRI',
  '4519':'BRI',
  '4520':'BRI',
  '4521':'BRI',
  '4550':'BRI',
  '4551':'BRI',
  '4552':'BRI',
  '4553':'BRI',
  '4554':'BRI',
  '4555':'BRI',
  '4556':'BRI',
  '4557':'BRI',
  '4558':'BRI',
  '4559':'BRI',
  '4560':'BRI',
  '4561':'BRI',
  '4562':'BRI',
  '4563':'BRI',
  '4564':'BRI',
  '4565':'BRI',
  '4566':'BRI',
  '4567':'BRI',
  '4568':'BRI',
  '4569':'BRI',
  '4570':'BRI',
  '4571':'BRI',
  '4572':'BRI',
  '4573':'BRI',
  '4574':'BRI',
  '4575':'BRI',
  '4580':'BRI',
  '4581':'BRI',
  '4600':'BRI',
  '4601':'BRI',
  '4605':'BRI',
  '4606':'BRI',
  '4608':'BRI',
  '4610':'BRI',
  '4611':'BRI',
  '4612':'BRI',
  '4613':'BRI',
  '4614':'BRI',
  '4615':'BRI',
  '4620':'BRI',
  '4621':'BRI',
  '4625':'BRI',
  '4626':'BRI',
  '4627':'BRI',
  '4630':'BRI',
  '4650':'BRI',
  '4655':'BRI',
  '4659':'BRI',
  '4660':'BRI',
  '4662':'BRI',
  '4670':'BRI',
  '4671':'BRI',
  '4673':'BRI',
  '4674':'BRI',
  '4676':'BRI',
  '4677':'BRI',
  '4678':'BRI',
  '4680':'BRI',
  '4694':'BRI',
  '4695':'BRI',
  '4697':'BRI',
  '4699':'BRI',
  '4700':'BRI',
  '4701':'BRI',
  '4702':'BRI',
  '4703':'BRI',
  '4704':'BRI',
  '4705':'BRI',
  '4706':'BRI',
  '4707':'BRI',
  '4709':'BRI',
  '4710':'BRI',
  '4711':'BRI',
  '4712':'BRI',
  '4713':'BRI',
  '4714':'BRI',
  '4715':'BRI',
  '4716':'BRI',
  '4717':'BRI',
  '4718':'BRI',
  '4719':'BRI',
  '4720':'BRI',
  '4721':'BRI',
  '4722':'BRI',
  '4723':'BRI',
  '4724':'BRI',
  '4725':'BRI',
  '4726':'BRI',
  '4727':'BRI',
  '4728':'BRI',
  '4730':'BRI',
  '4731':'BRI',
  '4732':'BRI',
  '4733':'BRI',
  '4735':'BRI',
  '4736':'BRI',
  '4737':'BRI',
  '4738':'BRI',
  '4739':'BRI',
  '4740':'BRI',
  '4741':'BRI',
  '4742':'BRI',
  '4743':'BRI',
  '4744':'BRI',
  '4745':'BRI',
  '4746':'BRI',
  '4750':'BRI',
  '4751':'BRI',
  '4753':'BRI',
  '4754':'BRI',
  '4756':'BRI',
  '4757':'BRI',
  '4798':'BRI',
  '4799':'BRI',
  '4800':'BRI',
  '4802':'BRI',
  '4803':'BRI',
  '4804':'BRI',
  '4805':'BRI',
  '4806':'BRI',
  '4807':'BRI',
  '4808':'BRI',
  '4809':'BRI',
  '4810':'BRI',
  '4811':'BRI',
  '4812':'BRI',
  '4813':'BRI',
  '4814':'BRI',
  '4815':'BRI',
  '4816':'BRI',
  '4817':'BRI',
  '4818':'BRI',
  '4819':'BRI',
  '4820':'BRI',
  '4821':'BRI',
  '4822':'BRI',
  '4823':'BRI',
  '4824':'BRI',
  '4825':'BRI',
  '4828':'BRI',
  '4829':'BRI',
  '4830':'BRI',
  '4849':'BRI',
  '4850':'BRI',
  '4852':'BRI',
  '4854':'BRI',
  '4855':'BRI',
  '4856':'BRI',
  '4857':'BRI',
  '4858':'BRI',
  '4859':'BRI',
  '4860':'BRI',
  '4861':'BRI',
  '4865':'BRI',
  '4868':'BRI',
  '4869':'BRI',
  '4870':'BRI',
  '4871':'BRI',
  '4872':'BRI',
  '4873':'BRI',
  '4874':'BRI',
  '4875':'BRI',
  '4876':'BRI',
  '4877':'BRI',
  '4878':'BRI',
  '4879':'BRI',
  '4880':'BRI',
  '4881':'BRI',
  '4882':'BRI',
  '4883':'BRI',
  '4884':'BRI',
  '4885':'BRI',
  '4886':'BRI',
  '4887':'BRI',
  '4888':'BRI',
  '4890':'BRI',
  '4891':'BRI',
  '4892':'BRI',
  '4895':'BRI',
  '5000':'ADL',
  '5001':'ADL',
  '5005':'ADL',
  '5006':'ADL',
  '5007':'ADL',
  '5008':'ADL',
  '5009':'ADL',
  '5010':'ADL',
  '5011':'ADL',
  '5012':'ADL',
  '5013':'ADL',
  '5014':'ADL',
  '5015':'ADL',
  '5016':'ADL',
  '5017':'ADL',
  '5018':'ADL',
  '5019':'ADL',
  '5020':'ADL',
  '5021':'ADL',
  '5022':'ADL',
  '5023':'ADL',
  '5024':'ADL',
  '5025':'ADL',
  '5031':'ADL',
  '5032':'ADL',
  '5033':'ADL',
  '5034':'ADL',
  '5035':'ADL',
  '5037':'ADL',
  '5038':'ADL',
  '5039':'ADL',
  '5040':'ADL',
  '5041':'ADL',
  '5042':'ADL',
  '5043':'ADL',
  '5044':'ADL',
  '5045':'ADL',
  '5046':'ADL',
  '5047':'ADL',
  '5048':'ADL',
  '5049':'ADL',
  '5050':'ADL',
  '5051':'ADL',
  '5052':'ADL',
  '5061':'ADL',
  '5062':'ADL',
  '5063':'ADL',
  '5064':'ADL',
  '5065':'ADL',
  '5066':'ADL',
  '5067':'ADL',
  '5068':'ADL',
  '5069':'ADL',
  '5070':'ADL',
  '5071':'ADL',
  '5072':'ADL',
  '5073':'ADL',
  '5074':'ADL',
  '5075':'ADL',
  '5076':'ADL',
  '5081':'ADL',
  '5082':'ADL',
  '5083':'ADL',
  '5084':'ADL',
  '5085':'ADL',
  '5086':'ADL',
  '5087':'ADL',
  '5088':'ADL',
  '5089':'ADL',
  '5090':'ADL',
  '5091':'ADL',
  '5092':'ADL',
  '5093':'ADL',
  '5094':'ADL',
  '5095':'ADL',
  '5096':'ADL',
  '5097':'ADL',
  '5098':'ADL',
  '5106':'ADL',
  '5107':'ADL',
  '5108':'ADL',
  '5109':'ADL',
  '5110':'ADL',
  '5111':'ADL',
  '5112':'ADL',
  '5113':'ADL',
  '5114':'ADL',
  '5115':'ADL',
  '5116':'ADL',
  '5117':'ADL',
  '5118':'ADL',
  '5120':'ADL',
  '5121':'ADL',
  '5125':'ADL',
  '5126':'ADL',
  '5127':'ADL',
  '5131':'ADL',
  '5132':'ADL',
  '5133':'ADL',
  '5134':'ADL',
  '5136':'ADL',
  '5137':'ADL',
  '5138':'ADL',
  '5139':'ADL',
  '5140':'ADL',
  '5141':'ADL',
  '5142':'ADL',
  '5144':'ADL',
  '5150':'ADL',
  '5151':'ADL',
  '5152':'ADL',
  '5153':'ADL',
  '5154':'ADL',
  '5155':'ADL',
  '5156':'ADL',
  '5157':'ADL',
  '5158':'ADL',
  '5159':'ADL',
  '5160':'ADL',
  '5161':'ADL',
  '5162':'ADL',
  '5163':'ADL',
  '5164':'ADL',
  '5165':'ADL',
  '5166':'ADL',
  '5167':'ADL',
  '5168':'ADL',
  '5169':'ADL',
  '5170':'ADL',
  '5171':'ADL',
  '5172':'ADL',
  '5173':'ADL',
  '5174':'ADL',
  '5201':'ADL',
  '5202':'ADL',
  '5203':'ADL',
  '5204':'ADL',
  '5210':'ADL',
  '5211':'ADL',
  '5212':'ADL',
  '5213':'ADL',
  '5214':'ADL',
  '5220':'ADL',
  '5221':'ADL',
  '5222':'ADL',
  '5223':'ADL',
  '5231':'ADL',
  '5232':'ADL',
  '5233':'ADL',
  '5234':'ADL',
  '5235':'ADL',
  '5236':'ADL',
  '5237':'ADL',
  '5238':'ADL',
  '5240':'ADL',
  '5241':'ADL',
  '5242':'ADL',
  '5243':'ADL',
  '5244':'ADL',
  '5245':'ADL',
  '5250':'ADL',
  '5251':'ADL',
  '5252':'ADL',
  '5253':'ADL',
  '5254':'ADL',
  '5255':'ADL',
  '5256':'ADL',
  '5259':'ADL',
  '5260':'ADL',
  '5261':'ADL',
  '5262':'ADL',
  '5263':'ADL',
  '5264':'ADL',
  '5265':'ADL',
  '5266':'ADL',
  '5267':'ADL',
  '5268':'ADL',
  '5269':'ADL',
  '5270':'ADL',
  '5271':'ADL',
  '5272':'ADL',
  '5273':'ADL',
  '5275':'ADL',
  '5276':'ADL',
  '5277':'ADL',
  '5278':'ADL',
  '5279':'ADL',
  '5280':'ADL',
  '5290':'ADL',
  '5291':'ADL',
  '5301':'ADL',
  '5302':'ADL',
  '5303':'ADL',
  '5304':'ADL',
  '5306':'ADL',
  '5307':'ADL',
  '5308':'ADL',
  '5309':'ADL',
  '5310':'ADL',
  '5311':'ADL',
  '5320':'ADL',
  '5321':'ADL',
  '5322':'ADL',
  '5330':'ADL',
  '5331':'ADL',
  '5332':'ADL',
  '5333':'ADL',
  '5340':'ADL',
  '5341':'ADL',
  '5342':'ADL',
  '5343':'ADL',
  '5344':'ADL',
  '5345':'ADL',
  '5346':'ADL',
  '5350':'ADL',
  '5351':'ADL',
  '5352':'ADL',
  '5353':'ADL',
  '5354':'ADL',
  '5355':'ADL',
  '5356':'ADL',
  '5357':'ADL',
  '5360':'ADL',
  '5371':'ADL',
  '5372':'ADL',
  '5373':'ADL',
  '5374':'ADL',
  '5381':'ADL',
  '5400':'ADL',
  '5401':'ADL',
  '5410':'ADL',
  '5411':'ADL',
  '5412':'ADL',
  '5413':'ADL',
  '5414':'ADL',
  '5415':'ADL',
  '5416':'ADL',
  '5417':'ADL',
  '5418':'ADL',
  '5419':'ADL',
  '5420':'ADL',
  '5421':'ADL',
  '5422':'ADL',
  '5431':'ADL',
  '5432':'ADL',
  '5433':'ADL',
  '5434':'ADL',
  '5440':'ADL',
  '5451':'ADL',
  '5452':'ADL',
  '5453':'ADL',
  '5454':'ADL',
  '5455':'ADL',
  '5460':'ADL',
  '5461':'ADL',
  '5462':'ADL',
  '5464':'ADL',
  '5470':'ADL',
  '5471':'ADL',
  '5472':'ADL',
  '5473':'ADL',
  '5480':'ADL',
  '5481':'ADL',
  '5482':'ADL',
  '5483':'ADL',
  '5485':'ADL',
  '5490':'ADL',
  '5491':'ADL',
  '5493':'ADL',
  '5495':'ADL',
  '5501':'ADL',
  '5502':'ADL',
  '5510':'ADL',
  '5520':'ADL',
  '5521':'ADL',
  '5522':'ADL',
  '5523':'ADL',
  '5540':'ADL',
  '5550':'ADL',
  '5552':'ADL',
  '5554':'ADL',
  '5555':'ADL',
  '5556':'ADL',
  '5558':'ADL',
  '5560':'ADL',
  '5570':'ADL',
  '5571':'ADL',
  '5572':'ADL',
  '5573':'ADL',
  '5575':'ADL',
  '5576':'ADL',
  '5577':'ADL',
  '5580':'ADL',
  '5581':'ADL',
  '5582':'ADL',
  '5583':'ADL',
  '5600':'ADL',
  '5601':'ADL',
  '5602':'ADL',
  '5603':'ADL',
  '5604':'ADL',
  '5605':'ADL',
  '5606':'ADL',
  '5607':'ADL',
  '5608':'ADL',
  '5609':'ADL',
  '5611':'ADL',
  '5630':'ADL',
  '5631':'ADL',
  '5632':'ADL',
  '5633':'ADL',
  '5640':'ADL',
  '5641':'ADL',
  '5642':'ADL',
  '5650':'ADL',
  '5651':'ADL',
  '5652':'ADL',
  '5653':'ADL',
  '5654':'ADL',
  '5655':'ADL',
  '5660':'ADL',
  '5661':'ADL',
  '5670':'ADL',
  '5671':'ADL',
  '5680':'ADL',
  '5690':'ADL',
  '5700':'ADL',
  '5701':'ADL',
  '5710':'ADL',
  '5713':'ADL',
  '5715':'ADL',
  '5717':'ADL',
  '5719':'ADL',
  '5720':'ADL',
  '5722':'ADL',
  '5723':'ADL',
  '5724':'ADL',
  '5725':'ADL',
  '5730':'ADL',
  '5731':'ADL',
  '5732':'ADL',
  '5733':'ADL',
  '5734':'ADL',
  '5800':'ADL',
  '5801':'ADL',
  '5810':'ADL',
  '5839':'ADL',
  '5942':'ADL',
  '5950':'ADL',
  '6000':'PER',
  '6001':'PER',
  '6003':'PER',
  '6004':'PER',
  '6005':'PER',
  '6006':'PER',
  '6007':'PER',
  '6008':'PER',
  '6009':'PER',
  '6010':'PER',
  '6011':'PER',
  '6012':'PER',
  '6014':'PER',
  '6015':'PER',
  '6016':'PER',
  '6017':'PER',
  '6018':'PER',
  '6019':'PER',
  '6020':'PER',
  '6021':'PER',
  '6022':'PER',
  '6023':'PER',
  '6024':'PER',
  '6025':'PER',
  '6026':'PER',
  '6027':'PER',
  '6028':'PER',
  '6029':'PER',
  '6030':'PER',
  '6031':'PER',
  '6032':'PER',
  '6033':'PER',
  '6034':'PER',
  '6035':'PER',
  '6036':'PER',
  '6037':'PER',
  '6038':'PER',
  '6041':'PER',
  '6042':'PER',
  '6043':'PER',
  '6044':'PER',
  '6050':'PER',
  '6051':'PER',
  '6052':'PER',
  '6053':'PER',
  '6054':'PER',
  '6055':'PER',
  '6056':'PER',
  '6057':'PER',
  '6058':'PER',
  '6059':'PER',
  '6060':'PER',
  '6061':'PER',
  '6062':'PER',
  '6063':'PER',
  '6064':'PER',
  '6065':'PER',
  '6066':'PER',
  '6067':'PER',
  '6068':'PER',
  '6069':'PER',
  '6070':'PER',
  '6071':'PER',
  '6072':'PER',
  '6073':'PER',
  '6074':'PER',
  '6076':'PER',
  '6077':'PER',
  '6078':'PER',
  '6079':'PER',
  '6081':'PER',
  '6082':'PER',
  '6083':'PER',
  '6084':'PER',
  '6090':'PER',
  '6100':'PER',
  '6101':'PER',
  '6102':'PER',
  '6103':'PER',
  '6104':'PER',
  '6105':'PER',
  '6106':'PER',
  '6107':'PER',
  '6108':'PER',
  '6109':'PER',
  '6110':'PER',
  '6111':'PER',
  '6112':'PER',
  '6121':'PER',
  '6122':'PER',
  '6123':'PER',
  '6124':'PER',
  '6125':'PER',
  '6126':'PER',
  '6147':'PER',
  '6148':'PER',
  '6149':'PER',
  '6150':'PER',
  '6151':'PER',
  '6152':'PER',
  '6153':'PER',
  '6154':'PER',
  '6155':'PER',
  '6156':'PER',
  '6157':'PER',
  '6158':'PER',
  '6159':'PER',
  '6160':'PER',
  '6161':'PER',
  '6162':'PER',
  '6163':'PER',
  '6164':'PER',
  '6165':'PER',
  '6166':'PER',
  '6167':'PER',
  '6168':'PER',
  '6169':'PER',
  '6170':'PER',
  '6171':'PER',
  '6172':'PER',
  '6173':'PER',
  '6174':'PER',
  '6175':'PER',
  '6176':'PER',
  '6180':'PER',
  '6181':'PER',
  '6182':'PER',
  '6207':'PER',
  '6208':'PER',
  '6209':'PER',
  '6210':'PER',
  '6211':'PER',
  '6213':'PER',
  '6214':'PER',
  '6215':'PER',
  '6218':'PER',
  '6219':'PER',
  '6220':'PER',
  '6221':'PER',
  '6223':'PER',
  '6224':'PER',
  '6225':'PER',
  '6226':'PER',
  '6227':'PER',
  '6228':'PER',
  '6229':'PER',
  '6230':'PER',
  '6231':'PER',
  '6232':'PER',
  '6233':'PER',
  '6236':'PER',
  '6237':'PER',
  '6239':'PER',
  '6240':'PER',
  '6243':'PER',
  '6244':'PER',
  '6251':'PER',
  '6252':'PER',
  '6253':'PER',
  '6254':'PER',
  '6255':'PER',
  '6256':'PER',
  '6258':'PER',
  '6260':'PER',
  '6262':'PER',
  '6271':'PER',
  '6275':'PER',
  '6280':'PER',
  '6281':'PER',
  '6282':'PER',
  '6284':'PER',
  '6285':'PER',
  '6286':'PER',
  '6288':'PER',
  '6290':'PER',
  '6302':'PER',
  '6304':'PER',
  '6306':'PER',
  '6308':'PER',
  '6309':'PER',
  '6311':'PER',
  '6312':'PER',
  '6313':'PER',
  '6315':'PER',
  '6316':'PER',
  '6317':'PER',
  '6318':'PER',
  '6320':'PER',
  '6321':'PER',
  '6322':'PER',
  '6323':'PER',
  '6324':'PER',
  '6326':'PER',
  '6327':'PER',
  '6328':'PER',
  '6330':'PER',
  '6331':'PER',
  '6332':'PER',
  '6333':'PER',
  '6335':'PER',
  '6336':'PER',
  '6337':'PER',
  '6338':'PER',
  '6341':'PER',
  '6343':'PER',
  '6346':'PER',
  '6348':'PER',
  '6350':'PER',
  '6351':'PER',
  '6352':'PER',
  '6353':'PER',
  '6355':'PER',
  '6356':'PER',
  '6357':'PER',
  '6358':'PER',
  '6359':'PER',
  '6361':'PER',
  '6363':'PER',
  '6365':'PER',
  '6367':'PER',
  '6368':'PER',
  '6369':'PER',
  '6370':'PER',
  '6372':'PER',
  '6373':'PER',
  '6375':'PER',
  '6383':'PER',
  '6384':'PER',
  '6385':'PER',
  '6386':'PER',
  '6390':'PER',
  '6391':'PER',
  '6392':'PER',
  '6393':'PER',
  '6394':'PER',
  '6395':'PER',
  '6396':'PER',
  '6397':'PER',
  '6398':'PER',
  '6401':'PER',
  '6403':'PER',
  '6405':'PER',
  '6407':'PER',
  '6409':'PER',
  '6410':'PER',
  '6411':'PER',
  '6412':'PER',
  '6413':'PER',
  '6414':'PER',
  '6415':'PER',
  '6418':'PER',
  '6419':'PER',
  '6420':'PER',
  '6421':'PER',
  '6422':'PER',
  '6423':'PER',
  '6424':'PER',
  '6425':'PER',
  '6426':'PER',
  '6427':'PER',
  '6428':'PER',
  '6429':'PER',
  '6430':'PER',
  '6431':'PER',
  '6432':'PER',
  '6433':'PER',
  '6434':'PER',
  '6436':'PER',
  '6437':'PER',
  '6438':'PER',
  '6440':'PER',
  '6442':'PER',
  '6443':'PER',
  '6445':'PER',
  '6446':'PER',
  '6447':'PER',
  '6448':'PER',
  '6450':'PER',
  '6452':'PER',
  '6460':'PER',
  '6461':'PER',
  '6462':'PER',
  '6463':'PER',
  '6465':'PER',
  '6466':'PER',
  '6467':'PER',
  '6468':'PER',
  '6470':'PER',
  '6472':'PER',
  '6473':'PER',
  '6475':'PER',
  '6476':'PER',
  '6477':'PER',
  '6479':'PER',
  '6480':'PER',
  '6484':'PER',
  '6485':'PER',
  '6487':'PER',
  '6488':'PER',
  '6489':'PER',
  '6490':'PER',
  '6501':'PER',
  '6502':'PER',
  '6503':'PER',
  '6504':'PER',
  '6505':'PER',
  '6506':'PER',
  '6507':'PER',
  '6509':'PER',
  '6510':'PER',
  '6511':'PER',
  '6512':'PER',
  '6513':'PER',
  '6514':'PER',
  '6515':'PER',
  '6516':'PER',
  '6517':'PER',
  '6518':'PER',
  '6519':'PER',
  '6521':'PER',
  '6522':'PER',
  '6525':'PER',
  '6528':'PER',
  '6530':'PER',
  '6531':'PER',
  '6532':'PER',
  '6535':'PER',
  '6536':'PER',
  '6537':'PER',
  '6556':'PER',
  '6558':'PER',
  '6560':'PER',
  '6562':'PER',
  '6564':'PER',
  '6566':'PER',
  '6567':'PER',
  '6568':'PER',
  '6569':'PER',
  '6571':'PER',
  '6572':'PER',
  '6574':'PER',
  '6575':'PER',
  '6603':'PER',
  '6605':'PER',
  '6606':'PER',
  '6608':'PER',
  '6609':'PER',
  '6612':'PER',
  '6613':'PER',
  '6614':'PER',
  '6616':'PER',
  '6620':'PER',
  '6623':'PER',
  '6625':'PER',
  '6627':'PER',
  '6628':'PER',
  '6630':'PER',
  '6631':'PER',
  '6632':'PER',
  '6635':'PER',
  '6638':'PER',
  '6639':'PER',
  '6640':'PER',
  '6642':'PER',
  '6646':'PER',
  '6701':'PER',
  '6705':'PER',
  '6707':'PER',
  '6710':'PER',
  '6711':'PER',
  '6712':'PER',
  '6713':'PER',
  '6714':'PER',
  '6716':'PER',
  '6718':'PER',
  '6720':'PER',
  '6721':'PER',
  '6722':'PER',
  '6725':'PER',
  '6726':'PER',
  '6728':'PER',
  '6731':'PER',
  '6733':'PER',
  '6740':'PER',
  '6743':'PER',
  '6751':'PER',
  '6753':'PER',
  '6754':'PER',
  '6758':'PER',
  '6760':'PER',
  '6762':'PER',
  '6765':'PER',
  '6770':'PER',
  '6798':'PER',
  '6799':'PER',
  '6800':'PER',
  '6809':'PER',
  '6827':'PER',
  '6830':'PER',
  '6831':'PER',
  '6837':'PER',
  '6838':'PER',
  '6839':'PER',
  '6840':'PER',
  '6841':'PER',
  '6842':'PER',
  '6843':'PER',
  '6844':'PER',
  '6845':'PER',
  '6846':'PER',
  '6847':'PER',
  '6848':'PER',
  '6849':'PER',
  '6850':'PER',
  '6865':'PER',
  '6872':'PER',
  '6892':'PER',
  '6900':'PER',
  '6901':'PER',
  '6902':'PER',
  '6903':'PER',
  '6904':'PER',
  '6905':'PER',
  '6906':'PER',
  '6907':'PER',
  '6909':'PER',
  '6910':'PER',
  '6911':'PER',
  '6912':'PER',
  '6913':'PER',
  '6914':'PER',
  '6915':'PER',
  '6916':'PER',
  '6917':'PER',
  '6918':'PER',
  '6919':'PER',
  '6920':'PER',
  '6921':'PER',
  '6922':'PER',
  '6923':'PER',
  '6924':'PER',
  '6925':'PER',
  '6926':'PER',
  '6929':'PER',
  '6931':'PER',
  '6932':'PER',
  '6933':'PER',
  '6934':'PER',
  '6935':'PER',
  '6936':'PER',
  '6939':'PER',
  '6941':'PER',
  '6942':'PER',
  '6943':'PER',
  '6944':'PER',
  '6945':'PER',
  '6946':'PER',
  '6947':'PER',
  '6951':'PER',
  '6952':'PER',
  '6953':'PER',
  '6954':'PER',
  '6955':'PER',
  '6956':'PER',
  '6957':'PER',
  '6958':'PER',
  '6959':'PER',
  '6960':'PER',
  '6961':'PER',
  '6963':'PER',
  '6964':'PER',
  '6965':'PER',
  '6966':'PER',
  '6967':'PER',
  '6968':'PER',
  '6969':'PER',
  '6970':'PER',
  '6979':'PER',
  '6981':'PER',
  '6982':'PER',
  '6983':'PER',
  '6984':'PER',
  '6985':'PER',
  '6986':'PER',
  '6987':'PER',
  '6988':'PER',
  '6989':'PER',
  '6990':'PER',
  '6991':'PER',
  '6992':'PER',
  '6997':'PER',
  '7000':'MEL',
  '7001':'MEL',
  '7002':'MEL',
  '7004':'MEL',
  '7005':'MEL',
  '7006':'MEL',
  '7007':'MEL',
  '7008':'MEL',
  '7009':'MEL',
  '7010':'MEL',
  '7011':'MEL',
  '7012':'MEL',
  '7015':'MEL',
  '7016':'MEL',
  '7017':'MEL',
  '7018':'MEL',
  '7019':'MEL',
  '7020':'MEL',
  '7021':'MEL',
  '7022':'MEL',
  '7023':'MEL',
  '7024':'MEL',
  '7025':'MEL',
  '7026':'MEL',
  '7027':'MEL',
  '7030':'MEL',
  '7050':'MEL',
  '7051':'MEL',
  '7052':'MEL',
  '7053':'MEL',
  '7054':'MEL',
  '7055':'MEL',
  '7109':'MEL',
  '7112':'MEL',
  '7113':'MEL',
  '7116':'MEL',
  '7117':'MEL',
  '7119':'MEL',
  '7120':'MEL',
  '7139':'MEL',
  '7140':'MEL',
  '7150':'MEL',
  '7151':'MEL',
  '7155':'MEL',
  '7162':'MEL',
  '7163':'MEL',
  '7170':'MEL',
  '7171':'MEL',
  '7172':'MEL',
  '7173':'MEL',
  '7174':'MEL',
  '7175':'MEL',
  '7176':'MEL',
  '7177':'MEL',
  '7178':'MEL',
  '7179':'MEL',
  '7180':'MEL',
  '7182':'MEL',
  '7183':'MEL',
  '7184':'MEL',
  '7185':'MEL',
  '7186':'MEL',
  '7187':'MEL',
  '7190':'MEL',
  '7209':'MEL',
  '7210':'MEL',
  '7211':'MEL',
  '7212':'MEL',
  '7213':'MEL',
  '7214':'MEL',
  '7215':'MEL',
  '7216':'MEL',
  '7248':'MEL',
  '7249':'MEL',
  '7250':'MEL',
  '7252':'MEL',
  '7253':'MEL',
  '7254':'MEL',
  '7255':'MEL',
  '7256':'MEL',
  '7257':'MEL',
  '7258':'MEL',
  '7259':'MEL',
  '7260':'MEL',
  '7261':'MEL',
  '7262':'MEL',
  '7263':'MEL',
  '7264':'MEL',
  '7265':'MEL',
  '7267':'MEL',
  '7268':'MEL',
  '7270':'MEL',
  '7275':'MEL',
  '7276':'MEL',
  '7277':'MEL',
  '7290':'MEL',
  '7291':'MEL',
  '7292':'MEL',
  '7300':'MEL',
  '7301':'MEL',
  '7302':'MEL',
  '7303':'MEL',
  '7304':'MEL',
  '7305':'MEL',
  '7306':'MEL',
  '7307':'MEL',
  '7310':'MEL',
  '7315':'MEL',
  '7316':'MEL',
  '7320':'MEL',
  '7321':'MEL',
  '7322':'MEL',
  '7325':'MEL',
  '7330':'MEL',
  '7331':'MEL',
  '7466':'MEL',
  '7467':'MEL',
  '7468':'MEL',
  '7469':'MEL',
  '7470':'MEL',
  '800':'BRI',
  '8001':'MEL',
  '8002':'MEL',
  '8003':'MEL',
  '8004':'MEL',
  '8006':'MEL',
  '8007':'MEL',
  '8008':'MEL',
  '8009':'MEL',
  '801':'BRI',
  '8010':'MEL',
  '8011':'MEL',
  '8012':'MEL',
  '803':'BRI',
  '804':'BRI',
  '8045':'MEL',
  '8051':'MEL',
  '8066':'MEL',
  '8069':'MEL',
  '8070':'MEL',
  '8071':'MEL',
  '810':'BRI',
  '8102':'MEL',
  '8107':'MEL',
  '811':'BRI',
  '8111':'MEL',
  '812':'BRI',
  '8120':'MEL',
  '813':'BRI',
  '814':'BRI',
  '815':'BRI',
  '820':'BRI',
  '8205':'MEL',
  '821':'BRI',
  '822':'BRI',
  '828':'BRI',
  '829':'BRI',
  '830':'BRI',
  '831':'BRI',
  '832':'BRI',
  '834':'BRI',
  '835':'BRI',
  '836':'BRI',
  '837':'BRI',
  '838':'BRI',
  '8383':'MEL',
  '839':'BRI',
  '840':'BRI',
  '841':'BRI',
  '8438':'MEL',
  '845':'BRI',
  '846':'BRI',
  '847':'BRI',
  '850':'BRI',
  '851':'BRI',
  '8511':'MEL',
  '852':'BRI',
  '853':'BRI',
  '854':'BRI',
  '860':'BRI',
  '861':'BRI',
  '862':'BRI',
  '870':'BRI',
  '871':'BRI',
  '872':'ADL',
  '873':'BRI',
  '874':'BRI',
  '875':'BRI',
  '8785':'MEL',
  '880':'BRI',
  '881':'BRI',
  '885':'BRI',
  '886':'BRI',
  '9000':'BRI',
  '9001':'BRI',
  '9002':'BRI',
  '9005':'BRI',
  '9007':'BRI',
  '9009':'BRI',
  '9010':'BRI',
  '9013':'BRI',
  '9015':'BRI',
  '906':'BRI',
  '907':'BRI',
  '909':'BRI',
  '9464':'BRI',
  '9600':'BRI',
  '9726':'BRI',
  '9999':'BRI',
};

var FW_PC_INJ={
  '1021':'BRI',
  '1022':'BRI',
  '1100':'BRI',
  '1215':'BRI',
  '1220':'BRI',
  '1225':'BRI',
  '1230':'BRI',
  '1231':'BRI',
  '1235':'BRI',
  '1239':'BRI',
  '1240':'BRI',
  '1291':'BRI',
  '1300':'BRI',
  '1335':'BRI',
  '1340':'BRI',
  '1350':'BRI',
  '1355':'BRI',
  '1360':'BRI',
  '1405':'BRI',
  '1435':'BRI',
  '1445':'BRI',
  '1450':'BRI',
  '1455':'BRI',
  '1460':'BRI',
  '1465':'BRI',
  '1466':'BRI',
  '1470':'BRI',
  '1475':'BRI',
  '1480':'BRI',
  '1481':'BRI',
  '1485':'BRI',
  '1490':'BRI',
  '1495':'BRI',
  '1499':'BRI',
  '1515':'BRI',
  '1560':'BRI',
  '1565':'BRI',
  '1570':'BRI',
  '1585':'BRI',
  '1590':'BRI',
  '1595':'BRI',
  '1602':'BRI',
  '1630':'BRI',
  '1635':'BRI',
  '1640':'BRI',
  '1655':'BRI',
  '1660':'BRI',
  '1670':'BRI',
  '1675':'BRI',
  '1680':'BRI',
  '1685':'BRI',
  '1700':'BRI',
  '1710':'BRI',
  '1715':'BRI',
  '1730':'BRI',
  '1750':'BRI',
  '1755':'BRI',
  '1765':'BRI',
  '1781':'BRI',
  '1790':'BRI',
  '1800':'BRI',
  '1805':'BRI',
  '1811':'BRI',
  '1825':'BRI',
  '1835':'BRI',
  '1851':'BRI',
  '1860':'BRI',
  '1871':'BRI',
  '1874':'BRI',
  '1875':'BRI',
  '1885':'BRI',
  '1890':'BRI',
  '1891':'BRI',
  '200':'CBR',
  '2000':'SYD',
  '2001':'SYD',
  '2002':'SYD',
  '2004':'SYD',
  '2006':'SYD',
  '2007':'SYD',
  '2008':'SYD',
  '2009':'SYD',
  '2010':'SYD',
  '2011':'SYD',
  '2012':'SYD',
  '2015':'SYD',
  '2016':'SYD',
  '2017':'SYD',
  '2018':'SYD',
  '2019':'SYD',
  '2020':'SYD',
  '2021':'SYD',
  '2022':'SYD',
  '2023':'SYD',
  '2024':'SYD',
  '2025':'SYD',
  '2026':'SYD',
  '2027':'SYD',
  '2028':'SYD',
  '2029':'SYD',
  '2030':'SYD',
  '2031':'SYD',
  '2032':'SYD',
  '2033':'SYD',
  '2034':'SYD',
  '2035':'SYD',
  '2036':'SYD',
  '2037':'SYD',
  '2038':'SYD',
  '2039':'SYD',
  '2040':'SYD',
  '2041':'SYD',
  '2042':'SYD',
  '2043':'SYD',
  '2044':'SYD',
  '2045':'SYD',
  '2046':'SYD',
  '2047':'SYD',
  '2048':'SYD',
  '2049':'SYD',
  '2050':'SYD',
  '2052':'SYD',
  '2055':'SYD',
  '2057':'SYD',
  '2059':'SYD',
  '2060':'SYD',
  '2061':'SYD',
  '2062':'SYD',
  '2063':'SYD',
  '2064':'SYD',
  '2065':'SYD',
  '2066':'SYD',
  '2067':'SYD',
  '2068':'SYD',
  '2069':'SYD',
  '2070':'SYD',
  '2071':'SYD',
  '2072':'SYD',
  '2073':'SYD',
  '2074':'SYD',
  '2075':'SYD',
  '2076':'SYD',
  '2077':'SYD',
  '2079':'SYD',
  '2080':'SYD',
  '2081':'MEL',
  '2082':'SYD',
  '2083':'MEL',
  '2084':'SYD',
  '2085':'SYD',
  '2086':'SYD',
  '2087':'SYD',
  '2088':'SYD',
  '2089':'SYD',
  '2090':'SYD',
  '2091':'SYD',
  '2092':'SYD',
  '2093':'SYD',
  '2094':'SYD',
  '2095':'SYD',
  '2096':'SYD',
  '2097':'SYD',
  '2099':'SYD',
  '2100':'SYD',
  '2101':'SYD',
  '2102':'SYD',
  '2103':'SYD',
  '2104':'SYD',
  '2105':'BRI',
  '2106':'SYD',
  '2107':'SYD',
  '2108':'SYD',
  '2109':'SYD',
  '2110':'SYD',
  '2111':'SYD',
  '2112':'SYD',
  '2113':'SYD',
  '2114':'SYD',
  '2115':'SYD',
  '2116':'SYD',
  '2117':'SYD',
  '2118':'SYD',
  '2119':'SYD',
  '2120':'SYD',
  '2121':'SYD',
  '2122':'SYD',
  '2123':'SYD',
  '2124':'SYD',
  '2125':'SYD',
  '2126':'SYD',
  '2127':'SYD',
  '2128':'SYD',
  '2129':'SYD',
  '2130':'SYD',
  '2131':'SYD',
  '2132':'SYD',
  '2133':'SYD',
  '2134':'SYD',
  '2135':'SYD',
  '2136':'SYD',
  '2137':'SYD',
  '2138':'SYD',
  '2139':'SYD',
  '2140':'SYD',
  '2141':'SYD',
  '2142':'SYD',
  '2143':'SYD',
  '2144':'SYD',
  '2145':'SYD',
  '2146':'SYD',
  '2147':'SYD',
  '2148':'SYD',
  '2150':'SYD',
  '2151':'SYD',
  '2152':'SYD',
  '2153':'SYD',
  '2154':'SYD',
  '2155':'SYD',
  '2156':'SYD',
  '2157':'SYD',
  '2158':'SYD',
  '2159':'SYD',
  '2160':'SYD',
  '2161':'SYD',
  '2162':'SYD',
  '2163':'SYD',
  '2164':'SYD',
  '2165':'SYD',
  '2166':'SYD',
  '2167':'SYD',
  '2168':'SYD',
  '2170':'SYD',
  '2171':'SYD',
  '2172':'SYD',
  '2173':'SYD',
  '2174':'SYD',
  '2175':'SYD',
  '2176':'SYD',
  '2177':'SYD',
  '2178':'SYD',
  '2179':'SYD',
  '2190':'SYD',
  '2191':'SYD',
  '2192':'SYD',
  '2193':'SYD',
  '2194':'SYD',
  '2195':'SYD',
  '2196':'SYD',
  '2197':'SYD',
  '2198':'SYD',
  '2199':'SYD',
  '2200':'SYD',
  '2203':'SYD',
  '2204':'SYD',
  '2205':'SYD',
  '2206':'SYD',
  '2207':'SYD',
  '2208':'SYD',
  '2209':'SYD',
  '2210':'SYD',
  '2211':'SYD',
  '2212':'SYD',
  '2213':'SYD',
  '2214':'SYD',
  '2216':'BRI',
  '2217':'SYD',
  '2218':'SYD',
  '2219':'SYD',
  '2220':'SYD',
  '2221':'SYD',
  '2222':'SYD',
  '2223':'SYD',
  '2224':'SYD',
  '2225':'SYD',
  '2226':'SYD',
  '2227':'SYD',
  '2228':'SYD',
  '2229':'SYD',
  '2230':'SYD',
  '2231':'SYD',
  '2232':'SYD',
  '2233':'SYD',
  '2234':'SYD',
  '2250':'SYD',
  '2251':'SYD',
  '2252':'SYD',
  '2256':'SYD',
  '2257':'SYD',
  '2258':'SYD',
  '2259':'SYD',
  '2260':'SYD',
  '2261':'SYD',
  '2262':'SYD',
  '2263':'SYD',
  '2264':'SYD',
  '2265':'CBR',
  '2267':'SYD',
  '2278':'SYD',
  '2280':'SYD',
  '2281':'SYD',
  '2282':'SYD',
  '2283':'SYD',
  '2284':'SYD',
  '2285':'SYD',
  '2286':'SYD',
  '2287':'SYD',
  '2289':'SYD',
  '2290':'SYD',
  '2291':'SYD',
  '2292':'SYD',
  '2293':'SYD',
  '2294':'SYD',
  '2295':'SYD',
  '2296':'SYD',
  '2297':'SYD',
  '2298':'SYD',
  '2299':'SYD',
  '2300':'SYD',
  '2302':'SYD',
  '2303':'SYD',
  '2304':'SYD',
  '2305':'SYD',
  '2306':'SYD',
  '2307':'SYD',
  '2308':'SYD',
  '2309':'SYD',
  '2310':'SYD',
  '2311':'BRI',
  '2312':'SYD',
  '2314':'SYD',
  '2315':'SYD',
  '2316':'SYD',
  '2317':'SYD',
  '2318':'SYD',
  '2319':'SYD',
  '2320':'SYD',
  '2321':'CBR',
  '2322':'SYD',
  '2323':'SYD',
  '2324':'CBR',
  '2325':'CBR',
  '2326':'SYD',
  '2327':'SYD',
  '2328':'CBR',
  '2329':'CBR',
  '2330':'CBR',
  '2331':'CBR',
  '2333':'CBR',
  '2334':'SYD',
  '2335':'CBR',
  '2336':'CBR',
  '2337':'CBR',
  '2338':'CBR',
  '2339':'CBR',
  '2340':'SYD',
  '2341':'CBR',
  '2342':'SYD',
  '2343':'SYD',
  '2344':'SYD',
  '2345':'SYD',
  '2346':'SYD',
  '2347':'SYD',
  '2348':'SYD',
  '2350':'SYD',
  '2351':'SYD',
  '2352':'SYD',
  '2353':'SYD',
  '2354':'SYD',
  '2355':'SYD',
  '2356':'SYD',
  '2357':'SYD',
  '2358':'SYD',
  '2359':'SYD',
  '2360':'SYD',
  '2361':'SYD',
  '2365':'SYD',
  '2369':'SYD',
  '2370':'SYD',
  '2371':'SYD',
  '2372':'SYD',
  '2379':'BRI',
  '2380':'SYD',
  '2381':'SYD',
  '2382':'SYD',
  '2386':'SYD',
  '2387':'SYD',
  '2388':'SYD',
  '2390':'SYD',
  '2395':'SYD',
  '2396':'SYD',
  '2397':'SYD',
  '2398':'SYD',
  '2399':'SYD',
  '2400':'SYD',
  '2401':'SYD',
  '2402':'SYD',
  '2403':'SYD',
  '2404':'CBR',
  '2405':'SYD',
  '2406':'SYD',
  '2408':'SYD',
  '2409':'SYD',
  '2410':'SYD',
  '2411':'SYD',
  '2415':'SYD',
  '2420':'SYD',
  '2421':'SYD',
  '2422':'SYD',
  '2423':'SYD',
  '2424':'SYD',
  '2425':'SYD',
  '2426':'SYD',
  '2427':'SYD',
  '2428':'SYD',
  '2429':'SYD',
  '2430':'SYD',
  '2431':'SYD',
  '2439':'SYD',
  '2440':'SYD',
  '2441':'SYD',
  '2442':'SYD',
  '2443':'SYD',
  '2444':'SYD',
  '2445':'SYD',
  '2446':'SYD',
  '2447':'SYD',
  '2448':'SYD',
  '2449':'SYD',
  '2450':'SYD',
  '2452':'SYD',
  '2453':'SYD',
  '2454':'SYD',
  '2455':'SYD',
  '2456':'SYD',
  '2460':'SYD',
  '2462':'SYD',
  '2463':'SYD',
  '2464':'BRI',
  '2465':'SYD',
  '2466':'SYD',
  '2469':'MEL',
  '2470':'MEL',
  '2471':'MEL',
  '2472':'MEL',
  '2473':'MEL',
  '2474':'MEL',
  '2475':'MEL',
  '2476':'MEL',
  '2477':'SYD',
  '2478':'SYD',
  '2479':'MEL',
  '2480':'MEL',
  '2481':'MEL',
  '2482':'MEL',
  '2483':'MEL',
  '2484':'SYD',
  '2485':'BRI',
  '2486':'SYD',
  '2487':'SYD',
  '2488':'SYD',
  '2489':'BRI',
  '2490':'BRI',
  '2500':'SYD',
  '2502':'SYD',
  '2505':'SYD',
  '2506':'SYD',
  '2508':'BRI',
  '2515':'SYD',
  '2516':'SYD',
  '2517':'SYD',
  '2518':'SYD',
  '2519':'SYD',
  '2520':'SYD',
  '2522':'SYD',
  '2525':'SYD',
  '2526':'SYD',
  '2527':'SYD',
  '2528':'SYD',
  '2529':'SYD',
  '2530':'SYD',
  '2533':'SYD',
  '2534':'SYD',
  '2535':'SYD',
  '2536':'SYD',
  '2537':'MEL',
  '2538':'SYD',
  '2539':'SYD',
  '2540':'SYD',
  '2541':'SYD',
  '2545':'SYD',
  '2546':'SYD',
  '2548':'SYD',
  '2549':'SYD',
  '2550':'MEL',
  '2551':'MEL',
  '2555':'SYD',
  '2556':'SYD',
  '2557':'SYD',
  '2558':'SYD',
  '2559':'SYD',
  '2560':'SYD',
  '2563':'MEL',
  '2564':'SYD',
  '2565':'SYD',
  '2566':'SYD',
  '2567':'SYD',
  '2568':'MEL',
  '2569':'MEL',
  '2570':'MEL',
  '2571':'SYD',
  '2572':'SYD',
  '2573':'SYD',
  '2574':'SYD',
  '2575':'SYD',
  '2576':'MEL',
  '2577':'MEL',
  '2578':'SYD',
  '2579':'MEL',
  '2580':'SYD',
  '2581':'SYD',
  '2582':'MEL',
  '2583':'SYD',
  '2584':'SYD',
  '2585':'SYD',
  '2586':'SYD',
  '2587':'SYD',
  '2588':'SYD',
  '2590':'SYD',
  '2594':'MEL',
  '2600':'CBR',
  '2601':'CBR',
  '2602':'CBR',
  '2603':'CBR',
  '2604':'CBR',
  '2605':'CBR',
  '2606':'CBR',
  '2607':'CBR',
  '2608':'CBR',
  '2609':'CBR',
  '2610':'CBR',
  '2611':'CBR',
  '2612':'CBR',
  '2614':'CBR',
  '2615':'MEL',
  '2616':'CBR',
  '2617':'CBR',
  '2618':'CBR',
  '2619':'CBR',
  '2620':'SYD',
  '2621':'SYD',
  '2622':'SYD',
  '2623':'SYD',
  '2624':'CBR',
  '2625':'CBR',
  '2626':'SYD',
  '2627':'SYD',
  '2628':'SYD',
  '2629':'SYD',
  '2630':'SYD',
  '2631':'SYD',
  '2632':'SYD',
  '2633':'SYD',
  '2640':'SYD',
  '2641':'MEL',
  '2642':'SYD',
  '2643':'MEL',
  '2644':'SYD',
  '2645':'SYD',
  '2646':'SYD',
  '2647':'MEL',
  '2648':'ADL',
  '2649':'SYD',
  '2650':'SYD',
  '2651':'MEL',
  '2652':'SYD',
  '2653':'SYD',
  '2655':'SYD',
  '2656':'SYD',
  '2658':'SYD',
  '2659':'SYD',
  '2660':'SYD',
  '2661':'SYD',
  '2663':'SYD',
  '2665':'SYD',
  '2666':'SYD',
  '2668':'SYD',
  '2669':'ADL',
  '2671':'SYD',
  '2672':'SYD',
  '2675':'SYD',
  '2678':'SYD',
  '2680':'MEL',
  '2681':'MEL',
  '2700':'SYD',
  '2701':'SYD',
  '2702':'SYD',
  '2703':'SYD',
  '2705':'SYD',
  '2706':'SYD',
  '2707':'SYD',
  '2708':'MEL',
  '2710':'ADL',
  '2711':'ADL',
  '2712':'ADL',
  '2713':'SYD',
  '2714':'SYD',
  '2715':'BRI',
  '2716':'ADL',
  '2717':'ADL',
  '2720':'SYD',
  '2721':'SYD',
  '2722':'SYD',
  '2725':'SYD',
  '2726':'SYD',
  '2727':'SYD',
  '2729':'SYD',
  '2730':'SYD',
  '2731':'SYD',
  '2732':'ADL',
  '2733':'ADL',
  '2734':'ADL',
  '2735':'SYD',
  '2736':'SYD',
  '2737':'SYD',
  '2738':'SYD',
  '2739':'ADL',
  '2745':'SYD',
  '2747':'SYD',
  '2748':'SYD',
  '2749':'SYD',
  '2750':'SYD',
  '2751':'SYD',
  '2752':'SYD',
  '2753':'SYD',
  '2754':'SYD',
  '2756':'SYD',
  '2757':'SYD',
  '2758':'SYD',
  '2759':'SYD',
  '2760':'SYD',
  '2761':'SYD',
  '2762':'SYD',
  '2763':'SYD',
  '2765':'SYD',
  '2766':'SYD',
  '2767':'SYD',
  '2768':'SYD',
  '2769':'SYD',
  '2770':'SYD',
  '2773':'SYD',
  '2774':'SYD',
  '2775':'SYD',
  '2776':'SYD',
  '2777':'SYD',
  '2778':'SYD',
  '2779':'SYD',
  '2780':'SYD',
  '2782':'SYD',
  '2783':'SYD',
  '2784':'SYD',
  '2785':'SYD',
  '2786':'SYD',
  '2787':'SYD',
  '2790':'SYD',
  '2791':'SYD',
  '2792':'SYD',
  '2793':'SYD',
  '2794':'SYD',
  '2795':'SYD',
  '2797':'SYD',
  '2798':'SYD',
  '2799':'SYD',
  '2800':'SYD',
  '2803':'SYD',
  '2804':'SYD',
  '2805':'SYD',
  '2806':'SYD',
  '2807':'SYD',
  '2808':'SYD',
  '2809':'SYD',
  '2810':'SYD',
  '2817':'SYD',
  '2818':'SYD',
  '2820':'SYD',
  '2821':'SYD',
  '2822':'SYD',
  '2823':'SYD',
  '2824':'SYD',
  '2825':'SYD',
  '2826':'SYD',
  '2827':'SYD',
  '2828':'SYD',
  '2829':'SYD',
  '2830':'SYD',
  '2831':'SYD',
  '2832':'SYD',
  '2833':'SYD',
  '2834':'SYD',
  '2835':'SYD',
  '2836':'SYD',
  '2838':'SYD',
  '2839':'SYD',
  '2840':'SYD',
  '2842':'SYD',
  '2843':'SYD',
  '2844':'SYD',
  '2845':'SYD',
  '2846':'SYD',
  '2847':'SYD',
  '2848':'SYD',
  '2849':'SYD',
  '2850':'SYD',
  '2852':'SYD',
  '2864':'SYD',
  '2865':'SYD',
  '2866':'SYD',
  '2867':'SYD',
  '2868':'SYD',
  '2869':'SYD',
  '2870':'SYD',
  '2871':'SYD',
  '2873':'SYD',
  '2874':'SYD',
  '2875':'SYD',
  '2876':'SYD',
  '2877':'SYD',
  '2878':'ADL',
  '2879':'ADL',
  '2880':'ADL',
  '2890':'ADL',
  '2891':'ADL',
  '2898':'ADL',
  '2899':'ADL',
  '2900':'CBR',
  '2901':'CBR',
  '2902':'CBR',
  '2903':'CBR',
  '2904':'CBR',
  '2905':'CBR',
  '2906':'CBR',
  '2911':'CBR',
  '2912':'CBR',
  '2913':'CBR',
  '2914':'CBR',
  '3000':'MEL',
  '3001':'MEL',
  '3002':'MEL',
  '3003':'MEL',
  '3004':'ADL',
  '3006':'MEL',
  '3008':'MEL',
  '3010':'MEL',
  '3011':'MEL',
  '3012':'MEL',
  '3013':'MEL',
  '3015':'MEL',
  '3016':'MEL',
  '3018':'MEL',
  '3019':'MEL',
  '3020':'MEL',
  '3021':'MEL',
  '3022':'MEL',
  '3023':'MEL',
  '3024':'MEL',
  '3025':'MEL',
  '3026':'MEL',
  '3027':'MEL',
  '3028':'MEL',
  '3029':'MEL',
  '3030':'MEL',
  '3031':'MEL',
  '3032':'MEL',
  '3033':'MEL',
  '3034':'MEL',
  '3036':'MEL',
  '3037':'MEL',
  '3038':'BRI',
  '3039':'MEL',
  '3040':'MEL',
  '3041':'MEL',
  '3042':'BRI',
  '3043':'MEL',
  '3044':'MEL',
  '3045':'MEL',
  '3046':'MEL',
  '3047':'MEL',
  '3048':'MEL',
  '3049':'MEL',
  '3050':'MEL',
  '3051':'MEL',
  '3052':'MEL',
  '3053':'MEL',
  '3054':'MEL',
  '3055':'MEL',
  '3056':'MEL',
  '3057':'BRI',
  '3058':'MEL',
  '3059':'MEL',
  '3060':'MEL',
  '3061':'MEL',
  '3062':'MEL',
  '3063':'BRI',
  '3064':'MEL',
  '3065':'MEL',
  '3066':'MEL',
  '3067':'MEL',
  '3068':'MEL',
  '3070':'MEL',
  '3071':'MEL',
  '3072':'BRI',
  '3073':'MEL',
  '3074':'MEL',
  '3075':'MEL',
  '3076':'MEL',
  '3078':'MEL',
  '3079':'MEL',
  '3081':'MEL',
  '3082':'MEL',
  '3083':'MEL',
  '3084':'MEL',
  '3085':'MEL',
  '3086':'MEL',
  '3087':'MEL',
  '3088':'MEL',
  '3089':'BRI',
  '3090':'BRI',
  '3091':'BRI',
  '3093':'MEL',
  '3094':'MEL',
  '3095':'MEL',
  '3096':'BRI',
  '3097':'BRI',
  '3099':'BRI',
  '3101':'MEL',
  '3102':'MEL',
  '3103':'BRI',
  '3104':'MEL',
  '3105':'MEL',
  '3106':'MEL',
  '3107':'MEL',
  '3108':'MEL',
  '3109':'MEL',
  '3111':'MEL',
  '3113':'BRI',
  '3114':'BRI',
  '3115':'BRI',
  '3116':'MEL',
  '3121':'MEL',
  '3122':'MEL',
  '3123':'MEL',
  '3124':'MEL',
  '3125':'MEL',
  '3126':'MEL',
  '3127':'MEL',
  '3128':'BRI',
  '3129':'MEL',
  '3130':'MEL',
  '3131':'MEL',
  '3132':'BRI',
  '3133':'MEL',
  '3134':'MEL',
  '3135':'MEL',
  '3136':'MEL',
  '3137':'MEL',
  '3138':'MEL',
  '3139':'BRI',
  '3140':'MEL',
  '3141':'MEL',
  '3142':'MEL',
  '3143':'MEL',
  '3144':'MEL',
  '3145':'BRI',
  '3146':'BRI',
  '3147':'MEL',
  '3148':'BRI',
  '3149':'BRI',
  '3150':'MEL',
  '3151':'MEL',
  '3152':'MEL',
  '3153':'MEL',
  '3154':'MEL',
  '3155':'MEL',
  '3156':'BRI',
  '3158':'BRI',
  '3159':'BRI',
  '3160':'BRI',
  '3161':'MEL',
  '3162':'BRI',
  '3163':'MEL',
  '3164':'MEL',
  '3165':'MEL',
  '3166':'MEL',
  '3167':'MEL',
  '3168':'MEL',
  '3169':'MEL',
  '3170':'BRI',
  '3171':'MEL',
  '3172':'MEL',
  '3173':'MEL',
  '3174':'MEL',
  '3175':'BRI',
  '3176':'MEL',
  '3177':'MEL',
  '3178':'MEL',
  '3179':'MEL',
  '3180':'MEL',
  '3181':'MEL',
  '3182':'MEL',
  '3183':'MEL',
  '3184':'MEL',
  '3185':'MEL',
  '3186':'BRI',
  '3187':'MEL',
  '3188':'MEL',
  '3189':'BRI',
  '3190':'MEL',
  '3191':'MEL',
  '3192':'MEL',
  '3193':'BRI',
  '3194':'MEL',
  '3195':'MEL',
  '3196':'MEL',
  '3197':'MEL',
  '3198':'MEL',
  '3199':'BRI',
  '3200':'BRI',
  '3201':'MEL',
  '3202':'MEL',
  '3204':'BRI',
  '3205':'MEL',
  '3206':'MEL',
  '3207':'MEL',
  '3211':'BRI',
  '3212':'BRI',
  '3213':'BRI',
  '3214':'MEL',
  '3215':'MEL',
  '3216':'MEL',
  '3217':'MEL',
  '3218':'BRI',
  '3219':'MEL',
  '3220':'MEL',
  '3221':'BRI',
  '3222':'MEL',
  '3223':'MEL',
  '3224':'MEL',
  '3225':'BRI',
  '3226':'MEL',
  '3227':'MEL',
  '3228':'MEL',
  '3230':'MEL',
  '3231':'BRI',
  '3232':'BRI',
  '3233':'BRI',
  '3234':'BRI',
  '3235':'BRI',
  '3236':'BRI',
  '3237':'BRI',
  '3238':'BRI',
  '3239':'BRI',
  '3240':'BRI',
  '3241':'BRI',
  '3242':'MEL',
  '3243':'BRI',
  '3249':'BRI',
  '3250':'MEL',
  '3251':'BRI',
  '3254':'BRI',
  '3260':'BRI',
  '3264':'BRI',
  '3265':'BRI',
  '3266':'BRI',
  '3267':'BRI',
  '3268':'BRI',
  '3269':'BRI',
  '3270':'BRI',
  '3271':'BRI',
  '3272':'BRI',
  '3273':'BRI',
  '3274':'BRI',
  '3275':'BRI',
  '3276':'BRI',
  '3277':'BRI',
  '3278':'BRI',
  '3279':'BRI',
  '3280':'BRI',
  '3281':'BRI',
  '3282':'BRI',
  '3283':'BRI',
  '3284':'BRI',
  '3285':'BRI',
  '3286':'BRI',
  '3287':'BRI',
  '3289':'BRI',
  '3292':'BRI',
  '3293':'BRI',
  '3294':'BRI',
  '3300':'BRI',
  '3301':'BRI',
  '3302':'BRI',
  '3303':'BRI',
  '3304':'BRI',
  '3305':'BRI',
  '3309':'BRI',
  '3310':'BRI',
  '3311':'BRI',
  '3312':'BRI',
  '3314':'BRI',
  '3315':'BRI',
  '3317':'MEL',
  '3318':'MEL',
  '3319':'MEL',
  '3321':'MEL',
  '3322':'MEL',
  '3323':'MEL',
  '3324':'MEL',
  '3325':'MEL',
  '3328':'MEL',
  '3329':'MEL',
  '3330':'MEL',
  '3331':'MEL',
  '3332':'MEL',
  '3333':'MEL',
  '3334':'MEL',
  '3335':'MEL',
  '3336':'MEL',
  '3337':'MEL',
  '3338':'MEL',
  '3340':'MEL',
  '3341':'MEL',
  '3342':'MEL',
  '3345':'MEL',
  '3350':'MEL',
  '3351':'MEL',
  '3352':'MEL',
  '3353':'MEL',
  '3354':'MEL',
  '3355':'MEL',
  '3356':'MEL',
  '3357':'MEL',
  '3358':'MEL',
  '3360':'MEL',
  '3361':'MEL',
  '3363':'BRI',
  '3364':'MEL',
  '3370':'BRI',
  '3371':'MEL',
  '3373':'MEL',
  '3374':'MEL',
  '3375':'BRI',
  '3377':'BRI',
  '3378':'BRI',
  '3379':'MEL',
  '3380':'MEL',
  '3381':'MEL',
  '3384':'BRI',
  '3385':'BRI',
  '3387':'BRI',
  '3388':'MEL',
  '3390':'MEL',
  '3391':'MEL',
  '3392':'BRI',
  '3393':'BRI',
  '3395':'BRI',
  '3396':'MEL',
  '3400':'BRI',
  '3401':'MEL',
  '3402':'BRI',
  '3407':'BRI',
  '3409':'BRI',
  '3412':'MEL',
  '3413':'MEL',
  '3414':'MEL',
  '3415':'BRI',
  '3418':'MEL',
  '3419':'MEL',
  '3420':'BRI',
  '3423':'MEL',
  '3424':'MEL',
  '3427':'MEL',
  '3428':'BRI',
  '3429':'BRI',
  '3430':'BRI',
  '3431':'MEL',
  '3432':'MEL',
  '3433':'MEL',
  '3434':'BRI',
  '3435':'BRI',
  '3437':'MEL',
  '3438':'MEL',
  '3440':'MEL',
  '3441':'MEL',
  '3442':'MEL',
  '3444':'BRI',
  '3446':'MEL',
  '3447':'MEL',
  '3448':'BRI',
  '3450':'BRI',
  '3451':'BRI',
  '3453':'BRI',
  '3458':'BRI',
  '3460':'MEL',
  '3461':'BRI',
  '3462':'BRI',
  '3463':'BRI',
  '3464':'BRI',
  '3465':'BRI',
  '3467':'BRI',
  '3468':'BRI',
  '3469':'BRI',
  '3472':'BRI',
  '3475':'BRI',
  '3477':'BRI',
  '3478':'MEL',
  '3480':'BRI',
  '3482':'BRI',
  '3483':'BRI',
  '3485':'BRI',
  '3487':'BRI',
  '3488':'BRI',
  '3489':'BRI',
  '3490':'BRI',
  '3491':'BRI',
  '3494':'BRI',
  '3496':'ADL',
  '3498':'ADL',
  '3500':'ADL',
  '3501':'ADL',
  '3502':'ADL',
  '3505':'ADL',
  '3506':'ADL',
  '3507':'ADL',
  '3509':'ADL',
  '3512':'ADL',
  '3515':'ADL',
  '3516':'ADL',
  '3517':'ADL',
  '3518':'ADL',
  '3520':'ADL',
  '3521':'ADL',
  '3522':'ADL',
  '3523':'ADL',
  '3525':'ADL',
  '3527':'ADL',
  '3529':'ADL',
  '3530':'ADL',
  '3531':'ADL',
  '3533':'ADL',
  '3537':'ADL',
  '3540':'ADL',
  '3542':'ADL',
  '3544':'ADL',
  '3546':'ADL',
  '3549':'ADL',
  '3550':'MEL',
  '3551':'MEL',
  '3552':'MEL',
  '3554':'MEL',
  '3555':'MEL',
  '3556':'BRI',
  '3557':'BRI',
  '3558':'BRI',
  '3559':'BRI',
  '3561':'MEL',
  '3562':'MEL',
  '3563':'MEL',
  '3564':'MEL',
  '3565':'MEL',
  '3566':'MEL',
  '3567':'BRI',
  '3568':'BRI',
  '3570':'BRI',
  '3571':'MEL',
  '3572':'MEL',
  '3573':'MEL',
  '3575':'BRI',
  '3576':'BRI',
  '3579':'BRI',
  '3580':'BRI',
  '3581':'BRI',
  '3583':'BRI',
  '3584':'BRI',
  '3585':'BRI',
  '3586':'BRI',
  '3588':'BRI',
  '3589':'BRI',
  '3590':'BRI',
  '3591':'BRI',
  '3594':'BRI',
  '3595':'BRI',
  '3596':'BRI',
  '3597':'BRI',
  '3599':'BRI',
  '3607':'MEL',
  '3608':'MEL',
  '3610':'MEL',
  '3612':'MEL',
  '3614':'MEL',
  '3616':'MEL',
  '3617':'MEL',
  '3618':'MEL',
  '3619':'MEL',
  '3620':'MEL',
  '3621':'MEL',
  '3622':'MEL',
  '3623':'MEL',
  '3624':'MEL',
  '3629':'MEL',
  '3630':'MEL',
  '3631':'MEL',
  '3632':'MEL',
  '3633':'MEL',
  '3634':'MEL',
  '3635':'MEL',
  '3636':'MEL',
  '3637':'MEL',
  '3638':'MEL',
  '3639':'MEL',
  '3640':'MEL',
  '3641':'MEL',
  '3643':'MEL',
  '3644':'MEL',
  '3646':'MEL',
  '3647':'MEL',
  '3649':'MEL',
  '3658':'MEL',
  '3659':'MEL',
  '3660':'MEL',
  '3661':'BRI',
  '3662':'MEL',
  '3663':'MEL',
  '3664':'MEL',
  '3665':'MEL',
  '3666':'MEL',
  '3669':'MEL',
  '3670':'MEL',
  '3671':'MEL',
  '3672':'MEL',
  '3673':'MEL',
  '3675':'MEL',
  '3676':'MEL',
  '3677':'MEL',
  '3678':'MEL',
  '3682':'MEL',
  '3683':'MEL',
  '3685':'MEL',
  '3687':'MEL',
  '3688':'BRI',
  '3689':'MEL',
  '3690':'MEL',
  '3691':'MEL',
  '3694':'MEL',
  '3695':'MEL',
  '3697':'MEL',
  '3698':'MEL',
  '3699':'MEL',
  '3700':'MEL',
  '3701':'BRI',
  '3704':'BRI',
  '3705':'BRI',
  '3707':'BRI',
  '3708':'BRI',
  '3709':'BRI',
  '3711':'MEL',
  '3712':'MEL',
  '3713':'MEL',
  '3714':'MEL',
  '3715':'MEL',
  '3717':'MEL',
  '3718':'MEL',
  '3719':'MEL',
  '3720':'MEL',
  '3722':'MEL',
  '3723':'MEL',
  '3724':'MEL',
  '3725':'MEL',
  '3726':'MEL',
  '3727':'MEL',
  '3728':'MEL',
  '3730':'MEL',
  '3732':'MEL',
  '3733':'MEL',
  '3735':'MEL',
  '3736':'MEL',
  '3737':'BRI',
  '3738':'MEL',
  '3739':'MEL',
  '3740':'MEL',
  '3741':'BRI',
  '3744':'MEL',
  '3746':'MEL',
  '3747':'MEL',
  '3749':'MEL',
  '3750':'MEL',
  '3751':'MEL',
  '3752':'MEL',
  '3753':'MEL',
  '3754':'BRI',
  '3755':'BRI',
  '3756':'MEL',
  '3757':'BRI',
  '3758':'BRI',
  '3759':'BRI',
  '3760':'BRI',
  '3761':'BRI',
  '3762':'MEL',
  '3763':'BRI',
  '3764':'BRI',
  '3765':'BRI',
  '3766':'BRI',
  '3767':'BRI',
  '3770':'BRI',
  '3775':'BRI',
  '3777':'BRI',
  '3778':'BRI',
  '3779':'BRI',
  '3781':'BRI',
  '3782':'BRI',
  '3783':'BRI',
  '3785':'BRI',
  '3786':'BRI',
  '3787':'BRI',
  '3788':'BRI',
  '3789':'BRI',
  '3791':'BRI',
  '3792':'BRI',
  '3793':'BRI',
  '3795':'BRI',
  '3796':'BRI',
  '3797':'BRI',
  '3799':'BRI',
  '3800':'MEL',
  '3802':'MEL',
  '3803':'MEL',
  '3804':'MEL',
  '3805':'MEL',
  '3806':'BRI',
  '3807':'BRI',
  '3808':'BRI',
  '3809':'BRI',
  '3810':'BRI',
  '3812':'BRI',
  '3813':'BRI',
  '3814':'BRI',
  '3815':'BRI',
  '3816':'BRI',
  '3818':'BRI',
  '3820':'BRI',
  '3821':'BRI',
  '3822':'BRI',
  '3823':'BRI',
  '3824':'BRI',
  '3825':'BRI',
  '3831':'BRI',
  '3832':'BRI',
  '3833':'BRI',
  '3835':'BRI',
  '3840':'BRI',
  '3841':'BRI',
  '3842':'BRI',
  '3844':'BRI',
  '3847':'BRI',
  '3850':'BRI',
  '3851':'BRI',
  '3852':'BRI',
  '3853':'BRI',
  '3854':'BRI',
  '3856':'BRI',
  '3857':'BRI',
  '3858':'BRI',
  '3859':'BRI',
  '3860':'BRI',
  '3862':'BRI',
  '3864':'BRI',
  '3865':'BRI',
  '3869':'BRI',
  '3870':'BRI',
  '3871':'BRI',
  '3873':'BRI',
  '3874':'BRI',
  '3875':'BRI',
  '3878':'BRI',
  '3880':'BRI',
  '3882':'BRI',
  '3885':'BRI',
  '3886':'BRI',
  '3887':'BRI',
  '3888':'BRI',
  '3889':'BRI',
  '3890':'BRI',
  '3891':'BRI',
  '3892':'BRI',
  '3893':'BRI',
  '3895':'BRI',
  '3896':'BRI',
  '3898':'BRI',
  '3900':'BRI',
  '3902':'BRI',
  '3903':'BRI',
  '3904':'BRI',
  '3909':'BRI',
  '3910':'MEL',
  '3911':'MEL',
  '3912':'MEL',
  '3913':'MEL',
  '3915':'MEL',
  '3916':'MEL',
  '3918':'MEL',
  '3919':'MEL',
  '3920':'MEL',
  '3921':'BRI',
  '3922':'BRI',
  '3923':'BRI',
  '3925':'BRI',
  '3926':'MEL',
  '3927':'MEL',
  '3928':'MEL',
  '3929':'MEL',
  '3930':'MEL',
  '3931':'MEL',
  '3933':'MEL',
  '3934':'MEL',
  '3936':'MEL',
  '3937':'MEL',
  '3938':'MEL',
  '3939':'MEL',
  '3940':'MEL',
  '3941':'MEL',
  '3942':'MEL',
  '3943':'MEL',
  '3944':'MEL',
  '3945':'BRI',
  '3946':'BRI',
  '3950':'BRI',
  '3951':'BRI',
  '3953':'BRI',
  '3954':'BRI',
  '3956':'BRI',
  '3957':'BRI',
  '3958':'BRI',
  '3959':'BRI',
  '3960':'BRI',
  '3962':'BRI',
  '3964':'BRI',
  '3965':'BRI',
  '3966':'BRI',
  '3967':'BRI',
  '3971':'BRI',
  '3975':'MEL',
  '3976':'MEL',
  '3977':'MEL',
  '3978':'BRI',
  '3979':'BRI',
  '3980':'BRI',
  '3981':'BRI',
  '3984':'BRI',
  '3987':'BRI',
  '3988':'BRI',
  '3990':'BRI',
  '3991':'BRI',
  '3992':'BRI',
  '3995':'BRI',
  '3996':'BRI',
  '4000':'BRI',
  '4001':'BRI',
  '4002':'BRI',
  '4003':'BRI',
  '4004':'BRI',
  '4005':'BRI',
  '4006':'BRI',
  '4007':'BRI',
  '4008':'BRI',
  '4009':'BRI',
  '4010':'BRI',
  '4011':'BRI',
  '4012':'BRI',
  '4013':'BRI',
  '4014':'BRI',
  '4017':'BRI',
  '4018':'BRI',
  '4019':'BRI',
  '4020':'BRI',
  '4021':'BRI',
  '4022':'BRI',
  '4025':'BRI',
  '4029':'BRI',
  '4030':'BRI',
  '4031':'BRI',
  '4032':'BRI',
  '4034':'BRI',
  '4035':'BRI',
  '4036':'BRI',
  '4037':'BRI',
  '4051':'BRI',
  '4053':'BRI',
  '4054':'BRI',
  '4055':'BRI',
  '4059':'BRI',
  '4060':'BRI',
  '4061':'BRI',
  '4064':'BRI',
  '4065':'BRI',
  '4066':'BRI',
  '4067':'BRI',
  '4068':'BRI',
  '4069':'BRI',
  '4070':'BRI',
  '4072':'BRI',
  '4073':'BRI',
  '4074':'BRI',
  '4075':'BRI',
  '4076':'BRI',
  '4077':'BRI',
  '4078':'BRI',
  '4101':'BRI',
  '4102':'BRI',
  '4103':'BRI',
  '4104':'BRI',
  '4105':'BRI',
  '4106':'BRI',
  '4107':'BRI',
  '4108':'BRI',
  '4109':'BRI',
  '4110':'BRI',
  '4111':'BRI',
  '4112':'BRI',
  '4113':'BRI',
  '4114':'BRI',
  '4115':'BRI',
  '4116':'BRI',
  '4117':'BRI',
  '4118':'BRI',
  '4119':'BRI',
  '4120':'BRI',
  '4121':'BRI',
  '4122':'BRI',
  '4123':'BRI',
  '4124':'BRI',
  '4125':'BRI',
  '4127':'BRI',
  '4128':'BRI',
  '4129':'BRI',
  '4130':'BRI',
  '4131':'BRI',
  '4132':'BRI',
  '4133':'BRI',
  '4151':'BRI',
  '4152':'BRI',
  '4153':'BRI',
  '4154':'BRI',
  '4155':'BRI',
  '4156':'BRI',
  '4157':'BRI',
  '4158':'BRI',
  '4159':'BRI',
  '4160':'BRI',
  '4161':'BRI',
  '4163':'BRI',
  '4164':'BRI',
  '4165':'BRI',
  '4169':'BRI',
  '4170':'BRI',
  '4171':'BRI',
  '4172':'BRI',
  '4173':'BRI',
  '4174':'BRI',
  '4178':'BRI',
  '4179':'BRI',
  '4183':'BRI',
  '4184':'BRI',
  '4205':'BRI',
  '4207':'BRI',
  '4208':'BRI',
  '4209':'BRI',
  '4210':'BRI',
  '4211':'BRI',
  '4212':'BRI',
  '4213':'BRI',
  '4214':'BRI',
  '4215':'BRI',
  '4216':'BRI',
  '4217':'BRI',
  '4218':'BRI',
  '4219':'BRI',
  '4220':'BRI',
  '4221':'BRI',
  '4222':'BRI',
  '4223':'BRI',
  '4224':'BRI',
  '4225':'BRI',
  '4226':'BRI',
  '4227':'BRI',
  '4228':'BRI',
  '4230':'BRI',
  '4270':'BRI',
  '4271':'BRI',
  '4272':'BRI',
  '4275':'BRI',
  '4280':'BRI',
  '4285':'BRI',
  '4287':'BRI',
  '4300':'BRI',
  '4301':'BRI',
  '4303':'BRI',
  '4304':'BRI',
  '4305':'BRI',
  '4306':'BRI',
  '4307':'BRI',
  '4309':'BRI',
  '4310':'BRI',
  '4311':'BRI',
  '4312':'BRI',
  '4313':'BRI',
  '4314':'BRI',
  '4340':'BRI',
  '4341':'BRI',
  '4342':'BRI',
  '4343':'BRI',
  '4344':'BRI',
  '4345':'BRI',
  '4346':'BRI',
  '4347':'BRI',
  '4350':'BRI',
  '4352':'BRI',
  '4353':'BRI',
  '4354':'BRI',
  '4355':'BRI',
  '4356':'BRI',
  '4357':'BRI',
  '4358':'BRI',
  '4359':'BRI',
  '4360':'BRI',
  '4361':'BRI',
  '4362':'BRI',
  '4363':'BRI',
  '4364':'BRI',
  '4365':'BRI',
  '4370':'BRI',
  '4371':'BRI',
  '4372':'BRI',
  '4373':'BRI',
  '4374':'BRI',
  '4375':'BRI',
  '4376':'BRI',
  '4377':'BRI',
  '4378':'BRI',
  '4380':'BRI',
  '4381':'BRI',
  '4382':'BRI',
  '4383':'BRI',
  '4384':'BRI',
  '4385':'BRI',
  '4387':'BRI',
  '4388':'BRI',
  '4390':'BRI',
  '4400':'BRI',
  '4401':'BRI',
  '4402':'BRI',
  '4403':'BRI',
  '4404':'BRI',
  '4405':'BRI',
  '4406':'BRI',
  '4407':'BRI',
  '4408':'BRI',
  '4410':'BRI',
  '4411':'BRI',
  '4412':'BRI',
  '4413':'BRI',
  '4415':'BRI',
  '4416':'BRI',
  '4417':'BRI',
  '4418':'BRI',
  '4419':'BRI',
  '4420':'BRI',
  '4421':'BRI',
  '4422':'BRI',
  '4423':'BRI',
  '4424':'BRI',
  '4425':'BRI',
  '4426':'BRI',
  '4427':'BRI',
  '4428':'BRI',
  '4454':'BRI',
  '4455':'BRI',
  '4461':'BRI',
  '4462':'BRI',
  '4465':'BRI',
  '4467':'BRI',
  '4468':'BRI',
  '4470':'BRI',
  '4471':'BRI',
  '4472':'BRI',
  '4474':'BRI',
  '4475':'BRI',
  '4477':'BRI',
  '4478':'BRI',
  '4479':'BRI',
  '4480':'BRI',
  '4481':'BRI',
  '4482':'BRI',
  '4486':'BRI',
  '4487':'BRI',
  '4488':'BRI',
  '4489':'BRI',
  '4490':'BRI',
  '4491':'BRI',
  '4492':'BRI',
  '4493':'BRI',
  '4494':'BRI',
  '4496':'BRI',
  '4497':'BRI',
  '4498':'BRI',
  '4500':'BRI',
  '4501':'BRI',
  '4502':'BRI',
  '4503':'BRI',
  '4504':'BRI',
  '4505':'BRI',
  '4506':'BRI',
  '4507':'BRI',
  '4508':'BRI',
  '4509':'BRI',
  '4510':'BRI',
  '4511':'BRI',
  '4512':'BRI',
  '4513':'BRI',
  '4514':'BRI',
  '4515':'BRI',
  '4516':'BRI',
  '4517':'BRI',
  '4518':'BRI',
  '4519':'BRI',
  '4520':'BRI',
  '4521':'BRI',
  '4550':'BRI',
  '4551':'BRI',
  '4552':'BRI',
  '4553':'BRI',
  '4554':'BRI',
  '4555':'BRI',
  '4556':'BRI',
  '4557':'BRI',
  '4558':'BRI',
  '4559':'BRI',
  '4560':'BRI',
  '4561':'BRI',
  '4562':'BRI',
  '4563':'BRI',
  '4564':'BRI',
  '4565':'BRI',
  '4566':'BRI',
  '4567':'BRI',
  '4568':'BRI',
  '4569':'BRI',
  '4570':'BRI',
  '4571':'BRI',
  '4572':'BRI',
  '4573':'BRI',
  '4574':'BRI',
  '4575':'BRI',
  '4580':'BRI',
  '4581':'BRI',
  '4600':'BRI',
  '4601':'BRI',
  '4605':'BRI',
  '4606':'BRI',
  '4608':'BRI',
  '4610':'BRI',
  '4611':'BRI',
  '4612':'BRI',
  '4613':'BRI',
  '4614':'BRI',
  '4615':'BRI',
  '4620':'BRI',
  '4621':'BRI',
  '4625':'BRI',
  '4626':'BRI',
  '4627':'BRI',
  '4630':'BRI',
  '4650':'BRI',
  '4655':'BRI',
  '4659':'BRI',
  '4660':'BRI',
  '4662':'BRI',
  '4670':'BRI',
  '4671':'BRI',
  '4673':'BRI',
  '4674':'BRI',
  '4676':'BRI',
  '4677':'BRI',
  '4678':'BRI',
  '4680':'BRI',
  '4694':'BRI',
  '4695':'BRI',
  '4697':'BRI',
  '4699':'BRI',
  '4700':'BRI',
  '4701':'BRI',
  '4702':'BRI',
  '4703':'BRI',
  '4704':'BRI',
  '4705':'BRI',
  '4706':'BRI',
  '4707':'BRI',
  '4709':'BRI',
  '4710':'BRI',
  '4711':'BRI',
  '4712':'BRI',
  '4713':'BRI',
  '4714':'BRI',
  '4715':'BRI',
  '4716':'BRI',
  '4717':'BRI',
  '4718':'BRI',
  '4719':'BRI',
  '4720':'BRI',
  '4721':'BRI',
  '4722':'BRI',
  '4723':'BRI',
  '4724':'BRI',
  '4725':'BRI',
  '4726':'BRI',
  '4727':'BRI',
  '4728':'BRI',
  '4730':'BRI',
  '4731':'BRI',
  '4732':'BRI',
  '4733':'BRI',
  '4735':'BRI',
  '4736':'BRI',
  '4737':'BRI',
  '4738':'BRI',
  '4739':'BRI',
  '4740':'BRI',
  '4741':'BRI',
  '4742':'BRI',
  '4743':'BRI',
  '4744':'BRI',
  '4745':'BRI',
  '4746':'BRI',
  '4750':'BRI',
  '4751':'BRI',
  '4753':'BRI',
  '4754':'BRI',
  '4756':'BRI',
  '4757':'BRI',
  '4798':'BRI',
  '4799':'BRI',
  '4800':'BRI',
  '4802':'BRI',
  '4803':'BRI',
  '4804':'BRI',
  '4805':'BRI',
  '4806':'BRI',
  '4807':'BRI',
  '4808':'BRI',
  '4809':'BRI',
  '4810':'BRI',
  '4811':'BRI',
  '4812':'BRI',
  '4813':'BRI',
  '4814':'BRI',
  '4815':'BRI',
  '4816':'BRI',
  '4817':'BRI',
  '4818':'BRI',
  '4819':'BRI',
  '4820':'BRI',
  '4821':'BRI',
  '4822':'BRI',
  '4823':'BRI',
  '4824':'BRI',
  '4825':'BRI',
  '4828':'BRI',
  '4829':'BRI',
  '4830':'BRI',
  '4849':'BRI',
  '4850':'BRI',
  '4852':'BRI',
  '4854':'BRI',
  '4855':'BRI',
  '4856':'BRI',
  '4857':'BRI',
  '4858':'BRI',
  '4859':'BRI',
  '4860':'BRI',
  '4861':'BRI',
  '4865':'BRI',
  '4868':'BRI',
  '4869':'BRI',
  '4870':'BRI',
  '4871':'BRI',
  '4872':'BRI',
  '4873':'BRI',
  '4874':'BRI',
  '4875':'BRI',
  '4876':'BRI',
  '4877':'BRI',
  '4878':'BRI',
  '4879':'BRI',
  '4880':'BRI',
  '4881':'BRI',
  '4882':'BRI',
  '4883':'BRI',
  '4884':'BRI',
  '4885':'BRI',
  '4886':'BRI',
  '4887':'BRI',
  '4888':'BRI',
  '4890':'BRI',
  '4891':'BRI',
  '4892':'BRI',
  '4895':'BRI',
  '5000':'ADL',
  '5001':'ADL',
  '5005':'ADL',
  '5006':'ADL',
  '5007':'ADL',
  '5008':'ADL',
  '5009':'ADL',
  '5010':'ADL',
  '5011':'ADL',
  '5012':'ADL',
  '5013':'ADL',
  '5014':'ADL',
  '5015':'ADL',
  '5016':'ADL',
  '5017':'ADL',
  '5018':'ADL',
  '5019':'ADL',
  '5020':'ADL',
  '5021':'ADL',
  '5022':'ADL',
  '5023':'ADL',
  '5024':'ADL',
  '5025':'ADL',
  '5031':'ADL',
  '5032':'ADL',
  '5033':'ADL',
  '5034':'ADL',
  '5035':'ADL',
  '5037':'ADL',
  '5038':'ADL',
  '5039':'ADL',
  '5040':'ADL',
  '5041':'ADL',
  '5042':'ADL',
  '5043':'ADL',
  '5044':'ADL',
  '5045':'ADL',
  '5046':'ADL',
  '5047':'ADL',
  '5048':'ADL',
  '5049':'ADL',
  '5050':'ADL',
  '5051':'ADL',
  '5052':'ADL',
  '5061':'ADL',
  '5062':'ADL',
  '5063':'ADL',
  '5064':'ADL',
  '5065':'ADL',
  '5066':'ADL',
  '5067':'ADL',
  '5068':'ADL',
  '5069':'ADL',
  '5070':'ADL',
  '5071':'ADL',
  '5072':'ADL',
  '5073':'ADL',
  '5074':'ADL',
  '5075':'ADL',
  '5076':'ADL',
  '5081':'ADL',
  '5082':'ADL',
  '5083':'ADL',
  '5084':'ADL',
  '5085':'ADL',
  '5086':'ADL',
  '5087':'ADL',
  '5088':'ADL',
  '5089':'ADL',
  '5090':'ADL',
  '5091':'ADL',
  '5092':'ADL',
  '5093':'ADL',
  '5094':'ADL',
  '5095':'ADL',
  '5096':'ADL',
  '5097':'ADL',
  '5098':'ADL',
  '5106':'ADL',
  '5107':'ADL',
  '5108':'ADL',
  '5109':'ADL',
  '5110':'ADL',
  '5111':'ADL',
  '5112':'ADL',
  '5113':'ADL',
  '5114':'ADL',
  '5115':'ADL',
  '5116':'ADL',
  '5117':'ADL',
  '5118':'ADL',
  '5120':'ADL',
  '5121':'ADL',
  '5125':'ADL',
  '5126':'ADL',
  '5127':'ADL',
  '5131':'ADL',
  '5132':'ADL',
  '5133':'ADL',
  '5134':'ADL',
  '5136':'ADL',
  '5137':'ADL',
  '5138':'ADL',
  '5139':'ADL',
  '5140':'ADL',
  '5141':'ADL',
  '5142':'ADL',
  '5144':'ADL',
  '5150':'ADL',
  '5151':'ADL',
  '5152':'ADL',
  '5153':'ADL',
  '5154':'ADL',
  '5155':'ADL',
  '5156':'ADL',
  '5157':'ADL',
  '5158':'ADL',
  '5159':'ADL',
  '5160':'ADL',
  '5161':'ADL',
  '5162':'ADL',
  '5163':'ADL',
  '5164':'ADL',
  '5165':'ADL',
  '5166':'ADL',
  '5167':'ADL',
  '5168':'ADL',
  '5169':'ADL',
  '5170':'ADL',
  '5171':'ADL',
  '5172':'ADL',
  '5173':'ADL',
  '5174':'ADL',
  '5201':'ADL',
  '5202':'ADL',
  '5203':'ADL',
  '5204':'ADL',
  '5210':'ADL',
  '5211':'ADL',
  '5212':'ADL',
  '5213':'ADL',
  '5214':'ADL',
  '5220':'ADL',
  '5221':'ADL',
  '5222':'ADL',
  '5223':'ADL',
  '5231':'ADL',
  '5232':'ADL',
  '5233':'ADL',
  '5234':'ADL',
  '5235':'ADL',
  '5236':'ADL',
  '5237':'ADL',
  '5238':'ADL',
  '5240':'ADL',
  '5241':'ADL',
  '5242':'ADL',
  '5243':'ADL',
  '5244':'ADL',
  '5245':'ADL',
  '5250':'ADL',
  '5251':'ADL',
  '5252':'ADL',
  '5253':'ADL',
  '5254':'ADL',
  '5255':'ADL',
  '5256':'ADL',
  '5259':'ADL',
  '5260':'ADL',
  '5261':'ADL',
  '5262':'ADL',
  '5263':'ADL',
  '5264':'ADL',
  '5265':'ADL',
  '5266':'ADL',
  '5267':'ADL',
  '5268':'ADL',
  '5269':'ADL',
  '5270':'ADL',
  '5271':'ADL',
  '5272':'ADL',
  '5273':'ADL',
  '5275':'ADL',
  '5276':'ADL',
  '5277':'ADL',
  '5278':'ADL',
  '5279':'ADL',
  '5280':'ADL',
  '5290':'ADL',
  '5291':'ADL',
  '5301':'ADL',
  '5302':'ADL',
  '5303':'ADL',
  '5304':'ADL',
  '5306':'ADL',
  '5307':'ADL',
  '5308':'ADL',
  '5309':'ADL',
  '5310':'ADL',
  '5311':'ADL',
  '5320':'ADL',
  '5321':'ADL',
  '5322':'ADL',
  '5330':'ADL',
  '5331':'ADL',
  '5332':'ADL',
  '5333':'ADL',
  '5340':'ADL',
  '5341':'ADL',
  '5342':'ADL',
  '5343':'ADL',
  '5344':'ADL',
  '5345':'ADL',
  '5346':'ADL',
  '5350':'ADL',
  '5351':'ADL',
  '5352':'ADL',
  '5353':'ADL',
  '5354':'ADL',
  '5355':'ADL',
  '5356':'ADL',
  '5357':'ADL',
  '5360':'ADL',
  '5371':'ADL',
  '5372':'ADL',
  '5373':'ADL',
  '5374':'ADL',
  '5381':'ADL',
  '5400':'ADL',
  '5401':'ADL',
  '5410':'ADL',
  '5411':'ADL',
  '5412':'ADL',
  '5413':'ADL',
  '5414':'ADL',
  '5415':'ADL',
  '5416':'ADL',
  '5417':'ADL',
  '5418':'ADL',
  '5419':'ADL',
  '5420':'ADL',
  '5421':'ADL',
  '5422':'ADL',
  '5431':'ADL',
  '5432':'ADL',
  '5433':'ADL',
  '5434':'ADL',
  '5440':'ADL',
  '5451':'ADL',
  '5452':'ADL',
  '5453':'ADL',
  '5454':'ADL',
  '5455':'ADL',
  '5460':'ADL',
  '5461':'ADL',
  '5462':'ADL',
  '5464':'ADL',
  '5470':'ADL',
  '5471':'ADL',
  '5472':'ADL',
  '5473':'ADL',
  '5480':'ADL',
  '5481':'ADL',
  '5482':'ADL',
  '5483':'ADL',
  '5485':'ADL',
  '5490':'ADL',
  '5491':'ADL',
  '5493':'ADL',
  '5495':'ADL',
  '5501':'ADL',
  '5502':'ADL',
  '5510':'ADL',
  '5520':'ADL',
  '5521':'ADL',
  '5522':'ADL',
  '5523':'ADL',
  '5540':'ADL',
  '5550':'ADL',
  '5552':'ADL',
  '5554':'ADL',
  '5555':'ADL',
  '5556':'ADL',
  '5558':'ADL',
  '5560':'ADL',
  '5570':'ADL',
  '5571':'ADL',
  '5572':'ADL',
  '5573':'ADL',
  '5575':'ADL',
  '5576':'ADL',
  '5577':'ADL',
  '5580':'ADL',
  '5581':'ADL',
  '5582':'ADL',
  '5583':'ADL',
  '5600':'ADL',
  '5601':'ADL',
  '5602':'ADL',
  '5603':'ADL',
  '5604':'ADL',
  '5605':'ADL',
  '5606':'ADL',
  '5607':'ADL',
  '5608':'ADL',
  '5609':'ADL',
  '5611':'ADL',
  '5630':'ADL',
  '5631':'ADL',
  '5632':'ADL',
  '5633':'ADL',
  '5640':'ADL',
  '5641':'ADL',
  '5642':'ADL',
  '5650':'ADL',
  '5651':'ADL',
  '5652':'ADL',
  '5653':'ADL',
  '5654':'ADL',
  '5655':'ADL',
  '5660':'ADL',
  '5661':'ADL',
  '5670':'ADL',
  '5671':'ADL',
  '5680':'ADL',
  '5690':'ADL',
  '5700':'ADL',
  '5701':'ADL',
  '5710':'ADL',
  '5713':'ADL',
  '5715':'ADL',
  '5717':'ADL',
  '5719':'ADL',
  '5720':'ADL',
  '5722':'ADL',
  '5723':'ADL',
  '5724':'ADL',
  '5725':'ADL',
  '5730':'ADL',
  '5731':'ADL',
  '5732':'ADL',
  '5733':'ADL',
  '5734':'ADL',
  '5800':'ADL',
  '5801':'ADL',
  '5810':'ADL',
  '5839':'ADL',
  '5942':'ADL',
  '5950':'ADL',
  '6000':'PER',
  '6001':'PER',
  '6003':'PER',
  '6004':'PER',
  '6005':'PER',
  '6006':'PER',
  '6007':'PER',
  '6008':'PER',
  '6009':'PER',
  '6010':'PER',
  '6011':'PER',
  '6012':'PER',
  '6014':'PER',
  '6015':'PER',
  '6016':'PER',
  '6017':'PER',
  '6018':'PER',
  '6019':'PER',
  '6020':'PER',
  '6021':'PER',
  '6022':'PER',
  '6023':'PER',
  '6024':'PER',
  '6025':'PER',
  '6026':'PER',
  '6027':'PER',
  '6028':'PER',
  '6029':'PER',
  '6030':'PER',
  '6031':'PER',
  '6032':'PER',
  '6033':'PER',
  '6034':'PER',
  '6035':'PER',
  '6036':'PER',
  '6037':'PER',
  '6038':'PER',
  '6041':'PER',
  '6042':'PER',
  '6043':'PER',
  '6044':'PER',
  '6050':'PER',
  '6051':'PER',
  '6052':'PER',
  '6053':'PER',
  '6054':'PER',
  '6055':'PER',
  '6056':'PER',
  '6057':'PER',
  '6058':'PER',
  '6059':'PER',
  '6060':'PER',
  '6061':'PER',
  '6062':'PER',
  '6063':'PER',
  '6064':'PER',
  '6065':'PER',
  '6066':'PER',
  '6067':'PER',
  '6068':'PER',
  '6069':'PER',
  '6070':'PER',
  '6071':'PER',
  '6072':'PER',
  '6073':'PER',
  '6074':'PER',
  '6076':'PER',
  '6077':'PER',
  '6078':'PER',
  '6079':'PER',
  '6081':'PER',
  '6082':'PER',
  '6083':'PER',
  '6084':'PER',
  '6090':'PER',
  '6100':'PER',
  '6101':'PER',
  '6102':'PER',
  '6103':'PER',
  '6104':'PER',
  '6105':'PER',
  '6106':'PER',
  '6107':'PER',
  '6108':'PER',
  '6109':'PER',
  '6110':'PER',
  '6111':'PER',
  '6112':'PER',
  '6121':'PER',
  '6122':'PER',
  '6123':'PER',
  '6124':'PER',
  '6125':'PER',
  '6126':'PER',
  '6147':'PER',
  '6148':'PER',
  '6149':'PER',
  '6150':'PER',
  '6151':'PER',
  '6152':'PER',
  '6153':'PER',
  '6154':'PER',
  '6155':'PER',
  '6156':'PER',
  '6157':'PER',
  '6158':'PER',
  '6159':'PER',
  '6160':'PER',
  '6161':'PER',
  '6162':'PER',
  '6163':'PER',
  '6164':'PER',
  '6165':'PER',
  '6166':'PER',
  '6167':'PER',
  '6168':'PER',
  '6169':'PER',
  '6170':'PER',
  '6171':'PER',
  '6172':'PER',
  '6173':'PER',
  '6174':'PER',
  '6175':'PER',
  '6176':'PER',
  '6180':'PER',
  '6181':'PER',
  '6182':'PER',
  '6207':'PER',
  '6208':'PER',
  '6209':'PER',
  '6210':'PER',
  '6211':'PER',
  '6213':'PER',
  '6214':'PER',
  '6215':'PER',
  '6218':'PER',
  '6219':'PER',
  '6220':'PER',
  '6221':'PER',
  '6223':'PER',
  '6224':'PER',
  '6225':'PER',
  '6226':'PER',
  '6227':'PER',
  '6228':'PER',
  '6229':'PER',
  '6230':'PER',
  '6231':'PER',
  '6232':'PER',
  '6233':'PER',
  '6236':'PER',
  '6237':'PER',
  '6239':'PER',
  '6240':'PER',
  '6243':'PER',
  '6244':'PER',
  '6251':'PER',
  '6252':'PER',
  '6253':'PER',
  '6254':'PER',
  '6255':'PER',
  '6256':'PER',
  '6258':'PER',
  '6260':'PER',
  '6262':'PER',
  '6271':'PER',
  '6275':'PER',
  '6280':'PER',
  '6281':'PER',
  '6282':'PER',
  '6284':'PER',
  '6285':'PER',
  '6286':'PER',
  '6288':'PER',
  '6290':'PER',
  '6302':'PER',
  '6304':'PER',
  '6306':'PER',
  '6308':'PER',
  '6309':'PER',
  '6311':'PER',
  '6312':'PER',
  '6313':'PER',
  '6315':'PER',
  '6316':'PER',
  '6317':'PER',
  '6318':'PER',
  '6320':'PER',
  '6321':'PER',
  '6322':'PER',
  '6323':'PER',
  '6324':'PER',
  '6326':'PER',
  '6327':'PER',
  '6328':'PER',
  '6330':'PER',
  '6331':'PER',
  '6332':'PER',
  '6333':'PER',
  '6335':'PER',
  '6336':'PER',
  '6337':'PER',
  '6338':'PER',
  '6341':'PER',
  '6343':'PER',
  '6346':'PER',
  '6348':'PER',
  '6350':'PER',
  '6351':'PER',
  '6352':'PER',
  '6353':'PER',
  '6355':'PER',
  '6356':'PER',
  '6357':'PER',
  '6358':'PER',
  '6359':'PER',
  '6361':'PER',
  '6363':'PER',
  '6365':'PER',
  '6367':'PER',
  '6368':'PER',
  '6369':'PER',
  '6370':'PER',
  '6372':'PER',
  '6373':'PER',
  '6375':'PER',
  '6383':'PER',
  '6384':'PER',
  '6385':'PER',
  '6386':'PER',
  '6390':'PER',
  '6391':'PER',
  '6392':'PER',
  '6393':'PER',
  '6394':'PER',
  '6395':'PER',
  '6396':'PER',
  '6397':'PER',
  '6398':'PER',
  '6401':'PER',
  '6403':'PER',
  '6405':'PER',
  '6407':'PER',
  '6409':'PER',
  '6410':'PER',
  '6411':'PER',
  '6412':'PER',
  '6413':'PER',
  '6414':'PER',
  '6415':'PER',
  '6418':'PER',
  '6419':'PER',
  '6420':'PER',
  '6421':'PER',
  '6422':'PER',
  '6423':'PER',
  '6424':'PER',
  '6425':'PER',
  '6426':'PER',
  '6427':'PER',
  '6428':'PER',
  '6429':'PER',
  '6430':'PER',
  '6431':'PER',
  '6432':'PER',
  '6433':'PER',
  '6434':'PER',
  '6436':'PER',
  '6437':'PER',
  '6438':'PER',
  '6440':'PER',
  '6442':'PER',
  '6443':'PER',
  '6445':'PER',
  '6446':'PER',
  '6447':'PER',
  '6448':'PER',
  '6450':'PER',
  '6452':'PER',
  '6460':'PER',
  '6461':'PER',
  '6462':'PER',
  '6463':'PER',
  '6465':'PER',
  '6466':'PER',
  '6467':'PER',
  '6468':'PER',
  '6470':'PER',
  '6472':'PER',
  '6473':'PER',
  '6475':'PER',
  '6476':'PER',
  '6477':'PER',
  '6479':'PER',
  '6480':'PER',
  '6484':'PER',
  '6485':'PER',
  '6487':'PER',
  '6488':'PER',
  '6489':'PER',
  '6490':'PER',
  '6501':'PER',
  '6502':'PER',
  '6503':'PER',
  '6504':'PER',
  '6505':'PER',
  '6506':'PER',
  '6507':'PER',
  '6509':'PER',
  '6510':'PER',
  '6511':'PER',
  '6512':'PER',
  '6513':'PER',
  '6514':'PER',
  '6515':'PER',
  '6516':'PER',
  '6517':'PER',
  '6518':'PER',
  '6519':'PER',
  '6521':'PER',
  '6522':'PER',
  '6525':'PER',
  '6528':'PER',
  '6530':'PER',
  '6531':'PER',
  '6532':'PER',
  '6535':'PER',
  '6536':'PER',
  '6537':'PER',
  '6556':'PER',
  '6558':'PER',
  '6560':'PER',
  '6562':'PER',
  '6564':'PER',
  '6566':'PER',
  '6567':'PER',
  '6568':'PER',
  '6569':'PER',
  '6571':'PER',
  '6572':'PER',
  '6574':'PER',
  '6575':'PER',
  '6603':'PER',
  '6605':'PER',
  '6606':'PER',
  '6608':'PER',
  '6609':'PER',
  '6612':'PER',
  '6613':'PER',
  '6614':'PER',
  '6616':'PER',
  '6620':'PER',
  '6623':'PER',
  '6625':'PER',
  '6627':'PER',
  '6628':'PER',
  '6630':'PER',
  '6631':'PER',
  '6632':'PER',
  '6635':'PER',
  '6638':'PER',
  '6639':'PER',
  '6640':'PER',
  '6642':'PER',
  '6646':'PER',
  '6701':'PER',
  '6705':'PER',
  '6707':'PER',
  '6710':'PER',
  '6711':'PER',
  '6712':'PER',
  '6713':'PER',
  '6714':'PER',
  '6716':'PER',
  '6718':'PER',
  '6720':'PER',
  '6721':'PER',
  '6722':'PER',
  '6725':'PER',
  '6726':'PER',
  '6728':'PER',
  '6731':'PER',
  '6733':'PER',
  '6740':'PER',
  '6743':'PER',
  '6751':'PER',
  '6753':'PER',
  '6754':'PER',
  '6758':'PER',
  '6760':'PER',
  '6762':'PER',
  '6765':'PER',
  '6770':'PER',
  '6798':'PER',
  '6799':'PER',
  '6800':'PER',
  '6809':'PER',
  '6827':'PER',
  '6830':'PER',
  '6831':'PER',
  '6837':'PER',
  '6838':'PER',
  '6839':'PER',
  '6840':'PER',
  '6841':'PER',
  '6842':'PER',
  '6843':'PER',
  '6844':'PER',
  '6845':'PER',
  '6846':'PER',
  '6847':'PER',
  '6848':'PER',
  '6849':'PER',
  '6850':'PER',
  '6865':'PER',
  '6872':'PER',
  '6892':'PER',
  '6900':'PER',
  '6901':'PER',
  '6902':'PER',
  '6903':'PER',
  '6904':'PER',
  '6905':'PER',
  '6906':'PER',
  '6907':'PER',
  '6909':'PER',
  '6910':'PER',
  '6911':'PER',
  '6912':'PER',
  '6913':'PER',
  '6914':'PER',
  '6915':'PER',
  '6916':'PER',
  '6917':'PER',
  '6918':'PER',
  '6919':'PER',
  '6920':'PER',
  '6921':'PER',
  '6922':'PER',
  '6923':'PER',
  '6924':'PER',
  '6925':'PER',
  '6926':'PER',
  '6929':'PER',
  '6931':'PER',
  '6932':'PER',
  '6933':'PER',
  '6934':'PER',
  '6935':'PER',
  '6936':'PER',
  '6939':'PER',
  '6941':'PER',
  '6942':'PER',
  '6943':'PER',
  '6944':'PER',
  '6945':'PER',
  '6946':'PER',
  '6947':'PER',
  '6951':'PER',
  '6952':'PER',
  '6953':'PER',
  '6954':'PER',
  '6955':'PER',
  '6956':'PER',
  '6957':'PER',
  '6958':'PER',
  '6959':'PER',
  '6960':'PER',
  '6961':'PER',
  '6963':'PER',
  '6964':'PER',
  '6965':'PER',
  '6966':'PER',
  '6967':'PER',
  '6968':'PER',
  '6969':'PER',
  '6970':'PER',
  '6979':'PER',
  '6981':'PER',
  '6982':'PER',
  '6983':'PER',
  '6984':'PER',
  '6985':'PER',
  '6986':'PER',
  '6987':'PER',
  '6988':'PER',
  '6989':'PER',
  '6990':'PER',
  '6991':'PER',
  '6992':'PER',
  '6997':'PER',
  '7000':'MEL',
  '7001':'MEL',
  '7002':'MEL',
  '7004':'MEL',
  '7005':'MEL',
  '7006':'MEL',
  '7007':'MEL',
  '7008':'MEL',
  '7009':'MEL',
  '7010':'MEL',
  '7011':'MEL',
  '7012':'MEL',
  '7015':'MEL',
  '7016':'MEL',
  '7017':'MEL',
  '7018':'MEL',
  '7019':'MEL',
  '7020':'MEL',
  '7021':'MEL',
  '7022':'MEL',
  '7023':'MEL',
  '7024':'MEL',
  '7025':'MEL',
  '7026':'MEL',
  '7027':'MEL',
  '7030':'MEL',
  '7050':'MEL',
  '7051':'MEL',
  '7052':'MEL',
  '7053':'MEL',
  '7054':'MEL',
  '7055':'MEL',
  '7109':'MEL',
  '7112':'MEL',
  '7113':'MEL',
  '7116':'MEL',
  '7117':'MEL',
  '7119':'MEL',
  '7120':'MEL',
  '7139':'MEL',
  '7140':'MEL',
  '7150':'MEL',
  '7151':'MEL',
  '7155':'MEL',
  '7162':'MEL',
  '7163':'MEL',
  '7170':'MEL',
  '7171':'MEL',
  '7172':'MEL',
  '7173':'MEL',
  '7174':'MEL',
  '7175':'MEL',
  '7176':'MEL',
  '7177':'MEL',
  '7178':'MEL',
  '7179':'MEL',
  '7180':'MEL',
  '7182':'MEL',
  '7183':'MEL',
  '7184':'MEL',
  '7185':'MEL',
  '7186':'MEL',
  '7187':'MEL',
  '7190':'MEL',
  '7209':'MEL',
  '7210':'MEL',
  '7211':'MEL',
  '7212':'MEL',
  '7213':'MEL',
  '7214':'MEL',
  '7215':'MEL',
  '7216':'MEL',
  '7248':'MEL',
  '7249':'MEL',
  '7250':'MEL',
  '7252':'MEL',
  '7253':'MEL',
  '7254':'MEL',
  '7255':'MEL',
  '7256':'MEL',
  '7257':'MEL',
  '7258':'MEL',
  '7259':'MEL',
  '7260':'MEL',
  '7261':'MEL',
  '7262':'MEL',
  '7263':'MEL',
  '7264':'MEL',
  '7265':'MEL',
  '7267':'MEL',
  '7268':'MEL',
  '7270':'MEL',
  '7275':'MEL',
  '7276':'MEL',
  '7277':'MEL',
  '7290':'MEL',
  '7291':'MEL',
  '7292':'MEL',
  '7300':'MEL',
  '7301':'MEL',
  '7302':'MEL',
  '7303':'MEL',
  '7304':'MEL',
  '7305':'MEL',
  '7306':'MEL',
  '7307':'MEL',
  '7310':'MEL',
  '7315':'MEL',
  '7316':'MEL',
  '7320':'MEL',
  '7321':'MEL',
  '7322':'MEL',
  '7325':'MEL',
  '7330':'MEL',
  '7331':'MEL',
  '7466':'MEL',
  '7467':'MEL',
  '7468':'MEL',
  '7469':'MEL',
  '7470':'MEL',
  '800':'BRI',
  '8001':'MEL',
  '8002':'MEL',
  '8003':'MEL',
  '8004':'MEL',
  '8006':'MEL',
  '8007':'MEL',
  '8008':'MEL',
  '8009':'MEL',
  '801':'BRI',
  '8010':'MEL',
  '8011':'MEL',
  '8012':'MEL',
  '803':'BRI',
  '804':'BRI',
  '8045':'MEL',
  '8051':'MEL',
  '8066':'MEL',
  '8069':'MEL',
  '8070':'MEL',
  '8071':'MEL',
  '810':'BRI',
  '8102':'MEL',
  '8107':'MEL',
  '811':'BRI',
  '8111':'MEL',
  '812':'BRI',
  '8120':'MEL',
  '813':'BRI',
  '814':'BRI',
  '815':'BRI',
  '820':'BRI',
  '8205':'MEL',
  '821':'BRI',
  '822':'BRI',
  '828':'BRI',
  '829':'BRI',
  '830':'BRI',
  '831':'BRI',
  '832':'BRI',
  '834':'BRI',
  '835':'BRI',
  '836':'BRI',
  '837':'BRI',
  '838':'BRI',
  '8383':'MEL',
  '839':'BRI',
  '840':'BRI',
  '841':'BRI',
  '8438':'MEL',
  '845':'BRI',
  '846':'BRI',
  '847':'BRI',
  '850':'BRI',
  '851':'BRI',
  '8511':'MEL',
  '852':'BRI',
  '853':'BRI',
  '854':'BRI',
  '860':'BRI',
  '861':'BRI',
  '862':'BRI',
  '870':'BRI',
  '871':'BRI',
  '872':'ADL',
  '873':'BRI',
  '874':'BRI',
  '875':'BRI',
  '8785':'MEL',
  '880':'BRI',
  '881':'BRI',
  '885':'BRI',
  '886':'BRI',
  '9000':'BRI',
  '9001':'BRI',
  '9002':'BRI',
  '9005':'BRI',
  '9007':'BRI',
  '9009':'BRI',
  '9010':'BRI',
  '9013':'BRI',
  '9015':'BRI',
  '906':'BRI',
  '907':'BRI',
  '909':'BRI',
  '9464':'BRI',
  '9600':'BRI',
  '9726':'BRI',
  '9999':'BRI',
};

var FW_PC_AX_OLD={
  '200':'CBRCBR',
  '2000':'SYDSYD',
  '2001':'SYDSYD',
  '2002':'SYDSYD',
  '2004':'SYDSYD',
  '2006':'SYDSYD',
  '2007':'SYDSYD',
  '2008':'SYDSYD',
  '2009':'SYDSYD',
  '2010':'SYDSYD',
  '2011':'SYDSYD',
  '2012':'SYDSYD',
  '2015':'SYDSYD',
  '2016':'SYDSYD',
  '2017':'SYDSYD',
  '2018':'SYDSYD',
  '2019':'SYDSYD',
  '2020':'SYDSYD',
  '2021':'SYDSYD',
  '2022':'SYDSYD',
  '2023':'SYDSYD',
  '2024':'SYDSYD',
  '2025':'SYDSYD',
  '2026':'SYDSYD',
  '2027':'SYDSYD',
  '2028':'SYDSYD',
  '2029':'SYDSYD',
  '2030':'SYDSYD',
  '2031':'SYDSYD',
  '2032':'SYDSYD',
  '2033':'SYDSYD',
  '2034':'SYDSYD',
  '2035':'SYDSYD',
  '2036':'SYDSYD',
  '2037':'SYDSYD',
  '2038':'SYDSYD',
  '2039':'SYDSYD',
  '2040':'SYDSYD',
  '2041':'SYDSYD',
  '2042':'SYDSYD',
  '2043':'SYDSYD',
  '2044':'SYDSYD',
  '2045':'SYDSYD',
  '2046':'SYDSYD',
  '2047':'SYDSYD',
  '2048':'SYDSYD',
  '2049':'SYDSYD',
  '2050':'SYDSYD',
  '2052':'SYDSYD',
  '2055':'SYDSYD',
  '2057':'SYDSYD',
  '2059':'SYDSYD',
  '2060':'SYDSYD',
  '2061':'SYDSYD',
  '2062':'SYDSYD',
  '2063':'SYDSYD',
  '2064':'SYDSYD',
  '2065':'SYDSYD',
  '2066':'SYDSYD',
  '2067':'SYDSYD',
  '2068':'SYDSYD',
  '2069':'SYDSYD',
  '2070':'SYDSYD',
  '2071':'SYDSYD',
  '2072':'SYDSYD',
  '2073':'SYDSYD',
  '2074':'SYDSYD',
  '2075':'SYDSYD',
  '2076':'SYDSYD',
  '2077':'SYDSYD',
  '2079':'SYDSYD',
  '2080':'SYDSYD',
  '2081':'MELSYD',
  '2082':'SYDSYD',
  '2084':'SYDSYD',
  '2085':'SYDSYD',
  '2086':'SYDSYD',
  '2087':'SYDSYD',
  '2088':'SYDSYD',
  '2089':'SYDSYD',
  '2090':'SYDSYD',
  '2091':'SYDSYD',
  '2092':'SYDSYD',
  '2093':'SYDSYD',
  '2094':'SYDSYD',
  '2095':'SYDSYD',
  '2096':'SYDSYD',
  '2097':'SYDSYD',
  '2099':'SYDSYD',
  '2100':'SYDSYD',
  '2101':'SYDSYD',
  '2102':'SYDSYD',
  '2103':'SYDSYD',
  '2104':'SYDSYD',
  '2105':'BRISYD',
  '2106':'SYDSYD',
  '2107':'SYDSYD',
  '2108':'SYDSYD',
  '2109':'SYDSYD',
  '2110':'SYDSYD',
  '2111':'SYDSYD',
  '2112':'SYDSYD',
  '2113':'SYDSYD',
  '2114':'SYDSYD',
  '2115':'SYDSYD',
  '2116':'SYDSYD',
  '2117':'SYDSYD',
  '2118':'SYDSYD',
  '2119':'SYDSYD',
  '2120':'SYDSYD',
  '2121':'SYDSYD',
  '2122':'SYDSYD',
  '2123':'SYDSYD',
  '2124':'SYDSYD',
  '2125':'SYDSYD',
  '2126':'SYDSYD',
  '2127':'SYDSYD',
  '2128':'SYDSYD',
  '2129':'SYDSYD',
  '2130':'SYDSYD',
  '2131':'SYDSYD',
  '2132':'SYDSYD',
  '2133':'SYDSYD',
  '2134':'SYDSYD',
  '2135':'SYDSYD',
  '2136':'SYDSYD',
  '2137':'SYDSYD',
  '2138':'SYDSYD',
  '2139':'SYDSYD',
  '2140':'SYDSYD',
  '2141':'SYDSYD',
  '2142':'SYDSYD',
  '2143':'SYDSYD',
  '2144':'SYDSYD',
  '2145':'SYDSYD',
  '2146':'SYDSYD',
  '2147':'SYDSYD',
  '2148':'SYDSYD',
  '2150':'SYDSYD',
  '2151':'SYDSYD',
  '2152':'SYDSYD',
  '2153':'SYDSYD',
  '2154':'SYDSYD',
  '2155':'SYDSYD',
  '2156':'SYDSYD',
  '2157':'SYDSYD',
  '2158':'SYDSYD',
  '2159':'SYDSYD',
  '2160':'SYDSYD',
  '2161':'SYDSYD',
  '2162':'SYDSYD',
  '2163':'SYDSYD',
  '2164':'SYDSYD',
  '2165':'SYDSYD',
  '2166':'SYDSYD',
  '2167':'SYDSYD',
  '2168':'SYDSYD',
  '2170':'SYDSYD',
  '2171':'SYDSYD',
  '2172':'SYDSYD',
  '2173':'SYDSYD',
  '2174':'SYDSYD',
  '2175':'SYDSYD',
  '2176':'SYDSYD',
  '2177':'SYDSYD',
  '2178':'SYDSYD',
  '2179':'SYDSYD',
  '2190':'SYDSYD',
  '2191':'SYDSYD',
  '2192':'SYDSYD',
  '2193':'SYDSYD',
  '2194':'SYDSYD',
  '2195':'SYDSYD',
  '2196':'SYDSYD',
  '2197':'SYDSYD',
  '2198':'SYDSYD',
  '2199':'SYDSYD',
  '2200':'SYDSYD',
  '2203':'SYDSYD',
  '2204':'SYDSYD',
  '2205':'SYDSYD',
  '2206':'SYDSYD',
  '2207':'SYDSYD',
  '2208':'SYDSYD',
  '2209':'SYDSYD',
  '2210':'SYDSYD',
  '2211':'SYDSYD',
  '2212':'SYDSYD',
  '2213':'SYDSYD',
  '2214':'SYDSYD',
  '2216':'BRISYD',
  '2217':'SYDSYD',
  '2218':'SYDSYD',
  '2219':'SYDSYD',
  '2220':'SYDSYD',
  '2221':'SYDSYD',
  '2222':'SYDSYD',
  '2223':'SYDSYD',
  '2224':'SYDSYD',
  '2225':'SYDSYD',
  '2226':'SYDSYD',
  '2227':'SYDSYD',
  '2228':'SYDSYD',
  '2229':'SYDSYD',
  '2230':'SYDSYD',
  '2231':'SYDSYD',
  '2232':'SYDSYD',
  '2233':'SYDSYD',
  '2234':'SYDSYD',
  '2250':'SYDCCT',
  '2251':'SYDCCT',
  '2252':'SYDCCT',
  '2256':'SYDCCT',
  '2257':'SYDCCT',
  '2258':'SYDCCT',
  '2259':'SYDCCT',
  '2260':'SYDCCT',
  '2261':'SYDCCT',
  '2262':'SYDCCT',
  '2263':'SYDCCT',
  '2264':'SYDNEW',
  '2265':'CBRNEW',
  '2267':'SYDNEW',
  '2278':'SYDNEW',
  '2280':'SYDNEW',
  '2281':'SYDNEW',
  '2282':'SYDNEW',
  '2283':'SYDNEW',
  '2284':'SYDNEW',
  '2285':'SYDNEW',
  '2286':'SYDNEW',
  '2287':'SYDNEW',
  '2289':'SYDNEW',
  '2290':'SYDNEW',
  '2291':'SYDNEW',
  '2292':'SYDNEW',
  '2293':'SYDNEW',
  '2294':'SYDNEW',
  '2295':'SYDNEW',
  '2296':'SYDNEW',
  '2297':'SYDNEW',
  '2298':'SYDNEW',
  '2299':'SYDNEW',
  '2300':'SYDNEW',
  '2302':'SYDNEW',
  '2303':'SYDNEW',
  '2304':'SYDNEW',
  '2305':'SYDNEW',
  '2306':'SYDNEW',
  '2307':'SYDNEW',
  '2308':'SYDNEW',
  '2310':'SYDNEW',
  '2312':'SYDPQQ',
  '2314':'SYDNEW',
  '2315':'SYDNEW',
  '2316':'SYDNEW',
  '2317':'SYDNEW',
  '2318':'SYDNEW',
  '2319':'SYDNEW',
  '2320':'SYDNEW',
  '2321':'CBRNEW',
  '2322':'SYDNEW',
  '2323':'SYDNEW',
  '2324':'CBRNEW',
  '2325':'CBRNEW',
  '2326':'SYDNEW',
  '2327':'SYDNEW',
  '2330':'CBRNEW',
  '2333':'CBRNEW',
  '2334':'SYDNEW',
  '2335':'CBRNEW',
  '2427':'SYDPQQ',
  '2428':'SYDPQQ',
  '2429':'SYDPQQ',
  '2430':'SYDPQQ',
  '2439':'SYDPQQ',
  '2440':'SYDPQQ',
  '2441':'SYDCFS',
  '2443':'SYDPQQ',
  '2444':'SYDPQQ',
  '2445':'SYDPQQ',
  '2446':'SYDPQQ',
  '2447':'SYDCFS',
  '2448':'SYDCFS',
  '2450':'SYDCFS',
  '2452':'SYDCFS',
  '2453':'SYDCFS',
  '2454':'SYDCFS',
  '2455':'SYDCFS',
  '2456':'SYDCFS',
  '2460':'SYDNTH',
  '2463':'SYDNTH',
  '2464':'BRINTH',
  '2465':'SYDNTH',
  '2470':'MELNTH',
  '2473':'MELNTH',
  '2474':'MELNTH',
  '2477':'SYDNTH',
  '2478':'SYDNTH',
  '2479':'MELNTH',
  '2480':'MELNTH',
  '2481':'MELNTH',
  '2482':'MELNTH',
  '2483':'MELNTH',
  '2484':'SYDGLD',
  '2485':'BRIGLD',
  '2486':'SYDGLD',
  '2487':'SYDGLD',
  '2488':'SYDGLD',
  '2489':'BRIGLD',
  '2490':'BRIGLD',
  '2500':'SYDWOL',
  '2502':'SYDWOL',
  '2505':'SYDWOL',
  '2506':'SYDWOL',
  '2508':'BRIWOL',
  '2515':'SYDWOL',
  '2516':'SYDWOL',
  '2517':'SYDWOL',
  '2518':'SYDWOL',
  '2519':'SYDWOL',
  '2520':'SYDWOL',
  '2522':'SYDWOL',
  '2525':'SYDWOL',
  '2526':'SYDWOL',
  '2527':'SYDWOL',
  '2528':'SYDWOL',
  '2529':'SYDWOL',
  '2530':'SYDWOL',
  '2533':'SYDWOL',
  '2534':'SYDWOL',
  '2535':'SYDWOL',
  '2540':'SYDWOL',
  '2541':'SYDWOL',
  '2555':'SYDSYD',
  '2556':'SYDSYD',
  '2557':'SYDSYD',
  '2558':'SYDSYD',
  '2559':'SYDSYD',
  '2560':'SYDSYD',
  '2564':'SYDSYD',
  '2565':'SYDSYD',
  '2566':'SYDSYD',
  '2567':'SYDSYD',
  '2570':'MELSYD',
  '2571':'SYDWOL',
  '2572':'SYDWOL',
  '2573':'SYDWOL',
  '2574':'SYDWOL',
  '2575':'SYDWOL',
  '2576':'MELWOL',
  '2577':'MELWOL',
  '2578':'SYDWOL',
  '2579':'MELWOL',
  '2580':'SYDCBR',
  '2590':'SYDYNG',
  '2594':'MELYNG',
  '2600':'CBRCBR',
  '2601':'CBRCBR',
  '2602':'CBRCBR',
  '2603':'CBRCBR',
  '2604':'CBRCBR',
  '2605':'CBRCBR',
  '2606':'CBRCBR',
  '2607':'CBRCBR',
  '2608':'CBRCBR',
  '2609':'CBRCBR',
  '2610':'CBRCBR',
  '2611':'CBRCBR',
  '2612':'CBRCBR',
  '2614':'CBRCBR',
  '2615':'MELCBR',
  '2616':'CBRCBR',
  '2617':'CBRCBR',
  '2618':'CBRCBR',
  '2619':'CBRCBR',
  '2620':'SYDCBR',
  '2640':'SYDALB',
  '2641':'MELALB',
  '2642':'SYDALB',
  '2643':'MELALB',
  '2646':'SYDALB',
  '2647':'MELALB',
  '2650':'SYDYNG',
  '2651':'MELYNG',
  '2652':'SYDYNG',
  '2678':'SYDYNG',
  '2680':'MELYNG',
  '2681':'MELYNG',
  '2705':'SYDYNG',
  '2708':'MELALB',
  '2745':'SYDSYD',
  '2747':'SYDSYD',
  '2748':'SYDSYD',
  '2749':'SYDSYD',
  '2750':'SYDSYD',
  '2751':'SYDSYD',
  '2752':'SYDSYD',
  '2753':'SYDSYD',
  '2754':'SYDSYD',
  '2756':'SYDSYD',
  '2759':'SYDSYD',
  '2760':'SYDSYD',
  '2761':'SYDSYD',
  '2762':'SYDSYD',
  '2763':'SYDSYD',
  '2765':'SYDSYD',
  '2766':'SYDSYD',
  '2767':'SYDSYD',
  '2768':'SYDSYD',
  '2769':'SYDSYD',
  '2770':'SYDSYD',
  '2773':'SYDSYD',
  '2774':'SYDSYD',
  '2776':'SYDSYD',
  '2777':'SYDSYD',
  '2778':'SYDSYD',
  '2779':'SYDSYD',
  '2780':'SYDSYD',
  '2782':'SYDSYD',
  '2783':'SYDSYD',
  '2784':'SYDSYD',
  '2785':'SYDSYD',
  '2786':'SYDSYD',
  '2794':'SYDYNG',
  '2795':'SYDOAG',
  '2800':'SYDOAG',
  '2891':'ADLSYD',
  '2900':'CBRCBR',
  '2901':'CBRCBR',
  '2902':'CBRCBR',
  '2903':'CBRCBR',
  '2904':'CBRCBR',
  '2905':'CBRCBR',
  '2906':'CBRCBR',
  '2911':'CBRCBR',
  '2912':'CBRCBR',
  '2913':'CBRCBR',
  '2914':'CBRCBR',
  '3000':'MELMEL',
  '3001':'MELMEL',
  '3002':'MELMEL',
  '3003':'MELMEL',
  '3004':'ADLMEL',
  '3006':'MELMEL',
  '3008':'MELMEL',
  '3010':'MELMEL',
  '3011':'MELMEL',
  '3012':'MELMEL',
  '3013':'MELMEL',
  '3015':'MELMEL',
  '3016':'MELMEL',
  '3018':'MELMEL',
  '3019':'MELMEL',
  '3020':'MELMEL',
  '3021':'MELMEL',
  '3022':'MELMEL',
  '3023':'MELMEL',
  '3024':'MELMEL',
  '3025':'MELMEL',
  '3026':'MELMEL',
  '3027':'MELMEL',
  '3028':'MELMEL',
  '3029':'MELMEL',
  '3030':'MELMEL',
  '3031':'MELMEL',
  '3032':'MELMEL',
  '3033':'MELMEL',
  '3034':'MELMEL',
  '3036':'MELMEL',
  '3037':'MELMEL',
  '3038':'BRIMEL',
  '3039':'MELMEL',
  '3040':'MELMEL',
  '3041':'MELMEL',
  '3042':'BRIMEL',
  '3043':'MELMEL',
  '3044':'MELMEL',
  '3045':'MELMEL',
  '3046':'MELMEL',
  '3047':'MELMEL',
  '3048':'MELMEL',
  '3049':'MELMEL',
  '3050':'MELMEL',
  '3051':'MELMEL',
  '3052':'MELMEL',
  '3053':'MELMEL',
  '3054':'MELMEL',
  '3055':'MELMEL',
  '3056':'MELMEL',
  '3057':'BRIMEL',
  '3058':'MELMEL',
  '3059':'MELMEL',
  '3060':'MELMEL',
  '3061':'MELMEL',
  '3062':'MELMEL',
  '3064':'MELMEL',
  '3065':'MELMEL',
  '3066':'MELMEL',
  '3067':'MELMEL',
  '3068':'MELMEL',
  '3070':'MELMEL',
  '3071':'MELMEL',
  '3072':'BRIMEL',
  '3073':'MELMEL',
  '3074':'MELMEL',
  '3075':'MELMEL',
  '3076':'MELMEL',
  '3078':'MELMEL',
  '3079':'MELMEL',
  '3081':'MELMEL',
  '3082':'MELMEL',
  '3083':'MELMEL',
  '3084':'MELMEL',
  '3085':'MELMEL',
  '3086':'MELMEL',
  '3087':'MELMEL',
  '3088':'MELMEL',
  '3093':'MELMEL',
  '3094':'MELMEL',
  '3095':'MELMEL',
  '3101':'MELMEL',
  '3102':'MELMEL',
  '3103':'BRIMEL',
  '3104':'MELMEL',
  '3105':'MELMEL',
  '3106':'MELMEL',
  '3107':'MELMEL',
  '3108':'MELMEL',
  '3109':'MELMEL',
  '3111':'MELMEL',
  '3116':'MELMEL',
  '3121':'MELMEL',
  '3122':'MELMEL',
  '3123':'MELMEL',
  '3124':'MELMEL',
  '3125':'MELMEL',
  '3126':'MELMEL',
  '3127':'MELMEL',
  '3128':'BRIMEL',
  '3129':'MELMEL',
  '3130':'MELMEL',
  '3131':'MELMEL',
  '3132':'BRIMEL',
  '3133':'MELMEL',
  '3134':'MELMEL',
  '3135':'MELMEL',
  '3136':'MELMEL',
  '3137':'MELMEL',
  '3138':'MELMEL',
  '3140':'MELMEL',
  '3141':'MELMEL',
  '3142':'MELMEL',
  '3143':'MELMEL',
  '3144':'MELMEL',
  '3145':'BRIMEL',
  '3146':'BRIMEL',
  '3147':'MELMEL',
  '3148':'BRIMEL',
  '3149':'BRIMEL',
  '3150':'MELMEL',
  '3151':'MELMEL',
  '3152':'MELMEL',
  '3153':'MELMEL',
  '3154':'MELMEL',
  '3155':'MELMEL',
  '3156':'BRIMEL',
  '3161':'MELMEL',
  '3162':'BRIMEL',
  '3163':'MELMEL',
  '3164':'MELMEL',
  '3165':'MELMEL',
  '3166':'MELMEL',
  '3167':'MELMEL',
  '3168':'MELMEL',
  '3169':'MELMEL',
  '3170':'BRIMEL',
  '3171':'MELMEL',
  '3172':'MELMEL',
  '3173':'MELMEL',
  '3174':'MELMEL',
  '3175':'BRIMEL',
  '3176':'MELMEL',
  '3177':'MELMEL',
  '3178':'MELMEL',
  '3179':'MELMEL',
  '3180':'MELMEL',
  '3181':'MELMEL',
  '3182':'MELMEL',
  '3183':'MELMEL',
  '3184':'MELMEL',
  '3185':'MELMEL',
  '3186':'BRIMEL',
  '3187':'MELMEL',
  '3188':'MELMEL',
  '3189':'BRIMEL',
  '3190':'MELMEL',
  '3191':'MELMEL',
  '3192':'MELMEL',
  '3193':'BRIMEL',
  '3194':'MELMEL',
  '3195':'MELMEL',
  '3196':'MELMEL',
  '3197':'MELMEL',
  '3198':'MELMEL',
  '3199':'BRIMEL',
  '3200':'BRIMEL',
  '3201':'MELMEL',
  '3202':'MELMEL',
  '3204':'BRIMEL',
  '3205':'MELMEL',
  '3206':'MELMEL',
  '3207':'MELMEL',
  '3212':'BRIGEE',
  '3213':'BRIGEE',
  '3214':'MELGEE',
  '3215':'MELGEE',
  '3216':'MELGEE',
  '3217':'MELGEE',
  '3218':'BRIGEE',
  '3219':'MELGEE',
  '3220':'MELGEE',
  '3221':'BRIGEE',
  '3222':'MELGEE',
  '3223':'MELGEE',
  '3224':'MELGEE',
  '3225':'BRIGEE',
  '3226':'MELGEE',
  '3227':'MELGEE',
  '3228':'MELGEE',
  '3250':'MELGEE',
  '3331':'MELGEE',
  '3335':'MELMEL',
  '3336':'MELMEL',
  '3337':'MELMEL',
  '3338':'MELMEL',
  '3340':'MELMEL',
  '3350':'MELGEE',
  '3352':'MELGEE',
  '3353':'MELGEE',
  '3354':'MELGEE',
  '3355':'MELGEE',
  '3356':'MELGEE',
  '3357':'MELGEE',
  '3358':'MELGEE',
  '3427':'MELMEL',
  '3429':'BRIMEL',
  '3437':'MELMEL',
  '3438':'MELMEL',
  '3442':'MELMEL',
  '3446':'MELBEN',
  '3447':'MELBEN',
  '3448':'BRIBEN',
  '3450':'BRIBEN',
  '3451':'BRIBEN',
  '3453':'BRIBEN',
  '3463':'BRIBEN',
  '3515':'ADLBEN',
  '3523':'ADLBEN',
  '3550':'MELBEN',
  '3551':'MELBEN',
  '3552':'MELBEN',
  '3554':'MELBEN',
  '3555':'MELBEN',
  '3556':'BRIBEN',
  '3676':'MELALB',
  '3677':'MELALB',
  '3678':'MELALB',
  '3683':'MELALB',
  '3685':'MELALB',
  '3687':'MELALB',
  '3688':'BRIALB',
  '3689':'MELALB',
  '3690':'MELALB',
  '3691':'MELALB',
  '3694':'MELALB',
  '3730':'MELALB',
  '3737':'BRIALB',
  '3738':'MELALB',
  '3739':'MELALB',
  '3740':'MELALB',
  '3741':'BRIALB',
  '3747':'MELALB',
  '3749':'MELALB',
  '3752':'MELMEL',
  '3754':'BRIMEL',
  '3800':'MELMEL',
  '3802':'MELMEL',
  '3803':'MELMEL',
  '3804':'MELMEL',
  '3805':'MELMEL',
  '3806':'BRIMEL',
  '3807':'BRIMEL',
  '3809':'BRIMEL',
  '3810':'BRIMEL',
  '3910':'MELMEL',
  '3911':'MELMEL',
  '3912':'MELMEL',
  '3913':'MELMEL',
  '3915':'MELMEL',
  '3916':'MELMEL',
  '3918':'MELMEL',
  '3919':'MELMEL',
  '3920':'MELMEL',
  '3926':'MELMEL',
  '3927':'MELMEL',
  '3928':'MELMEL',
  '3929':'MELMEL',
  '3930':'MELMEL',
  '3931':'MELMEL',
  '3933':'MELMEL',
  '3934':'MELMEL',
  '3936':'MELMEL',
  '3937':'MELMEL',
  '3938':'MELMEL',
  '3939':'MELMEL',
  '3940':'MELMEL',
  '3941':'MELMEL',
  '3942':'MELMEL',
  '3943':'MELMEL',
  '3944':'MELMEL',
  '3975':'MELMEL',
  '3976':'MELMEL',
  '3977':'MELMEL',
  '3978':'BRIMEL',
  '4000':'BRIBRI',
  '4001':'BRIBRI',
  '4002':'BRIBRI',
  '4003':'BRIBRI',
  '4004':'BRIBRI',
  '4005':'BRIBRI',
  '4006':'BRIBRI',
  '4007':'BRIBRI',
  '4008':'BRIBRI',
  '4009':'BRIBRI',
  '4010':'BRIBRI',
  '4011':'BRIBRI',
  '4012':'BRIBRI',
  '4013':'BRIBRI',
  '4014':'BRIBRI',
  '4017':'BRIBRI',
  '4018':'BRIBRI',
  '4019':'BRIBRI',
  '4020':'BRIBRI',
  '4021':'BRIBRI',
  '4022':'BRIBRI',
  '4029':'BRIBRI',
  '4030':'BRIBRI',
  '4031':'BRIBRI',
  '4032':'BRIBRI',
  '4034':'BRIBRI',
  '4035':'BRIBRI',
  '4036':'BRIBRI',
  '4037':'BRIBRI',
  '4051':'BRIBRI',
  '4053':'BRIBRI',
  '4054':'BRIBRI',
  '4055':'BRIBRI',
  '4059':'BRIBRI',
  '4060':'BRIBRI',
  '4061':'BRIBRI',
  '4064':'BRIBRI',
  '4065':'BRIBRI',
  '4066':'BRIBRI',
  '4067':'BRIBRI',
  '4068':'BRIBRI',
  '4069':'BRIBRI',
  '4070':'BRIBRI',
  '4072':'BRIBRI',
  '4073':'BRIBRI',
  '4074':'BRIBRI',
  '4075':'BRIBRI',
  '4076':'BRIBRI',
  '4077':'BRIBRI',
  '4078':'BRIBRI',
  '4101':'BRIBRI',
  '4102':'BRIBRI',
  '4103':'BRIBRI',
  '4104':'BRIBRI',
  '4105':'BRIBRI',
  '4106':'BRIBRI',
  '4107':'BRIBRI',
  '4108':'BRIBRI',
  '4109':'BRIBRI',
  '4110':'BRIBRI',
  '4111':'BRIBRI',
  '4112':'BRIBRI',
  '4113':'BRIBRI',
  '4114':'BRIBRI',
  '4115':'BRIBRI',
  '4116':'BRIBRI',
  '4117':'BRIBRI',
  '4118':'BRIBRI',
  '4119':'BRIBRI',
  '4120':'BRIBRI',
  '4121':'BRIBRI',
  '4122':'BRIBRI',
  '4123':'BRIBRI',
  '4124':'BRIBRI',
  '4125':'BRIBRI',
  '4127':'BRIBRI',
  '4128':'BRIBRI',
  '4129':'BRIBRI',
  '4130':'BRIBRI',
  '4131':'BRIBRI',
  '4132':'BRIBRI',
  '4133':'BRIBRI',
  '4151':'BRIBRI',
  '4152':'BRIBRI',
  '4153':'BRIBRI',
  '4154':'BRIBRI',
  '4155':'BRIBRI',
  '4156':'BRIBRI',
  '4157':'BRIBRI',
  '4158':'BRIBRI',
  '4159':'BRIBRI',
  '4160':'BRIBRI',
  '4161':'BRIBRI',
  '4163':'BRIBRI',
  '4164':'BRIBRI',
  '4165':'BRIBRI',
  '4169':'BRIBRI',
  '4170':'BRIBRI',
  '4171':'BRIBRI',
  '4172':'BRIBRI',
  '4173':'BRIBRI',
  '4174':'BRIBRI',
  '4178':'BRIBRI',
  '4179':'BRIBRI',
  '4205':'BRIBRI',
  '4207':'BRIBRI',
  '4208':'BRIBRI',
  '4209':'BRIGLD',
  '4210':'BRIGLD',
  '4211':'BRIGLD',
  '4212':'BRIGLD',
  '4213':'BRIGLD',
  '4214':'BRIGLD',
  '4215':'BRIGLD',
  '4216':'BRIGLD',
  '4217':'BRIGLD',
  '4218':'BRIGLD',
  '4219':'BRIGLD',
  '4220':'BRIGLD',
  '4221':'BRIGLD',
  '4222':'BRIGLD',
  '4223':'BRIGLD',
  '4224':'BRIGLD',
  '4225':'BRIGLD',
  '4226':'BRIGLD',
  '4227':'BRIGLD',
  '4228':'BRIGLD',
  '4230':'BRIGLD',
  '4271':'BRIGLD',
  '4272':'BRIGLD',
  '4275':'BRIGLD',
  '4280':'BRIBRI',
  '4285':'BRIBRI',
  '4300':'BRIBRI',
  '4301':'BRIBRI',
  '4303':'BRIBRI',
  '4304':'BRIBRI',
  '4305':'BRIBRI',
  '4306':'BRITOO',
  '4311':'BRITOO',
  '4341':'BRITOO',
  '4342':'BRITOO',
  '4343':'BRITOO',
  '4344':'BRITOO',
  '4345':'BRITOO',
  '4346':'BRITOO',
  '4347':'BRITOO',
  '4350':'BRITOO',
  '4352':'BRITOO',
  '4355':'BRITOO',
  '4356':'BRITOO',
  '4358':'BRITOO',
  '4359':'BRITOO',
  '4360':'BRITOO',
  '4361':'BRITOO',
  '4362':'BRITOO',
  '4370':'BRITOO',
  '4374':'BRITOO',
  '4375':'BRITOO',
  '4376':'BRITOO',
  '4377':'BRITOO',
  '4378':'BRITOO',
  '4380':'BRITOO',
  '4381':'BRITOO',
  '4382':'BRITOO',
  '4400':'BRITOO',
  '4401':'BRITOO',
  '4405':'BRITOO',
  '4500':'BRIBRI',
  '4501':'BRIBRI',
  '4502':'BRIBRI',
  '4503':'BRIBRI',
  '4504':'BRIBRI',
  '4505':'BRIBRI',
  '4506':'BRIBRI',
  '4507':'BRIBRI',
  '4508':'BRIBRI',
  '4509':'BRIBRI',
  '4510':'BRIBRI',
  '4511':'BRIBRI',
  '4519':'BRISUN',
  '4520':'BRIBRI',
  '4550':'BRISUN',
  '4551':'BRISUN',
  '4552':'BRISUN',
  '4553':'BRISUN',
  '4554':'BRISUN',
  '4555':'BRISUN',
  '4556':'BRISUN',
  '4557':'BRISUN',
  '4558':'BRISUN',
  '4559':'BRISUN',
  '4560':'BRISUN',
  '4561':'BRISUN',
  '4562':'BRISUN',
  '4563':'BRISUN',
  '4564':'BRISUN',
  '4565':'BRISUN',
  '4566':'BRISUN',
  '4567':'BRISUN',
  '4568':'BRISUN',
  '4570':'BRISUN',
  '4572':'BRISUN',
  '4573':'BRISUN',
  '4575':'BRISUN',
  '4650':'BRIMYB',
  '4655':'BRIMYB',
  '4659':'BRIMYB',
  '4660':'BRIBDB',
  '4662':'BRIMYB',
  '4670':'BRIBDB',
  '4671':'BRIBDB',
  '4699':'BRICAP',
  '4700':'BRICAP',
  '4701':'BRICAP',
  '4702':'BRICAP',
  '4703':'BRICAP',
  '4710':'BRICAP',
  '4711':'BRICAP',
  '4737':'BRIMKY',
  '4740':'BRIMKY',
  '4741':'BRIMKY',
  '4750':'BRIMKY',
  '4751':'BRIMKY',
  '4753':'BRIMKY',
  '4800':'BRIMKY',
  '4802':'BRIMKY',
  '4805':'BRIMKY',
  '4806':'BRITVL',
  '4807':'BRITVL',
  '4808':'BRITVL',
  '4809':'BRITVL',
  '4810':'BRITVL',
  '4811':'BRITVL',
  '4812':'BRITVL',
  '4814':'BRITVL',
  '4815':'BRITVL',
  '4816':'BRITVL',
  '4817':'BRITVL',
  '4818':'BRITVL',
  '4820':'BRITVL',
  '4850':'BRITVL',
  '4854':'BRICNS',
  '4855':'BRICNS',
  '4856':'BRICNS',
  '4858':'BRICNS',
  '4859':'BRICNS',
  '4860':'BRICNS',
  '4861':'BRICNS',
  '4865':'BRICNS',
  '4868':'BRICNS',
  '4869':'BRICNS',
  '4870':'BRICNS',
  '4871':'BRICNS',
  '4872':'BRICNS',
  '4873':'BRICNS',
  '4877':'BRICNS',
  '4878':'BRICNS',
  '4879':'BRICNS',
  '4880':'BRICNS',
  '4881':'BRICNS',
  '4882':'BRICNS',
  '4883':'BRICNS',
  '4884':'BRICNS',
  '4885':'BRICNS',
  '5000':'ADLADL',
  '5001':'ADLADL',
  '5005':'ADLADL',
  '5006':'ADLADL',
  '5007':'ADLADL',
  '5008':'ADLADL',
  '5009':'ADLADL',
  '5010':'ADLADL',
  '5011':'ADLADL',
  '5012':'ADLADL',
  '5013':'ADLADL',
  '5014':'ADLADL',
  '5015':'ADLADL',
  '5016':'ADLADL',
  '5017':'ADLADL',
  '5018':'ADLADL',
  '5019':'ADLADL',
  '5020':'ADLADL',
  '5021':'ADLADL',
  '5022':'ADLADL',
  '5023':'ADLADL',
  '5024':'ADLADL',
  '5025':'ADLADL',
  '5031':'ADLADL',
  '5032':'ADLADL',
  '5033':'ADLADL',
  '5034':'ADLADL',
  '5035':'ADLADL',
  '5037':'ADLADL',
  '5038':'ADLADL',
  '5039':'ADLADL',
  '5040':'ADLADL',
  '5041':'ADLADL',
  '5042':'ADLADL',
  '5043':'ADLADL',
  '5044':'ADLADL',
  '5045':'ADLADL',
  '5046':'ADLADL',
  '5047':'ADLADL',
  '5048':'ADLADL',
  '5049':'ADLADL',
  '5050':'ADLADL',
  '5051':'ADLADL',
  '5052':'ADLADL',
  '5061':'ADLADL',
  '5062':'ADLADL',
  '5063':'ADLADL',
  '5064':'ADLADL',
  '5065':'ADLADL',
  '5066':'ADLADL',
  '5067':'ADLADL',
  '5068':'ADLADL',
  '5069':'ADLADL',
  '5070':'ADLADL',
  '5071':'ADLADL',
  '5072':'ADLADL',
  '5073':'ADLADL',
  '5074':'ADLADL',
  '5075':'ADLADL',
  '5076':'ADLADL',
  '5081':'ADLADL',
  '5082':'ADLADL',
  '5083':'ADLADL',
  '5084':'ADLADL',
  '5085':'ADLADL',
  '5086':'ADLADL',
  '5087':'ADLADL',
  '5088':'ADLADL',
  '5089':'ADLADL',
  '5090':'ADLADL',
  '5091':'ADLADL',
  '5092':'ADLADL',
  '5093':'ADLADL',
  '5094':'ADLADL',
  '5095':'ADLADL',
  '5096':'ADLADL',
  '5097':'ADLADL',
  '5098':'ADLADL',
  '5106':'ADLADL',
  '5107':'ADLADL',
  '5108':'ADLADL',
  '5109':'ADLADL',
  '5110':'ADLADL',
  '5111':'ADLADL',
  '5112':'ADLADL',
  '5113':'ADLADL',
  '5114':'ADLADL',
  '5115':'ADLADL',
  '5116':'ADLADL',
  '5117':'ADLADL',
  '5118':'ADLADL',
  '5120':'ADLADL',
  '5121':'ADLADL',
  '5125':'ADLADL',
  '5126':'ADLADL',
  '5127':'ADLADL',
  '5158':'ADLADL',
  '5159':'ADLADL',
  '5160':'ADLADL',
  '5161':'ADLADL',
  '5162':'ADLADL',
  '5163':'ADLADL',
  '5164':'ADLADL',
  '5165':'ADLADL',
  '5166':'ADLADL',
  '5167':'ADLADL',
  '5168':'ADLADL',
  '5169':'ADLADL',
  '5170':'ADLADL',
  '5171':'ADLADL',
  '5172':'ADLADL',
  '5173':'ADLADL',
  '5174':'ADLADL',
  '5350':'ADLADL',
  '5351':'ADLADL',
  '5352':'ADLADL',
  '5353':'ADLADL',
  '5355':'ADLADL',
  '5800':'ADLADL',
  '5810':'ADLADL',
  '5839':'ADLADL',
  '5942':'ADLADL',
  '5950':'ADLADL',
  '6000':'PERPER',
  '6001':'PERPER',
  '6003':'PERPER',
  '6004':'PERPER',
  '6005':'PERPER',
  '6006':'PERPER',
  '6007':'PERPER',
  '6008':'PERPER',
  '6009':'PERPER',
  '6010':'PERPER',
  '6011':'PERPER',
  '6012':'PERPER',
  '6014':'PERPER',
  '6015':'PERPER',
  '6016':'PERPER',
  '6017':'PERPER',
  '6018':'PERPER',
  '6019':'PERPER',
  '6020':'PERPER',
  '6021':'PERPER',
  '6022':'PERPER',
  '6023':'PERPER',
  '6024':'PERPER',
  '6025':'PERPER',
  '6026':'PERPER',
  '6027':'PERPER',
  '6028':'PERPER',
  '6029':'PERPER',
  '6030':'PERPER',
  '6031':'PERPER',
  '6033':'PERPER',
  '6034':'PERPER',
  '6035':'PERPER',
  '6036':'PERPER',
  '6037':'PERPER',
  '6038':'PERPER',
  '6050':'PERPER',
  '6051':'PERPER',
  '6052':'PERPER',
  '6053':'PERPER',
  '6054':'PERPER',
  '6055':'PERPER',
  '6056':'PERPER',
  '6057':'PERPER',
  '6058':'PERPER',
  '6059':'PERPER',
  '6060':'PERPER',
  '6061':'PERPER',
  '6062':'PERPER',
  '6063':'PERPER',
  '6064':'PERPER',
  '6065':'PERPER',
  '6066':'PERPER',
  '6068':'PERPER',
  '6069':'PERPER',
  '6070':'PERPER',
  '6071':'PERPER',
  '6072':'PERPER',
  '6073':'PERPER',
  '6076':'PERPER',
  '6077':'PERPER',
  '6081':'PERPER',
  '6090':'PERPER',
  '6100':'PERPER',
  '6101':'PERPER',
  '6102':'PERPER',
  '6103':'PERPER',
  '6104':'PERPER',
  '6105':'PERPER',
  '6106':'PERPER',
  '6107':'PERPER',
  '6108':'PERPER',
  '6109':'PERPER',
  '6110':'PERPER',
  '6111':'PERPER',
  '6112':'PERPER',
  '6122':'PERPER',
  '6147':'PERPER',
  '6148':'PERPER',
  '6149':'PERPER',
  '6150':'PERPER',
  '6151':'PERPER',
  '6152':'PERPER',
  '6153':'PERPER',
  '6154':'PERPER',
  '6155':'PERPER',
  '6156':'PERPER',
  '6157':'PERPER',
  '6158':'PERPER',
  '6159':'PERPER',
  '6160':'PERPER',
  '6162':'PERPER',
  '6163':'PERPER',
  '6164':'PERPER',
  '6165':'PERPER',
  '6166':'PERPER',
  '6167':'PERPER',
  '6168':'PERPER',
  '6169':'PERPER',
  '6170':'PERPER',
  '6171':'PERPER',
  '6172':'PERPER',
  '6173':'PERPER',
  '6174':'PERPER',
  '6175':'PERPER',
  '6176':'PERPER',
  '6180':'PERPER',
  '6181':'PERPER',
  '6208':'PERPER',
  '6209':'PERPER',
  '6210':'PERPER',
  '6211':'PERPER',
  '6809':'PERPER',
  '6827':'PERPER',
  '6830':'PERPER',
  '6831':'PERPER',
  '6849':'PERPER',
  '6850':'PERPER',
  '6865':'PERPER',
  '6892':'PERPER',
  '6900':'PERPER',
  '6901':'PERPER',
  '6902':'PERPER',
  '6903':'PERPER',
  '6904':'PERPER',
  '6905':'PERPER',
  '6906':'PERPER',
  '6907':'PERPER',
  '6909':'PERPER',
  '6910':'PERPER',
  '6911':'PERPER',
  '6912':'PERPER',
  '6913':'PERPER',
  '6914':'PERPER',
  '6915':'PERPER',
  '6916':'PERPER',
  '6917':'PERPER',
  '6918':'PERPER',
  '6919':'PERPER',
  '6920':'PERPER',
  '6921':'PERPER',
  '6922':'PERPER',
  '6923':'PERPER',
  '6924':'PERPER',
  '6925':'PERPER',
  '6926':'PERPER',
  '6929':'PERPER',
  '6931':'PERPER',
  '6932':'PERPER',
  '6933':'PERPER',
  '6934':'PERPER',
  '6935':'PERPER',
  '6936':'PERPER',
  '6939':'PERPER',
  '6941':'PERPER',
  '6942':'PERPER',
  '6943':'PERPER',
  '6944':'PERPER',
  '6945':'PERPER',
  '6946':'PERPER',
  '6947':'PERPER',
  '6951':'PERPER',
  '6952':'PERPER',
  '6953':'PERPER',
  '6954':'PERPER',
  '6955':'PERPER',
  '6956':'PERPER',
  '6957':'PERPER',
  '6959':'PERPER',
  '6960':'PERPER',
  '6961':'PERPER',
  '6963':'PERPER',
  '6964':'PERPER',
  '6965':'PERPER',
  '6966':'PERPER',
  '6967':'PERPER',
  '6968':'PERPER',
  '6969':'PERPER',
  '6970':'PERPER',
  '6979':'PERPER',
  '6981':'PERPER',
  '6982':'PERPER',
  '6983':'PERPER',
  '6984':'PERPER',
  '6985':'PERPER',
  '6986':'PERPER',
  '6987':'PERPER',
  '6988':'PERPER',
  '6989':'PERPER',
  '6990':'PERPER',
  '6991':'PERPER',
  '6992':'PERPER',
  '6997':'PERPER',
  '7000':'MELTAS',
  '7001':'MELTAS',
  '7002':'MELTAS',
  '7004':'MELTAS',
  '7005':'MELTAS',
  '7006':'MELTAS',
  '7007':'MELTAS',
  '7008':'MELTAS',
  '7009':'MELTAS',
  '7010':'MELTAS',
  '7011':'MELTAS',
  '7015':'MELTAS',
  '7016':'MELTAS',
  '7017':'MELTAS',
  '7018':'MELTAS',
  '7019':'MELTAS',
  '7021':'MELTAS',
  '7025':'MELTAS',
  '7030':'MELTAS',
  '7050':'MELTAS',
  '7051':'MELTAS',
  '7052':'MELTAS',
  '7053':'MELTAS',
  '7054':'MELTAS',
  '7055':'MELTAS',
  '7109':'MELTAS',
  '7140':'MELTAS',
  '7170':'MELTAS',
  '7171':'MELTAS',
  '7172':'MELTAS',
  '7212':'MELLAU',
  '7248':'MELLAU',
  '7249':'MELLAU',
  '7250':'MELLAU',
  '7252':'MELLAU',
  '7253':'MELLAU',
  '7258':'MELLAU',
  '7260':'MELLAU',
  '7262':'MELLAU',
  '7270':'MELLAU',
  '7275':'MELLAU',
  '7276':'MELLAU',
  '7277':'MELLAU',
  '7290':'MELLAU',
  '7291':'MELLAU',
  '7292':'MELLAU',
  '7300':'MELLAU',
  '7301':'MELLAU',
  '7303':'MELLAU',
  '7304':'MELLAU',
  '7307':'MELDPO',
  '7310':'MELDPO',
  '7315':'MELDPO',
  '7316':'MELDPO',
  '7320':'MELDPO',
  '7322':'MELDPO',
  '7325':'MELDPO',
  '8003':'MELMEL',
  '8007':'MELMEL',
  '8008':'MELMEL',
  '8009':'MELMEL',
  '8010':'MELMEL',
  '8011':'MELMEL',
  '8012':'MELMEL',
  '8511':'MELMEL',
  '9000':'BRIBRI',
  '9001':'BRIBRI',
  '9002':'BRIBRI',
  '9005':'BRIBRI',
  '9007':'BRIBRI',
  '9009':'BRIBRI',
  '9010':'BRIBRI',
  '9013':'BRIBRI',
  '9015':'BRIBRI',
  '9464':'BRIBRI',
  '9600':'BRIBRI',
  '9726':'BRIGLD',
};

//logo decryption
var LOGO_DAI="data:image/png;base64,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";
var LOGO_PM="data:image/png;base64,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";
var LOGO_PR="data:image/png;base64,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";
function grd(n){return{display:"grid",gridTemplateColumns:"repeat("+n+",1fr)",gap:8}}
function mvS(c){return{fontSize:20,fontWeight:700,color:c||C.tx,fontVariantNumeric:"tabular-nums"}}

var C={bg:"#06080d",sf:"#0d1117",s2:"#161b22",bd:"#21262d",b2:"#30363d",tx:"#e6edf3",tm:"#8b949e",td:"#ffffff",ac:"#58a6ff",ad:"#1f6feb",gn:"#3fb950",gb:"rgba(63,185,80,.1)",rd:"#f85149",rb:"rgba(248,81,73,.1)",yw:"#d29922",yb:"rgba(210,153,34,.1)",pp:"#bc8cff",cy:"#39d2c0"};
var S={app:{background:C.bg,color:C.tx,minHeight:"100vh",fontFamily:bf,fontSize:11.5,lineHeight:1.5,padding:"12px 16px"},hdr:{marginBottom:16,display:"flex",justifyContent:"space-between",alignItems:"baseline",borderBottom:"1px solid "+C.bd,paddingBottom:10},h1:{fontSize:15,fontWeight:700,letterSpacing:".08em",textTransform:"uppercase",color:C.ac,margin:0},sec:{background:C.sf,border:"1px solid "+C.bd,marginBottom:10,padding:12},st:{fontSize:10,fontWeight:700,textTransform:"uppercase",letterSpacing:".07em",color:C.ac,marginBottom:8,paddingBottom:5,borderBottom:"1px solid "+C.bd},lb:{fontSize:9.5,color:C.tm,textTransform:"uppercase",letterSpacing:".05em",marginBottom:2,display:"block"},inp:{width:"100%",background:C.s2,border:"1px solid "+C.bd,color:C.tx,padding:"5px 7px",fontSize:11.5,fontFamily:bf,boxSizing:"border-box",outline:"none"},sel:{width:"100%",background:C.s2,border:"1px solid "+C.bd,color:C.tx,padding:"5px 7px",fontSize:11.5,fontFamily:bf,boxSizing:"border-box"},tbl:{width:"100%",borderCollapse:"collapse",fontSize:11},th:{textAlign:"left",padding:"5px 6px",borderBottom:"1px solid "+C.b2,color:C.tm,fontWeight:600,fontSize:9.5,textTransform:"uppercase",letterSpacing:".04em",whiteSpace:"nowrap"},thr:{textAlign:"right",padding:"5px 6px",borderBottom:"1px solid "+C.b2,color:C.tm,fontWeight:600,fontSize:9.5,textTransform:"uppercase",letterSpacing:".04em",whiteSpace:"nowrap"},td:{padding:"4px 6px",borderBottom:"1px solid "+C.bd},tdr:{padding:"4px 6px",borderBottom:"1px solid "+C.bd,textAlign:"right",fontVariantNumeric:"tabular-nums"},met:{background:C.s2,border:"1px solid "+C.bd,padding:10,textAlign:"center"},ml:{fontSize:8.5,color:C.tm,textTransform:"uppercase",letterSpacing:".06em",marginTop:3}};
var bf="'IBM Plex Mono','SF Mono',monospace";

function Fl(p){return (<div><label style={S.lb}>{p.l}</label>{p.children}</div>)}
function Mt(p){var px=p.p!==undefined?p.p:"$";return (<div style={S.met}><div style={mvS(p.c)}>{px}{p.v}</div><div style={S.ml}>{p.l}</div></div>)}
function Mb(p){var c=p.m>=p.t?C.gn:p.m>=0?C.yw:C.rd;var b=p.m>=p.t?C.gb:p.m>=0?C.yb:C.rb;return (<span style={{display:"inline-block",padding:"2px 5px",fontSize:9.5,fontWeight:600,color:c,background:b,border:"1px solid "+c+"30"}}>{f(p.m,1)}%</span>)}
function Tog(p){var bs={fontSize:9,padding:"4px 10px",fontFamily:bf,cursor:"pointer",border:"1px solid",borderRadius:0};return (<div style={{display:"flex",gap:1}}><button onClick={function(){p.onChange("target")}} style={{...bs,background:p.v==="target"?C.ad:C.sf,color:p.v==="target"?"#fff":C.tm,borderColor:p.v==="target"?C.ad:C.bd}}>Target</button><button onClick={function(){p.onChange("manual")}} style={{...bs,background:p.v==="manual"?C.ad:C.sf,color:p.v==="manual"?"#fff":C.tm,borderColor:p.v==="manual"?C.ad:C.bd}}>Manual</button></div>)}
function Tog2(p){var bs={fontSize:9,padding:"4px 10px",fontFamily:bf,cursor:"pointer",border:"1px solid",borderRadius:0};return (<div style={{display:"flex",gap:1}}>{p.opts.map(function(o){return (<button key={o[0]} onClick={function(){p.onChange(o[0])}} style={{...bs,background:p.v===o[0]?C.ad:C.sf,color:p.v===o[0]?"#fff":C.tm,borderColor:p.v===o[0]?C.ad:C.bd}}>{o[1]}</button>)})}</div>)}



function AppInner(){
  const { instance, accounts } = useMsal();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showDropdown, setShowDropdown] = useState(false);
 
  const getInitials = (name) => {
    if (!name) return "U";
    const parts = name.trim().split(" ");
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  };

  useEffect(() => {
    const initAuth = async () => {
      setLoading(true);
      if (!accounts || accounts.length === 0) {
        setUser(null);
        setLoading(false);
        return;
      }
      try {
        const request = {
          account: accounts[0],
          scopes: ["openid", "profile", "User.Read"],
        };
        await instance.acquireTokenSilent(request);
        const profile = await getUserProfile(instance, accounts);
        console.log("User profile:", profile);
        setUser(profile);
      } catch (err) {
        console.warn("Silent auth failed:", err);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    initAuth();
  }, [instance, accounts]);
  const handleLogin = () => {
    instance.loginRedirect({
      scopes: ["openid", "profile", "User.Read"],
    });
  };
  const handleLogout = async () => {
    await instance.logoutRedirect();
    setUser(null);
  };
    //get local storage value with safety checks (e.g. for SSR where window is not defined, or if localStorage is unavailable)
  function getLocal(k){
    try{return typeof window!=="undefined"&&window.localStorage?window.localStorage.getItem(k):null}catch(e){return null}
  }
  //set local storage value with safety checks (e.g. for SSR where window is not defined, or if localStorage is unavailable)
  function setLocal(k,v){
    try{if(typeof window!=="undefined"&&window.localStorage){window.localStorage.setItem(k,v);return true}}catch(e){}
    return false;
  }

//============== Zones ==============//
const [zones, setZones] = useState({});
const ZD_ZONES = zones && Object.keys(zones).length > 0 ? zones : ZD_ZONES_M;

const ZD_BUILT = useMemo(() => {
  const m = {};
  Object.keys(ZD_ZONES).forEach(pc => {
    m[pc] = [ZD_ZONES[pc], ""];
  });
  return m;
  console.log("Built zones mapping");
}, [ZD_ZONES]); 

const [ZD, sZD] = useState({});
const [zdLoaded, sZdLoaded] = useState(false);
const [zdLoading, sZdLoading] = useState(true);

async function loadZones() {
  // Try cache first
  let cached = getLocal("zd-postcodes");
  if (cached) {
    try {
      const parsed = JSON.parse(cached);
      if (Object.keys(parsed).length > 0) {
        setZones(parsed);
        const m = {};
        Object.keys(parsed).forEach(pc => {
          m[pc] = [parsed[pc], ""];
        });
        sZD(m);
        sZdLoaded(true);
      }
      console.log("Loaded zones from cache");
    } catch (e) {
      console.warn("Invalid cached zones:", e);
    }
  }

  // Then try API
  try {
    console.log("object id:", accounts[0]);
    const data = await getApiData("zones", accounts[0].localAccountId);
    setZones(data);
    const m = {};
    Object.keys(data).forEach(pc => {
      m[pc] = [data[pc], ""];
    });
    sZD(m);
    sZdLoaded(true);
    setLocal("zd-postcodes", JSON.stringify(data));
    if (typeof window !== "undefined" && window.storage) {
      try {
        await window.storage.set("zd-postcodes", JSON.stringify(data), true);
        console.log("Zones saved to shared storage");
      } catch (err) {
        console.warn("Shared storage update failed:", err);
      }
    }
  } catch (err) {
    console.error("Failed to fetch zones:", err);
    // Fallback to ZD_ZONES_M if API fails
    setZones(ZD_ZONES_M);
    console.log("Using fallback zones mapping");
    const m = {};
    Object.keys(ZD_ZONES_M).forEach(pc => {
      m[pc] = [ZD_ZONES_M[pc], ""];
    });
    sZD(m);
    sZdLoaded(true);
  } finally {
    sZdLoading(false);
  }
}

useEffect(() => {
  loadZones();
}, []);

  //============== Tiers ==============//
  const [tiers, setTiers] = useState([]);
  const [tiersLoaded, setTiersLoaded] = useState(false);
  const [tiersLoading, setTiersLoading] = useState(true);
  
  const TIERS = tiers && Object.keys(tiers).length > 0 ? tiers : TIERS_M;
  

async function loadTiers() {
  let cached = localStorage.getItem("tiers-cache");
  if (cached) {
    try {
      const parsed = JSON.parse(cached);
      if (Object.keys(parsed).length > 0) {
        setTiers(parsed);
        setTiersLoaded(true);
        console.log("Tiers loaded from cache");
      }
    } catch (e) {
      console.warn("Invalid cached tiers:", e);
    }
  }

  try {
    const data = await getApiData("tiers", accounts[0].localAccountId);
    setTiers(data);
    setTiersLoaded(true);
    localStorage.setItem("tiers-cache", JSON.stringify(data));
    console.log("Tiers loaded from API and cached");
  } catch (err) {
    console.error("Failed to fetch tiers:", err);
    // Fallback
    setTiers(TIERS_M);
    setTiersLoaded(true);
    console.log("Using fallback tiers mapping");
  } finally {
    setTiersLoading(false);
  }
}
  useEffect(() => {
  loadTiers();
}, []);

//============== Trucking ==============//
  const [trucking, setTrucking] = useState({});
  const [truckingLoaded, setTruckingLoaded] = useState(false);
  const [truckingLoading, setTruckingLoading] = useState(true);
  
  const TRK = trucking && Object.keys(trucking).length > 0 ? trucking : TRK_M;
  

  async function loadTrucking() {
  let cached = localStorage.getItem("trucking-cache");
  if (cached) {
    try {
      const parsed = JSON.parse(cached);
      if (Object.keys(parsed).length > 0) {
        setTrucking(parsed);
        setTruckingLoaded(true);
        console.log("Trucking data loaded from cache");
      }
    } catch (e) {
      console.warn("Invalid cached trucking data:", e);
    }
  }

  try {
    const data = await getApiData("trucking", accounts[0].localAccountId);
    setTrucking(data);
    setTruckingLoaded(true);
    localStorage.setItem("trucking-cache", JSON.stringify(data));
    console.log("Trucking data loaded from API and cached");
  } catch (err) {
    console.error("Failed to fetch trucking data:", err);
    // Fallback
    setTrucking(TRK_M);
    setTruckingLoaded(true);
    console.log("Using fallback trucking mapping");
  } finally {
    setTruckingLoading(false);
  }
}
  useEffect(() => {
  loadTrucking();
}, []);


//============== DESTSCAN ==============//
  const [destscan, setDestscan] = useState({});
  const [destscanLoaded, setDestscanLoaded] = useState(false);
  const [destscanLoading, setDestscanLoading] = useState(true);
  
  const SSC = destscan && Object.keys(destscan).length > 0 ? destscan : SSC_M;
  

  async function loadDestscan() {
  let cached = localStorage.getItem("destscan-cache");
  if (cached) {
    try {
      const parsed = JSON.parse(cached);
      if (Object.keys(parsed).length > 0) {
        setDestscan(parsed);
        setDestscanLoaded(true);
        console.log("Destscan data loaded from cache");
      }
    } catch (e) {
      console.warn("Invalid cached destscan data:", e);
    }
  }

  try {
    const data = await getApiData("destscan", accounts[0].localAccountId);
    setDestscan(data);
    setDestscanLoaded(true);
    localStorage.setItem("destscan-cache", JSON.stringify(data));
    console.log("Destscan data loaded from API and cached");
  } catch (err) {
    console.error("Failed to fetch destscan data:", err);
    // Fallback
    setDestscan(SSC_M);
    setDestscanLoaded(true);
    console.log("Using fallback destscan mapping");
  } finally {
    setDestscanLoading(false);
  }
}

  useEffect(() => {
  loadDestscan();
}, []);

//============== FMC ==============//
  const [fmc, setFmc] = useState({});
  const [fmcLoaded, setFmcLoaded] = useState(false);
  const [fmcLoading, setFmcLoading] = useState(true);
  
const FMC_AX = fmc && Object.keys(fmc).length > 0 ? fmc : FMC_AX_M;

  async function loadFmc() {
  let cached = localStorage.getItem("fmc-cache");
  if (cached) {
    try {
      const parsed = JSON.parse(cached);
      if (Object.keys(parsed).length > 0) {
        setFmc(parsed);
        setFmcLoaded(true);
        console.log("FMC data loaded from cache");
      }
    } catch (e) {
      console.warn("Invalid cached FMC data:", e);
    }
  }

  try {
    const data = await getApiData("fmc", accounts[0].localAccountId);
    setFmc(data);
    setFmcLoaded(true);
    localStorage.setItem("fmc-cache", JSON.stringify(data));
    console.log("FMC data loaded from API and cached");
  } catch (err) {
    console.error("Failed to fetch FMC data:", err);
    // Fallback
    setFmc(FMC_AX);
    setFmcLoaded(true);
    console.log("Using fallback FMC mapping");
  } finally {
    setFmcLoading(false);
  }
}

  useEffect(() => {
  loadFmc();
}, []);

async function reloadAll() {
  await Promise.all([
    loadZones(),
    loadTiers(),
    loadTrucking(),
    loadDestscan(),
    loadFmc()
  ]);
  console.log("All datasets reloaded");
}

  //Zone Data Upload Handler  
  function handleZdUpload(e){

    var file=e.target.files[0];if(!file)return;
    var reader=new FileReader();
    reader.onload=async function(ev){
      try{
        var data=JSON.parse(ev.target.result);
        if(Object.keys(data).length<100)return;
        sZD(data);
        var payload=JSON.stringify(data);
        var saved=false;

        await postZones(payload,user.id);
        
        // try{if(typeof window!=="undefined"&&window.storage){await window.storage.set("zd-postcodes",payload,true);saved=true}}catch(se){}
        // if(!saved)setLocal("zd-postcodes",payload);

      }catch(pe){}
    };
    reader.readAsText(file);
  }

  var [prod,sProd]=useState("pm");
  var [cust,sCust]=useState("");
  var [origin,sOrigR]=useState("LHR");
  var [vol,sVol]=useState(100000);
  var [avgWt,sWt]=useState(0.68);
  var [oppDim,sDim]=useState(1.2);
  var [fxM,sFxM]=useState("budgeted");
  var [fxO,sFxO]=useState({...FXD});
  var [fscOn,sFscOn]=useState(true);
  var [custFscOn,sCustFscOn]=useState(false);
  var [daffMode,sDaffMode]=useState("passthrough");
  var axPricing=true; // New Aramex rates always active
  var [disp,sDisp]=useState(function(){return JSON.parse(JSON.stringify(DD))});
  var [wDist,sWD]=useState(function(){return PMW.map(function(b){return b.p})});
  // PMA-specific 11-break weight distribution (overrides wDist mapping when set)
  var [wDistPMA,sWDistPMA]=useState(function(){return PMAW.map(function(){return 0})});
  var [dispMode,sDispMode]=useState("standard");
  var DW_STD=PMW.map(function(b){return b.p});
  var aDisp=dispMode==="standard"?DD:disp;
  var FMC=axPricing?FMC_AX:FMC_OLD;
  var aWDist=dispMode==="standard"?DW_STD:wDist;
  // 11-break PMA distribution: use wDistPMA if set (sums>0), else convert 7-band wDist (split ≤500g 50/50)
  var aWDistPMA=(function(){var sum=wDistPMA.reduce(function(a,b){return a+(+b||0)},0);if(sum>0)return wDistPMA;var c=[aWDist[0]/2,aWDist[0]/2,aWDist[1]||0,aWDist[2]||0,aWDist[3]||0,aWDist[4]||0,aWDist[5]||0,(aWDist[6]||0)/4,(aWDist[6]||0)/4,(aWDist[6]||0)/4,(aWDist[6]||0)/4];return c})();
  var [kgMode,sKgM]=useState("target");var [ppMode,sPpM]=useState("target");
  var [pmWtBasis,sPmWtBasis]=useState("vol");
  var [pmZones,sPmZ]=useState(1);
  var [pmRoutingCosts,sPmRoutingCosts]=useState(null); // {z1:[7],z2:[7],z3:[7],synced:ts} — routing-derived Leg 3 costs per PMW break
  var [pmBillingData,sPmBillingData]=useState(null);  // parsed 4-week billing CSV data
  var [pmBillingMsg,sPmBillingMsg]=useState("");       // upload status message
  var pmBillingRef=useRef(null);
  var [kgTgt,sKgT]=useState(20);var [ppTgt,sPpT]=useState(20);
  var [mPK,sMPK]=useState(0);var [mPP,sMPP]=useState(function(){return PMW.map(function(){return 0})});
  var [mPP3,sMPP3]=useState(function(){return [1,2,3].map(function(){return PMW.map(function(){return 0})})});
  var [ppRefine,sPpRefine]=useState(false);
  // V2 feature: per-zone lock — locked zones use target rate, unlocked zones use cost+margin
  var [prLockZones,sPrLockZones]=useState({});
  var [prCostPlusMargin,sPrCostPlusMargin]=useState(15); // % margin for unlocked zones
  var [ppExclW,sPpExclW]=useState({});
  var [ppExclZ,sPpExclZ]=useState({});
  var [pmCustTgtOn,sPmCustTgtOn]=useState(false);
  var [pmCustTgt,sPmCustTgt]=useState(function(){return PMW.map(function(){return 0})});
  var [prTgts,sPrTgts]=useState([{on:false,label:"Competitor 1",rates:{}},{on:false,label:"Competitor 2",rates:{}}]);
  var [prMeetIdx,sPrMeetIdx]=useState(0);
  var [prCbWi,sPrCbWi]=useState(0);
  // Backward-compat computed vars (read-only — most existing code uses these)
  var prCustTgtOn=prTgts[0]?prTgts[0].on:false;var prCustTgt=prTgts[0]?prTgts[0].rates:{};var prTgtLabel1=prTgts[0]?prTgts[0].label:"Competitor 1";
  var prCustTgt2On=prTgts.length>1&&prTgts[1]?prTgts[1].on:false;var prCustTgt2=prTgts.length>1&&prTgts[1]?prTgts[1].rates:{};var prTgtLabel2=prTgts.length>1&&prTgts[1]?prTgts[1].label:"Competitor 2";
  var prMeetWhich=prMeetIdx+1;
  // Setter wrappers (update the array via index)
  function updTgt(idx,field,val){sPrTgts(function(prev){var n=prev.map(function(t,i){return i===idx?Object.assign({},t,function(){var o={};o[field]=val;return o}()):t});return n})}
  function sPrCustTgtOn(v){updTgt(0,"on",v)}function sPrCustTgt(v){updTgt(0,"rates",v)}function sPrTgtLabel1(v){updTgt(0,"label",v)}
  function sPrCustTgt2On(v){if(prTgts.length<2)sPrTgts(function(p){return p.concat([{on:v,label:"Competitor 2",rates:{}}])});else updTgt(1,"on",v)}
  function sPrCustTgt2(v){if(prTgts.length<2)sPrTgts(function(p){return p.concat([{on:true,label:"Competitor 2",rates:v}])});else updTgt(1,"rates",v)}
  function sPrTgtLabel2(v){if(prTgts.length<2)return;updTgt(1,"label",v)}
  function sPrMeetWhich(v){sPrMeetIdx(v-1)}
  // Dynamic target helpers
  function addPrTgt(){sPrTgts(function(prev){return prev.concat([{on:true,label:"Competitor "+(prev.length+1),rates:{},source:"manual"}])})}
  function removePrTgt(idx){sPrTgts(function(prev){return prev.filter(function(_,i){return i!==idx})});if(prMeetIdx>=idx&&prMeetIdx>0)sPrMeetIdx(prMeetIdx-1)}
  function generateLCR(){
    // Find all enabled targets with rates
    var sources=prTgts.filter(function(t){return t.on&&t.rates&&Object.keys(t.rates).length>0});
    if(sources.length<2)return;
    // Collect all zone keys across all targets
    var allZones={};
    sources.forEach(function(t){Object.keys(t.rates).forEach(function(zk){allZones[zk]=true})});
    // For each zone × weight: take the minimum non-zero rate
    var lcrRates={};
    Object.keys(allZones).forEach(function(zk){
      lcrRates[zk]=PRW.map(function(_,wi){
        var best=Infinity;var found=false;
        sources.forEach(function(t){
          var r=t.rates[zk];
          if(r&&r[wi]>0&&r[wi]<best){best=r[wi];found=true}
        });
        return found?Math.round(best*100)/100:0;
      });
    });
    // Build label from source names
    var names=sources.map(function(t){return t.label});
    var lcrLabel="LCR ("+names.join(" / ")+")";
    // Add as a new target or update existing LCR target
    var existingIdx=-1;
    prTgts.forEach(function(t,i){if(t.label.indexOf("LCR (")===0)existingIdx=i});
    if(existingIdx>=0){
      updTgt(existingIdx,"rates",lcrRates);updTgt(existingIdx,"label",lcrLabel);updTgt(existingIdx,"on",true);
    }else{
      sPrTgts(function(prev){return prev.concat([{on:true,label:lcrLabel,rates:lcrRates,source:"calculated"}])});
    }
  }
  function generateZ1MetroFloor(){
    var src=prTgts[prMeetIdx];
    if(!src||!src.on||!src.rates||Object.keys(src.rates).length===0)return;
    // Toggle off — restore pre-floor rates
    if(src.source==='z1-floor'&&src.preFloorRates){
      updTgt(prMeetIdx,'rates',JSON.parse(JSON.stringify(src.preFloorRates)));
      updTgt(prMeetIdx,'source','mapped');
      updTgt(prMeetIdx,'preFloorRates',null);
      return;
    }
    var rawZM=src.rawZoneMap;
    if(!rawZM){alert("Raw zone map not available — please re-map the competitor rates to enable Z1 Metro Floor.");return;}
    // Store current rates before applying floor so they can be restored
    updTgt(prMeetIdx,'preFloorRates',JSON.parse(JSON.stringify(src.rates)));
    var newRates=JSON.parse(JSON.stringify(src.rates));
    // For each state Z1 zone, find minimum rate per weight break across contributing comp zones
    Object.keys(newRates).forEach(function(dz){
      if(!dz.endsWith('-Z1'))return;
      var compZones=rawZM[dz];if(!compZones||Object.keys(compZones).length===0)return;
      var floorRates=PRW.map(function(_,wi){
        var best=Infinity;var found=false;
        Object.keys(compZones).forEach(function(cz){
          var r=compZones[cz][wi];
          if(r>0&&r<best){best=r;found=true;}
        });
        return found?Math.round(best*100)/100:newRates[dz][wi];
      });
      newRates[dz]=floorRates;
    });
    updTgt(prMeetIdx,'rates',newRates);
    updTgt(prMeetIdx,'source','z1-floor');
  }
  var [lkw,sLkw]=useState(LKW.LHR);var [dtR,sDtR]=useState(0.17);
  var [existingKgWk,sExistingKgWk]=useState(0); // KGs/week of existing volume affected by rate change
  var [existingKgRate,sExistingKgRate]=useState(0); // current/existing rate per kg in customer currency
  var [l2Mode,sL2Mode]=useState("standard");
  var [l2Str,sL2Str]=useState("kgpc");
  var [l2Unit,sL2Unit]=useState("AKE");
  var [l2UnitKg,sL2UnitKg]=useState(750);
  var [l2AkePct,sL2AkePct]=useState(50);
  var [l2CtoDoc,sL2CtoDoc]=useState(78);
  var [l2CtoThk,sL2CtoThk]=useState(0.29);
  var [l2Depot,sL2Depot]=useState(0.35);
  var [l2FuelPrice,sL2FuelPrice]=useState(3.00);
  var [pmaInj,sPmaInj]=useState({MEL:true,SYD:false,BNE:false,PER:false});
  var [pmaOrig,sPmaOrig]=useState("HKG");
  var [pmaCc,sPmaCc]=useState(1.13);
  var [pmaKT,sPmaKT]=useState(20);var [pmaPT,sPmaPT]=useState(20);var [pmaPpMode,sPmaPpM]=useState("target");var [pmaPpR,sPmaPpR]=useState({});
  var [pmaPpRefine,sPmaPpRefine]=useState(false);
  var [pmaPpExclZ,sPmaPpExclZ]=useState({});
  var [pmaPpExclW,sPmaPpExclW]=useState({});
  var [pmaWtMode,sPmaWtM]=useState("phys");
  var [pmaPpWtMode,sPmaPpWtM]=useState("phys");
  var [pmaDim,sPmaDim]=useState(1.2);
  var [pmaCcy,sPmaCcy]=useState("local");
  var [showAUD,sShowAUD]=useState(false);
  var [pmaCFsc,sPmaCFsc]=useState(false);
  var [pmaCFscRate,sPmaCFscRate]=useState(0);
  var [pmaPpFscPct,sPmaPpFscPct]=useState(0); // per-piece delivery FSC % (e.g. 9% Evri surcharge on last-mile rate)
  // Asendia eBay simulation: reduce vol airfreight cost by GBP 0.27/kg if active
  var [afCostReduce,sAfCostReduce]=useState(false);
  var [pmaChinaSpecial,sPmaChinaSpec]=useState(false);
  var [dgfFlexAll,sDgfFlexAll]=useState(false);
  var [dgfDieselPrice,sDgfDieselPrice]=useState(1.85);
  var [pmaKgMode,sPmaKgM]=useState("target");
  var [pmaKgTgt,sPmaKgTgt]=useState(0); // customer's current per-KG rate to meet
  var [pmaMPK,sPmaMPK]=useState(0);
  var [pmaMPK_AKE,sPmaMPK_AKE]=useState(0);
  var [pmaMPK_PMC,sPmaMPK_PMC]=useState(0);
  var [pmaGranR,sPmaGranR]=useState({});
  var [pmaMPPL2,sPmaMPPL2]=useState(0);
  var [custTgtOn,sCustTgtOn]=useState(false);
  var [custTgtM,sCustTgtM]=useState(function(){return PMAW.map(function(){return 0})});
  var [custTgtR,sCustTgtR]=useState(function(){return PMAW.map(function(){return 0})});
  var [prD,sPrD]=useState("MEL");
  var [prM,sPrM]=useState(null);
  var [prMOverride,sPrMO]=useState(false);
  var [prDim,sPrDim]=useState(1.3);
  var [prRef,sPrRef]=useState(0.10);
  var [prCompBasis,sPrCompBasis]=useState("unknown");// physical|volumetric|unknown
  var [prCompFsc,sPrCompFsc]=useState("inclusive");// inclusive|exclusive|unknown
  var [prCompFscPct,sPrCompFscPct]=useState(5);

  var [oppId,sOppId]=useState(null);
  var [appStarted,sAppStarted]=useState(false);
  var [mainTab,sMainTab]=useState("pricing");
  var [pmRouting,sPmRouting]=useState(null);
  var [prRouting,sPrRouting]=useState(null);
  var [rtView,sRtView]=useState("pm");
  var [rtSection,sRtSection]=useState("summary");
  var [rtSearch,sRtSearch]=useState("");
  var [rtSearchResult,sRtSearchResult]=useState(null);
  var [rtPmZoneView,sRtPmZoneView]=useState(1);
  var [rtZoneSource,sRtZoneSource]=useState("routing"); // "routing" | "billing"
  var [pmRtSave,sPmRtSave]=useState(null); // null | "saving" | "saved" | "error"
  var [prRtSave,sPrRtSave]=useState(null);
  var pmRtRef=useRef(null);
  var prRtRef=useRef(null);
  var [oppList,sOppList]=useState([]);
  var [oppLoading,sOppLoading]=useState(false);
  var [saveAsMode,sSaveAsMode]=useState(false);
  var [saveAsName,sSaveAsName]=useState("");
  var [deleteConfirm,sDeleteConfirm]=useState(false);
  var [renameMode,sRenameMode]=useState(false);
  var [renameName,sRenameName]=useState("");
  var [hasCustDisp,sHasCustDisp]=useState(false);
  var saveRef=useRef(null);
  var oppCache=useRef({});

  var [loadMsg,sLoadMsg]=useState("");
  var storageOK=useRef(false);

  // Storage: ALWAYS use shared=true so all users in this chat see the same data
  var STORE_KEY="pricing-agent-v2";
  async function trySave(data){
    var payload=JSON.stringify(data);
    if(typeof window!=="undefined"&&window.storage){
      try{
        var r=await window.storage.set(STORE_KEY,payload,true);
        if(r!==null&&r!==undefined){storageOK.current="shared";sOppSaveStatus("shared");return "shared"}
        // set() returned null — shared storage silently failed, do not claim success
        console.log("Shared storage set returned null — falling back to localStorage");
      }catch(e){console.log("Shared storage set error:",e)}
    }
    if(setLocal(STORE_KEY,payload)){storageOK.current="local";sOppSaveStatus("local");return "localStorage"}
    sOppSaveStatus("failed");return null;
  }
  async function tryLoad(){
    // 1. Try shared storage first (visible to all users in chat)
    if(typeof window!=="undefined"&&window.storage){
      try{var r=await window.storage.get(STORE_KEY,true);if(r&&r.value){storageOK.current="shared";return JSON.parse(r.value)}}catch(e){}
    }
    // 2. Check localStorage -- if found, migrate to shared so others can see it
    try{
      var local=getLocal(STORE_KEY);
      if(local){
        var parsed=JSON.parse(local);
        storageOK.current="local";
        // Migrate: push localStorage data up to shared storage
        if(typeof window!=="undefined"&&window.storage){
          try{await window.storage.set(STORE_KEY,local,true);storageOK.current="migrated"}catch(e){}
        }
        return parsed;
      }
    }catch(e){}
    return null;
  }
  function downloadBackup(label){
    var bk={version:1,date:new Date().toISOString(),opps:{}};
    Object.keys(oppCache.current).forEach(function(id){
      var opp=JSON.parse(JSON.stringify(oppCache.current[id]));
      if(opp.prTgts)opp.prTgts=opp.prTgts.map(function(t){return{on:t.on,label:t.label,rates:t.rates,source:t.source,zoneMap:t.zoneMap||null,preFloorRates:t.preFloorRates||null,rawZoneMap:t.rawZoneMap||null,rawRates:t.rawRates||null,nativeBreaks:t.nativeBreaks||null,nativeRates:t.nativeRates||null,pcZones:t.pcZones||null}});
      bk.opps[id]=opp;
    });
    var blob=new Blob([JSON.stringify(bk)],{type:"application/json"});
    var url=URL.createObjectURL(blob);
    var a=document.createElement("a");a.href=url;
    a.download="pricing_"+(label||"backup")+"_"+new Date().toISOString().slice(0,10)+".json";
    a.click();URL.revokeObjectURL(url);
  }
  async function saveAllOpps(){
    // Strip heavy transient data from targets before saving
    var cleaned={};
    Object.keys(oppCache.current).forEach(function(id){
      var opp=JSON.parse(JSON.stringify(oppCache.current[id]));
      if(opp.prTgts)opp.prTgts=opp.prTgts.map(function(t){return{on:t.on,label:t.label,rates:t.rates,source:t.source,zoneMap:t.zoneMap||null,preFloorRates:t.preFloorRates||null,rawZoneMap:t.rawZoneMap||null,rawRates:t.rawRates||null,nativeBreaks:t.nativeBreaks||null,nativeRates:t.nativeRates||null,pcZones:t.pcZones||null}});
      cleaned[id]=opp;
    });
    var data={v:2,opps:cleaned,ts:new Date().toISOString()};
    var method=await trySave(data);
    return method;
  }
  // Show restore prompt if no data found
  var [showRestorePrompt,sShowRestorePrompt]=useState(false);
  async function refreshFromShared(){
    try{
      var data=await tryLoad();
      if(!data||!data.opps){sSaveMsg("No shared data found");setTimeout(function(){sSaveMsg("")},3000);return}
      var items=[];
      Object.keys(data.opps).forEach(function(id){
        var d=data.opps[id];
        oppCache.current[id]=d;
        items.push({key:"opp:"+id,id:id,name:d.cust||"Unnamed",prod:d.prod||"pr",updated:d.updated||""});
      });
      sOppList(items);
      if(storageOK.current==="shared"||storageOK.current==="migrated")sOppSaveStatus(null);
      sSaveMsg("Refreshed: "+items.length+" opps loaded from shared storage");
      setTimeout(function(){sSaveMsg("")},4000);
    }catch(e){sSaveMsg("Refresh error: "+e.message);setTimeout(function(){sSaveMsg("")},4000)}
  }
  useEffect(function(){
    (async function(){
      try{
        sLoadMsg("Loading...");
        var data=await tryLoad();
        var items=[];
        if(data&&data.opps){
          Object.keys(data.opps).forEach(function(id){
            var p=data.opps[id];
            oppCache.current[id]=p;
            items.push({key:"opp:"+id,id:id,name:p.cust||"Unnamed",prod:p.prod||"pm",updated:p.updated||""});
          });
          sLoadMsg(items.length+" opps loaded"+(storageOK.current==="shared"?" ✓ shared":(storageOK.current==="migrated"?" ✓ migrated to shared":(storageOK.current==="local"?" ⚠ local only":""))));
        }else{
          sLoadMsg("");sShowRestorePrompt(true);
        }
        // Seed check: only create if not in loaded data
        function seedMissing(id){return !items.find(function(o){return o.id===id})}
        console.log("Seeding check: "+items.length+" opps loaded, checking seeds...");
        var dispFull={NSW:{pct:31.6,z1:63.8,z2:23.5,z3:12.7},VIC:{pct:25.0,z1:74.7,z2:16.4,z3:8.9},QLD:{pct:21.0,z1:43.1,z2:37.0,z3:19.9},WA:{pct:12.1,z1:78.5,z2:14.0,z3:7.5},SA:{pct:6.2,z1:75.8,z2:15.7,z3:8.5},TAS:{pct:1.8,z1:55.6,z2:28.9,z3:15.6},ACT:{pct:1.7,z1:100,z2:0,z3:0},NT:{pct:0.5,z1:60,z2:0,z3:40}};
        var dispMetro={NSW:{pct:31.0,z1:100,z2:0,z3:0},VIC:{pct:28.7,z1:100,z2:0,z3:0},QLD:{pct:13.9,z1:100,z2:0,z3:0},WA:{pct:14.6,z1:100,z2:0,z3:0},SA:{pct:7.2,z1:100,z2:0,z3:0},TAS:{pct:1.5,z1:100,z2:0,z3:0},ACT:{pct:2.6,z1:100,z2:0,z3:0},NT:{pct:0.5,z1:100,z2:0,z3:0}};
        var rincosBase={prod:"pma",pmaOrig:"OTH",avgWt:0.7,pmaDim:1.6,pmaCcy:"AUD",pmaWtMode:"phys",pmaKT:20,pmaPT:20,pmaCFsc:false,pmaCFscRate:0,pmaChinaSpecial:false,pmaKgMode:"manual",pmaMPK:1.23,pmaPpMode:"target",pmaPpR:{},pmaPpRefine:false,pmaPpExclZ:{Z3:true,Z4:true},pmaPpExclW:{},axPricing:true,daffMode:"passthrough",dispMode:"customer",fscOn:true,custFscOn:false,fxM:"budgeted",fxO:{USD:.65,GBP:.5},l2Mode:"standard",l2FuelPrice:3.00,wDist:[45,25,15,7,3,2,2,1,0,0,0],custTgtOn:true,custTgtM:[5.61,5.61,5.64,5.70,5.95,6.24,6.61,0,0,0,0],custTgtR:[5.65,5.65,5.65,5.79,5.94,6.31,6.72,0,0,0,0],hasCustDisp:true};
        var rincosScenarios=[
          {id:"rincos_syd_full",cust:"Rincos (iHerb) -- SYD Metro+Rural",vol:2040000,pmaInj:{MEL:false,SYD:true,BNE:false,PER:false},disp:dispFull},
          {id:"rincos_syd_metro",cust:"Rincos (iHerb) -- SYD Metro Only",vol:1329277,pmaInj:{MEL:false,SYD:true,BNE:false,PER:false},disp:dispMetro},
          {id:"rincos_4p_full",cust:"Rincos (iHerb) -- 4-Port Metro+Rural",vol:2040000,pmaInj:{MEL:true,SYD:true,BNE:true,PER:true},disp:dispFull},
          {id:"rincos_4p_metro",cust:"Rincos (iHerb) -- 4-Port Metro Only",vol:1329277,pmaInj:{MEL:true,SYD:true,BNE:true,PER:true},disp:dispMetro}
        ];
        for(var ri=0;ri<rincosScenarios.length;ri++){
          var rsc=rincosScenarios[ri];if(seedMissing(rsc.id)){
            var rState={...rincosBase,...rsc,updated:new Date().toISOString()};
            oppCache.current[rsc.id]=rState;
            items.push({key:"opp:"+rsc.id,id:rsc.id,name:rsc.cust,prod:"pma",updated:rState.updated});
          }
        }
        // Next (DPD) -- LHR
        if(seedMissing("next_lhr")){
          var nextState={prod:"pm",cust:"Next (DPD) -- LHR",origin:"LHR",vol:900000,avgWt:1.07,oppDim:2.14,
            kgMode:"manual",mPK:2.67,ppMode:"meet",ppTgt:20,kgTgt:20,pmZones:1,pmWtBasis:"vol",
            ppRefine:true,mPP:[5.58,5.70,6.24,6.64,7.88,8.44,9.12],mPP3:[[],[],[]],
            ppExclW:{},ppExclZ:{},pmCustTgtOn:true,pmCustTgt:[2.79,2.85,3.12,3.32,3.94,4.22,4.56],
            daffMode:"passthrough",dtR:0.17,showAUD:false,
            fxM:"budgeted",fxO:{USD:.65,GBP:.5},fscOn:true,custFscOn:true,
            dispMode:"standard",disp:{},wDist:[27,29,30,9,3,0,0],
            l2Mode:"standard",l2Str:"kgonly",axPricing:true,
            lkw:30945,
            updated:new Date().toISOString()};
          oppCache.current["next_lhr"]=nextState;
          items.push({key:"opp:next_lhr",id:"next_lhr",name:"Next (DPD) -- LHR",prod:"pm",updated:nextState.updated});
        }

        // SF (Evri) -- MEL (China Parcel Max Access Ex Melbourne)
        // Source: SF AUS last mile target rate 0408 spreadsheet (Evri destination zones)
        // Rob email 24/04/2026: DGF Z1 ONLY (Z1+Z2 merged per DAI Post agreement), min 60k pcs/80k KGs/wk
        // MAX 5KG DEADWEIGHT — wi 6-10 excluded. Clearance: AUD 0.29/pc + AUD 0.40/kg. Rates ex FSC ex GST.
        // 3-PORT INJECTION: MEL+SYD+BNE — each city injects locally, NO LINEHAUL. Z1 only per port.
        // Routing: DGF for <=3kg (cheaper last-mile), Aramex for 4-5kg (cheaper on new contract)
        // Revenue: per-zone via pmaPpR — VIC-Z1/NSW-Z1/QLD-Z1 each get exact Evri metro target rates (no blending)
        // DGF FSC WAIVED: 60k pcs/wk = 12,000/day (5-day) exceeds 7,000/day ADV threshold.
        // Customer FSC 9% (per Rob) charged on revenue side. Coverage: MEL/SYD/BNE metro Z1 only.
        // Migration: remove all old SF Evri seeds
        ["sf_evri_mel","sf_evri_mel2","sf_evri_mel3","sf_evri_mel4"].forEach(function(k){if(!seedMissing(k)&&window.storage){window.storage.delete("opp:"+k,true).catch(function(){});}items=items.filter(function(x){return x.id!==k});});
        // SF Evri: smart seed — only update config fields, preserve user's pricing/leg2 settings
        // PATCH existing SF Evri opp with required SF-specific fields if missing (safe — only fills gaps)
        if(!seedMissing("sf_evri")&&oppCache.current["sf_evri"]){
          var sfPatch=oppCache.current["sf_evri"];
          if(sfPatch.dgfFlexAll===undefined)sfPatch.dgfFlexAll=true;
          if(sfPatch.pmaPpFscPct===undefined)sfPatch.pmaPpFscPct=9;
          if(sfPatch.pmaPpRefine===undefined)sfPatch.pmaPpRefine=true;
          var pmaPpRBad=!sfPatch.pmaPpR||Object.keys(sfPatch.pmaPpR).length===0;
          if(!pmaPpRBad){
            var v=sfPatch.pmaPpR["VIC-Z1"]||[],n=sfPatch.pmaPpR["NSW-Z1"]||[],q=sfPatch.pmaPpR["QLD-Z1"]||[];
            // Bad if any zone missing, wrong wi=0, or all three identical (corruption)
            if(!v.length||!n.length||!q.length)pmaPpRBad=true;
            else if(v[0]!==2.45||n[0]!==2.41||q[0]!==3.14)pmaPpRBad=true;
            else if(v[1]===n[1]&&n[1]===q[1])pmaPpRBad=true; // all identical = corruption
          }
          if(pmaPpRBad){sfPatch.pmaPpR={"VIC-Z1":[2.45,2.75,2.86,3.01,3.30,4.59,4.70,0,0,0,0],"NSW-Z1":[2.41,2.78,2.87,3.00,3.26,4.20,4.16,0,0,0,0],"QLD-Z1":[3.14,3.13,3.38,3.70,3.79,4.67,4.67,0,0,0,0]};}
          if(!sfPatch.pmaPpExclZ||(!sfPatch.pmaPpExclZ.Z3&&!sfPatch.pmaPpExclZ.Z4)){sfPatch.pmaPpExclZ={Z3:true,Z4:true};}
          if(!sfPatch.pmaPpExclW||!sfPatch.pmaPpExclW[7]){sfPatch.pmaPpExclW={7:true,8:true,9:true,10:true};}
          if(!sfPatch.pmaInj||sfPatch.pmaInj.BNE!==false){sfPatch.pmaInj={MEL:true,SYD:true,BNE:false,PER:false};}
          if(sfPatch.dgfDieselPrice===undefined)sfPatch.dgfDieselPrice=1.85;
          // Persist patched data back to storage so future loads get correct values
          if(window.storage){window.storage.set("opp:sf_evri",JSON.stringify(sfPatch),true).catch(function(){});}
        }
        // SIMPLE SEED: only create if missing. Never overwrite user changes.
        if(seedMissing("sf_evri")){
          var sfDefaults={prod:"pma",cust:"SF (Evri)",pmaOrig:"OTH",
            pmaInj:{MEL:true,SYD:true,BNE:false,PER:false},
            vol:3120000,avgWt:1.33,pmaDim:1.3,pmaCcy:"AUD",pmaWtMode:"phys",
            pmaKT:15,pmaPT:15,pmaCFsc:true,pmaCFscRate:9,pmaChinaSpecial:false,
            pmaPpMode:"meet",
            pmaPpR:{"VIC-Z1":[2.45,2.75,2.86,3.01,3.30,4.59,4.70,0,0,0,0],"NSW-Z1":[2.41,2.78,2.87,3.00,3.26,4.20,4.16,0,0,0,0],"QLD-Z1":[3.14,3.13,3.38,3.70,3.79,4.67,4.67,0,0,0,0]},
            pmaPpFscPct:9,
            pmaPpRefine:true,pmaPpExclZ:{Z3:true,Z4:true},pmaPpExclW:{7:true,8:true,9:true,10:true},
            daffMode:"passthrough",fscOn:true,custFscOn:true,dgfFlexAll:true,
            fxM:"budgeted",fxO:{USD:.65,GBP:.5},
            custTgtOn:true,
            custTgtM:[2.45,2.75,2.86,3.01,3.30,4.59,4.70,0,0,0,0],
            custTgtR:[0,0,0,0,0,0,0,0,0,0,0],
            lkw:80000,seedVersion:5};
          // User-editable fields: preserve existing if present, else use defaults
          var sfEvriState=Object.assign({},sfDefaults,{
            pmaKgMode:"target",pmaMPK:0,pmaMPK_AKE:0,pmaMPK_PMC:0,pmaGranR:false,pmaMPPL2:0,
            l2Mode:"standard",l2FuelPrice:3.00,l2AkePct:50,dgfDieselPrice:1.85,
            wDist:[32,27,22,11,5,3,0,0,0,0,0],
            wDistPMA:[16,16,27,22,11,5,3,0,0,0,0],
            dispMode:"customer",hasCustDisp:true,
            custDisp:{NSW:{pct:39.6,z1:100,z2:0,z3:0},VIC:{pct:32.4,z1:100,z2:0,z3:0},QLD:{pct:28.0,z1:100,z2:0,z3:0}},
            existingKgWk:0,existingKgRate:0,existingNewRate:0,
            updated:new Date().toISOString()
          });
          oppCache.current["sf_evri"]=sfEvriState;
          items=items.filter(function(x){return x.id!=="sf_evri"});
          items.push({key:"opp:sf_evri",id:"sf_evri",name:"SF (Evri)",prod:"pma",updated:sfEvriState.updated});
        }

        // Asendia UK (ebay) -- LHR
        // New eBay business: 326,343 pcs/yr, avg phys 1.4kg, dim 2.1 => vol wt 2.94kg
        // Proposed kg rate GBP 3.03 (vol) + GBP 2.80/pc also applied to existing biz (was GBP 3.23/kg).
        // NOTE: Rate reduction on existing ~15k kg/wk = ~GBP 3k/wk margin impact -- model separately.
        // Rob email margin estimate ~15%. Run lane DIM calc (Excel) to confirm DIM impact.
        if(seedMissing("asendia_uk_ebay")){
          // Lane data from 12/04/2026: 40,739 parcels, 39,257 KGs (0.96kg avg)
          // eBay new biz: 326,343 pcs/yr, 1.4kg phys, 2.1 dim => 8,786 KGs/wk
          // DIM blend: lane 1.38 + ebay 2.10 => blended 1.54 (+0.159) => A$-1.54M/yr on existing lane
          // Existing rate reduction GBP 3.23->3.03 (GBP 0.20/kg): 4wk avg 8,535 KGs/wk => ~GBP 89k/yr impact
          var asendiaEbayState={prod:"pm",cust:"Asendia UK (ebay)",origin:"LHR",vol:326343,avgWt:1.4,oppDim:2.1,
            kgMode:"target",kgTgt:15,ppMode:"target",ppTgt:15,pmZones:1,pmWtBasis:"vol",
            mPK:0,mPP:[0,0,0,0,0,0,0],mPP3:[[],[],[]],
            ppRefine:false,ppExclW:{},ppExclZ:{},pmCustTgtOn:false,pmCustTgt:[0,0,0,0,0,0,0],
            daffMode:"passthrough",dtR:0.17,showAUD:false,
            fxM:"budgeted",fxO:{USD:.65,GBP:.5},fscOn:true,custFscOn:false,
            dispMode:"standard",disp:{},wDist:[10,20,35,20,8,4,3],
            axPricing:true,l2Mode:"standard",l2Str:"kgonly",
            lkw:39257,
            existingKgWk:8535,existingKgRate:3.23,
            updated:new Date().toISOString()};
          oppCache.current["asendia_uk_ebay"]=asendiaEbayState;
          items.push({key:"opp:asendia_uk_ebay",id:"asendia_uk_ebay",name:"Asendia UK (ebay)",prod:"pm",updated:asendiaEbayState.updated});
        }

        // One-time eStore setup (PR domestic)
        // Map competitor 8 weight breaks [XP250,XP0,XP1,XP3,XP5,PWF10,PWF15,PWF25] to our 10 PR breaks [0.5,1,2,3,4,5,7,10,15,22]
        function mapR8(r){return[r[1],r[2],Math.round((r[2]+r[3])/2*100)/100,r[3],Math.round((r[3]+r[4])/2*100)/100,r[4],Math.round((r[4]+r[5])/2*100)/100,r[5],r[6],r[7]]}
        // iMile 9 breaks [0.25,0.5,1,2,3,5,10,15,20] to our 10 [0.5,1,2,3,4,5,7,10,15,22]
        function mapI9(r){return[r[1],r[2],r[3],r[4],Math.round((r[4]+r[5])/2*100)/100,r[5],Math.round((r[5]+r[6])/2*100)/100,r[6],r[7],r[8]]}

        // CP ex-SYD -- rates cross-referenced by actual DAI zone postcode file (10 PR breaks)
        var cpSyd={"ACT-Z1":[6.07,6.35,6.53,6.71,7.07,7.43,9.33,11.23,12.88,16.16],"NSW-Z1":[4.63,4.79,4.89,4.98,5.19,5.39,7.33,9.27,10.41,12.68],"NSW-Z2":[8.5,8.88,9.05,9.22,9.52,9.83,12.32,14.82,17.04,21.47],"NSW-Z3":[20.78,21.7,22.17,22.63,23.63,24.63,26.75,28.88,33.65,43.19],
          "VIC-Z1":[5.96,6.14,6.27,6.39,6.61,6.82,7.34,7.86,8.84,10.17],"VIC-Z2":[12.17,12.69,12.97,13.25,13.8,14.34,14.78,15.21,18.32,21.61],"VIC-Z3":[21.53,22.47,22.94,23.41,24.46,25.51,27.31,29.11,33.64,41.29],
          "QLD-Z1":[6.13,6.4,6.46,6.51,6.65,6.78,9.17,11.57,13.63,17.75],"QLD-Z2":[16.46,17.28,17.65,18.01,18.71,19.41,22.26,25.12,30.22,40.41],"QLD-Z3":[26.8,27.86,28.49,29.12,30.13,31.14,35.25,39.36,47.75,64.53],
          "SA-Z1":[5.58,5.73,5.78,5.84,6.04,6.23,7.62,9.0,10.02,12.08],"SA-Z2":[16.61,17.54,18.01,18.47,19.41,20.35,20.9,21.45,23.66,28.23],"SA-Z3":[23.75,24.7,25.17,25.65,27.07,28.5,29.51,30.52,36.27,47.77],
          "WA-Z1":[8.22,8.65,8.91,9.18,9.48,9.78,13.26,16.74,21.02,29.59],"WA-Z2":[26.05,27.0,27.47,27.95,29.36,30.78,34.78,38.77,49.04,69.57],"WA-Z3":[31.41,32.3,32.74,33.19,34.52,35.85,42.38,48.91,60.91,84.9],
          "TAS-Z1":[26.48,27.84,28.31,28.79,29.74,30.69,23.47,16.25,17.53,20.86],"NT-Z3":[93.73,93.94,94.05,94.16,94.37,94.58,94.5,94.43,100.48,112.57]};

        // CP ex-MEL -- rates cross-referenced by actual DAI zone postcode file (10 PR breaks)
        var cpMel={"ACT-Z1":[6.07,6.35,6.53,6.71,7.07,7.43,9.39,11.34,12.98,16.35],"VIC-Z1":[5.07,5.24,5.34,5.44,5.65,5.86,6.86,7.86,8.68,10.25],"VIC-Z2":[11.62,12.13,12.39,12.66,13.18,13.7,14.42,15.14,17.95,22.21],"VIC-Z3":[21.52,22.45,22.92,23.39,24.44,25.49,26.63,27.77,35.04,40.98],
          "NSW-Z1":[5.43,5.54,5.7,5.87,6.07,6.27,7.83,9.39,10.58,12.84],"NSW-Z2":[9.26,9.67,9.92,10.16,10.63,11.09,13.41,15.72,18.17,23.12],"NSW-Z3":[20.81,21.74,22.2,22.67,23.67,24.67,28.46,32.24,37.81,49.8],
          "QLD-Z1":[6.13,6.31,6.39,6.47,6.62,6.78,9.22,11.66,13.69,17.86],"QLD-Z2":[16.47,17.28,17.65,18.02,18.72,19.41,22.96,26.5,31.38,41.96],"QLD-Z3":[26.8,27.86,28.49,29.12,30.13,31.14,36.26,41.39,49.84,65.97],
          "SA-Z1":[5.36,5.47,5.63,5.8,6.0,6.2,7.75,9.31,10.57,13.42],"SA-Z2":[16.61,17.54,18.01,18.47,19.41,20.35,21.92,23.49,28.23,42.14],"SA-Z3":[23.75,24.7,25.17,25.65,27.07,28.5,28.5,28.5,38.0,47.77],
          "WA-Z1":[7.45,7.74,7.96,8.18,8.63,9.09,12.92,16.74,21.02,29.59],"WA-Z2":[26.05,27.0,27.47,27.95,29.36,30.78,34.78,38.77,49.04,69.57],"WA-Z3":[31.41,32.3,32.74,33.19,34.52,35.85,42.38,48.91,60.91,84.9],
          "TAS-Z1":[26.48,27.84,28.31,28.79,29.74,30.69,23.69,16.69,19.18,23.36],"NT-Z3":[93.73,93.94,94.05,94.16,94.37,94.58,94.57,94.56,100.64,112.79]};

        // iMile ex-SYD -- cross-referenced via CP postcodes to DAI zones (10 PR breaks)
        // WA/TAS/NT omitted -- not in iMile rate card (no comparison shown for those zones)
        var imSyd={"NSW-Z1":[3.61,3.83,4.05,4.38,5.25,6.12,7.63,9.15,15.24,16.93],"NSW-Z2":[4.63,4.84,5.06,5.26,6.3,7.33,9.18,11.03,17.26,18.8],"NSW-Z3":[4.94,5.16,5.39,5.56,6.64,7.72,9.69,11.67,17.89,19.39],
          "VIC-Z1":[4.3,5.0,5.72,5.77,7.44,9.1,11.83,14.55,21.71,25.17],"VIC-Z2":[4.96,5.53,6.24,6.41,7.94,9.47,12.59,15.71,22.93,26.4],"VIC-Z3":[5.54,5.98,6.71,6.95,8.36,9.77,13.22,16.67,23.94,27.41],
          "QLD-Z1":[4.25,5.11,5.96,6.2,8.17,10.13,13.1,16.07,23.8,28.62],"QLD-Z2":[5.08,5.92,6.78,7.02,8.8,10.58,14.15,17.73,25.42,29.53],"QLD-Z3":[5.24,6.1,6.97,7.21,8.97,10.73,14.46,18.19,25.92,29.95],
          "SA-Z1":[4.61,6.03,7.47,9.19,12.7,16.22,17.24,18.26,25.47,30.2],"SA-Z2":[5.28,6.33,7.38,9.56,12.28,14.99,16.02,17.06,26.44,31.17],
          "ACT-Z1":[4.94,5.16,5.39,5.56,6.64,7.72,9.7,11.67,17.9,19.39]};

        // iMile ex-MEL -- cross-referenced via CP postcodes to DAI zones (10 PR breaks)
        var imMel={"VIC-Z1":[3.64,3.86,4.07,4.4,5.27,6.13,7.67,9.21,15.33,17.06],"VIC-Z2":[4.23,4.46,4.65,4.96,5.86,6.76,8.65,10.53,16.75,18.52],"VIC-Z3":[4.84,5.02,5.2,5.49,6.43,7.38,9.58,11.79,18.07,19.87],
          "NSW-Z1":[4.25,4.96,5.69,5.72,7.44,9.16,11.82,14.47,21.67,25.14],"NSW-Z2":[5.29,5.94,6.59,6.8,8.73,10.65,13.52,16.39,24.09,27.72],"NSW-Z3":[5.57,6.22,6.86,7.1,9.1,11.1,14.05,17.0,24.88,28.57],
          "QLD-Z1":[4.73,5.74,6.75,6.76,9.36,11.95,15.28,18.6,27.94,32.89],"QLD-Z2":[5.58,6.41,7.26,7.46,9.88,12.3,16.98,21.67,29.12,34.01],"QLD-Z3":[5.74,6.55,7.37,7.61,10.0,12.4,17.39,22.37,29.45,34.36],
          "SA-Z1":[4.37,5.14,5.91,6.16,7.85,9.53,12.15,14.77,22.03,25.82],"SA-Z2":[5.34,6.12,6.89,7.15,8.74,10.32,13.53,16.74,24.0,27.7],"SA-Z3":[5.35,6.13,6.9,7.16,8.75,10.33,13.56,16.78,24.04,27.73],
          "ACT-Z1":[5.57,6.22,6.86,7.1,9.1,11.1,14.05,17.0,24.88,28.57]};

        var eStoreDefs=[
          {id:"estore_syd",cust:"eStore -- ex-SYD",prD:"SYD",imile:imSyd,cp:cpSyd},
          {id:"estore_mel",cust:"eStore -- ex-MEL",prD:"MEL",imile:imMel,cp:cpMel}
        ];
        for(var esi=0;esi<eStoreDefs.length;esi++){
          var esd=eStoreDefs[esi];if(seedMissing(esd.id)){
            var esState={prod:"pr",cust:esd.cust,vol:1825000,avgWt:0.8,prD:esd.prD,prDim:1.3,prRef:0.10,
              prM:null,prMOverride:false,ppMode:"target",ppTgt:20,ppRefine:false,ppExclW:{},ppExclZ:{},
              prCustTgtOn:true,prCustTgt:esd.imile,prTgtLabel1:"iMile",
              prCustTgt2On:true,prCustTgt2:esd.cp,prTgtLabel2:"Couriers Please",
              prMeetWhich:2,
              axPricing:true,dispMode:"standard",
              disp:JSON.parse(JSON.stringify(DD)),wDist:[67.7,16.2,9.3,3,1.4,0.8,1.6],
              fscOn:true,l2FuelPrice:3.00,daffMode:"passthrough",
              updated:new Date().toISOString()};
            oppCache.current[esd.id]=esState;
            items.push({key:"opp:"+esd.id,id:esd.id,name:esd.cust,prod:"pr",updated:esState.updated});
          }
        }

        // One-time ECMS setup
        var ecmsDisp={NSW:{pct:34.1,z1:79.2,z2:8.8,z3:12.0},VIC:{pct:29.4,z1:85.0,z2:4.8,z3:10.2},QLD:{pct:17.1,z1:58.5,z2:24.0,z3:17.5},WA:{pct:8.5,z1:85.9,z2:11.8,z3:2.4},SA:{pct:6.3,z1:84.1,z2:15.9,z3:0},ACT:{pct:3.0,z1:100,z2:0,z3:0},TAS:{pct:1.3,z1:76.9,z2:0,z3:23.1},NT:{pct:0.4,z1:75,z2:0,z3:25}};
        var ecmsTgt=[4.19,4.29,4.81,5.28,5.95,6.73,7.31,8.55,10.41,13.52,18.38];
        var ecmsDefs=[
          {id:"ecms_jp",cust:"ECMS -- ex-Japan (SYD+PER)",vol:780000,avgWt:1.0,pmaDim:1.2,
            pmaInj:{MEL:false,SYD:true,BNE:false,PER:true},wDist:[40,30,20,5,3,1,1,0,0,0,0]},
          {id:"ecms_cn",cust:"ECMS -- ex-China (SYD+PER)",vol:730000,avgWt:1.0,pmaDim:1.2,
            pmaInj:{MEL:false,SYD:true,BNE:false,PER:true},wDist:[67.7,16.2,9.3,3,1.4,0.8,1.6,0,0,0,0]}
        ];
        for(var ei=0;ei<ecmsDefs.length;ei++){
          var ed=ecmsDefs[ei];if(seedMissing(ed.id)){
            var ecmsState={prod:"pma",cust:ed.cust,pmaOrig:"OTH",vol:ed.vol,avgWt:ed.avgWt,pmaDim:ed.pmaDim,pmaCcy:"AUD",pmaWtMode:"phys",
              pmaKT:20,pmaPT:20,pmaCFsc:false,pmaCFscRate:0,pmaChinaSpecial:false,pmaKgMode:"manual",pmaMPK:0.45,pmaMPPL2:0.16,
              pmaPpMode:"meet",pmaPpR:{},pmaPpRefine:false,pmaPpExclZ:{},pmaPpExclW:{},
              axPricing:true,daffMode:"inclusive",dispMode:"customer",fscOn:true,custFscOn:false,
              fxM:"budgeted",fxO:{USD:.65,GBP:.5},l2Mode:"granular",l2Str:"kgpc",l2FuelPrice:3.00,
              wDist:ed.wDist,pmaInj:ed.pmaInj,
              disp:ecmsDisp,hasCustDisp:true,
              custTgtOn:true,custTgtM:ecmsTgt,custTgtR:ecmsTgt,
              updated:new Date().toISOString()};
            oppCache.current[ed.id]=ecmsState;
            items.push({key:"opp:"+ed.id,id:ed.id,name:ed.cust,prod:"pma",updated:ecmsState.updated});
          }
        }

        // One-time UBI setup with delivery-only targets (UBI rates × 0.92)
        var ubiDefs=[
          {id:"ubi_syd",cust:"UBI -- ex-SYD",pmaInj:{MEL:false,SYD:true,BNE:false,PER:false},
            custTgtM:[4.57,4.64,5.78,6.53,6.74,7.24,7.68,8.91,10.46,12.48,15.87],
            custTgtR:[7.50,7.50,11.12,13.37,13.69,14.20,15.55,18.27,23.44,30.06,41.70]},
          {id:"ubi_mel",cust:"UBI -- ex-MEL",pmaInj:{MEL:true,SYD:false,BNE:false,PER:false},
            custTgtM:[4.56,4.65,5.75,6.46,6.65,7.19,7.62,8.86,10.39,12.38,15.68],
            custTgtR:[7.67,7.67,11.91,14.41,14.81,15.38,16.85,19.73,25.31,32.37,44.93]},
          {id:"ubi_bne",cust:"UBI -- ex-BNE",pmaInj:{MEL:false,SYD:false,BNE:true,PER:false},
            custTgtM:[5.02,5.05,6.44,7.41,7.60,8.12,8.71,10.01,11.86,14.39,18.58],
            custTgtR:[7.57,7.57,11.79,14.35,14.71,15.32,16.96,20.32,26.54,34.59,48.84]}
        ];
        for(var ui=0;ui<ubiDefs.length;ui++){
          var ud=ubiDefs[ui];if(seedMissing(ud.id)){
            var uState={prod:"pma",cust:ud.cust,pmaOrig:"OTH",vol:1000000,avgWt:1.0,pmaDim:1.3,pmaCcy:"AUD",pmaWtMode:"phys",
              pmaKT:20,pmaPT:20,pmaCFsc:false,pmaCFscRate:0,pmaChinaSpecial:false,pmaKgMode:"manual",pmaMPK:0.97,pmaMPPL2:0.32,
              pmaPpMode:"meet",pmaPpR:{},pmaPpRefine:false,pmaPpExclZ:{},pmaPpExclW:{},
              axPricing:true,daffMode:"passthrough",dispMode:"standard",fscOn:true,custFscOn:false,
              fxM:"budgeted",fxO:{USD:.65,GBP:.5},l2Mode:"granular",l2Str:"kgpc",l2FuelPrice:3.00,
              wDist:[67.7,16.2,9.3,3,1.4,0.8,1.6,0,0,0,0],
              pmaInj:ud.pmaInj,custTgtOn:true,custTgtM:ud.custTgtM,custTgtR:ud.custTgtR,
              updated:new Date().toISOString()};
            oppCache.current[ud.id]=uState;
            items.push({key:"opp:"+ud.id,id:ud.id,name:ud.cust,prod:"pma",updated:uState.updated});
          }
        }
        sOppList(items);
        // Persist -- fire and forget, don't let save failure block the UI
        try{saveAllOpps()}catch(e){}
      }catch(e){console.log("Opp load error:",e)}
    })();
  },[]);

  // Load persisted routing data on mount
  useEffect(function(){
    (async function(){
      try{
        if(typeof window!=="undefined"&&window.storage){
          var pmR=await window.storage.get("routing-pm-v1",true);
          if(pmR&&pmR.value){try{sPmRouting(JSON.parse(pmR.value))}catch(pe){console.log("PM routing parse error:",pe)}}
          var prR=await window.storage.get("routing-pr-v1",true);
          if(prR&&prR.value){try{sPrRouting(JSON.parse(prR.value))}catch(pe){console.log("PR routing parse error:",pe)}}
          var bilR=await window.storage.get("billing-pm-v1",true);
          if(bilR&&bilR.value){
            try{
              var bilParsed=JSON.parse(bilR.value);
              // Version check — old format missing standard/pobox split, discard it
              var sampleSup=bilParsed.supplierMix&&Object.values(bilParsed.supplierMix)[0];
              if(sampleSup&&sampleSup.standard!==undefined){
                sPmBillingData(bilParsed);
              }else{
                console.log("Billing data in old format — discarding, please re-upload");
                window.storage.delete("billing-pm-v1",true).catch(function(){});
              }
            }catch(be){console.log("Billing parse error:",be)}
          }
          // Load global billing rates (written by confirmBillingCommit, independent of opps)
          var brR=await window.storage.get("billing-rates-v1",true);
          if(brR&&brR.value){try{sPmRoutingCosts(JSON.parse(brR.value))}catch(bre){console.log("Billing rates load error:",bre)}}
        }
      }catch(e){console.log("Routing load error:",e)}
    })();
  },[]);

  function getState(){
    return{prod:prod,cust:cust,origin:origin,vol:vol,avgWt:avgWt,oppDim:oppDim,fxM:fxM,fxO:fxO,fscOn:fscOn,custFscOn:custFscOn,daffMode:daffMode,dispMode:dispMode,axPricing:axPricing,disp:disp,wDist:wDist,hasCustDisp:hasCustDisp,
      kgMode:kgMode,ppMode:ppMode,pmWtBasis:pmWtBasis,pmZones:pmZones,kgTgt:kgTgt,ppTgt:ppTgt,mPK:mPK,mPP:mPP,mPP3:mPP3,ppRefine:ppRefine,ppExclW:ppExclW,ppExclZ:ppExclZ,prLockZones:prLockZones,prCostPlusMargin:prCostPlusMargin,pmCustTgtOn:pmCustTgtOn,pmCustTgt:pmCustTgt,prCustTgtOn:prCustTgtOn,prCustTgt:prCustTgt,prTgts:prTgts.map(function(t){return{on:t.on,label:t.label,rates:t.rates,source:t.source,zoneMap:t.zoneMap||null,preFloorRates:t.preFloorRates||null,rawZoneMap:t.rawZoneMap||null,rawRates:t.rawRates||null,nativeBreaks:t.nativeBreaks||null,nativeRates:t.nativeRates||null,pcZones:t.pcZones||null}}),prMeetIdx:prMeetIdx,lkw:lkw,dtR:dtR,existingKgWk:existingKgWk,existingKgRate:existingKgRate,afCostReduce:afCostReduce,
      l2Mode:l2Mode,l2Str:l2Str,l2Unit:l2Unit,l2UnitKg:l2UnitKg,l2AkePct:l2AkePct,l2CtoDoc:l2CtoDoc,l2CtoThk:l2CtoThk,l2Depot:l2Depot,l2FuelPrice:l2FuelPrice,
      pmaInj:pmaInj,pmaOrig:pmaOrig,pmaCc:pmaCc,pmaKT:pmaKT,pmaPT:pmaPT,pmaWtMode:pmaWtMode,pmaPpWtMode:pmaPpWtMode,pmaDim:pmaDim,pmaCcy:pmaCcy,showAUD:showAUD,pmaCFsc:pmaCFsc,pmaCFscRate:pmaCFscRate,pmaPpFscPct:pmaPpFscPct,pmaChinaSpecial:pmaChinaSpecial,pmaKgMode:pmaKgMode,pmaKgTgt:pmaKgTgt,pmaMPK:pmaMPK,pmaMPK_AKE:pmaMPK_AKE,pmaMPK_PMC:pmaMPK_PMC,pmaGranR:pmaGranR,pmaMPPL2:pmaMPPL2,pmaPpMode:pmaPpMode,pmaPpR:pmaPpR,pmaPpRefine:pmaPpRefine,pmaPpExclZ:pmaPpExclZ,pmaPpExclW:pmaPpExclW,custTgtOn:custTgtOn,custTgtM:custTgtM,custTgtR:custTgtR,dgfFlexAll:dgfFlexAll,dgfDieselPrice:dgfDieselPrice,wDistPMA:wDistPMA,
      prD:prD,prM:prM,prMOverride:prMOverride,prDim:prDim,prRef:prRef,prCompBasis:prCompBasis,prCompFsc:prCompFsc,prCompFscPct:prCompFscPct,
      gpSnap:(function(){
        try{
          if(prod==='pm'&&pmP&&costs){
            var daffInc=daffMode==='inclusive'?DAFF:0;
            var ppC=pmP.bFMC+daffInc;
            var kgCpk=costs.upKg;
            var ppR=pmP.avgPP;var kgRpk=pmP.effPhysTotal;
            var totR=kgRpk*avgWt+ppR;var totC=kgCpk*avgWt+ppC;
            var totGP=totR-totC;var netGP=totGP*vol+(dim&&dim.lbY||0);var netRev=totR*vol;
            var netM=netRev>0?Math.round(netGP/netRev*1000)/10:0;
            return{revPc:Math.round(totR*100)/100,costPc:Math.round(totC*100)/100,gpPc:Math.round(totGP*100)/100,legPc:Math.round(ppC*100)/100,gpPct:netM,gpAnnual:Math.round(netGP),revAnnual:Math.round(netRev)};
          }
          if(prod==='pma'&&pma&&costs){
            var daffInc2=daffMode==='inclusive'?DAFF:0;
            var totR2=0;var totC2=0;var totW2=0;
            // if(card&&card.rc){card.rc.forEach(function(r){var ds=aDisp[r.st];if(!ds||ds.pct<=0)return;var zPct=r.z===1?ds.z1:r.z===2?ds.z2:ds.z3;var w=ds.pct*zPct/10000;if(w<=0)return;r.rates.forEach(function(rt,i){if(!rt.excl){var wm=i===0?aWDist[0]/2:i===1?aWDist[0]/2:i<=6?aWDist[i-1]:aWDist[6]/4;totR2+=rt.rate*wm/100*w;totC2+=rt.cost*wm/100*w;totW2+=wm/100*w}})});}
            if(totW2>0){totR2/=totW2;totC2/=totW2;}
            var totGP2=totR2-totC2;var netGP2=totGP2*vol;var netRev2=totR2*vol;
            var netM2=netRev2>0?Math.round(netGP2/netRev2*1000)/10:0;
            return{revPc:Math.round(totR2*100)/100,costPc:Math.round(totC2*100)/100,gpPc:Math.round(totGP2*100)/100,legPc:0,gpPct:netM2,gpAnnual:Math.round(netGP2),revAnnual:Math.round(netRev2)};
          }
        }catch(e){}
        return null;
      })(),
      uploadInfo:uploadInfo?{pieces:uploadInfo.pieces,avgW:uploadInfo.avgW,avgDim:uploadInfo.avgDim,stTotal:uploadInfo.stTotal,hasDisp:uploadInfo.hasDisp,hasWb:uploadInfo.hasWb,hasDim:uploadInfo.hasDim,file:uploadInfo.file,fileCount:uploadInfo.fileCount,dimCount:uploadInfo.dimCount,dimSource:uploadInfo.dimSource,noDimPct:uploadInfo.noDimPct,noDimCount:uploadInfo.noDimCount,detectedCols:uploadInfo.detectedCols,totalRows:uploadInfo.totalRows,filteredRows:uploadInfo.filteredRows,filtered:uploadInfo.filtered,fileStats:uploadInfo.fileStats,dimVolGtCount:uploadInfo.dimVolGtCount,dimZeroCount:uploadInfo.dimZeroCount,dimNaNCount:uploadInfo.dimNaNCount,dimSamples:uploadInfo.dimSamples,noDimAvgWt:uploadInfo.noDimAvgWt,allCols:uploadInfo.allCols,wtSamples:uploadInfo.wtSamples}:null,
      updated:new Date().toISOString()};
  }
  function loadState(s){
    if(s.prod)sProd(s.prod);if(s.cust!==undefined)sCust(s.cust);if(s.origin)sOrigR(s.origin);if(s.vol)sVol(s.vol);if(s.avgWt)sWt(s.avgWt);if(s.oppDim)sDim(s.oppDim);
    if(s.fxM)sFxM(s.fxM);if(s.fxO)sFxO(s.fxO);if(s.fscOn!==undefined)sFscOn(s.fscOn);if(s.custFscOn!==undefined)sCustFscOn(s.custFscOn);if(s.daffMode)sDaffMode(s.daffMode);if(s.dispMode)sDispMode(s.dispMode);
    if(s.disp){sDisp(s.disp);if(s.hasCustDisp!==undefined){sHasCustDisp(s.hasCustDisp)}else if(s.dispMode==="customer"){sHasCustDisp(true)}}else{sDisp(JSON.parse(JSON.stringify(DD)));sHasCustDisp(false)}
    if(s.wDist)sWD(s.wDist);else sWD(PMW.map(function(b){return b.p}));
    if(s.kgMode)sKgM(s.kgMode);if(s.ppMode)sPpM(s.ppMode);if(s.pmWtBasis)sPmWtBasis(s.pmWtBasis);if(s.pmZones)sPmZ(s.pmZones);if(s.kgTgt)sKgT(s.kgTgt);if(s.ppTgt)sPpT(s.ppTgt);
    if(s.mPK!==undefined)sMPK(s.mPK);else sMPK(0);if(s.mPP)sMPP(s.mPP);else sMPP(PMW.map(function(){return 0}));if(s.mPP3)sMPP3(s.mPP3);else sMPP3([1,2,3].map(function(){return PMW.map(function(){return 0})}));if(s.ppRefine!==undefined)sPpRefine(s.ppRefine);else sPpRefine(false);if(s.prLockZones)sPrLockZones(s.prLockZones);else sPrLockZones({});if(s.prCostPlusMargin!==undefined)sPrCostPlusMargin(s.prCostPlusMargin);else sPrCostPlusMargin(15);if(s.ppExclW)sPpExclW(s.ppExclW);else sPpExclW({});if(s.ppExclZ)sPpExclZ(s.ppExclZ);else sPpExclZ({});if(s.pmCustTgtOn!==undefined)sPmCustTgtOn(s.pmCustTgtOn);else sPmCustTgtOn(false);if(s.pmCustTgt)sPmCustTgt(s.pmCustTgt);else sPmCustTgt(PMW.map(function(){return 0}));if(s.lkw)sLkw(s.lkw);if(s.dtR!==undefined)sDtR(s.dtR);if(s.existingKgWk!==undefined)sExistingKgWk(s.existingKgWk);else sExistingKgWk(0);if(s.existingKgRate!==undefined)sExistingKgRate(s.existingKgRate);else sExistingKgRate(0);
    // Load PR targets — new dynamic format or migrate from old
    if(s.prTgts){sPrTgts(s.prTgts);sPrMeetIdx(s.prMeetIdx||0)}
    else{var migTgts=[];
      if(s.prCustTgtOn||s.prCustTgt){migTgts.push({on:!!s.prCustTgtOn,label:s.prTgtLabel1||"Competitor 1",rates:s.prCustTgt||{}})}
      if(s.prCustTgt2On||s.prCustTgt2){migTgts.push({on:!!s.prCustTgt2On,label:s.prTgtLabel2||"Competitor 2",rates:s.prCustTgt2||{}})}
      if(migTgts.length===0)migTgts=[{on:false,label:"Competitor 1",rates:{}},{on:false,label:"Competitor 2",rates:{}}];
      sPrTgts(migTgts);sPrMeetIdx(s.prMeetWhich?s.prMeetWhich-1:0);
    }
    if(s.l2Mode)sL2Mode(s.l2Mode);if(s.l2Str)sL2Str(s.l2Str);if(s.l2Unit)sL2Unit(s.l2Unit);if(s.l2UnitKg)sL2UnitKg(s.l2UnitKg);if(s.l2AkePct!==undefined)sL2AkePct(s.l2AkePct);
    if(s.l2CtoDoc!==undefined)sL2CtoDoc(s.l2CtoDoc);if(s.l2CtoThk!==undefined)sL2CtoThk(s.l2CtoThk);if(s.l2Depot!==undefined)sL2Depot(s.l2Depot);if(s.l2FuelPrice)sL2FuelPrice(s.l2FuelPrice);
    if(s.pmaInj)sPmaInj(s.pmaInj);if(s.pmaOrig)sPmaOrig(s.pmaOrig);if(s.pmaCc!==undefined)sPmaCc(s.pmaCc);if(s.pmaKT)sPmaKT(s.pmaKT);if(s.pmaPT)sPmaPT(s.pmaPT);
    if(s.pmaWtMode)sPmaWtM(s.pmaWtMode);if(s.pmaPpWtMode)sPmaPpWtM(s.pmaPpWtMode);if(s.pmaDim)sPmaDim(s.pmaDim);if(s.pmaCcy)sPmaCcy(s.pmaCcy);if(s.showAUD!==undefined)sShowAUD(s.showAUD);if(s.pmaCFsc!==undefined)sPmaCFsc(s.pmaCFsc);
    if(s.pmaCFscRate!==undefined)sPmaCFscRate(s.pmaCFscRate);if(s.pmaPpFscPct!==undefined)sPmaPpFscPct(s.pmaPpFscPct);else sPmaPpFscPct(0);if(s.pmaChinaSpecial!==undefined)sPmaChinaSpec(s.pmaChinaSpecial);if(s.dgfFlexAll!==undefined)sDgfFlexAll(s.dgfFlexAll);else sDgfFlexAll(false);if(s.dgfDieselPrice!==undefined)sDgfDieselPrice(s.dgfDieselPrice);else sDgfDieselPrice(1.85);if(s.afCostReduce!==undefined)sAfCostReduce(s.afCostReduce);else sAfCostReduce(false);if(s.wDistPMA&&Array.isArray(s.wDistPMA)&&s.wDistPMA.length===11)sWDistPMA(s.wDistPMA);else sWDistPMA(PMAW.map(function(){return 0}));
    if(s.pmaKgMode)sPmaKgM(s.pmaKgMode);if(s.pmaKgTgt!==undefined)sPmaKgTgt(s.pmaKgTgt);if(s.pmaMPK!==undefined)sPmaMPK(s.pmaMPK);if(s.pmaMPK_AKE!==undefined)sPmaMPK_AKE(s.pmaMPK_AKE);if(s.pmaMPK_PMC!==undefined)sPmaMPK_PMC(s.pmaMPK_PMC);if(s.pmaGranR)sPmaGranR(s.pmaGranR);else sPmaGranR({});if(s.pmaMPPL2!==undefined)sPmaMPPL2(s.pmaMPPL2);if(s.pmaPpMode)sPmaPpM(s.pmaPpMode);if(s.pmaPpR)sPmaPpR(s.pmaPpR);else sPmaPpR({});if(s.pmaPpRefine!==undefined)sPmaPpRefine(s.pmaPpRefine);else sPmaPpRefine(false);if(s.pmaPpExclZ)sPmaPpExclZ(s.pmaPpExclZ);else sPmaPpExclZ({});if(s.pmaPpExclW)sPmaPpExclW(s.pmaPpExclW);else sPmaPpExclW({});
    if(s.custTgtOn!==undefined)sCustTgtOn(s.custTgtOn);else sCustTgtOn(false);if(s.custTgtM)sCustTgtM(s.custTgtM);else sCustTgtM(PMAW.map(function(){return 0}));if(s.custTgtR)sCustTgtR(s.custTgtR);else sCustTgtR(PMAW.map(function(){return 0}));
    if(s.prD)sPrD(s.prD);if(s.prM!==undefined)sPrM(s.prM);if(s.prMOverride!==undefined)sPrMO(s.prMOverride);if(s.prDim)sPrDim(s.prDim);if(s.prRef!==undefined)sPrRef(s.prRef);if(s.prCompBasis)sPrCompBasis(s.prCompBasis);if(s.prCompFsc)sPrCompFsc(s.prCompFsc);if(s.prCompFscPct!==undefined)sPrCompFscPct(s.prCompFscPct);
    // (old prCustTgt2/prTgtLabel/prMeetWhich load removed — handled by prTgts migration above)
    sUploadInfo(s.uploadInfo||null);sCustRows(null);sReportHTML(null);sMapOpen(false);sMapResult(null);sMapStats(null);sCompPcMap(null);sCompZones([]);sCompRates({});sCompAllRates({});sCompNativeBreaks([]);sCompAllNative({});sMapOrigins([]);sMapSelOrig("");sMapFiles([]);sMapLog([]);sMapFsc("inclusive");sMapFscPct(5);
  }
  var [saveMsg,sSaveMsg]=useState("");
  var [oppSaveStatus,sOppSaveStatus]=useState(null); // null | "saving" | "shared" | "local" | "failed"
  var [billingCommitPreview,sBillingCommitPreview]=useState(null); // {result, opps:[{id,name,prod,origin,vol,oldBlended,newBlended,delta,annualImpact}]}
  var [reportHTML,sReportHTML]=useState(null);
  var saveOpp=useCallback(async function(){
    var id=oppId||("opp_"+Date.now());
    var state=getState();
    // Keep full prTgts (with heavy data) in memory cache
    state.prTgts=prTgts;
    sOppId(id);
    oppCache.current[id]=state;
    sOppList(function(prev){var exists=prev.find(function(o){return o.id===id});if(exists){return prev.map(function(o){return o.id===id?{...o,name:cust||"Unnamed",prod:prod,updated:state.updated}:o})}return[...prev,{key:"opp:"+id,id:id,name:cust||"Unnamed",prod:prod,updated:state.updated}]});
    sOppSaveStatus("saving");
    var method=await saveAllOpps();
    if(method==="shared"){
      // Auto-clear success after 4s — persistent banner not needed for green state
      setTimeout(function(){sOppSaveStatus(null)},4000);
    }else if(method==="localStorage"){
      // Leave "local" status visible — user must acknowledge by downloading backup
    }else{
      // Leave "failed" status visible and force a backup download
      downloadBackup("save");
    }
  });
  saveRef.current=saveOpp;
  function startSaveAs(){sSaveAsMode(true);sSaveAsName(cust?(cust+" (copy)"):"New Opportunity")}
  function cancelSaveAs(){sSaveAsMode(false);sSaveAsName("")}
  async function confirmSaveAs(){
    var name=saveAsName.trim();if(!name){sSaveAsMode(false);return}
    sCust(name);var id="opp_"+Date.now();
    var state={...getState(),cust:name,updated:new Date().toISOString(),prTgts:prTgts};
    sOppId(id);
    sOppList(function(prev){return[...prev,{key:"opp:"+id,id:id,name:name,prod:prod,updated:state.updated}]});
    sSaveAsMode(false);sSaveAsName("");
    oppCache.current[id]=state;
    await saveAllOpps();
  }
  function startDelete(){sDeleteConfirm(true)}
  function cancelDelete(){sDeleteConfirm(false)}
  async function confirmDelete(){
    if(!oppId)return;
    var id=oppId;
    sOppList(function(prev){return prev.filter(function(o){return o.id!==id})});
    sOppId(null);sDeleteConfirm(false);
    delete oppCache.current[id];
    await saveAllOpps();
  }
  function startRename(){if(oppId){sRenameMode(true);sRenameName(cust||"")}}
  function cancelRename(){sRenameMode(false);sRenameName("")}
  async function confirmRename(){
    var name=renameName.trim();if(!name){sRenameMode(false);return}
    sCust(name);
    var id=oppId;
    if(id){
      sOppList(function(prev){return prev.map(function(o){return o.id===id?{...o,name:name}:o})});
      var state={...getState(),cust:name,updated:new Date().toISOString()};
      oppCache.current[id]=state;
      await saveAllOpps();
    }
    sRenameMode(false);sRenameName("");
  }
  function backupAll(){
    if(Object.keys(oppCache.current).length===0){sSaveMsg("⚠ No opps to backup");setTimeout(function(){sSaveMsg("")},3000);return}
    downloadBackup("backup");
    sSaveMsg("✓ Backed up "+Object.keys(oppCache.current).length+" opps");setTimeout(function(){sSaveMsg("")},3000);
  }
  function handleRestore(e){
    var file=e.target.files[0];if(!file)return;
    var reader=new FileReader();
    reader.onload=async function(ev){
      try{
        var data=JSON.parse(ev.target.result);
        if(!data.opps){sSaveMsg("✗ Invalid backup file");setTimeout(function(){sSaveMsg("")},3000);return}
        var ids=Object.keys(data.opps);var restored=0;
        for(var i=0;i<ids.length;i++){oppCache.current[ids[i]]=data.opps[ids[i]];restored++}
        var items=[];
        Object.keys(oppCache.current).forEach(function(id){
          var p=oppCache.current[id];
          items.push({key:"opp:"+id,id:id,name:p.cust||"Unnamed",prod:p.prod||"pm",updated:p.updated||""});
        });
        sOppList(items);
        await saveAllOpps();
        sSaveMsg("✓ Restored "+restored+" opps");setTimeout(function(){sSaveMsg("")},4000);
      }catch(pe){sSaveMsg("✗ Could not parse backup");setTimeout(function(){sSaveMsg("")},3000)}
    };
    reader.readAsText(file);
    e.target.value="";
  }
  var loadOpp=useCallback(function(id){
    sOppLoading(true);
    if(oppCache.current[id]){try{loadState(oppCache.current[id]);sOppId(id);sAppStarted(true)}catch(e){}}
    sOppLoading(false);
  },[]);
  var deleteOpp=useCallback(async function(id){
    delete oppCache.current[id];
    sOppList(function(prev){return prev.filter(function(o){return o.id!==id})});
    if(oppId===id)sOppId(null);
    await saveAllOpps();
  },[oppId]);
  var newOpp=useCallback(function(){
    sOppId(null);sCust("");sVol(100000);sWt(0.68);sDim(1.2);sProd("pm");sOrigR("LHR");sLkw(LKW.LHR);
    sMPK(0);sMPP(PMW.map(function(){return 0}));sMPP3([1,2,3].map(function(){return PMW.map(function(){return 0})}));
    sKgM("target");sPpM("target");sKgT(20);sPpT(20);sPmZ(1);
    sDisp(JSON.parse(JSON.stringify(DD)));sWD(PMW.map(function(b){return b.p}));
    sHasCustDisp(false);sDispMode("standard");sUploadInfo(null);sCustRows(null);sPmaPpWtM("phys");
    sPrTgts([{on:false,label:"Competitor 1",rates:{}},{on:false,label:"Competitor 2",rates:{}}]);sPrMeetIdx(0);sPrCompBasis("unknown");sPrCompFsc("unknown");sPrCompFscPct(5);sUploadInfo(null);sCustRows(null);sAppStarted(true);
  },[]);
  var [uploadInfo,sUploadInfo]=useState(null);
  var [custRows,sCustRows]=useState(null); // transient: [{pc,wt,st,zone}, ...] — NOT saved to storage
  var fileRef=useRef(null);
  var uploadDataRef=useRef(null);
  var [uploadDataMsg,setUploadDataMsg]=useState("");
  // ── Competitor Rate Mapper ──
  var [mapOpen,sMapOpen]=useState(false);
  var [compPcMap,sCompPcMap]=useState(null); // {postcode: compZone}
  var [compZones,sCompZones]=useState([]); // unique comp zones sorted
  var [compRates,sCompRates]=useState({}); // {compZone: [10 rates]} -- active origin
  var [compAllRates,sCompAllRates]=useState({});
  var [compNativeBreaks,sCompNativeBreaks]=useState([]);
  var [compAllNative,sCompAllNative]=useState({});
  var [mapOrigins,sMapOrigins]=useState([]); // detected origins
  var [mapSelOrig,sMapSelOrig]=useState(""); // selected origin
  var [compLabel,sCompLabel]=useState("Competitor");
  var [mapWhich,sMapWhich]=useState(0);
  var [mapResult,sMapResult]=useState(null);
  var [mapStats,sMapStats]=useState(null);
  var [mapFiles,sMapFiles]=useState([]); // [{name,type,rows,info}]
  var [mapLog,sMapLog]=useState([]);
  var [mapFsc,sMapFsc]=useState("inclusive");
  var [mapFscPct,sMapFscPct]=useState(5);
  var [compZoneTiers,sCompZoneTiers]=useState({});
  var [compZoneStates,sCompZoneStates]=useState({});
  var [compZoneDescs,sCompZoneDescs]=useState({}); // {compZone: "Ballarat"} from rate card

  var CITY_STATES={"adelaide":"SA","melbourne":"VIC","sydney":"NSW","brisbane":"QLD","perth":"WA","hobart":"TAS","darwin":"NT","canberra":"ACT",
    "ballarat":"VIC","bendigo":"VIC","geelong":"VIC","shepparton":"VIC","mildura":"VIC","warrnambool":"VIC","traralgon":"VIC","wodonga":"VIC","horsham":"VIC","sale":"VIC","morwell":"VIC",
    "newcastle":"NSW","wollongong":"NSW","gosford":"NSW","bathurst":"NSW","albury":"NSW","wagga":"NSW","dubbo":"NSW","tamworth":"NSW","orange":"NSW","lismore":"NSW","coffs":"NSW","port macquarie":"NSW","nowra":"NSW","armidale":"NSW","griffith":"NSW","broken hill":"NSW",
    "gold coast":"QLD","sunshine coast":"QLD","toowoomba":"QLD","cairns":"QLD","townsville":"QLD","mackay":"QLD","rockhampton":"QLD","bundaberg":"QLD","hervey bay":"QLD","gladstone":"QLD","ipswich":"QLD","gympie":"QLD","mount isa":"QLD",
    "mount gambier":"SA","port augusta":"SA","whyalla":"SA","murray bridge":"SA","port lincoln":"SA","port pirie":"SA",
    "bunbury":"WA","geraldton":"WA","kalgoorlie":"WA","albany":"WA","karratha":"WA","broome":"WA","port hedland":"WA","mandurah":"WA",
    "launceston":"TAS","devonport":"TAS","burnie":"TAS",
    "alice springs":"NT","katherine":"NT",
    "queanbeyan":"NSW","tuggeranong":"ACT","belconnen":"ACT","woden":"ACT"};

  function guessZoneState(zn,desc){
    var z=(zn||"").toUpperCase();
    // Direct zone code patterns
    if(/^VIC|^MEL|^GEL|^BEN|^BAL|^GEX|^MTP|^BDG/i.test(z))return "VIC";
    if(/^NSW|^SYD|^NTL|^WOL|^GOS|^CC$|^WLG|^NC\d/i.test(z))return "NSW";
    if(/^QLD|^BNE|^GC$|^OOL|^TSV|^MKY|^ROK|^TWB|^MCY|^IPS|^GYP|^QC\d/i.test(z))return "QLD";
    if(/^SA$|^SA\d|^ADL|^SCO|^SC\d|^CFS/i.test(z))return "SA";
    if(/^WA$|^WA\d|^PER|^WC\d/i.test(z))return "WA";
    if(/^TAS|^HBA|^LSY|^TC\d/i.test(z))return "TAS";
    if(/^NT$|^NT\d|^DRW/i.test(z))return "NT";
    if(/^ACT|^CBR/i.test(z))return "ACT";
    // City name lookup from description
    if(desc){
      var dl=desc.toLowerCase().trim();
      if(CITY_STATES[dl])return CITY_STATES[dl];
      // Partial match: check if desc contains a known city
      var cityKeys=Object.keys(CITY_STATES);
      for(var ci=0;ci<cityKeys.length;ci++){
        if(dl.indexOf(cityKeys[ci])>=0)return CITY_STATES[cityKeys[ci]];
      }
    }
    return "";
  }
  var compFileRef=useRef(null);
  var parcelFileRef=useRef(null);
  function handleParcelReUpload(e){
    var files=e.target.files;if(!files||!files.length)return;
    var pending=files.length;var allParsed=[];
    function processFile(file){
      var isXls=/\.xlsx?$/i.test(file.name);
      var reader=new FileReader();
      reader.onload=function(evt){
        try{
          var rows=[];
          if(isXls){
            var wb=XLSX.read(evt.target.result,{type:"array"});
            var ws=wb.Sheets[wb.SheetNames[0]];
            rows=XLSX.utils.sheet_to_json(ws,{defval:""});
          }else{
            var txt=evt.target.result;var delim=txt.indexOf("\t")>-1?"\t":",";
            var lines=txt.split(/\r?\n/).filter(function(r){return r.trim()});
            if(lines.length>=2){
              var hdr=lines[0].split(delim);
              for(var i=1;i<lines.length;i++){var vals=lines[i].split(delim);var obj={};hdr.forEach(function(h,hi){obj[h.trim()]=vals[hi]||""});rows.push(obj)}
            }
          }
          if(rows.length>=2){
            var cols=Object.keys(rows[0]);
            function normCol(s){return s.toLowerCase().replace(/[_.\-\/()#:,]/g," ").replace(/\s+/g," ").trim()}
            var wtCol=null;var pcCol=null;var puCol=null;
            cols.forEach(function(c){var n=normCol(c);
              if(!wtCol&&/weight/.test(n)&&!/cubic|vol|dim|charge/.test(n))wtCol=c;
              if(!pcCol&&/post\s*code|postcode|postal|zip/.test(n))pcCol=c;
              if(!puCol&&/pick\s*up|pickup|depot|origin/.test(n))puCol=c;
            });
            rows.forEach(function(r){
              if(puCol&&prD){var pu=String(r[puCol]).trim().toUpperCase();if(pu.indexOf(prD)<0)return}
              var wt=wtCol?parseFloat(r[wtCol]):0;
              var pc=pcCol?String(r[pcCol]).replace(/\s/g,""):"";
              if(!pc||isNaN(wt)||wt<=0)return;
              var zCode=ZD_ZONES[pc.replace(/^0+/,"")];
              if(zCode)allParsed.push({pc:pc,wt:wt,zone:zCode});
            });
          }
        }catch(err){console.error("Parcel re-upload error:",err)}
        pending--;
        if(pending<=0)sCustRows(allParsed.length>0?allParsed:null);
      };
      if(isXls)reader.readAsArrayBuffer(file);else reader.readAsText(file);
    }
    for(var fi=0;fi<files.length;fi++)processFile(files[fi]);
    e.target.value="";
    e.target.value="";
  }

  function daiZoneKey(zdCode){var m=zdCode.match(/^([A-Z]+)(\d)$/);return m?m[1]+"-Z"+m[2]:null}

  // Convert postcode to Australian state code
  function pcToState(pc){
    try{var p=parseInt(pc);
      if((p>=2600&&p<=2618)||(p>=2900&&p<=2920))return'ACT';
      if((p>=1000&&p<=2999)||(p>=200&&p<=299))return'NSW';
      if((p>=3000&&p<=3999)||(p>=8000&&p<=8999))return'VIC';
      if((p>=4000&&p<=4999)||(p>=9000&&p<=9999))return'QLD';
      if(p>=5000&&p<=5999)return'SA';
      if(p>=6000&&p<=6999)return'WA';
      if(p>=7000&&p<=7999)return'TAS';
      if(p>=800&&p<=999)return'NT';
    }catch(e){}return null;
  }

  var RT_WB=['<300g','500g','1kg','2kg','3kg','4kg','5kg','7kg','10kg','15kg','22kg'];
  var RT_CARRIERS={TGE:{name:'Toll Global Express',color:'#2563EB'},FW:{name:'Aramex',color:'#EA580C'},PFL:{name:'Parcel Freight Logistics',color:'#7C3AED'},PR:{name:'Parcel Right',color:'#059669'},APO:{name:'Australia Post',color:'#DC2626'},DGF:{name:'Dragonfly',color:'#0891B2'},NULL:{name:'No Service',color:'#6B7280'}};

  // Detect new routing file format (Zone col A, PC col C) vs old (PC col B)
  function detectNewFormat(rows){
    for(var i=1;i<Math.min(6,rows.length);i++){
      var r=rows[i];
      var col0=String(r?.[0]||'').trim();
      if(/Zone\s*\d/i.test(col0)||col0==='Not serviced')return true;
      if(/^\d{3,4}$/.test(String(r?.[2]||'')))return true;
    }
    return false;
  }

  // Parse zone string → {zoneKey, isNull, isROA, zoneNum}
  // PR: "NSW - Zone 1" → {zoneKey:"NSW-Z1"} | "ROA - Zone 3" → {zoneKey:"ROA-Z3",isROA:true}
  // PM: "Zone 1" → {zoneNum:"1"} — caller adds state from postcode
  function parseZoneStr(zoneStr){
    if(!zoneStr||zoneStr==='Not serviced')return{zoneKey:null,isNull:true,isROA:false};
    var m=zoneStr.match(/^([A-Z]+)\s*-\s*Zone\s*(\d)/i);
    if(m){var st=m[1].toUpperCase();var z=m[2];
      if(st==='ROA')return{zoneKey:'ROA-Z3',isNull:false,isROA:true};
      return{zoneKey:st+'-Z'+z,isNull:false,isROA:false};
    }
    var mFlat=zoneStr.match(/^Zone\s*(\d)/i);
    if(mFlat)return{zoneKey:null,zoneNum:mFlat[1],isNull:false,isROA:false};
    return{zoneKey:null,isNull:true,isROA:false};
  }

  function parseRoutingFileNew(rows){
    // New format: Zone(col0), PostcodeSuburb(col1), Postcode(col2), Suburb(col3), costs[4-14], carriers[15-25]
    var byPostcode={};var byZone={};var carrierTotals={};var nullList=[];var roaList=[];
    var totalSuburbs=0;var mixedCount=0;
    for(var ri=1;ri<rows.length;ri++){
      var row=rows[ri];
      var zoneStr=String(row?.[0]||'').trim();
      var pcRaw=String(row?.[2]||'').trim();
      var suburb=String(row?.[3]||'').trim();
      if(!pcRaw||!/^\d{3,4}$/.test(pcRaw)||!suburb)continue;
      var pcKey=pcRaw.replace(/^0+/,'');
      var costs=[];var carriers=[];
      for(var ci=0;ci<11;ci++){
        var cv=row[4+ci];
        costs.push(typeof cv==='number'?Math.round(cv*100)/100:(String(cv||'').toUpperCase()==='NULL'?0:Math.round((parseFloat(cv)||0)*100)/100));
        carriers.push(String(row[15+ci]||'').trim().toUpperCase()||'NULL');
      }
      var zp=parseZoneStr(zoneStr);
      var zoneKey=zp.zoneKey;
      // For flat PM zones derive state from postcode
      if(!zoneKey&&zp.zoneNum){var st2=pcToState(pcKey);if(st2)zoneKey=st2+'-Z'+zp.zoneNum;}
      var uniqueC=[];carriers.forEach(function(c){if(uniqueC.indexOf(c)<0)uniqueC.push(c)});
      if(uniqueC.length>1)mixedCount++;
      var primaryC=carriers[0]||'NULL';
      if(!byPostcode[pcKey])byPostcode[pcKey]=[];
      byPostcode[pcKey].push({suburb:suburb,costs:costs,carriers:carriers,primaryC:primaryC,zoneKey:zoneKey,isROA:zp.isROA||false});
      if(zp.isNull){nullList.push({pc:pcKey,suburb:suburb,zone:'Not serviced'});totalSuburbs++;continue;}
      if(zp.isROA)roaList.push({pc:pcKey,suburb:suburb});
      if(zoneKey){
        if(!byZone[zoneKey]){byZone[zoneKey]={costSum:Array(11).fill(0),fwCostSum:Array(11).fill(0),nonFwCostSum:Array(11).fill(0),carrierCounts:{},suburbCount:0,fwCount:0,nonFwCount:0}}
        var zd=byZone[zoneKey];zd.suburbCount++;
        var isFW=primaryC==='FW';
        if(isFW)zd.fwCount++;else zd.nonFwCount++;
        for(var wi=0;wi<11;wi++){
          if(costs[wi]>0){
            zd.costSum[wi]+=costs[wi];
            if(isFW)zd.fwCostSum[wi]+=costs[wi];else zd.nonFwCostSum[wi]+=costs[wi];
          }
        }
        carriers.forEach(function(c){zd.carrierCounts[c]=(zd.carrierCounts[c]||0)+1});
      }
      carrierTotals[primaryC]=(carrierTotals[primaryC]||0)+1;
      totalSuburbs++;
    }
    Object.keys(byZone).forEach(function(zk){var zd=byZone[zk];
      zd.avgCosts=zd.costSum.map(function(s){return zd.suburbCount>0?Math.round(s/zd.suburbCount*100)/100:0});delete zd.costSum;
    });
    return{byPostcode:byPostcode,byZone:byZone,carrierTotals:carrierTotals,totalSuburbs:totalSuburbs,mixedCount:mixedCount,nullList:nullList,roaList:roaList,totalPostcodes:Object.keys(byPostcode).length,formatVersion:2};
  }

  function parseRoutingFile(rows){
    if(detectNewFormat(rows))return parseRoutingFileNew(rows);
    // Legacy format
    var dataStart=1;
    for(var hi=0;hi<Math.min(6,rows.length);hi++){var rv=String(rows[hi]?.[1]||'').trim();if(/^\d{3,4}$/.test(rv)){dataStart=hi;break}}
    var byPostcode={};var byZone={};var carrierTotals={};var nullList=[];
    var totalSuburbs=0;var mixedCount=0;
    for(var ri=dataStart;ri<rows.length;ri++){
      var row=rows[ri];var pcRaw=String(row?.[1]||'').trim();var suburb=String(row?.[2]||'').trim();
      if(!pcRaw||!/^\d{3,4}$/.test(pcRaw)||!suburb)continue;
      var pcKey=pcRaw.replace(/^0+/,'');var costs=[];var carriers=[];
      for(var ci=0;ci<11;ci++){costs.push(Math.round((parseFloat(row[3+ci])||0)*100)/100);carriers.push((String(row[14+ci]||'').trim().toUpperCase())||'NULL');}
      var uniqueC=[];carriers.forEach(function(c){if(uniqueC.indexOf(c)<0)uniqueC.push(c)});if(uniqueC.length>1)mixedCount++;
      var primaryC=carriers[0]||'NULL';
      var zdEntry=ZD[pcKey]||ZD[pcRaw];var zdStr=zdEntry?(Array.isArray(zdEntry)?zdEntry[0]:zdEntry):null;
      var zoneKey=zdStr?daiZoneKey(zdStr):null;
      if(!byPostcode[pcKey])byPostcode[pcKey]=[];
      byPostcode[pcKey].push({suburb:suburb,costs:costs,carriers:carriers,primaryC:primaryC,zoneKey:zoneKey});
      if(zoneKey){
        if(!byZone[zoneKey]){byZone[zoneKey]={costSum:Array(11).fill(0),carrierCounts:{},suburbCount:0,nullCount:0}}
        var zd=byZone[zoneKey];zd.suburbCount++;
        for(var wi=0;wi<11;wi++){zd.costSum[wi]+=costs[wi];}
        carriers.forEach(function(c){zd.carrierCounts[c]=(zd.carrierCounts[c]||0)+1});
        if(!primaryC||primaryC==='NULL')zd.nullCount++;
      }
      carrierTotals[primaryC]=(carrierTotals[primaryC]||0)+1;
      if(!primaryC||primaryC==='NULL')nullList.push({pc:pcKey,suburb:suburb,zone:zoneKey||'?'});
      totalSuburbs++;
    }
    Object.keys(byZone).forEach(function(zk){var zd=byZone[zk];
      zd.avgCosts=zd.costSum.map(function(s){return zd.suburbCount>0?Math.round(s/zd.suburbCount*100)/100:0});delete zd.costSum;
    });
    return{byPostcode:byPostcode,byZone:byZone,carrierTotals:carrierTotals,totalSuburbs:totalSuburbs,mixedCount:mixedCount,nullList:nullList,roaList:[],totalPostcodes:Object.keys(byPostcode).length,formatVersion:1};
  }

  function handleRoutingUpload(e,product){
    var file=e.target.files[0];if(!file)return;
    var setSave=product==='pm'?sPmRtSave:sPrRtSave;
    var reader=new FileReader();
    reader.onload=function(evt){
      try{
        var wb=XLSX.read(evt.target.result,{type:'array'});
        // Detect combined two-tab file (new format)
        var pmSN=wb.SheetNames.find(function(n){return n.toLowerCase().indexOf('parcel max')>=0});
        var prSN=wb.SheetNames.find(function(n){return n.toLowerCase().indexOf('parcel right')>=0});
        if(pmSN&&prSN){
          var pmRows=XLSX.utils.sheet_to_json(wb.Sheets[pmSN],{header:1,defval:''});
          var prRows=XLSX.utils.sheet_to_json(wb.Sheets[prSN],{header:1,defval:''});
          var pmResult=parseRoutingFileNew(pmRows);
          var prResult=parseRoutingFileNew(prRows);
          sPmRouting(pmResult);sPrRouting(prResult);
          sPmRtSave("saving");sPrRtSave("saving");
          if(typeof window!=='undefined'&&window.storage){
            Promise.all([
              window.storage.set('routing-pm-v1',JSON.stringify(pmResult),true),
              window.storage.set('routing-pr-v1',JSON.stringify(prResult),true)
            ]).then(function(rs){
              var ok=rs.every(function(r){return!!r});
              sPmRtSave(ok?"saved":"error");sPrRtSave(ok?"saved":"error");
              if(ok)setTimeout(function(){sPmRtSave(null);sPrRtSave(null)},4000);
            }).catch(function(){sPmRtSave("error");sPrRtSave("error");});
          }else{sPmRtSave("error");sPrRtSave("error");}
          return;
        }
        // Single-product fallback
        var sheetName=(pmSN&&product==='pm')?pmSN:((prSN&&product==='pr')?prSN:wb.SheetNames[0]);
        var rows=XLSX.utils.sheet_to_json(wb.Sheets[sheetName],{header:1,defval:''});
        var result=parseRoutingFile(rows);
        if(product==='pm')sPmRouting(result);else sPrRouting(result);
        var stKey='routing-'+(product==='pm'?'pm':'pr')+'-v1';
        if(typeof window!=='undefined'&&window.storage){
          setSave("saving");
          window.storage.set(stKey,JSON.stringify(result),true)
            .then(function(r){if(r){setSave("saved");setTimeout(function(){setSave(null)},4000)}else{setSave("error")}})
            .catch(function(){setSave("error");});
        }else{setSave("error");}
      }catch(err){console.error('Routing parse error:',err);if(product==='pm'||product==='combined')sPmRtSave("error");if(product==='pr'||product==='combined')sPrRtSave("error");}
    };
    reader.readAsArrayBuffer(file);e.target.value='';
  }

  function clearRouting(product){
    if(product==='pm'){sPmRouting(null);sPmRtSave(null)}else{sPrRouting(null);sPrRtSave(null)}
    var stKey='routing-'+(product==='pm'?'pm':'pr')+'-v1';
    if(typeof window!=='undefined'&&window.storage){
      window.storage.delete(stKey,true).catch(function(e){});
    }
  }

  // ── Billing CSV weight → routing weight break index (11 breaks) ──
  var RT_WT_BREAKS=[0.3,0.5,1,2,3,4,5,7,10,15,22];
  function wtToRTIdx(wt){for(var i=0;i<RT_WT_BREAKS.length;i++){if(wt<=RT_WT_BREAKS[i])return i}return RT_WT_BREAKS.length-1}
  function wtToPMWIdx(wt){var b=[0.5,1,2,3,4,5,22];for(var i=0;i<b.length;i++){if(wt<=b[i])return i}return b.length-1}
  var NZ_SUPPLIERS={'NZ FREIGHTWAYS':1,'NZ POST':1};

  function parseBillingCSV(text,routingData,prRoutingData){
    var lines=text.split(/\r?\n/);
    if(lines.length<2)return null;
    var hdr=lines[0].split(',').map(function(h){return h.trim().replace(/"/g,'').toLowerCase()});
    var ci={
      ratedate:hdr.indexOf('ratedate'),service:hdr.indexOf('service'),
      country:hdr.indexOf('shipto'+(hdr.some(function(h){return h==='shiptocountry'})?'country':'')),
      supplier:hdr.indexOf('supplier'),cost:hdr.indexOf('costaud'),
      postcode:hdr.indexOf('postcode'),weight:hdr.indexOf('weightkg'),
      pobox:hdr.indexOf('poboxaddress')
    };
    // Fix country col detection
    ci.country=hdr.findIndex(function(h){return h.indexOf('country')>=0});

    var zoneCostSums={};var zoneCostCounts={};var zoneParcelCounts={};
    var stateZone={};var pmwCounts=Array(7).fill(0);
    var supplierMap={};var poboxCount=0;var totalPM=0;
    var dates=[];var unmapped=0;
    // Diagnostic: track Aramex parcel processing

    for(var i=1;i<lines.length;i++){
      if(!lines[i].trim())continue;
      var cols=lines[i].split(',');
      var svc=(cols[ci.service]||'').replace(/"/g,'').trim();
      var isPMRow=svc==='Parcel Max';var isPRRow=svc==='Parcel Right';var isPMARow=svc==='Parcel Max Access';
      if(!isPMRow&&!isPRRow&&!isPMARow)continue;
      var ctry=(cols[ci.country]||'').replace(/"/g,'').trim();
      if(ctry!=='AU')continue;
      var sup=(cols[ci.supplier]||'').replace(/"/g,'').trim();
      if(NZ_SUPPLIERS[sup.toUpperCase()])continue;
      var pb=(cols[ci.pobox]||'').replace(/"/g,'').trim().toUpperCase();
      var pc=(cols[ci.postcode]||'').replace(/"/g,'').trim().replace(/^0+/,'');
      var wt=parseFloat(cols[ci.weight])||0;
      var cost=parseFloat(cols[ci.cost])||0;
      var dt=(cols[ci.ratedate]||'').replace(/"/g,'').trim();

      if(!isPMRow){continue;}
      totalPM++;
      if(pb==='TRUE')poboxCount++;
      if(dt&&dates.indexOf(dt)<0)dates.push(dt);

      // Rerate Aramex parcels: subtract the known saving (FMC_OLD - FMC_AX) per zone/weight from actual cost
      // Works for all zones — Z1 saves most, Z2 saves some, Z3/unchanged zones save nothing
      if(sup==='Aramex'&&cost>0&&wt>0){
        var zk2=null;
        if(routingData&&routingData.byPostcode&&routingData.byPostcode[pc]){
          zk2=routingData.byPostcode[pc][0]&&routingData.byPostcode[pc][0].zoneKey;
        }
        if(zk2&&FMC_OLD[zk2]&&FMC_AX[zk2]){
          var wi2=wtToRTIdx(wt);
          var RT2FMC2=[0,0,1,2,3,4,5,6,7,8,9];
          var fi2=RT2FMC2[wi2];
          if(fi2!=null){
            var oldR=FMC_OLD[zk2][fi2]||0;
            var newR=FMC_AX[zk2][fi2]||0;
            var saving=oldR>newR?Math.round((oldR-newR)*1000)/1000:0;
            if(saving>0){cost=Math.max(0.01,Math.round((cost-saving)*100)/100);}
          }
        }
      }

      // Supplier mix — track by address type
      var addrType=pb==='TRUE'?'pobox':'standard';
      if(!supplierMap[sup])supplierMap[sup]={count:0,totalCost:0,standard:{count:0,totalCost:0},pobox:{count:0,totalCost:0}};
      supplierMap[sup].count++;supplierMap[sup].totalCost+=cost;
      supplierMap[sup][addrType].count++;supplierMap[sup][addrType].totalCost+=cost;

      // Weight distribution
      if(wt>0)pmwCounts[wtToPMWIdx(wt)]++;

      // Zone mapping via routing file
      var zoneKey=null;
      if(routingData&&routingData.byPostcode&&routingData.byPostcode[pc]){
        zoneKey=routingData.byPostcode[pc][0]&&routingData.byPostcode[pc][0].zoneKey;
      }

      if(!zoneKey){unmapped++;continue;}

      // Accumulate costs by zone × weight break
      // For Aramex parcels use FMC_AX (new agreed contract rate) instead of actual billed cost
      if(!zoneCostSums[zoneKey]){zoneCostSums[zoneKey]=Array(11).fill(0);zoneCostCounts[zoneKey]=Array(11).fill(0);zoneParcelCounts[zoneKey]=0;}
      var wi=wt>0?wtToRTIdx(wt):0;
      if(cost>0){zoneCostSums[zoneKey][wi]+=cost;zoneCostCounts[zoneKey][wi]++;}
      zoneParcelCounts[zoneKey]++;

      // State/zone dispersion
      var m=zoneKey.match(/^([A-Z]+)-Z(\d)$/);
      if(m){
        var st=m[1];var z=parseInt(m[2]);
        if(!stateZone[st])stateZone[st]={total:0,z1:0,z2:0,z3:0};
        stateZone[st].total++;
        if(z===1)stateZone[st].z1++;else if(z===2)stateZone[st].z2++;else stateZone[st].z3++;
      }
    } // end for loop

    // Build byZone avgCosts
    var byZone={};
    Object.keys(zoneCostSums).forEach(function(zk){
      byZone[zk]={
        avgCosts:zoneCostSums[zk].map(function(s,wi){return zoneCostCounts[zk][wi]>0?Math.round(s/zoneCostCounts[zk][wi]*100)/100:0}),
        counts:zoneCostCounts[zk].slice(),
        parcelCount:zoneParcelCounts[zk],totalCost:zoneCostSums[zk].reduce(function(a,b){return a+b},0)
      };
    });


    // State dispersion
    var stateDisp={};var grandTotal=Object.values(stateZone).reduce(function(s,v){return s+v.total},0);
    Object.keys(stateZone).forEach(function(st){
      var v=stateZone[st];
      stateDisp[st]={
        pct:grandTotal>0?Math.round(v.total/grandTotal*1000)/10:0,
        z1:v.total>0?Math.round(v.z1/v.total*1000)/10:0,
        z2:v.total>0?Math.round(v.z2/v.total*1000)/10:0,
        z3:v.total>0?Math.round(v.z3/v.total*1000)/10:0,
        total:v.total
      };
    });

    // Weight distribution %
    var pmwTotal=pmwCounts.reduce(function(a,b){return a+b},0);
    var weightDist=pmwCounts.map(function(c){return pmwTotal>0?Math.round(c/pmwTotal*1000)/10:0});

    // Supplier avg costs
    var supplierMix={};
    Object.keys(supplierMap).forEach(function(s){
      var v=supplierMap[s];
      supplierMix[s]={
        count:v.count,avgCost:v.count>0?Math.round(v.totalCost/v.count*100)/100:0,totalCost:Math.round(v.totalCost),
        standard:{count:(v.standard&&v.standard.count)||0,avgCost:v.standard&&v.standard.count>0?Math.round(v.standard.totalCost/v.standard.count*100)/100:0,totalCost:v.standard?Math.round(v.standard.totalCost):0},
        pobox:{count:(v.pobox&&v.pobox.count)||0,avgCost:v.pobox&&v.pobox.count>0?Math.round(v.pobox.totalCost/v.pobox.count*100)/100:0,totalCost:v.pobox?Math.round(v.pobox.totalCost):0}
      };
    });

    // Overall blended avg
    var allCost=Object.values(supplierMap).reduce(function(s,v){return s+v.totalCost},0);
    var blendedAvg=totalPM>0?Math.round(allCost/totalPM*100)/100:0;

    // Sort dates properly — DD/MM/YYYY format needs parsing before sort
    dates.sort(function(a,b){
      var pa=a.split('/');var pb=b.split('/');
      var da=pa.length===3?new Date(pa[2],pa[1]-1,pa[0]):new Date(a);
      var db=pb.length===3?new Date(pb[2],pb[1]-1,pb[0]):new Date(b);
      return da-db;
    });

    return{byZone:byZone,stateDisp:stateDisp,weightDist:weightDist,supplierMix:supplierMix,
      totalParcels:totalPM,poboxCount:poboxCount,poboxPct:totalPM>0?Math.round(poboxCount/totalPM*1000)/10:0,
      unmapped:unmapped,blendedAvg:blendedAvg,dateRange:{min:dates[0]||'',max:dates[dates.length-1]||''},
      synced:new Date().toISOString()};
  }

  function handleBillingUpload(e){
    var file=e.target.files[0];if(!file)return;
    if(!pmRouting){sPmBillingMsg("⚠ Upload PM routing file first — needed for zone mapping");setTimeout(function(){sPmBillingMsg("")},4000);return}
    sPmBillingMsg("⏳ Parsing "+file.name+" ("+Math.round(file.size/1024/1024)+"MB)...");
    var reader=new FileReader();
    reader.onload=function(evt){
      try{
        var result=parseBillingCSV(evt.target.result,pmRouting,prRouting);
        if(!result){sPmBillingMsg("✗ Parse failed — check file format");setTimeout(function(){sPmBillingMsg("")},4000);return}
        sPmBillingData(result);
        sPmBillingMsg("✓ Loaded "+result.totalParcels.toLocaleString()+" parcels ("+result.dateRange.min+" to "+result.dateRange.max+")");
        // Persist to shared storage
        if(typeof window!=='undefined'&&window.storage){
          window.storage.set('billing-pm-v1',JSON.stringify(result),true)
            .then(function(r){if(!r)sPmBillingMsg(function(m){return m+" ⚠ save failed"})})
            .catch(function(){sPmBillingMsg(function(m){return m+" ⚠ save failed"})});
        }
      }catch(err){console.error('Billing parse error:',err);sPmBillingMsg("✗ Error: "+err.message);setTimeout(function(){sPmBillingMsg("")},6000)}
    };
    reader.readAsText(file);e.target.value='';
  }
const [uploadedData, setUploadedData] = useState({});

const handleDataUpload = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  setUploadDataMsg(`⏳ Parsing ${file.name}...`);

  const reader = new FileReader();
  reader.onload = async (evt) => {
    try {
      const wb = XLSX.read(evt.target.result, { type: "array" });

      // Loop through each sheet name and upload separately
      for (const name of ["fmc", "trucking", "tiers", "destscan"]) {
        const ws = wb.Sheets[name];
        if (!ws) {
          console.warn(`Sheet '${name}' not found in file`);
          continue;
        }

        const rows = XLSX.utils.sheet_to_json(ws, { defval: "" });

        try {
          const res = await uploadPricingData({ [name]: rows }, user.id);
          const count = Object.keys(res[name]).length;
           setUploadedData(prev => ({ ...prev, [name]: res[name] }));
          setUploadDataMsg(`✓ ${name}: ${count} rows`);

          console.log(`Uploaded ${count} rows for ${name}:`, res[name]);
          await reloadAll();
          console.log(`Reloaded data after uploading ${name}`);
        } catch (err) {
          setUploadDataMsg(`✗ Upload failed for ${name}: ${err.data?.error || err.message}`);
        }
      }

      // Clear message after a few seconds
      setTimeout(() => setUploadDataMsg(""), 6000);
    } catch (err) {
      console.error("Data upload parse error:", err);
      setUploadDataMsg("✗ Parse error: " + err.message);
      // setTimeout(() => setUploadDataMsg(""), 6000);
    }
  };

  reader.readAsArrayBuffer(file);
  e.target.value = "";
};

  
  function doRtSearch(data){
    if(!data||!rtSearch.trim())return;
    var q=rtSearch.trim();
    var pcKey=q.replace(/^0+/,'');
    if(data.byPostcode[pcKey]){sRtSearchResult({type:'postcode',pc:q,suburbs:data.byPostcode[pcKey]});return}
    var matches=[];
    Object.keys(data.byPostcode).forEach(function(pc){
      data.byPostcode[pc].forEach(function(s){
        if(s.suburb.toLowerCase().indexOf(q.toLowerCase())>=0)matches.push({pc:pc,suburb:s.suburb,zoneKey:s.zoneKey,primaryC:s.primaryC,costs:s.costs,carriers:s.carriers});
      });
    });
    if(matches.length>0)sRtSearchResult({type:'suburb',matches:matches.slice(0,50)});
    else sRtSearchResult({type:'none'});
  }

  // ── PM Leg 3 Routing Sync ──
  // Maps routing byZone avgCosts → PMW weight breaks (7 breaks) per Z1/Z2/Z3
  // RT indices: [<300g=0, 500g=1, 1kg=2, 2kg=3, 3kg=4, 4kg=5, 5kg=6, 7kg=7, 10kg=8, 15kg=9, 22kg=10]
  // PMW breaks: [0-500g=0, 501g-1kg=1, 1.01-2kg=2, 2.01-3kg=3, 3.01-4kg=4, 4.01-5kg=5, 5.01-22kg=6]
  // Mapping: PMW[0]=RT[1], PMW[1]=RT[2], PMW[2]=RT[3], PMW[3]=RT[4], PMW[4]=RT[5], PMW[5]=RT[6], PMW[6]=avg(RT[7..10])
  var PM_RT_MAP=[1,2,3,4,5,6,null]; // null = weighted avg of RT[7,8,9,10]
  function syncPmLeg3FromRouting(){
    if(!pmRouting)return;
    var result={z1:Array(7).fill(0),z2:Array(7).fill(0),z3:Array(7).fill(0),synced:new Date().toISOString()};
    ['z1','z2','z3'].forEach(function(zKey,zi){
      var zNum=zi+1;
      var totalWt=0;var costSums=Array(7).fill(0);
      STS.forEach(function(st){
        var dd=aDisp[st];if(!dd)return;
        var zPct=zi===0?dd.z1:zi===1?dd.z2:dd.z3;
        var w=dd.pct*zPct/10000;if(w<=0)return;
        var zd=pmRouting.byZone[st+'-Z'+zNum];
        if(!zd||!zd.avgCosts)return;
        totalWt+=w;
        for(var pmwi=0;pmwi<6;pmwi++){costSums[pmwi]+=zd.avgCosts[PM_RT_MAP[pmwi]]*w}
        // PMW[6] = equal-weighted avg of RT[7,8,9,10]
        var last4=(zd.avgCosts[7]+zd.avgCosts[8]+zd.avgCosts[9]+zd.avgCosts[10])/4;
        costSums[6]+=last4*w;
      });
      if(totalWt>0)result[zKey]=costSums.map(function(s){return Math.round(s/totalWt*100)/100});
    });
    sPmRoutingCosts(result);
    setTimeout(function(){try{if(saveRef.current)saveRef.current()}catch(e){}},300);
  }
  function clearPmRoutingSync(){sPmRoutingCosts(null);setTimeout(function(){try{if(saveRef.current)saveRef.current()}catch(e){}},300)}

  function syncPmLeg3FromBilling(){
    if(!pmBillingData||!pmBillingData.byZone)return;
    // Build new blended result first
    var result={z1:Array(7).fill(0),z2:Array(7).fill(0),z3:Array(7).fill(0),synced:new Date().toISOString(),source:'billing',dateRange:pmBillingData.dateRange};
    ['z1','z2','z3'].forEach(function(zKey,zi){
      var zNum=zi+1;
      var totalWt=0;var costSums=Array(7).fill(0);
      STS.forEach(function(st){
        var bd=pmBillingData.stateDisp[st];if(!bd||bd.pct<=0)return;
        var zPct=zi===0?bd.z1:zi===1?bd.z2:bd.z3;
        var w=bd.pct*zPct/10000;if(w<=0)return;
        var zd=pmBillingData.byZone[st+'-Z'+zNum];
        if(!zd||!zd.avgCosts)return;
        totalWt+=w;
        for(var pmwi=0;pmwi<6;pmwi++)costSums[pmwi]+=zd.avgCosts[PM_RT_MAP[pmwi]]*w;
        costSums[6]+=((zd.avgCosts[7]+zd.avgCosts[8]+zd.avgCosts[9]+zd.avgCosts[10])/4)*w;
      });
      result[zKey]=totalWt>0?costSums.map(function(s){return Math.round(s/totalWt*100)/100}):costSums;
    });
    // Pre-compute flat blended using billing stateDisp — matches the "Flat (Blended)" display exactly
    var flatZW=[0,0,0];
    STS.forEach(function(st){var bd=pmBillingData.stateDisp[st];if(!bd||bd.pct<=0)return;flatZW[0]+=bd.pct*bd.z1/10000;flatZW[1]+=bd.pct*bd.z2/10000;flatZW[2]+=bd.pct*bd.z3/10000;});
    var flatZT=flatZW[0]+flatZW[1]+flatZW[2];
    var flatZP=flatZT>0?flatZW.map(function(w){return w/flatZT}):[0.7,0.15,0.15];
    result.blended=PMW.map(function(_,wi){return Math.round((result.z1[wi]*flatZP[0]+result.z2[wi]*flatZP[1]+result.z3[wi]*flatZP[2])*100)/100});
    // Compute per-opp impact for preview
    var oppRows=[];
    Object.keys(oppCache.current).forEach(function(id){
      var opp=oppCache.current[id];
      if(!opp||(opp.prod!=='pm'&&opp.prod!=='pma'))return;
      var avgWt=opp.avgWt||1;
      var wtIdx=Math.min(Math.max(Math.round(avgWt*2)-1,0),6); // 7-break index
      var vol=opp.vol||0;
      // Old blended Z1/Z2/Z3 cost
      var oldRC=pmRoutingCosts; // global billing rates — shared across all opps
      var dsp=opp.dispMode==='customer'&&opp.disp?opp.disp:DD;
      var totW=0;var oldBlend=0;var newBlend=0;
      ['NSW','VIC','QLD','SA','WA','ACT','TAS','NT'].forEach(function(st){
        var d=dsp[st];if(!d||d.pct<=0)return;
        [0,1,2].forEach(function(zi){
          var zPct=(zi===0?d.z1:zi===1?d.z2:d.z3);
          var w=d.pct*zPct/10000;if(w<=0)return;
          var oldC=oldRC?(oldRC['z'+(zi+1)]&&oldRC['z'+(zi+1)][wtIdx]||0):(FMC[st+'-Z'+(zi+1)]?FMC[st+'-Z'+(zi+1)][wtIdx]:0);
          var newC=result['z'+(zi+1)]?result['z'+(zi+1)][wtIdx]:0;
          oldBlend+=oldC*w;newBlend+=newC*w;totW+=w;
        });
      });
      if(totW>0){oldBlend/=totW;newBlend/=totW;}
      var delta=Math.round((newBlend-oldBlend)*1000)/1000;
      var annualImpact=vol>0?Math.round(delta*vol):null;
      // Use stored gpSnap for current GP — then adjust by Leg3 delta
      var snap=opp.gpSnap;
      var currentGPpct=snap?snap.gpPct:null;
      var currentGPannual=snap?snap.gpAnnual:null;
      var revAnnual=snap?snap.revAnnual:null;
      var newGPannual=currentGPannual!=null&&annualImpact!=null?Math.round(currentGPannual-annualImpact):null;
      var newGPpct=revAnnual&&revAnnual>0&&newGPannual!=null?Math.round(newGPannual/revAnnual*1000)/10:null;
      var deltaGPpct=currentGPpct!=null&&newGPpct!=null?Math.round((newGPpct-currentGPpct)*10)/10:null;
      var deltaGPannual=currentGPannual!=null&&newGPannual!=null?Math.round(newGPannual-currentGPannual):null;
      // Fallback: if no snap, show Leg3 cost impact as estimated GP$ delta (delta is negative = cost saving = GP improvement)
      var estDeltaGP=deltaGPannual!=null?deltaGPannual:(annualImpact!=null?Math.round(-annualImpact):null);
      var estIsApprox=deltaGPannual==null&&estDeltaGP!=null;
      oppRows.push({id:id,name:opp.cust||'Unnamed',prod:opp.prod,origin:opp.origin||'',
        vol:vol,oldBlend:Math.round(oldBlend*100)/100,newBlend:Math.round(newBlend*100)/100,
        delta:delta,annualImpact:annualImpact,hadPrev:!!oldRC,
        currentGPpct:currentGPpct,newGPpct:newGPpct,deltaGPpct:deltaGPpct,
        currentGPannual:currentGPannual,newGPannual:newGPannual,deltaGPannual:deltaGPannual,
        estDeltaGP:estDeltaGP,estIsApprox:estIsApprox,
        hasSnap:!!snap});
    });
    oppRows.sort(function(a,b){return a.delta-b.delta});
    sBillingCommitPreview({result:result,opps:oppRows});
  }

  function confirmBillingCommit(){
    if(!billingCommitPreview)return;
    var result=billingCommitPreview.result;
    // Write to single global key — all opps read from this at runtime, no per-opp writes needed
    sPmRoutingCosts(result);
    if(window.storage){
      window.storage.set("billing-rates-v1",JSON.stringify(result),true).catch(function(){});
    }
    sBillingCommitPreview(null);
    sSaveMsg("✓ Billing rates committed globally ("+billingCommitPreview.opps.length+" opps updated)");
    setTimeout(function(){sSaveMsg("")},5000);
  }

  function parseFileRows(file,callback){
    var reader=new FileReader();var isXls=/\.xlsx?$/i.test(file.name);
    reader.onload=function(evt){
      try{
        var rows=[];
        if(isXls){
          var wb=XLSX.read(evt.target.result,{type:"array"});
          // Try all sheets
          var allRows=[];
          wb.SheetNames.forEach(function(sn){
            var ws=wb.Sheets[sn];
            var sr=XLSX.utils.sheet_to_json(ws,{header:1,defval:""});
            if(sr.length>allRows.length)allRows=sr;// use largest sheet
          });
          rows=allRows;
        }else{
          var txt=evt.target.result;
          var delim=txt.indexOf("\t")>-1?"\t":",";
          rows=txt.split(/\r?\n/).filter(function(r){return r.trim()}).map(function(r){return r.split(delim)});
        }
        callback(null,rows,file.name);
      }catch(err){callback(err,null,file.name)}
    };
    if(isXls)reader.readAsArrayBuffer(file);else reader.readAsText(file);
  }

  function classifyFile(rows,fileName){
    if(!rows||rows.length<2)return{type:"unknown",reason:"< 2 rows"};
    // Try multiple header row offsets (common: title rows above actual headers)
    for(var hdrOff=0;hdrOff<Math.min(5,rows.length-1);hdrOff++){
      var hdr=rows[hdrOff].map(function(h){return String(h).trim().toLowerCase()});
      var pcCol=-1;var zCol=-1;
      hdr.forEach(function(h,i){
        if(pcCol<0&&/post\s*code|postcode|postal|zip\s*code|^pc$/i.test(h))pcCol=i;
        if(zCol<0&&/^(?:new\s+)?(?:pricing\s+)?zone|^region$|^area$|delivery\s*zone/i.test(h))zCol=i;
      });
      if(pcCol<0){for(var ci=0;ci<Math.min(hdr.length,5);ci++){var s=String(rows[hdrOff+1]?.[ci]||"").trim();if(/^\d{3,4}$/.test(s)){pcCol=ci;break}}}
      var pcLikeCount=0;
      for(var ri=hdrOff+1;ri<Math.min(rows.length,hdrOff+50);ri++){if(pcCol>=0){var v=String(rows[ri][pcCol]||"").trim();if(/^\d{3,4}$/.test(v))pcLikeCount++}}
      if(pcCol>=0&&pcLikeCount>20&&rows.length>50){
        if(zCol<0){for(var ci2=0;ci2<hdr.length;ci2++){if(ci2!==pcCol){zCol=ci2;break}}}
        return{type:"postcodes",pcCol:pcCol,zCol:zCol,pcColName:hdr[pcCol],zColName:zCol>=0?hdr[zCol]:"?",rows:rows.length-1-hdrOff,hdrRow:hdrOff};
      }
      // Rate card: detect origin (from) and destination (to) columns
      var fromCol=-1;var toCol=-1;var descCol=-1;
      hdr.forEach(function(h,i){
        if(fromCol<0&&/from\s*zone|origin|sender|^from$/i.test(h))fromCol=i;
        if(toCol<0&&/to\s*zone|dest|receiver|^to$|^zone$/i.test(h))toCol=i;
        if(descCol<0&&/name|description|city|location|zone\s*name|suburb/i.test(h))descCol=i;
      });
      if(toCol<0&&zCol>=0)toCol=zCol;
      if(toCol<0){for(var ci3=0;ci3<hdr.length;ci3++){
        var allNum=true;for(var ri2=hdrOff+1;ri2<Math.min(rows.length,hdrOff+10);ri2++){var v2=parseFloat(rows[ri2]?.[ci3]);if(isNaN(v2))allNum=false}
        if(!allNum&&ci3!==fromCol){toCol=ci3;break}
      }}
      // If no named desc column, check column after toCol for non-numeric text
      if(descCol<0&&toCol>=0&&toCol+1<hdr.length){
        var maybeDesc=true;
        for(var ri2b=hdrOff+1;ri2b<Math.min(rows.length,hdrOff+5);ri2b++){
          var dv=parseFloat(rows[ri2b]?.[toCol+1]);if(!isNaN(dv))maybeDesc=false;
        }
        if(maybeDesc&&toCol+1!==fromCol)descCol=toCol+1;
      }
      var wtCols=[];
      var knownWt={"xp250":0.25,"xp0":0.5,"xp0.5":0.5,"xp1":1,"xp2":2,"xp3":3,"xp5":5,"pwf10":10,"pwf15":15,"pwf20":20,"pwf25":25};
      hdr.forEach(function(h,i){
        if(i===fromCol||i===toCol||i===descCol)return;
        var hl=h.replace(/\s+/g,"").toLowerCase();
        if(knownWt[hl]!==undefined){wtCols.push({col:i,wt:knownWt[hl],hdr:h});return}
        // Handle range formats like "0.25＜W≤0.5KG" → extract upper bound (0.5)
        var hl2=h.replace(/[＜＞≤≥]/g,function(c){return{'\uff1c':'<','\uff1e':'>','\u2264':'<=','\u2265':'>='}[c]||c});
        var rangeMatch=hl2.match(/<=?\s*([\d.]+)\s*(?:kg)?/i);
        if(rangeMatch){var wv2=parseFloat(rangeMatch[1]);if(wv2>0&&wv2<=30){wtCols.push({col:i,wt:wv2,hdr:h});return}}
        var wm=h.match(/([\d.]+)\s*(?:kg)?/);
        if(wm){var wv=parseFloat(wm[1]);if(wv>0&&wv<=30)wtCols.push({col:i,wt:wv,hdr:h})}
      });
      if(toCol>=0&&wtCols.length>=3){
        var origins=[];
        if(fromCol>=0){var oSet={};for(var ri3=hdrOff+1;ri3<rows.length;ri3++){var ov=String(rows[ri3][fromCol]||"").trim();if(ov&&!oSet[ov]){oSet[ov]=true;origins.push(ov)}}}
        return{type:"rates",fromCol:fromCol,toCol:toCol,descCol:descCol,fromColName:fromCol>=0?hdr[fromCol]:null,toColName:hdr[toCol],wtCols:wtCols,origins:origins,rows:rows.length-1-hdrOff,hdrRow:hdrOff};
      }
    }
    var fallbackHdr=rows[0].map(function(h){return String(h).trim().toLowerCase()});
    return{type:"unknown",reason:"Could not classify. Headers: "+fallbackHdr.join(", ")};
  }

  function handleMapperUpload(e){
    var files=e.target.files;if(!files||!files.length)return;
    var pending=files.length;var parsed=[];var log=[];
    for(var i=0;i<files.length;i++){(function(file){
      parseFileRows(file,function(err,rows,name){
        pending--;
        if(err){log.push("✕ "+name+": "+err.message)}
        else{
          var cls=classifyFile(rows,name);
          parsed.push({name:name,cls:cls,rows:rows});
          log.push("✓ "+name+" -> "+(cls.type==="postcodes"?"Postcode file ("+cls.rows+" rows, zone col: "+cls.zColName+")":cls.type==="rates"?"Rate card ("+cls.rows+" zones, "+cls.wtCols.length+" weight breaks)":"Unknown -- "+cls.reason));
        }
        if(pending<=0)processMapperFiles(parsed,log);
      });
    })(files[i])}
    e.target.value="";
  }

  function processMapperFiles(parsed,log){
    var pcFile=parsed.find(function(p){return p.cls.type==="postcodes"});
    var rateFile=parsed.find(function(p){return p.cls.type==="rates"});
    // Build postcode map
    var map=null;var zones={};var matched=0;var totalPc=0;
    if(pcFile){
      map={};var cls=pcFile.cls;var dataStart=(cls.hdrRow||0)+1;
      for(var ri=dataStart;ri<pcFile.rows.length;ri++){
        var row=pcFile.rows[ri];
        var pc=String(row[cls.pcCol]||"").trim().replace(/^0+/,"");
        var zone=String(row[cls.zCol]||"").trim();
        if(!pc||!zone||pc.length<3||pc.length>4)continue;
        if(!map[pc])map[pc]={};
        map[pc][zone]=(map[pc][zone]||0)+1;
        zones[zone]=true;totalPc++;
        if(ZD_ZONES[pc])matched++;
      }
      var uniquePcs=Object.keys(map).length;
      log.push("  Suburb entries parsed: "+totalPc+" across "+uniquePcs+" postcodes, "+matched+" entries matched to DAI zones ("+Math.round(uniquePcs/Object.keys(ZD_ZONES).length*100)+"% postcode coverage)");
    }
    // Build rates from rate file
    var rates={};var allRatesByOrigin={};var detectedOrigins=[];var zoneDescs={};
    if(rateFile){
      var cls2=rateFile.cls;
      var compWts=cls2.wtCols.map(function(wc){return wc.wt});
      function nearestPRIdx(compWt){
        var bestI=0;var bestD=Math.abs(PRW[0]-compWt);
        for(var i=1;i<PRW.length;i++){var d=Math.abs(PRW[i]-compWt);if(d<bestD){bestD=d;bestI=i}}
        return bestI;
      }
      var wtMap=cls2.wtCols.map(function(wc){return{col:wc.col,prIdx:nearestPRIdx(wc.wt),compWt:wc.wt,prWt:PRW[nearestPRIdx(wc.wt)]}});
      var nativeBreaks=cls2.wtCols.slice().sort(function(a,b){return a.wt-b.wt}).map(function(wc){return wc.wt});
      var nativeCols=cls2.wtCols.slice().sort(function(a,b){return a.wt-b.wt}).map(function(wc){return wc.col});
      log.push("  Weight mapping: "+wtMap.map(function(w){return w.compWt+"kg->"+w.prWt+"kg"}).join(", "));
      log.push("  Native breaks: "+nativeBreaks.join(", ")+"kg");
      function parseRateRow(row2){
        var zRates=PRW.map(function(){return 0});
        wtMap.forEach(function(wm){var v=parseFloat(row2[wm.col]);if(!isNaN(v)&&v>0)zRates[wm.prIdx]=v});
        for(var wi=0;wi<zRates.length;wi++){
          if(zRates[wi]>0)continue;
          var below=-1;var above=-1;
          for(var b=wi-1;b>=0;b--){if(zRates[b]>0){below=b;break}}
          for(var a=wi+1;a<zRates.length;a++){if(zRates[a]>0){above=a;break}}
          if(below>=0&&above>=0){var frac=(PRW[wi]-PRW[below])/(PRW[above]-PRW[below]);zRates[wi]=Math.round((zRates[below]+(zRates[above]-zRates[below])*frac)*100)/100}
          else if(below>=0){zRates[wi]=zRates[below]}else if(above>=0){zRates[wi]=zRates[above]}
        }
        return zRates;
      }
      function parseNativeRow(row2){
        return nativeCols.map(function(c){var v=parseFloat(row2[c]);return(!isNaN(v)&&v>0)?v:0});
      }
      var allNativeByOrigin={};
      var hasOrigin=cls2.fromCol>=0;
      var hasDesc=cls2.descCol>=0;
      var rateStart=(cls2.hdrRow||0)+1;
      var seenZones={};var originSections=[];var currentSection=[];
      for(var ri2=rateStart;ri2<rateFile.rows.length;ri2++){
        var row2=rateFile.rows[ri2];
        var dest=String(row2[cls2.toCol]||"").trim();if(!dest)continue;
        var orig=hasOrigin?String(row2[cls2.fromCol]||"").trim():"ALL";
        if(hasDesc){var dsc=String(row2[cls2.descCol]||"").trim();if(dsc&&!zoneDescs[dest])zoneDescs[dest]=dsc}
        // Detect duplicate zones = new origin section
        if(!hasOrigin&&seenZones[dest]){
          originSections.push(currentSection);currentSection=[];seenZones={};
        }
        seenZones[dest]=true;
        zones[dest]=true;
        var zRates=parseRateRow(row2);
        var nRates=parseNativeRow(row2);
        currentSection.push({dest:dest,orig:orig,rates:zRates,native:nRates});
        if(hasOrigin){
          if(!allRatesByOrigin[orig])allRatesByOrigin[orig]={};
          allRatesByOrigin[orig][dest]=zRates;
          if(!allNativeByOrigin[orig])allNativeByOrigin[orig]={};
          allNativeByOrigin[orig][dest]=nRates;
        }
      }
      if(currentSection.length>0)originSections.push(currentSection);
      // If no explicit origin column but multiple sections detected, infer origins
      if(!hasOrigin&&originSections.length>1){
        var stateToDepot2={VIC:"MEL",NSW:"SYD",QLD:"BNE",SA:"ADL",WA:"PER",TAS:"HBA",NT:"DRW",ACT:"CBR"};
        originSections.forEach(function(section,si){
          var cheapest2=null;
          section.forEach(function(r){if(!cheapest2||r.rates[0]<cheapest2.rate)cheapest2={zone:r.dest,rate:r.rates[0]}});
          var st2=cheapest2?guessZoneState(cheapest2.zone,(zoneDescs||{})[cheapest2.zone]):"";
          var origLabel=stateToDepot2[st2]||("ORIGIN"+(si+1));
          if(!allRatesByOrigin[origLabel])allRatesByOrigin[origLabel]={};
          section.forEach(function(r){allRatesByOrigin[origLabel][r.dest]=r.rates});
          if(!allNativeByOrigin[origLabel])allNativeByOrigin[origLabel]={};
          section.forEach(function(r){allNativeByOrigin[origLabel][r.dest]=r.native});
          log.push("  Section "+(si+1)+": "+section.length+" zones -> inferred origin ex-"+origLabel+" (cheapest: "+cheapest2.zone+" $"+cheapest2.rate.toFixed(2)+")");
        });
      }else if(!hasOrigin&&originSections.length===1){
        allRatesByOrigin["ALL"]={};
        originSections[0].forEach(function(r){allRatesByOrigin["ALL"][r.dest]=r.rates});
        allNativeByOrigin["ALL"]={};
        originSections[0].forEach(function(r){allNativeByOrigin["ALL"][r.dest]=r.native});
      }
      detectedOrigins=Object.keys(allRatesByOrigin).sort();
      log.push("  Origins detected: "+detectedOrigins.join(", ")+" ("+detectedOrigins.length+" origins × dest zones)");
      detectedOrigins.forEach(function(o){log.push("    "+o+": "+Object.keys(allRatesByOrigin[o]).length+" destination zones")});
      // Set default origin to match current opp's depot if available
      if(detectedOrigins.length>0){
        var defOrig=detectedOrigins.indexOf(prD)>=0?prD:detectedOrigins[0];
        rates=allRatesByOrigin[defOrig];
      }
    }
    var zArr=Object.keys(zones).sort();
    if(map)sCompPcMap(map);
    sCompZones(zArr);
    sCompAllRates(allRatesByOrigin);
    if(nativeBreaks&&nativeBreaks.length>0)sCompNativeBreaks(nativeBreaks);
    sCompAllNative(allNativeByOrigin);
    if(Object.keys(zoneDescs||{}).length>0)sCompZoneDescs(zoneDescs);
    sMapOrigins(detectedOrigins);
    if(detectedOrigins.length>0){
      var selOrig=detectedOrigins.indexOf(prD)>=0?prD:detectedOrigins[0];
      sMapSelOrig(selOrig);
    }
    if(Object.keys(rates).length>0)sCompRates(rates);
    else if(!rateFile){
      var initR={};zArr.forEach(function(z){initR[z]=PRW.map(function(){return 0})});
      sCompRates(initR);
    }
    // For single-origin rate cards (no "from" column), infer origin from cheapest zone
    var inferredOrigin="";
    if(detectedOrigins.length<=1&&Object.keys(rates).length>0){
      var cheapest=null;
      Object.keys(rates).forEach(function(z){
        var r05=rates[z]&&rates[z][0]?rates[z][0]:Infinity;
        if(!cheapest||r05<cheapest.rate){cheapest={zone:z,rate:r05}}
      });
      if(cheapest){
        var cheapState=guessZoneState(cheapest.zone,(zoneDescs||{})[cheapest.zone]);
        var stateToDepot={VIC:"MEL",NSW:"SYD",QLD:"BNE",SA:"ADL",WA:"PER",TAS:"HBA",NT:"DRW",ACT:"CBR"};
        if(cheapState&&stateToDepot[cheapState]){
          inferredOrigin=stateToDepot[cheapState];
          log.push("  Inferred origin: ex-"+inferredOrigin+" (cheapest zone: "+cheapest.zone+(zoneDescs[cheapest.zone]?" ("+zoneDescs[cheapest.zone]+")":"")+
            " at $"+cheapest.rate.toFixed(2)+" -> "+cheapState+")");
          if(prD&&prD!==inferredOrigin){
            log.push("  !! WARNING: Current opp depot is "+prD+" but rates appear to be ex-"+inferredOrigin+". Verify correct rate card is loaded.");
          }
        }
      }
    }
    sMapResult(null);
    var uniquePcs=map?Object.keys(map).length:0;
    var daiMatched=map?Object.keys(map).filter(function(pc){return !!ZD_ZONES[pc]}).length:0;
    sMapStats({totalPc:totalPc,uniquePcs:uniquePcs,matched:daiMatched,daiTotal:Object.keys(ZD_ZONES).length,
      coverage:Object.keys(ZD_ZONES).length>0?Math.round(daiMatched/Object.keys(ZD_ZONES).length*100):0,
      zoneCount:zArr.length,files:parsed.map(function(p){return{name:p.name,type:p.cls.type}}),
      hasRateFile:!!rateFile,hasPcFile:!!pcFile,originCount:detectedOrigins.length});
    sMapFiles(parsed.map(function(p){return{name:p.name,type:p.cls.type,rows:p.cls.rows||0}}));
    sMapLog(log);
    // Auto-estimate tier assignments when no postcode file
    if(!pcFile&&Object.keys(rates).length>0){
      var estTiers={};
      var zoneRates=[];
      zArr.forEach(function(z){var r=rates[z];if(r&&r[0]>0)zoneRates.push({z:z,r05:r[0]})});
      zoneRates.sort(function(a,b){return a.r05-b.r05});
      // Name-based patterns first
      zoneRates.forEach(function(zr){
        var zl=zr.z.toLowerCase();
        // Metro patterns: ends in 0, or matches known city codes
        if(/0$/.test(zl)||/^(mel|syd|bne|adl|per|hba|drw|cbr)f?$/i.test(zr.z))estTiers[zr.z]="Z1";
        // Regional patterns: ends in 1
        else if(/1$/.test(zl))estTiers[zr.z]="Z2";
        // Remote patterns: ends in 2+, or known remote codes
        else if(/[2-9]$/.test(zl)||/^(rem|nt1|roa)$/i.test(zr.z))estTiers[zr.z]="Z3";
      });
      // Rate-based fallback for unassigned zones
      var unassigned=zoneRates.filter(function(zr){return !estTiers[zr.z]});
      if(unassigned.length>0){
        var t1=Math.ceil(unassigned.length*0.4);var t2=Math.ceil(unassigned.length*0.7);
        unassigned.forEach(function(zr,i){
          if(i<t1)estTiers[zr.z]="Z1";
          else if(i<t2)estTiers[zr.z]="Z2";
          else estTiers[zr.z]="Z3";
        });
      }
      sCompZoneTiers(estTiers);
      var estStates={};zArr.forEach(function(z){var gs=guessZoneState(z,(zoneDescs||{})[z]);if(gs)estStates[z]=gs});
      sCompZoneStates(estStates);
      log.push("  Auto-estimated tier assignments for "+Object.keys(estTiers).length+" zones (review and adjust before estimating)");
      sMapLog(log);
    }
    // Auto-run if both files present
    if(map&&Object.keys(rates).length>0){
      setTimeout(function(){runMapper()},100);
    }
  }

  function buildDaiZoneMap(){
    if(!compPcMap)return{};
    var daiZones={};
    Object.keys(ZD_ZONES).forEach(function(pc){
      var dz=daiZoneKey(ZD_ZONES[pc]);if(!dz)return;
      var czMap=compPcMap[pc];
      if(!daiZones[dz])daiZones[dz]={zones:{},total:0,unmapped:0};
      if(czMap){
        Object.keys(czMap).forEach(function(cz){
          if(!daiZones[dz].zones[cz])daiZones[dz].zones[cz]=0;
          daiZones[dz].zones[cz]+=czMap[cz];
          daiZones[dz].total+=czMap[cz];
        });
      }else{daiZones[dz].unmapped++}
    });
    return daiZones;
  }

  function calcBlendedForRates(ratesMap,excludeMap){
    var dzMap=buildDaiZoneMap();
    var result={};var details={};var anomalies=[];
    Object.keys(dzMap).forEach(function(dz){
      var info=dzMap[dz];if(info.total===0)return;
      var excl=excludeMap&&excludeMap[dz]?excludeMap[dz]:{};
      // Calculate with exclusions applied
      var activeTotal=0;
      Object.keys(info.zones).forEach(function(cz){if(!excl[cz])activeTotal+=info.zones[cz]});
      var rates=PRW.map(function(_,wi){
        var sum=0;var cnt=0;
        Object.keys(info.zones).forEach(function(cz){
          if(excl[cz])return;
          var cr=ratesMap[cz];
          if(cr&&cr[wi]>0){sum+=cr[wi]*info.zones[cz];cnt+=info.zones[cz]}
        });
        return cnt>0?Math.round(sum/cnt*100)/100:0;
      });
      result[dz]=rates;
      var zDetail=[];
      Object.keys(info.zones).sort().forEach(function(cz){
        zDetail.push({zone:cz,count:info.zones[cz],pct:Math.round(info.zones[cz]/info.total*1000)/10,excluded:!!excl[cz]});
      });
      details[dz]={mapped:info.total,unmapped:info.unmapped||0,breakdown:zDetail};
      // Detect anomalies: comp zone with <15% suburbs but >25% rate contribution at 0.5kg
      if(rates[0]>0&&!excludeMap){
        Object.keys(info.zones).forEach(function(cz){
          var cr=ratesMap[cz];if(!cr||!cr[0]||cr[0]<=0)return;
          var subPct=info.zones[cz]/info.total;
          var contrib=cr[0]*info.zones[cz]/(rates[0]*info.total);
          if(subPct<0.15&&contrib>0.25&&cr[0]>rates[0]*1.5){
            anomalies.push({daiZone:dz,compZone:cz,suburbs:info.zones[cz],subPct:Math.round(subPct*1000)/10,
              rate05:cr[0],blended05:rates[0],contribPct:Math.round(contrib*1000)/10});
          }
        });
      }
    });
    return{result:result,details:details,anomalies:anomalies};
  }

  var [mapAnomalies,sMapAnomalies]=useState([]);
  var [mapExclAnom,sMapExclAnom]=useState(null);
  var [mapAnomSel,sMapAnomSel]=useState({}); // {index: true} — which anomalies are selected for removal

  function applyFscToResult(result){
    if(mapFsc!=="exclusive"||!mapFscPct)return result;
    var mult=1+mapFscPct/100;var out={};
    Object.keys(result).forEach(function(dz){out[dz]=result[dz].map(function(r){return Math.round(r*mult*100)/100})});
    return out;
  }

  function runMapper(){
    if(!compPcMap||compZones.length===0)return;
    var calc=calcBlendedForRates(compRates,mapExclAnom);
    var fscResult=applyFscToResult(calc.result);
    sMapResult(fscResult);
    sMapStats(function(prev){return{...prev,details:calc.details,resultZones:Object.keys(fscResult).length}});
    if(calc.anomalies&&calc.anomalies.length>0&&!mapExclAnom){sMapAnomalies(calc.anomalies);var sel={};calc.anomalies.forEach(function(_,i){sel[i]=true});sMapAnomSel(sel)}
  }

  function runMapperClean(){
    var excl={};var count=0;
    mapAnomalies.forEach(function(a,ai){
      if(!mapAnomSel[ai])return;
      if(!excl[a.daiZone])excl[a.daiZone]={};
      excl[a.daiZone][a.compZone]=true;count++;
    });
    if(count===0)return;
    sMapExclAnom(excl);
    var calc=calcBlendedForRates(compRates,excl);
    var fscResult=applyFscToResult(calc.result);
    sMapResult(fscResult);
    sMapStats(function(prev){return{...prev,details:calc.details,resultZones:Object.keys(fscResult).length}});
    sMapLog(function(prev){return[...prev,"Recalculated with "+count+" anomal"+(count===1?"y":"ies")+" removed across "+Object.keys(excl).length+" zone"+(Object.keys(excl).length===1?"":"s")]});
  }

  function runMapperReset(){
    sMapExclAnom(null);sMapAnomSel({});
    var calc=calcBlendedForRates(compRates,null);
    var fscResult=applyFscToResult(calc.result);
    sMapResult(fscResult);
    sMapStats(function(prev){return{...prev,details:calc.details,resultZones:Object.keys(fscResult).length}});
    if(calc.anomalies)sMapAnomalies(calc.anomalies);
    sMapLog(function(prev){return[...prev,"Reset to full rates (anomalies restored)"]});
  }

  function runEstimate(){
    // Build state+tier indexed lookup
    // For each DAI zone (e.g. VIC-Z1), only use comp zones tagged with tier Z1 AND state VIC
    // Fallback: if no state-matched zones for a tier, use zones with no state assigned
    var byStateTier={};// {"VIC:Z1": [compZones], "NSW:Z2": [...]}
    var noStateByTier={Z1:[],Z2:[],Z3:[]};
    compZones.forEach(function(cz){
      var tier=compZoneTiers[cz];if(!tier||!compRates[cz])return;
      var st=compZoneStates[cz];
      if(st){
        var key=st+":"+tier;
        if(!byStateTier[key])byStateTier[key]=[];
        byStateTier[key].push(cz);
      }else{
        noStateByTier[tier].push(cz);
      }
    });
    var result={};var details={};var zoneCount=0;
    var STS_ALL=["NSW","VIC","QLD","SA","WA","TAS","NT","ACT"];
    STS_ALL.forEach(function(st){
      [1,2,3].forEach(function(z){
        var dzk=st+"-Z"+z;var tierKey="Z"+z;
        var stKey=st+":"+tierKey;
        // Prefer state-matched zones, fallback to unassigned zones of same tier
        var matchZones=byStateTier[stKey]||[];
        if(matchZones.length===0)matchZones=noStateByTier[tierKey]||[];
        if(matchZones.length===0)return;
        var rates=PRW.map(function(_,wi){
          var sum=0;var cnt=0;
          matchZones.forEach(function(cz){
            var cr=compRates[cz];if(cr&&cr[wi]>0){sum+=cr[wi];cnt++}
          });
          return cnt>0?Math.round(sum/cnt*100)/100:0;
        });
        if(rates.some(function(r){return r>0})){result[dzk]=rates;zoneCount++;
          details[dzk]={mapped:matchZones.length,unmapped:0,breakdown:matchZones.map(function(cz){return{zone:cz+"("+(compZoneStates[cz]||"nat")+")",count:1,pct:Math.round(100/matchZones.length*10)/10}})};
        }
      });
    });
    var fscResult=applyFscToResult(result);
    sMapResult(fscResult);
    sMapStats({resultZones:zoneCount,details:details,coverage:0,matched:0,daiTotal:Object.keys(ZD_ZONES).length,zoneCount:compZones.length,totalPc:0,uniquePcs:0,hasRateFile:true,hasPcFile:false,estimated:true});
    var z1ct=0;var z2ct=0;var z3ct=0;
    compZones.forEach(function(cz){var t=compZoneTiers[cz];if(t==="Z1")z1ct++;if(t==="Z2")z2ct++;if(t==="Z3")z3ct++});
    sMapLog(function(prev){return[...prev,"Estimated rates for "+zoneCount+" DAI zones from "+compZones.length+" comp zones (Z1:"+z1ct+" Z2:"+z2ct+" Z3:"+z3ct+")"]});
  }

  function applyEstimateResult(){
    if(!mapResult)return;
    // Build DAI zone -> comp zone name map from tier+state assignments
    var zm={};
    var STS_ALL=["NSW","VIC","QLD","SA","WA","TAS","NT","ACT"];
    STS_ALL.forEach(function(st){
      [1,2,3].forEach(function(z){
        var dzk=st+"-Z"+z;var tierKey="Z"+z;
        var matched=[];
        compZones.forEach(function(cz){
          if(compZoneTiers[cz]===tierKey&&compZoneStates[cz]===st)matched.push(cz);
        });
        if(matched.length===0){
          compZones.forEach(function(cz){
            if(compZoneTiers[cz]===tierKey&&!compZoneStates[cz])matched.push(cz);
          });
        }
        if(matched.length>0)zm[dzk]=matched.join("/");
      });
    });
    updTgt(mapWhich,"rates",mapResult);updTgt(mapWhich,"on",true);updTgt(mapWhich,"label",compLabel);updTgt(mapWhich,"source","estimated");updTgt(mapWhich,"zoneMap",zm);
    sMapLog(function(prev){return[...prev,"Applied ESTIMATED "+compLabel+" rates to Target "+(mapWhich+1)]});
    sMapResult(null);sCompZones([]);sCompRates({});sCompZoneTiers({});sCompZoneStates({});sMapFiles([]);
    var nextSlot=mapWhich+1;if(nextSlot>=prTgts.length)nextSlot=0;
    sMapWhich(nextSlot);sCompLabel("Competitor "+(nextSlot+1));
  }

  function switchOrigin(orig){
    sMapSelOrig(orig);sMapExclAnom(null);sMapAnomalies([]);
    if(compAllRates[orig]){
      sCompRates(compAllRates[orig]);
      if(compPcMap){
        var calc=calcBlendedForRates(compAllRates[orig],null);
        var fscResult=applyFscToResult(calc.result);
        sMapResult(fscResult);
        sMapStats(function(prev){return{...prev,details:calc.details,resultZones:Object.keys(fscResult).length}});
        if(calc.anomalies)sMapAnomalies(calc.anomalies);
      }
    }
  }

  function applyMapResult(){
    if(!mapResult)return;
    var slotLabel="Target "+(mapWhich+1);
    updTgt(mapWhich,"rates",mapResult);updTgt(mapWhich,"on",true);updTgt(mapWhich,"label",compLabel);updTgt(mapWhich,"source","mapped");
    // Store raw comp zone rates (with FSC if applied) for per-parcel lookup
    var rawR=JSON.parse(JSON.stringify(compRates));
    if(mapFsc==="exclusive"&&mapFscPct){var mult=1+mapFscPct/100;Object.keys(rawR).forEach(function(z){rawR[z]=rawR[z].map(function(r){return Math.round(r*mult*100)/100})})}
    updTgt(mapWhich,"rawRates",rawR);
    // Store rawZoneMap: {daiZone: {compZone: [rates]}} — used by Z1 Metro Floor
    // This preserves which comp zones contributed to each DAI zone and their individual rates
    var dzMap=buildDaiZoneMap();
    var rawZM={};
    Object.keys(dzMap).forEach(function(dz){
      var info=dzMap[dz];if(info.total===0)return;
      rawZM[dz]={};
      Object.keys(info.zones).forEach(function(cz){
        var cr=rawR[cz];if(!cr||cr.length===0)return;
        rawZM[dz][cz]=cr.slice();
      });
    });
    updTgt(mapWhich,"rawZoneMap",rawZM);
    // Store native weight breaks + rates for per-parcel analysis
    var activeNative=compAllNative[mapSelOrig||Object.keys(compAllNative)[0]]||{};
    var nativeR=JSON.parse(JSON.stringify(activeNative));
    if(mapFsc==="exclusive"&&mapFscPct){var mult1b=1+mapFscPct/100;Object.keys(nativeR).forEach(function(z){nativeR[z]=nativeR[z].map(function(r){return Math.round(r*mult1b*100)/100})})}
    updTgt(mapWhich,"nativeBreaks",compNativeBreaks);
    updTgt(mapWhich,"nativeRates",nativeR);
    // Store postcode->dominant comp zone lookup for parcel-level analysis
    if(compPcMap){
      var pcz={};Object.keys(compPcMap).forEach(function(pc){
        var zMap=compPcMap[pc];var best="";var bc=0;
        Object.keys(zMap).forEach(function(z){if(zMap[z]>bc){bc=zMap[z];best=z}});
        if(best)pcz[pc]=best;
      });
      updTgt(mapWhich,"pcZones",pcz);
    }
    sMapLog(function(prev){return[...prev,"Applied "+compLabel+" ("+(mapSelOrig||"")+")"+" to "+slotLabel]});
    sMapResult(null);sCompPcMap(null);sCompZones([]);sCompRates({});sCompAllRates({});sCompNativeBreaks([]);sCompAllNative({});sMapOrigins([]);sMapSelOrig("");sMapFiles([]);
    var nextSlot=mapWhich+1;if(nextSlot>=prTgts.length)nextSlot=0;
    sMapWhich(nextSlot);sCompLabel("Competitor "+(nextSlot+1));
  }

  function applyAllOrigins(){
    if(!compPcMap||mapOrigins.length===0)return;
    var applied=[];
    // Build pcZones once from compPcMap
    var pcz={};
    Object.keys(compPcMap).forEach(function(pc){
      var zMap=compPcMap[pc];var best="";var bc=0;
      Object.keys(zMap).forEach(function(z){if(zMap[z]>bc){bc=zMap[z];best=z}});
      if(best)pcz[pc]=best;
    });
    mapOrigins.forEach(function(orig){
      var origRates=compAllRates[orig];if(!origRates)return;
      var calc=calcBlendedForRates(origRates);
      var fscResult=applyFscToResult(calc.result);
      if(Object.keys(fscResult).length===0)return;
      var depot=orig;
      var found=false;
      oppList.forEach(function(opp){
        if(opp.prod!=="pr")return;
        var data=oppCache.current[opp.id];if(!data)return;
        if(data.prD===depot){
          if(!data.prTgts){
            var mig=[];
            if(data.prCustTgtOn||data.prCustTgt)mig.push({on:!!data.prCustTgtOn,label:data.prTgtLabel1||"Competitor 1",rates:data.prCustTgt||{},source:data.prCustTgt?"manual":undefined});
            if(data.prCustTgt2On||data.prCustTgt2)mig.push({on:!!data.prCustTgt2On,label:data.prTgtLabel2||"Competitor 2",rates:data.prCustTgt2||{},source:data.prCustTgt2?"manual":undefined});
            if(mig.length===0)mig=[{on:false,label:"Competitor 1",rates:{}},{on:false,label:"Competitor 2",rates:{}}];
            data.prTgts=mig;
          }
          while(data.prTgts.length<=mapWhich)data.prTgts.push({on:false,label:"Competitor "+(data.prTgts.length+1),rates:{}});
          var rawR2=JSON.parse(JSON.stringify(origRates));
          if(mapFsc==="exclusive"&&mapFscPct){var mult2=1+mapFscPct/100;Object.keys(rawR2).forEach(function(z){rawR2[z]=rawR2[z].map(function(r){return Math.round(r*mult2*100)/100})})}
          var nativeOrig2=compAllNative[orig]||{};var nativeR2=JSON.parse(JSON.stringify(nativeOrig2));
          if(mapFsc==="exclusive"&&mapFscPct){var mult2b=1+mapFscPct/100;Object.keys(nativeR2).forEach(function(z){nativeR2[z]=nativeR2[z].map(function(r){return Math.round(r*mult2b*100)/100})})}
          data.prTgts[mapWhich]={on:true,label:compLabel,rates:fscResult,source:"mapped",pcZones:pcz,rawRates:rawR2,nativeBreaks:compNativeBreaks,nativeRates:nativeR2};
          oppCache.current[opp.id]=data;
          applied.push(opp.name+" (depot:"+depot+", origin:"+orig+")");
          found=true;
        }
      });
      if(depot===prD){
        var rawR3=JSON.parse(JSON.stringify(origRates));
        if(mapFsc==="exclusive"&&mapFscPct){var mult3=1+mapFscPct/100;Object.keys(rawR3).forEach(function(z){rawR3[z]=rawR3[z].map(function(r){return Math.round(r*mult3*100)/100})})}
        var nativeOrig3=compAllNative[orig]||{};var nativeR3=JSON.parse(JSON.stringify(nativeOrig3));
        if(mapFsc==="exclusive"&&mapFscPct){var mult3b=1+mapFscPct/100;Object.keys(nativeR3).forEach(function(z){nativeR3[z]=nativeR3[z].map(function(r){return Math.round(r*mult3b*100)/100})})}
        updTgt(mapWhich,"rates",fscResult);updTgt(mapWhich,"on",true);updTgt(mapWhich,"label",compLabel);updTgt(mapWhich,"source","mapped");updTgt(mapWhich,"pcZones",pcz);updTgt(mapWhich,"rawRates",rawR3);updTgt(mapWhich,"nativeBreaks",compNativeBreaks);updTgt(mapWhich,"nativeRates",nativeR3);
        if(!found)applied.push("Current opp (depot:"+depot+", origin:"+orig+")");
      }
    });
    if(applied.length>0){
      saveAllOpps();
      sMapLog(function(prev){return[...prev,"Applied "+compLabel+" to "+applied.length+" opps: "+applied.join(", ")]});
    }
  }


  function exportMappingReport(){
    if(!mapResult||!mapStats||!mapStats.details||!compPcMap)return;
    var custName=cust||"Customer";var dateStr=new Date().toLocaleDateString("en-AU");
    var compName=compLabel||"Competitor";var originLabel=mapSelOrig||"ALL";
    var h="<html><head><title>"+custName+" -- "+compName+" Zone Mapping Report</title><style>";
    h+="*{box-sizing:border-box}body{font-family:'Segoe UI',Arial,sans-serif;padding:40px 50px;color:#1a1a2e;line-height:1.6;max-width:1200px;margin:0 auto;font-size:12px}";
    h+="h1{font-size:20px;color:#0a2463;margin:0 0 4px}h2{font-size:14px;color:#0a2463;margin:28px 0 10px;border-bottom:2px solid #0a2463;padding-bottom:4px}h3{font-size:12px;color:#3e92cc;margin:18px 0 6px}";
    h+="table{border-collapse:collapse;width:100%;margin:8px 0 16px;font-size:11px}th{background:#f0f4f8;text-align:left;padding:5px 8px;border:1px solid #d0d7de;font-weight:600;font-size:10px;text-transform:uppercase;letter-spacing:.03em}";
    h+="td{padding:4px 8px;border:1px solid #e1e5e9}.r{text-align:right;font-variant-numeric:tabular-nums}.b{font-weight:700}.gn{color:#1a7f37}.rd{color:#cf222e}.yw{color:#9a6700}";
    h+=".warn{background:#fff3cd;border:1px solid #ffca2c;padding:10px 14px;border-radius:4px;margin:8px 0;font-size:11px}";
    h+=".info{background:#e8f4fd;border:1px solid #b6d4fe;padding:10px 14px;border-radius:4px;margin:8px 0;font-size:11px}";
    h+=".zone-card{background:#f6f8fa;border:1px solid #d0d7de;padding:12px 16px;border-radius:4px;margin:12px 0;page-break-inside:avoid}";
    h+=".footer{margin-top:30px;padding-top:12px;border-top:1px solid #d0d7de;font-size:9px;color:#8b949e}";
    h+="@media print{body{padding:20px}.zone-card{break-inside:avoid}}";
    h+="</style></head><body>";

    // Header
    h+="<div style='font-size:11px;color:#57606a;text-transform:uppercase;letter-spacing:.1em'>Zone Mapping Audit Report</div>";
    h+="<h1>"+compName+" Rate Mapping to Parcel Right Zones</h1>";
    h+="<div style='font-size:12px;color:#57606a'>Prepared for <b>"+custName+"</b> | Origin: <b>"+originLabel+"</b> | "+dateStr+"</div>";

    // Methodology
    h+="<h2>Methodology</h2>";
    h+="<div class='info'><b>How blended rates are calculated:</b><ol style='margin:6px 0;padding-left:20px'>";
    h+="<li>Each postcode in the "+compName+" Location Master file maps to one or more "+compName+" zones (at suburb level)</li>";
    h+="<li>Each postcode in DAI's zone file maps to a DAI zone (e.g. VIC-Z1, NSW-Z2)</li>";
    h+="<li>For each DAI zone, we find all postcodes and their "+compName+" zone assignments</li>";
    h+="<li>Where a postcode spans multiple "+compName+" zones (different suburbs), we weight <b>proportionally by suburb count</b> (not majority-vote)</li>";
    h+="<li>The blended rate = weighted average of "+compName+" rates across all suburb entries within each DAI zone</li>";
    if(mapFsc==="exclusive")h+="<li><b style='color:#9a6700'>FSC adjustment:</b> "+compName+" rates exclude fuel surcharge. A "+mapFscPct+"% FSC has been added to all blended rates to reflect the true cost to the customer</li>";
    h+="</ol></div>";

    // Coverage summary
    h+="<h2>Coverage Summary</h2>";
    h+="<table><tr><th>Metric</th><th class='r'>Value</th></tr>";
    h+="<tr><td>DAI postcodes matched</td><td class='r b'>"+(mapStats.matched||0)+" of "+(mapStats.daiTotal||0)+" ("+mapStats.coverage+"%)</td></tr>";
    h+="<tr><td>Total suburb entries</td><td class='r b'>"+(mapStats.totalPc||0)+"</td></tr>";
    h+="<tr><td>"+compName+" zones detected</td><td class='r'>"+(mapStats.zoneCount||0)+"</td></tr>";
    h+="<tr><td>DAI zones with rates</td><td class='r'>"+(mapStats.resultZones||0)+"</td></tr>";
    h+="<tr><td>Origin</td><td class='r'>"+originLabel+"</td></tr>";
    h+="<tr><td>Weighting method</td><td class='r'>Suburb-level proportional</td></tr>";
    h+="<tr><td>FSC treatment</td><td class='r "+(mapFsc==="exclusive"?"yw b":"gn")+"'>"+(mapFsc==="exclusive"?"+"+mapFscPct+"% FSC added to all rates":"Rates are FSC-inclusive")+"</td></tr>";
    h+="</table>";

    // Per-zone detailed breakdown
    h+="<h2>Per-Zone Breakdown</h2>";
    if(mapFsc==="exclusive")h+="<div class='warn'><b>Note:</b> Individual "+compName+" zone rates below are shown <b>ex-FSC</b> (as per rate card). The blended rate row includes the "+mapFscPct+"% FSC adjustment.</div>";
    var sortedZones=Object.keys(mapResult).sort();
    sortedZones.forEach(function(dz){
      var d=mapStats.details[dz];if(!d)return;
      var rates=mapResult[dz];
      var totalSubs=d.mapped;
      h+="<div class='zone-card'>";
      h+="<h3 style='margin-top:0'>"+dz+" ("+totalSubs+" suburb entries"+(d.unmapped>0?", "+d.unmapped+" postcodes unmapped":"")+")  </h3>";

      // Zone composition table
      h+="<table><tr><th>"+compName+" Zone</th><th class='r'>Suburbs</th><th class='r'>Weight %</th>";
      h+="<th class='r'>0.5kg Rate</th><th class='r'>1kg Rate</th><th class='r'>Contribution 0.5kg</th><th class='r'>Contribution 1kg</th><th>Impact</th></tr>";

      var avgRate05=rates[0];var avgRate1=rates[1];
      // Sort breakdown by suburb count desc
      var sorted=d.breakdown.slice().sort(function(a,b){return b.count-a.count});
      var hasHighPriceWarning=false;

      sorted.forEach(function(bk){
        var cr=compRates[bk.zone];
        var r05=cr?cr[0]:0;var r1=cr?cr[1]:0;
        var contrib05=r05*bk.count/totalSubs;var contrib1=r1*bk.count/totalSubs;
        // Flag if this zone has <15% of suburbs but contributes disproportionately to the rate
        var pctOfSubs=bk.count/totalSubs;
        var pctOfRate05=avgRate05>0?contrib05/avgRate05:0;
        var isHighImpact=pctOfSubs<0.15&&pctOfRate05>0.25&&r05>avgRate05*1.5;
        if(isHighImpact)hasHighPriceWarning=true;

        var rowStyle=isHighImpact?" style='background:#fff3cd'":"";
        h+="<tr"+rowStyle+">";
        h+="<td class='b'>"+bk.zone+"</td>";
        h+="<td class='r'>"+bk.count+"</td>";
        h+="<td class='r'>"+bk.pct+"%</td>";
        h+="<td class='r b'>$"+f(r05)+"</td>";
        h+="<td class='r b'>$"+f(r1)+"</td>";
        h+="<td class='r'>$"+f(contrib05)+"</td>";
        h+="<td class='r'>$"+f(contrib1)+"</td>";
        h+="<td>"+(isHighImpact?"<span class='rd b'>!! High impact -- "+bk.pct+"% of suburbs but $"+f(r05)+" rate ("+f(pctOfRate05*100,0)+"% of blended)</span>":"")+"</td>";
        h+="</tr>";
      });

      h+="<tr style='background:#e8f4fd;font-weight:700'><td>BLENDED RATE</td><td class='r'>"+totalSubs+"</td><td class='r'>100%</td>";
      h+="<td class='r' style='font-size:13px'>$"+f(avgRate05)+"</td>";
      h+="<td class='r' style='font-size:13px'>$"+f(avgRate1)+"</td>";
      h+="<td class='r'>$"+f(avgRate05)+"</td><td class='r'>$"+f(avgRate1)+"</td><td></td></tr>";
      h+="</table>";

      if(hasHighPriceWarning){
        // Calculate what the rate would be without the high-impact zones
        var cleanSum05=0;var cleanSum1=0;var cleanCnt=0;
        sorted.forEach(function(bk){
          var cr2=compRates[bk.zone];var r05b=cr2?cr2[0]:0;var r1b=cr2?cr2[1]:0;
          var pctSub=bk.count/totalSubs;var pctRate=avgRate05>0?(r05b*bk.count/totalSubs)/avgRate05:0;
          var isHigh=pctSub<0.15&&pctRate>0.25&&r05b>avgRate05*1.5;
          if(!isHigh&&r05b>0){cleanSum05+=r05b*bk.count;cleanSum1+=r1b*bk.count;cleanCnt+=bk.count}
        });
        var cleanRate05=cleanCnt>0?cleanSum05/cleanCnt:0;
        var cleanRate1=cleanCnt>0?cleanSum1/cleanCnt:0;
        h+="<div class='warn'><b>Zone mismatch detected:</b> A small number of suburbs in this DAI zone are classified by "+compName;
        h+=" into expensive regional/country zones. This inflates the blended rate.<br><br>";
        h+="<b>Without the high-impact zones:</b> 0.5kg = <b>$"+f(cleanRate05)+"</b>, 1kg = <b>$"+f(cleanRate1)+"</b><br>";
        h+="<b>With all zones (actual):</b> 0.5kg = <b>$"+f(avgRate05)+"</b>, 1kg = <b>$"+f(avgRate1)+"</b><br>";
        h+="<b>Impact:</b> +$"+f(avgRate05-cleanRate05)+" per parcel at 0.5kg due to zone definition differences.<br><br>";
        h+="<em>This means "+compName+" charges significantly more for deliveries to these postcodes. ";
        h+="Parcel Right serves them at Zone 1 (metro) rates, representing a major saving for the customer.</em></div>";
      }

      // Full rate row
      h+="<div style='font-size:10px;color:#57606a;margin-top:4px'><b>All weight breaks:</b> ";
      h+=PRWL.map(function(l,wi){return l+"kg=$"+f(rates[wi])}).join(" | ");
      h+="</div>";
      h+="</div>";
    });

    // Weight break summary across all zones
    h+="<h2>Blended Rate Summary (All Zones)</h2>";
    h+="<table><tr><th>DAI Zone</th>";
    PRWL.forEach(function(l){h+="<th class='r'>"+l+"kg</th>"});
    h+="</tr>";
    sortedZones.forEach(function(dz){
      var rates=mapResult[dz];var d=mapStats.details[dz];
      h+="<tr><td class='b'>"+dz+"</td>";
      rates.forEach(function(r){h+="<td class='r'>$"+f(r)+"</td>"});
      h+="</tr>";
    });
    h+="</table>";

    h+="<div class='footer'>This mapping report is generated for audit and transparency purposes. "+compName+" zone assignments sourced from uploaded Location Master file. ";
    h+="Rates sourced from uploaded "+compName+" rate card for origin "+originLabel+". Suburb-level proportional weighting used throughout. Generated "+dateStr+" by Parcel Right Pricing Agent.</div>";
    h+="</body></html>";

    sReportHTML(h);
  }

  function exportParcelAnalysis(focusTgtIdx){try{
    if(!custRows||!pr||!pr.rc)return;
    var custName=cust||"Customer";var dateStr=new Date().toLocaleDateString("en-AU");
    function wtIdx(w){for(var i=0;i<PRW.length;i++){if(w<=PRW[i])return i}return PRW.length-1}
    var prRateMap={};pr.rc.forEach(function(z){prRateMap[z.k]=z.rates.map(function(r){return r.rate})});
    // Get all enabled targets
    var activeTgts=[];
    prTgts.forEach(function(t,ti){if(t.on&&t.rates&&Object.keys(t.rates).length>0&&t.source!=="calculated")activeTgts.push({idx:ti,label:t.label,rates:t.rates,source:t.source||"",rawRates:t.rawRates||null,pcZones:t.pcZones||null,zoneMap:t.zoneMap||null,nativeBreaks:t.nativeBreaks||null,nativeRates:t.nativeRates||null})});
    if(activeTgts.length===0)return;
    var hasMulti=activeTgts.length>1;
    // Native weight break lookup helper
    function nativeWtIdx(breaks,w){for(var i=0;i<breaks.length;i++){if(w<=breaks[i])return i}return breaks.length-1}
    // Build header row: rates then zones then savings
    var hdr=["Row","Postcode","Weight (kg)","PR Zone","Weight Break","Parcel Right"];
    activeTgts.forEach(function(at){hdr.push(at.label+" Rate")});
    if(hasMulti)hdr.push("LCR (Best Competitor)");
    activeTgts.forEach(function(at){hdr.push(at.label+" Zone")});
    if(hasMulti)hdr.push("LCR Zone");
    activeTgts.forEach(function(at){hdr.push("Saving vs "+at.label)});
    if(hasMulti)hdr.push("Saving vs LCR");
    hdr.push("Coverage");
    // Process rows
    var wsData=[hdr];var totPR=0;var totComp={};var totLCR=0;var rowCount=0;
    var covFull=0;var covPartial=0;var covNone=0;
    activeTgts.forEach(function(at){totComp[at.idx]=0});
    custRows.forEach(function(row,ri){
      if(!row.zone)return;
      var m=row.zone.match(/^([A-Z]+)(\d)$/);if(!m)return;
      var dzk=m[1]+"-Z"+m[2];var wi=wtIdx(row.wt);
      if(ppExclZ[dzk]||ppExclW[wi])return;
      var prRate=(prRateMap[dzk]&&prRateMap[dzk][wi])||0;
      if(prRate<=0)return; // Zone not offered — exclude from export regardless of ppExclZ state
      var compRates2=[];var compZones2=[];var bestComp=Infinity;var bestCompIdx=-1;var compCount=0;
      var pcClean=row.pc.replace(/^0+/,"");
      activeTgts.forEach(function(at,ati){
        var cr=0;var cZone="n/a";
        // Per-postcode lookup with native weight breaks (best accuracy)
        if(at.nativeRates&&at.nativeBreaks&&at.nativeBreaks.length>0&&at.pcZones&&at.pcZones[pcClean]){
          cZone=at.pcZones[pcClean];
          var nwi=nativeWtIdx(at.nativeBreaks,row.wt);
          cr=(at.nativeRates[cZone]&&at.nativeRates[cZone][nwi])||0;
        }
        // Fallback: raw rates at PR breaks with pcZones
        else if(at.rawRates&&at.pcZones&&at.pcZones[pcClean]){
          cZone=at.pcZones[pcClean];
          cr=(at.rawRates[cZone]&&at.rawRates[cZone][wi])||0;
        }
        // Estimated targets: use blended rate
        else if(at.zoneMap&&at.zoneMap[dzk]){
          cZone=at.zoneMap[dzk]+" (est)";
          cr=(at.rates[dzk]&&at.rates[dzk][wi])||0;
        }else{
          // Fallback to blended rate
          cr=(at.rates[dzk]&&at.rates[dzk][wi])||0;
        }
        compRates2.push(cr);totComp[at.idx]+=cr;
        if(cr>0){compCount++;if(cr<bestComp){bestComp=cr;bestCompIdx=ati}}
        compZones2.push(cZone);
      });
      var lcr=bestComp<Infinity?bestComp:0;
      var lcrZone=bestCompIdx>=0?(compZones2[bestCompIdx]+" ("+activeTgts[bestCompIdx].label+")"):"n/a";
      totPR+=prRate;totLCR+=lcr;
      rowCount++;
      var covLabel=compCount===activeTgts.length?"All carriers":(compCount>0?compCount+" of "+activeTgts.length:"No competitor rate");
      if(compCount===activeTgts.length)covFull++;else if(compCount>0)covPartial++;else covNone++;
      var xlRow=[ri+1,row.pc,Math.round(row.wt*1000)/1000,dzk,PRWL[wi]+"kg",prRate];
      compRates2.forEach(function(cr){xlRow.push(cr)});
      if(hasMulti)xlRow.push(lcr);
      compZones2.forEach(function(cz){xlRow.push(cz)});
      if(hasMulti)xlRow.push(lcrZone);
      compRates2.forEach(function(cr){xlRow.push(cr-prRate)});
      if(hasMulti)xlRow.push(lcr-prRate);
      xlRow.push(covLabel);
      wsData.push(xlRow);
    });
    if(rowCount===0)return;
    // Totals
    wsData.push([]);
    var totRow=["","","","","TOTALS",totPR];
    activeTgts.forEach(function(at){totRow.push(totComp[at.idx])});
    if(hasMulti)totRow.push(totLCR);
    activeTgts.forEach(function(){totRow.push("")}); // zone columns blank
    if(hasMulti)totRow.push(""); // LCR zone blank
    activeTgts.forEach(function(at){totRow.push(totComp[at.idx]-totPR)});
    if(hasMulti)totRow.push(totLCR-totPR);
    wsData.push(totRow);
    var ppRow=["","","","","PER PARCEL",totPR/rowCount];
    activeTgts.forEach(function(at){ppRow.push(totComp[at.idx]/rowCount)});
    if(hasMulti)ppRow.push(totLCR/rowCount);
    activeTgts.forEach(function(){ppRow.push("")}); // zone columns blank
    if(hasMulti)ppRow.push(""); // LCR zone blank
    activeTgts.forEach(function(at){ppRow.push((totComp[at.idx]-totPR)/rowCount)});
    if(hasMulti)ppRow.push((totLCR-totPR)/rowCount);
    wsData.push(ppRow);
    // Build XLSX
    var wb=XLSX.utils.book_new();
    var ws=XLSX.utils.aoa_to_sheet(wsData);
    var colWidths=[{wch:6},{wch:10},{wch:10},{wch:10},{wch:11},{wch:14}];
    activeTgts.forEach(function(){colWidths.push({wch:14})}); // rate cols
    if(hasMulti)colWidths.push({wch:18}); // LCR col
    activeTgts.forEach(function(){colWidths.push({wch:10})}); // zone cols
    if(hasMulti)colWidths.push({wch:20}); // LCR zone col
    activeTgts.forEach(function(){colWidths.push({wch:16})}); // saving cols
    if(hasMulti)colWidths.push({wch:16});
    colWidths.push({wch:18}); // coverage col
    ws["!cols"]=colWidths;
    // Green fill: Z1 rows where we are cheaper — specifically for z1-floor targets
    var hasFloor=activeTgts.some(function(at){return at.source==="z1-floor"});
    if(hasFloor){
      // Col index for first competitor rate (after PR rate col = index 5)
      var prColIdx=5;
      // For each data row (skip header row 0)
      for(var ri=1;ri<wsData.length;ri++){
        var dr=wsData[ri];
        if(!dr||!dr[3])continue; // no zone
        var zk=String(dr[3]);
        if(!zk.endsWith("-Z1"))continue; // only Z1
        var prRate=dr[5]||0;
        // Check if we are cheaper than at least one z1-floor target
        var cheaper=false;
        activeTgts.forEach(function(at,ati){
          if(at.source!=="z1-floor")return;
          var compRate=dr[6+ati]||0; // comp rate col
          if(prRate>0&&compRate>0&&prRate<compRate)cheaper=true;
        });
        if(!cheaper)continue;
        // Apply green fill to all cells in this row
        var ncols=dr.length;
        for(var ci2=0;ci2<ncols;ci2++){
          var cellRef=XLSX.utils.encode_cell({r:ri,c:ci2});
          if(!ws[cellRef])ws[cellRef]={v:dr[ci2]||"",t:typeof dr[ci2]==="number"?"n":"s"};
          ws[cellRef].s={fill:{patternType:"solid",fgColor:{rgb:"C6EFCE"}},font:{color:{rgb:"276221"}}};
        }
      }
    }
    XLSX.utils.book_append_sheet(wb,ws,"Parcel Analysis");
    var focusName=prTgts[focusTgtIdx]?prTgts[focusTgtIdx].label:"All";
    var fn=custName.replace(/\s+/g,"_")+"_Parcel_Analysis_vs_"+focusName.replace(/\s+/g,"_")+".xlsx";
    XLSX.writeFile(wb,fn);
  }catch(err){showExportError(err)}}
  function pcToState(pc){
    var p=parseInt(pc);if(isNaN(p))return null;
    if(p>=2000&&p<=2599||p>=2619&&p<=2899||p>=2921&&p<=2999)return"NSW";
    if(p>=2600&&p<=2618||p>=2900&&p<=2920)return"ACT";
    if(p>=3000&&p<=3999)return"VIC";if(p>=4000&&p<=4999)return"QLD";
    if(p>=5000&&p<=5999)return"SA";if(p>=6000&&p<=6999)return"WA";
    if(p>=7000&&p<=7999)return"TAS";if(p>=800&&p<=999)return"NT";return null;
  }

  function parseOneFile(file,callback){
    var isExcel=file.name.match(/\.xlsx?$/i);
    var reader=new FileReader();
    reader.onload=function(ev){
      try{
        var rows=[];
        if(isExcel){
          var wb=XLSX.read(new Uint8Array(ev.target.result),{type:"array"});
          var ws=wb.Sheets[wb.SheetNames[0]];
          rows=XLSX.utils.sheet_to_json(ws,{defval:""});
        }else{
          var text=ev.target.result;
          var lines=text.split("\n");var hdr=lines[0].split(",").map(function(h){return h.trim().replace(/"/g,"")});
          for(var i=1;i<lines.length;i++){var vals=lines[i].split(",");if(vals.length>=2){var obj={};hdr.forEach(function(h,j){obj[h]=vals[j]?vals[j].trim().replace(/"/g,""):""});rows.push(obj)}}
        }
        callback(rows);
      }catch(pe){callback([])}
    };
    if(isExcel){reader.readAsArrayBuffer(file)}else{reader.readAsText(file)}
  }
  function handleUpload(e){
    var files=Array.from(e.target.files);if(!files.length)return;
    var allRows=[];var fileNames=[];var fileStats=[];var filesProcessed=0;
    files.forEach(function(file){
      fileNames.push(file.name);
      parseOneFile(file,function(rows){
        fileStats.push({name:file.name,rows:rows.length});
        allRows=allRows.concat(rows);
        filesProcessed++;
        if(filesProcessed===files.length) processUploadedRows(allRows,fileNames,fileStats);
      });
    });
    e.target.value="";
  }
  function processUploadedRows(rows,fileNames,fileStats){
    try{
      if(rows.length===0){sUploadInfo({error:"No data rows found"});return}
      if(rows.length>1000000){sUploadInfo({error:"Too many rows ("+rows.length+"). Try a sample."});return}

      var cols=Object.keys(rows[0]);
      var usedCols={};
      function normCol(s){return s.toLowerCase().replace(/[_.\-\/()#:,]/g," ").replace(/\s+/g," ").trim()}
      function findCol(patterns,label){
        for(var ci=0;ci<cols.length;ci++){
          if(usedCols[cols[ci]])continue;
          var cl=normCol(cols[ci]);
          for(var pi=0;pi<patterns.length;pi++){if(cl.indexOf(patterns[pi])>=0){usedCols[cols[ci]]=label||true;return cols[ci]}}
        }
        return null;
      }
      // Detect cubic/vol FIRST so "weight" doesn't steal it
      var cbCol=findCol(["cubic weight","cubic wt","cubicweight","vol weight","vol wt","volumetric","dim weight","dimensional","chargeable weight","chargeable wt","cbm","cube weight","cubed weight","cubic kg","dead weight"],"dim");
      var wtCol=findCol(["actual weight","parcel weight","weight kg","weightkg","gross weight","net weight","item weight","shipment weight","weight"],"weight");
      var pcCol=findCol(["postcode","post code","zipcode","zip code","shiptozip","ship to zip","destination postcode","dest postcode","zip","postal"],"postcode");
      var lCol=findCol(["length","len"],"length");var wCol=findCol(["width","wid"],"width");var hCol=findCol(["height","hgt"," ht"],"height");
      var puCol=findCol(["pick up location","pickup location","pickup","depot","origin depot","injection port","origin"],"pickup");

      var hasLWH=!!(lCol&&wCol&&hCol);
      var weights=[];var postcodes=[];var noDimWeights=[];
      var dimVolSum=0;var dimActSum=0;var dimCount=0;var dimVolGtCount=0;
      var dimSamples=[];var wtSamples=[];var dimZeroCount=0;var dimNaNCount=0;
      var activeDepot=null;
      if(prod==="pr"){activeDepot=prD}
      else if(prod==="pma"){var activePorts=Object.keys(pmaInj).filter(function(p){return pmaInj[p]});if(activePorts.length===1)activeDepot=activePorts[0]}
      var totalRows=0;var filteredRows=0;var parsedRows=[];
      rows.forEach(function(r){
        totalRows++;
        if(puCol&&activeDepot){var pu=String(r[puCol]).trim().toUpperCase();if(pu.indexOf(activeDepot)<0)return}
        filteredRows++;
        var aw=wtCol?parseFloat(r[wtCol]):0;
        if(wtCol&&!isNaN(aw)&&aw>0)weights.push(aw);
        if(wtSamples.length<8&&wtCol)wtSamples.push(String(r[wtCol]).substring(0,20));
        var pc="";if(pcCol){var p=r[pcCol];if(p){pc=String(p).replace(/\s/g,"");postcodes.push(pc)}}
        // Capture row for parcel-level analysis (PR product only, max 500k rows)
        if(prod==="pr"&&parsedRows.length<500000&&pc&&!isNaN(aw)&&aw>0){
          var zCode=ZD_ZONES[pc.replace(/^0+/,"")];
          parsedRows.push({pc:pc,wt:aw,zone:zCode||null});
        }
        // Sample raw DIM column values for diagnostics
        if(dimSamples.length<8&&cbCol)dimSamples.push(String(r[cbCol]).substring(0,20));
        if(cbCol){var cwRaw=parseFloat(r[cbCol]);if(isNaN(cwRaw))dimNaNCount++;else if(cwRaw<=0)dimZeroCount++}
        // DIM: prefer LxWxH, fall back to cubic weight column -- never double-count
        // DIM = cubic / actual -- CAN be less than 1.0 for dense/heavy parcels
        var hasDim=false;
        if(hasLWH){
          var l=parseFloat(r[lCol]),wi=parseFloat(r[wCol]),h=parseFloat(r[hCol]);
          if(!isNaN(l)&&!isNaN(wi)&&!isNaN(h)&&l>0&&wi>0&&h>0&&!isNaN(aw)&&aw>0){
            var vw=l*wi*h/5000;
            dimVolSum+=vw;dimActSum+=aw;dimCount++;hasDim=true;
            if(vw>aw)dimVolGtCount++;
          }
        }
        if(!hasDim&&cbCol){
          var cw=parseFloat(r[cbCol]);
          if(!isNaN(cw)&&cw>0&&!isNaN(aw)&&aw>0){
            dimVolSum+=cw;dimActSum+=aw;dimCount++;hasDim=true;
            if(cw>aw)dimVolGtCount++;
          }
        }
        if(!hasDim&&!isNaN(aw)&&aw>0){noDimWeights.push(aw)}
      });

      var pieces=weights.length||filteredRows||rows.length;
      var avgW=weights.length>0?weights.reduce(function(a,b){return a+b},0)/weights.length:0;

      var wbCounts=PMW.map(function(){return 0});
      weights.forEach(function(w){if(w<=0.5)wbCounts[0]++;else if(w<=1)wbCounts[1]++;else if(w<=2)wbCounts[2]++;else if(w<=3)wbCounts[3]++;else if(w<=4)wbCounts[4]++;else if(w<=5)wbCounts[5]++;else wbCounts[6]++});
      var wbPcts=wbCounts.map(function(c){return weights.length>0?Math.round(c/weights.length*1000)/10:0});

      var stCounts={};STS.forEach(function(s){stCounts[s]=0});var stTotal=0;
      postcodes.forEach(function(pc){var st=pcToState(pc);if(st&&stCounts[st]!==undefined){stCounts[st]++;stTotal++}});
      var newDisp=null;
      if(stTotal>100){newDisp={};STS.forEach(function(st){newDisp[st]={pct:Math.round(stCounts[st]/stTotal*1000)/10,z1:DD[st].z1,z2:DD[st].z2,z3:DD[st].z3}})}

      // Unified DIM: weight-averaged regardless of source (LxWxH or cubic weight column)
      var avgDim=dimActSum>0?dimVolSum/dimActSum:0;

      if(avgW>0)sWt(Math.round(avgW*100)/100);
      if(wbPcts.some(function(p){return p>0}))sWD(wbPcts);
      if(newDisp){sDisp(newDisp);sHasCustDisp(true);sDispMode("customer")}
      if(avgDim>0){var roundedDim=Math.round(avgDim*100)/100;if(prod==="pr"){sPrDim(roundedDim)}else if(prod==="pma"){sPmaDim(roundedDim)}else{sDim(roundedDim)}}

      var noDimPct=weights.length>0?Math.round(noDimWeights.length/weights.length*1000)/10:0;
      var noDimAvgWt=noDimWeights.length>0?noDimWeights.reduce(function(a,b){return a+b},0)/noDimWeights.length:0;

      // Build column detection diagnostic
      var detectedCols={};
      if(wtCol)detectedCols.weight=wtCol;if(cbCol)detectedCols.dim=cbCol;if(pcCol)detectedCols.postcode=pcCol;
      if(lCol)detectedCols.length=lCol;if(wCol)detectedCols.width=wCol;if(hCol)detectedCols.height=hCol;
      if(puCol)detectedCols.pickup=puCol;

      sUploadInfo({pieces:pieces,avgW:avgW,avgDim:avgDim,stTotal:stTotal,hasDisp:!!newDisp,hasWb:weights.length>0,hasDim:dimCount>0,file:fileNames.join(", "),fileCount:fileNames.length,fileStats:fileStats||[],totalRows:totalRows,filteredRows:filteredRows,filtered:puCol&&activeDepot?activeDepot:null,dimCount:dimCount,dimVolGtCount:dimVolGtCount,dimZeroCount:dimZeroCount,dimNaNCount:dimNaNCount,noDimPct:noDimPct,noDimAvgWt:noDimAvgWt,noDimCount:noDimWeights.length,dimSource:hasLWH?"LxWxH":(cbCol?"cubic_weight":null),detectedCols:detectedCols,allCols:cols,dimSamples:dimSamples,wtSamples:wtSamples});
      if(parsedRows.length>0)sCustRows(parsedRows);
      setTimeout(function(){try{if(saveRef.current)saveRef.current()}catch(e){}},500);
    }catch(err){sUploadInfo({error:"Parse error: "+err.message})}
  };

  var fx=useMemo(function(){return fxM==="budgeted"?{...FXD}:{...fxO}},[fxM,fxO]);
  var afc=AFC[origin]?.c||"GBP";
  var setOrig=useCallback(function(o){sOrigR(o);sLkw(LKW[o]||10000)},[]);
  var prodLabel=prod==="pm"?"Parcel Max":prod==="pma"?"PM Access":"Parcel Right";

  var l2g=useMemo(function(){
    var fscPct=fscOn?getFSC(l2FuelPrice):0;
    var ports=["MEL","SYD","BNE","PER"];
    var depotKg=avgWt>0?l2Depot/avgWt:0;
    var calcUnit=function(uType,useVol){
      var uKg=useVol?(UNIT_VOL_KG[uType]||750):(UNIT_KG[uType]||750);
      var det=ports.map(function(port){
        var bRet=RETRIEVAL[uType]?.[port]||85;
        var ret=bRet*(1+fscPct);
        var docKg=l2CtoDoc/uKg;var thkKg=l2CtoThk;var retKg=ret/uKg;
        var coreKg=docKg+thkKg+retKg;var allInKg=coreKg+depotKg;
        return{port:port,baseRet:bRet,ret:ret,docKg:docKg,thkKg:thkKg,retKg:retKg,depotKg:depotKg,coreKg:coreKg,allInKg:allInKg,uKg:uKg};
      });
      var wC=0,wA=0;det.forEach(function(d){var w=DW[d.port]||0;wC+=d.coreKg*w;wA+=d.allInKg*w});
      return{details:det,avgCoreKg:wC,avgAllInKg:wA,uKg:uKg};
    };
    var ake=calcUnit("AKE",false);var pmc=calcUnit("PMC",false);
    var akeVol=calcUnit("AKE",true);var pmcVol=calcUnit("PMC",true);
    var ap=l2AkePct/100;var pp=1-ap;
    var bCoreKg=ake.avgCoreKg*ap+pmc.avgCoreKg*pp;
    var bAllInKg=ake.avgAllInKg*ap+pmc.avgAllInKg*pp;
    var bCoreKgVol=akeVol.avgCoreKg*ap+pmcVol.avgCoreKg*pp;
    var bAllInKgVol=akeVol.avgAllInKg*ap+pmcVol.avgAllInKg*pp;
    return{ake:ake,pmc:pmc,akeVol:akeVol,pmcVol:pmcVol,avgCoreKg:bCoreKg,avgAllInKg:bAllInKg,avgCoreKgVol:bCoreKgVol,avgAllInKgVol:bAllInKgVol,depotPc:l2Depot,fscPct:fscPct,depotKg:depotKg};
  },[l2AkePct,l2CtoDoc,l2CtoThk,l2Depot,fscOn,l2FuelPrice,avgWt]);

  var l2UnitData=l2Unit==="PMC"?l2g.pmc:l2g.ake;
  var l2Kg,l2Pc;
  if(prod==="pm"){
    l2Kg=dispMode==="standard"?1.13:l2g.avgAllInKg;l2Pc=0;
  }else if(l2Mode==="granular"){
    l2Kg=l2Str==="kgonly"?l2UnitData.avgAllInKg:l2UnitData.avgCoreKg;
    l2Pc=l2Str==="kgpc"?l2g.depotPc:0;
  }else{
    l2Kg=dispMode==="standard"?1.13:l2g.avgAllInKg;l2Pc=0;
  }

  var dim=useMemo(function(){
    var ld=LDIM[origin]?.avg||1.4;var cr=fscOn?AFC[origin]:AFC_NF[origin];if(!cr)return null;
    var crFull=AFC[origin];
    var wC=0;["SYD","MEL","BNE","PER"].forEach(function(d){wC+=(cr[d]||0)*(DW[d]||0)});
    var wCFull=0;["SYD","MEL","BNE","PER"].forEach(function(d){wCFull+=(crFull[d]||0)*(DW[d]||0)});
    var curP=wC*ld;var oWk=(vol/52)*avgWt;var blD=(lkw+oWk)>0?(lkw*ld+oWk*oppDim)/(lkw+oWk):ld;
    var nP=wC*blD;var reb=origin==="LHR"?dtR:0;var effL=nP-reb;var effA=toA(effL,cr.c,fx);
    var curEffL=curP-reb;var curEffA=toA(curEffL,cr.c,fx);
    var lbW=toA((curP-nP)*lkw,cr.c,fx);
    var fscAmt=wCFull*blD-wC*blD;
    return{ld:ld,blD:blD,dimD:blD-ld,wC:wC,curP:curP,nP:nP,effL:effL,effA:effA,curEffL:curEffL,curEffA:curEffA,ccy:cr.c,oWk:oWk,lbW:lbW,lbY:lbW*52,imp:oppDim<ld,fscAmt:fscAmt};
  },[origin,oppDim,vol,avgWt,lkw,fx,dtR,fscOn]);

  var costs=useMemo(function(){
    if(!dim)return null;
    // Asendia eBay simulation: reduce vol-kg airfreight cost by GBP 0.27/kg when toggled (LHR vol only)
    var afReductionAUD=(afCostReduce&&origin==="LHR"&&pmWtBasis==="vol")?toA(0.27*oppDim,"GBP",fx):0;
    var afA=Math.max(0,dim.effA-afReductionAUD);var opA=gOP(origin,fx);var upKg=afA+opA+l2Kg;
    var fmcWB=PMW.map(function(_,i){return gFMC(aDisp,pmI(PMW[i].mx),FMC)});
    var bFMC=fmcWB.reduce(function(s,r,i){return s+r*(aWDist[i]/100)},0);
    var fmcByZone=[1,2,3].map(function(z){return PMW.map(function(_,wi){var prIdx=pmI(PMW[wi].mx);var tw=0;var tc=0;STS.forEach(function(st){var fk=st+"-Z"+z;var fr=FMC[fk];if(!fr)return;var ds=aDisp[st];if(!ds)return;var zP=z===1?ds.z1:z===2?ds.z2:ds.z3;var w=ds.pct*zP;if(w<=0)return;tc+=fr[prIdx]*w;tw+=w});return tw>0?tc/tw:0})});
    return{afA:afA,opA:opA,l2Kg:l2Kg,l2Pc:l2Pc,upKg:upKg,fmcWB:fmcWB,bFMC:bFMC,fmcByZone:fmcByZone};
  },[dim,origin,fx,aDisp,aWDist,l2Kg,l2Pc,afCostReduce,pmWtBasis,oppDim]);

  var pmP=useMemo(function(){
    if(!costs||!dim)return null;
    // When Leg 3 costs have been synced from routing file, override FMC table
    var fmcWBeff=costs.fmcWB;
    var fmcByZoneEff=costs.fmcByZone;
    if(pmRoutingCosts&&Array.isArray(pmRoutingCosts.z1)&&Array.isArray(pmRoutingCosts.z2)&&Array.isArray(pmRoutingCosts.z3)){
      fmcByZoneEff=[pmRoutingCosts.z1,pmRoutingCosts.z2,pmRoutingCosts.z3];
      if(pmRoutingCosts.blended&&pmRoutingCosts.blended.length===7){
        // Use pre-computed billing flat blend — exact match to the routing section display
        fmcWBeff=pmRoutingCosts.blended;
      }else{
        var zWtsR=[0,0,0];STS.forEach(function(st){var ds=aDisp[st];if(!ds)return;zWtsR[0]+=ds.pct*ds.z1;zWtsR[1]+=ds.pct*ds.z2;zWtsR[2]+=ds.pct*ds.z3});
        var zTotR=zWtsR[0]+zWtsR[1]+zWtsR[2];var zPctsR=zTotR>0?zWtsR.map(function(w){return w/zTotR}):[.7,.15,.15];
        fmcWBeff=PMW.map(function(_,wi){return fmcByZoneEff[0][wi]*zPctsR[0]+fmcByZoneEff[1][wi]*zPctsR[1]+fmcByZoneEff[2][wi]*zPctsR[2]});
      }
    }
    var cfL=custFscOn?(CUST_FSC[origin]||0):0;
    var cfA=toA(cfL,afc,fx);
    var pmDimF=pmWtBasis==="vol"?oppDim:1;
    var volA,volL,effPhys,effPhysTotal;
    if(kgMode==="target"){
      effPhysTotal=costs.upKg/(1-kgTgt/100);
      var cfPhys=cfA*pmDimF;
      effPhys=effPhysTotal-cfPhys;
      volA=effPhys/pmDimF;volL=volA*(fx[afc]||1);
    }else{
      volL=mPK;volA=toA(mPK,afc,fx);
      effPhys=volA*pmDimF;
      effPhysTotal=effPhys+cfA*pmDimF;
    }
    var kgGP=effPhysTotal-costs.upKg;var kgM=effPhysTotal>0?(kgGP/effPhysTotal)*100:0;
    var fmcPlusL2=fmcWBeff.map(function(fmc){return fmc+l2Pc});
    var pp=[];PMW.forEach(function(_,i){
      var cost=fmcPlusL2[i];var excl=!!ppExclW[i];
      var baseRate;
      if(ppMode==="meet"&&pmCustTgtOn){baseRate=pmCustTgt[i]>0?toA(pmCustTgt[i],afc,fx):0}
      else{baseRate=cost/(1-ppTgt/100)}
      var rate=excl?0:ppRefine&&mPP[i]>0?mPP[i]:baseRate;
      pp.push(rate)
    });
    var ppBase=[];PMW.forEach(function(_,i){
      var cost=fmcPlusL2[i];
      if(ppMode==="meet"&&pmCustTgtOn){ppBase.push(pmCustTgt[i]>0?toA(pmCustTgt[i],afc,fx):0)}
      else{ppBase.push(cost/(1-ppTgt/100))}
    });
    var avgPP=pp.reduce(function(s,r,i){return s+r*(aWDist[i]/100)},0);
    var bFMCpL2=fmcPlusL2.reduce(function(s,r,i){return ppExclW[i]?s:s+r*(aWDist[i]/100)},0);
    var fmcByZonePlusL2=fmcByZoneEff.map(function(zf){return zf.map(function(fc){return fc+l2Pc})});
    var pp3=fmcByZonePlusL2.map(function(zFmc,zi){return PMW.map(function(_,wi){
      var cost=zFmc[wi];var excl=!!ppExclW[wi]||!!ppExclZ[zi];
      var baseRate;
      if(ppMode==="meet"&&pmCustTgtOn){baseRate=pmCustTgt[wi]>0?toA(pmCustTgt[wi],afc,fx):0}
      else{baseRate=cost/(1-ppTgt/100)}
      return excl?0:ppRefine&&mPP3[zi]&&mPP3[zi][wi]>0?mPP3[zi][wi]:baseRate
    })});
    var pp3Base=fmcByZonePlusL2.map(function(zFmc,zi){return PMW.map(function(_,wi){
      var cost=zFmc[wi];
      if(ppMode==="meet"&&pmCustTgtOn){return pmCustTgt[wi]>0?toA(pmCustTgt[wi],afc,fx):0}
      return cost/(1-ppTgt/100)
    })});
    var zWts=[0,0,0];STS.forEach(function(st){var ds=aDisp[st];if(!ds)return;zWts[0]+=ds.pct*ds.z1;zWts[1]+=ds.pct*ds.z2;zWts[2]+=ds.pct*ds.z3});
    var zTot=zWts[0]+zWts[1]+zWts[2];var zPcts=zTot>0?zWts.map(function(w){return w/zTot}):[.7,.15,.15];
    var avgPP3=0;pp3.forEach(function(zr,zi){zr.forEach(function(r,wi){avgPP3+=r*(aWDist[wi]/100)*zPcts[zi]})});
    var bFMC3=0;fmcByZonePlusL2.forEach(function(zf,zi){zf.forEach(function(fc,wi){bFMC3+=fc*(aWDist[wi]/100)*zPcts[zi]})});
    var useAvgPP=pmZones===3?avgPP3:avgPP;var useBFMC=pmZones===3?bFMC3:bFMCpL2;
    var usePpGP=useAvgPP-useBFMC;var usePpM=useAvgPP>0?(usePpGP/useAvgPP)*100:0;
    var daffCost=daffMode==="inclusive"?DAFF:0;
    var daffRev=daffMode==="passthrough"?DAFF:0;
    var tR=useAvgPP+daffRev+effPhysTotal*avgWt;var tC=costs.upKg*avgWt+useBFMC+daffCost;var tGP=tR-tC;var tM=tR>0?(tGP/tR)*100:0;
    return{volA:volA,volL:volL,effPhys:effPhys,effPhysTotal:effPhysTotal,cfL:cfL,cfA:cfA,kgGP:kgGP,kgM:kgM,daffCost:daffCost,daffRev:daffRev,pp:pp,ppBase:ppBase,pp3:pp3,pp3Base:pp3Base,fmcPlusL2:fmcPlusL2,fmcByZonePlusL2:fmcByZonePlusL2,avgPP:useAvgPP,ppGP:usePpGP,ppM:usePpM,bFMC:useBFMC,tR:tR,tC:tC,tGP:tGP,tM:tM,aR:tR*vol,aC:tC*vol,aGP:tGP*vol,zPcts:zPcts};
  },[costs,dim,kgMode,kgTgt,mPK,ppMode,ppTgt,mPP,mPP3,ppRefine,ppExclW,ppExclZ,pmCustTgtOn,pmCustTgt,pmZones,aWDist,avgWt,vol,afc,fx,dtR,origin,aDisp,l2Pc,oppDim,custFscOn,daffMode,pmWtBasis,pmRoutingCosts]);

  var pmaAfc=AFC[pmaOrig]?.c||(pmaOrig==="OTH"?"AUD":"HKD");
  var pmaFxR=fx[pmaAfc]||1;
  var pma=useMemo(function(){
    var isVol=pmaWtMode==="vol";
    var l2c=l2Mode==="granular"?(l2Str==="kgonly"?(isVol?l2g.avgAllInKgVol:l2g.avgAllInKg):(isVol?l2g.avgCoreKgVol:l2g.avgCoreKg)):(dispMode==="standard"?1.13:(isVol?l2g.avgAllInKgVol:l2g.avgAllInKg));
    var l2p=l2Mode==="granular"&&l2Str==="kgpc"?l2g.depotPc:0;
    var isGranular=l2Mode==="granular";
    var ports=Object.keys(pmaInj).filter(function(p){return pmaInj[p]});
    var daffCostVal=daffMode==="inclusive"?DAFF:0;

    var cfL=pmaCFsc?pmaCFscRate:0;
    var cfA=toA(cfL,pmaAfc,fx);
    var isVol=pmaWtMode==="vol";
    var dimVal=isVol?pmaDim:1;

    function calcKgRate(costKg, manualRate){
      var rateL,rateA,effPhys,effPhysTotal;
      if(pmaKgMode==="meet"){
        rateA=pmaCcy==="local"?toA(pmaKgTgt,pmaAfc,fx):pmaKgTgt;
        rateL=pmaCcy==="local"?pmaKgTgt:rateA;
        effPhys=rateA*(isVol?dimVal:1);
        effPhysTotal=effPhys+cfA*dimVal;
      }else if(pmaKgMode==="target"){
        effPhysTotal=costKg/(1-pmaKT/100);
        var cfPhys=cfA*dimVal;
        effPhys=effPhysTotal-cfPhys;
        rateA=isVol?effPhys/dimVal:effPhys;
        rateL=pmaCcy==="local"?rateA*pmaFxR:rateA;
      }else{
        rateL=manualRate;
        rateA=pmaCcy==="local"?toA(rateL,pmaAfc,fx):rateL;
        effPhys=rateA*(isVol?dimVal:1);
        effPhysTotal=effPhys+cfA*dimVal;
      }
      var kgGP=rateA-costKg;var kgM=rateA>0?(kgGP/rateA)*100:0;
      return{rateL:rateL,rateA:rateA,effPhys:effPhys,effPhysTotal:effPhysTotal,kgGP:kgGP,kgM:kgM,costKg:costKg};
    }

    var std=calcKgRate(l2c, pmaMPK);
    var rateL=std.rateL,rateA=std.rateA,effPhys=std.effPhys,effPhysTotal=std.effPhysTotal,kgGP=std.kgGP,kgM=std.kgM;

    var portGranular=null;
    if(isGranular){
      var useAke=isVol?l2g.akeVol:l2g.ake;
      var usePmc=isVol?l2g.pmcVol:l2g.pmc;
      portGranular=ports.map(function(port){
        var akeD=useAke.details.find(function(d){return d.port===port});
        var pmcD=usePmc.details.find(function(d){return d.port===port});
        var akeCost=akeD?(l2Str==="kgonly"?akeD.allInKg:akeD.coreKg):0;
        var pmcCost=pmcD?(l2Str==="kgonly"?pmcD.allInKg:pmcD.coreKg):0;
        var akeR=calcKgRate(akeCost, pmaGranR[port+"_AKE"]||0);
        var pmcR=calcKgRate(pmcCost, pmaGranR[port+"_PMC"]||0);
        return{port:port,akeCost:akeCost,pmcCost:pmcCost,ake:akeR,pmc:pmcR};
      });
      var ap=l2AkePct/100;var ppVal=1-ap;
      var bEPT=0;
      portGranular.forEach(function(pg){
        bEPT+=pg.ake.effPhysTotal*ap+pg.pmc.effPhysTotal*ppVal;
      });
      effPhysTotal=ports.length>0?bEPT/ports.length:0;
      rateA=effPhysTotal>0?effPhysTotal*(1-cfA*dimVal/effPhysTotal):0;
      kgGP=effPhysTotal-l2c;
      kgM=effPhysTotal>0?(kgGP/effPhysTotal)*100:0;
    }

    var hasL2Pc=l2Mode==="granular"&&l2Str==="kgpc"&&l2p>0;
    var l2PcRate=hasL2Pc?(pmaKgMode==="target"?l2p/(1-pmaKT/100):pmaMPPL2):0;
    var l2PcGP=l2PcRate-l2p;var l2PcM=l2PcRate>0?(l2PcGP/l2PcRate)*100:0;

    var ppCost=hasL2Pc?0:l2p;
    var portSt={MEL:"VIC",SYD:"NSW",BNE:"QLD",PER:"WA"};
    var cards=ports.map(function(port){
      var localSt=portSt[port]||"VIC";
      var allZones=STS.flatMap(function(st){return[1,2,3].filter(function(z){return!!FMC[st+"-Z"+z]}).map(function(z){return{st:st,z:z,k:st+"-Z"+z,l:st+" - Zone "+z}})});
      allZones=allZones.filter(function(zone){var d=aDisp[zone.st];if(!d||d.pct<=0)return false;var zPct=zone.z===1?d.z1:zone.z===2?d.z2:d.z3;return zPct>0});
      allZones.sort(function(a,b){var aL=a.st===localSt?0:1;var bL=b.st===localSt?0:1;if(aL!==bL)return aL-bL;if(a.st!==b.st)return a.st<b.st?-1:1;return a.z-b.z});
      var dfActive=pmaChinaSpecial&&DF_PORTS[port];
      var dgfFscWaived=dgfFlexAll&&(vol/52/5)>=7000;
      var dgfFscRate=dgfFscWaived?0:getDfFSC(dgfDieselPrice);
      var rc=allZones.map(function(zone){var fr=FMC[zone.k];
        var tr=TRK[zone.st]?.[port]||0;
        var sc=SSC[zone.st]?.[port]||0;var useDf=(dfActive&&zone.st===localSt&&zone.z===1)||(dgfFlexAll&&zone.z===1);
        var rates=PMAW.map(function(_,wi){var fri=wi===0?0:wi-1;var fmc=fr[fri];var actualFmc;
          if(useDf){
            if(dgfFlexAll){
              // Optimal routing: pick cheapest of DGF Flex Z1 vs Aramex new contract per weight break
              var dgfRate=DF_Z1[wi]*(1+dgfFscRate);
              var axFri=wi===0?0:wi-1;
              var axRates=FMC_AX[zone.k]||FMC_AX[zone.st+"-Z1"];
              var axRate=axRates&&axRates[axFri]>0?axRates[axFri]:dgfRate;
              actualFmc=Math.min(dgfRate,axRate);
            }else{
              actualFmc=fscOn?DF_Z1[wi]*(1+getDfFSC(l2FuelPrice)):DF_Z1[wi];
            }
          }else{actualFmc=fmc;}var cost=actualFmc+tr+sc+ppCost;var excl=!!pmaPpExclZ[zone.k]||!!pmaPpExclW[wi];var baseRate;if(pmaPpMode==="meet"){var isSFEvri2=(cust&&cust.indexOf("SF (Evri)")>=0);var tgt;if(isSFEvri2&&SF_EVRI_TGT[zone.k]){tgt=SF_EVRI_TGT[zone.k][wi]||0;}else{tgt=zone.z===1?custTgtM[wi]:custTgtR[wi];}baseRate=tgt>0?(pmaCcy==="local"&&pmaAfc!=="AUD"?toA(tgt,pmaAfc,fx):tgt):0}else{baseRate=cost/(1-pmaPT/100)}var rate=excl?0:pmaPpRefine&&pmaPpR[zone.k]&&pmaPpR[zone.k][wi]>0?pmaPpR[zone.k][wi]:baseRate;return{fmc:actualFmc,stdFmc:fmc,truck:tr,scan:sc,l2pp:l2p,cost:cost,rate:rate,baseRate:baseRate,isDf:useDf,excl:excl}});
        return{...zone,rates:rates,tr:tr,sc:sc,isDf:useDf}});
      var ts=STS.map(function(st){return{st:st,tr:TRK[st]?.[port]||0}});
      return{port:port,rc:rc,ts:ts,localSt:localSt};
    });

    var bPpCost=0,bPpRate=0;
    var prwToWd=[0,1,2,3,4,5,6,6,6,6];
    var wd10=PRW.map(function(_,i){var mi=prwToWd[i];var v=aWDist[mi]||0;return mi===6?v/4:v});
    var stToPort={NSW:"SYD",ACT:"SYD",VIC:"MEL",TAS:"MEL",QLD:"BNE",NT:"BNE",SA:"MEL",WA:"PER"};
    if(cards.length>0){
      STS.forEach(function(st){
        var ds=aDisp[st];if(!ds||ds.pct<=0)return;
        var bestPort=stToPort[st]||ports[0];
        if(ports.indexOf(bestPort)<0){
          var fallback={QLD:["SYD","BNE","MEL","PER"],NT:["BNE","SYD","MEL","PER"],ACT:["SYD","MEL","BNE","PER"],TAS:["MEL","SYD","BNE","PER"],SA:["MEL","SYD","BNE","PER"],WA:["PER","MEL","SYD","BNE"],NSW:["SYD","MEL","BNE","PER"],VIC:["MEL","SYD","BNE","PER"]}[st]||["SYD","MEL","BNE","PER"];
          for(var fi=0;fi<fallback.length;fi++){if(ports.indexOf(fallback[fi])>=0){bestPort=fallback[fi];break;}}
          if(ports.indexOf(bestPort)<0)bestPort=ports[0];
        }
        var card=cards.find(function(c){return c.port===bestPort})||cards[0];
        [1,2,3].forEach(function(z){
          var zPct=z===1?ds.z1:z===2?ds.z2:ds.z3;
          if(zPct<=0)return;
          var zk=st+"-Z"+z;
          var zone=card.rc.find(function(r){return r.k===zk});
          if(!zone)return;
          var wt=ds.pct*zPct/10000;
          for(var wi=1;wi<zone.rates.length;wi++){var r=zone.rates[wi];var wdPct=wd10[wi-1]/100;bPpCost+=r.cost*wt*wdPct;bPpRate+=r.rate*(1+(pmaPpFscPct||0)/100)*wt*wdPct}
        });
      });
    }

    var daffCost2=daffMode==="inclusive"?DAFF:0;
    var daffRev=daffMode==="passthrough"?DAFF:0;
    var l2pCostSep=hasL2Pc?l2p:0;
    var tR=bPpRate+l2PcRate+daffRev+effPhysTotal*avgWt;var tC=l2c*avgWt+l2pCostSep+bPpCost+daffCost2;var tGP=tR-tC;var tM=tR>0?(tGP/tR)*100:0;

    return{ports:ports,clC:l2c,daffCost:daffCost2,daffRev:daffRev,l2p:l2p,hasL2Pc:hasL2Pc,l2PcRate:l2PcRate,l2PcGP:l2PcGP,l2PcM:l2PcM,rateL:rateL,rateA:rateA,effPhys:effPhys,effPhysTotal:effPhysTotal,cfL:cfL,cfA:cfA,kgGP:kgGP,kgM:kgM,isGranular:isGranular,portGranular:portGranular,
      cards:cards,bPpCost:bPpCost,bPpRate:bPpRate,tR:tR,tC:tC,tGP:tGP,tM:tM,aR:tR*vol,aC:tC*vol,aGP:tGP*vol,dim:dimVal};
  },[pmaInj,pmaOrig,pmaKT,pmaPT,pmaPpMode,pmaPpR,pmaPpRefine,pmaPpExclZ,pmaPpExclW,pmaMPK,pmaMPK_AKE,pmaMPK_PMC,pmaGranR,pmaMPPL2,pmaKgMode,pmaKgTgt,pmaWtMode,pmaPpWtMode,pmaDim,pmaCcy,pmaCFsc,pmaCFscRate,pmaChinaSpecial,fscOn,l2FuelPrice,l2AkePct,aDisp,l2Mode,l2g,l2Str,fx,pmaAfc,pmaFxR,avgWt,vol,aWDist,daffMode,dispMode,custTgtOn,custTgtM,custTgtR,dgfFlexAll,dgfDieselPrice,pmaPpFscPct]);

  var pr=useMemo(function(){
    if(!TIERS||TIERS.length===0)return null;
    var tier=TIERS.find(function(t){return vol>=t.mn&&vol<t.mx})||TIERS[TIERS.length-1];
    var margin=prMOverride&&prM!==null?prM:tier.mg*100;
    var pp=tier.pu+tier.pr+tier.ins+prRef;
    var depotSt={MEL:"VIC",SYD:"NSW",BNE:"QLD"};
    var localSt=depotSt[prD]||"VIC";
    var zones=STS.flatMap(function(st)
      {return[1,2,3].filter(
        function(z){
          return!!FMC[st+"-Z"+z]}).map(
            function(z){
              return{st:st,z:z,k:st+"-Z"+z,l:st+" - Zone "+z}
            }
          )
      }
    );
    zones=zones.filter(function(zone)
    {var d=aDisp[zone.st];
      if(!d||d.pct<=0)
        return false;
    var zPct=zone.z===1?d.z1:zone.z===2?d.z2:d.z3;return zPct>0});
    zones.sort(function(a,b){var aL=a.st===localSt?0:1;var bL=b.st===localSt?0:1;if(aL!==bL)return aL-bL;if(a.st!==b.st)return a.st<b.st?-1:1;return a.z-b.z});
    var rc=zones.map(function(zone){
      var fr=FMC[zone.k];
      var tr=TRK[zone.st]?.[prD]||0;
      var sc=SSC[zone.st]?.[prD]||0;
      var zExcl=!!ppExclZ[zone.k];
      var meetTgt=prTgts[prMeetIdx];
      var prMeetTgt=meetTgt?meetTgt.rates:{};
      var prMeetOn=meetTgt?meetTgt.on:false;
      var rates=fr.map(function(fmc,wi){
        var cost=fmc+tr+sc+pp;
        var excl=zExcl||!!ppExclW[wi];
        var baseRate;
        var isV2=(cust&&cust.indexOf("V2")>=0);
        if(isV2)
        {
          // V2: zones with a target rate are AUTO-LOCKED unless explicitly unlocked.
          // Unlocked zones (no target OR explicitly unlocked via UI) use cost+margin.
          var hasTgt=prMeetOn&&prMeetTgt[zone.k]&&prMeetTgt[zone.k][wi]>0;
          // Default behavior: if user has not explicitly toggled this zone, treat presence-of-target as locked
          var explicitUnlock=prLockZones[zone.k]===false;
          var explicitLock=prLockZones[zone.k]===true;
          var effectivelyLocked=explicitLock||(!explicitUnlock&&hasTgt);
          if(effectivelyLocked&&hasTgt){
            baseRate=prMeetTgt[zone.k][wi];
          }else{
            var marg=prCostPlusMargin||15;
            baseRate=cost/(1-marg/100);
          }
        }
        else if(ppMode==="meet"&&prMeetOn&&prMeetTgt[zone.k]&&prMeetTgt[zone.k][wi]>0)
        {
          baseRate=prMeetTgt[zone.k][wi];
        }
        else
        {
          baseRate=cost/(1-margin/100);
        }
        var rate=excl?0:baseRate;
        return{fmc:fmc,truck:tr,scan:sc,pp:pp,cost:cost,rate:rate,baseRate:baseRate,excl:excl}
      });
      return{...zone,rates:rates,tr:tr,sc:sc}});
    var bCost=0,bRate=0;
    var prwMap=[0,1,2,3,4,5,6,6,6,6];
    var wd10=PRW.map(function(_,i){var mi=prwMap[i];var v=aWDist[mi]||0;return mi===6?v/4:v});
    rc.forEach(function(zone){
      var st=zone.st;var z=zone.z;var ds=aDisp[st];if(!ds)return;
      var zPct=z===1?ds.z1:z===2?ds.z2:ds.z3;
      var wt=ds.pct*zPct/10000;
      zone.rates.forEach(function(r,wi){var wdPct=wd10[wi]/100;bCost+=r.cost*wt*wdPct;bRate+=r.rate*wt*wdPct});
    });
    var tGP=bRate-bCost;
    var tM=bRate>0?(tGP/bRate)*100:0;
    return{tier:tier,margin:margin,pp:pp,rc:rc,bCost:bCost,bRate:bRate,tGP:tGP,tM:tM,aR:bRate*vol,aC:bCost*vol,aGP:tGP*vol};
  },[prD,vol,prM,prMOverride,prRef,ppMode,ppRefine,ppExclW,ppExclZ,prTgts,prMeetIdx,aDisp,aWDist,prLockZones,prCostPlusMargin,cust]);



  // =========== EXPORT FILES ===========
  function exportRateCard(fmt){
    var prodName=prod==="pm"?"Parcel Max":prod==="pma"?"PM Access":"Parcel Right";
    var dateStr=new Date().toLocaleDateString("en-AU");
    var custName=cust||"Customer";
    var rc=[],kgRate="",kgLabel="",depot="",marginPct="";
    if(prod==="pr"&&pr){
      depot=prD;marginPct=f(pr.margin,1)+"%";kgRate="N/A (domestic)";kgLabel="";rc=pr.rc;
    }else if(prod==="pma"&&pma){
      var ports=Object.keys(pmaInj).filter(function(p){return pmaInj[p]});
      depot=ports[0]||"MEL";marginPct=pmaPT+"%";
      kgRate=dc(pma.clC)+"/kg"+(daffMode==="inclusive"?" + "+dc(DAFF)+"/pc DAFF":"");kgLabel="Clearance";
      if(pma.cards.length>0)rc=pma.cards[0].rc;
    }else if(prod==="pm"&&pmP&&costs){
      depot=origin;marginPct=ppMode==="target"?ppTgt+"%":"Manual";
      var afcCcy=AFC[origin]?.c||"USD";kgRate=f(pmP.volL)+" "+afcCcy+"/vol kg";kgLabel="Volumetric Rate";rc="pm";
    }
    var summaryData=[["DAI Post -- Customer Rate Card"],[],["Customer",custName],["Product",prodName],["Origin/Depot",depot],["Date",dateStr],[],["Per KG Rate",kgRate],["Per Piece Margin",marginPct]];
    if(daffMode==="passthrough")summaryData.push(["DAFF Biosecurity","$0.37/pc -- charged separately"]);
    if(daffMode==="inclusive")summaryData.push(["DAFF Biosecurity","$0.37/pc -- inclusive in cost"]);
    
    var rcRows=[];
    var isPM=rc==="pm";
    if(isPM){
      var pmWL=PMW.map(function(wb){return wb.l});rcRows.push(["Band"].concat(pmWL));
      if(pmZones===1){rcRows.push(["Flat Rate"].concat(pmP.pp.map(function(r){return Math.round(r*100)/100})))}
      else{[0,1,2].forEach(function(zi){rcRows.push(["Zone "+(zi+1)].concat(pmP.pp3[zi].map(function(r){return Math.round(r*100)/100})))})}
    }else{
      var wLabels=prod==="pma"?PMAWL:PRWL;rcRows.push(["Zone"].concat(wLabels.map(function(l){return l+"kg"})));
      if(Array.isArray(rc))rc.forEach(function(z){rcRows.push([z.l].concat(z.rates.map(function(r){return Math.round(r.rate*100)/100})))});
    }
    if(zdLoaded){
      var zgRows=[["Postcode","Suburb(s)","Zone"]];
      var stZoneMap={"1":"Zone 1","2":"Zone 2","3":"Zone 3"};
      var zgEntries=Object.entries(ZD).map(
        function(e){
          var st=e[1][0].replace(/[0-9]/g,"");
          var zn=e[1][0].replace(/[^0-9]/g,"");
          return{pc:e[0],subs:e[1][1],st:st,z:zn,label:st+" - "+(stZoneMap[zn]||"Zone "+zn)}}
      );

      var localSt=prod==="pr"?{MEL:"VIC",SYD:"NSW",BNE:"QLD"}[prD]||"VIC":prod==="pma"?{MEL:"VIC",SYD:"NSW",BNE:"QLD",PER:"WA"}[Object.keys(pmaInj).find(
        function(p){return pmaInj[p]})]||"VIC":"VIC";
        //  zgEntries.sort(function(a,b){
        //     var aL = a.st === localSt ? 0 : 1;
        //     var bL = b.st === localSt ? 0 : 1;
        //     if (aL !== bL) return aL - bL;              // puts local state entries first
        //     if (a.st !== b.st) return a.st < b.st ? -1 : 1; // then sorts alphabetically by state
        //     if (a.z !== b.z) return a.z - b.z;          // then sorts numerically by zone
        //     return (parseInt(a.pc)||0) - (parseInt(b.pc)||0); // finally sorts by postcode number
        //   });
          zgEntries.forEach(function(e){zgRows.push([e.pc,e.subs,e.label])});
              if(fmt==="xlsx"||fmt==="both"){
                var wb=XLSX.utils.book_new();var ws1=XLSX.utils.aoa_to_sheet(summaryData);ws1["!cols"]=[{wch:20},{wch:40}];XLSX.utils.book_append_sheet(wb,ws1,"Summary");
                 var ws2=XLSX.utils.aoa_to_sheet(rcRows);var rcColW=isPM?PMW.map(function(){return{wch:12}}):(prod==="pma"?PMAWL:PRWL).map(function(){return{wch:10}});ws2["!cols"]=[{wch:18}].concat(rcColW);XLSX.utils.book_append_sheet(wb,ws2,"Rate Card");
        var ws3=XLSX.utils.aoa_to_sheet(zgRows);ws3["!cols"]=[{wch:10},{wch:50},{wch:18}];XLSX.utils.book_append_sheet(wb,ws3,"Zone Guide");
        var fn=custName.replace(/\s+/g,"_")+"_"+prodName.replace(/\s+/g,"_")+"_RateCard.xlsx";XLSX.writeFile(wb,fn);
      }
      if(fmt==="pdf"||fmt==="both"){
        var html="<html><head><title>"+custName+" -- "+prodName+" Rate Card</title><style>body{font-family:Arial,sans-serif;padding:30px;color:#222}h1{font-size:18px;margin-bottom:4px}h2{font-size:14px;color:#555;margin-top:24px;border-bottom:1px solid #ccc;padding-bottom:4px}table{border-collapse:collapse;width:100%;margin-top:8px;font-size:11px}th{background:#f0f0f0;text-align:left;padding:5px 8px;border:1px solid #ccc;font-weight:600}td{padding:4px 8px;border:1px solid #ddd;text-align:right}.zl{text-align:left;font-weight:600}.meta{font-size:12px;color:#555;margin:2px 0}.hdr{display:flex;justify-content:space-between;align-items:flex-end}.logo{color:#0066cc;font-weight:700;font-size:22px}@media print{body{padding:15px}}</style></head><body>";
        html+="<div class='hdr'><div><div class='logo'>DAI Post</div><h1>Customer Rate Card</h1></div><div style='text-align:right;font-size:11px;color:#777'>"+dateStr+"</div></div>";
        html+="<p class='meta'><b>Customer:</b> "+custName+" &nbsp;|&nbsp; <b>Product:</b> "+prodName+" &nbsp;|&nbsp; <b>Origin/Depot:</b> "+depot+"</p>";
        if(kgRate)html+="<p class='meta'><b>"+kgLabel+":</b> "+kgRate+"</p>";
        if(daffMode==="passthrough")html+="<p class='meta'><b>DAFF Biosecurity:</b> $0.37/pc charged separately</p>";
        html+="<h2>Per Piece Rate Card (AUD)</h2><table><tr>";
        if(isPM){
          html+="<th class='zl'>Band</th>";PMW.forEach(function(wb){html+="<th>"+wb.l+"</th>"});html+="</tr>";
          if(pmZones===1){html+="<tr><td class='zl'>Flat Rate</td>";pmP.pp.forEach(function(r){html+="<td>$"+(Math.round(r*100)/100).toFixed(2)+"</td>"});html+="</tr>"}
          else{[0,1,2].forEach(function(zi){html+="<tr><td class='zl'>Zone "+(zi+1)+"</td>";pmP.pp3[zi].forEach(function(r){html+="<td>$"+(Math.round(r*100)/100).toFixed(2)+"</td>"});html+="</tr>"})}
        }else{
          html+="<th class='zl'>Zone</th>";(prod==="pma"?PMAWL:PRWL).forEach(function(l){html+="<th>"+l+"kg</th>"});html+="</tr>";
          if(Array.isArray(rc))rc.forEach(function(z){html+="<tr><td class='zl'>"+z.l+"</td>";z.rates.forEach(function(r){html+="<td>$"+(Math.round(r.rate*100)/100).toFixed(2)+"</td>"});html+="</tr>"});
        }
        html+="</table>";
        html+="<h2>Zone &amp; Postcode Guide</h2><table><tr><th class='zl'>Postcode</th><th class='zl'>Suburb(s)</th><th class='zl'>Zone</th></tr>";
        zgEntries.forEach(function(e){html+="<tr><td class='zl'>"+e.pc+"</td><td class='zl' style='font-weight:400;font-size:10px'>"+e.subs+"</td><td class='zl'>"+e.label+"</td></tr>"});
        html+="</table><p style='margin-top:20px;font-size:9px;color:#999'>This rate card is confidential and intended for the named customer only. Rates are subject to review.</p></body></html>";
        var w=window.open("","_blank");if(w){w.document.write(html);w.document.close();setTimeout(function(){w.print()},500)}
      }
    }
  }


  function getSummaryStatus(tgtIdx){
    var missing=[];var preferred=[];var ready=true;
    if(!pr||prod!=="pr"){return{ready:false,missing:["Select Parcel Right product"],preferred:[]}}
    if(!vol||vol<=0){missing.push("Set annual volume");ready=false}
    var t=prTgts[tgtIdx];
    if(!t||!t.on){missing.push("Enable "+(t?t.label:"Target "+(tgtIdx+1))+" target");ready=false}
    else if(!t.rates||typeof t.rates!=="object"){missing.push("Enter "+(t.label)+" rates");ready=false}
    else{
      var filledZones=0;var totalZones=pr.rc.length;
      pr.rc.forEach(function(zone){var r=t.rates[zone.k];if(r){var hasRate=r.some(function(v){return v>0});if(hasRate)filledZones++}});
      if(filledZones<3){missing.push("Enter "+t.label+" rates in at least 3 zones ("+filledZones+" of "+totalZones+" filled)");ready=false}
    }
    if(!cust){missing.push("Enter customer name")}
    if(prCompBasis==="unknown")preferred.push("Set competitor weight basis (physical or volumetric) -- will run both scenarios if unknown");
    if(prCompBasis==="volumetric"&&(!prDim||prDim<=1))preferred.push("Set customer DIM for accurate volumetric rebucketing (currently "+f(prDim)+")");
    return{ready:ready,missing:missing,preferred:preferred};
  }
  function canExportSummary(tgtIdx){return getSummaryStatus(tgtIdx).ready}
  // ── PM Commercial Summary ──
  function getSummaryStatusPM(){
    var missing=[];var preferred=[];var ready=true;
    if(prod!=="pm"||!pmP||!costs||!dim){return{ready:false,missing:["Select Parcel Max and configure pricing"],preferred:[]}}
    if(!vol||vol<=0){missing.push("Set annual volume");ready=false}
    if(!pmCustTgtOn){missing.push("Enable customer target rates");ready=false}
    else{var filled=pmCustTgt.filter(function(v){return v>0}).length;if(filled<3){missing.push("Enter competitor rates in at least 3 weight bands ("+filled+" of "+PMW.length+" filled)");ready=false}}
    if(!cust){missing.push("Enter customer name")}
    if(prCompBasis==="unknown")preferred.push("Set competitor weight basis -- will run scenarios if unknown");
    return{ready:ready,missing:missing,preferred:preferred};
  }

  function getSummaryStatusPMA(){
    var missing=[];var preferred=[];var ready=true;
    if(prod!=="pma"||!pma){return{ready:false,missing:["Select PM Access and configure pricing"],preferred:[]}}
    if(!vol||vol<=0){missing.push("Set annual volume");ready=false}
    if(!custTgtOn){missing.push("Enable customer target rates");ready=false}
    else{var filledM=custTgtM.filter(function(v){return v>0}).length;var filledR=custTgtR.filter(function(v){return v>0}).length;if(filledM<3&&filledR<3){missing.push("Enter competitor rates in at least 3 weight bands (Metro: "+filledM+", Regional: "+filledR+")");ready=false}}
    if(!cust){missing.push("Enter customer name")}
    if(prCompBasis==="unknown")preferred.push("Set competitor weight basis -- will run scenarios if unknown");
    return{ready:ready,missing:missing,preferred:preferred};
  }

  function exportCommercialSummaryPM(){try{
    if(!getSummaryStatusPM().ready)return;
    var custName=cust||"Customer";var dateStr=new Date().toLocaleDateString("en-AU");
    var compName="Competitor";
    // Our rates per weight band
    var ourPP=pmZones===3?PMW.map(function(_,i){var r=0;pmP.pp3.forEach(function(z,zi){r+=z[i]*pmP.zPcts[zi]});return r}):pmP.pp;
    var compPP=pmCustTgt.map(function(v){return v>0?toA(v,afc,fx):0});
    // Weighted comparison
    var daiPc=0;var compPc=0;var wbRows=[];
    PMW.forEach(function(wb,i){
      var wPct=aWDist[i]/100;
      daiPc+=ourPP[i]*wPct;
      compPc+=compPP[i]*wPct;
      wbRows.push({band:wb.l,dai:ourPP[i],comp:compPP[i],diff:compPP[i]-ourPP[i],wPct:aWDist[i]});
    });
    // Per-KG component
    var daiKgPc=pmP.effPhysTotal*avgWt;
    var daiTotal=daiPc+daiKgPc+(daffMode==="passthrough"?DAFF:0);
    var compTotal=compPc;// competitor per-piece is typically all-in
    var savPc=compTotal-daiTotal;var savAnn=savPc*vol;var savWk=savAnn/52;var savMo=savAnn/12;
    var savPct=compTotal>0?((compTotal-daiTotal)/compTotal*100):0;
    var daiCheaper=savPc>=0;
    var winsDAI=wbRows.filter(function(r){return r.diff>=0&&r.comp>0}).length;
    var winsComp=wbRows.filter(function(r){return r.diff<0&&r.comp>0}).length;
    var compared=wbRows.filter(function(r){return r.comp>0}).length;
    // Build HTML
    var h=buildReportCSS(custName,compName,dateStr,"Parcel Max","ex-"+origin);
    if(daiCheaper){
      h+=buildHeroSavings(savWk,savMo,savAnn,savPc,savPct,compName,null);
    }else{
      h+=buildHeroCost(daiTotal,compTotal,savPc,compName);
    }
    h+=buildDataSourceDisclaimer();
    h+="<h2>Per Piece Rate Comparison</h2>";
    h+="<table><tr><th>Weight Band</th><th class='r'>Mix %</th><th class='r'>DAI Post</th><th class='r'>"+compName+"</th><th class='r'>Saving</th></tr>";
    wbRows.forEach(function(r){
      if(r.comp<=0)return;
      var cls=r.diff>=0?"gn":"rd";
      h+="<tr><td class='b'>"+r.band+"</td><td class='r'>"+f(r.wPct,1)+"%</td><td class='r b'>A$"+f(r.dai)+"</td><td class='r b'>A$"+f(r.comp)+"</td><td class='r b "+cls+"'>"+(r.diff>=0?"+":"")+"A$"+f(r.diff)+"</td></tr>";
    });
    h+="</table>";
    h+="<div class='callout-blue'><b>Note:</b> DAI Post pricing includes a per-piece delivery rate plus a per-KG airfreight component of <b>A$"+f(pmP.effPhysTotal)+"/kg × "+f(avgWt)+"kg avg = A$"+f(daiKgPc)+"</b> per parcel. "+compName+"'s per-piece rates are compared directly."+(daffMode==="passthrough"?" DAFF biosecurity fee of A$0.37/pc is charged separately.":"")+"</div>";
    h+=buildConclusionBlock(daiCheaper,custName,compName,savWk,savMo,savAnn,savPc,savPct,winsDAI,winsComp,compared,"weight bands");
    h+=buildScorecard(winsDAI,winsComp,compared,compName,"Weight Bands");
    h+=buildFinancialCards(daiTotal,compTotal,vol,compName);
    h+="<h2>Assumptions</h2><table><tr><th style='width:280px'>Parameter</th><th>Value</th></tr>";
    h+="<tr><td>Annual Volume</td><td class='r b'>"+(vol||0).toLocaleString()+"</td></tr>";
    h+="<tr><td>Average Weight</td><td class='r'>"+f(avgWt)+" kg</td></tr>";
    h+="<tr><td>Origin</td><td class='r'>"+origin+" ("+ORIS[origin]+")</td></tr>";
    h+="<tr><td>Customer DIM</td><td class='r'>"+f(oppDim)+"</td></tr>";
    h+="<tr><td>Weight Basis</td><td class='r'>"+(pmWtBasis==="vol"?"Volumetric":"Physical")+"</td></tr>";
    h+=buildDataSourceRows();
    h+="</table>";
    h+=buildFooter(custName,compName,dateStr);
    h+="</body></html>";
    outputReport(h,custName,compName);
  }catch(err){showExportError(err)}}

  function exportCommercialSummaryPMA(){try{
    if(!getSummaryStatusPMA().ready)return;
    var custName=cust||"Customer";var dateStr=new Date().toLocaleDateString("en-AU");
    var compName="Competitor";
    var ports=Object.keys(pmaInj).filter(function(p){return pmaInj[p]});
    if(pma.cards.length===0)return;
    // Get blended our rates from first card (or weighted across cards)
    var card=pma.cards[0];
    // Compare metro (Z1) and regional (Z2+)
    var daiZ1=0;var daiZ23=0;var compZ1=0;var compZ23=0;
    var wbRowsM=[];var wbRowsR=[];
    PMAW.forEach(function(_,wi){
      var wPct=aWDist[wi>0?wi-1:0]/100;// map PMAW 11 bands to aWDist 7 bands
      if(wi===0)wPct=aWDist[0]/200;// 0.25kg band gets half of first dist bucket
      // Find Z1 rate for this weight from the card
      var z1Zone=card.rc.find(function(r){return r.z===1});
      var z23Zone=card.rc.find(function(r){return r.z===2})||card.rc.find(function(r){return r.z===3});
      var ourM=z1Zone?z1Zone.rates[wi].rate:0;
      var ourR=z23Zone?z23Zone.rates[wi].rate:0;
      var theirM=custTgtM[wi]||0;var theirR=custTgtR[wi]||0;
      if(theirM>0){wbRowsM.push({band:PMAWL[wi]+"kg",dai:ourM,comp:theirM,diff:theirM-ourM})}
      if(theirR>0){wbRowsR.push({band:PMAWL[wi]+"kg",dai:ourR,comp:theirR,diff:theirR-ourR})}
    });
    // Blended using zone distribution
    var z1Wt=0;var z23Wt=0;
    STS.forEach(function(st){var ds=aDisp[st];if(!ds)return;z1Wt+=ds.pct*ds.z1/10000;z23Wt+=ds.pct*(ds.z2+ds.z3)/10000});
    // Simple blended per piece
    var daiPc=pma.bPpRate;var compPc=0;
    PMAW.forEach(function(_,wi){
      var wIdx=wi>0?wi-1:0;var wPct=(wIdx===0&&wi===0)?aWDist[0]/200:(wi===0?aWDist[0]/200:aWDist[wIdx]/100);
      var theirBlended=(custTgtM[wi]||0)*z1Wt+(custTgtR[wi]||0)*z23Wt;
      compPc+=theirBlended*wPct;
    });
    var daiKgPc=pma.effPhysTotal*avgWt;
    var daiTotal=daiPc+daiKgPc+pma.daffRev+(pma.hasL2Pc?pma.l2PcRate:0);
    var compTotal=compPc;
    var savPc=compTotal-daiTotal;var savAnn=savPc*vol;var savWk=savAnn/52;var savMo=savAnn/12;
    var savPct=compTotal>0?((compTotal-daiTotal)/compTotal*100):0;
    var daiCheaper=savPc>=0;
    var winsM=wbRowsM.filter(function(r){return r.diff>=0}).length;
    var winsR=wbRowsR.filter(function(r){return r.diff>=0}).length;
    // Build HTML
    var h=buildReportCSS(custName,compName,dateStr,"PM Access","Ports: "+ports.join(", "));
    if(daiCheaper){h+=buildHeroSavings(savWk,savMo,savAnn,savPc,savPct,compName,null)}
    else{h+=buildHeroCost(daiTotal,compTotal,savPc,compName)}
    h+=buildDataSourceDisclaimer();
    if(wbRowsM.length>0){
      h+="<h2>Metro (Zone 1) Rate Comparison</h2>";
      h+="<table><tr><th>Weight</th><th class='r'>DAI Post</th><th class='r'>"+compName+"</th><th class='r'>Saving</th></tr>";
      wbRowsM.forEach(function(r){var cls=r.diff>=0?"gn":"rd";h+="<tr><td class='b'>"+r.band+"</td><td class='r b'>A$"+f(r.dai)+"</td><td class='r b'>A$"+f(r.comp)+"</td><td class='r b "+cls+"'>"+(r.diff>=0?"+":"")+"A$"+f(r.diff)+"</td></tr>"});
      h+="</table>";
    }
    if(wbRowsR.length>0){
      h+="<h2>Regional Rate Comparison</h2>";
      h+="<table><tr><th>Weight</th><th class='r'>DAI Post</th><th class='r'>"+compName+"</th><th class='r'>Saving</th></tr>";
      wbRowsR.forEach(function(r){var cls=r.diff>=0?"gn":"rd";h+="<tr><td class='b'>"+r.band+"</td><td class='r b'>A$"+f(r.dai)+"</td><td class='r b'>A$"+f(r.comp)+"</td><td class='r b "+cls+"'>"+(r.diff>=0?"+":"")+"A$"+f(r.diff)+"</td></tr>"});
      h+="</table>";
    }
    h+="<div class='callout-blue'><b>Note:</b> DAI Post pricing includes a per-piece delivery rate plus per-KG clearance of <b>A$"+f(pma.clC)+"/kg × "+f(avgWt)+"kg = A$"+f(daiKgPc)+"</b> per parcel."+(daffMode==="passthrough"?" DAFF A$0.37/pc charged separately.":"")+"</div>";
    var totalWins=winsM+winsR;var totalLoss=wbRowsM.filter(function(r){return r.diff<0}).length+wbRowsR.filter(function(r){return r.diff<0}).length;
    h+=buildConclusionBlock(daiCheaper,custName,compName,savWk,savMo,savAnn,savPc,savPct,totalWins,totalLoss,totalWins+totalLoss,"weight bands");
    h+=buildScorecard(totalWins,totalLoss,totalWins+totalLoss,compName,"Weight Bands");
    h+=buildFinancialCards(daiTotal,compTotal,vol,compName);
    h+="<h2>Assumptions</h2><table><tr><th style='width:280px'>Parameter</th><th>Value</th></tr>";
    h+="<tr><td>Annual Volume</td><td class='r b'>"+(vol||0).toLocaleString()+"</td></tr>";
    h+="<tr><td>Average Weight</td><td class='r'>"+f(avgWt)+" kg</td></tr>";
    h+="<tr><td>Injection Ports</td><td class='r'>"+ports.join(", ")+"</td></tr>";
    h+=buildDataSourceRows();
    h+="</table>";
    h+=buildFooter(custName,compName,dateStr);
    h+="</body></html>";
    outputReport(h,custName,compName);
  }catch(err){showExportError(err)}}

  // ── Shared report building helpers ──
  function buildReportCSS(custName,compName,dateStr,prodName,depot,brand){
    var isPR=brand==="pr";
    var pri=isPR?"#037A68":"#0a2463";var priLt=isPR?"#04a98f":"#1e6091";var priAc=isPR?"#05c9a7":"#3e92cc";
    var h="<html><head><title>"+custName+" -- Commercial Summary vs "+compName+"</title><style>";
    h+="*{box-sizing:border-box}body{font-family:'Segoe UI',Arial,sans-serif;padding:40px 50px;color:#1a1a2e;line-height:1.6;max-width:1100px;margin:0 auto}";
    h+="h1{font-size:22px;color:"+pri+";margin:0 0 4px}h2{font-size:15px;color:"+pri+";margin:28px 0 10px;border-bottom:2px solid "+pri+";padding-bottom:4px}h3{font-size:13px;color:"+priAc+";margin:18px 0 6px}";
    h+="table{border-collapse:collapse;width:100%;margin:8px 0 16px;font-size:11px}th{background:#f0f4f8;text-align:left;padding:6px 10px;border:1px solid #d0d7de;font-weight:600;font-size:10px;text-transform:uppercase;letter-spacing:.03em}";
    h+="td{padding:5px 10px;border:1px solid #e1e5e9}.r{text-align:right;font-variant-numeric:tabular-nums}.b{font-weight:700}.gn{color:#1a7f37}.rd{color:#cf222e}.yw{color:#9a6700}.hl{background:#dafbe1}.hln{background:#ffebe9}";
    h+=".hero{background:linear-gradient(135deg,"+pri+","+priLt+");color:#fff;padding:28px 32px;margin:20px 0 30px;border-radius:6px}";
    h+=".hero h2{color:#fff;border:none;margin:0 0 16px;font-size:18px}.hero .big{font-size:36px;font-weight:800;margin:4px 0}.hero .sub{font-size:13px;opacity:.85;margin-top:4px}";
    h+=".callout{background:#fff3cd;border:1px solid #ffecb5;padding:12px 16px;border-radius:4px;margin:16px 0;font-size:12px}";
    h+=".callout-blue{background:#e8f4fd;border:1px solid #b6d4fe;padding:12px 16px;border-radius:4px;margin:16px 0;font-size:12px}";
    h+=".callout-green{background:#d1e7dd;border:1px solid #badbcc;padding:12px 16px;border-radius:4px;margin:16px 0;font-size:12px}";
    h+=".grid2{display:grid;grid-template-columns:1fr 1fr;gap:16px}.grid3{display:grid;grid-template-columns:1fr 1fr 1fr;gap:16px}";
    h+=".card{background:#f6f8fa;border:1px solid #d0d7de;padding:16px;border-radius:4px;text-align:center}.card .num{font-size:24px;font-weight:800;margin:4px 0}.card .lbl{font-size:10px;text-transform:uppercase;color:#57606a;letter-spacing:.05em}";
    h+=".footer{margin-top:30px;padding-top:12px;border-top:1px solid #d0d7de;font-size:9px;color:#8b949e}";
    h+="@media print{body{padding:20px}.hero{break-inside:avoid}table{break-inside:avoid}}";
    h+="</style></head><body>";
    var brandName=isPR?"Parcel Right":"DAI Post";
    var logoSrc=isPR?LOGO_PR:LOGO_DAI;
    h+="<div style='display:flex;justify-content:space-between;align-items:flex-end'><div><div style='font-size:11px;color:#57606a;text-transform:uppercase;letter-spacing:.1em'>Commercial Summary</div><h1>"+brandName+" vs "+compName+"</h1><div style='font-size:12px;color:#57606a'>Prepared for <b>"+custName+"</b> &nbsp;|&nbsp; "+dateStr+"</div></div><div style='text-align:right'><img src='"+logoSrc+"' style='height:28px;margin-bottom:4px' /><div style='font-size:10px;color:#57606a'>"+prodName+" -- "+depot+"</div></div></div>";
    return h;
  }
  function buildHeroSavings(savWk,savMo,savAnn,savPc,savPct,compName,extra,brand){
    var bn=brand==="pr"?"Parcel Right":"DAI Post";
    var h="<div class='hero'><h2>Your Estimated Savings with "+bn+"</h2><div class='grid3'>";
    h+="<div><div class='big'>A$"+(Math.round(Math.abs(savWk))).toLocaleString()+"</div><div class='sub'>per week</div></div>";
    h+="<div><div class='big'>A$"+(Math.round(Math.abs(savMo))).toLocaleString()+"</div><div class='sub'>per month</div></div>";
    h+="<div><div class='big'>A$"+(Math.round(Math.abs(savAnn))).toLocaleString()+"</div><div class='sub'>per year</div></div>";
    h+="</div>";
    if(extra)h+="<div style='margin-top:12px;font-size:11px;opacity:.8'>"+extra+"</div>";
    h+="</div>";return h;
  }
  function buildHeroCost(daiTot,compTot,savPc,compName,brand){
    var bn=brand==="pr"?"Parcel Right":"DAI Post";var pri=brand==="pr"?"#037A68":"#6a040f";var pri2=brand==="pr"?"#04a98f":"#9d0208";
    var h="<div class='hero' style='background:linear-gradient(135deg,"+pri+","+pri2+")'><h2>Cost Comparison</h2><div class='grid3'>";
    h+="<div><div class='big'>A$"+f(daiTot)+"</div><div class='sub'>"+bn+" / parcel</div></div>";
    h+="<div><div class='big'>A$"+f(compTot)+"</div><div class='sub'>"+compName+" / parcel</div></div>";
    h+="<div><div class='big'>A$"+f(Math.abs(savPc))+"</div><div class='sub'>Difference</div></div></div></div>";
    return h;
  }
  function buildConclusionBlock(daiCheaper,custName,compName,savWk,savMo,savAnn,savPc,savPct,wins,losses,total,unitLabel,brand){
    var bn=brand==="pr"?"Parcel Right":"DAI Post";var pri=brand==="pr"?"#037A68":"#0a2463";
    var h="<h2>Conclusion</h2>";
    if(daiCheaper){
      h+="<div style='background:"+pri+";color:#fff;padding:24px 28px;border-radius:6px;margin:20px 0'>";
      h+="<div style='font-size:16px;font-weight:800;margin-bottom:16px;text-transform:uppercase;letter-spacing:.06em'>By switching to "+bn+", "+custName+" would save:</div>";
      h+="<div class='grid3'>";
      h+="<div style='text-align:center'><div style='font-size:32px;font-weight:800;color:#4ade80'>A$"+(Math.round(savWk)).toLocaleString()+"</div><div style='font-size:12px;opacity:.8;margin-top:4px'>per week</div></div>";
      h+="<div style='text-align:center'><div style='font-size:32px;font-weight:800;color:#4ade80'>A$"+(Math.round(savMo)).toLocaleString()+"</div><div style='font-size:12px;opacity:.8;margin-top:4px'>per month</div></div>";
      h+="<div style='text-align:center'><div style='font-size:32px;font-weight:800;color:#4ade80'>A$"+(Math.round(savAnn)).toLocaleString()+"</div><div style='font-size:12px;opacity:.8;margin-top:4px'>per year</div></div></div>";
      h+="<div style='margin-top:12px;padding-top:12px;border-top:1px solid rgba(255,255,255,.2);font-size:12px;opacity:.9'>That's <b>A$"+f(Math.abs(savPc))+" less per parcel</b> (<b>"+f(Math.abs(savPct),1)+"%</b> lower). "+bn+" wins in <b>"+wins+" of "+total+"</b> "+unitLabel+".</div></div>";
    }else{
      h+="<div class='callout'><b>At current rates, "+compName+" is A$"+f(Math.abs(savPc))+" per parcel cheaper</b> (A$"+(Math.round(Math.abs(savWk))).toLocaleString()+"/wk, A$"+(Math.round(Math.abs(savMo))).toLocaleString()+"/mo, A$"+(Math.round(Math.abs(savAnn))).toLocaleString()+"/yr). ";
      h+=bn+" is still cheaper in <b>"+wins+" of "+total+"</b> "+unitLabel+". Contact us to discuss volume-based pricing.</div>";
    }
    return h;
  }
  function buildScorecard(wins,losses,total,compName,label){
    var h="<h2>Scorecard</h2><div class='grid3' style='margin-bottom:16px'>";
    h+="<div class='card'><div class='num gn'>"+wins+"</div><div class='lbl'>"+label+" DAI Wins</div></div>";
    h+="<div class='card'><div class='num rd'>"+losses+"</div><div class='lbl'>"+label+" "+compName+" Wins</div></div>";
    h+="<div class='card'><div class='num'>"+total+"</div><div class='lbl'>Total Compared</div></div></div>";
    return h;
  }
  function buildFinancialCards(daiTot,compTot,volume,compName,brand){
    var bn=brand==="pr"?"Parcel Right":"DAI Post";var pri=brand==="pr"?"#037A68":"#0a2463";
    var h="<h2>Annual Financial Projection</h2><div class='grid2' style='margin-bottom:16px'>";
    h+="<div class='card'><div class='lbl'>"+bn+" -- Annual Cost</div><div class='num' style='color:"+pri+"'>A$"+(Math.round(daiTot*volume)).toLocaleString()+"</div><div style='font-size:11px;color:#57606a'>A$"+f(daiTot)+" &times; "+(volume||0).toLocaleString()+" parcels</div></div>";
    h+="<div class='card'><div class='lbl'>"+compName+" -- Annual Cost</div><div class='num' style='color:#cf222e'>A$"+(Math.round(compTot*volume)).toLocaleString()+"</div><div style='font-size:11px;color:#57606a'>A$"+f(compTot)+" &times; "+(volume||0).toLocaleString()+" parcels</div></div></div>";
    return h;
  }
  function buildDataSourceDisclaimer(){
    var isStd=dispMode==="standard";
    if(!isStd)return "";
    var h="<div style='background:#fff3cd;border:2px solid #ffca2c;padding:14px 18px;border-radius:4px;margin:16px 0'>";
    h+="<div style='font-weight:800;font-size:13px;color:#664d03;margin-bottom:6px'>⚠ Important: This analysis uses estimated industry-average data</div>";
    h+="<div style='font-size:12px;color:#664d03;line-height:1.7'>";
    h+="The <b>weight distribution</b> and <b>state/zone dispersion</b> used in this analysis are based on <b>DAI Post standard industry averages</b>, not this customer's actual parcel data. ";
    h+="Results may differ materially from actual costs once real order data is applied.<br><br>";
    h+="<b>To improve accuracy:</b> Upload the customer's order history (with postcodes and weights) into the Pricing Agent before generating this report. ";
    h+="This will replace the standard assumptions with the customer's actual delivery profile.</div></div>";
    return h;
  }
  function buildDataSourceRows(){
    var isStd=dispMode==="standard";
    var style=isStd?" style='background:#fff3cd'":"";
    var h="<tr"+style+"><td>Weight Distribution</td><td class='r b "+(isStd?"yw":"")+"'>"+(isStd?"⚠ Industry Standard Estimate":"✓ Customer Upload Data")+"</td></tr>";
    h+="<tr"+style+"><td>State/Zone Dispersion</td><td class='r b "+(isStd?"yw":"")+"'>"+(isStd?"⚠ Industry Standard Estimate":"✓ Customer Upload Data")+"</td></tr>";
    return h;
  }
  function buildFooter(custName,compName,dateStr,brand){
    var bn=brand==="pr"?"Parcel Right":"DAI Post";
    return "<div class='footer'>This analysis is confidential and prepared exclusively for "+custName+". "+compName+" rates sourced from customer-provided data. Actual costs may vary. Generated "+dateStr+" by "+bn+" Pricing.</div>";
  }
  function outputReport(h,custName,compName){
    sReportHTML(h);
    try{var blob=new Blob([h],{type:"text/html"});var url=URL.createObjectURL(blob);var a=document.createElement("a");a.href=url;a.download=(custName.replace(/\s+/g,"_")+"_vs_"+compName.replace(/\s+/g,"_")+"_Commercial_Summary.html");document.body.appendChild(a);a.click();document.body.removeChild(a);setTimeout(function(){URL.revokeObjectURL(url)},1000)}catch(de){}
  }
  function showExportError(err){console.error("Export Error:",err);var eDiv=document.createElement("div");eDiv.style.cssText="position:fixed;top:20px;left:50%;transform:translateX(-50%);background:#f85149;color:#fff;padding:12px 20px;font-size:13px;z-index:9999;border-radius:4px;font-family:monospace;max-width:600px";eDiv.textContent="Export error: "+err.message;document.body.appendChild(eDiv);setTimeout(function(){eDiv.remove()},8000)}

  function exportCommercialSummary(whichTgt){try{
    if(!canExportSummary(whichTgt))return;
    var custName=cust||"Customer";
    var dateStr=new Date().toLocaleDateString("en-AU");
    var tgtObj=prTgts[whichTgt]||prTgts[0];
    var compName=tgtObj?tgtObj.label:"Competitor";
    var compTgt=tgtObj?tgtObj.rates:{};
    var prwMap=[0,1,2,3,4,5,6,6,6,6];
    var wd10=PRW.map(function(_,i){var mi=prwMap[i];var v=aWDist[mi]||0;return mi===6?v/4:v});
    var pcCounts={};
    if(ZD&&Object.keys(ZD).length>0){Object.keys(ZD).forEach(function(pc){var zCode=ZD[pc][0];if(zCode){var st=zCode.replace(/[0-9]/g,"");var z=zCode.replace(/[^0-9]/g,"");var k=st+"-Z"+z;pcCounts[k]=(pcCounts[k]||0)+1}})}
    var totalZ1pcs=0;var totalZ2pcs=0;var totalZ3pcs=0;
    Object.keys(pcCounts).forEach(function(k){if(k.endsWith("-Z1"))totalZ1pcs+=pcCounts[k];else if(k.endsWith("-Z2"))totalZ2pcs+=pcCounts[k];else totalZ3pcs+=pcCounts[k]});
    // Midpoints for PR weight breaks
    var mids=[0.25,0.75,1.5,2.5,3.5,4.5,6,8.5,12.5,18.5];
    function rebucketMap(dm){
      return mids.map(function(m){
        var vw=m*dm;
        for(var j=0;j<PRW.length;j++){if(vw<=PRW[j])return j}
        return PRW.length-1;
      });
    }
    // Run one scenario: basis=physical|volumetric, fscMult=1 or 1+fsc%
    function calcScenario(basis,fscMult){
      var remap=basis==="volumetric"?rebucketMap(prDim||1.3):null;
      var daiTot=0;var compTot=0;var stRows=[];var zonesCompared=0;var zonesDAIcheaper=0;var zonesCompCheaper=0;
      STS.forEach(function(st){
        var ds=aDisp[st];if(!ds||ds.pct<=0)return;
        var stPct=ds.pct/100;var stVol=Math.round(vol*stPct);
        var stDai=0;var stComp=0;var stZones=[];
        [1,2,3].forEach(function(z){
          var zk=st+"-Z"+z;
          if(ppExclZ[zk])return; // Skip excluded zones
          var zPct=(z===1?ds.z1:z===2?ds.z2:ds.z3)/100;
          if(zPct<=0)return;
          var zone=pr.rc.find(function(r){return r.k===zk});if(!zone)return;
          var cRates=compTgt[zk];
          var zDai=0;var zComp=0;var hasComp=false;var wbRows=[];
          zone.rates.forEach(function(r,wi){
            if(ppExclW[wi])return; // Skip excluded weight breaks
            var wdPct=wd10[wi]/100;
            zDai+=r.rate*wdPct;
            var ci=remap?remap[wi]:wi;
            var cRate=(cRates&&cRates[ci])?cRates[ci]*fscMult:0;
            if(cRates&&cRates[ci]>0)hasComp=true;
            zComp+=cRate*wdPct;
            wbRows.push({wb:PRWL[wi],dai:r.rate,comp:cRate,origBand:remap?PRWL[ci]+"kg":null,diff:cRate-r.rate});
          });
          if(hasComp){
            zonesCompared++;if(zDai<=zComp)zonesDAIcheaper++;else zonesCompCheaper++;
            stZones.push({z:z,zk:zk,zPct:zPct*100,dai:zDai,comp:zComp,diff:zComp-zDai,pcs:pcCounts[zk]||0,wbRows:wbRows});
            stDai+=zDai*zPct;stComp+=zComp*zPct;
          }
        });
        daiTot+=stDai*stPct;compTot+=stComp*stPct;
        if(stZones.length>0)stRows.push({st:st,pct:ds.pct,vol:stVol,dai:stDai,comp:stComp,diff:stComp-stDai,zones:stZones});
      });
      stRows.sort(function(a,b){return b.pct-a.pct});
      var savPc=compTot-daiTot;var savAnn=savPc*vol;var savWk=savAnn/52;var savMo=savAnn/12;
      var savPct=compTot>0?((compTot-daiTot)/compTot*100):0;
      var allZones=[];stRows.forEach(function(sr){sr.zones.forEach(function(z){allZones.push({...z,st:sr.st,stPct:sr.pct})})});
      allZones.sort(function(a,b){return(b.stPct*b.zPct)-(a.stPct*a.zPct)});
      return{daiTot:daiTot,compTot:compTot,savPc:savPc,savAnn:savAnn,savWk:savWk,savMo:savMo,savPct:savPct,
        stRows:stRows,topZones:allZones.slice(0,6),zonesCompared:zonesCompared,zonesDAIcheaper:zonesDAIcheaper,zonesCompCheaper:zonesCompCheaper,
        basis:basis,fscMult:fscMult,isVol:basis==="volumetric"};
    }
    // ── Z1 Metro Floor: parcel-level benefit analysis ──
    var isZ1Floor=tgtObj&&tgtObj.source==="z1-floor";
    var z1FloorParcelBenefit=null;
    if(isZ1Floor&&custRows&&custRows.length>0&&pr&&pr.rc){
      function wtIdxFloor(w){for(var i=0;i<PRW.length;i++){if(w<=PRW[i])return i}return PRW.length-1}
      var prRateMapFloor={};pr.rc.forEach(function(z){prRateMapFloor[z.k]=z.rates.map(function(r){return r.rate})});
      var z1Parcels=0;var z1Benefiting=0;var z1TotalSaving=0;var z1PRTotal=0;var z1CompTotal=0;
      custRows.forEach(function(row){
        if(!row.zone)return;
        var m=row.zone.match(/^([A-Z]+)(\d)$/);if(!m)return;
        var dzk=m[1]+"-Z"+m[2];
        if(!dzk.endsWith("-Z1"))return;
        var wi=wtIdxFloor(row.wt);
        var prRate=(prRateMapFloor[dzk]&&prRateMapFloor[dzk][wi])||0;
        if(prRate<=0)return;
        z1Parcels++;z1PRTotal+=prRate;
        // Get actual competitor rate from target rates (parcel-level)
        var compRate=(compTgt[dzk]&&compTgt[dzk][wi])||0;
        if(compRate<=0)return;
        z1CompTotal+=compRate;
        if(prRate<compRate){z1Benefiting++;z1TotalSaving+=compRate-prRate;}
      });
      if(z1Parcels>0){
        var z1VolFrac=z1Parcels/custRows.length;
        z1FloorParcelBenefit={
          parcels:z1Parcels,benefiting:z1Benefiting,benefitPct:Math.round(z1Benefiting/z1Parcels*100),
          totalSaving:z1TotalSaving,perParcel:z1Parcels>0?z1TotalSaving/z1Parcels:0,
          annSaving:z1TotalSaving/custRows.length*vol,annSavingWk:z1TotalSaving/custRows.length*vol/52,
          annSavingMo:z1TotalSaving/custRows.length*vol/12,
          prAvg:z1PRTotal/z1Parcels,compAvg:z1Parcels>0?z1CompTotal/z1Parcels:0,
          volFrac:z1VolFrac
        };
      }
    }
    // Build scenarios
    var scenarios=[];
    var bases=prCompBasis==="unknown"?["physical","volumetric"]:[prCompBasis];
    var fscs=prCompFsc==="unknown"?[{m:1,l:"FSC Inclusive"},{m:1+prCompFscPct/100,l:"+ "+prCompFscPct+"% FSC"}]:[prCompFsc==="exclusive"?{m:1+prCompFscPct/100,l:"+ "+prCompFscPct+"% FSC"}:{m:1,l:"FSC Inclusive"}];
    bases.forEach(function(b){fscs.forEach(function(fc){
      var r=calcScenario(b,fc.m);
      r.label=(b==="volumetric"?"Volumetric":"Physical")+" weight, "+fc.l;
      r.shortLabel=(b==="volumetric"?"Vol":"Phys")+", "+fc.l;
      scenarios.push(r);
    })});
    var best=scenarios.reduce(function(a,b){return a.savAnn>=b.savAnn?a:b});
    var worst=scenarios.reduce(function(a,b){return a.savAnn<=b.savAnn?a:b});
    // ── HTML Report ──
    var h="<html><head><title>"+custName+" -- Commercial Summary vs "+compName+"</title><style>";
    h+="*{box-sizing:border-box}body{font-family:'Segoe UI',Arial,sans-serif;padding:40px 50px;color:#1a1a2e;line-height:1.6;max-width:1100px;margin:0 auto}";
    h+="h1{font-size:22px;color:#037A68;margin:0 0 4px}h2{font-size:15px;color:#037A68;margin:28px 0 10px;border-bottom:2px solid #037A68;padding-bottom:4px}h3{font-size:13px;color:#05c9a7;margin:18px 0 6px}";
    h+="table{border-collapse:collapse;width:100%;margin:8px 0 16px;font-size:11px}th{background:#f0f4f8;text-align:left;padding:6px 10px;border:1px solid #d0d7de;font-weight:600;font-size:10px;text-transform:uppercase;letter-spacing:.03em}";
    h+="td{padding:5px 10px;border:1px solid #e1e5e9}.r{text-align:right;font-variant-numeric:tabular-nums}.b{font-weight:700}.gn{color:#1a7f37}.rd{color:#cf222e}.yw{color:#9a6700}.hl{background:#dafbe1}.hln{background:#ffebe9}";
    h+=".hero{background:linear-gradient(135deg,#037A68,#04a98f);color:#fff;padding:28px 32px;margin:20px 0 30px;border-radius:6px}";
    h+=".hero h2{color:#fff;border:none;margin:0 0 16px;font-size:18px}.hero .big{font-size:36px;font-weight:800;margin:4px 0}.hero .sub{font-size:13px;opacity:.85;margin-top:4px}";
    h+=".callout{background:#fff3cd;border:1px solid #ffecb5;padding:12px 16px;border-radius:4px;margin:16px 0;font-size:12px}";
    h+=".callout-blue{background:#e8f4fd;border:1px solid #b6d4fe;padding:12px 16px;border-radius:4px;margin:16px 0;font-size:12px}";
    h+=".callout-green{background:#d1e7dd;border:1px solid #badbcc;padding:12px 16px;border-radius:4px;margin:16px 0;font-size:12px}";
    h+=".grid2{display:grid;grid-template-columns:1fr 1fr;gap:16px}.grid3{display:grid;grid-template-columns:1fr 1fr 1fr;gap:16px}.grid4{display:grid;grid-template-columns:1fr 1fr 1fr 1fr;gap:12px}";
    h+=".card{background:#f6f8fa;border:1px solid #d0d7de;padding:16px;border-radius:4px;text-align:center}.card .num{font-size:24px;font-weight:800;margin:4px 0}.card .lbl{font-size:10px;text-transform:uppercase;color:#57606a;letter-spacing:.05em}";
    h+=".footer{margin-top:30px;padding-top:12px;border-top:1px solid #d0d7de;font-size:9px;color:#8b949e}";
    h+="@media print{body{padding:20px}.hero{break-inside:avoid}table{break-inside:avoid}}";
    h+="</style></head><body>";
    // Header
    h+="<div style='display:flex;justify-content:space-between;align-items:flex-end'><div><div style='font-size:11px;color:#57606a;text-transform:uppercase;letter-spacing:.1em'>Commercial Summary</div><h1>Parcel Right vs "+compName+"</h1><div style='font-size:12px;color:#57606a'>Prepared for <b>"+custName+"</b> &nbsp;|&nbsp; "+dateStr+"</div></div><div style='text-align:right'><img src=''+LOGO_PR+'' style='height:28px;margin-bottom:4px' /><div style='font-size:10px;color:#57606a'>Parcel Right -- ex-"+prD+"</div></div></div>";
    // Hero -- use best scenario
    if(best.savPc>=0){
      h+="<div class='hero'><h2>Your Estimated Savings with Parcel Right</h2><div class='grid3'>";
      h+="<div><div class='big'>A$"+(Math.round(Math.abs(best.savWk))).toLocaleString()+"</div><div class='sub'>per week</div></div>";
      h+="<div><div class='big'>A$"+(Math.round(Math.abs(best.savMo))).toLocaleString()+"</div><div class='sub'>per month</div></div>";
      h+="<div><div class='big'>A$"+(Math.round(Math.abs(best.savAnn))).toLocaleString()+"</div><div class='sub'>per year</div></div>";
      h+="</div>";
      if(scenarios.length>1)h+="<div style='margin-top:12px;font-size:11px;opacity:.8'>Best case: "+best.label+""+(worst.savPc>=0?" · Even in the most conservative scenario ("+worst.label+"), you still save A$"+(Math.round(Math.abs(worst.savAnn))).toLocaleString()+"/yr":"")+"</div>";
      h+="</div>";
    }else{
      h+="<div class='hero' style='background:linear-gradient(135deg,#6a040f,#9d0208)'><h2>Cost Comparison</h2><div class='grid3'>";
      h+="<div><div class='big'>A$"+f(best.daiTot)+"</div><div class='sub'>Parcel Right / parcel</div></div>";
      h+="<div><div class='big'>A$"+f(best.compTot)+"</div><div class='sub'>"+compName+" / parcel</div></div>";
      h+="<div><div class='big'>A$"+f(Math.abs(best.savPc))+"</div><div class='sub'>Difference</div></div></div></div>";
    }
    // Z1 Metro Floor benefit callout
    if(isZ1Floor&&z1FloorParcelBenefit){
      var zfb=z1FloorParcelBenefit;
      h+="<div style='background:#d1fae5;border:2px solid #059669;padding:20px 24px;border-radius:6px;margin:20px 0'>";
      h+="<div style='font-size:14px;font-weight:800;color:#065f46;margin-bottom:12px'>⊕ Z1 Metro Floor Advantage — Based on Your Actual Parcel Data</div>";
      h+="<div class='grid4' style='margin-bottom:12px'>";
      h+="<div class='card' style='background:#fff'><div class='num' style='color:#059669'>A$"+f(zfb.annSaving/1000>1?zfb.annSaving/1000:zfb.annSaving,zfb.annSaving/1000>1?1:0)+(zfb.annSaving/1000>1?"K":"")+"</div><div class='lbl'>Annual Saving (Z1)</div></div>";
      h+="<div class='card' style='background:#fff'><div class='num' style='color:#059669'>A$"+f(zfb.perParcel)+"</div><div class='lbl'>Avg Saving / Z1 Parcel</div></div>";
      h+="<div class='card' style='background:#fff'><div class='num' style='color:#059669'>"+zfb.benefitPct+"%</div><div class='lbl'>Z1 Parcels Benefiting</div></div>";
      h+="<div class='card' style='background:#fff'><div class='num' style='color:#1e40af'>"+zfb.parcels.toLocaleString()+"</div><div class='lbl'>Z1 Parcels Analysed</div></div>";
      h+="</div>";
      h+="<div style='font-size:11px;color:#065f46;line-height:1.7'>By pricing all Zone 1 metro deliveries at <b>"+compName+"'s lowest metro rate</b> (A$"+f(zfb.prAvg)+"/parcel avg), ";
      h+="Parcel Right is cheaper on <b>"+zfb.benefiting.toLocaleString()+" of "+zfb.parcels.toLocaleString()+"</b> Zone 1 parcels versus "+compName+"'s blended rates. ";
      h+="Zone 1 accounts for <b>"+Math.round(zfb.volFrac*100)+"% of your total volume</b>. ";
      h+="This approach protects against <b>rate streaming</b> — the customer cannot cherry-pick "+compName+" for cheap metro zones and use Parcel Right only for expensive zones.</div>";
      h+="</div>";
    }
    // Scenario summary table (if multiple)
    if(scenarios.length>1){
      h+="<h2>Scenario Analysis</h2>";
      h+="<div class='callout-blue'><b>Why scenarios?</b> We don't yet know "+(prCompBasis==="unknown"?"whether "+compName+" charges on physical or volumetric weight":"")+(prCompBasis==="unknown"&&prCompFsc==="unknown"?" and ":"")+(prCompFsc==="unknown"?"whether "+compName+"'s rates include fuel surcharge or not":"")+". Each combination changes the true comparison. "+(prCompBasis==="unknown"?"If "+compName+" charges on volumetric weight, their effective rates increase because parcels with a DIM factor of "+f(prDim)+" get charged at heavier weight bands.":"")+"</div>";
      h+="<table><tr><th>Scenario</th><th class='r'>"+compName+" / pc</th><th class='r'>Parcel Right / pc</th><th class='r'>Saving / pc</th><th class='r'>Saving / week</th><th class='r'>Saving / month</th><th class='r'>Saving / year</th></tr>";
      scenarios.forEach(function(sc){
        var cls=sc.savPc>=0?"gn":"rd";
        h+="<tr><td class='b'>"+sc.label+"</td><td class='r'>A$"+f(sc.compTot)+"</td><td class='r'>A$"+f(sc.daiTot)+"</td>";
        h+="<td class='r b "+cls+"'>"+(sc.savPc>=0?"+":"")+"A$"+f(sc.savPc)+"</td>";
        h+="<td class='r b "+cls+"'>"+(sc.savWk>=0?"+":"")+"A$"+(Math.round(sc.savWk)).toLocaleString()+"</td>";
        h+="<td class='r b "+cls+"'>"+(sc.savMo>=0?"+":"")+"A$"+(Math.round(sc.savMo)).toLocaleString()+"</td>";
        h+="<td class='r b "+cls+"' style='font-size:12px'>"+(sc.savAnn>=0?"+":"")+"A$"+(Math.round(Math.abs(sc.savAnn))).toLocaleString()+"</td></tr>";
      });
      h+="</table>";
    }
    // Use best scenario for detailed breakdown
    var sc=best;
    h+=buildDataSourceDisclaimer();
    // Why comparisons are misleading
    h+="<h2>Why Carrier Comparisons Are Misleading</h2>";
    h+="<div class='callout-blue'><b>The zone definition problem:</b> Every carrier defines delivery zones differently. A competitor's \"metro\" zone often covers a narrower set of postcodes than Parcel Right Zone 1. ";
    if(totalZ1pcs>0)h+="Parcel Right Zone 1 covers <b>"+totalZ1pcs.toLocaleString()+" postcodes</b> nationally -- extending well beyond CBD into areas other carriers classify as regional. ";
    h+="This means a lower headline \"metro\" rate can be misleading.</div>";
    if(sc.isVol){
      h+="<div class='callout'><b>Volumetric weight impact:</b> "+compName+" charges on volumetric weight. With a DIM factor of <b>"+f(prDim)+"</b>, parcels shift into heavier weight bands. ";
      h+="For example, a 0.5kg physical parcel becomes "+f(0.5*prDim)+"kg volumetric -- potentially charged at the "+PRWL[rebucketMap(prDim)[0]]+"kg rate instead of the 0.5kg rate. ";
      h+="Parcel Right charges on physical weight, so your lighter parcels stay in lower-cost bands.</div>";
    }
    h+="<div class='callout'><b>This report solves that problem.</b> We have mapped "+compName+"'s rates against Parcel Right's zone definitions and applied your actual parcel distribution -- <b>"+(vol||0).toLocaleString()+" parcels/year</b>"+(sc.isVol?", adjusted for volumetric rebucketing at DIM "+f(prDim):"")+", weighted by state, zone, and weight band -- to calculate the true like-for-like cost.</div>";
    var exclZones=Object.keys(ppExclZ).filter(function(k){return ppExclZ[k]});
    var exclWts=Object.keys(ppExclW).filter(function(k){return ppExclW[k]}).map(function(k){return PRWL[k]+"kg"});
    if(exclZones.length>0||exclWts.length>0){
      h+="<div class='callout'><b>Tailored pricing scope:</b> This analysis reflects only the lanes Parcel Right is quoting on.";
      if(exclZones.length>0)h+=" <b>"+exclZones.length+" zone"+(exclZones.length>1?"s":"")+" excluded:</b> "+exclZones.join(", ")+".";
      if(exclWts.length>0)h+=" <b>"+exclWts.length+" weight break"+(exclWts.length>1?"s":"")+" excluded:</b> "+exclWts.join(", ")+".";
      h+=" Only parcels within the quoted scope are included in the savings calculation.</div>";
    }
    // State-by-State
    h+="<h2>State-by-State Cost Comparison"+(scenarios.length>1?" ("+sc.shortLabel+")":"")+"</h2>";
    h+="<table><tr><th>State</th><th class='r'>% of Volume</th><th class='r'>Parcels</th><th class='r'>Parcel Right / pc</th><th class='r'>"+compName+" / pc</th><th class='r'>Saving / pc</th><th class='r'>Annual Saving</th></tr>";
    var totalAnnSav=0;
    sc.stRows.forEach(function(sr){
      var cls=sr.diff>=0?"gn":"rd";var annSav=sr.diff*sr.vol;totalAnnSav+=annSav;
      h+="<tr><td class='b'>"+sr.st+"</td><td class='r'>"+f(sr.pct,1)+"%</td><td class='r'>"+sr.vol.toLocaleString()+"</td>";
      h+="<td class='r b'>A$"+f(sr.dai)+"</td><td class='r b'>A$"+f(sr.comp)+"</td>";
      h+="<td class='r b "+cls+"'>"+(sr.diff>=0?"+":"")+"A$"+f(sr.diff)+"</td>";
      h+="<td class='r b "+cls+"'>"+(annSav>=0?"+":"")+"A$"+(Math.round(Math.abs(annSav))).toLocaleString()+"</td></tr>";
    });
    h+="<tr style='border-top:2px solid #0a2463'><td class='b' colspan='2'>NATIONAL TOTAL</td><td class='r b'>"+(vol||0).toLocaleString()+"</td>";
    h+="<td class='r b'>A$"+f(sc.daiTot)+"</td><td class='r b'>A$"+f(sc.compTot)+"</td>";
    h+="<td class='r b "+(sc.savPc>=0?"gn":"rd")+"'>"+(sc.savPc>=0?"+":"")+"A$"+f(sc.savPc)+"</td>";
    h+="<td class='r b "+(totalAnnSav>=0?"gn":"rd")+"' style='font-size:13px'>"+(totalAnnSav>=0?"+":"")+"A$"+(Math.round(Math.abs(totalAnnSav))).toLocaleString()+"</td></tr></table>";
    // Zone coverage
    if(totalZ1pcs>0){
      h+="<h2>Parcel Right Zone Coverage</h2>";
      h+="<table><tr><th>State / Zone</th><th class='r'>Postcodes</th><th class='r'>% of Deliveries</th><th class='r'>DAI Wtd Rate</th><th class='r'>"+compName+" Wtd Rate</th><th class='r'>Difference</th></tr>";
      sc.stRows.forEach(function(sr){sr.zones.forEach(function(z){
        var cls=z.diff>=0?"gn":"rd";
        h+="<tr><td class='b'>"+sr.st+" -- Zone "+z.z+"</td><td class='r'>"+z.pcs.toLocaleString()+"</td><td class='r'>"+f(z.zPct,1)+"%</td>";
        h+="<td class='r b'>A$"+f(z.dai)+"</td><td class='r b'>A$"+f(z.comp)+"</td>";
        h+="<td class='r b "+cls+"'>"+(z.diff>=0?"+":"")+"A$"+f(z.diff)+"</td></tr>";
      })});
      h+="</table>";
    }
    // Top zones detail
    h+="<h2>Detailed Rate Comparison -- Highest Volume Zones"+(scenarios.length>1?" ("+sc.shortLabel+")":"")+"</h2>";
    h+="<p style='font-size:11px;color:#57606a'>Side-by-side rates. <span class='gn b'>Green</span> = Parcel Right cheaper. <span class='rd b'>Red</span> = "+compName+" cheaper."+(sc.isVol?" <i>Comp. band shows the volumetric weight band "+compName+" would charge at.</i>":"")+"</p>";
    sc.topZones.forEach(function(tz){
      h+="<h3>"+tz.st+" -- Zone "+tz.z;
      if(tz.pcs>0)h+=" <span style='font-weight:400;color:#57606a'>("+tz.pcs.toLocaleString()+" postcodes)</span>";
      h+="</h3><table><tr><th>Phys. Weight</th>";
      PRWL.forEach(function(l){h+="<th class='r'>"+l+"kg</th>"});
      h+="<th class='r'>Wtd Avg</th></tr>";
      h+="<tr><td class='b' style='color:#037A68'>Parcel Right</td>";
      tz.wbRows.forEach(function(wb){h+="<td class='r'>$"+f(wb.dai)+"</td>"});
      h+="<td class='r b'>$"+f(tz.dai)+"</td></tr>";
      h+="<tr><td class='b' style='color:#cf222e'>"+compName+(sc.isVol?" (vol.)":"")+"</td>";
      tz.wbRows.forEach(function(wb){var cls=wb.dai<=wb.comp?"hl":"hln";h+="<td class='r "+cls+"'>$"+f(wb.comp)+(wb.origBand?"<div style='font-size:8px;color:#57606a'>@"+wb.origBand+"</div>":"")+"</td>"});
      h+="<td class='r b'>$"+f(tz.comp)+"</td></tr>";
      h+="<tr style='background:#f6f8fa'><td class='b' style='color:#57606a'>DAI Saving</td>";
      tz.wbRows.forEach(function(wb){var cls=wb.diff>=0?"gn":"rd";h+="<td class='r b "+cls+"'>"+(wb.diff>=0?"+":"")+f(wb.diff)+"</td>"});
      var zSv=tz.diff;h+="<td class='r b "+(zSv>=0?"gn":"rd")+"'>"+(zSv>=0?"+":"")+f(zSv)+"</td></tr></table>";
    });
    // Savings conclusion
    h+="<h2>Conclusion</h2>";
    if(best.savPc>=0){
      h+="<div style='background:#0a2463;color:#fff;padding:24px 28px;border-radius:6px;margin:20px 0'>";
      h+="<div style='font-size:16px;font-weight:800;margin-bottom:16px;text-transform:uppercase;letter-spacing:.06em'>By switching to Parcel Right, "+custName+" would save:</div>";
      h+="<div class='grid3'>";
      h+="<div style='text-align:center'><div style='font-size:32px;font-weight:800;color:#4ade80'>A$"+(Math.round(best.savWk)).toLocaleString()+"</div><div style='font-size:12px;opacity:.8;margin-top:4px'>per week</div></div>";
      h+="<div style='text-align:center'><div style='font-size:32px;font-weight:800;color:#4ade80'>A$"+(Math.round(best.savMo)).toLocaleString()+"</div><div style='font-size:12px;opacity:.8;margin-top:4px'>per month</div></div>";
      h+="<div style='text-align:center'><div style='font-size:32px;font-weight:800;color:#4ade80'>A$"+(Math.round(best.savAnn)).toLocaleString()+"</div><div style='font-size:12px;opacity:.8;margin-top:4px'>per year</div></div></div>";
      if(scenarios.length>1){
        h+="<div style='margin-top:16px;padding-top:12px;border-top:1px solid rgba(255,255,255,.2);font-size:12px'>";
        var allPositive=scenarios.every(function(s){return s.savPc>=0});
        if(allPositive){h+="<b>Parcel Right is cheaper in every scenario analysed.</b> Savings range from A$"+(Math.round(worst.savAnn)).toLocaleString()+" to A$"+(Math.round(best.savAnn)).toLocaleString()+" per year."}
        else{h+="Savings depend on assumptions. Best case: A$"+(Math.round(best.savAnn)).toLocaleString()+"/yr ("+best.label+"). Contact us to confirm "+compName+"'s charging basis."}
        h+="</div>";
      }else{
        h+="<div style='margin-top:12px;padding-top:12px;border-top:1px solid rgba(255,255,255,.2);font-size:12px;opacity:.9'>That's <b>A$"+f(Math.abs(best.savPc))+" less per parcel</b> (<b>"+f(Math.abs(best.savPct),1)+"%</b> lower). Parcel Right wins in <b>"+best.zonesDAIcheaper+" of "+best.zonesCompared+"</b> delivery zones.</div>";
      }
      h+="</div>";
    }else{
      h+="<div class='callout'><b>At current rates, "+compName+" is A$"+f(Math.abs(best.savPc))+" per parcel cheaper</b> (A$"+(Math.round(Math.abs(best.savWk))).toLocaleString()+"/wk, A$"+(Math.round(Math.abs(best.savMo))).toLocaleString()+"/mo, A$"+(Math.round(Math.abs(best.savAnn))).toLocaleString()+"/yr). ";
      h+="However, Parcel Right is still cheaper in <b>"+best.zonesDAIcheaper+" of "+best.zonesCompared+"</b> zones. Contact us to discuss volume-based pricing.</div>";
    }
    // Scorecard
    h+="<h2>Zone-by-Zone Scorecard</h2><div class='grid3' style='margin-bottom:16px'>";
    h+="<div class='card'><div class='num gn'>"+best.zonesDAIcheaper+"</div><div class='lbl'>Zones Parcel Right Wins</div></div>";
    h+="<div class='card'><div class='num rd'>"+best.zonesCompCheaper+"</div><div class='lbl'>Zones "+compName+" Wins</div></div>";
    h+="<div class='card'><div class='num'>"+best.zonesCompared+"</div><div class='lbl'>Total Zones Compared</div></div></div>";
    // Assumptions
    h+="<h2>Assumptions &amp; Methodology</h2>";
    h+="<table><tr><th style='width:280px'>Parameter</th><th>Value</th></tr>";
    h+="<tr><td>Annual Parcel Volume</td><td class='r b'>"+(vol||0).toLocaleString()+"</td></tr>";
    h+="<tr><td>Average Parcel Weight</td><td class='r'>"+f(avgWt)+" kg</td></tr>";
    h+="<tr><td>Customer DIM Factor</td><td class='r'>"+f(prDim)+"</td></tr>";
    h+="<tr><td>Parcel Right Depot</td><td class='r'>"+prD+"</td></tr>";
    h+="<tr><td>Parcel Right Pricing Tier</td><td class='r'>"+pr.tier.l+" ("+f(pr.tier.mg*100,1)+"% target)</td></tr>";
    h+="<tr><td>"+compName+" Weight Basis</td><td class='r "+(prCompBasis==="unknown"?"yw":"")+"'>"+(prCompBasis==="unknown"?"Unknown -- both scenarios shown":prCompBasis==="volumetric"?"Volumetric (DIM "+f(prDim)+")":"Physical")+"</td></tr>";
    h+="<tr><td>"+compName+" FSC</td><td class='r "+(prCompFsc==="unknown"?"yw":"")+"'>"+(prCompFsc==="unknown"?"Unknown -- both scenarios shown":prCompFsc==="exclusive"?"+ "+prCompFscPct+"% FSC on top":"Inclusive in rates")+"</td></tr>";
    h+=buildDataSourceRows();
    h+="<tr><td>Zones With Competitor Data</td><td class='r b'>"+best.zonesCompared+"</td></tr></table>";
    h+="<div class='callout-blue' style='margin-top:16px'><b>Methodology:</b> Both rate cards are applied to the identical set of parcels -- same state distribution, same zone allocation, same weight profile. ";
    if(scenarios.some(function(s){return s.isVol}))h+="For volumetric scenarios, each parcel's physical weight is multiplied by DIM "+f(prDim)+" to determine the competitor's effective weight band. ";
    h+="Results are weighted by actual delivery volume to produce a true blended cost per parcel. "+compName+"'s rates have been mapped against Parcel Right zone definitions at the postcode level.</div>";
    h+="<div class='footer'>This analysis is confidential and prepared exclusively for "+custName+". "+compName+" rates sourced from their published rate card or customer-provided data. ";
    h+="Actual costs may vary based on surcharges, minimum charges, and service-level differences. Generated "+dateStr+" by Parcel Right Pricing.</div>";
    h+="</body></html>";
    outputReport(h,custName,compName);
  }catch(err){showExportError(err)}}

  var udp=useCallback(function(st,k,v){sDisp(function(p){return{...p,[st]:{...p[st],[k]:parseFloat(v)||0}}})},[]);

  var dcCcy=prod==="pm"?afc:prod==="pma"?(pmaCcy==="local"?pmaAfc:"AUD"):"AUD";
  var dcFx=prod==="pm"?(fx[afc]||1):prod==="pma"?pmaFxR:1;
  var dcLabel=showAUD||dcCcy==="AUD"?"AUD":dcCcy;
  var dcPrefix=showAUD||dcCcy==="AUD"?"A$":dcCcy+" ";
  function dc(audVal,dp){if(showAUD||dcCcy==="AUD")return "A$"+f(audVal,dp);return dcCcy+" "+f(audVal*dcFx,dp)+" (A$"+f(audVal,dp)+")"}
  var showCcyToggle=prod!=="pr"&&dcCcy!=="AUD";

  var pmKgLabel=pmWtBasis==="vol"?"/vol kg":"/kg";
  var pmKgDiv=pmWtBasis==="vol"?oppDim:1;
  var pmAfCostAUD=0;
  if(dim){
    if(pmWtBasis==="vol"){
      var afReb=origin==="LHR"?dtR/oppDim:0;
      // Asendia simulation reduction
      var afSimReduceL=(afCostReduce&&origin==="LHR")?0.27:0;
      pmAfCostAUD=toA(Math.max(0,dim.wC-afReb-afSimReduceL),dim.ccy,fx);
    }else{
      pmAfCostAUD=dim.effA;
    }
  }

  return (
    <>
    <div className="app">
     {/* ========================== HEADER ========================== */}
      <div className="hdr">
        {/* /* add PM logo and PR logo */}
        <div style={{display:"flex",alignItems:"center",gap:12}}>
          {!oppId?(<>
            <img src={LOGO_DAI} alt="DAI Post" style={{height:22}} />
            <span style={{color:C.bd,fontSize:14,margin:"0 6px"}}>|</span>
            <img src={LOGO_PR} alt="Parcel Right" style={{height:18}} />
            </>
          ):prod==="pr"?
          (
            <img src={LOGO_PR} alt="Parcel Right" style={{height:20}} />
          ):(prod==="pm"||prod==="pma")?(<>
            <img src={LOGO_DAI} alt="DAI Post" style={{height:22}} />
            <span style={{color:C.bd,fontSize:14,margin:"0 4px"}}>|</span>
            <img src={LOGO_PM} alt="Parcel Max" style={{height:16}} /></>
          ):(<img src={LOGO_DAI} alt="DAI Post" style={{height:22}} />)
          }
            <span style={{fontSize:10}} className="span-white">
            PRICING AGENT 
            {/* <span style={{color:prod==="pr"?"#037A68":"#0091b3"}}>v188</span>
            <span style={{color:"#666",marginLeft:4}}>b241</span> */}
            </span>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ fontSize: 10}} className="span-white">
            {prodLabel} · {cust || "New Opportunity"}
            {oppId ? " (saved)" : ""}
          </span>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {loading ? (
            <span style={{ fontSize: 10}} className="span-white">
              Checking session...
            </span>
          ) : user ? (
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <div className="profileInititals">
                {getInitials(user.displayName)}
              </div>
              <span style={{ fontSize: 10}} className="span-white">
                {user.displayName}
                <button onClick={handleLogout} className="header-logout">
                  Log Out
                </button>
              </span>
            </div>
          ) : (
            <button onClick={handleLogin} className="header-login" >
              Login
            </button>
          )}
        </div>
        
      </div>
      
{/* =================== MENU TAB ================== */}
      <div className="menu-tab">
        <button onClick={() => sMainTab("pricing")} className={`menu-option ${mainTab === "pricing" ? "active-pricing" : ""}`}>
        Pricing
        </button>
        <button onClick={() => sMainTab("routing")} className={`menu-option ${mainTab === "routing" ? "active-routing" : ""}`}>
        {"Internal Routing" + (pmRouting || prRouting ? " ✓" : "")}
        </button>
      </div>
      <div className={`flex-container ${oppSaveStatus === "local" || oppSaveStatus === "failed" ? "compact" : ""}`}>
        <button onClick={newOpp} className="btn btn-new">+ New</button>
        <button onClick={saveOpp} className="btn btn-save">Save</button>
        {oppSaveStatus === "saving" && <span className="status status-saving">⏳ Saving...</span>}
        {oppSaveStatus === "shared" && <span className="status status-shared">✓ Saved — visible to all users</span>}
        {saveMsg && !oppSaveStatus && (
          <span className={`status ${saveMsg.startsWith("✓") ? "status-shared" : "status-error"}`}>
            {saveMsg}
          </span>
        )}
        <button onClick={startSaveAs} className="btn btn-saveas">Save As</button>

        {saveAsMode && (<>
          <input style={{...S.inp,width:220,fontSize:11,border:"1px solid "+C.yw}} value={saveAsName} onChange={function(e){sSaveAsName(e.target.value)}} onKeyDown={function(e){if(e.key==="Enter")confirmSaveAs();if(e.key==="Escape")cancelSaveAs()}} autoFocus placeholder="Enter opportunity name..." />
          <button onClick={confirmSaveAs} style={{padding:"5px 10px",background:C.gn,border:"none",color:"#fff",fontFamily:bf,fontSize:10,cursor:"pointer",borderRadius:0}}>Confirm</button>
          <button onClick={cancelSaveAs} style={{padding:"5px 10px",background:"transparent",border:"1px solid "+C.bd,color:C.td,fontFamily:bf,fontSize:10,cursor:"pointer",borderRadius:0}}>Cancel</button>
        </>)}
        {oppList.length>0 && (<>
          <span style={{fontSize:9,color:C.td}}>|</span>
          <select style={{...S.sel,minWidth:260,fontSize:10.5,fontWeight:600,color:oppId?C.ac:C.tm}} value={oppId||""} onChange={function(e){if(e.target.value){loadOpp(e.target.value)}else{sOppId(null);sAppStarted(false)}}}>
            <option value="">-- Select Saved Opportunity --</option>
            {oppList.map(function(o){
              var pLabel=o.prod==="pm"?"PM":o.prod==="pma"?"PMA":"PR";
              return (<option key={o.id} value={o.id}>{(o.name||"Unnamed")+" ("+pLabel+")"}</option>);
            })}
          </select>
          {oppId && !deleteConfirm && !renameMode && (<>
            <button onClick={startRename} style={{padding:"5px 8px",background:"transparent",border:"1px solid "+C.bd,color:C.yw,fontFamily:bf,fontSize:10,cursor:"pointer",borderRadius:0}}>Rename</button>
            <button onClick={startDelete} style={{padding:"5px 8px",background:"transparent",border:"1px solid "+C.bd,color:C.rd,fontFamily:bf,fontSize:10,cursor:"pointer",borderRadius:0}}>Delete</button>
          </>)}
          {oppId && deleteConfirm && (<>
            <span style={{fontSize:10,color:C.rd,fontWeight:600}}>Delete "{oppList.find(function(o){return o.id===oppId})?.name}"?</span>
            <button onClick={confirmDelete} style={{padding:"5px 10px",background:C.rd,border:"none",color:"#fff",fontFamily:bf,fontSize:10,cursor:"pointer",borderRadius:0}}>Yes, Delete</button>
            <button onClick={cancelDelete} style={{padding:"5px 10px",background:"transparent",border:"1px solid "+C.bd,color:C.td,fontFamily:bf,fontSize:10,cursor:"pointer",borderRadius:0}}>Cancel</button>
          </>)}
          {oppId && renameMode && (<>
            <input style={{...S.inp,width:220,fontSize:11,border:"1px solid "+C.yw}} value={renameName} onChange={function(e){sRenameName(e.target.value)}} onKeyDown={function(e){if(e.key==="Enter")confirmRename();if(e.key==="Escape")cancelRename()}} autoFocus placeholder="New name..." />
            <button onClick={confirmRename} style={{padding:"5px 10px",background:C.gn,border:"none",color:"#fff",fontFamily:bf,fontSize:10,cursor:"pointer",borderRadius:0}}>Rename</button>
            <button onClick={cancelRename} style={{padding:"5px 10px",background:"transparent",border:"1px solid "+C.bd,color:C.td,fontFamily:bf,fontSize:10,cursor:"pointer",borderRadius:0}}>Cancel</button>
          </>)}
        </>)}
        {oppLoading && (<span style={{fontSize:10,color:C.ac}}>Loading...</span>)}
        <span style={{fontSize:9,color:C.td}}>|</span>
        <button onClick={backupAll} style={{padding:"5px 8px",background:"transparent",border:"1px solid "+C.bd,color:C.td,fontFamily:bf,fontSize:9,cursor:"pointer",borderRadius:0}}>⬇ Backup</button>
        <label style={{padding:"5px 8px",background:"transparent",border:"1px solid "+C.bd,color:C.td,fontFamily:bf,fontSize:9,cursor:"pointer",borderRadius:0,display:"inline-block"}}>
          ⬆ Restore <input type="file" accept=".json" onChange={handleRestore} style={{display:"none"}} />
        </label>
      </div>

      {oppSaveStatus==="local"&&(
        <div style={{marginBottom:8,padding:"8px 12px",background:C.yw+"18",border:"2px solid "+C.yw+"70",display:"flex",alignItems:"flex-start",gap:12,flexWrap:"wrap"}}>
          <div style={{flex:1,minWidth:200}}>
            <div style={{fontSize:11,fontWeight:700,color:C.yw,marginBottom:2}}>⚠ Saved locally only — other users cannot see this</div>
            <div style={{fontSize:9,color:C.yw+"cc"}}>Shared storage failed or is unavailable in this session. Your data is saved in this browser only. Use the backup button to share your opportunities with the team.</div>
          </div>
          <button onClick={function(){backupAll();sOppSaveStatus(null)}} style={{fontSize:9,padding:"5px 14px",background:C.yw,color:"#000",border:"none",cursor:"pointer",fontFamily:bf,fontWeight:700,whiteSpace:"nowrap"}}>⬇ Download Backup</button>
          <button onClick={function(){sOppSaveStatus(null)}} style={{fontSize:9,padding:"5px 10px",background:"transparent",border:"1px solid "+C.yw+"60",color:C.yw,cursor:"pointer",fontFamily:bf}}>Dismiss</button>
        </div>
      )}

      {oppSaveStatus==="failed"&&(
        <div style={{marginBottom:8,padding:"8px 12px",background:C.rd+"18",border:"2px solid "+C.rd+"70",display:"flex",alignItems:"flex-start",gap:12,flexWrap:"wrap"}}>
          <div style={{flex:1,minWidth:200}}>
            <div style={{fontSize:11,fontWeight:700,color:C.rd,marginBottom:2}}>✗ Save failed — data not persisted anywhere</div>
            <div style={{fontSize:9,color:C.rd+"cc"}}>Both shared storage and local storage failed. Your changes exist in memory for this session only. A backup file has been downloaded automatically — keep it safe.</div>
          </div>
          <button onClick={function(){backupAll()}} style={{fontSize:9,padding:"5px 14px",background:C.rd,color:"#fff",border:"none",cursor:"pointer",fontFamily:bf,fontWeight:700,whiteSpace:"nowrap"}}>⬇ Download Backup Again</button>
        </div>
      )}

      {mainTab === "pricing" && !appStarted && (
        <div className="empty-state">
          <div className="logo-row">
            <img src={LOGO_DAI} alt="DAI Post" height={40} />
            <span className="logo-separator">|</span>
            <img src={LOGO_PR} alt="Parcel Right" height={32} />
          </div>

          <div className="empty-title">Pricing Agent</div>

          <div className="empty-instruction">
            Select a saved opportunity above or click <strong>+ New</strong> to get started
          </div>
        </div>
      )}
{/* // =================== OPPORTUNITY TAB ================== */}
      {mainTab==="pricing"&&appStarted&&(<>
      <div className="sec"><div className="st">Opportunity</div>
        <div style={grd(6)}>
          {/* ========= Product =========  */}
          <Fl l="Product">
            <select style={{...S.sel,fontWeight:700,color:C.ac}} value={prod} onChange={function(e){sProd(e.target.value)}}>
            <option value="pm">Parcel Max</option>
            <option value="pma">PM Access</option>
            <option value="pr">Parcel Right</option>
            </select>
          </Fl>
          {/* ========= Customer =========  */}
          <Fl l="Customer">
            <input style={S.inp} value={cust} onChange={function(e){sCust(e.target.value)}} placeholder="Name..." />
          </Fl>

          {/* ========= Origin =========  */}
          {prod==="pm" && (
            <Fl l="Origin">
              <select style={S.sel} value={origin} onChange={function(e){setOrig(e.target.value)}}>{Object.entries(ORIS).map(function(kv){return (<option key={kv[0]} value={kv[0]}>{kv[1]}</option>)})}
              </select>
            </Fl>
          )}        
          {prod==="pma" && (
            <Fl l="Origin Country">
              <select style={S.sel} value={pmaOrig} onChange={function(e){sPmaOrig(e.target.value)}}>
                <option value="HKG">China</option>
                <option value="OTH">Other</option>
                </select>
            </Fl>
          )}
          {prod==="pr" && (
            <Fl l="Depot">
              <select style={S.sel} value={prD} onChange={function(e){sPrD(e.target.value)}}>{["MEL","SYD","BNE"].map(function(d){
                return (<option key={d}>{d}</option>)})}
              </select>
            </Fl>
          )}

          {/* ========= Annual Volume =========  */}
          <Fl l="Annual Volume">
            <input style={S.inp} type="text" value={vol?vol.toLocaleString():""} onChange={function(e){sVol(+(e.target.value.replace(/,/g,""))||0)}} />
          </Fl>
          {/* ========= Avg Weight =========  */}
          <Fl l="Avg Weight (kg)">
            <input style={S.inp} type="number" step=".01" value={avgWt} onChange={function(e){sWt(+e.target.value||0)}} />
          </Fl>
          {/* ========= DIM/ Weight =========  */}      
          {prod==="pm" && (<Fl l="Customer DIM"><input style={{...S.inp,fontWeight:700}} type="number" step=".01" value={oppDim} onChange={function(e){sDim(+e.target.value||1)}} /></Fl>)}
          {prod==="pm" && (<Fl l="Weight Basis"><select style={{...S.sel,fontWeight:700,color:pmWtBasis==="vol"?C.cy:C.gn}} value={pmWtBasis} onChange={function(e){sPmWtBasis(e.target.value)}}><option value="vol">Volumetric</option><option value="phys">Physical</option></select></Fl>)}
          {prod==="pr" && (<Fl l="Customer DIM"><input style={{...S.inp,fontWeight:700}} type="number" step=".01" value={prDim} onChange={function(e){sPrDim(+e.target.value||1)}} /></Fl>)}
          {prod==="pr" && (<Fl l="Referral Fee/pc"><input style={S.inp} type="number" step=".01" value={prRef} onChange={function(e){sPrRef(+e.target.value||0)}} /></Fl>)}
        </div>

          {/* ========= FX =========  */}

        {prod==="pm" && (
          <div style={{...grd(3),marginTop:8}}>
            <Fl l="FX">
              <select style={S.sel} value={fxM} onChange={function(e){sFxM(e.target.value)}}>
                <option value="budgeted">Budgeted</option>
                <option value="spot">Spot</option>
              </select>
            </Fl>
            {fxM==="spot" && (<>
              <Fl l="USD"><input style={S.inp} type="number" step=".01" value={fxO.USD} onChange={function(e){sFxO(function(p){return{...p,USD:+e.target.value}})}} /></Fl>
              <Fl l="GBP"><input style={S.inp} type="number" step=".01" value={fxO.GBP} onChange={function(e){sFxO(function(p){return{...p,GBP:+e.target.value}})}} /></Fl></>
            )}
          </div>)}
        {prod==="pma" && (<>
          <div style={{...grd(5),marginTop:8}}>
            <div><label style={S.lb}>Injection Ports</label><div style={{display:"flex",gap:8,marginTop:4}}>{["MEL","SYD","BNE","PER"].map(function(p){return (<label key={p} style={{display:"flex",alignItems:"center",gap:4,cursor:"pointer",fontSize:11,color:pmaInj[p]?C.ac:C.tm}}><input type="checkbox" checked={pmaInj[p]||false} onChange={function(){sPmaInj(function(prev){return{...prev,[p]:!prev[p]}})}} />{p}</label>)})}</div></div>
            <Fl l="KG Rate Weight"><select style={{...S.sel,fontWeight:600,color:pmaWtMode==="vol"?C.cy:C.gn}} value={pmaWtMode} onChange={function(e){sPmaWtM(e.target.value)}}><option value="phys">Physical KG</option><option value="vol">Volumetric KG</option></select></Fl>
            <Fl l="Delivery Weight"><select style={{...S.sel,fontWeight:600,color:pmaPpWtMode==="vol"?C.cy:C.gn}} value={pmaPpWtMode} onChange={function(e){sPmaPpWtM(e.target.value)}}><option value="phys">Physical KG</option><option value="vol">Volumetric KG</option></select></Fl>
            <Fl l="Customer DIM"><input style={{...S.inp,fontWeight:700}} type="number" step=".01" value={pmaDim} onChange={function(e){sPmaDim(+e.target.value||1)}} /></Fl>
            <Fl l="Currency"><select style={S.sel} value={pmaCcy} onChange={function(e){sPmaCcy(e.target.value)}}><option value="local">{pmaAfc}</option><option value="AUD">AUD</option></select></Fl>
          </div>

          
          {dgfFlexAll&&(function(){
            var dailyVol=Math.round(vol/52/5);
            var fscWaived=dailyVol>=7000;
            var fscPct=fscWaived?0:getDfFSC(dgfDieselPrice)*100;
            return <div style={{marginTop:8,padding:"8px 12px",background:fscWaived?C.gn+"12":C.yw+"12",border:"1px solid "+(fscWaived?C.gn+"40":C.yw+"40"),display:"flex",alignItems:"center",gap:16,flexWrap:"wrap"}}>
              <div>
                <div style={{fontSize:9,fontWeight:700,color:fscWaived?C.gn:C.yw,textTransform:"uppercase",letterSpacing:".05em"}}>DGF Flex FSC</div>
                <div style={{fontSize:11,fontWeight:700,color:fscWaived?C.gn:C.yw}}>{fscWaived?"WAIVED":"+"+(fscPct).toFixed(2)+"%"}</div>
              </div>
              <div style={{fontSize:9,color:C.td}}>
                <div>{dailyVol.toLocaleString()+" pcs/day (5-day) vs 7,000 threshold"}</div>
                <div>{fscWaived?"Volume exceeds threshold — FSC not charged by DGF":"Below threshold — FSC applies at A$"+f(dgfDieselPrice)+"/L diesel"}</div>
              </div>
              <Fl l="Diesel price (A$/L)"><div style={{display:"flex",alignItems:"center",gap:4}}><input style={{...S.inp,width:80}} type="number" step=".01" value={dgfDieselPrice} onChange={function(e){sDgfDieselPrice(+e.target.value||1.85)}} /><a href="https://aip.com.au/pricing/Diesel/National/National-Average" target="_blank" rel="noopener noreferrer" style={{fontSize:8,color:C.ac,textDecoration:"none",whiteSpace:"nowrap"}}>AIP ↗</a></div></Fl>
            </div>;
          })()}
          {dgfFlexAll&&(
            <div style={{marginTop:8,padding:"8px 12px",background:C.s2,border:"1px solid "+C.bd}}>
              <div style={{fontSize:9,fontWeight:700,color:C.ac,textTransform:"uppercase",letterSpacing:".05em",marginBottom:6}}>Port Split</div>
              <div style={{display:"flex",gap:8,alignItems:"flex-end"}}>
                {["NSW","VIC"].map(function(st){
                  var cur=disp[st]?Math.round(disp[st].pct*10)/10:0;
                  return <Fl key={st} l={st+"%"}><input style={{...S.inp,width:60}} type="number" step=".1" min="0" max="100" value={cur} onChange={function(e){
                    var val=+e.target.value||0;
                    // Zero all states except NSW/VIC/QLD — this opp is restricted to those 3 ports
                    var newDisp={NSW:{pct:disp["NSW"]?disp["NSW"].pct:0,z1:100,z2:0,z3:0},VIC:{pct:disp["VIC"]?disp["VIC"].pct:0,z1:100,z2:0,z3:0},QLD:{pct:0,z1:100,z2:0,z3:0}};
                    newDisp[st]={pct:val,z1:100,z2:0,z3:0};
                    var qld=Math.max(0,Math.round((100-(val+(disp[st==="NSW"?"VIC":"NSW"]?disp[st==="NSW"?"VIC":"NSW"].pct:0)))*10)/10);
                    newDisp["QLD"]={pct:qld,z1:100,z2:0,z3:0};
                    sDisp(newDisp);sHasCustDisp(true);sDispMode("customer");
                  }} /></Fl>;
                })}
                <Fl l="QLD% (balance)"><div style={{...S.inp,width:60,display:"flex",alignItems:"center",justifyContent:"flex-end",color:C.gn,fontWeight:700}}>{Math.max(0,Math.round((100-(["NSW","VIC"].reduce(function(s,st){return s+(disp[st]?disp[st].pct:0)},0)))*10)/10)}</div></Fl>
                <div style={{fontSize:9,color:C.td,alignSelf:"flex-end",paddingBottom:4}}>{(function(){var nswVic=["NSW","VIC"].reduce(function(s,st){return s+(disp[st]?disp[st].pct:0)},0);var qldBal=Math.max(0,Math.round((100-nswVic)*10)/10);var t=Math.round((nswVic+qldBal)*10)/10;return t+"% total"+(Math.abs(t-100)>0.1?" ⚠":"")})()}</div>
              </div>
            </div>
          )}
          {pmaOrig==="HKG" && (
            <div style={{marginTop:8,padding:8,background:pmaChinaSpecial?C.cy+"10":"transparent",border:"1px solid "+(pmaChinaSpecial?C.cy+"40":C.bd),display:"flex",alignItems:"center",gap:12}}>
              <label style={{display:"flex",alignItems:"center",gap:6,cursor:"pointer",fontSize:11,color:pmaChinaSpecial?C.cy:C.tm}}>
                <input type="checkbox" checked={pmaChinaSpecial} onChange={function(){sPmaChinaSpec(!pmaChinaSpecial)}} />
                <span style={{fontWeight:600}}>Special China Rates (Dragonfly)</span>
              </label>
              {pmaChinaSpecial && (
                <div style={{display:"flex",gap:12,fontSize:10,alignItems:"center"}}>
                  <span style={{color:C.gn}}>MEL -- Active</span>
                  <span style={{color:C.yw}}>SYD -- Coming soon</span>
                  <span style={{color:C.yw}}>BNE -- Coming soon</span>
                  <span style={{color:C.td}}>Metro Z1 coverage only</span>
                </div>
              )}
            </div>
          )}
        </>)}
        <div style={{marginTop:8,display:"flex",alignItems:"center",gap:14,flexWrap:"wrap"}}>

          {/* ========== Upload Data (fmx / trucking / tier / destscan) ========== */}
 <input
        ref={uploadDataRef}
        type="file"
        accept=".xlsx,.xls"
        onChange={handleDataUpload}
        style={{ display: "none" }}
      />
      <button
        onClick={() => uploadDataRef.current && uploadDataRef.current.click()}
        style={{
          padding: "5px 12px",
          background: C.s2,
          border: "1px solid " + C.ac + "60",
          color: C.ac,
          fontFamily: bf,
          fontSize: 10.5,
          cursor: "pointer",
          borderRadius: 0,
          fontWeight: 600,
        }}
      >
        Upload Data
      </button>
      {uploadDataMsg && (
        <span
          style={{
            fontSize: 9.5,
            color: uploadDataMsg.startsWith("✓")
              ? C.gn
              : uploadDataMsg.startsWith("✗")
              ? C.rd
              : C.yw,
          }}
        >
          {uploadDataMsg}
        </span>
      
      )}
          {/* ========== PM &PMA  upload customer data ========== */}
          <input ref={fileRef} type="file" accept=".csv,.txt,.xlsx,.xls" onChange={handleUpload} multiple style={{display:"none"}} />
          <button onClick={function(){fileRef.current&&fileRef.current.click()}} style={{padding:"5px 12px",background:C.s2,border:"1px solid "+C.bd,color:C.ac,fontFamily:bf,fontSize:10.5,cursor:"pointer",borderRadius:0}}>Upload Customer Data (multi-file)</button>
          {uploadInfo&&(<button onClick={function(){sUploadInfo(null);sCustRows(null);sDispMode("standard");sHasCustDisp(false)}} style={{padding:"5px 10px",background:"transparent",border:"1px solid "+C.rd+"60",color:C.rd,fontFamily:bf,fontSize:9.5,cursor:"pointer",borderRadius:0}}>Clear Upload Data</button>)}
          
          {/* ========== PM &PMA  PRofile ========== */}
          <div style={{display:"flex",alignItems:"center",gap:6,padding:"4px 10px",background:dispMode==="customer"?C.ac+"15":"transparent",border:"1px solid "+(dispMode==="customer"?C.ac+"40":C.bd),borderRadius:0}}>
            <span style={{fontSize:10,fontWeight:600,color:C.ac}}>Profile</span>
            <select style={{...S.sel,width:"auto",fontSize:10,padding:"2px 4px"}} value={dispMode} onChange={function(e){sDispMode(e.target.value)}}>
              <option value="standard">Standard (DAI Post avg)</option>
              <option value="customer" disabled={!hasCustDisp}>{hasCustDisp?"Customer Data":"Customer Data (upload first)"}</option>
            </select>
            <span style={{fontSize:9,color:dispMode==="customer"?C.ac:C.td}}>{dispMode==="customer"?"Using customer dispersion + weight mix":"Using DAI Post standard profile"}</span>
          </div>

          {/* ========== PM &PMA  PRicing Option ========== */}
          {showCcyToggle && (
            <div style={{display:"flex",alignItems:"center",gap:6,padding:"4px 10px",background:C.ac+"15",border:"1px solid "+C.ac+"40",borderRadius:0}}>
              <span style={{fontSize:10,fontWeight:600,color:C.ac}}>Display</span>
              <button onClick={function(){sShowAUD(!showAUD)}} style={{fontSize:9,padding:"3px 10px",background:showAUD?C.ad:C.sf,color:showAUD?"#fff":C.tm,border:"1px solid "+(showAUD?C.ad:C.bd),cursor:"pointer",fontFamily:bf,borderRadius:0}}>{showAUD?"AUD":"AUD"}</button>
              <button onClick={function(){sShowAUD(!showAUD)}} style={{fontSize:9,padding:"3px 10px",background:!showAUD?C.ad:C.sf,color:!showAUD?"#fff":C.tm,border:"1px solid "+(!showAUD?C.ad:C.bd),cursor:"pointer",fontFamily:bf,borderRadius:0}}>{dcCcy}</button>
              <span style={{fontSize:9,color:C.td}}>{"Showing pricing in "+(showAUD?"AUD":dcCcy)}</span>
            </div>
          )}

          {/* ==========  PM &PMA FSC Cost ========== */}

          {(prod==="pm"||prod==="pma") && (
            <div style={{display:"flex",alignItems:"center",gap:6,padding:"4px 10px",background:fscOn?C.yw+"15":"transparent",border:"1px solid "+(fscOn?C.yw+"40":C.bd),borderRadius:0}}>
              <label style={{display:"flex",alignItems:"center",gap:5,cursor:"pointer",fontSize:10.5,color:fscOn?C.yw:C.tm}}>
                <input type="checkbox" checked={fscOn} onChange={function(){sFscOn(!fscOn)}} />
                <span style={{fontWeight:600}}>FSC in Cost</span>
              </label>
              {fscOn && (<>
                <span style={{fontSize:9,color:C.td}}>|</span>
                <span style={{fontSize:9.5,color:C.yw}}>Diesel:</span>
                <input style={{...S.inp,width:60,textAlign:"right",padding:"2px 5px",fontSize:10.5}} type="number" step=".01" value={l2FuelPrice} onChange={function(e){sL2FuelPrice(+e.target.value||0)}} />
                <span style={{fontSize:9,color:C.yw}}>$/L</span>
                <span style={{fontSize:9,color:C.td}}>|</span>
                <span style={{fontSize:9,color:C.yw}}>{prod==="pm"?"AF+":""}{"Ret "+f(getFSC(l2FuelPrice)*100,1)+"%"}{pmaChinaSpecial?" · DF "+f(getDfFSC(l2FuelPrice)*100,1)+"%":""}</span>
              </>)}
              {!fscOn && (<><span style={{fontSize:9,color:C.td}}>|</span><span style={{fontSize:9.5,color:C.td}}>{prod==="pm"?"All fuel surcharges excluded":"Retrieval FSC excluded"}</span></>)}
            </div>
          )}

          {/* ==========  PM &PMA DAFF ========== */}
          {(prod==="pm"||prod==="pma") && (
            <div style={{display:"flex",alignItems:"center",gap:6,padding:"4px 10px",background:C.cy+"10",border:"1px solid "+C.cy+"30",borderRadius:0}}>
              <span style={{fontSize:10,fontWeight:600,color:C.cy}}>DAFF $0.37/pc</span>
              <select style={{...S.sel,width:"auto",fontSize:10,padding:"2px 4px"}} value={daffMode} onChange={function(e){sDaffMode(e.target.value)}}>
                <option value="inclusive">Inclusive</option>
                <option value="passthrough">Passthrough</option>
              </select>
              <span style={{fontSize:9,color:C.td}}>{daffMode==="inclusive"?"Absorbed in cost -- reduces margin":"Charged to customer -- margin neutral"}</span>
            </div>
          )}

          {/* ==========ZONEDATA COUNT ============*/}
          <div style={{padding:"2px 10px",display:"flex",alignItems:"center",gap:8}}>
            <span style={{fontSize:9,color:C.gn}}>✓ Zone data ({Object.keys(ZD).length} postcodes){ZD[Object.keys(ZD)[0]]&&ZD[Object.keys(ZD)[0]][1]?" + suburbs":""}</span>
            {!(ZD[Object.keys(ZD)[0]]&&ZD[Object.keys(ZD)[0]][1])&&<label style={{fontSize:8.5,color:C.td,cursor:"pointer",textDecoration:"underline"}}>
              Upload full file for suburb names in exports <input type="file" accept=".json" onChange={handleZdUpload} style={{display:"none"}} />
            </label>}
            <span style={{fontSize:8,color:storageOK.current==="shared"||storageOK.current==="migrated"?C.gn:storageOK.current==="local"?C.yw:C.td}}>| {oppList.length} opps{storageOK.current==="shared"?" ✓ synced":(storageOK.current==="migrated"?" ✓ synced":(storageOK.current==="local"?" ⚠ local":""))} {loadMsg}</span>
            <button onClick={refreshFromShared} style={{fontSize:8,padding:"1px 6px",background:"transparent",border:"1px solid "+C.ac+"40",color:C.ac,cursor:"pointer",fontFamily:bf,borderRadius:0}}>Refresh</button>
          </div>


          {showRestorePrompt&&<div style={{padding:"10px 12px",background:C.yw+"18",border:"2px solid "+C.yw+"60",display:"flex",alignItems:"center",gap:12,flexWrap:"wrap"}}>
            <span style={{fontSize:12,fontWeight:700,color:C.yw}}>Have a backup file?</span>
            <label style={{padding:"6px 16px",background:C.yw,color:"#000",fontFamily:bf,fontSize:11,fontWeight:700,cursor:"pointer",borderRadius:0,display:"inline-block"}}>
              Load Saved Data <input type="file" accept=".json" onChange={function(e){handleRestore(e);sShowRestorePrompt(false)}} style={{display:"none"}} />
            </label>
            <button onClick={function(){sShowRestorePrompt(false)}} style={{padding:"4px 10px",background:"transparent",border:"1px solid "+C.bd,color:C.td,fontFamily:bf,fontSize:10,cursor:"pointer",borderRadius:0}}>Dismiss</button>
          </div>}
        </div>
        {Object.keys(uploadedData).length > 0 && (
            <div style={{padding:"2px 10px",display:"flex",flexDirection:"column",gap:4}}>
              {Object.entries(uploadedData).map(([sheetName, data]) => (
                <div key={sheetName} style={{display:"flex",alignItems:"center",gap:8}}>
                  <span style={{fontSize:9,color:C.gn}}>
                    ✓ {sheetName} ({Object.keys(data).length} entries)
                  </span>
                </div>
              ))}
            </div>
          )} 
{/* study */}
          {uploadInfo && !uploadInfo.error && (
            <div style={{position:"relative",padding:12,background:C.gn+"12",border:"1px solid "+C.gn+"40",marginTop:6}}>
              <div style={{fontSize:11,fontWeight:700,color:C.gn,marginBottom:6}}>{"✓ Customer Data Loaded"+(uploadInfo.fileCount>1?" -- "+uploadInfo.fileCount+" files combined":" -- "+uploadInfo.file)+(uploadInfo.filtered?" (filtered to "+uploadInfo.filtered+" -- "+(uploadInfo.filteredRows||0).toLocaleString()+" of "+(uploadInfo.totalRows||0).toLocaleString()+" rows)":"  -- "+(uploadInfo.totalRows||0).toLocaleString()+" total rows")}</div>
              {uploadInfo.fileStats&&uploadInfo.fileStats.length>1&&(
                <div style={{marginBottom:6,fontSize:9,color:C.tm}}>{uploadInfo.fileStats.map(function(fs,i){return (i>0?" + ":"")+fs.name+" ("+fs.rows.toLocaleString()+" rows)"}).join("")}</div>
              )}
              <div style={grd(5)}>
                <div><span style={{fontSize:9,color:C.tm}}>PIECES</span><div style={{fontSize:13,fontWeight:700,color:C.tx}}>{(uploadInfo.pieces||0).toLocaleString()}</div>{uploadInfo.filtered&&<div style={{fontSize:8,color:C.yw}}>{"filtered to "+uploadInfo.filtered}</div>}</div>
                <div><span style={{fontSize:9,color:C.tm}}>AVG WEIGHT</span><div style={{fontSize:13,fontWeight:700,color:C.tx}}>{f(uploadInfo.avgW)+"kg"}</div></div>
                {uploadInfo.hasDim&&<div><span style={{fontSize:9,color:C.tm}}>AVG DIM</span><div style={{fontSize:13,fontWeight:700,color:C.tx}}>{f(uploadInfo.avgDim)}</div><div style={{fontSize:8,color:C.td}}>{(uploadInfo.dimCount||0).toLocaleString()+" parcels with DIM data"+(uploadInfo.dimSource?" ("+uploadInfo.dimSource+")":"")}</div><div style={{fontSize:8,color:C.cy}}>{((uploadInfo.dimVolGtCount||0)).toLocaleString()+" volumetric · "+(uploadInfo.dimCount-(uploadInfo.dimVolGtCount||0)).toLocaleString()+" weight-dominant"}</div></div>}
                {!uploadInfo.hasDim&&<div><span style={{fontSize:9,color:C.yw}}>DIM</span><div style={{fontSize:13,fontWeight:700,color:C.yw}}>N/A</div><div style={{fontSize:8,color:C.yw}}>{uploadInfo.detectedCols&&uploadInfo.detectedCols.dim?"Col '"+uploadInfo.detectedCols.dim+"' found but no valid cubic+weight pairs":"No cubic/vol weight column detected"}</div></div>}
                {(uploadInfo.noDimCount>0)&&<div><span style={{fontSize:9,color:C.yw}}>NO DIM DATA</span><div style={{fontSize:13,fontWeight:700,color:C.yw}}>{uploadInfo.noDimPct+"%"}</div><div style={{fontSize:8,color:C.td}}>{(uploadInfo.noDimCount||0).toLocaleString()+" parcels · avg "+f(uploadInfo.noDimAvgWt)+"kg phys"}</div></div>}
                {uploadInfo.hasDisp&&<div><span style={{fontSize:9,color:C.tm}}>POSTCODES</span><div style={{fontSize:13,fontWeight:700,color:C.tx}}>{(uploadInfo.stTotal||0).toLocaleString()+" mapped"}</div></div>}
              </div>
              <div style={{marginTop:8,fontSize:10,color:C.tm}}>
                {uploadInfo.hasDisp&&"✓ State/zone dispersion updated from postcodes  "}
                {"✓ Weight distribution updated  "}
                {uploadInfo.avgW>0&&"✓ Avg weight set to "+f(uploadInfo.avgW)+"kg  "}
                {uploadInfo.hasDim?"✓ DIM set to "+f(uploadInfo.avgDim)+" via "+(uploadInfo.dimSource||"calculated")+" ("+(uploadInfo.dimCount||0).toLocaleString()+" parcels: "+((uploadInfo.dimVolGtCount||0)).toLocaleString()+" volumetric + "+(uploadInfo.dimCount-(uploadInfo.dimVolGtCount||0)).toLocaleString()+" weight-dominant"+(uploadInfo.noDimCount>0?" · "+(uploadInfo.noDimCount||0).toLocaleString()+" with no DIM data":"")+")":"○ DIM unchanged -- "+(uploadInfo.noDimCount>0?(uploadInfo.noDimCount||0).toLocaleString()+" parcels had no cubic weight data":"no cubic weight column detected")}
              </div>
              <div style={{marginTop:6,padding:6,background:C.s2,border:"1px solid "+C.bd,fontSize:9,color:C.tm}}>
                <span style={{fontWeight:600,color:C.ac}}>Columns detected: </span>
                {uploadInfo.detectedCols&&Object.keys(uploadInfo.detectedCols).map(function(k){return k+"->\""+uploadInfo.detectedCols[k]+"\""}).join("  ·  ")}
                {uploadInfo.detectedCols&&!uploadInfo.detectedCols.dim&&<span style={{color:C.yw}}>{" · DIM: not matched"}</span>}
                {uploadInfo.detectedCols&&!uploadInfo.detectedCols.weight&&<span style={{color:C.rd}}>{" · Weight: not matched"}</span>}
                <div style={{marginTop:3,color:C.td}}>All columns in file: {uploadInfo.allCols?uploadInfo.allCols.join(", "):""}</div>
                {uploadInfo.wtSamples&&uploadInfo.wtSamples.length>0&&<div style={{marginTop:3,color:C.tm}}>Weight samples: [{uploadInfo.wtSamples.join(", ")}]</div>}
                {uploadInfo.dimSamples&&uploadInfo.dimSamples.length>0&&<div style={{marginTop:3,color:uploadInfo.hasDim?C.tm:C.yw}}>DIM col samples: [{uploadInfo.dimSamples.join(", ")}]{uploadInfo.dimZeroCount>0&&<span style={{color:C.yw}}>{" · "+(uploadInfo.dimZeroCount||0).toLocaleString()+" zeros"}</span>}{uploadInfo.dimNaNCount>0&&<span style={{color:C.rd}}>{" · "+(uploadInfo.dimNaNCount||0).toLocaleString()+" non-numeric"}</span>}</div>}
              </div>
              <div style={{marginTop:4,fontSize:9,color:C.td}}>{"Annual volume unchanged -- update manually if needed."+(uploadInfo.fileCount>1?" Files: "+uploadInfo.file:"")}</div>
            </div>
          )}
          {uploadInfo && uploadInfo.error && (<span style={{fontSize:10,color:C.rd}}>{uploadInfo.error}</span>)}
        </div>

      
{/* // =================== PM & PMA DESCT CLEARANCE TAB ================== */}

      {(prod==="pm"||prod==="pma") && (
        <div style={{...S.sec,borderColor:C.yw+"40"}}>
          <div style={{...S.st,color:C.yw,borderColor:C.yw+"30",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <span>Destination Clearance (Leg 2)</span>
            {prod==="pma" && <Tog2 v={l2Mode} onChange={sL2Mode} opts={[["standard","Standard"],["granular","Granular"]]} />}
          </div>
          {(prod==="pm"||(prod==="pma"&&l2Mode==="standard")) && (
            <div style={grd(3)}>
              <div style={S.met}>
                <div style={mvS(C.rd)}>{dc(l2Kg)+"/kg"}{daffMode==="inclusive"&&<span style={{fontSize:13,color:C.cy}}>{" + "+dc(DAFF)+"/pc"}</span>}</div>
                <div style={S.ml}>{daffMode==="inclusive"?"Leg 2 Cost/kg + DAFF/pc":"Leg 2 Cost/kg"}</div>
              </div>
              <Mt l="Source" v={dispMode==="standard"?"Standard rate ($1.13/kg)":"Dispersion-weighted (customer)"} c={C.tm} p="" />
              {dispMode==="customer"&&<div style={S.met}><div style={{fontSize:11,color:C.tm}}></div><div style={S.ml}>Port Weights</div></div>}
            </div>
          )}
          {prod==="pma"&&l2Mode==="granular" && (<>
            <div style={{marginBottom:8,display:"flex",gap:12,alignItems:"center"}}>
              <Fl l="Rate Structure"><Tog2 v={l2Str} onChange={sL2Str} opts={[["kgpc","Per KG + Per Piece"],["kgonly","Per KG Only"]]} /></Fl>
              <span style={{fontSize:9,color:pmaWtMode==="vol"?C.cy:C.gn,fontWeight:600,marginTop:12}}>{"Costs on "+(pmaWtMode==="vol"?"VOLUMETRIC":"PHYSICAL")+" weight"}</span>
            </div>
            <div style={grd(4)}>
              <Mt l="CTO Doc Fee" v={f(l2CtoDoc,0)} c={C.tm} p="A$" />
              <Mt l="CTO THK/kg" v={f(l2CtoThk)} c={C.tm} p="A$" />
              <Fl l="Depot ($/pc)"><input style={S.inp} type="number" step=".01" value={l2Depot} onChange={function(e){sL2Depot(+e.target.value||0)}} /></Fl>
              {fscOn && (<Mt l={"Ret FSC "+f(getFSC(l2FuelPrice)*100,1)+"%"} v={"@ $"+f(l2FuelPrice)+"/L"} c={C.yw} p="" />)}
            </div>
            {["AKE","PMC"].map(function(uType){
              var isVol=pmaWtMode==="vol";
              var uData=isVol?(uType==="AKE"?l2g.akeVol:l2g.pmcVol):(uType==="AKE"?l2g.ake:l2g.pmc);
              var physKg=UNIT_KG[uType];var volKg=UNIT_VOL_KG[uType];
              var dispKg=isVol?volKg:physKg;
              return (<div key={uType} style={{marginTop:10}}>
                <div style={{fontSize:10,fontWeight:700,color:C.ac,marginBottom:4}}>{uType+" -- "+(isVol?volKg+"kg vol capacity":physKg+"kg phys capacity")}{isVol&&physKg!==volKg&&<span style={{color:C.td,fontWeight:400}}>{" (phys: "+physKg+"kg)"}</span>}</div>
                <table style={S.tbl}>
                  <thead><tr><th style={S.th}>Port</th><th style={S.thr}>CTO Doc/{(isVol?"vol ":"")+"kg"}</th><th style={S.thr}>CTO THK/kg</th><th style={S.thr}>Retrieval</th>{fscOn&&<th style={S.thr}>+FSC</th>}<th style={S.thr}>Ret/{(isVol?"vol ":"")+"kg"}</th>{l2Str==="kgonly"&&<th style={S.thr}>Depot/kg</th>}<th style={S.thr}>{l2Str==="kgonly"?"Total/kg":"Per KG"}</th></tr></thead>
                  <tbody>{uData.details.map(function(d){return (<tr key={d.port}><td style={{...S.td,fontWeight:600}}>{d.port}</td><td style={S.tdr}>${f(d.docKg,4)}</td><td style={S.tdr}>${f(d.thkKg)}</td><td style={S.tdr}>${f(d.baseRet,0)}</td>{fscOn&&<td style={{...S.tdr,color:C.yw}}>${f(d.ret-d.baseRet,0)}</td>}<td style={S.tdr}>${f(d.retKg,4)}</td>{l2Str==="kgonly"&&<td style={S.tdr}>${f(d.depotKg,4)}</td>}<td style={{...S.tdr,fontWeight:700,color:C.ac}}>${f(l2Str==="kgonly"?d.allInKg:d.coreKg,4)}</td></tr>)})}</tbody>
                </table>
                <div style={{...grd(l2Str==="kgpc"?3:2),marginTop:4}}>
                  <Mt l={"Wtd Avg "+uType+"/"+(isVol?"vol ":"")+"kg"+(l2Str==="kgonly"?" (all-in)":"")} v={f(l2Str==="kgonly"?uData.avgAllInKg:uData.avgCoreKg,4)} c={C.rd} p="A$" />
                  {l2Str==="kgpc" && (<Mt l="+ Per Piece (depot)" v={f(l2g.depotPc)} c={C.rd} p="A$" />)}
                  {l2Str==="kgpc" && daffMode==="inclusive" && (<Mt l="+ DAFF Biosecurity" v={f(DAFF)+"/pc"} c={C.cy} p="A$" />)}
                  <Mt l={fscOn?"Ret FSC @ $"+f(l2FuelPrice)+"/L":"No FSC"} v={fscOn?(l2g.fscPct*100).toFixed(1)+"%":"Off"} c={fscOn?C.yw:C.tm} p="" />
                </div>
              </div>);
            })}
            {l2Str==="kgpc" && (<div style={{marginTop:6,padding:6,fontSize:9.5,color:C.gn,background:C.gb,border:"1px solid "+C.gn+"30"}}>Per KG + Per Piece structure protects depot margin against light freight -- depot cost anchored at ${f(l2Depot)}/piece regardless of parcel weight</div>)}
            {l2Str==="kgonly" && (<div style={{marginTop:6,padding:6,fontSize:9.5,color:C.tm,background:C.s2,border:"1px solid "+C.bd}}>{"Depot $"+f(l2Depot)+"/pc converted to $"+f(l2g.depotKg,4)+"/kg at "+f(avgWt)+"kg avg -- note: margin risk if actual avg weight is lighter"}</div>)}
          </>)}
        </div>
      )}
{/* // =================== PM & PMA DIM IMPACT TAB ================== */}

      {prod==="pm" && pmP && dim && costs && (<>
        <div style={{...S.sec,borderColor:C.cy+"60"}}><div style={{...S.st,color:C.cy,borderColor:C.cy+"40"}}>DIM Impact</div>
          <div style={grd(5)}><Mt l="Cust DIM" v={f(oppDim)} c={dim.imp?C.gn:C.yw} p="" /><Mt l="Lane DIM" v={f(dim.ld)} c={C.tm} p="" /><Mt l="Blended" v={f(dim.blD)} c={dim.imp?C.gn:C.rd} p="" /><Mt l="Change" v={(dim.dimD>=0?"+":"")+f(dim.dimD,3)} c={dim.imp?C.gn:C.rd} p="" /><Mt l="Lane Benefit/Yr" v={"A"+fK(dim.lbY)} c={dim.lbY>=0?C.gn:C.rd} p="" /></div>
          <div style={{marginTop:8,overflowX:"auto"}}><table style={S.tbl}>
            <thead><tr><th style={S.th}>Component</th><th style={S.thr}>KGs/Week</th><th style={S.thr}>DIM Factor</th><th style={S.thr}>Wtd KGs</th><th style={S.thr}>% of Lane</th></tr></thead>
            <tbody>
              {(function(){var oWk=Math.round((vol/52)*avgWt);var totKg=lkw+oWk;var wtdExist=lkw*dim.ld;var wtdNew=oWk*oppDim;var wtdTot=wtdExist+wtdNew;return[
                <tr key="exist"><td style={S.td}>Existing Lane Volume</td><td style={S.tdr}>{(lkw||0).toLocaleString()}</td><td style={S.tdr}>{f(dim.ld)}</td><td style={S.tdr}>{Math.round(wtdExist).toLocaleString()}</td><td style={S.tdr}>{f(totKg>0?lkw/totKg*100:0,1)}%</td></tr>,
                <tr key="new"><td style={{...S.td,color:C.ac}}>+ This Opportunity</td><td style={{...S.tdr,color:C.ac}}>{(oWk||0).toLocaleString()}</td><td style={{...S.tdr,color:C.ac}}>{f(oppDim)}</td><td style={{...S.tdr,color:C.ac}}>{Math.round(wtdNew).toLocaleString()}</td><td style={{...S.tdr,color:C.ac}}>{f(totKg>0?oWk/totKg*100:0,1)}%</td></tr>,
                <tr key="tot" style={{borderTop:"2px solid "+C.cy}}><td style={{...S.td,fontWeight:700,color:C.cy}}>Total (Blended)</td><td style={{...S.tdr,fontWeight:700}}>{(totKg||0).toLocaleString()}</td><td style={{...S.tdr,fontWeight:700,color:C.cy}}>{f(totKg>0?wtdTot/totKg:0)}</td><td style={{...S.tdr,fontWeight:700}}>{Math.round(wtdTot).toLocaleString()}</td><td style={S.tdr}>100%</td></tr>,
                <tr key="impact" style={{borderTop:"1px solid "+C.bd}}><td colSpan={2} style={{...S.td,color:dim.lbY>=0?C.gn:C.rd,fontWeight:600}}>{"DIM "+(dim.dimD>=0?"increase":"decrease")+" of "+f(Math.abs(dim.dimD),3)+" on "+(lkw||0).toLocaleString()+" existing KGs/wk"}</td><td colSpan={3} style={{...S.tdr,color:dim.lbY>=0?C.gn:C.rd,fontWeight:700}}>{"= A"+fK(dim.lbW)+"/wk × 52 = A"+fK(dim.lbY)+"/yr"}</td></tr>
              ]})()}
            </tbody>
          </table></div>
          <div style={{marginTop:4,display:"flex",gap:8,alignItems:"center"}}>
            <Fl l="Lane KGs/Week"><input style={{...S.inp,width:100}} type="number" value={lkw} onChange={function(e){sLkw(+e.target.value||0)}} /></Fl>
            <span style={{fontSize:9,color:C.td,marginTop:12}}>Current weekly KGs on the {origin} trade lane (update from actuals)</span>
          </div>
          {origin==="LHR" && (<div style={{...grd(3),marginTop:8}}><Fl l="DT Rebate (£/kg)"><input style={S.inp} type="number" step=".01" value={dtR} onChange={function(e){sDtR(+e.target.value||0)}} /></Fl><Mt l="Eff AF/phys kg (rebated)" v={f(dim.effL)+" "+dim.ccy+" (was "+f(dim.curEffL)+")"} c={C.gn} p="" /><Mt l="Eff AF/phys kg (AUD)" v={f(dim.effA)+" (was "+f(dim.curEffA)+")"} c={C.gn} p="A$" /></div>)}
          
        </div>

        <div className="sec"><div style={S.st}>{"Per KG Pricing ("+(pmWtBasis==="vol"?"Volumetric":"Physical")+")"}</div>
          <div style={{marginBottom:8,display:"flex",gap:12,alignItems:"center"}}>
            <Tog v={kgMode} onChange={sKgM} />
            <label style={{display:"flex",alignItems:"center",gap:5,cursor:"pointer",fontSize:10.5,color:custFscOn?C.yw:C.tm,padding:"4px 8px",background:custFscOn?C.yb:"transparent",border:"1px solid "+(custFscOn?C.yw+"40":C.bd)}}>
              <input type="checkbox" checked={custFscOn} onChange={function(){sCustFscOn(!custFscOn)}} />
              <span>Customer FSC {custFscOn?dc(pmP.cfA)+pmKgLabel:"off"}</span>
            </label>
            {origin==="LHR"&&pmWtBasis==="vol"&&(<label style={{display:"flex",alignItems:"center",gap:5,cursor:"pointer",fontSize:10.5,color:afCostReduce?C.gn:C.tm,padding:"4px 8px",background:afCostReduce?C.gn+"15":"transparent",border:"1px solid "+(afCostReduce?C.gn+"60":C.bd)}}>
              <input type="checkbox" checked={afCostReduce} onChange={function(){sAfCostReduce(!afCostReduce)}} />
              <span>{afCostReduce?"AF cost -GBP 0.27/kg ✓":"Sim AF cost -GBP 0.27/kg"}</span>
            </label>)}
          </div>
          <div style={grd(5)}>
            <Mt l={"AF"+pmKgLabel} v={dc(pmAfCostAUD)} c={C.tx} p="" />
            <Mt l={"Orig"+pmKgLabel} v={f(costs.opA/pmKgDiv*(fx[afc]||1))+" (A$"+f(costs.opA/pmKgDiv)+")"} c={C.tx} p={afc+" "} />
            <Mt l={daffMode==="inclusive"?"Leg2"+pmKgLabel+" + DAFF/pc":"Leg2"+pmKgLabel} v={f(costs.l2Kg/pmKgDiv*(fx[afc]||1),3)+(daffMode==="inclusive"?" + "+dc(DAFF)+"/pc":"")} c={C.tx} p={afc+" "} />
            <Mt l={"Total Cost"+pmKgLabel} v={f(costs.upKg/pmKgDiv*(fx[afc]||1))+" (A$"+f(costs.upKg/pmKgDiv)+")"} c={C.rd} p={afc+" "} />
            {kgMode==="target"?(<div><Fl l="Target %"><input style={S.inp} type="number" value={kgTgt} onChange={function(e){sKgT(+e.target.value||0)}} /></Fl><div style={{marginTop:4,fontSize:11,color:C.gn,fontWeight:700,textAlign:"center"}}>{"Proposed: "+dc(pmP.volA)+pmKgLabel}</div></div>):(<Fl l={"Rate ("+afc+pmKgLabel+")"}><input style={{...S.inp,fontSize:14,fontWeight:700,textAlign:"center"}} type="number" step=".01" value={mPK} onChange={function(e){sMPK(+e.target.value||0)}} /></Fl>)}
          </div>
          <div style={{...grd(6),marginTop:8}}>
            <Mt l="Base Rate" v={dc(pmP.volA)+pmKgLabel} c={C.ac} p="" />
            {custFscOn && (<Mt l={"+ Customer FSC"} v={dc(pmP.cfA)+pmKgLabel} c={C.yw} p="" />)}
            <Mt l="Total" v={dc(pmP.volA+(pmP.cfA||0))+pmKgLabel} c={C.ac} p="" />
            <Mt l="Eff. Rev/phys kg" v={dc(pmP.effPhysTotal)} c={C.ac} p="" />
            <Mt l="GP/phys kg" v={dc(pmP.kgGP)} c={pmP.kgGP>=0?C.gn:C.rd} p="" />
            <div style={S.met}><div style={mvS(pmP.kgM>=kgTgt?C.gn:pmP.kgM>=0?C.yw:C.rd)}>{f(pmP.kgM,1)}%</div><div style={S.ml}>Per KG Margin</div></div>
          </div>
          <div style={{marginTop:6,padding:6,fontSize:9.5,color:C.tm,background:C.s2,border:"1px solid "+C.bd}}>{pmWtBasis==="vol"?"Customer pays "+dc(pmP.volA)+(custFscOn?" + "+dc(pmP.cfA)+" FSC":"")+" /vol kg":"Customer pays "+dc(pmP.volA)+(custFscOn?" + "+dc(pmP.cfA)+" FSC":"")+" /phys kg"}</div>
        </div>

        <div style={{...S.sec,borderColor:pmCustTgtOn?C.yw+"40":C.bd,background:pmCustTgtOn?C.yw+"05":"transparent",paddingBottom:8}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:pmCustTgtOn?8:0}}>
            <label style={{display:"flex",alignItems:"center",gap:6,cursor:"pointer",fontSize:10.5,color:pmCustTgtOn?C.yw:C.tm}}>
              <input type="checkbox" checked={pmCustTgtOn} onChange={function(){sPmCustTgtOn(!pmCustTgtOn)}} />
              <span style={{fontWeight:700,textTransform:"uppercase",letterSpacing:".05em"}}>Customer Target Rates</span>
            </label>
            {pmCustTgtOn && <span style={{fontSize:9,color:C.yw}}>{"Per-piece delivery targets in "+afc+" by weight band"}</span>}
          </div>
          {pmCustTgtOn && (
            <div style={{overflowX:"auto"}}><table style={S.tbl}>
              <thead><tr><th style={S.th}>Band</th>{PMW.map(function(wb){return (<th key={wb.l} style={S.thr}>{wb.l}</th>)})}</tr></thead>
              <tbody><tr><td style={{...S.td,fontWeight:600,color:C.yw}}>Target/pc</td>{PMW.map(function(_,i){return (<td key={i} style={S.tdr}><input style={{...S.inp,width:55,textAlign:"right",fontSize:10}} type="number" step=".01" value={pmCustTgt[i]||""} onChange={function(e){sPmCustTgt(function(p){var n=[...p];n[i]=+e.target.value||0;return n})}} /></td>)})}</tr></tbody>
            </table></div>
          )}
        </div>

        <div className="sec"><div style={{...S.st,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <span>Per Piece Pricing</span>
          <div style={{display:"flex",gap:6,alignItems:"center"}}>
            {pmRoutingCosts&&Array.isArray(pmRoutingCosts.z1)&&(
              <span style={{fontSize:9,color:"#7C3AED",fontWeight:600}}>
                {pmRoutingCosts.source==='billing'
                  ?"📊 Leg 3 from billing data"+(pmRoutingCosts.dateRange?" ("+pmRoutingCosts.dateRange.min+" – "+pmRoutingCosts.dateRange.max+")":"")
                  :"⬡ Leg 3 from routing file"+(pmRoutingCosts.synced?" ("+new Date(pmRoutingCosts.synced).toLocaleDateString("en-AU")+")":"")}
              </span>
            )}
            {pmBillingData&&(prod==="pm"||prod==="pma")&&(
              <button onClick={syncPmLeg3FromBilling} style={{fontSize:9,padding:"3px 10px",background:C.ac,border:"none",color:"#fff",cursor:"pointer",fontFamily:bf,fontWeight:700}}>{"📊 "+(pmRoutingCosts&&pmRoutingCosts.source==='billing'?"Re-commit Billing Costs":"Commit Billing Costs to Opp")}</button>
            )}

            {pmRoutingCosts&&(
              <button onClick={clearPmRoutingSync} style={{fontSize:9,padding:"3px 8px",background:"transparent",border:"1px solid "+C.rd+"60",color:C.rd,cursor:"pointer",fontFamily:bf}}>Reset to FMC</button>
            )}
            {!pmRouting&&!pmBillingData&&prod==="pm"&&(
              <span style={{fontSize:9,color:C.td}}>Upload routing file or billing data to enable Leg 3 sync</span>
            )}
          </div>
        </div>
          <div style={{marginBottom:8,display:"flex",gap:12,alignItems:"center",flexWrap:"wrap"}}>
            <span style={{fontSize:10,fontWeight:700,color:C.cy}}>Step 1</span>
            <Tog2 v={ppMode} onChange={function(v){sPpM(v);if(v==="meet")sPmCustTgtOn(true)}} opts={[["target","Target %"],["meet","Meet Customer Targets"]]} />
            {ppMode==="target"&&(<Fl l="Target %"><input style={{...S.inp,width:80}} type="number" value={ppTgt} onChange={function(e){sPpT(+e.target.value||0)}} /></Fl>)}
            {ppMode==="meet"&&!pmCustTgtOn&&(<span style={{fontSize:9.5,color:C.rd,fontWeight:600}}>Enable Customer Target Rates above</span>)}
            <Fl l="Zones"><select style={{...S.sel,width:110}} value={pmZones} onChange={function(e){sPmZ(+e.target.value)}}><option value={1}>1 Zone (Flat)</option><option value={3}>3 Zones</option></select></Fl>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:8,flexWrap:"wrap"}}>
            <label style={{display:"flex",alignItems:"center",gap:6,cursor:"pointer",fontSize:10.5,color:ppRefine?C.yw:C.tm}}>
              <input type="checkbox" checked={ppRefine} onChange={function(){sPpRefine(!ppRefine)}} />
              <span style={{fontWeight:700,fontSize:10}}>Step 2 -- Refine Manually</span>
            </label>
            {ppRefine && (<>
              <button onClick={function(){if(pmZones===1){sMPP(pmP.ppBase.map(function(r){return Math.round(r*100)/100}))}else{sMPP3(pmP.pp3Base.map(function(z){return z.map(function(r){return Math.round(r*100)/100})}))}}} style={{fontSize:9,padding:"4px 10px",background:C.ad,color:"#fff",border:"1px solid "+C.ad,cursor:"pointer",fontFamily:bf,borderRadius:0}}>{"Load from "+(ppMode==="meet"?"Customer Targets":"Target %")}</button>
              <button onClick={function(){sMPP(PMW.map(function(){return 0}));sMPP3([1,2,3].map(function(){return PMW.map(function(){return 0})}));sPpExclW({});sPpExclZ({})}} style={{fontSize:9,padding:"4px 10px",background:"transparent",border:"1px solid "+C.rd,color:C.rd,cursor:"pointer",fontFamily:bf,borderRadius:0}}>Reset All Changes</button>
              <span style={{fontSize:9,color:C.yw}}>Edit rates, ✕ to exclude, ↩ to restore</span>
            </>)}
          </div>
          {pmZones===1 && (
            <table style={S.tbl}><thead><tr><th style={S.th}>Band</th>{ppRefine&&<th style={{...S.thr,width:30}}></th>}<th style={S.thr}>Cost</th><th style={S.thr}>Rate</th><th style={S.thr}>GP</th><th style={S.thr}>GP%</th><th style={S.thr}>Mix%</th><th style={S.thr}>Annual GP</th></tr></thead>
              <tbody>{PMW.map(function(wb,i){var fmc=pmP.fmcPlusL2[i];var rate=pmP.pp[i];var excl=!!ppExclW[i];var gp=rate-fmc;var mg=rate>0?(gp/rate)*100:0;var cellColor=excl?C.td:gp>=0?C.gn:C.rd;var isOverride=ppRefine&&mPP[i]>0;var tgt=pmCustTgtOn?pmCustTgt[i]:0;var allIn=tgt>0?toA(tgt,afc,fx):0;var hitTgt=allIn>0&&rate<=allIn;return (<tr key={i} style={{opacity:excl?.4:1}}>
                <td style={{...S.td,textDecoration:excl?"line-through":"none"}}>{wb.l}</td>
                {ppRefine&&<td style={{...S.tdr,padding:2}}><button onClick={function(){sPpExclW(function(p){var n={...p};if(n[i])delete n[i];else n[i]=true;return n})}} style={{fontSize:8,background:"transparent",border:"none",color:excl?C.gn:C.rd,cursor:"pointer",fontFamily:bf}}>{excl?"↩":"✕"}</button></td>}
                <td style={{...S.tdr,color:C.tm}}>{dc(fmc)}</td>
                <td style={S.tdr}>{excl?"--":ppRefine?(<><input style={{...S.inp,width:65,textAlign:"right",fontWeight:isOverride?700:400,color:isOverride?C.yw:C.tx}} type="number" step=".01" value={mPP[i]||""} placeholder={f(pmP.ppBase[i])} onChange={function(e){var n=[...mPP];n[i]=+e.target.value||0;sMPP(n)}} />{tgt>0&&<div style={{fontSize:8,color:hitTgt?C.gn:C.rd}}>{dc(allIn)+(hitTgt?" ✓":" ✗")}</div>}</>):(<><span style={{color:cellColor,fontWeight:600}}>{dc(rate)}</span>{tgt>0&&<div style={{fontSize:8,color:hitTgt?C.gn:C.rd}}>{dc(allIn)+(hitTgt?" ✓":" ✗")}</div>}</>)}</td>
                <td style={{...S.tdr,color:cellColor}}>{excl?"--":dc(gp)}</td>
                <td style={{...S.tdr,color:excl?C.td:mg>=15?C.gn:mg>=0?C.yw:C.rd,fontWeight:600}}>{excl?"--":f(mg,1)+"%"}</td>
                <td style={S.tdr}><input style={{...S.inp,width:50,textAlign:"right"}} type="number" step=".1" value={wDist[i]} onChange={function(e){var n=[...wDist];n[i]=+e.target.value||0;sWD(n)}} /></td>
                <td style={{...S.tdr,color:excl?C.td:gp>=0?C.gn:C.rd,fontWeight:600}}>{excl?"--":fK(gp*vol*wDist[i]/100)}</td>
              </tr>)})}</tbody></table>
          )}
          {pmZones===3 && (<div>{[0,1,2].map(function(zi){var zColor=zi===0?C.ac:zi===1?C.yw:C.rd;var zPct=pmP.zPcts?(pmP.zPcts[zi]*100).toFixed(1)+"%":"";var zExcl=!!ppExclZ[zi];return (<div key={zi} style={{marginBottom:10,opacity:zExcl?.4:1}}><div style={{fontSize:10,fontWeight:700,color:zColor,marginBottom:4}}>{"Zone "+(zi+1)+" "}<span style={{color:C.tm,fontWeight:400}}>({zPct})</span>{ppRefine&&<button onClick={function(){sPpExclZ(function(p){var n={...p};if(n[zi])delete n[zi];else n[zi]=true;return n})}} style={{marginLeft:8,fontSize:8,background:"transparent",border:"none",color:zExcl?C.gn:C.rd,cursor:"pointer",fontFamily:bf}}>{zExcl?"↩ Restore":"✕ Remove"}</button>}</div><table style={S.tbl}><thead><tr><th style={S.th}>Band</th>{ppRefine&&<th style={{...S.thr,width:30}}></th>}<th style={S.thr}>Cost</th><th style={S.thr}>Rate</th><th style={S.thr}>GP</th><th style={S.thr}>GP%</th>{zi===0&&<th style={S.thr}>Mix%</th>}</tr></thead><tbody>{PMW.map(function(wb,wi){var fmc=pmP.fmcByZonePlusL2[zi][wi];var rate=pmP.pp3[zi][wi];var excl=zExcl||!!ppExclW[wi];var gp=rate-fmc;var mg=rate>0?(gp/rate)*100:0;var cellColor=excl?C.td:gp>=0?C.gn:C.rd;var isOverride=ppRefine&&mPP3[zi]&&mPP3[zi][wi]>0;var tgt=pmCustTgtOn?pmCustTgt[wi]:0;var allIn=tgt>0?toA(tgt,afc,fx):0;var hitTgt=allIn>0&&rate<=allIn;return (<tr key={wi} style={{opacity:excl?.4:1}}>
                <td style={{...S.td,textDecoration:excl?"line-through":"none"}}>{wb.l}</td>
                {ppRefine&&<td style={{...S.tdr,padding:2}}><button onClick={function(){sPpExclW(function(p){var n={...p};if(n[wi])delete n[wi];else n[wi]=true;return n})}} style={{fontSize:8,background:"transparent",border:"none",color:excl?C.gn:C.rd,cursor:"pointer",fontFamily:bf}}>{excl?"↩":"✕"}</button></td>}
                <td style={{...S.tdr,color:C.tm}}>{dc(fmc)}</td>
                <td style={S.tdr}>{excl?"--":ppRefine?(<><input style={{...S.inp,width:65,textAlign:"right",fontWeight:isOverride?700:400,color:isOverride?C.yw:C.tx}} type="number" step=".01" value={mPP3[zi]?mPP3[zi][wi]||"":""} placeholder={f(pmP.pp3Base[zi][wi])} onChange={function(e){var n=mPP3.map(function(a){return[...a]});n[zi][wi]=+e.target.value||0;sMPP3(n)}} />{tgt>0&&<div style={{fontSize:8,color:hitTgt?C.gn:C.rd}}>{dc(allIn)+(hitTgt?" ✓":" ✗")}</div>}</>):(<><span style={{color:cellColor,fontWeight:600}}>{dc(rate)}</span>{tgt>0&&<div style={{fontSize:8,color:hitTgt?C.gn:C.rd}}>{dc(allIn)+(hitTgt?" ✓":" ✗")}</div>}</>)}</td>
                <td style={{...S.tdr,color:cellColor}}>{excl?"--":dc(gp)}</td>
                <td style={{...S.tdr,color:excl?C.td:mg>=15?C.gn:mg>=0?C.yw:C.rd,fontWeight:600}}>{excl?"--":f(mg,1)+"%"}</td>
                {zi===0&&<td style={S.tdr}><input style={{...S.inp,width:50,textAlign:"right"}} type="number" step=".1" value={wDist[wi]} onChange={function(e){var n=[...wDist];n[wi]=+e.target.value||0;sWD(n)}} /></td>}
              </tr>)})}</tbody></table></div>)})}</div>)}
          <div style={{...grd(4),marginTop:8}}><Mt l="Avg Rate/pc" v={dc(pmP.avgPP)} c={C.ac} p="" /><Mt l="Blended Delivery Cost" v={dc(pmP.bFMC)} c={C.rd} p="" /><Mt l="GP/pc" v={dc(pmP.ppGP)} c={pmP.ppGP>=0?C.gn:C.rd} p="" /><div style={S.met}><div style={mvS(pmP.ppM>=ppTgt?C.gn:pmP.ppM>=0?C.yw:C.rd)}>{f(pmP.ppM,1)}%</div><div style={S.ml}>Per Piece Margin</div></div></div>
        </div>

        {prod==="pm"&&(
          <div style={{...S.sec,borderColor:C.yw+"40",background:C.yw+"04"}}>
            <div style={{...S.st,color:C.yw,borderColor:C.yw+"30"}}>Existing Volume Rate Impact</div>
            <div style={{fontSize:9,color:C.td,marginBottom:8}}>Use when winning new business triggers a rate change that also applies to existing volume with this customer.</div>
            <div style={{display:"flex",gap:12,flexWrap:"wrap",alignItems:"flex-end",marginBottom:8}}>              <Fl l="Existing KGs/week"><input style={{...S.inp,width:120}} type="number" step="1" value={existingKgWk||""} onChange={function(e){sExistingKgWk(+e.target.value||0)}} placeholder="0" /></Fl>              <Fl l={(afc+" existing rate/kg")}><input style={{...S.inp,width:120}} type="number" step="0.01" value={existingKgRate||""} onChange={function(e){sExistingKgRate(+e.target.value||0)}} placeholder="0.00" /></Fl>              <Fl l={(afc+" new rate/kg (from opp)")}><div style={{...S.inp,width:120,display:"flex",alignItems:"center",color:C.gn,fontWeight:700,fontSize:12}}>{pmP&&pmP.volL>0?f(pmP.volL):"—"}</div></Fl>              {existingKgRate>0&&pmP&&pmP.volL>0&&existingKgRate>pmP.volL&&<div style={{padding:"4px 8px",background:C.s2,border:"1px solid "+C.bd,fontSize:9}}><span style={{color:C.td}}>Reduction: </span><span style={{color:C.gn,fontWeight:700}}>{afc+" "+f(Math.round((existingKgRate-pmP.volL)*100)/100)+"/kg"}</span></div>}              {existingKgWk>0&&existingKgRate>0&&pmP&&pmP.volL>0&&existingKgRate>pmP.volL&&(function(){var delta=Math.round((existingKgRate-(pmP&&pmP.volL||0))*100)/100;                var annL=existingKgWk*52*delta;                var annA=annL/(fx[afc]||1);                return <div style={{padding:"6px 10px",background:C.rd+"15",border:"1px solid "+C.rd+"40"}}>                  <div style={{fontSize:9,fontWeight:700,color:C.rd}}>Annual margin reduction</div>                  <div style={{fontSize:11,fontWeight:700,color:C.rd}}>{afc+" "+f(annL,0)+"  ≈  A"+fK(-annA)}</div>                  <div style={{fontSize:9,color:C.td,marginTop:2}}>{afc+" "+f(existingKgRate)+" → "+f(pmP.volL)+"/kg  ·  "+existingKgWk.toLocaleString()+" KGs/wk × 52"}</div>                </div>;              })()}            </div>          </div>        )}        <div style={{...S.sec,background:"#0d1520",borderColor:C.ac+"40"}}><div style={{...S.st,color:"#fff",borderColor:C.ac+"40"}}>{"Combined Margin (AUD)"}</div>
          <div style={{overflowX:"auto",marginBottom:10}}><table style={{...S.tbl,fontSize:10.5}}>
            <thead><tr><th style={{...S.th,color:C.ac}}>Component</th><th style={{...S.thr,color:C.ac}}>Unit</th><th style={{...S.thr,color:C.ac}}>Revenue (A$)</th><th style={{...S.thr,color:C.ac}}>Cost (A$)</th><th style={{...S.thr,color:C.ac}}>GP (A$)</th><th style={{...S.thr,color:C.ac}}>Margin</th><th style={{...S.thr,color:C.ac}}>Annual GP (A$)</th></tr></thead>
            <tbody>
              {(function(){var kgRpk=pmP.effPhysTotal;var kgCpk=costs.upKg;var kgGPpk=kgRpk-kgCpk;var kgMpk=kgRpk>0?(kgGPpk/kgRpk)*100:0;
                var lcFx=fx[afc]||1;var isLocal=afc!=="AUD";
                var daffInc=daffMode==="inclusive"?DAFF:0;
                var ppR=pmP.avgPP;var ppC=pmP.bFMC+daffInc;var ppGP=ppR-ppC;var ppM=ppR>0?(ppGP/ppR)*100:0;
                var annKg=vol*avgWt;
                var totR=kgRpk*avgWt+ppR;var totC=kgCpk*avgWt+ppC;var totGP=totR-totC;var totM=totR>0?(totGP/totR)*100:0;
                return [
                  <tr key="kg"><td style={S.td}>Per KG Charge{isLocal&&<div style={{fontSize:8,color:C.td}}>{"Customer rate: "+afc+" "+f(kgRpk*lcFx)+"/kg"}</div>}</td><td style={{...S.tdr,fontSize:9,color:C.td}}>/kg</td><td style={{...S.tdr,color:C.ac}}>{"A$"+f(kgRpk)}</td><td style={{...S.tdr,color:C.rd}}>{"A$"+f(kgCpk)}</td><td style={{...S.tdr,color:kgGPpk>=0?C.gn:C.rd,fontWeight:600}}>{"A$"+f(kgGPpk)}</td><td style={{...S.tdr,color:kgMpk>=15?C.gn:kgMpk>=0?C.yw:C.rd}}>{f(kgMpk,1)+"%"}</td><td style={{...S.tdr,color:kgGPpk>=0?C.gn:C.rd}}>{fK(kgGPpk*annKg)}</td></tr>,
                  <tr key="pp"><td style={S.td}>{"Delivery (blended)"+(daffInc>0?" incl. DAFF":"")}</td><td style={{...S.tdr,fontSize:9,color:C.td}}>/pc</td><td style={{...S.tdr,color:C.ac}}>{"A$"+f(ppR)}</td><td style={{...S.tdr,color:C.rd}}>{"A$"+f(ppC)+(daffInc>0?" *":"")}</td><td style={{...S.tdr,color:ppGP>=0?C.gn:C.rd,fontWeight:600}}>{"A$"+f(ppGP)}</td><td style={{...S.tdr,color:ppM>=15?C.gn:ppM>=0?C.yw:C.rd}}>{f(ppM,1)+"%"}</td><td style={{...S.tdr,color:ppGP>=0?C.gn:C.rd}}>{fK(ppGP*vol)}</td></tr>,
                  <tr key="tot" style={{borderTop:"2px solid "+C.ac}}><td style={{...S.td,fontWeight:700,color:C.ac}}>TOTAL</td><td style={{...S.tdr,fontSize:9,color:C.td}}>/pc</td><td style={{...S.tdr,color:C.ac,fontWeight:700}}>{"A$"+f(totR)}</td><td style={{...S.tdr,color:C.rd,fontWeight:700}}>{"A$"+f(totC)}</td><td style={{...S.tdr,color:totGP>=0?C.gn:C.rd,fontWeight:700}}>{"A$"+f(totGP)}</td><td style={{...S.tdr,color:totM>=15?C.gn:totM>=0?C.yw:C.rd,fontWeight:700}}>{f(totM,1)+"%"}</td><td style={{...S.tdr,color:totGP>=0?C.gn:C.rd,fontWeight:700}}>{fK(totGP*vol)}</td></tr>,

                  dim.lbY!==0&&<tr key="dim"><td style={{...S.td,color:C.yw}}>{"Lane DIM "+(dim.lbY>=0?"Benefit":"Cost")}</td><td style={S.tdr}></td><td style={S.tdr}></td><td style={S.tdr}></td><td style={S.tdr}></td><td style={S.tdr}></td><td style={{...S.tdr,color:dim.lbY>=0?C.gn:C.rd,fontWeight:600}}>{(dim.lbY>=0?"+":"")+ fK(dim.lbY)}</td></tr>,
                  existingKgWk>0&&existingKgRate>0&&pmP&&pmP.volL>0&&existingKgRate>pmP.volL&&(function(){var annImpA=-(existingKgWk*52*(pmP&&pmP.volL>0&&existingKgRate>pmP.volL?Math.round((existingKgRate-pmP.volL)*100)/100:0)/(fx[afc]||1));return <tr key="exrate"><td style={{...S.td,color:C.rd}}>{"Existing Vol Rate Reduction"}<div style={{fontSize:8,color:C.td}}>{afc+" "+f(existingKgRate)+" → "+f(pmP.volL)+"/kg  ·  "+existingKgWk.toLocaleString()+" KGs/wk × 52"}</div></td><td style={S.tdr}></td><td style={S.tdr}></td><td style={S.tdr}></td><td style={S.tdr}></td><td style={S.tdr}></td><td style={{...S.tdr,color:C.rd,fontWeight:600}}>{fK(annImpA)}</td></tr>})(),
                  <tr key="net" style={{borderTop:"1px solid "+C.ac+"60"}}><td style={{...S.td,fontWeight:700,color:"#fff"}}>NET ANNUAL</td><td style={S.tdr}></td><td style={S.tdr}></td><td style={S.tdr}></td><td style={S.tdr}></td><td style={S.tdr}></td><td style={{...S.tdr,color:(totGP*vol+dim.lbY-(existingKgWk>0&&existingKgRate>0&&pmP&&pmP.volL>0&&existingKgRate>pmP.volL?existingKgWk*52*(pmP&&pmP.volL>0&&existingKgRate>pmP.volL?Math.round((existingKgRate-pmP.volL)*100)/100:0)/(fx[afc]||1):0))>=0?C.gn:C.rd,fontWeight:700,fontSize:13}}>{fK(totGP*vol+dim.lbY-(existingKgWk>0&&existingKgRate>0&&pmP&&pmP.volL>0&&existingKgRate>pmP.volL?existingKgWk*52*(pmP&&pmP.volL>0&&existingKgRate>pmP.volL?Math.round((existingKgRate-pmP.volL)*100)/100:0)/(fx[afc]||1):0))}</td></tr>
                ]})()}
            </tbody>
          </table></div>
          <div style={grd(4)}>
            {(function(){var kgRpk=pmP.effPhysTotal;var kgCpk=costs.upKg;var daffInc=daffMode==="inclusive"?DAFF:0;
              var ppR=pmP.avgPP;var ppC=pmP.bFMC+daffInc;
              var totR=kgRpk*avgWt+ppR;var totC=kgCpk*avgWt+ppC;var totGP=totR-totC;
              var oppGP=totGP*vol;var oppRev=totR*vol;
              var oppM=oppRev>0?(oppGP/oppRev)*100:0;
              var rateRedA=existingKgWk>0&&existingKgRate>0&&pmP&&pmP.volL>0&&existingKgRate>pmP.volL?existingKgWk*52*(pmP&&pmP.volL>0&&existingKgRate>pmP.volL?Math.round((existingKgRate-pmP.volL)*100)/100:0)/(fx[afc]||1):0;
              var netGP=oppGP+(dim.lbY||0)-rateRedA;var netRev=oppRev;
              var netM=netRev>0?(netGP/netRev)*100:0;
              return [
                <div key="om" style={S.met}><div style={mvS(oppM>=15?C.gn:oppM>=0?C.yw:C.rd)}>{f(oppM,1)}%</div><div style={S.ml}>Opp Margin</div></div>,
                <div key="nm" style={S.met}><div style={mvS(netM>=15?C.gn:netM>=0?C.yw:C.rd)}>{f(netM,1)}%</div><div style={S.ml}>Net Margin (incl DIM)</div></div>,
                <Mt key="r" l="Annual Revenue (AUD)" v={"A"+fK(netRev)} c={C.ac} p="" />,
                <Mt key="g" l="Annual GP Net (AUD)" v={"A"+fK(netGP)} c={netGP>=0?C.gn:C.rd} p="" />
              ]})()}
          </div>
        </div>
      </>)}
{/* // =================== PMA PER KG PRICING TAB ================== */}

      {prod==="pma" && pma && (<>
        <div className="sec">
          <div style={S.st}>{"Per KG -- Customs Clearance ("+(pmaWtMode==="vol"?"Volumetric":"Physical")+")"}</div>
            
            <div style={{marginBottom:8,display:"flex",gap:12,alignItems:"center",flexWrap:"wrap"}}>
              
              {/* ========= Target Manual Meet Customer =========  */}
              <Tog2 v={pmaKgMode} onChange={sPmaKgM} opts={[["target","Target"],["manual","Manual"],["meet","Meet Customer"]]} />
              
                {/* ========= Meet Customer =========  */}
                {pmaKgMode==="meet"&&(
                  <div style={{display:"flex",alignItems:"center",gap:4}}>
                    <span style={{fontSize:10,color:C.yw}}>Customer Rate:</span>
                    <input style={{...S.inp,width:80,textAlign:"right",fontWeight:700,color:C.yw}} type="number" step=".01" value={pmaKgTgt||""} onChange={function(e){sPmaKgTgt(+e.target.value||0)}} />
                    <span style={{fontSize:9,color:C.yw}}>{pmaCcy==="local"?pmaAfc:"AUD"}{pmaWtMode==="vol"?"/vol kg":"/kg"}</span>
                  </div>
                )}

                <label style={{display:"flex",alignItems:"center",gap:5,cursor:"pointer",fontSize:10.5,color:pmaCFsc?C.yw:C.tm,padding:"4px 8px",background:pmaCFsc?C.yb:"transparent",border:"1px solid "+(pmaCFsc?C.yw+"40":C.bd)}}>
                  <input type="checkbox" checked={pmaCFsc} onChange={function(){sPmaCFsc(!pmaCFsc)}} />
                  <span>Customer FSC</span>
                </label>
                
                {/* ========= Customer FSC TRUE =========  */}
                {pmaCFsc && (
                  <div style={{display:"flex",alignItems:"center",gap:4}}>
                    <input style={{...S.inp,width:70,textAlign:"right"}} type="number" step=".01" value={pmaCFscRate} onChange={function(e){sPmaCFscRate(+e.target.value||0)}} />
                    <span style={{fontSize:10,color:C.yw}}>{pmaCcy==="local"?pmaAfc:"AUD"}{pmaWtMode==="vol"?"/vol kg":"/kg"}</span>
                  </div>
                )}
            </div>

              {pma.isGranular && pma.portGranular ? (
                <div>
                {/* ========= Target =========  */}
                  {pmaKgMode==="target"&&(
                    <div style={{display:"flex",gap:12,marginBottom:8,alignItems:"center"}}>
                      <Fl l="Target %">
                        <input style={{...S.inp,width:60}} type="number" value={pmaKT} onChange={function(e){sPmaKT(+e.target.value||0)}} />
                        </Fl>
                    </div>
                  )}
                  <div style={{overflowX:"auto"}}>
                    <table style={S.tbl}>
                    <thead>
                      <tr>
                        <th style={S.th}>Port</th><th style={S.th}>Unit</th>
                        <th style={S.thr}>Cost/kg</th>
                        {pmaKgMode==="manual"&&
                        <th style={S.thr}>Rate/kg</th>}
                        <th style={S.thr}>{pmaKgMode==="meet"?"Customer Rate":"Proposed/kg"}</th>
                        <th style={S.thr}>GP/kg</th>
                        <th style={S.thr}>Margin</th>
                      </tr>
                    </thead>
                    <tbody>{pma.portGranular.map(function(pg){
                      return [
                        <tr key={pg.port+"_AKE"}>
                          <td style={{...S.td,fontWeight:700}} rowSpan={2}>{pg.port}</td>
                          <td style={{...S.td,fontSize:10}}>AKE <span style={{fontSize:8,color:C.td}}>{(pmaWtMode==="vol"?UNIT_VOL_KG.AKE:UNIT_KG.AKE)+"kg"+(pmaWtMode==="vol"?" vol":" phys")}</span></td>
                          <td style={{...S.tdr,color:C.rd}}>{dc(pg.akeCost)}</td>
                          {pmaKgMode==="manual"&&<td style={S.tdr}><input style={{...S.inp,width:65,textAlign:"right",fontSize:11,fontWeight:700}} type="number" step=".01" value={pmaGranR[pg.port+"_AKE"]||""} onChange={function(e){sPmaGranR(function(p){return{...p,[pg.port+"_AKE"]:+e.target.value||0}})}} /></td>}
                          <td style={{...S.tdr,color:pmaKgMode==="meet"?C.yw:C.gn,fontWeight:700}}>{dc(pg.ake.rateA)}</td>
                          <td style={{...S.tdr,color:pg.ake.kgGP>=0?C.gn:C.rd}}>{dc(pg.ake.kgGP)}</td>
                          <td style={S.tdr}><Mb m={pg.ake.kgM} t={pmaKT} /></td>
                        </tr>,
                        <tr key={pg.port+"_PMC"} style={{borderTop:"1px dashed "+C.bd}}>
                          <td style={{...S.td,fontSize:10}}>PMC <span style={{fontSize:8,color:C.td}}>{(pmaWtMode==="vol"?UNIT_VOL_KG.PMC:UNIT_KG.PMC)+"kg"+(pmaWtMode==="vol"?" vol":" phys")}</span></td>
                          <td style={{...S.tdr,color:C.rd}}>{dc(pg.pmcCost)}</td>
                          {pmaKgMode==="manual"&&<td style={S.tdr}><input style={{...S.inp,width:65,textAlign:"right",fontSize:11,fontWeight:700}} type="number" step=".01" value={pmaGranR[pg.port+"_PMC"]||""} onChange={function(e){sPmaGranR(function(p){return{...p,[pg.port+"_PMC"]:+e.target.value||0}})}} /></td>}
                          <td style={{...S.tdr,color:pmaKgMode==="meet"?C.yw:C.gn,fontWeight:700}}>{dc(pg.pmc.rateA)}</td>
                          <td style={{...S.tdr,color:pg.pmc.kgGP>=0?C.gn:C.rd}}>{dc(pg.pmc.kgGP)}</td>
                          <td style={S.tdr}><Mb m={pg.pmc.kgM} t={pmaKT} /></td>
                        </tr>
                      ];
                    })}</tbody>
                  </table>
                </div>

                  {pma.hasL2Pc && (
                    <div style={{...grd(daffMode==="inclusive"?4:3),marginTop:8}}>
                      <div style={S.met}>
                        <div style={mvS(C.rd)}>{dc(pma.l2p)+"/pc"}</div>
                        <div style={S.ml}>Depot Cost/pc</div>
                      </div>
                      {daffMode==="inclusive"&&(
                        <div style={S.met}>
                          <div style={mvS(C.cy)}>{"A$"+f(DAFF)+"/pc"}</div>
                          <div style={S.ml}>DAFF Biosecurity</div>
                        </div>
                      )}

                      {pmaKgMode==="target"?(
                        <div style={S.met}>
                          <div style={mvS(C.gn)}>{dc(pma.l2PcRate)+"/pc"}</div>
                          <div style={S.ml}>{"Proposed/pc ("+f(pma.l2PcM,1)+"%)"}</div>
                        </div>
                        ):(
                        <Fl l="Rate/pc (AUD)">
                          <input style={{...S.inp,fontSize:14,fontWeight:700,textAlign:"center"}} type="number" step=".01" value={pmaMPPL2} onChange={function(e){sPmaMPPL2(+e.target.value||0)}} />
                        </Fl>)}
                      {pmaCFsc && (
                        <Mt l={"+ Customer FSC"} v={f(pma.cfL)+(pmaWtMode==="vol"?"/vol kg":"/kg")} c={C.yw} p="" />)}
                    </div>
                  )}
                </div>
              ) : 
              (
                <div style={grd(pma.hasL2Pc?5:4)}>
                <Mt l={daffMode==="inclusive"?"Clearance + DAFF":"Clearance Cost"} v={f(pmaCcy==="local"?pma.clC*pmaFxR:pma.clC)+(daffMode==="inclusive"?"/kg + $0.37/pc":"")+" (A$"+f(pma.clC)+(daffMode==="inclusive"?"/kg)":")")} c={C.rd} p="" />
                
                {pmaKgMode==="target"?(
                  <div>
                    <Fl l="Target %">
                      <input style={S.inp} type="number" value={pmaKT} onChange={function(e){sPmaKT(+e.target.value||0)}} />
                    </Fl>
                    <div style={{marginTop:4,fontSize:11,color:C.gn,fontWeight:700,textAlign:"center"}}>{"Proposed: "+dc(pma.rateA)+(pmaWtMode==="vol"?"/vol kg":"/kg")}</div>
                  </div>):
                pmaKgMode==="meet"?(
                  <div style={S.met}>
                    <div style={mvS(C.yw)}>{dc(pma.rateA)+(pmaWtMode==="vol"?"/vol kg":"/kg")}</div>
                    <div style={S.ml}>{"Meeting customer @ "+f(pma.kgM,1)+"%"}</div>
                  </div>):(
                    <Fl l={(pmaWtMode==="vol"?"Vol Rate":"Rate")+" ("+(pmaCcy==="local"?pmaAfc:"AUD")+"/kg)"}>
                      <input style={{...S.inp,fontSize:14,fontWeight:700,textAlign:"center"}} type="number" step=".01" value={pmaMPK} onChange={function(e){sPmaMPK(+e.target.value||0)}} />
                    </Fl>
                  )}

                {pma.hasL2Pc && (<>
                  <div style={S.met}>
                    <div style={mvS(C.rd)}>{dc(pma.l2p)+"/pc"}</div>
                    <div style={S.ml}>Depot Cost/pc</div>
                  </div>
                {pmaKgMode==="target"?(
                  <div style={S.met}
                  ><div style={mvS(C.gn)}>{dc(pma.l2PcRate)+"/pc"}</div>
                  <div style={S.ml}>{"Proposed/pc ("+f(pma.l2PcM,1)+"%)"}</div>
                  </div>):(
                    <Fl l="Rate/pc (AUD)">
                    <input style={{...S.inp,fontSize:14,fontWeight:700,textAlign:"center"}} type="number" step=".01" value={pmaMPPL2} onChange={function(e){sPmaMPPL2(+e.target.value||0)}} />
                    </Fl>)}
                </>)}

                {pmaCFsc && (
                  <Mt l={"+ Customer FSC"} v={f(pma.cfL)+(pmaWtMode==="vol"?"/vol kg":"/kg")} c={C.yw} p="" />)}
                  <Mt l="GP/phys kg" v={dc(pma.kgGP)+" ("+f(pma.kgM,1)+"%)"} c={pma.kgGP>=0?C.gn:C.rd} p="" />
              </div>
              )
              }
          {/* ================ Leg 2 Margin Analysis ================*/}
          {pma.isGranular && pma.portGranular && pma.portGranular.length>0 && (
            <div style={{marginTop:8}}>
              <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:6}}>
                <span style={{fontSize:10,fontWeight:700,color:C.cy}}>Leg 2 Margin Analysis</span>
                <div style={{display:"flex",alignItems:"center",gap:4}}>
                  <span style={{fontSize:9.5,color:C.tm}}>AKE %</span>
                  <input style={{...S.inp,width:50,textAlign:"right",fontSize:10.5}} type="number" min="0" max="100" value={l2AkePct} onChange={function(e){sL2AkePct(Math.min(100,Math.max(0,+e.target.value||0)))}} />
                  <span style={{fontSize:9.5,color:C.tm}}>PMC %</span>
                  <span style={{fontSize:10.5,fontWeight:600,color:C.ac}}>{100-l2AkePct}</span>
                </div>
              </div>
              <div style={{overflowX:"auto"}}><table style={{...S.tbl,fontSize:10.5}}>
              <thead><tr><th style={{...S.th,color:C.cy}}>Leg 2 Component</th><th style={{...S.thr,color:C.cy}}>Unit</th><th style={{...S.thr,color:C.cy}}>Mix</th><th style={{...S.thr,color:C.cy}}>KGs/wk</th><th style={{...S.thr,color:C.cy}}>Cost (A$)</th><th style={{...S.thr,color:C.cy}}>Rate (A$)</th><th style={{...S.thr,color:C.cy}}>GP (A$)</th><th style={{...S.thr,color:C.cy}}>Margin</th><th style={{...S.thr,color:C.cy}}>Annual GP</th></tr></thead>
              <tbody>
                {(function(){
                  var rows=[];var ap=l2AkePct/100;var pp=1-ap;
                  // Build dynamic port→states map (handles inactive ports — reroutes their states)
                  var stToPortDef={NSW:"SYD",ACT:"SYD",VIC:"MEL",TAS:"MEL",QLD:"BNE",NT:"BNE",SA:"MEL",WA:"PER"};
                  var activePorts1=Object.keys(pmaInj).filter(function(p){return pmaInj[p]});
                  function actualPort1(st){var pref=stToPortDef[st];if(activePorts1.indexOf(pref)>=0)return pref;
                    // Fallback chain: prefer geographically closest active port
                    var fallback={QLD:["SYD","BNE","MEL","PER"],NT:["BNE","SYD","MEL","PER"],ACT:["SYD","MEL","BNE","PER"],TAS:["MEL","SYD","BNE","PER"],SA:["MEL","SYD","BNE","PER"],WA:["PER","MEL","SYD","BNE"],NSW:["SYD","MEL","BNE","PER"],VIC:["MEL","SYD","BNE","PER"]}[st]||["SYD","MEL","BNE","PER"];
                    for(var i=0;i<fallback.length;i++){if(activePorts1.indexOf(fallback[i])>=0)return fallback[i];}
                    return activePorts1[0];}
                  var portStMap={MEL:[],SYD:[],BNE:[],PER:[]};
                  Object.keys(stToPortDef).forEach(function(st){var p=actualPort1(st);if(p&&portStMap[p])portStMap[p].push(st);});
                  pma.portGranular.forEach(function(pg){
                    // Compute KGs/week for this port based on state dispersion
                    var portPct=0;(portStMap[pg.port]||[]).forEach(function(st){var ds=aDisp[st];if(ds&&ds.pct>0)portPct+=ds.pct});
                    var portKgWk=Math.round(vol/52*portPct/100*avgWt);
                    var akeGP=pg.ake.rateA-pg.akeCost;var akeMg=pg.ake.rateA>0?(akeGP/pg.ake.rateA)*100:0;
                    var pmcGP=pg.pmc.rateA-pg.pmcCost;var pmcMg=pg.pmc.rateA>0?(pmcGP/pg.pmc.rateA)*100:0;
                    var portVol=vol*portPct/100;var akeAnn=akeGP*avgWt*portVol*ap;var pmcAnn=pmcGP*avgWt*portVol*pp;
                    rows.push(<tr key={pg.port+"_ake"} style={{opacity:ap===0?.4:1}}><td style={S.td}>{pg.port+" AKE"}</td><td style={{...S.tdr,fontSize:9,color:C.td}}>{pmaWtMode==="vol"?"/vol kg":"/kg"}</td><td style={{...S.tdr,fontSize:9,color:C.ac}}>{l2AkePct+"%"}</td><td style={{...S.tdr,fontSize:9,color:C.td}}>{ap>0?(Math.round(portKgWk*ap)).toLocaleString():"-"}</td><td style={{...S.tdr,color:C.rd}}>{"A$"+f(pg.akeCost)}</td><td style={{...S.tdr,color:C.ac}}>{"A$"+f(pg.ake.rateA)}</td><td style={{...S.tdr,color:akeGP>=0?C.gn:C.rd,fontWeight:600}}>{"A$"+f(akeGP)}</td><td style={{...S.tdr,color:akeMg>=15?C.gn:akeMg>=0?C.yw:C.rd}}>{f(akeMg,1)+"%"}</td><td style={{...S.tdr,color:akeAnn>=0?C.gn:C.rd}}>{fK(akeAnn)}</td></tr>);
                    rows.push(<tr key={pg.port+"_pmc"} style={{opacity:pp===0?.4:1}}><td style={S.td}>{pg.port+" PMC"}</td><td style={{...S.tdr,fontSize:9,color:C.td}}>{pmaWtMode==="vol"?"/vol kg":"/kg"}</td><td style={{...S.tdr,fontSize:9,color:C.ac}}>{(100-l2AkePct)+"%"}</td><td style={{...S.tdr,fontSize:9,color:C.td}}>{pp>0?(Math.round(portKgWk*pp)).toLocaleString():"-"}</td><td style={{...S.tdr,color:C.rd}}>{"A$"+f(pg.pmcCost)}</td><td style={{...S.tdr,color:C.ac}}>{"A$"+f(pg.pmc.rateA)}</td><td style={{...S.tdr,color:pmcGP>=0?C.gn:C.rd,fontWeight:600}}>{"A$"+f(pmcGP)}</td><td style={{...S.tdr,color:pmcMg>=15?C.gn:pmcMg>=0?C.yw:C.rd}}>{f(pmcMg,1)+"%"}</td><td style={{...S.tdr,color:pmcAnn>=0?C.gn:C.rd}}>{fK(pmcAnn)}</td></tr>);
                    var blC=pg.akeCost*ap+pg.pmcCost*pp;var blR=pg.ake.rateA*ap+pg.pmc.rateA*pp;var blGP=blR-blC;var blMg=blR>0?(blGP/blR)*100:0;var blAnn=akeAnn+pmcAnn;
                    rows.push(<tr key={pg.port+"_blend"} style={{borderTop:"1px solid "+C.cy+"40",background:C.cy+"08"}}><td style={{...S.td,fontWeight:600,color:C.cy}}>{pg.port+" Blended KG"}</td><td style={{...S.tdr,fontSize:9,color:C.td}}>{pmaWtMode==="vol"?"/vol kg":"/kg"}</td><td style={{...S.tdr,fontSize:9,color:C.cy}}>{"100%"}</td><td style={{...S.tdr,fontSize:9,fontWeight:600,color:C.cy}}>{portKgWk.toLocaleString()}</td><td style={{...S.tdr,color:C.rd,fontWeight:600}}>{"A$"+f(blC)}</td><td style={{...S.tdr,color:C.ac,fontWeight:600}}>{"A$"+f(blR)}</td><td style={{...S.tdr,color:blGP>=0?C.gn:C.rd,fontWeight:700}}>{"A$"+f(blGP)}</td><td style={{...S.tdr,color:blMg>=15?C.gn:blMg>=0?C.yw:C.rd,fontWeight:600}}>{f(blMg,1)+"%"}</td><td style={{...S.tdr,color:blAnn>=0?C.gn:C.rd,fontWeight:700}}>{fK(blAnn)}</td></tr>);
                  });
                  if(pma.hasL2Pc){
                    var daffIncL2=daffMode==="inclusive"?DAFF:0;
                    var dpGP=pma.l2PcRate-pma.l2p;var dpMg=pma.l2PcRate>0?(dpGP/pma.l2PcRate)*100:0;var dpAnn=dpGP*vol;
                    rows.push(<tr key="depot"><td style={S.td}>Depot</td><td style={{...S.tdr,fontSize:9,color:C.td}}>/pc</td><td style={S.tdr}></td><td style={S.tdr}></td><td style={{...S.tdr,color:C.rd}}>{"A$"+f(pma.l2p)}</td><td style={{...S.tdr,color:C.ac}}>{"A$"+f(pma.l2PcRate)}</td><td style={{...S.tdr,color:dpGP>=0?C.gn:C.rd,fontWeight:600}}>{"A$"+f(dpGP)}</td><td style={{...S.tdr,color:dpMg>=0?C.gn:C.rd}}>{f(dpMg,1)+"%"}</td><td style={{...S.tdr,color:dpAnn>=0?C.gn:C.rd}}>{fK(dpAnn)}</td></tr>);
                    if(daffIncL2>0){rows.push(<tr key="daff_incl"><td style={S.td}>DAFF Biosecurity<div style={{fontSize:8,color:C.td}}>Govt pass-through</div></td><td style={{...S.tdr,fontSize:9,color:C.td}}>/pc</td><td style={S.tdr}></td><td style={S.tdr}></td><td style={{...S.tdr,color:C.cy}}>{"A$"+f(DAFF)}</td><td style={{...S.tdr,color:C.cy}}>{"A$"+f(DAFF)}</td><td style={{...S.tdr,color:C.tm}}>{"A$0.00"}</td><td style={{...S.tdr,color:C.tm}}>{"0.0%"}</td><td style={{...S.tdr,color:C.tm}}>{fK(0)}</td></tr>)}
                  }
                  var daffC=daffMode==="inclusive"?DAFF:0;var daffR=daffMode==="passthrough"?DAFF:0;
                  if(daffMode==="passthrough"){
                    rows.push(<tr key="daff"><td style={S.td}>DAFF Biosecurity</td><td style={{...S.tdr,fontSize:9,color:C.td}}>/pc</td><td style={S.tdr}></td><td style={S.tdr}></td><td style={{...S.tdr,color:C.td}}>{"A$0.00"}</td><td style={{...S.tdr,color:C.ac}}>{"A$"+f(DAFF)}</td><td style={{...S.tdr,color:C.td}}>{"A$0.00"}</td><td style={{...S.tdr,color:C.td,fontSize:9}}>passthrough</td><td style={{...S.tdr,color:C.td}}>{"$0"}</td></tr>);
                  }
                  // Total per piece using blended KG
                  var blKgC=0,blKgR=0;
                  pma.portGranular.forEach(function(pg){blKgC+=pg.akeCost*ap+pg.pmcCost*pp;blKgR+=pg.ake.rateA*ap+pg.pmc.rateA*pp});
                  if(pma.portGranular.length>1){blKgC/=pma.portGranular.length;blKgR/=pma.portGranular.length}
                  var totC=blKgC*avgWt+(pma.hasL2Pc?pma.l2p:0)+daffC;
                  var totR=blKgR*avgWt+(pma.hasL2Pc?pma.l2PcRate:0)+daffR;
                  var totGP=totR-totC;var totMg=totR>0?(totGP/totR)*100:0;
                  

                  // Total row - only show Annual GP
                  var totAnn=0;
                  pma.portGranular.forEach(function(pg){
                    var akeGPv=pg.ake.rateA-pg.akeCost;var pmcGPv=pg.pmc.rateA-pg.pmcCost;
                    var pPctTot=0;(portStMap[pg.port]||[]).forEach(function(st){var ds=aDisp[st];if(ds&&ds.pct>0)pPctTot+=ds.pct});
                    var portVolTot=vol*pPctTot/100;
                    totAnn+=(akeGPv*avgWt*portVolTot*ap)+(pmcGPv*avgWt*portVolTot*pp);
                  });
                  if(pma.hasL2Pc){var daffIncTot=daffMode==="inclusive"?DAFF:0;totAnn+=(pma.l2PcRate-(pma.l2p+daffIncTot))*vol}
                  var totalKgWk=Math.round(vol/52*avgWt);rows.push(<tr key="total" style={{borderTop:"2px solid "+C.cy}}><td style={{...S.td,fontWeight:700,color:C.cy}}>TOTAL LEG 2</td><td style={S.tdr}></td><td style={S.tdr}></td><td style={{...S.tdr,fontWeight:700,color:C.cy}}>{totalKgWk.toLocaleString()}</td><td style={S.tdr}></td><td style={S.tdr}></td><td style={S.tdr}></td><td style={S.tdr}></td><td style={{...S.tdr,color:totAnn>=0?C.gn:C.rd,fontWeight:700,fontSize:12}}>{"A"+fK(totAnn)}</td></tr>);
                  return rows;
                })()}
              </tbody>
            </table></div></div>
          )}
        </div>

        {prod==="pma" && (
        <div style={{...S.sec,borderColor:custTgtOn?C.yw+"40":C.bd,background:custTgtOn?C.yw+"05":"transparent",paddingBottom:8}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:custTgtOn?8:0}}>
            <label style={{display:"flex",alignItems:"center",gap:6,cursor:"pointer",fontSize:10.5,color:custTgtOn?C.yw:C.tm}}>
              <input type="checkbox" checked={custTgtOn} onChange={function(){sCustTgtOn(!custTgtOn)}} />
              <span style={{fontWeight:700,textTransform:"uppercase",letterSpacing:".05em"}}>Customer Target Rates</span>
            </label>
            {custTgtOn && <span style={{fontSize:9,color:C.yw}}>{"Per-piece delivery targets in "+(pmaCcy==="local"?pmaAfc:"AUD")+" (Metro / Rural)"}</span>}
            {custTgtOn && (
              <div style={{display:"flex",alignItems:"center",gap:6,marginLeft:"auto"}}>
                <span style={{fontSize:9,color:C.td}}>Delivery FSC:</span>
                <input style={{...S.inp,width:55,textAlign:"right"}} type="number" step=".1" min="0" value={pmaPpFscPct} onChange={function(e){sPmaPpFscPct(+e.target.value||0)}} />
                <span style={{fontSize:9,color:pmaPpFscPct>0?C.yw:C.td}}>%{pmaPpFscPct>0?" (rates shown incl. FSC)":""}</span>
              </div>
            )}
          </div>
          {custTgtOn && (
            <div style={{overflowX:"auto"}}><table style={S.tbl}>
              <thead><tr><th style={S.th}>Zone</th>{PMAWL.map(function(l){return (<th key={l} style={S.thr}>{l}kg</th>)})}</tr></thead>
              <tbody>
                {(function(){
                  // If pmaPpRefine is on and we have per-zone rates, show one row per zone
                  // For SF (Evri): always use hardcoded customer targets (never corrupt)
                  var isSFEvri=(cust&&cust.indexOf("SF (Evri)")>=0);
                  var tgtSrc=isSFEvri?SF_EVRI_TGT:pmaPpR;
                  var zoneKeys=Object.keys(tgtSrc).filter(function(k){return tgtSrc[k]&&tgtSrc[k].some(function(v){return v>0})});
                  if(pmaPpRefine&&zoneKeys.length>0){
                    return zoneKeys.map(function(zk){
                      var label=zk; // e.g. "VIC-Z1"
                      return <tr key={zk}><td style={{...S.td,fontWeight:600,color:C.gn,whiteSpace:"nowrap"}}>{label}</td>{PMAW.map(function(_,i){
                        var baseV=tgtSrc[zk][i]||0;
                        var dispV=baseV>0&&pmaPpFscPct>0?Math.round(baseV*(1+pmaPpFscPct/100)*100)/100:baseV;
                        return (<td key={i} style={{...S.tdr}}>
                          <div style={{fontSize:10,fontWeight:700,color:pmaPpFscPct>0&&baseV>0?C.yw:baseV>0?C.tx:C.td}}>{dispV>0?"$"+f(dispV):""}</div>
                          {pmaPpFscPct>0&&baseV>0&&<div style={{fontSize:8,color:C.td}}>{"base $"+f(baseV)}</div>}
                        </td>);
                      })}</tr>;
                    });
                  }
                  // Default: single Metro row from custTgtM
                  return [
                    <tr key="metro"><td style={{...S.td,fontWeight:600,color:C.gn}}>Metro (Z1)</td>{PMAW.map(function(_,i){var baseV=custTgtM[i]||0;var dispV=baseV>0&&pmaPpFscPct>0?Math.round(baseV*(1+pmaPpFscPct/100)*100)/100:baseV;return (<td key={i} style={{...S.tdr,color:pmaPpFscPct>0&&baseV>0?C.yw:"inherit"}}><div style={{fontSize:10,fontWeight:700,color:pmaPpFscPct>0&&baseV>0?C.yw:C.tx}}>{dispV>0?"$"+f(dispV):""}</div>{pmaPpFscPct>0&&baseV>0&&<div style={{fontSize:8,color:C.td}}>{"base $"+f(baseV)}</div>}</td>)})}</tr>,
                    (custTgtR.some(function(v){return v>0})?(<tr key="rural"><td style={{...S.td,fontWeight:600,color:C.rd}}>Rural (Z2+Z3)</td>{PMAW.map(function(_,i){var baseV=custTgtR[i]||0;var dispV=baseV>0&&pmaPpFscPct>0?Math.round(baseV*(1+pmaPpFscPct/100)*100)/100:baseV;return (<td key={i} style={{...S.tdr}}><div style={{fontSize:10,fontWeight:700,color:pmaPpFscPct>0&&baseV>0?C.yw:C.tx}}>{dispV>0?"$"+f(dispV):""}</div>{pmaPpFscPct>0&&baseV>0&&<div style={{fontSize:8,color:C.td}}>{"base $"+f(baseV)}</div>}</td>)})}</tr>):null)
                  ];
                })()}
              </tbody>
            </table></div>
          )}
        </div>)}

        <div style={{...S.sec,paddingBottom:8}}>
          <div style={{display:"flex",alignItems:"center",gap:12,flexWrap:"wrap"}}>
            <span style={{fontSize:10,fontWeight:700,textTransform:"uppercase",letterSpacing:".05em",color:C.cy}}>{"Step 1 -- Per Piece Delivery ("+(pmaPpWtMode==="vol"?"Volumetric":"Physical")+")"}</span>
            <Tog2 v={pmaPpMode} onChange={function(v){sPmaPpM(v);if(v==="meet")sCustTgtOn(true)}} opts={[["target","Target %"],["meet","Meet Customer Targets"]]} />
            {pmaPpMode==="target"&&(<div style={{display:"flex",alignItems:"center",gap:6}}><label style={{fontSize:9.5,color:C.tm}}>Target %</label><input style={{...S.inp,width:60}} type="number" value={pmaPT} onChange={function(e){sPmaPT(+e.target.value||0)}} /></div>)}
            {pmaPpMode==="meet"&&!custTgtOn&&(<span style={{fontSize:9.5,color:C.rd,fontWeight:600}}>Enable Customer Target Rates above to use this mode</span>)}
          </div>
          <div style={{display:"flex",alignItems:"center",gap:12,marginTop:8,flexWrap:"wrap"}}>
            <label style={{display:"flex",alignItems:"center",gap:6,cursor:"pointer",fontSize:10.5,color:pmaPpRefine?C.yw:C.tm}}>
              <input type="checkbox" checked={pmaPpRefine} onChange={function(){sPmaPpRefine(!pmaPpRefine)}} />
              <span style={{fontWeight:700,textTransform:"uppercase",letterSpacing:".05em",fontSize:10}}>Step 2 -- Refine Manually</span>
            </label>
            {pmaPpRefine && (<>
              <button onClick={function(){if(pma.cards.length>0){var newR={};pma.cards.forEach(function(card){card.rc.forEach(function(z){newR[z.k]=z.rates.map(function(r){return Math.round(r.baseRate*100)/100})})});sPmaPpR(newR)}}} style={{fontSize:9,padding:"4px 10px",background:C.ad,color:"#fff",border:"1px solid "+C.ad,cursor:"pointer",fontFamily:bf,borderRadius:0}}>{"Load from "+(pmaPpMode==="meet"?"Customer Targets":"Target %")}</button>
              <button onClick={function(){sPmaPpR({});sPmaPpExclZ({});sPmaPpExclW({})}} style={{fontSize:9,padding:"4px 10px",background:"transparent",border:"1px solid "+C.rd,color:C.rd,cursor:"pointer",fontFamily:bf,borderRadius:0}}>Reset All Changes</button>
              <span style={{fontSize:9,color:C.yw}}>Edit rates, remove zones/weights with ✕, restore with ↩</span>
            </>)}
          </div>
        </div>

        {pma.cards.map(function(card){
          var dfAvail=pmaChinaSpecial&&DF_PORTS[card.port];
          var dfPending=pmaChinaSpecial&&!DF_PORTS[card.port];
          return (<div key={card.port}>
          <div className="sec">
            <div style={{...S.st,color:C.cy,borderColor:C.cy+"30"}}>{"Rate Card -- ex-"+card.port+(pmaPpMode==="target"?" at "+pmaPT+"% margin":" -- Meeting Customer Targets")+(pmaPpRefine?" (manually refined)":"")}{dfAvail&&<span style={{marginLeft:8,fontSize:9,color:C.gn,fontWeight:400}}>Dragonfly Z1 available</span>}{dfPending&&<span style={{marginLeft:8,fontSize:9,color:C.yw,fontWeight:400}}>Dragonfly coming soon</span>}</div><div style={{fontSize:8,color:(function(){var t=aWDistPMA.reduce(function(a,b){return a+(+b||0)},0);return Math.abs(t-100)<0.5?C.gn:C.yw})(),marginTop:-4,marginBottom:4}}>{"Wt Distribution Total: "+(function(){var t=aWDistPMA.reduce(function(a,b){return a+(+b||0)},0);return f(t,1)+"%"+(Math.abs(t-100)<0.5?" ✓":" ⚠")})()}</div>
            <div style={{overflowX:"auto"}}><table style={S.tbl}><thead><tr><th style={S.th}>{pmaPpRefine?"Zone":"Zone"}</th>{PMAWL.map(function(l,wi){var wMix=aWDistPMA[wi]||0;return (<th key={l} style={{...S.thr,color:pmaPpExclW[wi]?C.td:C.tx,textDecoration:pmaPpExclW[wi]?"line-through":"none"}}>{l}kg<div style={{marginTop:2}}><input style={{width:32,fontSize:8,padding:"1px 2px",textAlign:"center",background:C.s2,color:C.ac,border:"1px solid "+C.bd,fontFamily:bf}} type="number" step="0.1" min="0" max="100" value={wMix||""} onChange={function(e){var v=+e.target.value||0;sWDistPMA(function(p){var arr=p.length===11?[...p]:PMAW.map(function(){return 0});arr[wi]=v;return arr})}} placeholder="0" /><span style={{fontSize:7,color:C.td,marginLeft:2}}>%</span></div>{pmaPpRefine&&<button onClick={function(){sPmaPpExclW(function(p){var n={...p};if(n[wi])delete n[wi];else n[wi]=true;return n})}} style={{marginLeft:3,fontSize:8,background:"transparent",border:"none",color:pmaPpExclW[wi]?C.gn:C.rd,cursor:"pointer",fontFamily:bf,padding:0}}>{pmaPpExclW[wi]?"↩":"✕"}</button>}</th>)})}<th style={S.thr}>Avg Margin</th><th style={S.thr}>Annual $</th>{pmaPpRefine&&<th style={{...S.thr,width:30}}></th>}</tr></thead>
              <tbody>{(function(){var stToPortMap={NSW:"SYD",ACT:"SYD",VIC:"MEL",TAS:"MEL",QLD:"BNE",NT:"BNE",SA:"MEL",WA:"PER"};
              // Re-route: if a state's preferred port isn't active, fall back to nearest active port
              var activePorts2=Object.keys(pmaInj).filter(function(p){return pmaInj[p]});
              function actualPortFor(st){var pref=stToPortMap[st];if(activePorts2.indexOf(pref)>=0)return pref;var fallback={QLD:["SYD","BNE","MEL","PER"],NT:["BNE","SYD","MEL","PER"],ACT:["SYD","MEL","BNE","PER"],TAS:["MEL","SYD","BNE","PER"],SA:["MEL","SYD","BNE","PER"],WA:["PER","MEL","SYD","BNE"],NSW:["SYD","MEL","BNE","PER"],VIC:["MEL","SYD","BNE","PER"]}[st]||["SYD","MEL","BNE","PER"];for(var i=0;i<fallback.length;i++){if(activePorts2.indexOf(fallback[i])>=0)return fallback[i];}return activePorts2[0]||pref;}
              var grandTotal=0;var rows=card.rc.filter(function(r){if(dgfFlexAll){return actualPortFor(r.st)===card.port;}return true;}).map(function(r){var totGP=0;var totRate=0;var zoneExcl=!!pmaPpExclZ[r.k];r.rates.forEach(function(rt,i){if(!rt.excl){var wMix=aWDistPMA[i]||0;totGP+=(rt.rate-rt.cost)*wMix/100;totRate+=rt.rate*wMix/100}});var avgM=totRate>0?(totGP/totRate)*100:0;var isZ1=r.z===1;var portKgRate=pma.rateA;if(pma.isGranular&&pma.portGranular){var pg=pma.portGranular.find(function(p){return p.port===card.port});if(pg){var ap=l2AkePct/100;portKgRate=pg.ake.rateA*ap+pg.pmc.rateA*(1-ap)}}var ds=aDisp[r.st];var zPctV=ds?(r.z===1?ds.z1:r.z===2?ds.z2:ds.z3):0;var zVol=ds?vol*ds.pct/100*zPctV/100:0;var wGP=0;r.rates.forEach(function(rt,i){if(!rt.excl){var fscF2=1+(pmaPpFscPct||0)/100;var gp=rt.rate*fscF2-rt.cost;var wMix=aWDistPMA[i]||0;wGP+=gp*wMix/100}});var annGP=zoneExcl?0:wGP*zVol;grandTotal+=annGP;return (<tr key={r.k} style={r.isDf?{background:C.cy+"08"}:{opacity:zoneExcl?.4:1}}><td style={{...S.td,fontWeight:600,fontSize:10,whiteSpace:"nowrap",textDecoration:zoneExcl?"line-through":"none"}}>{r.l}{r.isDf&&<span style={{color:C.cy,fontSize:8,marginLeft:4}}>{"DF"}</span>}{(function(){var volPct=ds?ds.pct*zPctV/100:0;return volPct>0?(<span style={{fontSize:7,color:C.td,marginLeft:4}}>{f(volPct,1)+"%"}</span>):null})()}</td>{r.rates.map(function(rt,i){var fscF=1+(pmaPpFscPct||0)/100;
                  var isSFEvri3=(cust&&cust.indexOf("SF (Evri)")>=0);var baseTgt=custTgtOn?(isSFEvri3&&SF_EVRI_TGT[r.k]?(SF_EVRI_TGT[r.k][i]||0):(isZ1?custTgtM[i]:custTgtR[i])):0;
                  var dispTgt=baseTgt>0?Math.round(baseTgt*fscF*100)/100:0;
                  var dispRate=Math.round(rt.rate*fscF*100)/100;
                  var gp=dispRate-rt.cost;var mg=dispRate>0?(gp/dispRate)*100:0;
                  var hitTgt=dispTgt>0&&dispRate<=dispTgt;
                  var cellColor=gp>=0?C.gn:C.rd;var cellBg=gp>=0?C.gn+"08":C.rd+"10";var isOverride=pmaPpRefine&&pmaPpR[r.k]&&pmaPpR[r.k][i]>0;if(rt.excl){return(<td key={i} style={{...S.tdr,color:C.td,fontSize:9,background:C.s2}}>{"--"}</td>)}if(pmaPpRefine){return(<td key={i} style={{...S.tdr,background:cellBg,borderLeft:isOverride?"2px solid "+C.yw:"none"}}>{(pmaPpFscPct>0&&isOverride&&rt.rate>0)?(<div style={{fontSize:11,fontWeight:700,color:C.yw,textAlign:"right"}}>{dc(dispRate)}<div style={{fontSize:8,color:C.td,fontWeight:400}}>{"base "}<input style={{...S.inp,width:44,textAlign:"right",fontSize:8,display:"inline",padding:"0 2px"}} type="number" step=".01" value={(pmaPpR[r.k]&&pmaPpR[r.k][i])||""} placeholder={f(rt.baseRate)} onChange={function(e){sPmaPpR(function(prev){var n={...prev};n[r.k]=[...(prev[r.k]||PMAW.map(function(){return 0}))];n[r.k][i]=+e.target.value||0;return n})}} /></div></div>):(<input style={{...S.inp,width:58,textAlign:"right",fontSize:10,fontWeight:isOverride?700:400,color:isOverride?C.yw:C.tx}} type="number" step=".01" value={(pmaPpR[r.k]&&pmaPpR[r.k][i])||""} placeholder={f(rt.baseRate)} onChange={function(e){sPmaPpR(function(prev){var n={...prev};n[r.k]=[...(prev[r.k]||PMAW.map(function(){return 0}))];n[r.k][i]=+e.target.value||0;return n})}} />)}<div style={{fontSize:8,fontWeight:400}}><span style={{color:cellColor}}>{f(mg,1)+"% "+dc(gp)}</span>{dispTgt>0&&<span style={{color:hitTgt?C.gn:C.rd}}>{" tgt:"+dc(dispTgt)+(hitTgt?" ✓":" ✗")}</span>}</div></td>)}return(<td key={i} style={{...S.tdr,fontSize:10.5,color:cellColor,fontWeight:700,background:cellBg}}>{dc(dispRate)}{pmaPpFscPct>0&&rt.rate>0&&<div style={{fontSize:7,color:C.td}}>{"base "+dc(rt.rate)}</div>}<div style={{fontSize:8,fontWeight:400}}><span style={{color:cellColor}}>{f(mg,1)+"%"}</span>{dispTgt>0&&<span style={{color:hitTgt?C.gn:C.rd}}>{" | tgt:"+dc(dispTgt)+(hitTgt?" ✓":" ✗")}</span>}</div></td>)})}<td style={{...S.tdr,color:zoneExcl?C.td:avgM>=0?C.gn:C.rd,fontWeight:700}}>{zoneExcl?"--":f(avgM,1)+"%"}</td><td style={{...S.tdr,color:annGP>=0?C.gn:C.rd,fontWeight:600,fontSize:10}}>{zoneExcl?"--":fK(annGP)}</td>{pmaPpRefine&&<td style={{...S.tdr,padding:2}}><button onClick={function(){sPmaPpExclZ(function(p){var n={...p};if(n[r.k])delete n[r.k];else n[r.k]=true;return n})}} style={{fontSize:8,background:"transparent",border:"none",color:zoneExcl?C.gn:C.rd,cursor:"pointer",fontFamily:bf,padding:"2px 4px"}}>{zoneExcl?"↩":"✕"}</button></td>}</tr>)});return rows.concat([<tr key="total" style={{borderTop:"2px solid "+C.ac}}><td style={{...S.td,fontWeight:700,color:C.ac}} colSpan={PMAWL.length+1}>TOTAL</td><td style={{...S.tdr,fontWeight:700,color:C.ac}}></td><td style={{...S.tdr,fontWeight:700,color:grandTotal>=0?C.gn:C.rd,fontSize:12}}>{fK(grandTotal)}</td>{pmaPpRefine&&<td></td>}</tr>])})()}</tbody></table></div>
          </div>
          <div className="sec">
            <div style={{...S.st,color:C.cy,borderColor:C.cy+"30"}}>{"Cost Breakdown -- ex-"+card.port}</div>
            <div style={{overflowX:"auto"}}><table style={S.tbl}>
              <thead><tr><th style={S.th}>Zone</th><th style={S.thr}>{dgfFlexAll?"DGF/Aramex (0.25kg)":"FMC (0.25kg)"}</th><th style={S.thr}>Trucking</th><th style={S.thr}>Dest Scan</th><th style={S.thr}>Total Cost</th><th style={S.thr}>Rate (0.25kg)</th><th style={S.thr}>GP</th><th style={S.thr}>GP%</th><th style={S.thr}>Annual $</th></tr></thead>
              <tbody>{(function(){var portLocalSt={MEL:"VIC",SYD:"NSW",BNE:"QLD",PER:"WA"}[card.port]||null;
              var cbTotal=0;var rows=card.rc.filter(function(r){
                if(!pmaPpExclZ[r.k]&&r.rates.some(function(rt){return !rt.excl&&rt.cost>0})){
                  // When dgfFlexAll: only show this port's local state zone (direct injection only, no linehaul)
                  if(dgfFlexAll&&portLocalSt){return r.st===portLocalSt;}
                  return true;
                }
                return false;
              }).map(function(r){var ds=aDisp[r.st];var zPct=ds?(r.z===1?ds.z1:r.z===2?ds.z2:ds.z3):0;var zVol=ds?vol*ds.pct/100*zPct/100:0;var wGP=0;var wRev=0;var wCost=0;r.rates.forEach(function(rt,i){if(!rt.excl){var fscInc=1+(pmaPpFscPct||0)/100;var rtGP=rt.rate*fscInc-rt.cost;var wMix=aWDistPMA[i]||0;wGP+=rtGP*wMix/100;wRev+=rt.rate*fscInc*wMix/100;wCost+=rt.cost*wMix/100}});var wtdMg=wRev>0?(wGP/wRev)*100:0;var annGP=wGP*zVol;cbTotal+=annGP;return (<tr key={r.k} style={r.isDf?{background:C.cy+"08"}:{}}>
                <td style={{...S.td,fontWeight:600,fontSize:10}}>{r.l}{r.isDf&&<span style={{color:C.cy,fontSize:8,marginLeft:4}}>{"DF"}</span>}</td>
                <td style={{...S.tdr,color:(r.isDf||dgfFlexAll&&r.z===1)?C.cy:C.tx}}>{dc(r.rates[0].fmc)}{dgfFlexAll&&r.z===1&&r.rates[0].stdFmc&&r.rates[0].stdFmc!==r.rates[0].fmc&&<div style={{fontSize:7,color:C.td}}>{"std: "+dc(r.rates[0].stdFmc)}</div>}</td>
                <td style={S.tdr}>{dc(r.tr)}</td>
                <td style={S.tdr}>{dc(r.sc)}</td>
                <td style={{...S.tdr,fontWeight:600}}>{dc(r.rates[0].cost)}</td>
                <td style={{...S.tdr,color:C.ac,fontWeight:700}}>{dc(Math.round(r.rates[0].rate*(1+(pmaPpFscPct||0)/100)*100)/100)}{pmaPpFscPct>0&&r.rates[0].rate>0&&<div style={{fontSize:7,color:C.td}}>{"base "+dc(r.rates[0].rate)}</div>}</td>
                <td style={{...S.tdr,color:wGP>=0?C.gn:C.rd}}>{"A$"+f(wGP)}</td>
                <td style={{...S.tdr,color:wtdMg>=15?C.gn:wtdMg>=0?C.yw:C.rd,fontWeight:600}}>{f(wtdMg,1)+"%"}</td>
                <td style={{...S.tdr,color:annGP>=0?C.gn:C.rd,fontWeight:600}}>{fK(annGP)}</td>
              </tr>)});return rows.concat([<tr key="cbtotal" style={{borderTop:"2px solid "+C.ac}}><td style={{...S.td,fontWeight:700,color:C.ac}} colSpan={8}>TOTAL</td><td style={{...S.tdr,fontWeight:700,color:cbTotal>=0?C.gn:C.rd,fontSize:12}}>{fK(cbTotal)}</td></tr>])})()}</tbody>
            </table></div>
          </div>
          </div>);
        })}
        {pma.ports.length===0 && (<div style={{...S.sec,textAlign:"center",color:C.yw,padding:20}}>Select injection ports above</div>)}

        {pma.ports.length>0 && (
          <div style={{...S.sec,background:"#0d1520",borderColor:C.ac+"40"}}>
            <div style={{...S.st,color:"#fff",borderColor:C.ac+"40"}}>{"Combined Margin (AUD)"}</div>
            <div style={{overflowX:"auto",marginBottom:10}}><table style={{...S.tbl,fontSize:10.5}}>
              <thead><tr><th style={{...S.th,color:C.ac}}>Component</th><th style={{...S.thr,color:C.ac}}>Unit</th><th style={{...S.thr,color:C.ac}}>Revenue (A$)</th><th style={{...S.thr,color:C.ac}}>Cost (A$)</th><th style={{...S.thr,color:C.ac}}>GP (A$)</th><th style={{...S.thr,color:C.ac}}>Margin</th><th style={{...S.thr,color:C.ac}}>Annual Rev</th><th style={{...S.thr,color:C.ac}}>Annual Cost</th><th style={{...S.thr,color:C.ac}}>Annual GP</th></tr></thead>
              <tbody>
                {(function(){
                  var ap2=l2AkePct/100;var pp2=1-ap2;
                  var isLocal=pmaCcy==="local"&&pmaAfc!=="AUD";var lcFx=pmaFxR;
                  var daffInc=daffMode==="inclusive"?DAFF:0;
                  var chargeWt=avgWt*(pmaWtMode==="vol"?pmaDim:1); // vol-kg or phys-kg per parcel
                  // Build dynamic portStMap2 (handles inactive ports — reroutes their states to active alternatives)
                  var stToPortDef2={NSW:"SYD",ACT:"SYD",VIC:"MEL",TAS:"MEL",QLD:"BNE",NT:"BNE",SA:"MEL",WA:"PER"};
                  var activePorts2x=Object.keys(pmaInj).filter(function(p){return pmaInj[p]});
                  function actualPort2(st){var pref=stToPortDef2[st];if(activePorts2x.indexOf(pref)>=0)return pref;
                    // Fallback chain: prefer geographically closest active port
                    var fallback={QLD:["SYD","BNE","MEL","PER"],NT:["BNE","SYD","MEL","PER"],ACT:["SYD","MEL","BNE","PER"],TAS:["MEL","SYD","BNE","PER"],SA:["MEL","SYD","BNE","PER"],WA:["PER","MEL","SYD","BNE"],NSW:["SYD","MEL","BNE","PER"],VIC:["MEL","SYD","BNE","PER"]}[st]||["SYD","MEL","BNE","PER"];
                    for(var i=0;i<fallback.length;i++){if(activePorts2x.indexOf(fallback[i])>=0)return fallback[i];}
                    return activePorts2x[0];}
                  var portStMap2={MEL:[],SYD:[],BNE:[],PER:[]};
                  Object.keys(stToPortDef2).forEach(function(st){var p=actualPort2(st);if(p&&portStMap2[p])portStMap2[p].push(st);});
                  // Compute Leg 2 total annual GP - EXACT same logic as Leg 2 Margin Analysis TOTAL row
                  var l2TotAnn=0;
                  if(pma.portGranular){
                    pma.portGranular.forEach(function(pg){
                      var akeGPv=pg.ake.rateA-pg.akeCost;var pmcGPv=pg.pmc.rateA-pg.pmcCost;
                      var pPct2=0;(portStMap2[pg.port]||[]).forEach(function(st){var ds=aDisp[st];if(ds&&ds.pct>0)pPct2+=ds.pct});
                      var portVol2=vol*pPct2/100;
                      l2TotAnn+=(akeGPv*avgWt*portVol2*ap2)+(pmcGPv*avgWt*portVol2*pp2);
                    });
                    if(pma.hasL2Pc){var daffIncTot=daffMode==="inclusive"?DAFF:0;l2TotAnn+=(pma.l2PcRate-(pma.l2p+daffIncTot))*vol;}
                  }
                  // Clearance: blended KG + depot. DAFF never in revenue (passthrough govt charge). Only in cost if inclusive.
                  var clKgC=0,clKgR=0;
                  if(pma.isGranular&&pma.portGranular){
                    var totalPortPct2=0;
                    pma.portGranular.forEach(function(pg){var pPct=0;(portStMap2[pg.port]||[]).forEach(function(st){var ds=aDisp[st];if(ds&&ds.pct>0)pPct+=ds.pct});totalPortPct2+=pPct;});
                    pma.portGranular.forEach(function(pg){
                      var pPct=0;(portStMap2[pg.port]||[]).forEach(function(st){var ds=aDisp[st];if(ds&&ds.pct>0)pPct+=ds.pct});
                      var wt=totalPortPct2>0?pPct/totalPortPct2:1/pma.portGranular.length;
                      clKgC+=(pg.akeCost*ap2+pg.pmcCost*pp2)*wt;
                      clKgR+=(pg.ake.rateA*ap2+pg.pmc.rateA*pp2)*wt;
                    });
                  }else{clKgC=pma.clC;clKgR=pma.rateA}
                  var clRev=clKgR*chargeWt+(pma.hasL2Pc?pma.l2PcRate:0);
                  var clCost=clKgC*chargeWt+(pma.hasL2Pc?pma.l2p:0)+daffInc;
                  var clGP=clRev-clCost;var clM=clRev>0?(clGP/clRev)*100:0;var clAnn=clGP*vol;
                  // Clearance rows - split into KG and Depot when kgpc
                  var clRows=[];
                  if(pma.hasL2Pc){
                    var kgRev=clKgR*chargeWt;var kgCost=clKgC*chargeWt;var kgGP2=kgRev-kgCost;var kgM2=kgRev>0?(kgGP2/kgRev)*100:0;var kgAnn=pma.hasL2Pc?(l2TotAnn-(pma.l2PcRate-pma.l2p)*vol):l2TotAnn;var kgAnnR=kgRev*vol;var kgAnnC=kgCost*vol;
                    var dpRev=pma.l2PcRate;var dpCost=pma.l2p;var dpGP2=dpRev-dpCost;var dpM2=dpRev>0?(dpGP2/dpRev)*100:0;var dpAnn=dpGP2*vol;var dpAnnR=dpRev*vol;var dpAnnC=dpCost*vol;
                    var kgGPperKg=clKgR-clKgC;var kgMperKg=clKgR>0?(kgGPperKg/clKgR)*100:0;clRows.push(<tr key="cl_kg"><td style={S.td}>{"Clearance KG"+(pmaWtMode==="vol"?" (Vol)":"")}</td><td style={{...S.tdr,fontSize:9,color:C.td}}>{pmaWtMode==="vol"?"/vol-kg":"/kg"}</td><td style={{...S.tdr,color:C.ac}}>{"A$"+f(clKgR)}</td><td style={{...S.tdr,color:C.rd}}>{"A$"+f(clKgC)}</td><td style={{...S.tdr,color:kgGPperKg>=0?C.gn:C.rd,fontWeight:600}}>{"A$"+f(kgGPperKg)}</td><td style={{...S.tdr,color:kgMperKg>=15?C.gn:kgMperKg>=0?C.yw:C.rd}}>{f(kgMperKg,1)+"%"}</td><td style={{...S.tdr,color:C.ac}}>{fK(kgAnnR)}</td><td style={{...S.tdr,color:C.rd}}>{fK(kgAnnC)}</td><td style={{...S.tdr,color:kgAnn>=0?C.gn:C.rd}}>{fK(kgAnn)}</td></tr>);
                    clRows.push(<tr key="cl_dp"><td style={S.td}>Clearance Depot<div style={{fontSize:8,color:C.td}}>Per piece</div></td><td style={{...S.tdr,fontSize:9,color:C.td}}>/pc</td><td style={{...S.tdr,color:C.ac}}>{"A$"+f(dpRev)}</td><td style={{...S.tdr,color:C.rd}}>{"A$"+f(dpCost)}</td><td style={{...S.tdr,color:dpGP2>=0?C.gn:C.rd,fontWeight:600}}>{"A$"+f(dpGP2)}</td><td style={{...S.tdr,color:dpM2>=0?C.gn:C.rd}}>{f(dpM2,1)+"%"}</td><td style={{...S.tdr,color:C.ac}}>{fK(dpAnnR)}</td><td style={{...S.tdr,color:C.rd}}>{fK(dpAnnC)}</td><td style={{...S.tdr,color:dpAnn>=0?C.gn:C.rd}}>{fK(dpAnn)}</td></tr>);
                    if(daffInc>0){var daffAnn=daffInc*vol;clRows.push(<tr key="cl_daff"><td style={S.td}>DAFF Biosecurity<div style={{fontSize:8,color:C.td}}>Govt pass-through</div></td><td style={{...S.tdr,fontSize:9,color:C.td}}>/pc</td><td style={{...S.tdr,color:C.cy}}>{"A$"+f(daffInc)}</td><td style={{...S.tdr,color:C.cy}}>{"A$"+f(daffInc)}</td><td style={{...S.tdr,color:C.tm}}>{"A$0.00"}</td><td style={{...S.tdr,color:C.tm}}>{"0.0%"}</td><td style={{...S.tdr,color:C.cy}}>{fK(daffInc*vol)}</td><td style={{...S.tdr,color:C.cy}}>{fK(daffInc*vol)}</td><td style={{...S.tdr,color:C.tm}}>{fK(0)}</td></tr>)}
                  }else{
                    clRows.push(<tr key="cl"><td style={S.td}>Clearance<div style={{fontSize:8,color:C.td}}>Blended KG</div></td><td style={{...S.tdr,fontSize:9,color:C.td}}>/pc</td><td style={{...S.tdr,color:C.ac}}>{av(clRev)}</td><td style={{...S.tdr,color:C.rd}}>{av(clCost-daffInc)}</td><td style={{...S.tdr,color:(clGP+daffInc)>=0?C.gn:C.rd,fontWeight:600}}>{"A$"+f(clGP+daffInc)}</td><td style={{...S.tdr,color:(clM)>=15?C.gn:clM>=0?C.yw:C.rd}}>{f(clRev>0?((clRev-(clCost-daffInc))/clRev)*100:0,1)+"%"}</td><td style={{...S.thr,color:C.ac}}>{fK(clRev*vol)}</td><td style={{...S.tdr,color:C.rd}}>{fK((clCost-daffInc)*vol)}</td><td style={{...S.tdr,color:(clAnn+daffInc*vol)>=0?C.gn:C.rd}}>{fK(clAnn+daffInc*vol)}</td></tr>);
                    if(daffInc>0){clRows.push(<tr key="cl_daff2"><td style={S.td}>DAFF Biosecurity<div style={{fontSize:8,color:C.td}}>Govt pass-through</div></td><td style={{...S.tdr,fontSize:9,color:C.td}}>/pc</td><td style={{...S.tdr,color:C.cy}}>{"A$"+f(daffInc)}</td><td style={{...S.tdr,color:C.cy}}>{"A$"+f(daffInc)}</td><td style={{...S.tdr,color:C.tm}}>{"A$0.00"}</td><td style={{...S.tdr,color:C.tm}}>{"0.0%"}</td><td style={{...S.tdr,color:C.cy}}>{fK(daffInc*vol)}</td><td style={{...S.tdr,color:C.cy}}>{fK(daffInc*vol)}</td><td style={{...S.tdr,color:C.tm}}>{fK(0)}</td></tr>)}
                  }
                  // Delivery - match rate card calculation exactly
                  var ppAnn=0;var ppRevTot=0;var ppCostTot=0;
                  var stToPort2={NSW:"SYD",ACT:"SYD",VIC:"MEL",TAS:"MEL",QLD:"BNE",NT:"BNE",SA:"MEL",WA:"PER"};
                  var activePorts=Object.keys(pmaInj).filter(function(p){return pmaInj[p]});
                  if(pma.cards.length>0){
                    STS.forEach(function(st){var ds=aDisp[st];if(!ds||ds.pct<=0)return;
                      var bestPort=stToPort2[st]||activePorts[0];if(activePorts.indexOf(bestPort)<0)bestPort=activePorts[0];
                      var card=pma.cards.find(function(c){return c.port===bestPort})||pma.cards[0];
                      [1,2,3].forEach(function(z){var zPct=z===1?ds.z1:z===2?ds.z2:ds.z3;if(zPct<=0)return;
                        var zk=st+"-Z"+z;var zone=card.rc.find(function(r){return r.k===zk});if(!zone)return;
                        var zVol2=vol*ds.pct/100*zPct/100;
                        // Filter: dgfFlexAll = direct injection only (local state per port); skip excluded zones
                        // dgfFlexAll: bestPort already resolved via stToPort fallback earlier — no further filter needed (st's port is bestPort by definition)
                        if(pmaPpExclZ[zk])return;
                        var fscInc3=1+(pmaPpFscPct||0)/100;
                        zone.rates.forEach(function(rt,i){if(!rt.excl){var gp=rt.rate*fscInc3-rt.cost;var wMix=aWDistPMA[i]||0;
                          ppAnn+=gp*wMix/100*zVol2;ppRevTot+=rt.rate*fscInc3*wMix/100*zVol2;ppCostTot+=rt.cost*wMix/100*zVol2}});
                      });
                    });
                  }
                  var ppR=vol>0?ppRevTot/vol:0;var ppC=vol>0?ppCostTot/vol:0;var ppGP=ppR-ppC;var ppM=ppR>0?(ppGP/ppR)*100:0;
                  // Total
                  var totR=clRev+ppR;var totC=clCost+ppC;var totGP=totR-totC;var totM=totR>0?(totGP/totR)*100:0;var totAnn=l2TotAnn+ppAnn;
                  function av(v){return "A$"+f(v)+(isLocal?" ("+pmaAfc+" "+f(v*lcFx)+")":"")}
                  return [
                    ...clRows,
                    <tr key="pp"><td style={S.td}>Delivery (blended)</td><td style={{...S.tdr,fontSize:9,color:C.td}}>/pc</td><td style={{...S.tdr,color:C.ac}}>{"A$"+f(ppR)}</td><td style={{...S.tdr,color:C.rd}}>{"A$"+f(ppC)}</td><td style={{...S.tdr,color:ppGP>=0?C.gn:C.rd,fontWeight:600}}>{"A$"+f(ppGP)}</td><td style={{...S.tdr,color:ppM>=15?C.gn:ppM>=0?C.yw:C.rd}}>{f(ppM,1)+"%"}</td><td style={{...S.tdr,color:C.ac}}>{fK(ppRevTot)}</td><td style={{...S.tdr,color:C.rd}}>{fK(ppCostTot)}</td><td style={{...S.tdr,color:ppAnn>=0?C.gn:C.rd}}>{fK(ppAnn)}</td></tr>,
                    <tr key="tot" style={{borderTop:"2px solid "+C.ac}}><td style={{...S.td,fontWeight:700,color:C.ac}}>TOTAL</td><td style={{...S.tdr,fontSize:9,color:C.td}}>/pc</td><td style={{...S.tdr,color:C.ac,fontWeight:700}}>{"A$"+f(totR)}</td><td style={{...S.tdr,color:C.rd,fontWeight:700}}>{"A$"+f(totC)}</td><td style={{...S.tdr,color:totGP>=0?C.gn:C.rd,fontWeight:700}}>{"A$"+f(totGP)}</td><td style={{...S.tdr,color:totM>=15?C.gn:totM>=0?C.yw:C.rd,fontWeight:700}}>{f(totM,1)+"%"}</td><td style={{...S.tdr,color:C.ac,fontWeight:700}}>{fK(totR*vol)}</td><td style={{...S.tdr,color:C.rd,fontWeight:700}}>{fK(totC*vol)}</td><td style={{...S.tdr,color:totAnn>=0?C.gn:C.rd,fontWeight:700}}>{fK(totAnn)}</td></tr>
                  ]})()}
              </tbody>
            </table></div>
            <div style={grd(3)}>
              {(function(){
                var ap3=l2AkePct/100;var pp3=1-ap3;
                var daffInc3=daffMode==="inclusive"?DAFF:0;
                var chargeWt3=avgWt*(pmaWtMode==="vol"?pmaDim:1);
                // l2TotAnn — exact same calc as Leg 2 Margin Analysis TOTAL row
                var l2TotAnnM=0;
                // Build dynamic portStMap3 for metric box
                var stToPortDef3={NSW:"SYD",ACT:"SYD",VIC:"MEL",TAS:"MEL",QLD:"BNE",NT:"BNE",SA:"MEL",WA:"PER"};
                var activePorts3y=Object.keys(pmaInj).filter(function(p){return pmaInj[p]});
                function actualPort3y(st){var pref=stToPortDef3[st];if(activePorts3y.indexOf(pref)>=0)return pref;
                    // Fallback chain: prefer geographically closest active port
                    var fallback={QLD:["SYD","BNE","MEL","PER"],NT:["BNE","SYD","MEL","PER"],ACT:["SYD","MEL","BNE","PER"],TAS:["MEL","SYD","BNE","PER"],SA:["MEL","SYD","BNE","PER"],WA:["PER","MEL","SYD","BNE"],NSW:["SYD","MEL","BNE","PER"],VIC:["MEL","SYD","BNE","PER"]}[st]||["SYD","MEL","BNE","PER"];
                    for(var i=0;i<fallback.length;i++){if(activePorts3y.indexOf(fallback[i])>=0)return fallback[i];}
                    return activePorts3y[0];}
                var portStMap3={MEL:[],SYD:[],BNE:[],PER:[]};
                Object.keys(stToPortDef3).forEach(function(st){var p=actualPort3y(st);if(p&&portStMap3[p])portStMap3[p].push(st);});
                if(pma.portGranular){
                  pma.portGranular.forEach(function(pg){
                    var akeGPv=pg.ake.rateA-pg.akeCost;var pmcGPv=pg.pmc.rateA-pg.pmcCost;
                    var pPct3a=0;(portStMap3[pg.port]||[]).forEach(function(st){var ds=aDisp[st];if(ds&&ds.pct>0)pPct3a+=ds.pct});
                    var portVol3=vol*pPct3a/100;
                    l2TotAnnM+=(akeGPv*avgWt*portVol3*ap3)+(pmcGPv*avgWt*portVol3*pp3);
                  });
                  if(pma.hasL2Pc){var daffIncTotM=daffMode==="inclusive"?DAFF:0;l2TotAnnM+=(pma.l2PcRate-(pma.l2p+daffIncTotM))*vol;}
                }
                var clKgC3=0,clKgR3=0,clAnnFromPorts3=0;
                if(pma.isGranular&&pma.portGranular){
                  var totalPortPct3=0;
                  pma.portGranular.forEach(function(pg){var pPct=0;(portStMap3[pg.port]||[]).forEach(function(st){var ds=aDisp[st];if(ds&&ds.pct>0)pPct+=ds.pct});totalPortPct3+=pPct;});
                  pma.portGranular.forEach(function(pg){
                    var pPct=0;(portStMap3[pg.port]||[]).forEach(function(st){var ds=aDisp[st];if(ds&&ds.pct>0)pPct+=ds.pct});
                    var wt3=totalPortPct3>0?pPct/totalPortPct3:1/pma.portGranular.length;
                    var pgR3=pg.ake.rateA*ap3+pg.pmc.rateA*pp3;
                    var pgC3=pg.akeCost*ap3+pg.pmcCost*pp3;
                    clKgC3+=pgC3*wt3;clKgR3+=pgR3*wt3;
                    clAnnFromPorts3+=(pgR3-pgC3)*chargeWt3*(vol*pPct/100);
                  });
                }else{clKgC3=pma.clC;clKgR3=pma.rateA;clAnnFromPorts3=(clKgR3-clKgC3)*chargeWt3*vol;}
                var clRev3=clKgR3*chargeWt3+(pma.hasL2Pc?pma.l2PcRate:0);
                var clCost3=clKgC3*chargeWt3+(pma.hasL2Pc?pma.l2p:0)+daffInc3;
                // Delivery - match rate card exactly
                var ppAnn3=0;var ppRevTot3=0;var ppCostTot3=0;
                var stToPort3={NSW:"SYD",ACT:"SYD",VIC:"MEL",TAS:"MEL",QLD:"BNE",NT:"BNE",SA:"MEL",WA:"PER"};
                var activePorts3=Object.keys(pmaInj).filter(function(p){return pmaInj[p]});
                if(pma.cards.length>0){
                  STS.forEach(function(st){var ds=aDisp[st];if(!ds||ds.pct<=0)return;
                    var bestPort=stToPort3[st]||activePorts3[0];
                    if(activePorts3.indexOf(bestPort)<0){
                      var fallback={QLD:["SYD","BNE","MEL","PER"],NT:["BNE","SYD","MEL","PER"],ACT:["SYD","MEL","BNE","PER"],TAS:["MEL","SYD","BNE","PER"],SA:["MEL","SYD","BNE","PER"],WA:["PER","MEL","SYD","BNE"],NSW:["SYD","MEL","BNE","PER"],VIC:["MEL","SYD","BNE","PER"]}[st]||["SYD","MEL","BNE","PER"];
                      for(var fi=0;fi<fallback.length;fi++){if(activePorts3.indexOf(fallback[fi])>=0){bestPort=fallback[fi];break;}}
                      if(activePorts3.indexOf(bestPort)<0)bestPort=activePorts3[0];
                    }
                    var card=pma.cards.find(function(c){return c.port===bestPort})||pma.cards[0];
                    [1,2,3].forEach(function(z){var zPct=z===1?ds.z1:z===2?ds.z2:ds.z3;if(zPct<=0)return;
                      var zk=st+"-Z"+z;var zone=card.rc.find(function(r){return r.k===zk});if(!zone)return;
                      var zVol3=vol*ds.pct/100*zPct/100;
                      // dgfFlexAll: bestPort already resolved via stToPort fallback earlier — no further filter needed
                      if(pmaPpExclZ[zk])return;
                      var fscInc4=1+(pmaPpFscPct||0)/100;
                      zone.rates.forEach(function(rt,i){if(!rt.excl){var gp=rt.rate*fscInc4-rt.cost;var wMix=aWDistPMA[i]||0;
                        ppAnn3+=gp*wMix/100*zVol3;ppRevTot3+=rt.rate*fscInc4*wMix/100*zVol3;ppCostTot3+=rt.cost*wMix/100*zVol3}});
                    });
                  });
                }
                var ppR3=vol>0?ppRevTot3/vol:0;var ppC3=vol>0?ppCostTot3/vol:0;
                var totR3=clRev3+ppR3;var totC3=clCost3+ppC3;
                var totGP3=totR3-totC3;var totM3=totR3>0?(totGP3/totR3)*100:0;
                var netRev=totR3*vol;var netCost=totC3*vol;
                // Use port-volume-weighted annual GP for clearance to match Leg 2 section
                var netGP=pma.portGranular?(l2TotAnnM+ppAnn3):totGP3*vol;
                return [
                  <div key="m" style={S.met}><div style={mvS(totM3>=15?C.gn:totM3>=0?C.yw:C.rd)}>{f(totM3,1)}%</div><div style={S.ml}>Total Margin</div></div>,
                  <Mt key="r" l="Annual Revenue (AUD)" v={"A"+fK(netRev)} c={C.ac} p="" />,
                  <Mt key="g" l="Annual GP (AUD)" v={"A"+fK(netGP)} c={netGP>=0?C.gn:C.rd} p="" />
                ]})()}
            </div>
          </div> 
        )}
      </>)}

      {prod==="pr" && pr && (<>

        {/* //================PR Tier + Margin section ===============//    */}
        <div className="sec">
          <div className="st">Tier + Margin</div>
          {(function(){
            var prwMap5=[0,1,2,3,4,5,6,6,6,6];
            var wd10r=PRW.map(function(_,i){var mi=prwMap5[i];var v=aWDist[mi]||0;return mi===6?v/4:v});
            var tRevTot=0;var tCostTot=0;var tWtR=0;
            pr.rc.forEach(function(zone){
              var st=zone.st;var z=zone.z;var ds=aDisp[st];if(!ds)return;
              var zPct=z===1?ds.z1:z===2?ds.z2:ds.z3;
              var wt=ds.pct*zPct/10000;
              zone.rates.forEach(function(r,wi){if(!r.excl){var wdPct=wd10r[wi]/100;tRevTot+=r.rate*wt*wdPct;tCostTot+=r.cost*wt*wdPct;tWtR+=wt*wdPct}});
            });
            var ppRr=tWtR>0?tRevTot/tWtR:0;var ppCr=tWtR>0?tCostTot/tWtR:0;
            var actualM=ppRr>0?((ppRr-ppCr)/ppRr)*100:0;
            var tierTgt=pr.tier.mg*100;
            var mColor=actualM>=tierTgt?C.gn:actualM>=tierTgt*0.85?C.yw:C.rd;
                        return (
              <div style={grd(3)}>
                <div style={S.met}>
                  <div style={mvS(C.pp)}>{pr.tier.l}</div>
                  <div style={S.ml}>{(pr.tier.mn||0).toLocaleString()+"+ parcels"}</div>
                </div>
                <div style={S.met}>
                  <div style={mvS(C.tm)}>{f(tierTgt,1)+"%"}</div>
                  <div style={S.ml}>Tier Target Margin</div>
                </div>
                <div style={{...S.met,background:mColor+"15",border:"1px solid "+mColor+"40"}}>
                  <div style={mvS("#fff")}>{f(actualM,1)+"%"}</div>
                  <div style={{...S.ml,color:mColor}}>{actualM>=tierTgt?"At or above target":actualM>=tierTgt*0.85?"Below target":"Well below target"}</div>
                </div>
              </div>
            );
          })()}
        </div>
        {/* //================PR Targets ===============//    */}

        {prTgts.map((tgt, ti) => {
          const tColorClass = ["yw", "pp", "cy", "gn", "ac", "rd"][ti % 6];
          const isOn = tgt.on;

          return (
            <div key={ti} className={`target-block ${tColorClass} ${isOn ? "active" : ""}`}>
              <div className={`target-header ${isOn ? "on" : ""}`}>
                <label className={`target-label ${isOn ? tColorClass : "tm"}`}>
                  <input
                    type="checkbox"
                    checked={isOn}
                    onChange={() => updTgt(ti, "on", !isOn)}
                  />
                  <span>{"Target " + (ti + 1)}</span>
                </label>

                {isOn && (
                  <>
                    <input
                      className="target-input"
                      value={tgt.label}
                      onChange={(e) => updTgt(ti, "label", e.target.value)}
                      placeholder="Competitor name..."
                    />

                    {tgt.source === "mapped" && <span className="badge mapped">MAPPED</span>}
                    {tgt.source === "estimated" && <span className="badge estimated">ESTIMATED</span>}
                    {tgt.source === "calculated" && <span className="badge calculated">CALCULATED</span>}
                    {(!tgt.source || tgt.source === "manual") &&
                      tgt.rates &&
                      Object.keys(tgt.rates).length > 0 && (
                        <span className="badge unverified">UNVERIFIED</span>
                      )}

                    {tgt.rates && Object.keys(tgt.rates).length > 0 && (
                      <button
                        className="btn-clear"
                        onClick={() => {
                          updTgt(ti, "rates", {});
                          updTgt(ti, "source", null);
                        }}
                      >
                        Clear Rates
                      </button>
                    )}
                  </>
                )}

                {ti >= 2 && (
                  <button className="btn-remove" onClick={() => removePrTgt(ti)}>
                    Remove
                  </button>
                )}
              </div>

              {isOn && pr && (
                <div className="table-wrapper">
                  <table className="rates-table">
                    <thead>
                      <tr>
                        <th>Zone</th>
                        {PRWL.map((l) => (
                          <th key={l}>{l}kg</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {pr.rc.map((z) => (
                        <tr key={z.k}>
                          <td className={`zone-label ${tColorClass}`}>{z.l}</td>
                          {PRW.map((_, wi) => {
                            const val = tgt.rates[z.k]?.[wi] || "";
                            const isFloored =
                              tgt.source === "z1-floor" &&
                              tgt.preFloorRates &&
                              z.k.endsWith("-Z1") &&
                              tgt.preFloorRates[z.k] &&
                              tgt.rates[z.k] &&
                              tgt.rates[z.k][wi] !== tgt.preFloorRates[z.k][wi];

                            return (
                              <td key={wi}>
                                <input
                                  className={`rate-input ${isFloored ? "floored" : ""}`}
                                  type="number"
                                  step=".01"
                                  value={val}
                                  onChange={(e) =>
                                    updTgt(
                                      ti,
                                      "rates",
                                      (() => {
                                        const n = { ...tgt.rates };
                                        n[z.k] = [].concat(
                                          tgt.rates[z.k] || PRW.map(() => 0)
                                        );
                                        n[z.k][wi] = +e.target.value || 0;
                                        return n;
                                      })()
                                    )
                                  }
                                />
                              </td>
                            );
                          })}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          );
        })}

        {/* //================PR Add Competitor Target ===============//    */}
        <div className="btn-row">
          <button className="btn-add" onClick={addPrTgt}>
            + Add Competitor Target
          </button>

          {prTgts.filter(t => t.on && t.rates && Object.keys(t.rates).length > 0).length >= 2 && (
            <button className="btn-generate" onClick={generateLCR}>
              Generate Least Cost Route (best of all competitors)
            </button>
          )}
        </div>

        {/* //================PR RATE CARD HEADER ===============//    */}
        <div style={{...S.sec}}>
          <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:8,flexWrap:"wrap"}}>
            <span style={{fontSize:10,fontWeight:700,color:C.cy}}>Step 1</span>
            <Tog2 v={ppMode} onChange={function(v){sPpM(v);if(v==="meet"&&!prTgts.some(function(t){return t.on}))updTgt(0,"on",true)}} opts={[["target","Target %"],["meet","Meet Competitor"]]} />
            {ppMode==="meet"&&prTgts.some(function(t){return t.on})&&(<select style={{...S.sel,width:"auto",fontSize:10,padding:"4px 8px",fontWeight:600,color:C.yw}} value={prMeetIdx} onChange={function(e){sPrMeetIdx(+e.target.value)}}>{prTgts.map(function(t,ti){return t.on?(<option key={ti} value={ti}>{"Meet "+t.label}</option>):null})}</select>)}
            {ppMode==="meet"&&(function(){var src=prTgts[prMeetIdx];var hasZ1=src&&src.on&&src.rates&&Object.keys(src.rates).some(function(zk){return zk.endsWith('-Z1')});var isFloor=src&&src.source==='z1-floor';var canApply=hasZ1&&src.rawZoneMap;if(!hasZ1)return null;return isFloor?(<button onClick={generateZ1MetroFloor} style={{fontSize:9,padding:"4px 10px",background:C.yw+"18",border:"1px solid "+C.yw+"50",color:C.yw,cursor:"pointer",fontFamily:bf,fontWeight:600,borderRadius:0}}>{"⊖ Remove Z1 Metro Floor"}</button>):canApply?(<button onClick={generateZ1MetroFloor} style={{fontSize:9,padding:"4px 10px",background:C.gn+"18",border:"1px solid "+C.gn+"50",color:C.gn,cursor:"pointer",fontFamily:bf,fontWeight:600,borderRadius:0}}>{"⊕ Apply Z1 Metro Floor to "+src.label}</button>):null})()}
            {ppMode==="meet"&&!prTgts.some(function(t){return t.on})&&(<span style={{fontSize:9.5,color:C.rd,fontWeight:600}}>Enable at least one target above</span>)}
            {ppMode==="target"&&pr&&(<div style={{display:"flex",alignItems:"center",gap:6}}><span style={{fontSize:9.5,color:C.tm,whiteSpace:"nowrap"}}>Margin %</span><input style={{...S.inp,width:65,textAlign:"right",fontWeight:700,color:prMOverride?C.yw:C.tx}} type="number" step=".1" value={prMOverride&&prM!==null?prM:Math.round(pr.tier.mg*1000)/10} onChange={function(e){var v=+e.target.value;if(!isNaN(v)&&e.target.value!==""){sPrM(v);sPrMO(true)}else{sPrM(null);sPrMO(false)}}} />{prMOverride&&(<button onClick={function(){sPrM(null);sPrMO(false)}} style={{fontSize:8,background:"transparent",border:"1px solid "+C.yw+"40",color:C.yw,cursor:"pointer",fontFamily:bf,padding:"2px 6px",borderRadius:0,whiteSpace:"nowrap"}}>Reset to Tier</button>)}<span style={{fontSize:8.5,color:prMOverride?C.yw:C.td}}>{prMOverride?"Custom override -- tier default is "+f(pr.tier.mg*100,1)+"%":"Tier "+pr.tier.id+" default"}</span></div>)}
          </div>
          <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:8,flexWrap:"wrap"}}>
            <label style={{display:"flex",alignItems:"center",gap:6,cursor:"pointer",fontSize:10.5,color:ppRefine?C.yw:C.tm}}>
              <input type="checkbox" checked={ppRefine} onChange={function(){sPpRefine(!ppRefine)}} />
              <span style={{fontWeight:700,fontSize:10}}>Step 2 -- Refine Manually</span>
            </label>
            {ppRefine && (<>
              <button onClick={function(){sPpExclW({});sPpExclZ({})}} style={{fontSize:9,padding:"4px 10px",background:"transparent",border:"1px solid "+C.rd,color:C.rd,cursor:"pointer",fontFamily:bf,borderRadius:0}}>Reset All Changes</button>
              <span style={{fontSize:9,color:C.yw}}>✕ to exclude zones/weights, ↩ to restore</span>
            </>)}
          </div>

        {/* //================PR RATE CARD TABLE ===============//    */}
          <div style={{...S.st,display:"flex",alignItems:"center",gap:12}}>

            {/* Rate Card -- ex-MEL at 22.5%; otherwise shows "Meeting Customer Targets" */}
            <span>{"Rate Card -- ex-"+prD+(ppMode==="target"?" at "+f(pr.margin,1)+"%":" -- Meeting Customer Targets")+(ppRefine?" (refined)":"")}</span>
            {cust&&cust.indexOf("V2")>=0&&
              (
                <span style={{fontSize:10,color:C.tm,fontWeight:400,display:"flex",alignItems:"center",gap:4}}>Cost+ % for unlocked: 
                    <input style={{...S.inp,width:50,fontSize:10,textAlign:"center"}} type="number" step="0.5" value={prCostPlusMargin} 
                            onChange={function(e){sPrCostPlusMargin(+e.target.value||15)}} />
                            <span style={{color:C.cy}}>%</span>
                </span>
              )
            }
          </div>

          <div style={{overflowX:"auto"}}>
            <table style={S.tbl}>
              <thead>
                <tr>
                  <th style={S.th}>Zone</th>
                  {PRWL.map(function(l,wi){
                    var prwMap=[0,1,2,3,4,5,6,6,6,6];
                     // prwMap maps each weight index wi to a distribution bucket mi.
                    var mi=prwMap[wi];             
                    var wMix=mi===6?aWDist[mi]/4:aWDist[mi]||0;

                    return (
                      // weight column can be exluded in refine mode
                      <th key={l} style={{...S.thr,color:ppExclW[wi]?C.td:C.tx,textDecoration:ppExclW[wi]?"line-through":"none"}}>{l}kg
                      {/* // subscript for weight band mix percentage in overall volume, only shown when mix >0% to avoid cluttering the table with zeroes  */}
                        <div style={{fontSize:7,color:C.td,fontWeight:400}}>{f(wMix,1)+"%"}</div>
                        {ppRefine&&
                          <button onClick={function(){
                            sPpExclW(function(p){var n={...p};if(n[wi])delete n[wi];else n[wi]=true;return n})}} style={{marginLeft:3,fontSize:8,background:"transparent",border:"none",color:ppExclW[wi]?C.gn:C.rd,cursor:"pointer",fontFamily:bf,padding:0}}>{ppExclW[wi]?"↩":"✕"}
                          </button>}
                      </th>)})
                  }
                  <th style={S.thr}>Avg</th>
                  <th style={S.thr}>Annual $</th>
                  {ppRefine&&<th style={{...S.thr,width:30}}></th>}
                </tr>
              </thead>
              <tbody>
                {(function(){
                var grandTotal=0;
                var rows=pr.rc.map(function(r){
                  var zExcl=!!ppExclZ[r.k];
                  var totGP=0;
                  var totRate=0;

                  r.rates.forEach(function(rt,wi)
                  {if(!rt.excl)
                    {
                      var prwMap2=[0,1,2,3,4,5,6,6,6,6];
                      var mi=prwMap2[wi];
                      var wMix=mi===6?aWDist[mi]/4:aWDist[mi]||0;
                      totGP+=(rt.rate-rt.cost)*wMix/100;totRate+=rt.rate*wMix/100
                    }
                  });
                // Weighted-average gross margin % for this zone across all active weight bands.
                var avgM=totRate>0?(totGP/totRate)*100:0;

                var ds=aDisp[r.st];
                var zPct=ds?(r.z===1?ds.z1:r.z===2?ds.z2:ds.z3):0;
                var zVol=ds?vol*ds.pct/100*zPct/100:0;

                //annual GP
                var annGP=zExcl?0:totGP*zVol;grandTotal+=annGP;
                
                return (
                <tr key={r.k} style={{opacity:zExcl?.4:1}}>
                  <td style={{...S.td,fontWeight:600,fontSize:10,whiteSpace:"nowrap",textDecoration:zExcl?"line-through":"none"}}>
                    {r.l}{
                      (function(){var volPct=ds?ds.pct*zPct/100:0;return volPct>0?(
                        //Volume percentage subscript, only shown if zone has volume contribution >0% to avoid cluttering the table with zeroes. Also hidden when zone is excluded in refine mode since it's not relevant to the refined pricecard.
                        <span style={{fontSize:7,color:C.td,marginLeft:4}}>{f(volPct,1)+"%"}</span>):null})()}
                  </td>

                    {r.rates.map(function(rt,i){
                      var gp=rt.rate-rt.cost;
                      var mg=rt.rate>0?(gp/rt.rate)*100:0;
                      var cellColor=rt.excl?C.td:gp>=0?C.gn:C.rd;
                      if(rt.excl)return(
                        <td key={i} style={{...S.tdr,color:C.td,fontSize:9,background:C.s2}}>{"--"}</td>
                      );
                      return(
                        //rate cell with conditional coloring based on profitability, and optional subscript showing margin % and customer target achievement
                        <td key={i} style={{...S.tdr,fontSize:10.5,color:cellColor,fontWeight:700,background:gp>=0?C.gn+"08":C.rd+"10"}}>
                          {dc(rt.rate)}
                          <div style={{fontSize:8,fontWeight:400}}>

                            {/* //subscript for target margin  */}
                            <span style={{color:cellColor}}>{f(mg,1)+"%"}</span>

                            {prCustTgtOn&&prCustTgt[r.k]&&prCustTgt[r.k][i]>0&&
                            <span style={{color:rt.rate<=prCustTgt[r.k][i]?C.gn:C.rd}}>
                              {" "+prTgtLabel1.substring(0,3)+(rt.rate<=prCustTgt[r.k][i]?"✓":"✗")}
                            </span>}
                            {prCustTgt2On&&prCustTgt2[r.k]&&prCustTgt2[r.k][i]>0&&
                            <span style={{color:rt.rate<=prCustTgt2[r.k][i]?C.gn:C.rd}}>
                              {" "+prTgtLabel2.substring(0,3)+(rt.rate<=prCustTgt2[r.k][i]?"✓":"✗")}
                            </span>}
                          </div>
                        </td>)
                    })}

                        <td style={{...S.tdr,color:zExcl?C.td:avgM>=0?C.gn:C.rd,fontWeight:700}}>{zExcl?"--":f(avgM,1)+"%"}</td>
                        <td style={{...S.tdr,color:annGP>=0?C.gn:C.rd,fontWeight:600,fontSize:10}}>{zExcl?"--":fK(annGP)}</td>
                        {(ppRefine||(cust&&cust.indexOf("V2")>=0))&&
                        <td style={{...S.tdr,padding:2,whiteSpace:"nowrap"}}>
                          {cust&&cust.indexOf("V2")>=0&&
                            (function(){
                              var meetTgt=prTgts[prMeetIdx];
                              var hasTgt=meetTgt&&meetTgt.on&&meetTgt.rates[r.k]&&meetTgt.rates[r.k].some(function(v){return v>0});
                              var explicitUnlock=prLockZones[r.k]===false;
                              var explicitLock=prLockZones[r.k]===true;
                              var locked=explicitLock||(!explicitUnlock&&hasTgt);
                              return (
                              <button onClick={function(){sPrLockZones(function(p){var n={...p};if(locked){n[r.k]=false;}else{n[r.k]=true;}return n})}} title={locked?"Locked — using customer target":"Unlocked — using cost+margin"} style={{fontSize:9,background:"transparent",border:"none",color:locked?C.gn:C.tm,cursor:"pointer",fontFamily:bf,padding:"2px 3px",marginRight:2}}>{locked?"🔒":"🔓"}</button>);
                            })()}
                            {ppRefine&&(
                            <button onClick={function(){sPpExclZ(function(p){var n={...p};if(n[r.k])delete n[r.k];else n[r.k]=true;return n})}} style={{fontSize:8,background:"transparent",border:"none",color:zExcl?C.gn:C.rd,cursor:"pointer",fontFamily:bf,padding:"2px 4px"}}>{zExcl?"↩":"✕"}</button>)}
                        </td>}
                </tr>)});
                return rows.concat([
                  <tr key="total" style={{borderTop:"2px solid "+C.ac}}>
                    <td style={{...S.td,fontWeight:700,color:C.ac}} colSpan={PRWL.length+1}>TOTAL</td>
                    <td style={{...S.tdr,fontWeight:700,color:C.ac}}></td><td style={{...S.tdr,fontWeight:700,color:grandTotal>=0?C.gn:C.rd,fontSize:12}}>{fK(grandTotal)}</td>{
                    (ppRefine||(cust&&cust.indexOf("V2")>=0))&&<td></td>}
                  </tr>])
               })()}
              </tbody>
            </table>
          </div>
        </div>

        {/* //================ Cost Breakdown section ===============// */}
        <div style={{...S.sec}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:6}}>
            <div style={S.st}>{"Cost Breakdown -- ex-"+prD}</div>
            <div style={{display:"flex",gap:2,marginLeft:"auto"}}>
              {PRWL.map(function(lbl,i){return(
                <button key={i} onClick={function(){sPrCbWi(i)}} style={{fontSize:9,padding:"2px 6px",fontFamily:bf,cursor:"pointer",border:"1px solid",borderRadius:0,background:prCbWi===i?C.ad:C.sf,color:prCbWi===i?"#fff":C.tm,borderColor:prCbWi===i?C.ad:C.bd}}>{lbl+"kg"}</button>
              )})}
            </div>
          </div>
          <div style={{overflowX:"auto"}}>
            <table style={S.tbl}>
              <thead>
                <tr>
                  <th style={S.th}>Zone</th>
                  <th style={S.thr}>{"FMC ("+PRWL[prCbWi]+"kg)"}</th>
                  <th style={S.thr}>Trucking</th>
                  <th style={S.thr}>Dest Scan</th>
                  <th style={S.thr}>Pickup</th>
                  <th style={S.thr}>Processing</th>
                  <th style={S.thr}>Insurance</th>
                  <th style={S.thr}>Referral</th>
                  <th style={S.thr}>Total Cost</th>
                  <th style={S.thr}>{"Rate ("+PRWL[prCbWi]+"kg)"}</th>
                  <th style={S.thr}>GP</th>
                  <th style={S.thr}>GP%</th>
                  <th style={S.thr}>Annual $</th>
                  </tr>
                </thead>
              <tbody>
                {(function(){
                  var prCbTotal=0;
                  var rows=pr.rc.filter(
                    function(r){
                      return["NSW","VIC","QLD","SA","WA","TAS","ACT","NT"].indexOf(r.st)>=0}).map(function(r){
                        var ds=aDisp[r.st];
                        var zPct=ds?(r.z===1?ds.z1:r.z===2?ds.z2:ds.z3):0;
                        var zVol=ds?vol*ds.pct/100*zPct/100:0;
                        var prwMap=[0,1,2,3,4,5,6,6,6,6];
                        var wGP=0;
                        var wRev=0;
                        var wCost=0;
                          r.rates.forEach(
                            function(rt,i){if(!rt.excl){
                              var rtGP=rt.rate-rt.cost;
                              var mi=prwMap[i];
                              var wMix=mi===6?aWDist[mi]/4:aWDist[mi]||0;wGP+=rtGP*wMix/100;wRev+=rt.rate*wMix/100;wCost+=rt.cost*wMix/100}});
                              var wtdMg=wRev>0?(wGP/wRev)*100:0;
                              var annGP=wGP*zVol;prCbTotal+=annGP;
                              return (
                              <tr key={r.k}>
                                {/* ZONE //var zones */}
                                <td style={{...S.td,fontWeight:600,fontSize:10}}>{r.l}</td>
                                {/* FMC ()//var fmc */}
                                <td style={S.tdr}>{"A$"+f(r.rates[prCbWi].fmc)}</td>
                                {/* TRUCKING//var trk */}
                                <td style={S.tdr}>{"A$"+f(r.tr)}</td>
                                {/* DEST SCAN//var ssc */}
                                <td style={S.tdr}>{"A$"+f(r.sc)}</td>
                                {/* PICKUP//var tier pu */}
                                <td style={S.tdr}>{"A$"+f(pr.tier.pu,4)}</td>
                                {/* PROCESSING//var tier pr */}
                                <td style={S.tdr}>{"A$"+f(pr.tier.pr)}</td>
                                {/* INSURANCE//var tier ins */}
                                <td style={S.tdr}>{"A$"+f(pr.tier.ins)}</td>
                                {/* REFERRAL//var referral set to 0.10 input*/}
                                <td style={S.tdr}>{"A$"+f(prRef)}</td>
                                {/* TOTAL COST //var cost=fmc+trk+sc+pp;
                                // var pp=tier.pu+tier.pr+tier.ins+prRef; */}
                                <td style={{...S.tdr,fontWeight:600}}>{"A$"+f(r.rates[prCbWi].cost)}</td>
                                {/* RATE   // var rate=excl?0:baseRate; */}
                                <td style={{...S.tdr,color:C.ac,fontWeight:700}}>{dc(r.rates[prCbWi].rate)}</td>
                                {/* GP //var gp=rate-cost; */} 
                                <td style={{...S.tdr,color:wGP>=0?C.gn:C.rd}}>{"A$"+f(wGP)}</td>
                                {/* GP% //var mg=rate>0?(gp/rate)*100:0; */}
                                <td style={{...S.tdr,color:wtdMg>=15?C.gn:wtdMg>=0?C.yw:C.rd,fontWeight:600}}>{f(wtdMg,1)+"%"}</td>
                                {/* ANNUAL $ //var annGP=gp*zVol; */}
                                <td style={{...S.tdr,color:annGP>=0?C.gn:C.rd,fontWeight:600}}>{fK(annGP)}</td>
                              </tr>);
              });return rows.concat([<tr key="prcbtotal" style={{borderTop:"2px solid "+C.ac}}><td style={{...S.td,fontWeight:700,color:C.ac}} colSpan={12}>TOTAL</td><td style={{...S.tdr,fontWeight:700,color:prCbTotal>=0?C.gn:C.rd,fontSize:12}}>{fK(prCbTotal)}</td></tr>])})()}</tbody>
            </table>
          </div>
        </div>

        {/* //================  Combined Margin ===============// */}
        <div style={{...S.sec,background:"#0d1520",borderColor:C.ac+"40"}}>
          <div style={{...S.st,color:"#fff",borderColor:C.ac+"40"}}>Combined Margin (AUD)</div>
          <div style={{overflowX:"auto",marginBottom:10}}><table style={{...S.tbl,fontSize:10.5}}>
            <thead><tr><th style={{...S.th,color:C.ac}}>Component</th><th style={{...S.thr,color:C.ac}}>Rev/pc</th><th style={{...S.thr,color:C.ac}}>Cost/pc</th><th style={{...S.thr,color:C.ac}}>GP/pc</th><th style={{...S.thr,color:C.ac}}>Margin</th><th style={{...S.thr,color:C.ac}}>Annual Rev</th><th style={{...S.thr,color:C.ac}}>Annual Cost</th><th style={{...S.thr,color:C.ac}}>Annual GP</th></tr></thead>
            <tbody>
              {(function(){
                // Use exact same per-zone weighted calculation as cost breakdown
                var prRevTot=0;var prCostTot=0;var prGPTot=0;var prWtTot=0;
                var prwMap3=[0,1,2,3,4,5,6,6,6,6];
                var wd10p=PRW.map(function(_,i){var mi=prwMap3[i];var v=aWDist[mi]||0;return mi===6?v/4:v});
                pr.rc.forEach(function(zone){
                  var st=zone.st;var z=zone.z;var ds=aDisp[st];if(!ds)return;
                  var zPct=z===1?ds.z1:z===2?ds.z2:ds.z3;
                  var wt=ds.pct*zPct/10000;
                  zone.rates.forEach(function(r,wi){if(!r.excl){var wdPct=wd10p[wi]/100;prRevTot+=r.rate*wt*wdPct;prCostTot+=r.cost*wt*wdPct;prGPTot+=(r.rate-r.cost)*wt*wdPct;prWtTot+=wt*wdPct}});
                });
                var ppR=prWtTot>0?prRevTot/prWtTot:0;var ppC=prWtTot>0?prCostTot/prWtTot:0;var ppGP=prWtTot>0?prGPTot/prWtTot:0;
                var ppM=ppR>0?(ppGP/ppR)*100:0;
                var annR=ppR*vol*prWtTot;var annC=ppC*vol*prWtTot;var annGP=ppGP*vol*prWtTot;
                return [
                  <tr key="pp"><td style={S.td}>Per Piece (Delivery)</td><td style={{...S.tdr,color:C.ac}}>{"A$"+f(ppR)}</td><td style={{...S.tdr,color:C.rd}}>{"A$"+f(ppC)}</td><td style={{...S.tdr,color:ppGP>=0?C.gn:C.rd,fontWeight:600}}>{"A$"+f(ppGP)}</td><td style={{...S.tdr,color:ppM>=pr.margin?C.gn:ppM>=0?C.yw:C.rd}}>{f(ppM,1)+"%"}</td><td style={{...S.tdr,color:C.ac}}>{fK(annR)}</td><td style={{...S.tdr,color:C.rd}}>{fK(annC)}</td><td style={{...S.tdr,color:annGP>=0?C.gn:C.rd,fontWeight:700}}>{fK(annGP)}</td></tr>
                ]})()}
            </tbody>
          </table></div>
          <div style={grd(4)}>
            {(function(){
              var prwMap4=[0,1,2,3,4,5,6,6,6,6];
              var wd10q=PRW.map(function(_,i){var mi=prwMap4[i];var v=aWDist[mi]||0;return mi===6?v/4:v});
              var tRevTot=0;var tCostTot=0;var tWtTot=0;
              pr.rc.forEach(function(zone){
                var st=zone.st;var z=zone.z;var ds=aDisp[st];if(!ds)return;
                var zPct=z===1?ds.z1:z===2?ds.z2:ds.z3;
                var wt=ds.pct*zPct/10000;
                zone.rates.forEach(function(r,wi){if(!r.excl){var wdPct=wd10q[wi]/100;tRevTot+=r.rate*wt*wdPct;tCostTot+=r.cost*wt*wdPct;tWtTot+=wt*wdPct}});
              });
              var ppRt=tWtTot>0?tRevTot/tWtTot:0;var ppCt=tWtTot>0?tCostTot/tWtTot:0;
              var tGP=ppRt-ppCt;var tM=ppRt>0?(tGP/ppRt)*100:0;
              var netRev=ppRt*vol*tWtTot;var netGP=tGP*vol*tWtTot;
              var parcelsServed=Math.round(vol*tWtTot);
              var parcelsServedWk=Math.round(vol*tWtTot/52);
              return [
                <div key="m" style={S.met}><div style={mvS(tM>=pr.margin?C.gn:tM>=0?C.yw:C.rd)}>{f(tM,1)}%</div><div style={S.ml}>Blended Margin</div></div>,
                <Mt key="r" l="Annual Revenue (AUD)" v={"A"+fK(netRev)} c={C.ac} p="" />,
                <Mt key="g" l="Annual GP (AUD)" v={"A"+fK(netGP)} c={netGP>=0?C.gn:C.rd} p="" />,
                <div key="p" style={S.met}><div style={mvS(C.pp)}>{parcelsServedWk.toLocaleString()}</div><div style={S.ml}>Parcels / Week (offered zones)</div><div style={{fontSize:9,color:C.td,marginTop:2}}>{parcelsServed.toLocaleString()+" / yr"}</div></div>
              ]})()}
          </div>
        </div>
      </>)}

      {(prod==="pr"?pr:(prod==="pma"?pma:pmP)) && (
        <div style={{...S.sec,borderColor:C.gn+"40",background:C.gn+"05"}}>
          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
            <div><span style={{fontSize:11,fontWeight:700,color:C.gn,textTransform:"uppercase",letterSpacing:".05em"}}>Export Customer Rate Card</span><span style={{fontSize:9.5,color:C.tm,marginLeft:10}}>Rate table + per-KG rate + zone/postcode guide</span></div>
            <div style={{display:"flex",gap:6}}>
              <button onClick={function(){exportRateCard("xlsx")}} style={{fontSize:10,padding:"5px 14px",background:C.gn,color:"#fff",border:"none",cursor:"pointer",fontFamily:bf,fontWeight:600}}>Excel (.xlsx)</button>
              <button onClick={function(){exportRateCard("pdf")}} style={{fontSize:10,padding:"5px 14px",background:C.ac,color:"#fff",border:"none",cursor:"pointer",fontFamily:bf,fontWeight:600}}>Print / PDF</button>
              <button onClick={function(){exportRateCard("both")}} style={{fontSize:10,padding:"5px 14px",background:C.ad,color:"#fff",border:"none",cursor:"pointer",fontFamily:bf,fontWeight:600}}>Both</button>
            </div>
          </div>
        </div>
      )}

      {prod==="pm"&&pmP&&pmCustTgtOn&&(function(){
        var st=getSummaryStatusPM();
        return (
        <div style={{...S.sec,borderColor:st.ready?C.pp+"40":C.bd,background:st.ready?C.pp+"05":"transparent"}}>
          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:8}}>
            <div>
              <span style={{fontSize:11,fontWeight:700,color:st.ready?C.pp:C.tm,textTransform:"uppercase",letterSpacing:".05em"}}>Commercial Summary Report</span>
              <span style={{fontSize:9.5,color:C.tm,marginLeft:10}}>{st.ready?"Ready to export":"Provide the data below to unlock"}</span>
            </div>
            {st.ready&&(<button onClick={exportCommercialSummaryPM} style={{fontSize:10,padding:"5px 14px",background:C.pp,color:"#fff",border:"none",cursor:"pointer",fontFamily:bf,fontWeight:600}}>Export vs Competitor</button>)}
          </div>
          {!st.ready&&st.missing.length>0&&(<div style={{marginTop:8,padding:8,background:C.s2,border:"1px solid "+C.bd}}>{st.missing.map(function(m,i){return (<div key={i} style={{fontSize:10,color:C.rd,padding:"2px 0"}}>{"✕ Required: "+m}</div>)})}</div>)}
          {st.preferred&&st.preferred.length>0&&(<div style={{marginTop:6,padding:6,background:C.s2,border:"1px solid "+C.bd}}>{st.preferred.map(function(m,i){return (<div key={i} style={{fontSize:9.5,color:C.yw,padding:"1px 0"}}>{"ℹ "+m}</div>)})}</div>)}
        </div>);
      })()}

      {prod==="pma"&&pma&&custTgtOn&&(function(){
        var st=getSummaryStatusPMA();
        return (
        <div style={{...S.sec,borderColor:st.ready?C.pp+"40":C.bd,background:st.ready?C.pp+"05":"transparent"}}>
          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:8}}>
            <div>
              <span style={{fontSize:11,fontWeight:700,color:st.ready?C.pp:C.tm,textTransform:"uppercase",letterSpacing:".05em"}}>Commercial Summary Report</span>
              <span style={{fontSize:9.5,color:C.tm,marginLeft:10}}>{st.ready?"Ready to export":"Provide the data below to unlock"}</span>
            </div>
            {st.ready&&(<button onClick={exportCommercialSummaryPMA} style={{fontSize:10,padding:"5px 14px",background:C.pp,color:"#fff",border:"none",cursor:"pointer",fontFamily:bf,fontWeight:600}}>Export vs Competitor</button>)}
          </div>
          {!st.ready&&st.missing.length>0&&(<div style={{marginTop:8,padding:8,background:C.s2,border:"1px solid "+C.bd}}>{st.missing.map(function(m,i){return (<div key={i} style={{fontSize:10,color:C.rd,padding:"2px 0"}}>{"✕ Required: "+m}</div>)})}</div>)}
          {st.preferred&&st.preferred.length>0&&(<div style={{marginTop:6,padding:6,background:C.s2,border:"1px solid "+C.bd}}>{st.preferred.map(function(m,i){return (<div key={i} style={{fontSize:9.5,color:C.yw,padding:"1px 0"}}>{"ℹ "+m}</div>)})}</div>)}
        </div>);
      })()}

        {/* //================  competitor rate mapper ===============// */}

      {prod==="pr"&&(<div style={{...S.sec,borderColor:mapOpen?C.cy+"40":C.bd}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:8}}>
          <span style={{fontSize:11,fontWeight:700,color:C.cy,textTransform:"uppercase",letterSpacing:".05em"}}>Competitor Rate Mapper</span>
          <button onClick={function(){sMapOpen(!mapOpen)}} style={{fontSize:10,padding:"4px 12px",background:mapOpen?C.cy:C.s2,color:mapOpen?"#000":C.cy,border:"1px solid "+C.cy+"60",cursor:"pointer",fontFamily:bf,fontWeight:600,borderRadius:0}}>{mapOpen?"Close Mapper":"Open Mapper"}</button>
        </div>
        <div style={{fontSize:9,color:C.tm,marginTop:4}}>Upload competitor postcode-zone + rate card files. The system auto-detects file types, maps competitor zones to DAI zones, and calculates blended rates.</div>
        {mapOpen&&(<div style={{marginTop:12}}>
          <div style={{display:"flex",gap:10,alignItems:"center",flexWrap:"wrap",marginBottom:10}}>
            <Fl l="Competitor Name"><input style={{...S.inp,fontWeight:700,color:C.cy}} value={compLabel} onChange={function(e){sCompLabel(e.target.value)}} /></Fl>
            <Fl l="Populate Target Slot"><select style={{...S.sel,fontWeight:700,color:C.cy}} value={mapWhich} onChange={function(e){sMapWhich(+e.target.value)}}>{prTgts.map(function(t,ti){return (<option key={ti} value={ti}>{"Target "+(ti+1)+" ("+t.label+")"}</option>)})}</select></Fl>
            {mapOrigins.length>1&&(<Fl l={"Origin ("+mapOrigins.length+" detected)"}><select style={{...S.sel,fontWeight:700,color:C.ac}} value={mapSelOrig} onChange={function(e){switchOrigin(e.target.value)}}>{mapOrigins.map(function(o){return (<option key={o} value={o}>{o}</option>)})}</select></Fl>)}
            <Fl l="Rates include FSC?"><select style={{...S.sel,fontWeight:700,color:mapFsc==="exclusive"?C.yw:C.gn}} value={mapFsc} onChange={function(e){sMapFsc(e.target.value)}}><option value="inclusive">Yes - FSC inclusive</option><option value="exclusive">No - add FSC on top</option></select></Fl>
            {mapFsc==="exclusive"&&(<Fl l="FSC %"><input style={{...S.inp,width:60,fontWeight:700,color:C.yw,textAlign:"right"}} type="number" step=".5" value={mapFscPct} onChange={function(e){sMapFscPct(+e.target.value||0)}} /></Fl>)}
          </div>
          {mapFsc==="exclusive"&&(<div style={{fontSize:9,color:C.yw,marginBottom:8,padding:"4px 8px",background:C.yw+"10",border:"1px solid "+C.yw+"30"}}>{"FSC "+mapFscPct+"% will be added to all competitor rates before blending. Blended rates shown below include FSC."}</div>)}

          <div style={{padding:10,background:C.s2,border:"1px solid "+C.bd,marginBottom:10}}>
            <div style={{fontSize:10,fontWeight:700,color:C.tx,marginBottom:6}}>Upload Files (multi-select: postcode file + rate card)</div>
            <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap"}}>
              <input ref={compFileRef} type="file" accept=".csv,.txt,.xlsx,.xls" onChange={handleMapperUpload} multiple style={{display:"none"}} />
              <button onClick={function(){compFileRef.current&&compFileRef.current.click()}} style={{padding:"5px 14px",background:C.s2,border:"1px solid "+C.cy+"60",color:C.cy,fontFamily:bf,fontSize:10.5,cursor:"pointer",borderRadius:0}}>Upload Files (multi-select)</button>
              {mapFiles.length>0&&mapFiles.map(function(mf,i){return (<span key={i} style={{fontSize:9,color:mf.type==="postcodes"?C.gn:mf.type==="rates"?C.ac:C.yw,padding:"2px 6px",background:C.bg,border:"1px solid "+C.bd}}>{"✓ "+mf.name+" -> "+(mf.type==="postcodes"?"Postcodes ("+mf.rows+" rows)":mf.type==="rates"?"Rate Card ("+mf.rows+" zones)":"Unknown")}</span>)})}
              {compPcMap&&mapStats&&!mapStats.hasRateFile&&(<span style={{fontSize:9,color:C.yw}}>No rate card detected -- enter rates manually below</span>)}
            </div>
            {mapLog.length>0&&(<div style={{marginTop:6,padding:6,background:C.bg,border:"1px solid "+C.bd,maxHeight:100,overflowY:"auto"}}>{mapLog.map(function(l,i){return (<div key={i} style={{fontSize:8.5,color:l.startsWith("✕")?C.rd:l.startsWith("✓")?C.gn:C.tm,fontFamily:"monospace"}}>{l}</div>)})}</div>)}
            {mapStats&&(<div style={{fontSize:9,color:C.tm,marginTop:4}}>{"DAI zone coverage: "+mapStats.coverage+"% ("+mapStats.matched+" of "+mapStats.daiTotal+" postcodes matched)  ·  "+(mapStats.totalPc||0)+" suburb entries across "+(mapStats.uniquePcs||0)+" postcodes  ·  "+mapStats.zoneCount+" competitor zones"}</div>)}
          </div>

          {compZones.length>0&&(<div style={{padding:10,background:C.s2,border:"1px solid "+C.bd,marginBottom:10}}>
            <div style={{fontSize:10,fontWeight:700,color:C.tx,marginBottom:6}}>{mapStats&&mapStats.hasRateFile?"Parsed Competitor Rates (editable)":"Enter Competitor Rates per Zone (A$ per parcel)"}</div>
            <div style={{overflowX:"auto"}}>
              <table style={{borderCollapse:"collapse",fontSize:9.5,width:"100%"}}>
                <thead><tr>
                  <th style={{...S.th,position:"sticky",left:0,background:C.s2,zIndex:2,minWidth:80}}>Comp Zone</th>
                  {!compPcMap&&(<th style={{...S.th,minWidth:50}}>Tier</th>)}
                  {!compPcMap&&(<th style={{...S.th,minWidth:50}}>State</th>)}
                  {PRW.map(function(w,i){return (<th key={i} style={{...S.th,textAlign:"right",minWidth:52}}>{PRWL[i]+"kg"}</th>)})}
                </tr></thead>
                <tbody>{compZones.map(function(cz){return (
                  <tr key={cz}>
                    <td style={{...S.td,position:"sticky",left:0,background:C.sf,zIndex:1,fontWeight:700,color:C.cy}}>{cz}{compZoneDescs[cz]&&(<span style={{fontWeight:400,color:C.tm,fontSize:8,marginLeft:4}}>{compZoneDescs[cz]}</span>)}</td>
                    {!compPcMap&&(<td style={S.td}><select style={{...S.sel,fontSize:8,padding:"2px",width:44,color:compZoneTiers[cz]?C.gn:C.td}} value={compZoneTiers[cz]||""} onChange={function(e){sCompZoneTiers(function(prev){var n=Object.assign({},prev);if(e.target.value)n[cz]=e.target.value;else delete n[cz];return n})}}><option value="">--</option><option value="Z1">Z1</option><option value="Z2">Z2</option><option value="Z3">Z3</option></select></td>)}
                    {!compPcMap&&(<td style={S.td}><select style={{...S.sel,fontSize:8,padding:"2px",width:52,color:compZoneStates[cz]?C.ac:C.td}} value={compZoneStates[cz]||""} onChange={function(e){sCompZoneStates(function(prev){var n=Object.assign({},prev);if(e.target.value)n[cz]=e.target.value;else delete n[cz];return n})}}><option value="">--</option><option value="NSW">NSW</option><option value="VIC">VIC</option><option value="QLD">QLD</option><option value="SA">SA</option><option value="WA">WA</option><option value="TAS">TAS</option><option value="NT">NT</option><option value="ACT">ACT</option></select></td>)}
                    {PRW.map(function(_,wi){return (
                      <td key={wi} style={{...S.tdr,padding:0}}>
                        <input type="number" step=".01" style={{width:"100%",background:"transparent",border:"1px solid "+C.bd,color:compRates[cz]&&compRates[cz][wi]>0?C.tx:C.td,textAlign:"right",fontSize:9.5,padding:"3px 4px",fontFamily:bf}} value={(compRates[cz]&&compRates[cz][wi])||""} onChange={function(e){var v=+e.target.value||0;sCompRates(function(prev){var n={...prev};n[cz]=[...(n[cz]||PRW.map(function(){return 0}))];n[cz][wi]=v;return n})}} />
                      </td>
                    )})}
                  </tr>
                )})}</tbody>
              </table>
            </div>
            <div style={{marginTop:8,display:"flex",gap:8,flexWrap:"wrap"}}>
              <button onClick={runMapper} disabled={!compPcMap} style={{padding:"6px 16px",background:compPcMap?C.cy:C.s2,color:compPcMap?"#000":C.td,border:"none",cursor:compPcMap?"pointer":"default",fontFamily:bf,fontSize:10.5,fontWeight:700,borderRadius:0}}>{mapResult?"Recalculate":"Calculate Blended Rates"}</button>
              {!compPcMap&&Object.keys(compZoneTiers).length>0&&(<button onClick={runEstimate} style={{padding:"6px 16px",background:C.yw,color:"#000",border:"none",cursor:"pointer",fontFamily:bf,fontSize:10.5,fontWeight:700,borderRadius:0}}>Estimate Zone Rates (no postcode file)</button>)}
              {mapResult&&mapStats&&mapStats.estimated&&(<button onClick={applyEstimateResult} style={{padding:"6px 16px",background:C.gn,color:"#000",border:"none",cursor:"pointer",fontFamily:bf,fontSize:10.5,fontWeight:700,borderRadius:0}}>{"Apply Estimate to Target "+(mapWhich+1)}</button>)}
              {mapResult&&!mapStats.estimated&&(<button onClick={applyMapResult} style={{padding:"6px 16px",background:C.gn,color:"#000",border:"none",cursor:"pointer",fontFamily:bf,fontSize:10.5,fontWeight:700,borderRadius:0}}>{"Apply "+(mapSelOrig||compLabel)+" to Target "+(mapWhich+1)}</button>)}
              {mapResult&&mapOrigins.length>1&&(<button onClick={applyAllOrigins} style={{padding:"6px 16px",background:C.pp,color:"#fff",border:"none",cursor:"pointer",fontFamily:bf,fontSize:10.5,fontWeight:700,borderRadius:0}}>{"Apply ALL "+mapOrigins.length+" origins to matching opps"}</button>)}
              {mapResult&&(<button onClick={exportMappingReport} style={{padding:"6px 16px",background:C.ac,color:"#fff",border:"none",cursor:"pointer",fontFamily:bf,fontSize:10.5,fontWeight:700,borderRadius:0}}>View Mapping Report</button>)}
              {mapResult&&(<button onClick={function(){sMapResult(null);sCompPcMap(null);sCompZones([]);sCompRates({});sMapStats(null);sMapFiles([]);sMapLog([])}} style={{padding:"6px 12px",background:"transparent",border:"1px solid "+C.rd+"60",color:C.rd,cursor:"pointer",fontFamily:bf,fontSize:9.5,borderRadius:0}}>Clear All</button>)}
            </div>
          </div>)}

          {mapResult&&mapStats&&mapStats.details&&(<div style={{padding:10,background:C.s2,border:"1px solid "+C.gn+"40",marginBottom:10}}>
            <div style={{fontSize:10,fontWeight:700,color:C.gn,marginBottom:6}}>{"✓ Blended Rates Calculated -- "+mapStats.resultZones+" DAI zones mapped"}</div>
            <div style={{overflowX:"auto"}}>
              <table style={{borderCollapse:"collapse",fontSize:9.5,width:"100%"}}>
                <thead><tr>
                  <th style={{...S.th,position:"sticky",left:0,background:C.s2,zIndex:2,minWidth:70}}>DAI Zone</th>
                  <th style={{...S.th,textAlign:"right",minWidth:50}}>Suburbs</th>
                  <th style={{...S.th,minWidth:140}}>Comp Zone Breakdown (suburb-weighted)</th>
                  {PRW.map(function(w,i){return (<th key={i} style={{...S.th,textAlign:"right",minWidth:48}}>{PRWL[i]+"kg"}</th>)})}
                </tr></thead>
                <tbody>{Object.keys(mapResult).sort().map(function(dz){
                  var d=mapStats.details[dz];var rates=mapResult[dz];
                  return (<tr key={dz}>
                    <td style={{...S.td,position:"sticky",left:0,background:C.sf,zIndex:1,fontWeight:700,color:C.ac}}>{dz}</td>
                    <td style={{...S.tdr}}>{d?d.mapped:0}</td>
                    <td style={{...S.td,fontSize:8,color:C.tm}}>{d?d.breakdown.map(function(b){return b.zone+" "+b.pct+"%"}).join(" · "):""}</td>
                    {rates.map(function(r,wi){return (<td key={wi} style={{...S.tdr,fontWeight:700,color:r>0?C.gn:C.td}}>{"$"+f(r)}</td>)})}
                  </tr>);
                })}</tbody>
              </table>
            </div>
            {mapAnomalies.length>0&&(<div style={{marginTop:8,padding:10,background:C.yw+"10",border:"1px solid "+C.yw+"40"}}>
              <div style={{fontSize:10,fontWeight:700,color:C.yw,marginBottom:6}}>{"Zone mismatches detected -- "+mapAnomalies.length+" anomal"+(mapAnomalies.length===1?"y":"ies")+" found"}</div>
              <div style={{fontSize:9,color:C.tm,marginBottom:6}}>Small numbers of suburbs in expensive competitor zones are inflating some DAI zone averages:</div>
              <table style={{borderCollapse:"collapse",fontSize:9,width:"100%"}}>
                <thead><tr><th style={{...S.th,width:30}}></th><th style={S.th}>DAI Zone</th><th style={S.th}>Comp Zone</th><th style={{...S.thr}}>Suburbs</th><th style={{...S.thr}}>% of Zone</th><th style={{...S.thr}}>Comp 0.5kg</th><th style={{...S.thr}}>Blended With</th><th style={{...S.thr,color:C.gn}}>Without</th><th style={{...S.thr,color:C.yw}}>Impact</th><th style={{...S.thr}}>Contrib</th>{prRouting&&<th style={{...S.thr,color:C.ac}}>DAI 0.5kg</th>}</tr></thead>
                <tbody>{mapAnomalies.map(function(a,ai){
                  var totalSubs=a.subPct>0?Math.round(a.suburbs/(a.subPct/100)):a.suburbs;
                  var cleanSubs=totalSubs-a.suburbs;
                  var cleanRate=cleanSubs>0?Math.round((a.blended05*totalSubs-a.rate05*a.suburbs)/cleanSubs*100)/100:0;
                  var impact=Math.round((a.blended05-cleanRate)*100)/100;
                  // Compute DAI avg cost for postcodes in this anomaly (comp zone ∩ DAI zone)
                  var daiAvg=null;
                  if(prRouting&&compPcMap){
                    var costSum=0;var costCt=0;
                    Object.keys(compPcMap).forEach(function(pc){
                      var czMap=compPcMap[pc];if(!czMap||!czMap[a.compZone])return;
                      // Check this postcode maps to the same DAI zone
                      var pcKey=pc.replace(/^0+/,'');
                      var zdE=ZD[pcKey];var zdStr=zdE?(Array.isArray(zdE)?zdE[0]:zdE):null;
                      var dz=zdStr?daiZoneKey(zdStr):null;
                      if(dz!==a.daiZone)return;
                      var subs=prRouting.byPostcode[pcKey];
                      if(!subs)return;
                      subs.forEach(function(s){
                        if(s.costs&&s.costs[1]>0){costSum+=s.costs[1];costCt++;}
                      });
                    });
                    if(costCt>0)daiAvg=Math.round(costSum/costCt*100)/100;
                  }
                  return (<tr key={ai} style={{opacity:mapAnomSel[ai]?1:0.5}}>
                    <td style={S.td}><input type="checkbox" checked={!!mapAnomSel[ai]} onChange={function(){sMapAnomSel(function(prev){var n=Object.assign({},prev);if(n[ai])delete n[ai];else n[ai]=true;return n})}} /></td>
                    <td style={{...S.td,fontWeight:700,color:C.ac}}>{a.daiZone}</td>
                    <td style={{...S.td,fontWeight:700,color:C.rd}}>{a.compZone}</td>
                    <td style={S.tdr}>{a.suburbs}</td>
                    <td style={S.tdr}>{a.subPct+"%"}</td>
                    <td style={{...S.tdr,color:C.rd,fontWeight:700}}>{"$"+f(a.rate05)}</td>
                    <td style={{...S.tdr,fontWeight:700}}>{"$"+f(a.blended05)}</td>
                    <td style={{...S.tdr,fontWeight:700,color:C.gn}}>{"$"+f(cleanRate)}</td>
                    <td style={{...S.tdr,fontWeight:700,color:C.yw}}>{"-$"+f(impact)}</td>
                    <td style={{...S.tdr,color:C.tm}}>{a.contribPct+"%"}</td>
                    {prRouting&&<td style={{...S.tdr,fontWeight:700,color:daiAvg?C.ac:C.td}}>{daiAvg?"$"+f(daiAvg):"—"}</td>}
                  </tr>)})}</tbody>
              </table>
              <div style={{marginTop:8,display:"flex",gap:8,alignItems:"center"}}>
                {!mapExclAnom&&Object.keys(mapAnomSel).length>0&&(<button onClick={runMapperClean} style={{padding:"5px 14px",background:C.yw,color:"#000",border:"none",cursor:"pointer",fontFamily:bf,fontSize:10,fontWeight:700,borderRadius:0}}>{"Recalculate without "+Object.keys(mapAnomSel).length+" selected anomal"+(Object.keys(mapAnomSel).length===1?"y":"ies")}</button>)}
                {!mapExclAnom&&Object.keys(mapAnomSel).length===0&&(<span style={{fontSize:9,color:C.tm}}>Tick the anomalies you want to exclude, then recalculate</span>)}
                {mapExclAnom&&(<><span style={{fontSize:10,color:C.gn,fontWeight:700}}>{"✓ "+Object.keys(mapAnomSel).length+" anomal"+(Object.keys(mapAnomSel).length===1?"y":"ies")+" removed -- rates recalculated"}</span><button onClick={runMapperReset} style={{padding:"5px 10px",background:"transparent",border:"1px solid "+C.tm+"60",color:C.tm,cursor:"pointer",fontFamily:bf,fontSize:9,borderRadius:0}}>Restore original rates</button></>)}
              </div>
            </div>)}
          </div>)}
        </div>)}
      </div>)}

      {prod==="pr"&&pr&&prTgts.some(function(t){return t.on})&&(function(){
        var statuses=prTgts.map(function(t,i){return t.on?getSummaryStatus(i):{ready:false,missing:[],preferred:[]}});
        var anyReady=statuses.some(function(s){return s.ready});
        var allMissing=[];var allPreferred=[];
        statuses.forEach(function(s){if(!s.ready)s.missing.forEach(function(m){if(allMissing.indexOf(m)<0)allMissing.push(m)})});
        var pSrc=statuses.find(function(s){return s.ready})||statuses[0];
        if(pSrc&&pSrc.preferred)pSrc.preferred.forEach(function(m){if(allPreferred.indexOf(m)<0)allPreferred.push(m)});
        var scenCount=(prCompBasis==="unknown"?2:1)*(prCompFsc==="unknown"?2:1);
        return (
        <div style={{...S.sec,borderColor:anyReady?C.pp+"40":C.bd,background:anyReady?C.pp+"05":"transparent"}}>
          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:8}}>
            <div>
              <span style={{fontSize:11,fontWeight:700,color:anyReady?C.pp:C.tm,textTransform:"uppercase",letterSpacing:".05em"}}>Commercial Summary Report</span>
              <span style={{fontSize:9.5,color:C.tm,marginLeft:10}}>{anyReady?(scenCount>1?"Ready -- will generate "+scenCount+" scenarios for unknowns":"Ready to export"):"Provide the data below to unlock"}</span>
            </div>
            {anyReady&&(<div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
              {prTgts.map(function(t,ti){var s=statuses[ti];return s&&s.ready?(<button key={ti} onClick={function(){exportCommercialSummary(ti)}} style={{fontSize:10,padding:"5px 14px",background:[C.pp,C.ad,C.cy,C.gn,C.ac][ti%5],color:"#fff",border:"none",cursor:"pointer",fontFamily:bf,fontWeight:600}}>{"Export vs "+t.label}</button>):null})}
              {custRows&&anyReady&&(<button onClick={function(){exportParcelAnalysis(0)}} style={{fontSize:10,padding:"5px 14px",background:C.gn+"20",border:"1px solid "+C.gn,color:C.gn,cursor:"pointer",fontFamily:bf,fontWeight:600}}>{"Parcel-Level Analysis (XLSX) -- "+custRows.length.toLocaleString()+" parcels"}</button>)}
              {!custRows&&anyReady&&(<><input ref={parcelFileRef} type="file" accept=".csv,.txt,.xlsx,.xls" multiple onChange={handleParcelReUpload} style={{display:"none"}} /><button onClick={function(){parcelFileRef.current&&parcelFileRef.current.click()}} style={{fontSize:10,padding:"5px 14px",background:C.s2,border:"1px solid "+C.gn+"60",color:C.gn,cursor:"pointer",fontFamily:bf,fontWeight:600}}>Upload Parcel Data for XLSX Analysis</button></>)}
            </div>)}
          </div>
          {!anyReady&&allMissing.length>0&&(
            <div style={{marginTop:8,padding:8,background:C.s2,border:"1px solid "+C.bd}}>
              {allMissing.map(function(m,i){return (<div key={i} style={{fontSize:10,color:C.rd,padding:"2px 0"}}>{"✕ Required: "+m}</div>)})}
            </div>
          )}
          <div style={{...grd(4),marginTop:10}}>
            <div><label style={S.lb}>Competitor Weight Basis</label><select style={{...S.sel,color:prCompBasis==="unknown"?C.yw:C.gn,fontWeight:600}} value={prCompBasis} onChange={function(e){sPrCompBasis(e.target.value)}}><option value="unknown">Unknown (scenario both)</option><option value="physical">Physical Weight</option><option value="volumetric">Volumetric Weight</option></select></div>
            <div><label style={S.lb}>Customer DIM</label><input style={{...S.inp,fontWeight:700,color:prDim>1?C.gn:C.tm}} type="number" step=".01" value={prDim} onChange={function(e){sPrDim(+e.target.value||1)}} /><div style={{fontSize:8,color:C.td,marginTop:2}}>{prCompBasis==="volumetric"?"Used to rebucket competitor weight bands":"Only needed if competitor is volumetric"}</div></div>
          </div>
          {allPreferred.length>0&&(
            <div style={{marginTop:6,padding:6,background:C.s2,border:"1px solid "+C.bd}}>
              {allPreferred.map(function(m,i){return (<div key={i} style={{fontSize:9.5,color:C.yw,padding:"1px 0"}}>{"ℹ "+m}</div>)})}
            </div>
          )}
        </div>);
      })()}

      {reportHTML&&(
        <div id="cs-report-wrapper" style={{...S.sec,borderColor:C.pp+"60",background:C.sf,padding:0,marginBottom:10}}>
          <style dangerouslySetInnerHTML={{__html:"@media print{body>*,body>*>*{visibility:hidden!important;height:0!important;overflow:hidden!important;margin:0!important;padding:0!important}#cs-report-wrapper,#cs-report-wrapper *{visibility:visible!important;height:auto!important;overflow:visible!important}.cs-toolbar{display:none!important}.cs-report{padding:0!important}}"}} />
          <div className="cs-toolbar" style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"10px 12px",borderBottom:"1px solid "+C.bd,background:C.s2}}>
            <span style={{fontSize:11,fontWeight:700,color:C.pp,textTransform:"uppercase",letterSpacing:".05em"}}>Commercial Summary Report</span>
            <div style={{display:"flex",gap:6}}>
              <button onClick={function(){window.print()}} style={{fontSize:9,padding:"4px 10px",background:C.gn,color:"#fff",border:"none",cursor:"pointer",fontFamily:bf,fontWeight:600}}>Save as PDF</button>
              <button onClick={function(){try{var blob=new Blob([reportHTML],{type:"text/html"});var url=URL.createObjectURL(blob);var a=document.createElement("a");a.href=url;a.download="Commercial_Summary.html";document.body.appendChild(a);a.click();document.body.removeChild(a);setTimeout(function(){URL.revokeObjectURL(url)},1000)}catch(e){}}} style={{fontSize:9,padding:"4px 10px",background:C.ad,color:"#fff",border:"none",cursor:"pointer",fontFamily:bf,fontWeight:600}}>Download HTML</button>
              <button onClick={function(){sReportHTML(null)}} style={{fontSize:9,padding:"4px 10px",background:C.rd,color:"#fff",border:"none",cursor:"pointer",fontFamily:bf,fontWeight:600}}>Close</button>
            </div>
          </div>
          <div className="cs-report" style={{padding:0,background:"#fff",borderRadius:"0 0 0 0"}} dangerouslySetInnerHTML={{__html:(function(){var styles=(reportHTML.match(/<style>([\s\S]*?)<\/style>/)||["",""])[1];var scoped=styles.replace(/body\{/g,".cs-report{").replace(/body /g,".cs-report ");var body=reportHTML.replace(/[\s\S]*<body>/,"").replace(/<\/body>[\s\S]*/,"");return "<style>"+scoped+"</style><div class='cs-report'>"+body+"</div>"})()}} />
        </div>
      )}
      </>)}

      {mainTab==="routing"&&(function(){
        var rtData=rtView==="pm"?pmRouting:prRouting;
        var rtLabel=rtView==="pm"?"Parcel Max":"Parcel Right";
        var RTCO={"#2563EB":"TGE","#EA580C":"FW","#7C3AED":"PFL","#059669":"PR","#DC2626":"APO","#0891B2":"DGF","#6B7280":"NULL"};
        // Zone ordering: state then Z1/Z2/Z3
        var RT_ZONES_ORDERED=[];
        STS.forEach(function(st){[1,2,3].forEach(function(z){RT_ZONES_ORDERED.push(st+"-Z"+z)})});
        // FMC weight index map: routing[i] → FMC index (null if no match)
        var RT_TO_FMC=[null,0,1,2,3,4,5,6,7,8,9];
        // Blended Z1/Z2/Z3 cost across network using DD dispersion
        function calcBlendedZoneCost(data){
          if(!data||!data.byZone)return null;
          var res={Z1:Array(11).fill(0),Z2:Array(11).fill(0),Z3:Array(11).fill(0)};
          var wts={Z1:0,Z2:0,Z3:0};
          STS.forEach(function(st){
            var dd=DD[st];if(!dd)return;
            [1,2,3].forEach(function(z){
              var zk=st+"-Z"+z;var zd=data.byZone[zk];if(!zd)return;
              var pct=dd.pct*(z===1?dd.z1:z===2?dd.z2:dd.z3)/10000;
              if(pct<=0)return;
              var key="Z"+z;wts[key]+=pct;
              for(var wi=0;wi<11;wi++){res[key][wi]+=zd.avgCosts[wi]*pct}
            });
          });
          ["Z1","Z2","Z3"].forEach(function(zk){if(wts[zk]>0)for(var wi=0;wi<11;wi++)res[zk][wi]=Math.round(res[zk][wi]/wts[zk]*100)/100});
          return res;
        }
        // When PM billing data loaded, compute blended using actual dispersion
        function calcBlendedFromBilling(bd){
          if(!bd||!bd.byZone||!bd.stateDisp)return null;
          var res={Z1:Array(11).fill(0),Z2:Array(11).fill(0),Z3:Array(11).fill(0)};
          var wts={Z1:0,Z2:0,Z3:0};
          STS.forEach(function(st){
            var disp=bd.stateDisp[st];if(!disp||disp.pct<=0)return;
            [1,2,3].forEach(function(z){
              var zk=st+'-Z'+z;var zd=bd.byZone[zk];if(!zd||!zd.avgCosts)return;
              var pct=disp.pct*(z===1?disp.z1:z===2?disp.z2:disp.z3)/10000;
              if(pct<=0)return;
              var key='Z'+z;wts[key]+=pct;
              for(var wi=0;wi<11;wi++){res[key][wi]+=zd.avgCosts[wi]*pct}
            });
          });
          ['Z1','Z2','Z3'].forEach(function(zk){if(wts[zk]>0)for(var wi=0;wi<11;wi++)res[zk][wi]=Math.round(res[zk][wi]/wts[zk]*100)/100});
          return res;
        }
        var useBillingBlended=rtView==="pm"&&pmBillingData&&pmBillingData.byZone;
        var blended=useBillingBlended?calcBlendedFromBilling(pmBillingData):(rtData?calcBlendedZoneCost(rtData):null);
        var blendedSource=useBillingBlended?('Actual Billing Data · '+pmBillingData.dateRange.min+' to '+pmBillingData.dateRange.max):'DAI Standard Dispersion';


        return (
        <div>
          {/* Upload row — combined file (new format) or individual per product */}
          <div style={{marginBottom:10}}>
            {/* Combined upload — primary for new two-tab format */}
            <div style={{padding:12,background:(pmRouting&&prRouting)?C.gn+"12":C.s2,border:"2px solid "+((pmRouting&&prRouting)?C.gn+"60":"#7C3AED40"),marginBottom:8}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
                <div>
                  <span style={{fontSize:10,fontWeight:700,color:(pmRouting&&prRouting)?C.gn:"#7C3AED",textTransform:"uppercase",letterSpacing:".05em"}}>{"DAI Routing File (PM + PR)"+(pmRouting&&prRouting?" ✓":"")}</span>
                  <span style={{fontSize:9,color:C.td,marginLeft:10}}>FMC_live_reference_for_AC.xlsx — contains both tabs</span>
                </div>
                <div style={{display:"flex",gap:4}}>
                  {(pmRouting||prRouting)&&<button onClick={function(){clearRouting('pm');clearRouting('pr')}} style={{fontSize:9,padding:"3px 8px",background:"transparent",border:"1px solid "+C.rd+"60",color:C.rd,cursor:"pointer",fontFamily:bf}}>Clear Both</button>}
                  <input type="file" accept=".xlsx,.xls" ref={pmRtRef} style={{display:"none"}} onChange={function(e){handleRoutingUpload(e,'pm')}} />
                  <button onClick={function(){pmRtRef.current&&pmRtRef.current.click()}} style={{fontSize:9,padding:"4px 14px",background:"#7C3AED",border:"none",color:"#fff",cursor:"pointer",fontFamily:bf,fontWeight:700}}>Upload Combined XLSX</button>
                </div>
              </div>
              <div style={{display:"flex",gap:20,flexWrap:"wrap"}}>
                {["pm","pr"].map(function(p){
                  var loaded=p==="pm"?pmRouting:prRouting;
                  var sv=p==="pm"?pmRtSave:prRtSave;
                  var lbl=p==="pm"?"Parcel Max":"Parcel Right";
                  return (<div key={p} style={{fontSize:9}}>
                    <span style={{fontWeight:700,color:loaded?C.gn:C.td}}>{lbl+": "}</span>
                    {loaded?(<span style={{color:C.tx}}>
                      <b style={{color:C.ac}}>{loaded.totalSuburbs.toLocaleString()}</b> suburbs · <b style={{color:C.ac}}>{loaded.totalPostcodes.toLocaleString()}</b> postcodes
                      {loaded.nullList&&loaded.nullList.length>0&&<span style={{color:C.rd}}> · <b>{loaded.nullList.length}</b> not serviced</span>}
                      {loaded.roaList&&loaded.roaList.length>0&&<span style={{color:C.yw}}> · <b>{loaded.roaList.length}</b> ROA→Z3</span>}
                      {loaded.formatVersion===2&&<span style={{color:"#7C3AED"}}> · zone file ✓</span>}
                    </span>):<span style={{color:C.td}}>not loaded</span>}
                    {sv==="saving"&&<span style={{color:C.yw,marginLeft:6}}>⏳ saving...</span>}
                    {sv==="saved"&&<span style={{color:C.gn,marginLeft:6}}>✓ saved</span>}
                    {sv==="error"&&<span style={{color:C.rd,marginLeft:6,fontWeight:700}}>⚠ save failed — session only</span>}
                  </div>);
                })}
              </div>
            </div>
            {/* Individual per-product fallback */}
            <div style={{display:"flex",gap:6,alignItems:"center"}}>
              <span style={{fontSize:9,color:C.td}}>Upload individually:</span>
              {["pm","pr"].map(function(p){
                var ref=p==="pm"?prRtRef:pmRtRef;
                return (<span key={p}>
                  <input type="file" accept=".xlsx,.xls" ref={ref} style={{display:"none"}} onChange={function(e){handleRoutingUpload(e,p)}} />
                  <button onClick={function(){ref.current&&ref.current.click()}} style={{fontSize:8.5,padding:"2px 8px",background:"transparent",border:"1px solid "+C.bd,color:C.td,cursor:"pointer",fontFamily:bf}}>{(p==="pm"?"PM":"PR")+" only"}</button>
                </span>);
              })}
            </div>
          </div>

          {/* Sub-tab: PM / PR */}
          <div style={{display:"flex",gap:1,marginBottom:10}}>
            {["pm","pr"].map(function(p){
              var loaded=p==="pm"?pmRouting:prRouting;
              var lbl=(p==="pm"?"Parcel Max":"Parcel Right")+(loaded?" ✓":"");
              return (<button key={p} onClick={function(){sRtView(p);sRtSearchResult(null);sRtSearch("")}} style={{padding:"6px 16px",background:rtView===p?C.s2:C.bg,border:"1px solid "+(rtView===p?"#7C3AED":C.bd),color:rtView===p?"#7C3AED":C.td,fontFamily:bf,fontSize:10.5,cursor:"pointer",fontWeight:rtView===p?700:400}}>{lbl}</button>);
            })}
          </div>


          {!rtData&&(
            <div style={{padding:40,textAlign:"center",color:C.td,fontSize:11}}>Upload the {rtLabel} routing XLSX above to load carrier data</div>
          )}

          {rtData&&(<>
            {/* Section tabs */}
            <div style={{display:"flex",gap:1,marginBottom:10}}>
              {[["summary","Overview"],["zones","Zone Costs"],["lookup","Lookup"]].map(function(s){
                return (<button key={s[0]} onClick={function(){sRtSection(s[0]);if(s[0]!=="lookup")sRtSearchResult(null)}} style={{padding:"5px 14px",background:rtSection===s[0]?C.s2:C.bg,border:"1px solid "+(rtSection===s[0]?C.bd:C.bd+"80"),color:rtSection===s[0]?C.ac:C.td,fontFamily:bf,fontSize:10,cursor:"pointer",fontWeight:rtSection===s[0]?700:400}}>{s[1]}</button>);
              })}
            </div>

            {/* OVERVIEW */}
            {rtSection==="summary"&&(function(){
              var total=rtData.totalSuburbs;
              var isPM=rtView==="pm";
              var sortedC=Object.entries(rtData.carrierTotals).sort(function(a,b){return b[1]-a[1]});
              return (
                <div>
                  {/* Summary metrics */}
                  <div style={{...grd(5),marginBottom:12}}>
                    <div style={S.met}><div style={{fontSize:15,fontWeight:700,color:C.ac}}>{rtData.totalSuburbs.toLocaleString()}</div><div style={S.ml}>Total Suburbs</div></div>
                    <div style={S.met}><div style={{fontSize:15,fontWeight:700,color:C.ac}}>{rtData.totalPostcodes.toLocaleString()}</div><div style={S.ml}>Postcodes</div></div>
                    <div style={S.met}><div style={{fontSize:15,fontWeight:700,color:rtData.nullList.length>0?C.rd:C.gn}}>{rtData.nullList.length.toLocaleString()}</div><div style={S.ml}>No Service (NULL)</div></div>
                    <div style={S.met}><div style={{fontSize:15,fontWeight:700,color:C.yw}}>{rtData.mixedCount.toLocaleString()}</div><div style={S.ml}>Mixed Carrier</div></div>
                    <div style={S.met}><div style={{fontSize:15,fontWeight:700,color:C.pp}}>{Object.keys(rtData.carrierTotals).length}</div><div style={S.ml}>Carrier Codes</div></div>
                  </div>

                  {/* Carrier mix stacked bar */}
                  <div style={{...S.sec,marginBottom:10}}>
                    <div style={{...S.st,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                      <span>Carrier Mix (by suburb, primary carrier)</span>
                      {isPM&&pmBillingData&&<span style={{fontSize:9,color:C.ac,fontWeight:600}}>{"+ Actual parcel volume · "+pmBillingData.dateRange.min+" to "+pmBillingData.dateRange.max+" (4 weeks)"}</span>}
                      {isPM&&!pmBillingData&&<span style={{fontSize:9,color:C.td}}>Upload billing CSV in Zone Costs tab to add actual parcel volume</span>}
                    </div>
                    <div style={{display:"flex",height:24,width:"100%",marginBottom:10,overflow:"hidden",borderRadius:2}}>
                      {sortedC.map(function(kv){
                        var code=kv[0];var count=kv[1];
                        var pct=total>0?count/total*100:0;
                        var info=RT_CARRIERS[code]||{name:code,color:"#6B7280"};
                        return (<div key={code} title={code+": "+count.toLocaleString()+" suburbs ("+f(pct,1)+"%)"} style={{width:pct+"%",background:info.color,minWidth:pct>1?2:0}} />);
                      })}
                    </div>
                    <table style={S.tbl}>
                      <thead><tr>
                        <th style={S.th}>Carrier</th>
                        <th style={S.thr}>Suburbs</th>
                        <th style={S.thr}>Suburb %</th>
                        {isPM&&pmBillingData&&<th style={{...S.thr,color:C.ac}}>Parcel Vol %</th>}
                        {isPM&&pmBillingData&&<th style={{...S.thr,color:C.ac}}>Parcels</th>}
                        {isPM&&pmBillingData&&<th style={{...S.thr,color:C.ac}}>Avg Cost</th>}
                        <th style={S.th}></th>
                      </tr></thead>
                      <tbody>
                        {sortedC.map(function(kv){
                          var code=kv[0];var count=kv[1];
                          var pct=total>0?count/total*100:0;
                          var info=RT_CARRIERS[code]||{name:code,color:"#6B7280"};
                          // Map routing carrier code to billing CSV supplier name
                          var BILLING_NAME={FW:'Aramex',PR:'Parcel Right',TGE:'TGE',PFL:'PFL',APO:'APO',DGF:'DGF',NULL:null};
                          var billingKey=BILLING_NAME[code]||code;
                          var bm=isPM&&pmBillingData&&billingKey?(pmBillingData.supplierMix[billingKey]||null):null;
                          // Guard against stale format missing count
                          if(bm&&bm.count===undefined)bm=null;
                          var bTotal=isPM&&pmBillingData?pmBillingData.totalParcels:0;
                          var bPct=bm&&bTotal>0?bm.count/bTotal*100:0;
                          return (
                            <tr key={code}>
                              <td style={S.td}><span style={{display:"inline-block",width:10,height:10,background:info.color,marginRight:6,verticalAlign:"middle"}} /><b>{code}</b> — {info.name}</td>
                              <td style={S.tdr}>{count.toLocaleString()}</td>
                              <td style={S.tdr}><b style={{color:info.color}}>{f(pct,1)}%</b></td>
                              {isPM&&pmBillingData&&<td style={S.tdr}>{bm?(<b style={{color:info.color}}>{f(bPct,1)}%</b>):<span style={{color:C.td}}>—</span>}</td>}
                              {isPM&&pmBillingData&&<td style={{...S.tdr,color:C.td}}>{bm?bm.count.toLocaleString():"—"}</td>}
                              {isPM&&pmBillingData&&<td style={{...S.tdr,color:bm?C.ac:C.td}}>{bm?"$"+f(bm.avgCost):"—"}</td>}
                              <td style={{...S.td,paddingLeft:0}}><div style={{height:8,width:pct+"%",background:info.color+"60",minWidth:2}} /></td>
                            </tr>
                          );
                        })}
                        {isPM&&pmBillingData&&(function(){
                          var bTotal=pmBillingData.totalParcels;
                          var bCost=Object.values(pmBillingData.supplierMix).reduce(function(s,v){return s+v.totalCost},0);
                          return (<tr style={{borderTop:"2px solid "+C.bd,background:C.s2}}>
                            <td style={{...S.td,fontWeight:700,color:C.tx}}>Total</td>
                            <td style={{...S.tdr,fontWeight:700}}>{rtData.totalSuburbs.toLocaleString()}</td>
                            <td style={{...S.tdr,fontWeight:700}}>100%</td>
                            <td style={{...S.tdr,fontWeight:700,color:C.tx}}>100%</td>
                            <td style={{...S.tdr,fontWeight:700,color:C.tx}}>{bTotal.toLocaleString()}</td>
                            <td style={{...S.tdr,fontWeight:700,color:C.gn}}>${f(bTotal>0?Math.round(bCost/bTotal*100)/100:0)}</td>
                            <td style={S.td}></td>
                          </tr>);
                        })()}
                      </tbody>
                    </table>
                  </div>

                  {/* NULL suburbs */}
                  {rtData.nullList.length>0&&(
                    <div style={{...S.sec}}>
                      <div style={{...S.st,color:C.rd}}>No-Service Suburbs ({rtData.nullList.length.toLocaleString()})</div>
                      <div style={{fontSize:9,color:C.td,marginBottom:6}}>These postcodes have no carrier available — parcels cannot be delivered.</div>
                      <div style={{maxHeight:200,overflowY:"auto",fontSize:10}}>
                        <table style={S.tbl}><thead><tr><th style={S.th}>Postcode</th><th style={S.th}>Suburb</th><th style={S.th}>Zone</th></tr></thead>
                          <tbody>{rtData.nullList.slice(0,200).map(function(s,i){return (<tr key={i}><td style={S.td}>{s.pc}</td><td style={S.td}>{s.suburb}</td><td style={S.td}><span style={{color:C.td}}>{s.zone}</span></td></tr>)})}</tbody>
                        </table>
                      </div>
                      {rtData.nullList.length>200&&<div style={{fontSize:9,color:C.td,marginTop:4}}>Showing first 200 of {rtData.nullList.length}</div>}
                    </div>
                  )}
                </div>
              );
            })()}

            {/* ZONE COSTS */}
            {rtSection==="zones"&&(function(){
              var isPM=rtView==="pm";
              var pmSynced=isPM&&pmRoutingCosts;
              return (
                <div>
                  {/* PM Weight Break View — matches pricing engine structure */}
                  {isPM&&(
                    <div style={{...S.sec,marginBottom:10,borderColor:"#7C3AED40"}}>
                      <div style={{...S.st,color:"#7C3AED",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                        <span>Leg 3 Cost — Mapped to PM Weight Breaks</span>
                        <Tog2 v={rtPmZoneView===1?"1":"3"} onChange={function(v){sRtPmZoneView(v==="1"?1:3)}} opts={[["1","1 Zone (Flat)"],["3","3 Zones"]]} />
                      </div>
                      <div style={{fontSize:9,color:C.td,marginBottom:8}}>Routing costs aggregated to PM's 7 weight breaks, blended using standard DAI dispersion. Sync to opp via the Per Piece Pricing section in the Pricing tab.</div>
                      <div style={{overflowX:"auto"}}>
                        <table style={{...S.tbl,fontSize:10.5}}>
                          <thead><tr>
                            <th style={S.th}>Zone</th>
                            {PMW.map(function(wb){return <th key={wb.l} style={S.thr}>{wb.l}</th>})}
                          </tr></thead>
                          <tbody>
                            {(function(){
                              // Pre-compute all three zone cost arrays
                              var zoneCosts=[0,1,2].map(function(zi){
                                var rtCosts=Array(7).fill(0);var totalWt=0;
                                STS.forEach(function(st){
                                  var dd=DD[st];if(!dd)return;
                                  var zPct=zi===0?dd.z1:zi===1?dd.z2:dd.z3;
                                  var w=dd.pct*zPct/10000;if(w<=0)return;
                                  var zd=rtData&&rtData.byZone?rtData.byZone[st+'-Z'+(zi+1)]:null;
                                  if(!zd||!zd.avgCosts)return;
                                  totalWt+=w;
                                  for(var pmwi=0;pmwi<6;pmwi++)rtCosts[pmwi]+=zd.avgCosts[PM_RT_MAP[pmwi]]*w;
                                  rtCosts[6]+=((zd.avgCosts[7]+zd.avgCosts[8]+zd.avgCosts[9]+zd.avgCosts[10])/4)*w;
                                });
                                return totalWt>0?rtCosts.map(function(s){return Math.round(s/totalWt*100)/100}):rtCosts;
                              });
                              // Zone proportions for blended calc
                              var zWts=[0,0,0];STS.forEach(function(st){var dd=DD[st];if(!dd)return;zWts[0]+=dd.pct*dd.z1/10000;zWts[1]+=dd.pct*dd.z2/10000;zWts[2]+=dd.pct*dd.z3/10000});
                              var zTot=zWts[0]+zWts[1]+zWts[2];var zPcts=zTot>0?zWts.map(function(w){return w/zTot}):[.7,.15,.15];
                              if(rtPmZoneView===1){
                                // Single blended row
                                var blendedRow=PMW.map(function(_,wi){return Math.round((zoneCosts[0][wi]*zPcts[0]+zoneCosts[1][wi]*zPcts[1]+zoneCosts[2][wi]*zPcts[2])*100)/100});
                                return [<tr key="flat" style={{background:C.ac+"08"}}>
                                  <td style={{...S.td,fontWeight:700,color:C.ac}}>Flat (Blended)</td>
                                  {blendedRow.map(function(c,wi){return <td key={wi} style={{...S.tdr,fontWeight:600}}>{c>0?"$"+f(c):"—"}</td>})}
                                </tr>];
                              }
                              // 3-zone rows
                              return [0,1,2].map(function(zi){
                                var zColor=zi===0?C.gn:zi===1?C.yw:C.rd;
                                return (<tr key={zi} style={{background:zi===0?C.gn+"06":zi===1?C.yw+"06":C.rd+"06"}}>
                                  <td style={{...S.td,fontWeight:700,color:zColor}}>{'Z'+(zi+1)}</td>
                                  {zoneCosts[zi].map(function(c,wi){return <td key={wi} style={S.tdr}>{c>0?"$"+f(c):"—"}</td>})}
                                </tr>);
                              });
                            })()}
                          </tbody>
                        </table>
                      </div>
                      <div style={{marginTop:6,fontSize:9,color:C.td}}>Ground-truth Leg 3 cost from routing file, weighted by standard DAI dispersion.</div>
                    </div>
                  )}

                  {/* Actual 4-Week Billing Data — PM only */}
                  {isPM&&(
                    <div style={{...S.sec,marginBottom:10,borderColor:pmBillingData?C.ac+"50":C.bd}}>
                      <div style={{...S.st,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                        <span style={{color:pmBillingData?C.ac:C.tm}}>{"Actual Network Cost — 4-Week Billing Data"+(pmBillingData?" ✓":"")}</span>
                        <div style={{display:"flex",gap:6,alignItems:"center"}}>
                          {pmBillingData&&<button onClick={function(){sPmBillingData(null);sPmBillingMsg("");if(window.storage)window.storage.delete('billing-pm-v1',true).catch(function(){})}} style={{fontSize:8.5,padding:"2px 8px",background:"transparent",border:"1px solid "+C.rd+"60",color:C.rd,cursor:"pointer",fontFamily:bf}}>Clear</button>}
                          <input type="file" accept=".csv,.txt" ref={pmBillingRef} style={{display:"none"}} onChange={handleBillingUpload} />
                          <button onClick={function(){pmBillingRef.current&&pmBillingRef.current.click()}} style={{fontSize:9,padding:"3px 10px",background:pmBillingData?C.s2:C.ac,border:"1px solid "+(pmBillingData?C.bd:C.ac),color:pmBillingData?C.tm:"#fff",cursor:"pointer",fontFamily:bf,fontWeight:700}}>{pmBillingData?"Re-upload CSV":"Upload Billing CSV"}</button>
                        </div>
                      </div>
                      {!pmRouting&&<div style={{fontSize:9,color:C.yw,marginBottom:4}}>⚠ Upload PM routing file first — required for zone mapping</div>}
                      {pmBillingData&&(prod==="pm"||prod==="pma")&&(
                        <div style={{marginTop:8,padding:"8px 10px",background:C.ac+"12",border:"1px solid "+C.ac+"40",display:"flex",alignItems:"center",justifyContent:"space-between",gap:12}}>
                          <div>
                            <span style={{fontSize:10,fontWeight:700,color:C.ac}}>Commit to all PM + PMA opps</span>
                            <span style={{fontSize:9,color:C.td,marginLeft:8}}>Updates cost basis on every saved PM and PMA opp using actual billing dispersion</span>
                          </div>
                          <button onClick={syncPmLeg3FromBilling} style={{fontSize:9.5,padding:"4px 14px",background:C.ac,border:"none",color:"#fff",cursor:"pointer",fontFamily:bf,fontWeight:700,whiteSpace:"nowrap"}}>📊 Commit Billing Costs to All PM/PMA Opps</button>
                        </div>
                      )}
                      {pmBillingMsg&&<div style={{fontSize:9,fontWeight:600,color:pmBillingMsg.startsWith("✓")?C.gn:pmBillingMsg.startsWith("⏳")?C.yw:C.rd,marginTop:4}}>{pmBillingMsg}</div>}
                      {pmBillingData&&(function(){
                        var bd=pmBillingData;
                        // Compute blended avg from billing data per zone using actual dispersion
                        var billingZoneCosts=[0,1,2].map(function(zi){
                          var costs=Array(7).fill(0);var totalWt=0;
                          STS.forEach(function(st){
                            var dd=bd.stateDisp[st];if(!dd||dd.pct<=0)return;
                            var zPct=zi===0?dd.z1:zi===1?dd.z2:dd.z3;
                            var w=dd.pct*zPct/10000;if(w<=0)return;
                            var zd=bd.byZone[st+'-Z'+(zi+1)];if(!zd||!zd.avgCosts)return;
                            totalWt+=w;
                            for(var pmwi=0;pmwi<6;pmwi++)costs[pmwi]+=zd.avgCosts[PM_RT_MAP[pmwi]]*w;
                            costs[6]+=((zd.avgCosts[7]+zd.avgCosts[8]+zd.avgCosts[9]+zd.avgCosts[10])/4)*w;
                          });
                          return totalWt>0?costs.map(function(s){return Math.round(s/totalWt*100)/100}):costs;
                        });
                        var zWts=[0,0,0];STS.forEach(function(st){var dd=bd.stateDisp[st];if(!dd)return;zWts[0]+=dd.pct*dd.z1/10000;zWts[1]+=dd.pct*dd.z2/10000;zWts[2]+=dd.pct*dd.z3/10000});
                        var zTot=zWts[0]+zWts[1]+zWts[2];var zPcts=zTot>0?zWts.map(function(w){return w/zTot}):[.7,.15,.15];
                        var blendedFlat=PMW.map(function(_,wi){return Math.round((billingZoneCosts[0][wi]*zPcts[0]+billingZoneCosts[1][wi]*zPcts[1]+billingZoneCosts[2][wi]*zPcts[2])*100)/100});
                        return (<>
                          {/* Summary strip */}
                          <div style={{...grd(5),marginBottom:10,marginTop:8}}>
                            <div style={S.met}><div style={{fontSize:13,fontWeight:700,color:C.ac}}>{bd.totalParcels.toLocaleString()}</div><div style={S.ml}>Total Parcels</div></div>
                            <div style={S.met}><div style={{fontSize:13,fontWeight:700,color:C.gn}}>{"A$"+f(bd.blendedAvg)}</div><div style={S.ml}>Blended Avg/pc</div></div>
                            <div style={S.met}><div style={{fontSize:13,fontWeight:700,color:C.yw}}>{bd.poboxPct+"%"}</div><div style={S.ml}>PO Box ({bd.poboxCount.toLocaleString()})</div></div>
                            <div style={S.met}><div style={{fontSize:13,fontWeight:700,color:C.td}}>{bd.unmapped.toLocaleString()}</div><div style={S.ml}>Unmapped PC</div></div>
                            <div style={S.met}><div style={{fontSize:10,fontWeight:700,color:C.tm}}>{bd.dateRange.min}</div><div style={{fontSize:10,fontWeight:700,color:C.tm}}>{bd.dateRange.max}</div><div style={S.ml}>Date Range</div></div>
                          </div>
                          {/* Actual cost by zone × PMW breaks */}
                          <div style={{marginBottom:8}}>
                            <div style={{fontSize:9.5,fontWeight:700,color:C.ac,marginBottom:4,textTransform:"uppercase",letterSpacing:".05em"}}>Actual Leg 3 Cost per Zone (from billing)</div>
                            <div style={{overflowX:"auto"}}>
                              <table style={{...S.tbl,fontSize:10.5}}>
                                <thead><tr>
                                  <th style={S.th}>Zone</th>
                                  <th style={S.thr}>Parcels</th>
                                  {PMW.map(function(wb){return <th key={wb.l} style={S.thr}>{wb.l}</th>})}
                                </tr></thead>
                                <tbody>
                                  {(rtPmZoneView===1?[
                                    <tr key="flat" style={{background:C.ac+"08"}}>
                                      <td style={{...S.td,fontWeight:700,color:C.ac}}>Flat (Blended)</td>
                                      <td style={{...S.tdr,color:C.td}}>{bd.totalParcels.toLocaleString()}</td>
                                      {blendedFlat.map(function(c,wi){return <td key={wi} style={{...S.tdr,fontWeight:600,color:C.ac}}>{c>0?"$"+f(c):"—"}</td>})}
                                    </tr>
                                  ]:[0,1,2].map(function(zi){
                                    var zColor=zi===0?C.gn:zi===1?C.yw:C.rd;
                                    var parcels=0;STS.forEach(function(st){var zd=bd.byZone[st+'-Z'+(zi+1)];if(zd)parcels+=zd.parcelCount||0});
                                    return (<tr key={zi} style={{background:zi===0?C.gn+"06":zi===1?C.yw+"06":C.rd+"06"}}>
                                      <td style={{...S.td,fontWeight:700,color:zColor}}>{'Z'+(zi+1)}</td>
                                      <td style={{...S.tdr,color:C.td}}>{parcels.toLocaleString()}</td>
                                      {billingZoneCosts[zi].map(function(c,wi){return <td key={wi} style={{...S.tdr,color:c>0?C.tx:C.td}}>{c>0?"$"+f(c):"—"}</td>})}
                                    </tr>);
                                  }))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                          {/* Carrier cost breakdown — pivot table matching analyst format */}
                          <div style={{marginBottom:8}}>
                            <div style={{fontSize:9.5,fontWeight:700,color:C.tm,marginBottom:4,textTransform:"uppercase",letterSpacing:".05em"}}>Carrier Cost Breakdown</div>
                            <table style={{...S.tbl,fontSize:10}}>
                              <thead><tr>
                                <th style={S.th}>Address Type</th>
                                <th style={S.th}>Carrier</th>
                                <th style={S.thr}>Parcels</th>
                                <th style={S.thr}>%</th>
                                <th style={S.thr}>Est Cost</th>
                                <th style={S.thr}>Avg Rate</th>
                              </tr></thead>
                              <tbody>
                                {(function(){
                                  var rows=[];
                                  var grand=bd.totalParcels;
                                  // Standard address section
                                  var stdSuppliers=Object.entries(bd.supplierMix)
                                    .filter(function(kv){return kv[1].standard&&kv[1].standard.count>0})
                                    .sort(function(a,b){return (b[1].standard&&b[1].standard.count||0)-(a[1].standard&&a[1].standard.count||0)});
                                  var stdTotal=stdSuppliers.reduce(function(s,kv){return s+(kv[1].standard&&kv[1].standard.count||0)},0);
                                  var stdCost=stdSuppliers.reduce(function(s,kv){return s+(kv[1].standard&&kv[1].standard.totalCost||0)},0);
                                  var stdAvg=stdTotal>0?Math.round(stdCost/stdTotal*100)/100:0;
                                  // Standard header row
                                  rows.push(<tr key="std-hdr" style={{background:C.s2}}>
                                    <td style={{...S.td,fontWeight:700,color:C.tx}} colSpan={2}>Standard Address</td>
                                    <td style={{...S.tdr,fontWeight:700}}>{stdTotal.toLocaleString()}</td>
                                    <td style={{...S.tdr,fontWeight:700}}>{grand>0?f(stdTotal/grand*100,1)+"%":"—"}</td>
                                    <td style={{...S.tdr,fontWeight:700}}>${stdCost.toLocaleString()}</td>
                                    <td style={{...S.tdr,fontWeight:700,color:C.gn}}>${f(stdAvg)}</td>
                                  </tr>);
                                  // Standard carrier rows
                                  stdSuppliers.forEach(function(kv){
                                    var info=RT_CARRIERS[kv[0]]||{color:"#6B7280"};
                                    var v=kv[1].standard;
                                    rows.push(<tr key={"std-"+kv[0]}>
                                      <td style={S.td}></td>
                                      <td style={{...S.td,color:info.color,fontWeight:600}}>{kv[0]}</td>
                                      <td style={S.tdr}>{v.count.toLocaleString()}</td>
                                      <td style={{...S.tdr,color:C.td}}>{grand>0?f(v.count/grand*100,1)+"%":"—"}</td>
                                      <td style={S.tdr}>${v.totalCost.toLocaleString()}</td>
                                      <td style={{...S.tdr,color:C.ac}}>${f(v.avgCost)}</td>
                                    </tr>);
                                  });
                                  // PO Box section
                                  var pbSuppliers=Object.entries(bd.supplierMix)
                                    .filter(function(kv){return kv[1].pobox&&kv[1].pobox.count>0})
                                    .sort(function(a,b){return (b[1].pobox&&b[1].pobox.count||0)-(a[1].pobox&&a[1].pobox.count||0)});
                                  if(pbSuppliers.length>0){
                                    var pbTotal=pbSuppliers.reduce(function(s,kv){return s+(kv[1].pobox&&kv[1].pobox.count||0)},0);
                                    var pbCost=pbSuppliers.reduce(function(s,kv){return s+(kv[1].pobox&&kv[1].pobox.totalCost||0)},0);
                                    var pbAvg=pbTotal>0?Math.round(pbCost/pbTotal*100)/100:0;
                                    rows.push(<tr key="pb-hdr" style={{background:C.s2}}>
                                      <td style={{...S.td,fontWeight:700,color:C.yw}} colSpan={2}>PO Box Address</td>
                                      <td style={{...S.tdr,fontWeight:700}}>{pbTotal.toLocaleString()}</td>
                                      <td style={{...S.tdr,fontWeight:700}}>{grand>0?f(pbTotal/grand*100,1)+"%":"—"}</td>
                                      <td style={{...S.tdr,fontWeight:700}}>${pbCost.toLocaleString()}</td>
                                      <td style={{...S.tdr,fontWeight:700,color:C.yw}}>${f(pbAvg)}</td>
                                    </tr>);
                                    pbSuppliers.forEach(function(kv){
                                      var info=RT_CARRIERS[kv[0]]||{color:"#6B7280"};
                                      var v=kv[1].pobox;
                                      rows.push(<tr key={"pb-"+kv[0]}>
                                        <td style={S.td}></td>
                                        <td style={{...S.td,color:info.color,fontWeight:600}}>{kv[0]}</td>
                                        <td style={S.tdr}>{v.count.toLocaleString()}</td>
                                        <td style={{...S.tdr,color:C.td}}>{grand>0?f(v.count/grand*100,1)+"%":"—"}</td>
                                        <td style={S.tdr}>${v.totalCost.toLocaleString()}</td>
                                        <td style={{...S.tdr,color:C.yw}}>${f(v.avgCost)}</td>
                                      </tr>);
                                    });
                                  }
                                  // Grand total
                                  var gtCost=Object.values(bd.supplierMix).reduce(function(s,v){return s+v.totalCost},0);
                                  rows.push(<tr key="gt" style={{borderTop:"2px solid "+C.bd,background:C.s2}}>
                                    <td style={{...S.td,fontWeight:700,color:C.tx}} colSpan={2}>Grand Total</td>
                                    <td style={{...S.tdr,fontWeight:700}}>{grand.toLocaleString()}</td>
                                    <td style={{...S.tdr,fontWeight:700,color:C.td}}>100%</td>
                                    <td style={{...S.tdr,fontWeight:700}}>${Math.round(gtCost).toLocaleString()}</td>
                                    <td style={{...S.tdr,fontWeight:700,color:C.gn}}>${f(bd.blendedAvg)}</td>
                                  </tr>);
                                  return rows;
                                })()}
                              </tbody>
                            </table>
                          </div>
                          {/* State distribution vs DD */}
                          <div>
                            <div style={{fontSize:9.5,fontWeight:700,color:C.tm,marginBottom:4,textTransform:"uppercase",letterSpacing:".05em"}}>State Distribution — Actual vs Standard</div>
                            <table style={{...S.tbl,fontSize:9.5}}>
                              <thead><tr>
                                <th style={S.th}>State</th>
                                <th style={S.thr}>Actual %</th><th style={S.thr}>Standard %</th>
                                <th style={S.thr}>Z1 act</th><th style={S.thr}>Z2 act</th><th style={S.thr}>Z3 act</th>
                                <th style={S.thr}>Z1 std</th><th style={S.thr}>Z2 std</th><th style={S.thr}>Z3 std</th>
                              </tr></thead>
                              <tbody>
                                {STS.map(function(st){
                                  var act=bd.stateDisp[st];var std=DD[st];if(!act&&!std)return null;
                                  var pctDiff=act&&std?Math.round((act.pct-std.pct)*10)/10:0;
                                  return (<tr key={st}>
                                    <td style={{...S.td,fontWeight:700}}>{st}</td>
                                    <td style={{...S.tdr,color:Math.abs(pctDiff)>2?C.yw:C.tx}}>{act?act.pct+"%":"—"}{pctDiff!==0&&<span style={{fontSize:8,color:pctDiff>0?C.gn:C.rd}}>{" "+(pctDiff>0?"+":"")+pctDiff}</span>}</td>
                                    <td style={{...S.tdr,color:C.td}}>{std?std.pct+"%":"—"}</td>
                                    <td style={S.tdr}>{act?act.z1+"%":"—"}</td>
                                    <td style={S.tdr}>{act?act.z2+"%":"—"}</td>
                                    <td style={S.tdr}>{act?act.z3+"%":"—"}</td>
                                    <td style={{...S.tdr,color:C.td}}>{std?std.z1+"%":"—"}</td>
                                    <td style={{...S.tdr,color:C.td}}>{std?std.z2+"%":"—"}</td>
                                    <td style={{...S.tdr,color:C.td}}>{std?std.z3+"%":"—"}</td>
                                  </tr>);
                                })}
                              </tbody>
                            </table>
                          </div>
                        </>);
                      })()}
                    </div>
                  )}
                  {blended&&(rtView==="pm")&&(
                    <div style={{...S.sec,marginBottom:10,borderColor:useBillingBlended?C.ac+"40":C.bd}}>
                      <div style={{...S.st,color:"#7C3AED",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                        <span>Blended Network Cost to Serve</span>
                        <span style={{fontSize:9,fontWeight:600,color:useBillingBlended?C.ac:"#7C3AED"}}>{useBillingBlended?"📊 "+blendedSource:"⬡ "+blendedSource}</span>
                      </div>
                      <div style={{fontSize:9,color:C.td,marginBottom:8}}>{useBillingBlended?"Weighted average actual billed carrier cost per zone using your actual parcel distribution from billing data.":"Weighted average actual carrier cost per zone using standard DAI Post state/zone distribution."}</div>
                      <div style={{overflowX:"auto"}}>
                        <table style={S.tbl}>
                          <thead><tr>
                            <th style={S.th}>Zone</th>
                            {RT_WB.map(function(wb,wi){return (<th key={wi} style={S.thr}>{wb}</th>)})}
                          </tr></thead>
                          <tbody>
                            {["Z1","Z2","Z3"].map(function(zk){
                              return (
                                <tr key={zk} style={{background:zk==="Z1"?C.gn+"08":zk==="Z2"?C.yw+"08":C.rd+"08"}}>
                                  <td style={{...S.td,fontWeight:700,color:zk==="Z1"?C.gn:zk==="Z2"?C.yw:C.rd}}>Blended {zk}</td>
                                  {blended[zk].map(function(c,wi){
                                    return (<td key={wi} style={{...S.tdr,color:c>0?C.tx:C.td}}>{c>0?"$"+f(c):"—"}</td>);
                                  })}
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}

                  {/* Per-zone detailed table */}
                  <div style={{...S.sec}}>
                    <div style={{...S.st,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                      <span>Zone-Level Average Carrier Costs</span>
                      {isPM&&pmBillingData&&(
                        <Tog2 v={rtZoneSource} onChange={sRtZoneSource} opts={[["routing","Routing File"],["billing","Billing Data"]]} />
                      )}
                    </div>
                    <div style={{fontSize:9,color:C.td,marginBottom:8}}>
                      {rtZoneSource==="billing"&&isPM&&pmBillingData
                        ?"Actual average billed cost per zone from 4-week billing data. % diff vs routing file shown. Dimmed cells have <10 parcels."
                        :"Average actual carrier cost per suburb within each DAI zone from routing file."}
                    </div>
                    <div style={{overflowX:"auto"}}>
                      <table style={{...S.tbl,fontSize:10}}>
                        <thead><tr>
                          <th style={{...S.th,minWidth:80}}>Zone</th>
                          <th style={S.thr}>Suburbs</th>
                          <th style={{...S.th,minWidth:80}}>Top Carrier</th>
                          {RT_WB.map(function(wb,wi){return (<th key={wi} style={{...S.thr,minWidth:52,fontSize:8.5}}>{wb}</th>)})}
                        </tr></thead>
                        <tbody>
                          {RT_ZONES_ORDERED.map(function(zk){
                            var zd=rtData.byZone[zk];
                            if(!zd||zd.suburbCount===0)return null;
                            var z=zk.slice(-1);
                            var rowBg=z==="1"?C.gn+"06":z==="2"?C.yw+"06":C.rd+"06";
                            var topC=Object.entries(zd.carrierCounts).sort(function(a,b){return b[1]-a[1]})[0];
                            var topInfo=topC?(RT_CARRIERS[topC[0]]||{name:topC[0],color:"#6B7280"}):null;
                            var billingZd=rtZoneSource==="billing"&&isPM&&pmBillingData?pmBillingData.byZone[zk]:null;
                            return (
                              <tr key={zk} style={{background:rowBg}}>
                                <td style={{...S.td,fontWeight:700,color:z==="1"?C.gn:z==="2"?C.yw:C.rd}}>{zk}</td>
                                <td style={S.tdr}>{zd.suburbCount}</td>
                                <td style={S.td}>
                                  {topInfo&&<><span style={{display:"inline-block",width:8,height:8,background:topInfo.color,marginRight:4,verticalAlign:"middle"}} />{topC[0]}</>}
                                </td>
                                {zd.avgCosts.map(function(c,wi){
                                  if(billingZd){
                                    var bc=billingZd.avgCosts[wi];
                                    var cnt=billingZd.counts&&billingZd.counts[wi]||0;
                                    var thin=cnt<10;
                                    var diff=bc>0&&c>0?Math.round((bc-c)/c*100):null;
                                    return (
                                      <td key={wi} style={{...S.tdr,fontSize:10,opacity:thin?0.4:1}}>
                                        {bc>0?(<>
                                          <div style={{color:thin?C.td:C.tx}}>${f(bc)}</div>
                                          {diff!==null&&!thin&&<div style={{fontSize:7.5,color:diff>5?C.rd:diff<-5?C.gn:C.td}}>{diff>0?"+":""}{diff}%</div>}
                                          {thin&&<div style={{fontSize:7,color:C.td}}>n={cnt}</div>}
                                        </>):<span style={{color:C.td}}>—</span>}
                                      </td>
                                    );
                                  }
                                  return (
                                    <td key={wi} style={{...S.tdr,fontSize:10,color:c>0?C.tx:C.td}}>{c>0?"$"+f(c):"—"}</td>
                                  );
                                })}
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              );
            })()}

            {/* LOOKUP */}
            {rtSection==="lookup"&&(
              <div>
                <div style={{...S.sec,marginBottom:10}}>
                  <div style={{...S.st}}>Postcode / Suburb Lookup</div>
                  <div style={{display:"flex",gap:6,marginBottom:10}}>
                    <input style={{...S.inp,maxWidth:300,fontSize:12}} placeholder="Enter postcode or suburb name..." value={rtSearch} onChange={function(e){sRtSearch(e.target.value);sRtSearchResult(null)}} onKeyDown={function(e){if(e.key==="Enter")doRtSearch(rtData)}} />
                    <button onClick={function(){doRtSearch(rtData)}} style={{padding:"5px 14px",background:C.ad,border:"none",color:"#fff",cursor:"pointer",fontFamily:bf,fontSize:10.5,fontWeight:600}}>Search</button>
                    {rtSearchResult&&<button onClick={function(){sRtSearchResult(null);sRtSearch("")}} style={{padding:"5px 10px",background:"transparent",border:"1px solid "+C.bd,color:C.td,cursor:"pointer",fontFamily:bf,fontSize:9}}>Clear</button>}
                  </div>
                  <div style={{fontSize:9,color:C.td}}>Search by 4-digit postcode or suburb name. Results show carrier allocation and cost per weight break.</div>
                </div>

                {rtSearchResult&&rtSearchResult.type==="none"&&(
                  <div style={{padding:16,color:C.td,fontSize:11}}>No results found for "{rtSearch}"</div>
                )}

                {rtSearchResult&&rtSearchResult.type==="postcode"&&(
                  <div className="sec">
                    <div style={{...S.st}}>Postcode {rtSearchResult.pc} — {rtSearchResult.suburbs.length} suburb{rtSearchResult.suburbs.length!==1?"s":""}</div>
                    {rtSearchResult.suburbs.map(function(s,si){
                      var info=RT_CARRIERS[s.primaryC]||{name:s.primaryC,color:"#6B7280"};
                      var uniqueC=[];s.carriers.forEach(function(c){if(uniqueC.indexOf(c)<0)uniqueC.push(c)});
                      return (
                        <div key={si} style={{marginBottom:12,padding:10,background:C.s2,border:"1px solid "+C.bd}}>
                          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8}}>
                            <div>
                              <span style={{fontWeight:700,fontSize:12,color:C.tx}}>{s.suburb}</span>
                              {s.zoneKey&&<span style={{fontSize:10,color:C.ac,marginLeft:8}}>{s.zoneKey}</span>}
                            </div>
                            <div style={{display:"flex",gap:6,flexWrap:"wrap",justifyContent:"flex-end"}}>
                              {uniqueC.map(function(c,ci){var ci2=RT_CARRIERS[c]||{name:c,color:"#6B7280"};return (<span key={ci} style={{fontSize:9,padding:"2px 7px",background:ci2.color+"20",border:"1px solid "+ci2.color+"50",color:ci2.color,fontWeight:600}}>{c}</span>)})}
                            </div>
                          </div>
                          <div style={{overflowX:"auto"}}>
                            <table style={{...S.tbl,fontSize:10}}>
                              <thead><tr>
                                <th style={S.th}>Weight Break</th>
                                {RT_WB.map(function(wb,wi){return (<th key={wi} style={S.thr}>{wb}</th>)})}
                              </tr></thead>
                              <tbody>
                                <tr>
                                  <td style={{...S.td,fontWeight:600,color:C.tm}}>Carrier</td>
                                  {s.carriers.map(function(c,wi){var ci2=RT_CARRIERS[c]||{name:c,color:"#6B7280"};return (<td key={wi} style={{...S.tdr,color:ci2.color,fontSize:9.5,fontWeight:600}}>{c}</td>)})}
                                </tr>
                                <tr>
                                  <td style={{...S.td,fontWeight:600,color:C.tm}}>Cost/parcel</td>
                                  {s.costs.map(function(c,wi){return (<td key={wi} style={{...S.tdr,color:c>0?C.tx:C.td}}>{c>0?"$"+f(c):"—"}</td>)})}
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}

                {rtSearchResult&&rtSearchResult.type==="suburb"&&(
                  <div className="sec">
                    <div style={{...S.st}}>Suburb Search Results — {rtSearchResult.matches.length} match{rtSearchResult.matches.length!==1?"es":""}{rtSearchResult.matches.length===50?" (first 50)":""}</div>
                    <table style={S.tbl}>
                      <thead><tr>
                        <th style={S.th}>Suburb</th>
                        <th style={S.th}>Postcode</th>
                        <th style={S.th}>Zone</th>
                        <th style={S.th}>Carrier</th>
                        <th style={S.thr}>500g</th>
                        <th style={S.thr}>1kg</th>
                        <th style={S.thr}>3kg</th>
                        <th style={S.thr}>5kg</th>
                        <th style={S.thr}>10kg</th>
                      </tr></thead>
                      <tbody>
                        {rtSearchResult.matches.map(function(m,mi){
                          var info=RT_CARRIERS[m.primaryC]||{name:m.primaryC,color:"#6B7280"};
                          return (
                            <tr key={mi}>
                              <td style={{...S.td,fontWeight:600}}>{m.suburb}</td>
                              <td style={S.td}>{m.pc}</td>
                              <td style={{...S.td,color:C.ac}}>{m.zoneKey||"—"}</td>
                              <td style={{...S.td,color:info.color,fontWeight:600}}>{m.primaryC}</td>
                              <td style={S.tdr}>{m.costs[1]>0?"$"+f(m.costs[1]):"—"}</td>
                              <td style={S.tdr}>{m.costs[2]>0?"$"+f(m.costs[2]):"—"}</td>
                              <td style={S.tdr}>{m.costs[4]>0?"$"+f(m.costs[4]):"—"}</td>
                              <td style={S.tdr}>{m.costs[6]>0?"$"+f(m.costs[6]):"—"}</td>
                              <td style={S.tdr}>{m.costs[8]>0?"$"+f(m.costs[8]):"—"}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}
          </>)}
        </div>
        );
      })()}


    </div>

    {/* ─── BILLING COMMIT PREVIEW MODAL ─── */}
    {billingCommitPreview&&(
      <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.75)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center"}}>
        <div style={{background:C.sf,border:"1px solid "+C.bd,width:960,maxHeight:"82vh",display:"flex",flexDirection:"column",fontFamily:bf}}>
          <div style={{padding:"12px 16px",background:C.s2,borderBottom:"1px solid "+C.bd,display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
            <div>
              <div style={{fontSize:12,fontWeight:700,color:C.ac,marginBottom:3}}>COMMIT BILLING COSTS — IMPACT PREVIEW</div>
              <div style={{fontSize:9,color:C.td,marginTop:2}}>
                {"GP$ and GP% from last-saved opp values. Adjusted by Leg 3 cost delta — Leg 3 change flows 1:1 to GP$, GP% recalculated against saved revenue. "+(billingCommitPreview.opps.filter(function(r){return !r.hasSnap}).length>0?"⚠ "+billingCommitPreview.opps.filter(function(r){return !r.hasSnap}).length+" opp(s) have no GP snapshot — save those opps first.":"")}
              </div>
            </div>
            <button onClick={function(){sBillingCommitPreview(null)}} style={{background:"transparent",border:"none",color:C.td,fontSize:16,cursor:"pointer",padding:"0 4px"}}>✕</button>
          </div>
          <div style={{overflowY:"auto",flex:1,padding:"8px 0"}}>
            {billingCommitPreview.opps.length===0?(
              <div style={{padding:24,textAlign:"center",fontSize:10,color:C.td}}>No PM/PMA opps found in saved opportunities.</div>
            ):(
              <table style={{...S.tbl,fontSize:9,width:"100%"}}>
                <thead style={{position:"sticky",top:0,background:C.s2}}>
                  <tr>
                    <th style={{...S.th,textAlign:"left"}}>Customer</th>
                    <th style={S.th}>Prod</th>
                    <th style={S.th}>Origin</th>
                    <th style={S.thr}>Vol/yr</th>
                    <th style={S.thr}>Leg3 Δ/pc</th>
                    <th style={{...S.thr,color:C.yw}}>Cur GP%</th>
                    <th style={{...S.thr,color:C.gn}}>New GP%</th>
                    <th style={{...S.thr,color:C.ac}}>Δ GP%</th>
                    <th style={{...S.thr,color:C.yw}}>Cur GP$ pa</th>
                    <th style={{...S.thr,color:C.gn}}>New GP$ pa</th>
                    <th style={{...S.thr,color:C.ac}}>Δ GP$ pa</th>
                  </tr>
                </thead>
                <tbody>
                  {billingCommitPreview.opps.map(function(row){
                    var improved=row.delta<0;var worsened=row.delta>0.005;
                    var gpImproved=row.deltaGPpct>0;
                    return(<tr key={row.id} style={{background:improved?C.gn+"08":worsened?C.rd+"08":""}}>
                      <td style={{...S.td,minWidth:180,textAlign:"left",color:C.tx,fontWeight:600}}>{row.name}</td>
                      <td style={S.td}>{(row.prod||'').toUpperCase()}</td>
                      <td style={S.td}>{row.origin}</td>
                      <td style={{...S.tdr,color:C.td}}>{row.vol>0?Math.round(row.vol/1000)+"K":"—"}</td>
                      <td style={{...S.tdr,fontWeight:700,color:improved?C.gn:worsened?C.rd:C.td}}>
                        {Math.abs(row.delta)<0.001?"—":(improved?"-":"+")+"$"+f(Math.abs(row.delta))}
                      </td>
                      <td style={{...S.tdr,color:C.td}}>{row.currentGPpct!=null?row.currentGPpct+"%":"—"}</td>
                      <td style={{...S.tdr,color:gpImproved?C.gn:C.tx}}>{row.newGPpct!=null?row.newGPpct+"%":"—"}</td>
                      <td style={{...S.tdr,fontWeight:700,color:gpImproved?C.gn:row.deltaGPpct<-0.05?C.rd:C.td}}>
                        {row.deltaGPpct!=null?(gpImproved?"+":"")+row.deltaGPpct+"pp":"—"}
                      </td>
                      <td style={{...S.tdr,color:C.td}}>{row.currentGPannual!=null?"$"+(Math.abs(row.currentGPannual)/1000).toFixed(0)+"K":"—"}</td>
                      <td style={{...S.tdr,color:gpImproved?C.gn:C.tx}}>{row.newGPannual!=null?"$"+(Math.abs(row.newGPannual)/1000).toFixed(0)+"K":"—"}</td>
                      <td style={{...S.tdr,fontWeight:700,color:gpImproved?C.gn:row.deltaGPannual<-100?C.rd:C.td}}>
                        {(function(){var val=row.estDeltaGP;if(val==null)return"—";var rounded=Math.round(val/100)*100;var prefix=row.estIsApprox?"~":"";return (val>0?"+":"")+prefix+"$"+Math.abs(rounded).toLocaleString();}())}
                      </td>
                    </tr>);
                  })}
                </tbody>
                <tfoot style={{background:C.s2}}>
                  <tr>
                    <td colSpan={8} style={{...S.td,fontWeight:700,textAlign:"right",fontSize:9}}>Total annual GP$ impact (est.):</td>
                    <td colSpan={2} style={{...S.tdr}}></td>
                    <td style={{...S.tdr,fontWeight:700,color:C.ac,fontSize:10}}>{(function(){
                      var tot=billingCommitPreview.opps.reduce(function(s,r){return s+(r.deltaGPannual!=null?r.deltaGPannual:(r.estDeltaGP||0))},0);
                      var rounded=Math.round(tot/100)*100;
                      return (tot>0?"+":"")+"$"+Math.abs(rounded).toLocaleString();
                    })()}</td>
                  </tr>
                </tfoot>
              </table>
            )}
          </div>
          <div style={{padding:"10px 16px",borderTop:"1px solid "+C.bd,display:"flex",gap:8,justifyContent:"flex-end",alignItems:"center"}}>
            <span style={{fontSize:9,color:C.td,flex:1}}>
              {"Committing updates Leg 3 cost basis on all "+billingCommitPreview.opps.length+" PM/PMA opps. GP$ and GP% are calculated from last-saved values — re-open each opp after committing to see the fully recalculated margin."}
            </span>
            <button onClick={function(){sBillingCommitPreview(null)}} style={{fontSize:10,padding:"6px 16px",background:C.s2,color:C.tm,border:"1px solid "+C.bd,cursor:"pointer",fontFamily:bf}}>Cancel</button>
            <button onClick={confirmBillingCommit} style={{fontSize:10,padding:"6px 22px",background:C.ac,color:"#fff",border:"none",cursor:"pointer",fontFamily:bf,fontWeight:700}}>
              Confirm & Commit to All Opps
            </button>
          </div>
        </div>
      </div>
    )}
    </>
  );
}
export default function App(){return <ErrorBoundary><AppInner /></ErrorBoundary>;}
